var Cm = Object.defineProperty;
var km = (n, e, t) => e in n ? Cm(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var kn = (n, e, t) => km(n, typeof e != "symbol" ? e + "" : e, t);
import { styled as oe } from "@pigment-css/react";
import ot, { createContext as Aa, useMemo as Ln, useContext as Wi, useState as We, useCallback as ft, useEffect as Et, useRef as lr, useLayoutEffect as Dm, useDebugValue as Pm, memo as Pf } from "react";
const Xr = {
  vars: {
    colors: {
      primary: "var(--colors-primary)"
    },
    typography: {
      fonts: {
        base: "var(--typography-fonts-base)"
      },
      fontWeights: {
        regular: "var(--typography-fontWeights-regular)",
        bold: "var(--typography-fontWeights-bold)"
      },
      fontSizes: {
        large: "var(--typography-fontSizes-large)",
        medium: "var(--typography-fontSizes-medium)",
        small: "var(--typography-fontSizes-small)"
      }
    },
    palette: {
      background: "var(--palette-background)",
      border: "var(--palette-border)",
      text: "var(--palette-text)",
      textMuted: "var(--palette-textMuted)"
    }
  }
};
var Hr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Zc(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function Xc(n) {
  if (n.__esModule) return n;
  var e = n.default;
  if (typeof e == "function") {
    var t = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.keys(n).forEach(function(r) {
    var s = Object.getOwnPropertyDescriptor(n, r);
    Object.defineProperty(t, r, s.get ? s : {
      enumerable: !0,
      get: function() {
        return n[r];
      }
    });
  }), t;
}
var Mf = { exports: {} }, li = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ud;
function Mm() {
  if (ud) return li;
  ud = 1;
  var n = Symbol.for("react.transitional.element"), e = Symbol.for("react.fragment");
  function t(r, s, i) {
    var o = null;
    if (i !== void 0 && (o = "" + i), s.key !== void 0 && (o = "" + s.key), "key" in s) {
      i = {};
      for (var a in s)
        a !== "key" && (i[a] = s[a]);
    } else i = s;
    return s = i.ref, {
      $$typeof: n,
      type: r,
      key: o,
      ref: s !== void 0 ? s : null,
      props: i
    };
  }
  return li.Fragment = e, li.jsx = t, li.jsxs = t, li;
}
Mf.exports = Mm();
var K = Mf.exports;
let Jc = class extends Error {
  constructor(t, r = {}) {
    super(t, r.cause ? { cause: r.cause } : void 0);
    kn(this, "name", "BaseError");
    kn(this, "cause");
    this.cause = r.cause;
  }
};
class Om extends Jc {
  constructor() {
    super("Invalid domain manifest");
    kn(this, "name", "AddMiniApp.InvalidDomainManifest");
  }
}
let Bm = class extends Jc {
  constructor() {
    super("Add miniapp rejected by user");
    kn(this, "name", "AddMiniApp.RejectedByUser");
  }
};
class Of extends Jc {
  constructor() {
    super("Sign in rejected by user");
    kn(this, "name", "SignIn.RejectedByUser");
  }
}
var Ye;
(function(n) {
  n.assertEqual = (s) => {
  };
  function e(s) {
  }
  n.assertIs = e;
  function t(s) {
    throw new Error();
  }
  n.assertNever = t, n.arrayToEnum = (s) => {
    const i = {};
    for (const o of s)
      i[o] = o;
    return i;
  }, n.getValidEnumValues = (s) => {
    const i = n.objectKeys(s).filter((a) => typeof s[s[a]] != "number"), o = {};
    for (const a of i)
      o[a] = s[a];
    return n.objectValues(o);
  }, n.objectValues = (s) => n.objectKeys(s).map(function(i) {
    return s[i];
  }), n.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const i = [];
    for (const o in s)
      Object.prototype.hasOwnProperty.call(s, o) && i.push(o);
    return i;
  }, n.find = (s, i) => {
    for (const o of s)
      if (i(o))
        return o;
  }, n.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && Number.isFinite(s) && Math.floor(s) === s;
  function r(s, i = " | ") {
    return s.map((o) => typeof o == "string" ? `'${o}'` : o).join(i);
  }
  n.joinValues = r, n.jsonStringifyReplacer = (s, i) => typeof i == "bigint" ? i.toString() : i;
})(Ye || (Ye = {}));
var dd;
(function(n) {
  n.mergeShapes = (e, t) => ({
    ...e,
    ...t
    // second overwrites first
  });
})(dd || (dd = {}));
const de = Ye.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Un = (n) => {
  switch (typeof n) {
    case "undefined":
      return de.undefined;
    case "string":
      return de.string;
    case "number":
      return Number.isNaN(n) ? de.nan : de.number;
    case "boolean":
      return de.boolean;
    case "function":
      return de.function;
    case "bigint":
      return de.bigint;
    case "symbol":
      return de.symbol;
    case "object":
      return Array.isArray(n) ? de.array : n === null ? de.null : n.then && typeof n.then == "function" && n.catch && typeof n.catch == "function" ? de.promise : typeof Map < "u" && n instanceof Map ? de.map : typeof Set < "u" && n instanceof Set ? de.set : typeof Date < "u" && n instanceof Date ? de.date : de.object;
    default:
      return de.unknown;
  }
}, se = Ye.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class Rn extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const t = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const t = e || function(i) {
      return i.message;
    }, r = { _errors: [] }, s = (i) => {
      for (const o of i.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(s);
        else if (o.code === "invalid_return_type")
          s(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          s(o.argumentsError);
        else if (o.path.length === 0)
          r._errors.push(t(o));
        else {
          let a = r, l = 0;
          for (; l < o.path.length; ) {
            const c = o.path[l];
            l === o.path.length - 1 ? (a[c] = a[c] || { _errors: [] }, a[c]._errors.push(t(o))) : a[c] = a[c] || { _errors: [] }, a = a[c], l++;
          }
        }
    };
    return s(this), r;
  }
  static assert(e) {
    if (!(e instanceof Rn))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Ye.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (t) => t.message) {
    const t = {}, r = [];
    for (const s of this.issues)
      if (s.path.length > 0) {
        const i = s.path[0];
        t[i] = t[i] || [], t[i].push(e(s));
      } else
        r.push(e(s));
    return { formErrors: r, fieldErrors: t };
  }
  get formErrors() {
    return this.flatten();
  }
}
Rn.create = (n) => new Rn(n);
const nc = (n, e) => {
  let t;
  switch (n.code) {
    case se.invalid_type:
      n.received === de.undefined ? t = "Required" : t = `Expected ${n.expected}, received ${n.received}`;
      break;
    case se.invalid_literal:
      t = `Invalid literal value, expected ${JSON.stringify(n.expected, Ye.jsonStringifyReplacer)}`;
      break;
    case se.unrecognized_keys:
      t = `Unrecognized key(s) in object: ${Ye.joinValues(n.keys, ", ")}`;
      break;
    case se.invalid_union:
      t = "Invalid input";
      break;
    case se.invalid_union_discriminator:
      t = `Invalid discriminator value. Expected ${Ye.joinValues(n.options)}`;
      break;
    case se.invalid_enum_value:
      t = `Invalid enum value. Expected ${Ye.joinValues(n.options)}, received '${n.received}'`;
      break;
    case se.invalid_arguments:
      t = "Invalid function arguments";
      break;
    case se.invalid_return_type:
      t = "Invalid function return type";
      break;
    case se.invalid_date:
      t = "Invalid date";
      break;
    case se.invalid_string:
      typeof n.validation == "object" ? "includes" in n.validation ? (t = `Invalid input: must include "${n.validation.includes}"`, typeof n.validation.position == "number" && (t = `${t} at one or more positions greater than or equal to ${n.validation.position}`)) : "startsWith" in n.validation ? t = `Invalid input: must start with "${n.validation.startsWith}"` : "endsWith" in n.validation ? t = `Invalid input: must end with "${n.validation.endsWith}"` : Ye.assertNever(n.validation) : n.validation !== "regex" ? t = `Invalid ${n.validation}` : t = "Invalid";
      break;
    case se.too_small:
      n.type === "array" ? t = `Array must contain ${n.exact ? "exactly" : n.inclusive ? "at least" : "more than"} ${n.minimum} element(s)` : n.type === "string" ? t = `String must contain ${n.exact ? "exactly" : n.inclusive ? "at least" : "over"} ${n.minimum} character(s)` : n.type === "number" ? t = `Number must be ${n.exact ? "exactly equal to " : n.inclusive ? "greater than or equal to " : "greater than "}${n.minimum}` : n.type === "bigint" ? t = `Number must be ${n.exact ? "exactly equal to " : n.inclusive ? "greater than or equal to " : "greater than "}${n.minimum}` : n.type === "date" ? t = `Date must be ${n.exact ? "exactly equal to " : n.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(n.minimum))}` : t = "Invalid input";
      break;
    case se.too_big:
      n.type === "array" ? t = `Array must contain ${n.exact ? "exactly" : n.inclusive ? "at most" : "less than"} ${n.maximum} element(s)` : n.type === "string" ? t = `String must contain ${n.exact ? "exactly" : n.inclusive ? "at most" : "under"} ${n.maximum} character(s)` : n.type === "number" ? t = `Number must be ${n.exact ? "exactly" : n.inclusive ? "less than or equal to" : "less than"} ${n.maximum}` : n.type === "bigint" ? t = `BigInt must be ${n.exact ? "exactly" : n.inclusive ? "less than or equal to" : "less than"} ${n.maximum}` : n.type === "date" ? t = `Date must be ${n.exact ? "exactly" : n.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(n.maximum))}` : t = "Invalid input";
      break;
    case se.custom:
      t = "Invalid input";
      break;
    case se.invalid_intersection_types:
      t = "Intersection results could not be merged";
      break;
    case se.not_multiple_of:
      t = `Number must be a multiple of ${n.multipleOf}`;
      break;
    case se.not_finite:
      t = "Number must be finite";
      break;
    default:
      t = e.defaultError, Ye.assertNever(n);
  }
  return { message: t };
};
let Fm = nc;
function Nm() {
  return Fm;
}
const Um = (n) => {
  const { data: e, path: t, errorMaps: r, issueData: s } = n, i = [...t, ...s.path || []], o = {
    ...s,
    path: i
  };
  if (s.message !== void 0)
    return {
      ...s,
      path: i,
      message: s.message
    };
  let a = "";
  const l = r.filter((c) => !!c).slice().reverse();
  for (const c of l)
    a = c(o, { data: e, defaultError: a }).message;
  return {
    ...s,
    path: i,
    message: a
  };
};
function le(n, e) {
  const t = Nm(), r = Um({
    issueData: e,
    data: n.data,
    path: n.path,
    errorMaps: [
      n.common.contextualErrorMap,
      // contextual error map is first priority
      n.schemaErrorMap,
      // then schema-bound map if available
      t,
      // then global override map
      t === nc ? void 0 : nc
      // then global default map
    ].filter((s) => !!s)
  });
  n.common.issues.push(r);
}
class Rr {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, t) {
    const r = [];
    for (const s of t) {
      if (s.status === "aborted")
        return Ie;
      s.status === "dirty" && e.dirty(), r.push(s.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, t) {
    const r = [];
    for (const s of t) {
      const i = await s.key, o = await s.value;
      r.push({
        key: i,
        value: o
      });
    }
    return Rr.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, t) {
    const r = {};
    for (const s of t) {
      const { key: i, value: o } = s;
      if (i.status === "aborted" || o.status === "aborted")
        return Ie;
      i.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof o.value < "u" || s.alwaysSet) && (r[i.value] = o.value);
    }
    return { status: e.value, value: r };
  }
}
const Ie = Object.freeze({
  status: "aborted"
}), ui = (n) => ({ status: "dirty", value: n }), Ur = (n) => ({ status: "valid", value: n }), hd = (n) => n.status === "aborted", fd = (n) => n.status === "dirty", Ks = (n) => n.status === "valid", No = (n) => typeof Promise < "u" && n instanceof Promise;
var fe;
(function(n) {
  n.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, n.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(fe || (fe = {}));
class zn {
  constructor(e, t, r, s) {
    this._cachedPath = [], this.parent = e, this.data = t, this._path = r, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const gd = (n, e) => {
  if (Ks(e))
    return { success: !0, data: e.value };
  if (!n.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const t = new Rn(n.common.issues);
      return this._error = t, this._error;
    }
  };
};
function je(n) {
  if (!n)
    return {};
  const { errorMap: e, invalid_type_error: t, required_error: r, description: s } = n;
  if (e && (t || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (o, a) => {
    const { message: l } = n;
    return o.code === "invalid_enum_value" ? { message: l ?? a.defaultError } : typeof a.data > "u" ? { message: l ?? r ?? a.defaultError } : o.code !== "invalid_type" ? { message: a.defaultError } : { message: l ?? t ?? a.defaultError };
  }, description: s };
}
class ze {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Un(e.data);
  }
  _getOrReturnCtx(e, t) {
    return t || {
      common: e.parent.common,
      data: e.data,
      parsedType: Un(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new Rr(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Un(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const t = this._parse(e);
    if (No(t))
      throw new Error("Synchronous parse encountered promise.");
    return t;
  }
  _parseAsync(e) {
    const t = this._parse(e);
    return Promise.resolve(t);
  }
  parse(e, t) {
    const r = this.safeParse(e, t);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(e, t) {
    const r = {
      common: {
        issues: [],
        async: (t == null ? void 0 : t.async) ?? !1,
        contextualErrorMap: t == null ? void 0 : t.errorMap
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Un(e)
    }, s = this._parseSync({ data: e, path: r.path, parent: r });
    return gd(r, s);
  }
  "~validate"(e) {
    var r, s;
    const t = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Un(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: t });
        return Ks(i) ? {
          value: i.value
        } : {
          issues: t.common.issues
        };
      } catch (i) {
        (s = (r = i == null ? void 0 : i.message) == null ? void 0 : r.toLowerCase()) != null && s.includes("encountered") && (this["~standard"].async = !0), t.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: t }).then((i) => Ks(i) ? {
      value: i.value
    } : {
      issues: t.common.issues
    });
  }
  async parseAsync(e, t) {
    const r = await this.safeParseAsync(e, t);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(e, t) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: t == null ? void 0 : t.errorMap,
        async: !0
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Un(e)
    }, s = this._parse({ data: e, path: r.path, parent: r }), i = await (No(s) ? s : Promise.resolve(s));
    return gd(r, i);
  }
  refine(e, t) {
    const r = (s) => typeof t == "string" || typeof t > "u" ? { message: t } : typeof t == "function" ? t(s) : t;
    return this._refinement((s, i) => {
      const o = e(s), a = () => i.addIssue({
        code: se.custom,
        ...r(s)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (a(), !1)) : o ? !0 : (a(), !1);
    });
  }
  refinement(e, t) {
    return this._refinement((r, s) => e(r) ? !0 : (s.addIssue(typeof t == "function" ? t(r, s) : t), !1));
  }
  _refinement(e) {
    return new ds({
      schema: this,
      typeName: Re.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (t) => this["~validate"](t)
    };
  }
  optional() {
    return In.create(this, this._def);
  }
  nullable() {
    return hs.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return an.create(this);
  }
  promise() {
    return Vo.create(this, this._def);
  }
  or(e) {
    return $o.create([this, e], this._def);
  }
  and(e) {
    return Go.create(this, e, this._def);
  }
  transform(e) {
    return new ds({
      ...je(this._def),
      schema: this,
      typeName: Re.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const t = typeof e == "function" ? e : () => e;
    return new Ko({
      ...je(this._def),
      innerType: this,
      defaultValue: t,
      typeName: Re.ZodDefault
    });
  }
  brand() {
    return new Uf({
      typeName: Re.ZodBranded,
      type: this,
      ...je(this._def)
    });
  }
  catch(e) {
    const t = typeof e == "function" ? e : () => e;
    return new Ho({
      ...je(this._def),
      innerType: this,
      catchValue: t,
      typeName: Re.ZodCatch
    });
  }
  describe(e) {
    const t = this.constructor;
    return new t({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return eu.create(this, e);
  }
  readonly() {
    return Wo.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const $m = /^c[^\s-]{8,}$/i, Gm = /^[0-9a-z]+$/, jm = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Vm = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Km = /^[a-z0-9_-]{21}$/i, Hm = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Wm = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, qm = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, zm = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let ll;
const Ym = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Zm = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Xm = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Jm = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Qm = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, e1 = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Bf = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", t1 = new RegExp(`^${Bf}$`);
function Ff(n) {
  let e = "[0-5]\\d";
  n.precision ? e = `${e}\\.\\d{${n.precision}}` : n.precision == null && (e = `${e}(\\.\\d+)?`);
  const t = n.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${t}`;
}
function r1(n) {
  return new RegExp(`^${Ff(n)}$`);
}
function n1(n) {
  let e = `${Bf}T${Ff(n)}`;
  const t = [];
  return t.push(n.local ? "Z?" : "Z"), n.offset && t.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${t.join("|")})`, new RegExp(`^${e}$`);
}
function s1(n, e) {
  return !!((e === "v4" || !e) && Ym.test(n) || (e === "v6" || !e) && Xm.test(n));
}
function i1(n, e) {
  if (!Hm.test(n))
    return !1;
  try {
    const [t] = n.split(".");
    if (!t)
      return !1;
    const r = t.replace(/-/g, "+").replace(/_/g, "/").padEnd(t.length + (4 - t.length % 4) % 4, "="), s = JSON.parse(atob(r));
    return !(typeof s != "object" || s === null || "typ" in s && (s == null ? void 0 : s.typ) !== "JWT" || !s.alg || e && s.alg !== e);
  } catch {
    return !1;
  }
}
function o1(n, e) {
  return !!((e === "v4" || !e) && Zm.test(n) || (e === "v6" || !e) && Jm.test(n));
}
class Vn extends ze {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== de.string) {
      const i = this._getOrReturnCtx(e);
      return le(i, {
        code: se.invalid_type,
        expected: de.string,
        received: i.parsedType
      }), Ie;
    }
    const r = new Rr();
    let s;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (s = this._getOrReturnCtx(e, s), le(s, {
          code: se.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (s = this._getOrReturnCtx(e, s), le(s, {
          code: se.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "length") {
        const o = e.data.length > i.value, a = e.data.length < i.value;
        (o || a) && (s = this._getOrReturnCtx(e, s), o ? le(s, {
          code: se.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : a && le(s, {
          code: se.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), r.dirty());
      } else if (i.kind === "email")
        qm.test(e.data) || (s = this._getOrReturnCtx(e, s), le(s, {
          validation: "email",
          code: se.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "emoji")
        ll || (ll = new RegExp(zm, "u")), ll.test(e.data) || (s = this._getOrReturnCtx(e, s), le(s, {
          validation: "emoji",
          code: se.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "uuid")
        Vm.test(e.data) || (s = this._getOrReturnCtx(e, s), le(s, {
          validation: "uuid",
          code: se.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "nanoid")
        Km.test(e.data) || (s = this._getOrReturnCtx(e, s), le(s, {
          validation: "nanoid",
          code: se.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid")
        $m.test(e.data) || (s = this._getOrReturnCtx(e, s), le(s, {
          validation: "cuid",
          code: se.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid2")
        Gm.test(e.data) || (s = this._getOrReturnCtx(e, s), le(s, {
          validation: "cuid2",
          code: se.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "ulid")
        jm.test(e.data) || (s = this._getOrReturnCtx(e, s), le(s, {
          validation: "ulid",
          code: se.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          s = this._getOrReturnCtx(e, s), le(s, {
            validation: "url",
            code: se.invalid_string,
            message: i.message
          }), r.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (s = this._getOrReturnCtx(e, s), le(s, {
        validation: "regex",
        code: se.invalid_string,
        message: i.message
      }), r.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (s = this._getOrReturnCtx(e, s), le(s, {
        code: se.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), r.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (s = this._getOrReturnCtx(e, s), le(s, {
        code: se.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), r.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (s = this._getOrReturnCtx(e, s), le(s, {
        code: se.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), r.dirty()) : i.kind === "datetime" ? n1(i).test(e.data) || (s = this._getOrReturnCtx(e, s), le(s, {
        code: se.invalid_string,
        validation: "datetime",
        message: i.message
      }), r.dirty()) : i.kind === "date" ? t1.test(e.data) || (s = this._getOrReturnCtx(e, s), le(s, {
        code: se.invalid_string,
        validation: "date",
        message: i.message
      }), r.dirty()) : i.kind === "time" ? r1(i).test(e.data) || (s = this._getOrReturnCtx(e, s), le(s, {
        code: se.invalid_string,
        validation: "time",
        message: i.message
      }), r.dirty()) : i.kind === "duration" ? Wm.test(e.data) || (s = this._getOrReturnCtx(e, s), le(s, {
        validation: "duration",
        code: se.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "ip" ? s1(e.data, i.version) || (s = this._getOrReturnCtx(e, s), le(s, {
        validation: "ip",
        code: se.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "jwt" ? i1(e.data, i.alg) || (s = this._getOrReturnCtx(e, s), le(s, {
        validation: "jwt",
        code: se.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "cidr" ? o1(e.data, i.version) || (s = this._getOrReturnCtx(e, s), le(s, {
        validation: "cidr",
        code: se.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "base64" ? Qm.test(e.data) || (s = this._getOrReturnCtx(e, s), le(s, {
        validation: "base64",
        code: se.invalid_string,
        message: i.message
      }), r.dirty()) : i.kind === "base64url" ? e1.test(e.data) || (s = this._getOrReturnCtx(e, s), le(s, {
        validation: "base64url",
        code: se.invalid_string,
        message: i.message
      }), r.dirty()) : Ye.assertNever(i);
    return { status: r.value, value: e.data };
  }
  _regex(e, t, r) {
    return this.refinement((s) => e.test(s), {
      validation: t,
      code: se.invalid_string,
      ...fe.errToObj(r)
    });
  }
  _addCheck(e) {
    return new Vn({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...fe.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...fe.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...fe.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...fe.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...fe.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...fe.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...fe.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...fe.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...fe.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...fe.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...fe.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...fe.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...fe.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (e == null ? void 0 : e.offset) ?? !1,
      local: (e == null ? void 0 : e.local) ?? !1,
      ...fe.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...fe.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...fe.errToObj(e) });
  }
  regex(e, t) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...fe.errToObj(t)
    });
  }
  includes(e, t) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: t == null ? void 0 : t.position,
      ...fe.errToObj(t == null ? void 0 : t.message)
    });
  }
  startsWith(e, t) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...fe.errToObj(t)
    });
  }
  endsWith(e, t) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...fe.errToObj(t)
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...fe.errToObj(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...fe.errToObj(t)
    });
  }
  length(e, t) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...fe.errToObj(t)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, fe.errToObj(e));
  }
  trim() {
    return new Vn({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Vn({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Vn({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
Vn.create = (n) => new Vn({
  checks: [],
  typeName: Re.ZodString,
  coerce: (n == null ? void 0 : n.coerce) ?? !1,
  ...je(n)
});
function a1(n, e) {
  const t = (n.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, s = t > r ? t : r, i = Number.parseInt(n.toFixed(s).replace(".", "")), o = Number.parseInt(e.toFixed(s).replace(".", ""));
  return i % o / 10 ** s;
}
class Hs extends ze {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== de.number) {
      const i = this._getOrReturnCtx(e);
      return le(i, {
        code: se.invalid_type,
        expected: de.number,
        received: i.parsedType
      }), Ie;
    }
    let r;
    const s = new Rr();
    for (const i of this._def.checks)
      i.kind === "int" ? Ye.isInteger(e.data) || (r = this._getOrReturnCtx(e, r), le(r, {
        code: se.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), s.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (r = this._getOrReturnCtx(e, r), le(r, {
        code: se.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), s.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (r = this._getOrReturnCtx(e, r), le(r, {
        code: se.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), s.dirty()) : i.kind === "multipleOf" ? a1(e.data, i.value) !== 0 && (r = this._getOrReturnCtx(e, r), le(r, {
        code: se.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), s.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (r = this._getOrReturnCtx(e, r), le(r, {
        code: se.not_finite,
        message: i.message
      }), s.dirty()) : Ye.assertNever(i);
    return { status: s.value, value: e.data };
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, fe.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, fe.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, fe.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, fe.toString(t));
  }
  setLimit(e, t, r, s) {
    return new Hs({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: r,
          message: fe.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Hs({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: fe.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: fe.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: fe.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: fe.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: fe.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: fe.toString(t)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: fe.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: fe.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: fe.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && Ye.isInteger(e.value));
  }
  get isFinite() {
    let e = null, t = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (t === null || r.value > t) && (t = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(t) && Number.isFinite(e);
  }
}
Hs.create = (n) => new Hs({
  checks: [],
  typeName: Re.ZodNumber,
  coerce: (n == null ? void 0 : n.coerce) || !1,
  ...je(n)
});
class xi extends ze {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== de.bigint)
      return this._getInvalidInput(e);
    let r;
    const s = new Rr();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (r = this._getOrReturnCtx(e, r), le(r, {
        code: se.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), s.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (r = this._getOrReturnCtx(e, r), le(r, {
        code: se.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), s.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (r = this._getOrReturnCtx(e, r), le(r, {
        code: se.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), s.dirty()) : Ye.assertNever(i);
    return { status: s.value, value: e.data };
  }
  _getInvalidInput(e) {
    const t = this._getOrReturnCtx(e);
    return le(t, {
      code: se.invalid_type,
      expected: de.bigint,
      received: t.parsedType
    }), Ie;
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, fe.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, fe.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, fe.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, fe.toString(t));
  }
  setLimit(e, t, r, s) {
    return new xi({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: r,
          message: fe.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new xi({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: fe.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: fe.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: fe.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: fe.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: fe.toString(t)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
xi.create = (n) => new xi({
  checks: [],
  typeName: Re.ZodBigInt,
  coerce: (n == null ? void 0 : n.coerce) ?? !1,
  ...je(n)
});
class sc extends ze {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== de.boolean) {
      const r = this._getOrReturnCtx(e);
      return le(r, {
        code: se.invalid_type,
        expected: de.boolean,
        received: r.parsedType
      }), Ie;
    }
    return Ur(e.data);
  }
}
sc.create = (n) => new sc({
  typeName: Re.ZodBoolean,
  coerce: (n == null ? void 0 : n.coerce) || !1,
  ...je(n)
});
class Uo extends ze {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== de.date) {
      const i = this._getOrReturnCtx(e);
      return le(i, {
        code: se.invalid_type,
        expected: de.date,
        received: i.parsedType
      }), Ie;
    }
    if (Number.isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return le(i, {
        code: se.invalid_date
      }), Ie;
    }
    const r = new Rr();
    let s;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (s = this._getOrReturnCtx(e, s), le(s, {
        code: se.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), r.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (s = this._getOrReturnCtx(e, s), le(s, {
        code: se.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), r.dirty()) : Ye.assertNever(i);
    return {
      status: r.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Uo({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: fe.toString(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: fe.toString(t)
    });
  }
  get minDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
}
Uo.create = (n) => new Uo({
  checks: [],
  coerce: (n == null ? void 0 : n.coerce) || !1,
  typeName: Re.ZodDate,
  ...je(n)
});
class pd extends ze {
  _parse(e) {
    if (this._getType(e) !== de.symbol) {
      const r = this._getOrReturnCtx(e);
      return le(r, {
        code: se.invalid_type,
        expected: de.symbol,
        received: r.parsedType
      }), Ie;
    }
    return Ur(e.data);
  }
}
pd.create = (n) => new pd({
  typeName: Re.ZodSymbol,
  ...je(n)
});
class ic extends ze {
  _parse(e) {
    if (this._getType(e) !== de.undefined) {
      const r = this._getOrReturnCtx(e);
      return le(r, {
        code: se.invalid_type,
        expected: de.undefined,
        received: r.parsedType
      }), Ie;
    }
    return Ur(e.data);
  }
}
ic.create = (n) => new ic({
  typeName: Re.ZodUndefined,
  ...je(n)
});
class oc extends ze {
  _parse(e) {
    if (this._getType(e) !== de.null) {
      const r = this._getOrReturnCtx(e);
      return le(r, {
        code: se.invalid_type,
        expected: de.null,
        received: r.parsedType
      }), Ie;
    }
    return Ur(e.data);
  }
}
oc.create = (n) => new oc({
  typeName: Re.ZodNull,
  ...je(n)
});
class md extends ze {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Ur(e.data);
  }
}
md.create = (n) => new md({
  typeName: Re.ZodAny,
  ...je(n)
});
class yd extends ze {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Ur(e.data);
  }
}
yd.create = (n) => new yd({
  typeName: Re.ZodUnknown,
  ...je(n)
});
class Yn extends ze {
  _parse(e) {
    const t = this._getOrReturnCtx(e);
    return le(t, {
      code: se.invalid_type,
      expected: de.never,
      received: t.parsedType
    }), Ie;
  }
}
Yn.create = (n) => new Yn({
  typeName: Re.ZodNever,
  ...je(n)
});
class vd extends ze {
  _parse(e) {
    if (this._getType(e) !== de.undefined) {
      const r = this._getOrReturnCtx(e);
      return le(r, {
        code: se.invalid_type,
        expected: de.void,
        received: r.parsedType
      }), Ie;
    }
    return Ur(e.data);
  }
}
vd.create = (n) => new vd({
  typeName: Re.ZodVoid,
  ...je(n)
});
class an extends ze {
  _parse(e) {
    const { ctx: t, status: r } = this._processInputParams(e), s = this._def;
    if (t.parsedType !== de.array)
      return le(t, {
        code: se.invalid_type,
        expected: de.array,
        received: t.parsedType
      }), Ie;
    if (s.exactLength !== null) {
      const o = t.data.length > s.exactLength.value, a = t.data.length < s.exactLength.value;
      (o || a) && (le(t, {
        code: o ? se.too_big : se.too_small,
        minimum: a ? s.exactLength.value : void 0,
        maximum: o ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), r.dirty());
    }
    if (s.minLength !== null && t.data.length < s.minLength.value && (le(t, {
      code: se.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), r.dirty()), s.maxLength !== null && t.data.length > s.maxLength.value && (le(t, {
      code: se.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), r.dirty()), t.common.async)
      return Promise.all([...t.data].map((o, a) => s.type._parseAsync(new zn(t, o, t.path, a)))).then((o) => Rr.mergeArray(r, o));
    const i = [...t.data].map((o, a) => s.type._parseSync(new zn(t, o, t.path, a)));
    return Rr.mergeArray(r, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, t) {
    return new an({
      ...this._def,
      minLength: { value: e, message: fe.toString(t) }
    });
  }
  max(e, t) {
    return new an({
      ...this._def,
      maxLength: { value: e, message: fe.toString(t) }
    });
  }
  length(e, t) {
    return new an({
      ...this._def,
      exactLength: { value: e, message: fe.toString(t) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
an.create = (n, e) => new an({
  type: n,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Re.ZodArray,
  ...je(e)
});
function Ds(n) {
  if (n instanceof jt) {
    const e = {};
    for (const t in n.shape) {
      const r = n.shape[t];
      e[t] = In.create(Ds(r));
    }
    return new jt({
      ...n._def,
      shape: () => e
    });
  } else return n instanceof an ? new an({
    ...n._def,
    type: Ds(n.element)
  }) : n instanceof In ? In.create(Ds(n.unwrap())) : n instanceof hs ? hs.create(Ds(n.unwrap())) : n instanceof cs ? cs.create(n.items.map((e) => Ds(e))) : n;
}
class jt extends ze {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), t = Ye.objectKeys(e);
    return this._cached = { shape: e, keys: t }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== de.object) {
      const c = this._getOrReturnCtx(e);
      return le(c, {
        code: se.invalid_type,
        expected: de.object,
        received: c.parsedType
      }), Ie;
    }
    const { status: r, ctx: s } = this._processInputParams(e), { shape: i, keys: o } = this._getCached(), a = [];
    if (!(this._def.catchall instanceof Yn && this._def.unknownKeys === "strip"))
      for (const c in s.data)
        o.includes(c) || a.push(c);
    const l = [];
    for (const c of o) {
      const u = i[c], d = s.data[c];
      l.push({
        key: { status: "valid", value: c },
        value: u._parse(new zn(s, d, s.path, c)),
        alwaysSet: c in s.data
      });
    }
    if (this._def.catchall instanceof Yn) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const u of a)
          l.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: s.data[u] }
          });
      else if (c === "strict")
        a.length > 0 && (le(s, {
          code: se.unrecognized_keys,
          keys: a
        }), r.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const u of a) {
        const d = s.data[u];
        l.push({
          key: { status: "valid", value: u },
          value: c._parse(
            new zn(s, d, s.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const u of l) {
        const d = await u.key, h = await u.value;
        c.push({
          key: d,
          value: h,
          alwaysSet: u.alwaysSet
        });
      }
      return c;
    }).then((c) => Rr.mergeObjectSync(r, c)) : Rr.mergeObjectSync(r, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return fe.errToObj, new jt({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (t, r) => {
          var i, o;
          const s = ((o = (i = this._def).errorMap) == null ? void 0 : o.call(i, t, r).message) ?? r.defaultError;
          return t.code === "unrecognized_keys" ? {
            message: fe.errToObj(e).message ?? s
          } : {
            message: s
          };
        }
      } : {}
    });
  }
  strip() {
    return new jt({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new jt({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new jt({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new jt({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: Re.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, t) {
    return this.augment({ [e]: t });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new jt({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const t = {};
    for (const r of Ye.objectKeys(e))
      e[r] && this.shape[r] && (t[r] = this.shape[r]);
    return new jt({
      ...this._def,
      shape: () => t
    });
  }
  omit(e) {
    const t = {};
    for (const r of Ye.objectKeys(this.shape))
      e[r] || (t[r] = this.shape[r]);
    return new jt({
      ...this._def,
      shape: () => t
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return Ds(this);
  }
  partial(e) {
    const t = {};
    for (const r of Ye.objectKeys(this.shape)) {
      const s = this.shape[r];
      e && !e[r] ? t[r] = s : t[r] = s.optional();
    }
    return new jt({
      ...this._def,
      shape: () => t
    });
  }
  required(e) {
    const t = {};
    for (const r of Ye.objectKeys(this.shape))
      if (e && !e[r])
        t[r] = this.shape[r];
      else {
        let i = this.shape[r];
        for (; i instanceof In; )
          i = i._def.innerType;
        t[r] = i;
      }
    return new jt({
      ...this._def,
      shape: () => t
    });
  }
  keyof() {
    return Nf(Ye.objectKeys(this.shape));
  }
}
jt.create = (n, e) => new jt({
  shape: () => n,
  unknownKeys: "strip",
  catchall: Yn.create(),
  typeName: Re.ZodObject,
  ...je(e)
});
jt.strictCreate = (n, e) => new jt({
  shape: () => n,
  unknownKeys: "strict",
  catchall: Yn.create(),
  typeName: Re.ZodObject,
  ...je(e)
});
jt.lazycreate = (n, e) => new jt({
  shape: n,
  unknownKeys: "strip",
  catchall: Yn.create(),
  typeName: Re.ZodObject,
  ...je(e)
});
class $o extends ze {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = this._def.options;
    function s(i) {
      for (const a of i)
        if (a.result.status === "valid")
          return a.result;
      for (const a of i)
        if (a.result.status === "dirty")
          return t.common.issues.push(...a.ctx.common.issues), a.result;
      const o = i.map((a) => new Rn(a.ctx.common.issues));
      return le(t, {
        code: se.invalid_union,
        unionErrors: o
      }), Ie;
    }
    if (t.common.async)
      return Promise.all(r.map(async (i) => {
        const o = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: t.data,
            path: t.path,
            parent: o
          }),
          ctx: o
        };
      })).then(s);
    {
      let i;
      const o = [];
      for (const l of r) {
        const c = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        }, u = l._parseSync({
          data: t.data,
          path: t.path,
          parent: c
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !i && (i = { result: u, ctx: c }), c.common.issues.length && o.push(c.common.issues);
      }
      if (i)
        return t.common.issues.push(...i.ctx.common.issues), i.result;
      const a = o.map((l) => new Rn(l));
      return le(t, {
        code: se.invalid_union,
        unionErrors: a
      }), Ie;
    }
  }
  get options() {
    return this._def.options;
  }
}
$o.create = (n, e) => new $o({
  options: n,
  typeName: Re.ZodUnion,
  ...je(e)
});
const xn = (n) => n instanceof lc ? xn(n.schema) : n instanceof ds ? xn(n.innerType()) : n instanceof jo ? [n.value] : n instanceof us ? n.options : n instanceof cc ? Ye.objectValues(n.enum) : n instanceof Ko ? xn(n._def.innerType) : n instanceof ic ? [void 0] : n instanceof oc ? [null] : n instanceof In ? [void 0, ...xn(n.unwrap())] : n instanceof hs ? [null, ...xn(n.unwrap())] : n instanceof Uf || n instanceof Wo ? xn(n.unwrap()) : n instanceof Ho ? xn(n._def.innerType) : [];
class Qc extends ze {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== de.object)
      return le(t, {
        code: se.invalid_type,
        expected: de.object,
        received: t.parsedType
      }), Ie;
    const r = this.discriminator, s = t.data[r], i = this.optionsMap.get(s);
    return i ? t.common.async ? i._parseAsync({
      data: t.data,
      path: t.path,
      parent: t
    }) : i._parseSync({
      data: t.data,
      path: t.path,
      parent: t
    }) : (le(t, {
      code: se.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), Ie);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, t, r) {
    const s = /* @__PURE__ */ new Map();
    for (const i of t) {
      const o = xn(i.shape[e]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const a of o) {
        if (s.has(a))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(a)}`);
        s.set(a, i);
      }
    }
    return new Qc({
      typeName: Re.ZodDiscriminatedUnion,
      discriminator: e,
      options: t,
      optionsMap: s,
      ...je(r)
    });
  }
}
function ac(n, e) {
  const t = Un(n), r = Un(e);
  if (n === e)
    return { valid: !0, data: n };
  if (t === de.object && r === de.object) {
    const s = Ye.objectKeys(e), i = Ye.objectKeys(n).filter((a) => s.indexOf(a) !== -1), o = { ...n, ...e };
    for (const a of i) {
      const l = ac(n[a], e[a]);
      if (!l.valid)
        return { valid: !1 };
      o[a] = l.data;
    }
    return { valid: !0, data: o };
  } else if (t === de.array && r === de.array) {
    if (n.length !== e.length)
      return { valid: !1 };
    const s = [];
    for (let i = 0; i < n.length; i++) {
      const o = n[i], a = e[i], l = ac(o, a);
      if (!l.valid)
        return { valid: !1 };
      s.push(l.data);
    }
    return { valid: !0, data: s };
  } else return t === de.date && r === de.date && +n == +e ? { valid: !0, data: n } : { valid: !1 };
}
class Go extends ze {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e), s = (i, o) => {
      if (hd(i) || hd(o))
        return Ie;
      const a = ac(i.value, o.value);
      return a.valid ? ((fd(i) || fd(o)) && t.dirty(), { status: t.value, value: a.data }) : (le(r, {
        code: se.invalid_intersection_types
      }), Ie);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([i, o]) => s(i, o)) : s(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
Go.create = (n, e, t) => new Go({
  left: n,
  right: e,
  typeName: Re.ZodIntersection,
  ...je(t)
});
class cs extends ze {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== de.array)
      return le(r, {
        code: se.invalid_type,
        expected: de.array,
        received: r.parsedType
      }), Ie;
    if (r.data.length < this._def.items.length)
      return le(r, {
        code: se.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Ie;
    !this._def.rest && r.data.length > this._def.items.length && (le(r, {
      code: se.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), t.dirty());
    const i = [...r.data].map((o, a) => {
      const l = this._def.items[a] || this._def.rest;
      return l ? l._parse(new zn(r, o, r.path, a)) : null;
    }).filter((o) => !!o);
    return r.common.async ? Promise.all(i).then((o) => Rr.mergeArray(t, o)) : Rr.mergeArray(t, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new cs({
      ...this._def,
      rest: e
    });
  }
}
cs.create = (n, e) => {
  if (!Array.isArray(n))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new cs({
    items: n,
    typeName: Re.ZodTuple,
    rest: null,
    ...je(e)
  });
};
class xd extends ze {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== de.map)
      return le(r, {
        code: se.invalid_type,
        expected: de.map,
        received: r.parsedType
      }), Ie;
    const s = this._def.keyType, i = this._def.valueType, o = [...r.data.entries()].map(([a, l], c) => ({
      key: s._parse(new zn(r, a, r.path, [c, "key"])),
      value: i._parse(new zn(r, l, r.path, [c, "value"]))
    }));
    if (r.common.async) {
      const a = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const c = await l.key, u = await l.value;
          if (c.status === "aborted" || u.status === "aborted")
            return Ie;
          (c.status === "dirty" || u.status === "dirty") && t.dirty(), a.set(c.value, u.value);
        }
        return { status: t.value, value: a };
      });
    } else {
      const a = /* @__PURE__ */ new Map();
      for (const l of o) {
        const c = l.key, u = l.value;
        if (c.status === "aborted" || u.status === "aborted")
          return Ie;
        (c.status === "dirty" || u.status === "dirty") && t.dirty(), a.set(c.value, u.value);
      }
      return { status: t.value, value: a };
    }
  }
}
xd.create = (n, e, t) => new xd({
  valueType: e,
  keyType: n,
  typeName: Re.ZodMap,
  ...je(t)
});
class Ei extends ze {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== de.set)
      return le(r, {
        code: se.invalid_type,
        expected: de.set,
        received: r.parsedType
      }), Ie;
    const s = this._def;
    s.minSize !== null && r.data.size < s.minSize.value && (le(r, {
      code: se.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), t.dirty()), s.maxSize !== null && r.data.size > s.maxSize.value && (le(r, {
      code: se.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), t.dirty());
    const i = this._def.valueType;
    function o(l) {
      const c = /* @__PURE__ */ new Set();
      for (const u of l) {
        if (u.status === "aborted")
          return Ie;
        u.status === "dirty" && t.dirty(), c.add(u.value);
      }
      return { status: t.value, value: c };
    }
    const a = [...r.data.values()].map((l, c) => i._parse(new zn(r, l, r.path, c)));
    return r.common.async ? Promise.all(a).then((l) => o(l)) : o(a);
  }
  min(e, t) {
    return new Ei({
      ...this._def,
      minSize: { value: e, message: fe.toString(t) }
    });
  }
  max(e, t) {
    return new Ei({
      ...this._def,
      maxSize: { value: e, message: fe.toString(t) }
    });
  }
  size(e, t) {
    return this.min(e, t).max(e, t);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Ei.create = (n, e) => new Ei({
  valueType: n,
  minSize: null,
  maxSize: null,
  typeName: Re.ZodSet,
  ...je(e)
});
class lc extends ze {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    return this._def.getter()._parse({ data: t.data, path: t.path, parent: t });
  }
}
lc.create = (n, e) => new lc({
  getter: n,
  typeName: Re.ZodLazy,
  ...je(e)
});
class jo extends ze {
  _parse(e) {
    if (e.data !== this._def.value) {
      const t = this._getOrReturnCtx(e);
      return le(t, {
        received: t.data,
        code: se.invalid_literal,
        expected: this._def.value
      }), Ie;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
jo.create = (n, e) => new jo({
  value: n,
  typeName: Re.ZodLiteral,
  ...je(e)
});
function Nf(n, e) {
  return new us({
    values: n,
    typeName: Re.ZodEnum,
    ...je(e)
  });
}
class us extends ze {
  _parse(e) {
    if (typeof e.data != "string") {
      const t = this._getOrReturnCtx(e), r = this._def.values;
      return le(t, {
        expected: Ye.joinValues(r),
        received: t.parsedType,
        code: se.invalid_type
      }), Ie;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const t = this._getOrReturnCtx(e), r = this._def.values;
      return le(t, {
        received: t.data,
        code: se.invalid_enum_value,
        options: r
      }), Ie;
    }
    return Ur(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Values() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  extract(e, t = this._def) {
    return us.create(e, {
      ...this._def,
      ...t
    });
  }
  exclude(e, t = this._def) {
    return us.create(this.options.filter((r) => !e.includes(r)), {
      ...this._def,
      ...t
    });
  }
}
us.create = Nf;
class cc extends ze {
  _parse(e) {
    const t = Ye.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== de.string && r.parsedType !== de.number) {
      const s = Ye.objectValues(t);
      return le(r, {
        expected: Ye.joinValues(s),
        received: r.parsedType,
        code: se.invalid_type
      }), Ie;
    }
    if (this._cache || (this._cache = new Set(Ye.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const s = Ye.objectValues(t);
      return le(r, {
        received: r.data,
        code: se.invalid_enum_value,
        options: s
      }), Ie;
    }
    return Ur(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
cc.create = (n, e) => new cc({
  values: n,
  typeName: Re.ZodNativeEnum,
  ...je(e)
});
class Vo extends ze {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== de.promise && t.common.async === !1)
      return le(t, {
        code: se.invalid_type,
        expected: de.promise,
        received: t.parsedType
      }), Ie;
    const r = t.parsedType === de.promise ? t.data : Promise.resolve(t.data);
    return Ur(r.then((s) => this._def.type.parseAsync(s, {
      path: t.path,
      errorMap: t.common.contextualErrorMap
    })));
  }
}
Vo.create = (n, e) => new Vo({
  type: n,
  typeName: Re.ZodPromise,
  ...je(e)
});
class ds extends ze {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Re.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e), s = this._def.effect || null, i = {
      addIssue: (o) => {
        le(r, o), o.fatal ? t.abort() : t.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), s.type === "preprocess") {
      const o = s.transform(r.data, i);
      if (r.common.async)
        return Promise.resolve(o).then(async (a) => {
          if (t.value === "aborted")
            return Ie;
          const l = await this._def.schema._parseAsync({
            data: a,
            path: r.path,
            parent: r
          });
          return l.status === "aborted" ? Ie : l.status === "dirty" || t.value === "dirty" ? ui(l.value) : l;
        });
      {
        if (t.value === "aborted")
          return Ie;
        const a = this._def.schema._parseSync({
          data: o,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? Ie : a.status === "dirty" || t.value === "dirty" ? ui(a.value) : a;
      }
    }
    if (s.type === "refinement") {
      const o = (a) => {
        const l = s.refinement(a, i);
        if (r.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return a;
      };
      if (r.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? Ie : (a.status === "dirty" && t.dirty(), o(a.value), { status: t.value, value: a.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((a) => a.status === "aborted" ? Ie : (a.status === "dirty" && t.dirty(), o(a.value).then(() => ({ status: t.value, value: a.value }))));
    }
    if (s.type === "transform")
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!Ks(o))
          return Ie;
        const a = s.transform(o.value, i);
        if (a instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: t.value, value: a };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => Ks(o) ? Promise.resolve(s.transform(o.value, i)).then((a) => ({
          status: t.value,
          value: a
        })) : Ie);
    Ye.assertNever(s);
  }
}
ds.create = (n, e, t) => new ds({
  schema: n,
  typeName: Re.ZodEffects,
  effect: e,
  ...je(t)
});
ds.createWithPreprocess = (n, e, t) => new ds({
  schema: e,
  effect: { type: "preprocess", transform: n },
  typeName: Re.ZodEffects,
  ...je(t)
});
class In extends ze {
  _parse(e) {
    return this._getType(e) === de.undefined ? Ur(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
In.create = (n, e) => new In({
  innerType: n,
  typeName: Re.ZodOptional,
  ...je(e)
});
class hs extends ze {
  _parse(e) {
    return this._getType(e) === de.null ? Ur(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
hs.create = (n, e) => new hs({
  innerType: n,
  typeName: Re.ZodNullable,
  ...je(e)
});
class Ko extends ze {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    let r = t.data;
    return t.parsedType === de.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: t.path,
      parent: t
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Ko.create = (n, e) => new Ko({
  innerType: n,
  typeName: Re.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...je(e)
});
class Ho extends ze {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = {
      ...t,
      common: {
        ...t.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return No(s) ? s.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new Rn(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new Rn(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Ho.create = (n, e) => new Ho({
  innerType: n,
  typeName: Re.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...je(e)
});
class Ed extends ze {
  _parse(e) {
    if (this._getType(e) !== de.nan) {
      const r = this._getOrReturnCtx(e);
      return le(r, {
        code: se.invalid_type,
        expected: de.nan,
        received: r.parsedType
      }), Ie;
    }
    return { status: "valid", value: e.data };
  }
}
Ed.create = (n) => new Ed({
  typeName: Re.ZodNaN,
  ...je(n)
});
class Uf extends ze {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = t.data;
    return this._def.type._parse({
      data: r,
      path: t.path,
      parent: t
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class eu extends ze {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return i.status === "aborted" ? Ie : i.status === "dirty" ? (t.dirty(), ui(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return s.status === "aborted" ? Ie : s.status === "dirty" ? (t.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(e, t) {
    return new eu({
      in: e,
      out: t,
      typeName: Re.ZodPipeline
    });
  }
}
class Wo extends ze {
  _parse(e) {
    const t = this._def.innerType._parse(e), r = (s) => (Ks(s) && (s.value = Object.freeze(s.value)), s);
    return No(t) ? t.then((s) => r(s)) : r(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Wo.create = (n, e) => new Wo({
  innerType: n,
  typeName: Re.ZodReadonly,
  ...je(e)
});
var Re;
(function(n) {
  n.ZodString = "ZodString", n.ZodNumber = "ZodNumber", n.ZodNaN = "ZodNaN", n.ZodBigInt = "ZodBigInt", n.ZodBoolean = "ZodBoolean", n.ZodDate = "ZodDate", n.ZodSymbol = "ZodSymbol", n.ZodUndefined = "ZodUndefined", n.ZodNull = "ZodNull", n.ZodAny = "ZodAny", n.ZodUnknown = "ZodUnknown", n.ZodNever = "ZodNever", n.ZodVoid = "ZodVoid", n.ZodArray = "ZodArray", n.ZodObject = "ZodObject", n.ZodUnion = "ZodUnion", n.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", n.ZodIntersection = "ZodIntersection", n.ZodTuple = "ZodTuple", n.ZodRecord = "ZodRecord", n.ZodMap = "ZodMap", n.ZodSet = "ZodSet", n.ZodFunction = "ZodFunction", n.ZodLazy = "ZodLazy", n.ZodLiteral = "ZodLiteral", n.ZodEnum = "ZodEnum", n.ZodEffects = "ZodEffects", n.ZodNativeEnum = "ZodNativeEnum", n.ZodOptional = "ZodOptional", n.ZodNullable = "ZodNullable", n.ZodDefault = "ZodDefault", n.ZodCatch = "ZodCatch", n.ZodPromise = "ZodPromise", n.ZodBranded = "ZodBranded", n.ZodPipeline = "ZodPipeline", n.ZodReadonly = "ZodReadonly";
})(Re || (Re = {}));
const St = Vn.create, $f = Hs.create, l1 = sc.create;
Yn.create;
const ss = an.create, Wt = jt.create, qo = $o.create, Gf = Qc.create;
Go.create;
cs.create;
const Xt = jo.create, uc = us.create;
Vo.create;
In.create;
hs.create;
const c1 = /[@#$%^&*+=/\\|~«»]/, u1 = /(!{2,}|\?{2,}|-{2,})/, d1 = /[\u{1F300}-\u{1F9FF}]|[\u{2702}-\u{27B0}]|[\u{2600}-\u{26FF}]|[\u{2B00}-\u{2BFF}]/u, bs = ({ max: n, noSpaces: e } = {}) => (e ? St().max(n ?? Number.POSITIVE_INFINITY).regex(/^\S*$/, "Spaces are not allowed") : St().max(n ?? Number.POSITIVE_INFINITY)).refine((r) => !d1.test(r), {
  message: "Emojis and symbols are not allowed"
}).refine((r) => !c1.test(r), {
  message: "Special characters (@, #, $, %, ^, &, *, +, =, /, \\, |, ~, «, ») are not allowed"
}).refine((r) => !u1.test(r), {
  message: "Repeated punctuations (!!, ??, --) are not allowed"
}), dr = St().url().startsWith("https://", { message: "Must be an https url" }).max(1024).refine((n) => !n.includes(" "), {
  message: "URL must not contain spaces"
}).refine((n) => {
  try {
    const e = new URL(n).hostname;
    return !(e === "localhost" || e.endsWith(".localhost") || /^(\d{1,3}\.){3}\d{1,3}$/.test(e) || e.startsWith("[") && e.endsWith("]"));
  } catch {
    return !1;
  }
}, {
  message: "URL must not use IP addresses or localhost"
}), tu = St().max(32), jf = St().max(32), h1 = /^[-a-z0-9]{3,8}:[-_a-zA-Z0-9]{1,32}\/(?:[-a-z0-9]{3,8}:[-.%a-zA-Z0-9]{1,128}(?:\/[-.%a-zA-Z0-9]{1,78})?|native)$/, f1 = St().regex(h1, { message: "Invalid CAIP-19 asset ID" }), ru = St().regex(/^#([0-9A-F]{3}|[0-9A-F]{6})$/i, {
  message: "Invalid hex color code. It should be in the format #RRGGBB or #RGB."
}), g1 = /^(?!.*\.\.)([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/, p1 = St().max(1024).regex(g1, {
  message: "Must be a valid domain name (e.g., example.com, sub.example.com)"
}).refine((n) => !n.includes("://"), {
  message: "Domain must not include protocol (http://, https://, etc.)"
}).refine((n) => !n.includes("/"), {
  message: "Domain must not include path separators"
}).refine((n) => !n.includes("@"), {
  message: "Domain must not include @ symbol"
}).refine((n) => !n.includes(":"), {
  message: "Domain must not include port numbers"
}), m1 = qo([Xt("1:1"), Xt("3:2")]), y1 = Wt({
  header: St(),
  payload: St(),
  signature: St()
});
Wt({
  fid: $f(),
  type: Xt("app_key"),
  key: St().startsWith("0x")
});
const v1 = Wt({
  type: Xt("launch_frame"),
  name: tu,
  url: dr.optional(),
  splashImageUrl: dr.optional(),
  splashBackgroundColor: ru.optional()
}), x1 = Wt({
  type: Xt("launch_miniapp"),
  name: tu,
  url: dr.optional(),
  splashImageUrl: dr.optional(),
  splashBackgroundColor: ru.optional()
}), E1 = Wt({
  type: Xt("view_token"),
  token: f1
}), S1 = Gf("type", [
  x1,
  E1,
  // Remove after compatibility period
  v1
]), b1 = Wt({
  title: jf,
  action: S1
});
Wt({
  version: qo([St(), $f()]).transform((n) => String(n)).pipe(qo([Xt("next"), Xt("1")])),
  imageUrl: dr,
  aspectRatio: m1.optional(),
  button: b1
});
const nu = Wt({
  url: St(),
  token: St()
});
Wt({
  notificationId: St().max(128),
  title: St().max(32),
  body: St().max(128),
  targetUrl: dr,
  tokens: St().array().max(100)
});
Wt({
  result: Wt({
    successfulTokens: ss(St()),
    invalidTokens: ss(St()),
    rateLimitedTokens: ss(St())
  })
});
const T1 = Wt({
  event: Xt("miniapp_added"),
  notificationDetails: nu.optional()
}), w1 = Wt({
  event: Xt("frame_added"),
  notificationDetails: nu.optional()
}), A1 = Wt({
  event: Xt("miniapp_removed")
}), I1 = Wt({
  event: Xt("frame_removed")
}), _1 = Wt({
  event: Xt("notifications_enabled"),
  notificationDetails: nu.required()
}), L1 = Wt({
  event: Xt("notifications_disabled")
});
Gf("event", [
  T1,
  A1,
  _1,
  L1,
  // Remove after compatibility period
  w1,
  I1
]);
const R1 = [
  "wallet.getEthereumProvider",
  "wallet.getSolanaProvider",
  "actions.ready",
  "actions.openUrl",
  "actions.close",
  "actions.setPrimaryButton",
  "actions.addMiniApp",
  "actions.signIn",
  "actions.viewCast",
  "actions.viewProfile",
  "actions.composeCast",
  "actions.viewToken",
  "actions.sendToken",
  "actions.swapToken",
  "actions.openMiniApp",
  "haptics.impactOccurred",
  "haptics.notificationOccurred",
  "haptics.selectionChanged",
  "back"
], C1 = uc([
  "games",
  "social",
  "finance",
  "utility",
  "productivity",
  "health-fitness",
  "news-media",
  "music",
  "shopping",
  "education",
  "developer-tools",
  "entertainment",
  "art-creativity"
]), k1 = [
  "eip155:1",
  // Ethereum mainnet
  "eip155:8453",
  // Base mainnet
  "eip155:42161",
  // Arbitrum One
  "eip155:421614",
  // Arbitrum Sepolia
  "eip155:84532",
  // Base Sepolia
  "eip155:666666666",
  // Degen
  "eip155:100",
  // Gnosis
  "eip155:10",
  // Optimism
  "eip155:11155420",
  // Optimism Sepolia
  "eip155:137",
  // Polygon
  "eip155:11155111",
  // Ethereum Sepolia
  "eip155:7777777",
  // Zora
  "eip155:130",
  // Unichain
  "eip155:10143",
  // Monad testnet
  "eip155:42220",
  // Celo
  "solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp"
  // Solana
];
function Sd(n) {
  const e = new Set(n);
  return Array.from(e);
}
const bd = Wt({
  // 0.0.0 and 0.0.1 are not technically part of the spec but kept for
  // backwards compatibility. next should always resolve to the most recent
  // schema version.
  version: qo([
    Xt("0.0.0"),
    Xt("0.0.1"),
    Xt("1"),
    Xt("next")
  ]),
  name: tu,
  iconUrl: dr,
  homeUrl: dr,
  /** deprecated, set ogImageUrl instead */
  imageUrl: dr.optional(),
  /** deprecated, will rely on fc:frame/fc:miniapp meta tag */
  buttonTitle: jf.optional(),
  splashImageUrl: dr.optional(),
  splashBackgroundColor: ru.optional(),
  webhookUrl: dr.optional(),
  /** see: https://github.com/farcasterxyz/miniapps/discussions/191 */
  subtitle: bs({ max: 30 }).optional(),
  description: bs({ max: 170 }).optional(),
  screenshotUrls: ss(dr).max(3).optional(),
  primaryCategory: C1.optional(),
  tags: ss(bs({ max: 20, noSpaces: !0 })).max(5).optional(),
  heroImageUrl: dr.optional(),
  tagline: bs({ max: 30 }).optional(),
  ogTitle: bs({ max: 30 }).optional(),
  ogDescription: bs({ max: 100 }).optional(),
  ogImageUrl: dr.optional(),
  /** see: https://github.com/farcasterxyz/miniapps/discussions/204 */
  noindex: l1().optional(),
  /** see https://github.com/farcasterxyz/miniapps/discussions/256 */
  requiredChains: ss(uc(k1)).transform(Sd).optional(),
  requiredCapabilities: ss(uc(R1)).transform(Sd).optional(),
  /** see https://github.com/farcasterxyz/miniapps/discussions/158 */
  /** Documentation will be added once this feature is finalized. */
  castShareUrl: dr.optional(),
  /** Canonical domain for the miniapp application */
  canonicalDomain: p1.optional()
}).refine((n) => {
  if (n.castShareUrl === void 0)
    return !0;
  try {
    const e = new URL(n.homeUrl).hostname, t = new URL(n.castShareUrl).hostname;
    return e === t;
  } catch {
    return !1;
  }
}, {
  message: "castShareUrl must have the same domain as homeUrl",
  path: ["castShareUrl"]
});
Wt({
  accountAssociation: y1,
  miniapp: bd.optional(),
  // Support both 'frame' and 'miniapp' during transition period
  frame: bd.optional()
}).refine((n) => n.frame && n.miniapp ? JSON.stringify(n.frame) === JSON.stringify(n.miniapp) : !0, {
  message: 'If both "frame" and "miniapp" are provided, they must be identical',
  path: ["frame", "miniapp"]
}).transform((n) => ({
  ...n,
  frame: n.frame ?? n.miniapp
}));
var $e = {}, Ia = {};
Ia.byteLength = M1;
Ia.toByteArray = B1;
Ia.fromByteArray = U1;
var tn = [], Dr = [], D1 = typeof Uint8Array < "u" ? Uint8Array : Array, cl = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Ts = 0, P1 = cl.length; Ts < P1; ++Ts)
  tn[Ts] = cl[Ts], Dr[cl.charCodeAt(Ts)] = Ts;
Dr[45] = 62;
Dr[95] = 63;
function Vf(n) {
  var e = n.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var t = n.indexOf("=");
  t === -1 && (t = e);
  var r = t === e ? 0 : 4 - t % 4;
  return [t, r];
}
function M1(n) {
  var e = Vf(n), t = e[0], r = e[1];
  return (t + r) * 3 / 4 - r;
}
function O1(n, e, t) {
  return (e + t) * 3 / 4 - t;
}
function B1(n) {
  var e, t = Vf(n), r = t[0], s = t[1], i = new D1(O1(n, r, s)), o = 0, a = s > 0 ? r - 4 : r, l;
  for (l = 0; l < a; l += 4)
    e = Dr[n.charCodeAt(l)] << 18 | Dr[n.charCodeAt(l + 1)] << 12 | Dr[n.charCodeAt(l + 2)] << 6 | Dr[n.charCodeAt(l + 3)], i[o++] = e >> 16 & 255, i[o++] = e >> 8 & 255, i[o++] = e & 255;
  return s === 2 && (e = Dr[n.charCodeAt(l)] << 2 | Dr[n.charCodeAt(l + 1)] >> 4, i[o++] = e & 255), s === 1 && (e = Dr[n.charCodeAt(l)] << 10 | Dr[n.charCodeAt(l + 1)] << 4 | Dr[n.charCodeAt(l + 2)] >> 2, i[o++] = e >> 8 & 255, i[o++] = e & 255), i;
}
function F1(n) {
  return tn[n >> 18 & 63] + tn[n >> 12 & 63] + tn[n >> 6 & 63] + tn[n & 63];
}
function N1(n, e, t) {
  for (var r, s = [], i = e; i < t; i += 3)
    r = (n[i] << 16 & 16711680) + (n[i + 1] << 8 & 65280) + (n[i + 2] & 255), s.push(F1(r));
  return s.join("");
}
function U1(n) {
  for (var e, t = n.length, r = t % 3, s = [], i = 16383, o = 0, a = t - r; o < a; o += i)
    s.push(N1(n, o, o + i > a ? a : o + i));
  return r === 1 ? (e = n[t - 1], s.push(
    tn[e >> 2] + tn[e << 4 & 63] + "=="
  )) : r === 2 && (e = (n[t - 2] << 8) + n[t - 1], s.push(
    tn[e >> 10] + tn[e >> 4 & 63] + tn[e << 2 & 63] + "="
  )), s.join("");
}
var su = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
su.read = function(n, e, t, r, s) {
  var i, o, a = s * 8 - r - 1, l = (1 << a) - 1, c = l >> 1, u = -7, d = t ? s - 1 : 0, h = t ? -1 : 1, f = n[e + d];
  for (d += h, i = f & (1 << -u) - 1, f >>= -u, u += a; u > 0; i = i * 256 + n[e + d], d += h, u -= 8)
    ;
  for (o = i & (1 << -u) - 1, i >>= -u, u += r; u > 0; o = o * 256 + n[e + d], d += h, u -= 8)
    ;
  if (i === 0)
    i = 1 - c;
  else {
    if (i === l)
      return o ? NaN : (f ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, r), i = i - c;
  }
  return (f ? -1 : 1) * o * Math.pow(2, i - r);
};
su.write = function(n, e, t, r, s, i) {
  var o, a, l, c = i * 8 - s - 1, u = (1 << c) - 1, d = u >> 1, h = s === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = r ? 0 : i - 1, p = r ? 1 : -1, y = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, o = u) : (o = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), o + d >= 1 ? e += h / l : e += h * Math.pow(2, 1 - d), e * l >= 2 && (o++, l /= 2), o + d >= u ? (a = 0, o = u) : o + d >= 1 ? (a = (e * l - 1) * Math.pow(2, s), o = o + d) : (a = e * Math.pow(2, d - 1) * Math.pow(2, s), o = 0)); s >= 8; n[t + f] = a & 255, f += p, a /= 256, s -= 8)
    ;
  for (o = o << s | a, c += s; c > 0; n[t + f] = o & 255, f += p, o /= 256, c -= 8)
    ;
  n[t + f - p] |= y * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(n) {
  const e = Ia, t = su, r = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  n.Buffer = a, n.SlowBuffer = C, n.INSPECT_MAX_BYTES = 50;
  const s = 2147483647;
  n.kMaxLength = s, a.TYPED_ARRAY_SUPPORT = i(), !a.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function i() {
    try {
      const k = new Uint8Array(1), E = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(E, Uint8Array.prototype), Object.setPrototypeOf(k, E), k.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(a.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (a.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(a.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (a.isBuffer(this))
        return this.byteOffset;
    }
  });
  function o(k) {
    if (k > s)
      throw new RangeError('The value "' + k + '" is invalid for option "size"');
    const E = new Uint8Array(k);
    return Object.setPrototypeOf(E, a.prototype), E;
  }
  function a(k, E, S) {
    if (typeof k == "number") {
      if (typeof E == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return d(k);
    }
    return l(k, E, S);
  }
  a.poolSize = 8192;
  function l(k, E, S) {
    if (typeof k == "string")
      return h(k, E);
    if (ArrayBuffer.isView(k))
      return p(k);
    if (k == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof k
      );
    if (pt(k, ArrayBuffer) || k && pt(k.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (pt(k, SharedArrayBuffer) || k && pt(k.buffer, SharedArrayBuffer)))
      return y(k, E, S);
    if (typeof k == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const $ = k.valueOf && k.valueOf();
    if ($ != null && $ !== k)
      return a.from($, E, S);
    const W = m(k);
    if (W) return W;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof k[Symbol.toPrimitive] == "function")
      return a.from(k[Symbol.toPrimitive]("string"), E, S);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof k
    );
  }
  a.from = function(k, E, S) {
    return l(k, E, S);
  }, Object.setPrototypeOf(a.prototype, Uint8Array.prototype), Object.setPrototypeOf(a, Uint8Array);
  function c(k) {
    if (typeof k != "number")
      throw new TypeError('"size" argument must be of type number');
    if (k < 0)
      throw new RangeError('The value "' + k + '" is invalid for option "size"');
  }
  function u(k, E, S) {
    return c(k), k <= 0 ? o(k) : E !== void 0 ? typeof S == "string" ? o(k).fill(E, S) : o(k).fill(E) : o(k);
  }
  a.alloc = function(k, E, S) {
    return u(k, E, S);
  };
  function d(k) {
    return c(k), o(k < 0 ? 0 : b(k) | 0);
  }
  a.allocUnsafe = function(k) {
    return d(k);
  }, a.allocUnsafeSlow = function(k) {
    return d(k);
  };
  function h(k, E) {
    if ((typeof E != "string" || E === "") && (E = "utf8"), !a.isEncoding(E))
      throw new TypeError("Unknown encoding: " + E);
    const S = A(k, E) | 0;
    let $ = o(S);
    const W = $.write(k, E);
    return W !== S && ($ = $.slice(0, W)), $;
  }
  function f(k) {
    const E = k.length < 0 ? 0 : b(k.length) | 0, S = o(E);
    for (let $ = 0; $ < E; $ += 1)
      S[$] = k[$] & 255;
    return S;
  }
  function p(k) {
    if (pt(k, Uint8Array)) {
      const E = new Uint8Array(k);
      return y(E.buffer, E.byteOffset, E.byteLength);
    }
    return f(k);
  }
  function y(k, E, S) {
    if (E < 0 || k.byteLength < E)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (k.byteLength < E + (S || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let $;
    return E === void 0 && S === void 0 ? $ = new Uint8Array(k) : S === void 0 ? $ = new Uint8Array(k, E) : $ = new Uint8Array(k, E, S), Object.setPrototypeOf($, a.prototype), $;
  }
  function m(k) {
    if (a.isBuffer(k)) {
      const E = b(k.length) | 0, S = o(E);
      return S.length === 0 || k.copy(S, 0, 0, E), S;
    }
    if (k.length !== void 0)
      return typeof k.length != "number" || et(k.length) ? o(0) : f(k);
    if (k.type === "Buffer" && Array.isArray(k.data))
      return f(k.data);
  }
  function b(k) {
    if (k >= s)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s.toString(16) + " bytes");
    return k | 0;
  }
  function C(k) {
    return +k != k && (k = 0), a.alloc(+k);
  }
  a.isBuffer = function(E) {
    return E != null && E._isBuffer === !0 && E !== a.prototype;
  }, a.compare = function(E, S) {
    if (pt(E, Uint8Array) && (E = a.from(E, E.offset, E.byteLength)), pt(S, Uint8Array) && (S = a.from(S, S.offset, S.byteLength)), !a.isBuffer(E) || !a.isBuffer(S))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (E === S) return 0;
    let $ = E.length, W = S.length;
    for (let z = 0, J = Math.min($, W); z < J; ++z)
      if (E[z] !== S[z]) {
        $ = E[z], W = S[z];
        break;
      }
    return $ < W ? -1 : W < $ ? 1 : 0;
  }, a.isEncoding = function(E) {
    switch (String(E).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, a.concat = function(E, S) {
    if (!Array.isArray(E))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (E.length === 0)
      return a.alloc(0);
    let $;
    if (S === void 0)
      for (S = 0, $ = 0; $ < E.length; ++$)
        S += E[$].length;
    const W = a.allocUnsafe(S);
    let z = 0;
    for ($ = 0; $ < E.length; ++$) {
      let J = E[$];
      if (pt(J, Uint8Array))
        z + J.length > W.length ? (a.isBuffer(J) || (J = a.from(J)), J.copy(W, z)) : Uint8Array.prototype.set.call(
          W,
          J,
          z
        );
      else if (a.isBuffer(J))
        J.copy(W, z);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      z += J.length;
    }
    return W;
  };
  function A(k, E) {
    if (a.isBuffer(k))
      return k.length;
    if (ArrayBuffer.isView(k) || pt(k, ArrayBuffer))
      return k.byteLength;
    if (typeof k != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof k
      );
    const S = k.length, $ = arguments.length > 2 && arguments[2] === !0;
    if (!$ && S === 0) return 0;
    let W = !1;
    for (; ; )
      switch (E) {
        case "ascii":
        case "latin1":
        case "binary":
          return S;
        case "utf8":
        case "utf-8":
          return xe(k).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return S * 2;
        case "hex":
          return S >>> 1;
        case "base64":
          return be(k).length;
        default:
          if (W)
            return $ ? -1 : xe(k).length;
          E = ("" + E).toLowerCase(), W = !0;
      }
  }
  a.byteLength = A;
  function P(k, E, S) {
    let $ = !1;
    if ((E === void 0 || E < 0) && (E = 0), E > this.length || ((S === void 0 || S > this.length) && (S = this.length), S <= 0) || (S >>>= 0, E >>>= 0, S <= E))
      return "";
    for (k || (k = "utf8"); ; )
      switch (k) {
        case "hex":
          return O(this, E, S);
        case "utf8":
        case "utf-8":
          return g(this, E, S);
        case "ascii":
          return _(this, E, S);
        case "latin1":
        case "binary":
          return D(this, E, S);
        case "base64":
          return L(this, E, S);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return N(this, E, S);
        default:
          if ($) throw new TypeError("Unknown encoding: " + k);
          k = (k + "").toLowerCase(), $ = !0;
      }
  }
  a.prototype._isBuffer = !0;
  function I(k, E, S) {
    const $ = k[E];
    k[E] = k[S], k[S] = $;
  }
  a.prototype.swap16 = function() {
    const E = this.length;
    if (E % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let S = 0; S < E; S += 2)
      I(this, S, S + 1);
    return this;
  }, a.prototype.swap32 = function() {
    const E = this.length;
    if (E % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let S = 0; S < E; S += 4)
      I(this, S, S + 3), I(this, S + 1, S + 2);
    return this;
  }, a.prototype.swap64 = function() {
    const E = this.length;
    if (E % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let S = 0; S < E; S += 8)
      I(this, S, S + 7), I(this, S + 1, S + 6), I(this, S + 2, S + 5), I(this, S + 3, S + 4);
    return this;
  }, a.prototype.toString = function() {
    const E = this.length;
    return E === 0 ? "" : arguments.length === 0 ? g(this, 0, E) : P.apply(this, arguments);
  }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(E) {
    if (!a.isBuffer(E)) throw new TypeError("Argument must be a Buffer");
    return this === E ? !0 : a.compare(this, E) === 0;
  }, a.prototype.inspect = function() {
    let E = "";
    const S = n.INSPECT_MAX_BYTES;
    return E = this.toString("hex", 0, S).replace(/(.{2})/g, "$1 ").trim(), this.length > S && (E += " ... "), "<Buffer " + E + ">";
  }, r && (a.prototype[r] = a.prototype.inspect), a.prototype.compare = function(E, S, $, W, z) {
    if (pt(E, Uint8Array) && (E = a.from(E, E.offset, E.byteLength)), !a.isBuffer(E))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof E
      );
    if (S === void 0 && (S = 0), $ === void 0 && ($ = E ? E.length : 0), W === void 0 && (W = 0), z === void 0 && (z = this.length), S < 0 || $ > E.length || W < 0 || z > this.length)
      throw new RangeError("out of range index");
    if (W >= z && S >= $)
      return 0;
    if (W >= z)
      return -1;
    if (S >= $)
      return 1;
    if (S >>>= 0, $ >>>= 0, W >>>= 0, z >>>= 0, this === E) return 0;
    let J = z - W, Fe = $ - S;
    const ke = Math.min(J, Fe), _e = this.slice(W, z), dt = E.slice(S, $);
    for (let we = 0; we < ke; ++we)
      if (_e[we] !== dt[we]) {
        J = _e[we], Fe = dt[we];
        break;
      }
    return J < Fe ? -1 : Fe < J ? 1 : 0;
  };
  function U(k, E, S, $, W) {
    if (k.length === 0) return -1;
    if (typeof S == "string" ? ($ = S, S = 0) : S > 2147483647 ? S = 2147483647 : S < -2147483648 && (S = -2147483648), S = +S, et(S) && (S = W ? 0 : k.length - 1), S < 0 && (S = k.length + S), S >= k.length) {
      if (W) return -1;
      S = k.length - 1;
    } else if (S < 0)
      if (W) S = 0;
      else return -1;
    if (typeof E == "string" && (E = a.from(E, $)), a.isBuffer(E))
      return E.length === 0 ? -1 : j(k, E, S, $, W);
    if (typeof E == "number")
      return E = E & 255, typeof Uint8Array.prototype.indexOf == "function" ? W ? Uint8Array.prototype.indexOf.call(k, E, S) : Uint8Array.prototype.lastIndexOf.call(k, E, S) : j(k, [E], S, $, W);
    throw new TypeError("val must be string, number or Buffer");
  }
  function j(k, E, S, $, W) {
    let z = 1, J = k.length, Fe = E.length;
    if ($ !== void 0 && ($ = String($).toLowerCase(), $ === "ucs2" || $ === "ucs-2" || $ === "utf16le" || $ === "utf-16le")) {
      if (k.length < 2 || E.length < 2)
        return -1;
      z = 2, J /= 2, Fe /= 2, S /= 2;
    }
    function ke(dt, we) {
      return z === 1 ? dt[we] : dt.readUInt16BE(we * z);
    }
    let _e;
    if (W) {
      let dt = -1;
      for (_e = S; _e < J; _e++)
        if (ke(k, _e) === ke(E, dt === -1 ? 0 : _e - dt)) {
          if (dt === -1 && (dt = _e), _e - dt + 1 === Fe) return dt * z;
        } else
          dt !== -1 && (_e -= _e - dt), dt = -1;
    } else
      for (S + Fe > J && (S = J - Fe), _e = S; _e >= 0; _e--) {
        let dt = !0;
        for (let we = 0; we < Fe; we++)
          if (ke(k, _e + we) !== ke(E, we)) {
            dt = !1;
            break;
          }
        if (dt) return _e;
      }
    return -1;
  }
  a.prototype.includes = function(E, S, $) {
    return this.indexOf(E, S, $) !== -1;
  }, a.prototype.indexOf = function(E, S, $) {
    return U(this, E, S, $, !0);
  }, a.prototype.lastIndexOf = function(E, S, $) {
    return U(this, E, S, $, !1);
  };
  function G(k, E, S, $) {
    S = Number(S) || 0;
    const W = k.length - S;
    $ ? ($ = Number($), $ > W && ($ = W)) : $ = W;
    const z = E.length;
    $ > z / 2 && ($ = z / 2);
    let J;
    for (J = 0; J < $; ++J) {
      const Fe = parseInt(E.substr(J * 2, 2), 16);
      if (et(Fe)) return J;
      k[S + J] = Fe;
    }
    return J;
  }
  function F(k, E, S, $) {
    return Me(xe(E, k.length - S), k, S, $);
  }
  function B(k, E, S, $) {
    return Me(Pe(E), k, S, $);
  }
  function V(k, E, S, $) {
    return Me(be(E), k, S, $);
  }
  function H(k, E, S, $) {
    return Me(Qe(E, k.length - S), k, S, $);
  }
  a.prototype.write = function(E, S, $, W) {
    if (S === void 0)
      W = "utf8", $ = this.length, S = 0;
    else if ($ === void 0 && typeof S == "string")
      W = S, $ = this.length, S = 0;
    else if (isFinite(S))
      S = S >>> 0, isFinite($) ? ($ = $ >>> 0, W === void 0 && (W = "utf8")) : (W = $, $ = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const z = this.length - S;
    if (($ === void 0 || $ > z) && ($ = z), E.length > 0 && ($ < 0 || S < 0) || S > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    W || (W = "utf8");
    let J = !1;
    for (; ; )
      switch (W) {
        case "hex":
          return G(this, E, S, $);
        case "utf8":
        case "utf-8":
          return F(this, E, S, $);
        case "ascii":
        case "latin1":
        case "binary":
          return B(this, E, S, $);
        case "base64":
          return V(this, E, S, $);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return H(this, E, S, $);
        default:
          if (J) throw new TypeError("Unknown encoding: " + W);
          W = ("" + W).toLowerCase(), J = !0;
      }
  }, a.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function L(k, E, S) {
    return E === 0 && S === k.length ? e.fromByteArray(k) : e.fromByteArray(k.slice(E, S));
  }
  function g(k, E, S) {
    S = Math.min(k.length, S);
    const $ = [];
    let W = E;
    for (; W < S; ) {
      const z = k[W];
      let J = null, Fe = z > 239 ? 4 : z > 223 ? 3 : z > 191 ? 2 : 1;
      if (W + Fe <= S) {
        let ke, _e, dt, we;
        switch (Fe) {
          case 1:
            z < 128 && (J = z);
            break;
          case 2:
            ke = k[W + 1], (ke & 192) === 128 && (we = (z & 31) << 6 | ke & 63, we > 127 && (J = we));
            break;
          case 3:
            ke = k[W + 1], _e = k[W + 2], (ke & 192) === 128 && (_e & 192) === 128 && (we = (z & 15) << 12 | (ke & 63) << 6 | _e & 63, we > 2047 && (we < 55296 || we > 57343) && (J = we));
            break;
          case 4:
            ke = k[W + 1], _e = k[W + 2], dt = k[W + 3], (ke & 192) === 128 && (_e & 192) === 128 && (dt & 192) === 128 && (we = (z & 15) << 18 | (ke & 63) << 12 | (_e & 63) << 6 | dt & 63, we > 65535 && we < 1114112 && (J = we));
        }
      }
      J === null ? (J = 65533, Fe = 1) : J > 65535 && (J -= 65536, $.push(J >>> 10 & 1023 | 55296), J = 56320 | J & 1023), $.push(J), W += Fe;
    }
    return w($);
  }
  const x = 4096;
  function w(k) {
    const E = k.length;
    if (E <= x)
      return String.fromCharCode.apply(String, k);
    let S = "", $ = 0;
    for (; $ < E; )
      S += String.fromCharCode.apply(
        String,
        k.slice($, $ += x)
      );
    return S;
  }
  function _(k, E, S) {
    let $ = "";
    S = Math.min(k.length, S);
    for (let W = E; W < S; ++W)
      $ += String.fromCharCode(k[W] & 127);
    return $;
  }
  function D(k, E, S) {
    let $ = "";
    S = Math.min(k.length, S);
    for (let W = E; W < S; ++W)
      $ += String.fromCharCode(k[W]);
    return $;
  }
  function O(k, E, S) {
    const $ = k.length;
    (!E || E < 0) && (E = 0), (!S || S < 0 || S > $) && (S = $);
    let W = "";
    for (let z = E; z < S; ++z)
      W += tt[k[z]];
    return W;
  }
  function N(k, E, S) {
    const $ = k.slice(E, S);
    let W = "";
    for (let z = 0; z < $.length - 1; z += 2)
      W += String.fromCharCode($[z] + $[z + 1] * 256);
    return W;
  }
  a.prototype.slice = function(E, S) {
    const $ = this.length;
    E = ~~E, S = S === void 0 ? $ : ~~S, E < 0 ? (E += $, E < 0 && (E = 0)) : E > $ && (E = $), S < 0 ? (S += $, S < 0 && (S = 0)) : S > $ && (S = $), S < E && (S = E);
    const W = this.subarray(E, S);
    return Object.setPrototypeOf(W, a.prototype), W;
  };
  function R(k, E, S) {
    if (k % 1 !== 0 || k < 0) throw new RangeError("offset is not uint");
    if (k + E > S) throw new RangeError("Trying to access beyond buffer length");
  }
  a.prototype.readUintLE = a.prototype.readUIntLE = function(E, S, $) {
    E = E >>> 0, S = S >>> 0, $ || R(E, S, this.length);
    let W = this[E], z = 1, J = 0;
    for (; ++J < S && (z *= 256); )
      W += this[E + J] * z;
    return W;
  }, a.prototype.readUintBE = a.prototype.readUIntBE = function(E, S, $) {
    E = E >>> 0, S = S >>> 0, $ || R(E, S, this.length);
    let W = this[E + --S], z = 1;
    for (; S > 0 && (z *= 256); )
      W += this[E + --S] * z;
    return W;
  }, a.prototype.readUint8 = a.prototype.readUInt8 = function(E, S) {
    return E = E >>> 0, S || R(E, 1, this.length), this[E];
  }, a.prototype.readUint16LE = a.prototype.readUInt16LE = function(E, S) {
    return E = E >>> 0, S || R(E, 2, this.length), this[E] | this[E + 1] << 8;
  }, a.prototype.readUint16BE = a.prototype.readUInt16BE = function(E, S) {
    return E = E >>> 0, S || R(E, 2, this.length), this[E] << 8 | this[E + 1];
  }, a.prototype.readUint32LE = a.prototype.readUInt32LE = function(E, S) {
    return E = E >>> 0, S || R(E, 4, this.length), (this[E] | this[E + 1] << 8 | this[E + 2] << 16) + this[E + 3] * 16777216;
  }, a.prototype.readUint32BE = a.prototype.readUInt32BE = function(E, S) {
    return E = E >>> 0, S || R(E, 4, this.length), this[E] * 16777216 + (this[E + 1] << 16 | this[E + 2] << 8 | this[E + 3]);
  }, a.prototype.readBigUInt64LE = at(function(E) {
    E = E >>> 0, Ge(E, "offset");
    const S = this[E], $ = this[E + 7];
    (S === void 0 || $ === void 0) && ye(E, this.length - 8);
    const W = S + this[++E] * 2 ** 8 + this[++E] * 2 ** 16 + this[++E] * 2 ** 24, z = this[++E] + this[++E] * 2 ** 8 + this[++E] * 2 ** 16 + $ * 2 ** 24;
    return BigInt(W) + (BigInt(z) << BigInt(32));
  }), a.prototype.readBigUInt64BE = at(function(E) {
    E = E >>> 0, Ge(E, "offset");
    const S = this[E], $ = this[E + 7];
    (S === void 0 || $ === void 0) && ye(E, this.length - 8);
    const W = S * 2 ** 24 + this[++E] * 2 ** 16 + this[++E] * 2 ** 8 + this[++E], z = this[++E] * 2 ** 24 + this[++E] * 2 ** 16 + this[++E] * 2 ** 8 + $;
    return (BigInt(W) << BigInt(32)) + BigInt(z);
  }), a.prototype.readIntLE = function(E, S, $) {
    E = E >>> 0, S = S >>> 0, $ || R(E, S, this.length);
    let W = this[E], z = 1, J = 0;
    for (; ++J < S && (z *= 256); )
      W += this[E + J] * z;
    return z *= 128, W >= z && (W -= Math.pow(2, 8 * S)), W;
  }, a.prototype.readIntBE = function(E, S, $) {
    E = E >>> 0, S = S >>> 0, $ || R(E, S, this.length);
    let W = S, z = 1, J = this[E + --W];
    for (; W > 0 && (z *= 256); )
      J += this[E + --W] * z;
    return z *= 128, J >= z && (J -= Math.pow(2, 8 * S)), J;
  }, a.prototype.readInt8 = function(E, S) {
    return E = E >>> 0, S || R(E, 1, this.length), this[E] & 128 ? (255 - this[E] + 1) * -1 : this[E];
  }, a.prototype.readInt16LE = function(E, S) {
    E = E >>> 0, S || R(E, 2, this.length);
    const $ = this[E] | this[E + 1] << 8;
    return $ & 32768 ? $ | 4294901760 : $;
  }, a.prototype.readInt16BE = function(E, S) {
    E = E >>> 0, S || R(E, 2, this.length);
    const $ = this[E + 1] | this[E] << 8;
    return $ & 32768 ? $ | 4294901760 : $;
  }, a.prototype.readInt32LE = function(E, S) {
    return E = E >>> 0, S || R(E, 4, this.length), this[E] | this[E + 1] << 8 | this[E + 2] << 16 | this[E + 3] << 24;
  }, a.prototype.readInt32BE = function(E, S) {
    return E = E >>> 0, S || R(E, 4, this.length), this[E] << 24 | this[E + 1] << 16 | this[E + 2] << 8 | this[E + 3];
  }, a.prototype.readBigInt64LE = at(function(E) {
    E = E >>> 0, Ge(E, "offset");
    const S = this[E], $ = this[E + 7];
    (S === void 0 || $ === void 0) && ye(E, this.length - 8);
    const W = this[E + 4] + this[E + 5] * 2 ** 8 + this[E + 6] * 2 ** 16 + ($ << 24);
    return (BigInt(W) << BigInt(32)) + BigInt(S + this[++E] * 2 ** 8 + this[++E] * 2 ** 16 + this[++E] * 2 ** 24);
  }), a.prototype.readBigInt64BE = at(function(E) {
    E = E >>> 0, Ge(E, "offset");
    const S = this[E], $ = this[E + 7];
    (S === void 0 || $ === void 0) && ye(E, this.length - 8);
    const W = (S << 24) + // Overflow
    this[++E] * 2 ** 16 + this[++E] * 2 ** 8 + this[++E];
    return (BigInt(W) << BigInt(32)) + BigInt(this[++E] * 2 ** 24 + this[++E] * 2 ** 16 + this[++E] * 2 ** 8 + $);
  }), a.prototype.readFloatLE = function(E, S) {
    return E = E >>> 0, S || R(E, 4, this.length), t.read(this, E, !0, 23, 4);
  }, a.prototype.readFloatBE = function(E, S) {
    return E = E >>> 0, S || R(E, 4, this.length), t.read(this, E, !1, 23, 4);
  }, a.prototype.readDoubleLE = function(E, S) {
    return E = E >>> 0, S || R(E, 8, this.length), t.read(this, E, !0, 52, 8);
  }, a.prototype.readDoubleBE = function(E, S) {
    return E = E >>> 0, S || R(E, 8, this.length), t.read(this, E, !1, 52, 8);
  };
  function v(k, E, S, $, W, z) {
    if (!a.isBuffer(k)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (E > W || E < z) throw new RangeError('"value" argument is out of bounds');
    if (S + $ > k.length) throw new RangeError("Index out of range");
  }
  a.prototype.writeUintLE = a.prototype.writeUIntLE = function(E, S, $, W) {
    if (E = +E, S = S >>> 0, $ = $ >>> 0, !W) {
      const Fe = Math.pow(2, 8 * $) - 1;
      v(this, E, S, $, Fe, 0);
    }
    let z = 1, J = 0;
    for (this[S] = E & 255; ++J < $ && (z *= 256); )
      this[S + J] = E / z & 255;
    return S + $;
  }, a.prototype.writeUintBE = a.prototype.writeUIntBE = function(E, S, $, W) {
    if (E = +E, S = S >>> 0, $ = $ >>> 0, !W) {
      const Fe = Math.pow(2, 8 * $) - 1;
      v(this, E, S, $, Fe, 0);
    }
    let z = $ - 1, J = 1;
    for (this[S + z] = E & 255; --z >= 0 && (J *= 256); )
      this[S + z] = E / J & 255;
    return S + $;
  }, a.prototype.writeUint8 = a.prototype.writeUInt8 = function(E, S, $) {
    return E = +E, S = S >>> 0, $ || v(this, E, S, 1, 255, 0), this[S] = E & 255, S + 1;
  }, a.prototype.writeUint16LE = a.prototype.writeUInt16LE = function(E, S, $) {
    return E = +E, S = S >>> 0, $ || v(this, E, S, 2, 65535, 0), this[S] = E & 255, this[S + 1] = E >>> 8, S + 2;
  }, a.prototype.writeUint16BE = a.prototype.writeUInt16BE = function(E, S, $) {
    return E = +E, S = S >>> 0, $ || v(this, E, S, 2, 65535, 0), this[S] = E >>> 8, this[S + 1] = E & 255, S + 2;
  }, a.prototype.writeUint32LE = a.prototype.writeUInt32LE = function(E, S, $) {
    return E = +E, S = S >>> 0, $ || v(this, E, S, 4, 4294967295, 0), this[S + 3] = E >>> 24, this[S + 2] = E >>> 16, this[S + 1] = E >>> 8, this[S] = E & 255, S + 4;
  }, a.prototype.writeUint32BE = a.prototype.writeUInt32BE = function(E, S, $) {
    return E = +E, S = S >>> 0, $ || v(this, E, S, 4, 4294967295, 0), this[S] = E >>> 24, this[S + 1] = E >>> 16, this[S + 2] = E >>> 8, this[S + 3] = E & 255, S + 4;
  };
  function M(k, E, S, $, W) {
    ct(E, $, W, k, S, 7);
    let z = Number(E & BigInt(4294967295));
    k[S++] = z, z = z >> 8, k[S++] = z, z = z >> 8, k[S++] = z, z = z >> 8, k[S++] = z;
    let J = Number(E >> BigInt(32) & BigInt(4294967295));
    return k[S++] = J, J = J >> 8, k[S++] = J, J = J >> 8, k[S++] = J, J = J >> 8, k[S++] = J, S;
  }
  function te(k, E, S, $, W) {
    ct(E, $, W, k, S, 7);
    let z = Number(E & BigInt(4294967295));
    k[S + 7] = z, z = z >> 8, k[S + 6] = z, z = z >> 8, k[S + 5] = z, z = z >> 8, k[S + 4] = z;
    let J = Number(E >> BigInt(32) & BigInt(4294967295));
    return k[S + 3] = J, J = J >> 8, k[S + 2] = J, J = J >> 8, k[S + 1] = J, J = J >> 8, k[S] = J, S + 8;
  }
  a.prototype.writeBigUInt64LE = at(function(E, S = 0) {
    return M(this, E, S, BigInt(0), BigInt("0xffffffffffffffff"));
  }), a.prototype.writeBigUInt64BE = at(function(E, S = 0) {
    return te(this, E, S, BigInt(0), BigInt("0xffffffffffffffff"));
  }), a.prototype.writeIntLE = function(E, S, $, W) {
    if (E = +E, S = S >>> 0, !W) {
      const ke = Math.pow(2, 8 * $ - 1);
      v(this, E, S, $, ke - 1, -ke);
    }
    let z = 0, J = 1, Fe = 0;
    for (this[S] = E & 255; ++z < $ && (J *= 256); )
      E < 0 && Fe === 0 && this[S + z - 1] !== 0 && (Fe = 1), this[S + z] = (E / J >> 0) - Fe & 255;
    return S + $;
  }, a.prototype.writeIntBE = function(E, S, $, W) {
    if (E = +E, S = S >>> 0, !W) {
      const ke = Math.pow(2, 8 * $ - 1);
      v(this, E, S, $, ke - 1, -ke);
    }
    let z = $ - 1, J = 1, Fe = 0;
    for (this[S + z] = E & 255; --z >= 0 && (J *= 256); )
      E < 0 && Fe === 0 && this[S + z + 1] !== 0 && (Fe = 1), this[S + z] = (E / J >> 0) - Fe & 255;
    return S + $;
  }, a.prototype.writeInt8 = function(E, S, $) {
    return E = +E, S = S >>> 0, $ || v(this, E, S, 1, 127, -128), E < 0 && (E = 255 + E + 1), this[S] = E & 255, S + 1;
  }, a.prototype.writeInt16LE = function(E, S, $) {
    return E = +E, S = S >>> 0, $ || v(this, E, S, 2, 32767, -32768), this[S] = E & 255, this[S + 1] = E >>> 8, S + 2;
  }, a.prototype.writeInt16BE = function(E, S, $) {
    return E = +E, S = S >>> 0, $ || v(this, E, S, 2, 32767, -32768), this[S] = E >>> 8, this[S + 1] = E & 255, S + 2;
  }, a.prototype.writeInt32LE = function(E, S, $) {
    return E = +E, S = S >>> 0, $ || v(this, E, S, 4, 2147483647, -2147483648), this[S] = E & 255, this[S + 1] = E >>> 8, this[S + 2] = E >>> 16, this[S + 3] = E >>> 24, S + 4;
  }, a.prototype.writeInt32BE = function(E, S, $) {
    return E = +E, S = S >>> 0, $ || v(this, E, S, 4, 2147483647, -2147483648), E < 0 && (E = 4294967295 + E + 1), this[S] = E >>> 24, this[S + 1] = E >>> 16, this[S + 2] = E >>> 8, this[S + 3] = E & 255, S + 4;
  }, a.prototype.writeBigInt64LE = at(function(E, S = 0) {
    return M(this, E, S, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), a.prototype.writeBigInt64BE = at(function(E, S = 0) {
    return te(this, E, S, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function ee(k, E, S, $, W, z) {
    if (S + $ > k.length) throw new RangeError("Index out of range");
    if (S < 0) throw new RangeError("Index out of range");
  }
  function ne(k, E, S, $, W) {
    return E = +E, S = S >>> 0, W || ee(k, E, S, 4), t.write(k, E, S, $, 23, 4), S + 4;
  }
  a.prototype.writeFloatLE = function(E, S, $) {
    return ne(this, E, S, !0, $);
  }, a.prototype.writeFloatBE = function(E, S, $) {
    return ne(this, E, S, !1, $);
  };
  function Ce(k, E, S, $, W) {
    return E = +E, S = S >>> 0, W || ee(k, E, S, 8), t.write(k, E, S, $, 52, 8), S + 8;
  }
  a.prototype.writeDoubleLE = function(E, S, $) {
    return Ce(this, E, S, !0, $);
  }, a.prototype.writeDoubleBE = function(E, S, $) {
    return Ce(this, E, S, !1, $);
  }, a.prototype.copy = function(E, S, $, W) {
    if (!a.isBuffer(E)) throw new TypeError("argument should be a Buffer");
    if ($ || ($ = 0), !W && W !== 0 && (W = this.length), S >= E.length && (S = E.length), S || (S = 0), W > 0 && W < $ && (W = $), W === $ || E.length === 0 || this.length === 0) return 0;
    if (S < 0)
      throw new RangeError("targetStart out of bounds");
    if ($ < 0 || $ >= this.length) throw new RangeError("Index out of range");
    if (W < 0) throw new RangeError("sourceEnd out of bounds");
    W > this.length && (W = this.length), E.length - S < W - $ && (W = E.length - S + $);
    const z = W - $;
    return this === E && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(S, $, W) : Uint8Array.prototype.set.call(
      E,
      this.subarray($, W),
      S
    ), z;
  }, a.prototype.fill = function(E, S, $, W) {
    if (typeof E == "string") {
      if (typeof S == "string" ? (W = S, S = 0, $ = this.length) : typeof $ == "string" && (W = $, $ = this.length), W !== void 0 && typeof W != "string")
        throw new TypeError("encoding must be a string");
      if (typeof W == "string" && !a.isEncoding(W))
        throw new TypeError("Unknown encoding: " + W);
      if (E.length === 1) {
        const J = E.charCodeAt(0);
        (W === "utf8" && J < 128 || W === "latin1") && (E = J);
      }
    } else typeof E == "number" ? E = E & 255 : typeof E == "boolean" && (E = Number(E));
    if (S < 0 || this.length < S || this.length < $)
      throw new RangeError("Out of range index");
    if ($ <= S)
      return this;
    S = S >>> 0, $ = $ === void 0 ? this.length : $ >>> 0, E || (E = 0);
    let z;
    if (typeof E == "number")
      for (z = S; z < $; ++z)
        this[z] = E;
    else {
      const J = a.isBuffer(E) ? E : a.from(E, W), Fe = J.length;
      if (Fe === 0)
        throw new TypeError('The value "' + E + '" is invalid for argument "value"');
      for (z = 0; z < $ - S; ++z)
        this[z + S] = J[z % Fe];
    }
    return this;
  };
  const ve = {};
  function Ae(k, E, S) {
    ve[k] = class extends S {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: E.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${k}]`, this.stack, delete this.name;
      }
      get code() {
        return k;
      }
      set code(W) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: W,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${k}]: ${this.message}`;
      }
    };
  }
  Ae(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(k) {
      return k ? `${k} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), Ae(
    "ERR_INVALID_ARG_TYPE",
    function(k, E) {
      return `The "${k}" argument must be of type number. Received type ${typeof E}`;
    },
    TypeError
  ), Ae(
    "ERR_OUT_OF_RANGE",
    function(k, E, S) {
      let $ = `The value of "${k}" is out of range.`, W = S;
      return Number.isInteger(S) && Math.abs(S) > 2 ** 32 ? W = qt(String(S)) : typeof S == "bigint" && (W = String(S), (S > BigInt(2) ** BigInt(32) || S < -(BigInt(2) ** BigInt(32))) && (W = qt(W)), W += "n"), $ += ` It must be ${E}. Received ${W}`, $;
    },
    RangeError
  );
  function qt(k) {
    let E = "", S = k.length;
    const $ = k[0] === "-" ? 1 : 0;
    for (; S >= $ + 4; S -= 3)
      E = `_${k.slice(S - 3, S)}${E}`;
    return `${k.slice(0, S)}${E}`;
  }
  function qe(k, E, S) {
    Ge(E, "offset"), (k[E] === void 0 || k[E + S] === void 0) && ye(E, k.length - (S + 1));
  }
  function ct(k, E, S, $, W, z) {
    if (k > S || k < E) {
      const J = typeof E == "bigint" ? "n" : "";
      let Fe;
      throw E === 0 || E === BigInt(0) ? Fe = `>= 0${J} and < 2${J} ** ${(z + 1) * 8}${J}` : Fe = `>= -(2${J} ** ${(z + 1) * 8 - 1}${J}) and < 2 ** ${(z + 1) * 8 - 1}${J}`, new ve.ERR_OUT_OF_RANGE("value", Fe, k);
    }
    qe($, W, z);
  }
  function Ge(k, E) {
    if (typeof k != "number")
      throw new ve.ERR_INVALID_ARG_TYPE(E, "number", k);
  }
  function ye(k, E, S) {
    throw Math.floor(k) !== k ? (Ge(k, S), new ve.ERR_OUT_OF_RANGE("offset", "an integer", k)) : E < 0 ? new ve.ERR_BUFFER_OUT_OF_BOUNDS() : new ve.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${E}`,
      k
    );
  }
  const Be = /[^+/0-9A-Za-z-_]/g;
  function me(k) {
    if (k = k.split("=")[0], k = k.trim().replace(Be, ""), k.length < 2) return "";
    for (; k.length % 4 !== 0; )
      k = k + "=";
    return k;
  }
  function xe(k, E) {
    E = E || 1 / 0;
    let S;
    const $ = k.length;
    let W = null;
    const z = [];
    for (let J = 0; J < $; ++J) {
      if (S = k.charCodeAt(J), S > 55295 && S < 57344) {
        if (!W) {
          if (S > 56319) {
            (E -= 3) > -1 && z.push(239, 191, 189);
            continue;
          } else if (J + 1 === $) {
            (E -= 3) > -1 && z.push(239, 191, 189);
            continue;
          }
          W = S;
          continue;
        }
        if (S < 56320) {
          (E -= 3) > -1 && z.push(239, 191, 189), W = S;
          continue;
        }
        S = (W - 55296 << 10 | S - 56320) + 65536;
      } else W && (E -= 3) > -1 && z.push(239, 191, 189);
      if (W = null, S < 128) {
        if ((E -= 1) < 0) break;
        z.push(S);
      } else if (S < 2048) {
        if ((E -= 2) < 0) break;
        z.push(
          S >> 6 | 192,
          S & 63 | 128
        );
      } else if (S < 65536) {
        if ((E -= 3) < 0) break;
        z.push(
          S >> 12 | 224,
          S >> 6 & 63 | 128,
          S & 63 | 128
        );
      } else if (S < 1114112) {
        if ((E -= 4) < 0) break;
        z.push(
          S >> 18 | 240,
          S >> 12 & 63 | 128,
          S >> 6 & 63 | 128,
          S & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return z;
  }
  function Pe(k) {
    const E = [];
    for (let S = 0; S < k.length; ++S)
      E.push(k.charCodeAt(S) & 255);
    return E;
  }
  function Qe(k, E) {
    let S, $, W;
    const z = [];
    for (let J = 0; J < k.length && !((E -= 2) < 0); ++J)
      S = k.charCodeAt(J), $ = S >> 8, W = S % 256, z.push(W), z.push($);
    return z;
  }
  function be(k) {
    return e.toByteArray(me(k));
  }
  function Me(k, E, S, $) {
    let W;
    for (W = 0; W < $ && !(W + S >= E.length || W >= k.length); ++W)
      E[W + S] = k[W];
    return W;
  }
  function pt(k, E) {
    return k instanceof E || k != null && k.constructor != null && k.constructor.name != null && k.constructor.name === E.name;
  }
  function et(k) {
    return k !== k;
  }
  const tt = function() {
    const k = "0123456789abcdef", E = new Array(256);
    for (let S = 0; S < 16; ++S) {
      const $ = S * 16;
      for (let W = 0; W < 16; ++W)
        E[$ + W] = k[S] + k[W];
    }
    return E;
  }();
  function at(k) {
    return typeof BigInt > "u" ? Ve : k;
  }
  function Ve() {
    throw new Error("BigInt not supported");
  }
})($e);
const ws = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function iu(n) {
  return n instanceof Uint8Array || ArrayBuffer.isView(n) && n.constructor.name === "Uint8Array";
}
function dc(n) {
  if (!Number.isSafeInteger(n) || n < 0)
    throw new Error("positive integer expected, got " + n);
}
function ln(n, ...e) {
  if (!iu(n))
    throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(n.length))
    throw new Error("Uint8Array expected of length " + e + ", got length=" + n.length);
}
function $1(n) {
  if (typeof n != "function" || typeof n.create != "function")
    throw new Error("Hash should be wrapped by utils.createHasher");
  dc(n.outputLen), dc(n.blockLen);
}
function zo(n, e = !0) {
  if (n.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && n.finished)
    throw new Error("Hash#digest() has already been called");
}
function G1(n, e) {
  ln(n);
  const t = e.outputLen;
  if (n.length < t)
    throw new Error("digestInto() expects output buffer of length at least " + t);
}
function Ws(...n) {
  for (let e = 0; e < n.length; e++)
    n[e].fill(0);
}
function ul(n) {
  return new DataView(n.buffer, n.byteOffset, n.byteLength);
}
function zr(n, e) {
  return n << 32 - e | n >>> e;
}
const Kf = /* @ts-ignore */ typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", j1 = /* @__PURE__ */ Array.from({ length: 256 }, (n, e) => e.toString(16).padStart(2, "0"));
function qs(n) {
  if (ln(n), Kf)
    return n.toHex();
  let e = "";
  for (let t = 0; t < n.length; t++)
    e += j1[n[t]];
  return e;
}
const pn = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function Td(n) {
  if (n >= pn._0 && n <= pn._9)
    return n - pn._0;
  if (n >= pn.A && n <= pn.F)
    return n - (pn.A - 10);
  if (n >= pn.a && n <= pn.f)
    return n - (pn.a - 10);
}
function ou(n) {
  if (typeof n != "string")
    throw new Error("hex string expected, got " + typeof n);
  if (Kf)
    return Uint8Array.fromHex(n);
  const e = n.length, t = e / 2;
  if (e % 2)
    throw new Error("hex string expected, got unpadded hex of length " + e);
  const r = new Uint8Array(t);
  for (let s = 0, i = 0; s < t; s++, i += 2) {
    const o = Td(n.charCodeAt(i)), a = Td(n.charCodeAt(i + 1));
    if (o === void 0 || a === void 0) {
      const l = n[i] + n[i + 1];
      throw new Error('hex string expected, got non-hex character "' + l + '" at index ' + i);
    }
    r[s] = o * 16 + a;
  }
  return r;
}
function V1(n) {
  if (typeof n != "string")
    throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(n));
}
function au(n) {
  return typeof n == "string" && (n = V1(n)), ln(n), n;
}
function An(...n) {
  let e = 0;
  for (let r = 0; r < n.length; r++) {
    const s = n[r];
    ln(s), e += s.length;
  }
  const t = new Uint8Array(e);
  for (let r = 0, s = 0; r < n.length; r++) {
    const i = n[r];
    t.set(i, s), s += i.length;
  }
  return t;
}
class Hf {
}
function Wf(n) {
  const e = (r) => n().update(au(r)).digest(), t = n();
  return e.outputLen = t.outputLen, e.blockLen = t.blockLen, e.create = () => n(), e;
}
function qf(n = 32) {
  if (ws && typeof ws.getRandomValues == "function")
    return ws.getRandomValues(new Uint8Array(n));
  if (ws && typeof ws.randomBytes == "function")
    return Uint8Array.from(ws.randomBytes(n));
  throw new Error("crypto.getRandomValues must be defined");
}
function K1(n, e, t, r) {
  if (typeof n.setBigUint64 == "function")
    return n.setBigUint64(e, t, r);
  const s = BigInt(32), i = BigInt(4294967295), o = Number(t >> s & i), a = Number(t & i), l = r ? 4 : 0, c = r ? 0 : 4;
  n.setUint32(e + l, o, r), n.setUint32(e + c, a, r);
}
function H1(n, e, t) {
  return n & e ^ ~n & t;
}
function W1(n, e, t) {
  return n & e ^ n & t ^ e & t;
}
class zf extends Hf {
  constructor(e, t, r, s) {
    super(), this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.blockLen = e, this.outputLen = t, this.padOffset = r, this.isLE = s, this.buffer = new Uint8Array(e), this.view = ul(this.buffer);
  }
  update(e) {
    zo(this), e = au(e), ln(e);
    const { view: t, buffer: r, blockLen: s } = this, i = e.length;
    for (let o = 0; o < i; ) {
      const a = Math.min(s - this.pos, i - o);
      if (a === s) {
        const l = ul(e);
        for (; s <= i - o; o += s)
          this.process(l, o);
        continue;
      }
      r.set(e.subarray(o, o + a), this.pos), this.pos += a, o += a, this.pos === s && (this.process(t, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    zo(this), G1(e, this), this.finished = !0;
    const { buffer: t, view: r, blockLen: s, isLE: i } = this;
    let { pos: o } = this;
    t[o++] = 128, Ws(this.buffer.subarray(o)), this.padOffset > s - o && (this.process(r, 0), o = 0);
    for (let d = o; d < s; d++)
      t[d] = 0;
    K1(r, s - 8, BigInt(this.length * 8), i), this.process(r, 0);
    const a = ul(e), l = this.outputLen;
    if (l % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const c = l / 4, u = this.get();
    if (c > u.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let d = 0; d < c; d++)
      a.setUint32(4 * d, u[d], i);
  }
  digest() {
    const { buffer: e, outputLen: t } = this;
    this.digestInto(e);
    const r = e.slice(0, t);
    return this.destroy(), r;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: t, buffer: r, length: s, finished: i, destroyed: o, pos: a } = this;
    return e.destroyed = o, e.finished = i, e.length = s, e.pos = a, s % t && e.buffer.set(r), e;
  }
  clone() {
    return this._cloneInto();
  }
}
const Dn = /* @__PURE__ */ Uint32Array.from([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), rr = /* @__PURE__ */ Uint32Array.from([
  1779033703,
  4089235720,
  3144134277,
  2227873595,
  1013904242,
  4271175723,
  2773480762,
  1595750129,
  1359893119,
  2917565137,
  2600822924,
  725511199,
  528734635,
  4215389547,
  1541459225,
  327033209
]), Qi = /* @__PURE__ */ BigInt(2 ** 32 - 1), wd = /* @__PURE__ */ BigInt(32);
function q1(n, e = !1) {
  return e ? { h: Number(n & Qi), l: Number(n >> wd & Qi) } : { h: Number(n >> wd & Qi) | 0, l: Number(n & Qi) | 0 };
}
function z1(n, e = !1) {
  const t = n.length;
  let r = new Uint32Array(t), s = new Uint32Array(t);
  for (let i = 0; i < t; i++) {
    const { h: o, l: a } = q1(n[i], e);
    [r[i], s[i]] = [o, a];
  }
  return [r, s];
}
const Ad = (n, e, t) => n >>> t, Id = (n, e, t) => n << 32 - t | e >>> t, As = (n, e, t) => n >>> t | e << 32 - t, Is = (n, e, t) => n << 32 - t | e >>> t, eo = (n, e, t) => n << 64 - t | e >>> t - 32, to = (n, e, t) => n >>> t - 32 | e << 64 - t;
function mn(n, e, t, r) {
  const s = (e >>> 0) + (r >>> 0);
  return { h: n + t + (s / 2 ** 32 | 0) | 0, l: s | 0 };
}
const Y1 = (n, e, t) => (n >>> 0) + (e >>> 0) + (t >>> 0), Z1 = (n, e, t, r) => e + t + r + (n / 2 ** 32 | 0) | 0, X1 = (n, e, t, r) => (n >>> 0) + (e >>> 0) + (t >>> 0) + (r >>> 0), J1 = (n, e, t, r, s) => e + t + r + s + (n / 2 ** 32 | 0) | 0, Q1 = (n, e, t, r, s) => (n >>> 0) + (e >>> 0) + (t >>> 0) + (r >>> 0) + (s >>> 0), ey = (n, e, t, r, s, i) => e + t + r + s + i + (n / 2 ** 32 | 0) | 0, ty = /* @__PURE__ */ Uint32Array.from([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Pn = /* @__PURE__ */ new Uint32Array(64);
class ry extends zf {
  constructor(e = 32) {
    super(64, e, 8, !1), this.A = Dn[0] | 0, this.B = Dn[1] | 0, this.C = Dn[2] | 0, this.D = Dn[3] | 0, this.E = Dn[4] | 0, this.F = Dn[5] | 0, this.G = Dn[6] | 0, this.H = Dn[7] | 0;
  }
  get() {
    const { A: e, B: t, C: r, D: s, E: i, F: o, G: a, H: l } = this;
    return [e, t, r, s, i, o, a, l];
  }
  // prettier-ignore
  set(e, t, r, s, i, o, a, l) {
    this.A = e | 0, this.B = t | 0, this.C = r | 0, this.D = s | 0, this.E = i | 0, this.F = o | 0, this.G = a | 0, this.H = l | 0;
  }
  process(e, t) {
    for (let d = 0; d < 16; d++, t += 4)
      Pn[d] = e.getUint32(t, !1);
    for (let d = 16; d < 64; d++) {
      const h = Pn[d - 15], f = Pn[d - 2], p = zr(h, 7) ^ zr(h, 18) ^ h >>> 3, y = zr(f, 17) ^ zr(f, 19) ^ f >>> 10;
      Pn[d] = y + Pn[d - 7] + p + Pn[d - 16] | 0;
    }
    let { A: r, B: s, C: i, D: o, E: a, F: l, G: c, H: u } = this;
    for (let d = 0; d < 64; d++) {
      const h = zr(a, 6) ^ zr(a, 11) ^ zr(a, 25), f = u + h + H1(a, l, c) + ty[d] + Pn[d] | 0, y = (zr(r, 2) ^ zr(r, 13) ^ zr(r, 22)) + W1(r, s, i) | 0;
      u = c, c = l, l = a, a = o + f | 0, o = i, i = s, s = r, r = f + y | 0;
    }
    r = r + this.A | 0, s = s + this.B | 0, i = i + this.C | 0, o = o + this.D | 0, a = a + this.E | 0, l = l + this.F | 0, c = c + this.G | 0, u = u + this.H | 0, this.set(r, s, i, o, a, l, c, u);
  }
  roundClean() {
    Ws(Pn);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), Ws(this.buffer);
  }
}
const Yf = z1([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((n) => BigInt(n))), ny = Yf[0], sy = Yf[1], Mn = /* @__PURE__ */ new Uint32Array(80), On = /* @__PURE__ */ new Uint32Array(80);
class iy extends zf {
  constructor(e = 64) {
    super(128, e, 16, !1), this.Ah = rr[0] | 0, this.Al = rr[1] | 0, this.Bh = rr[2] | 0, this.Bl = rr[3] | 0, this.Ch = rr[4] | 0, this.Cl = rr[5] | 0, this.Dh = rr[6] | 0, this.Dl = rr[7] | 0, this.Eh = rr[8] | 0, this.El = rr[9] | 0, this.Fh = rr[10] | 0, this.Fl = rr[11] | 0, this.Gh = rr[12] | 0, this.Gl = rr[13] | 0, this.Hh = rr[14] | 0, this.Hl = rr[15] | 0;
  }
  // prettier-ignore
  get() {
    const { Ah: e, Al: t, Bh: r, Bl: s, Ch: i, Cl: o, Dh: a, Dl: l, Eh: c, El: u, Fh: d, Fl: h, Gh: f, Gl: p, Hh: y, Hl: m } = this;
    return [e, t, r, s, i, o, a, l, c, u, d, h, f, p, y, m];
  }
  // prettier-ignore
  set(e, t, r, s, i, o, a, l, c, u, d, h, f, p, y, m) {
    this.Ah = e | 0, this.Al = t | 0, this.Bh = r | 0, this.Bl = s | 0, this.Ch = i | 0, this.Cl = o | 0, this.Dh = a | 0, this.Dl = l | 0, this.Eh = c | 0, this.El = u | 0, this.Fh = d | 0, this.Fl = h | 0, this.Gh = f | 0, this.Gl = p | 0, this.Hh = y | 0, this.Hl = m | 0;
  }
  process(e, t) {
    for (let A = 0; A < 16; A++, t += 4)
      Mn[A] = e.getUint32(t), On[A] = e.getUint32(t += 4);
    for (let A = 16; A < 80; A++) {
      const P = Mn[A - 15] | 0, I = On[A - 15] | 0, U = As(P, I, 1) ^ As(P, I, 8) ^ Ad(P, I, 7), j = Is(P, I, 1) ^ Is(P, I, 8) ^ Id(P, I, 7), G = Mn[A - 2] | 0, F = On[A - 2] | 0, B = As(G, F, 19) ^ eo(G, F, 61) ^ Ad(G, F, 6), V = Is(G, F, 19) ^ to(G, F, 61) ^ Id(G, F, 6), H = X1(j, V, On[A - 7], On[A - 16]), L = J1(H, U, B, Mn[A - 7], Mn[A - 16]);
      Mn[A] = L | 0, On[A] = H | 0;
    }
    let { Ah: r, Al: s, Bh: i, Bl: o, Ch: a, Cl: l, Dh: c, Dl: u, Eh: d, El: h, Fh: f, Fl: p, Gh: y, Gl: m, Hh: b, Hl: C } = this;
    for (let A = 0; A < 80; A++) {
      const P = As(d, h, 14) ^ As(d, h, 18) ^ eo(d, h, 41), I = Is(d, h, 14) ^ Is(d, h, 18) ^ to(d, h, 41), U = d & f ^ ~d & y, j = h & p ^ ~h & m, G = Q1(C, I, j, sy[A], On[A]), F = ey(G, b, P, U, ny[A], Mn[A]), B = G | 0, V = As(r, s, 28) ^ eo(r, s, 34) ^ eo(r, s, 39), H = Is(r, s, 28) ^ to(r, s, 34) ^ to(r, s, 39), L = r & i ^ r & a ^ i & a, g = s & o ^ s & l ^ o & l;
      b = y | 0, C = m | 0, y = f | 0, m = p | 0, f = d | 0, p = h | 0, { h: d, l: h } = mn(c | 0, u | 0, F | 0, B | 0), c = a | 0, u = l | 0, a = i | 0, l = o | 0, i = r | 0, o = s | 0;
      const x = Y1(B, H, g);
      r = Z1(x, F, V, L), s = x | 0;
    }
    ({ h: r, l: s } = mn(this.Ah | 0, this.Al | 0, r | 0, s | 0)), { h: i, l: o } = mn(this.Bh | 0, this.Bl | 0, i | 0, o | 0), { h: a, l } = mn(this.Ch | 0, this.Cl | 0, a | 0, l | 0), { h: c, l: u } = mn(this.Dh | 0, this.Dl | 0, c | 0, u | 0), { h: d, l: h } = mn(this.Eh | 0, this.El | 0, d | 0, h | 0), { h: f, l: p } = mn(this.Fh | 0, this.Fl | 0, f | 0, p | 0), { h: y, l: m } = mn(this.Gh | 0, this.Gl | 0, y | 0, m | 0), { h: b, l: C } = mn(this.Hh | 0, this.Hl | 0, b | 0, C | 0), this.set(r, s, i, o, a, l, c, u, d, h, f, p, y, m, b, C);
  }
  roundClean() {
    Ws(Mn, On);
  }
  destroy() {
    Ws(this.buffer), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const Zf = /* @__PURE__ */ Wf(() => new ry()), oy = /* @__PURE__ */ Wf(() => new iy());
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const lu = /* @__PURE__ */ BigInt(0), hc = /* @__PURE__ */ BigInt(1);
function fs(n, e) {
  if (typeof e != "boolean")
    throw new Error(n + " boolean expected, got " + e);
}
function ro(n) {
  const e = n.toString(16);
  return e.length & 1 ? "0" + e : e;
}
function Xf(n) {
  if (typeof n != "string")
    throw new Error("hex string expected, got " + typeof n);
  return n === "" ? lu : BigInt("0x" + n);
}
function _a(n) {
  return Xf(qs(n));
}
function Si(n) {
  return ln(n), Xf(qs(Uint8Array.from(n).reverse()));
}
function cu(n, e) {
  return ou(n.toString(16).padStart(e * 2, "0"));
}
function La(n, e) {
  return cu(n, e).reverse();
}
function Tt(n, e, t) {
  let r;
  if (typeof e == "string")
    try {
      r = ou(e);
    } catch (i) {
      throw new Error(n + " must be hex string or Uint8Array, cause: " + i);
    }
  else if (iu(e))
    r = Uint8Array.from(e);
  else
    throw new Error(n + " must be hex string or Uint8Array");
  const s = r.length;
  if (typeof t == "number" && s !== t)
    throw new Error(n + " of length " + t + " expected, got " + s);
  return r;
}
const dl = (n) => typeof n == "bigint" && lu <= n;
function ay(n, e, t) {
  return dl(n) && dl(e) && dl(t) && e <= n && n < t;
}
function Bs(n, e, t, r) {
  if (!ay(e, t, r))
    throw new Error("expected valid " + n + ": " + t + " <= n < " + r + ", got " + e);
}
function ly(n) {
  let e;
  for (e = 0; n > lu; n >>= hc, e += 1)
    ;
  return e;
}
const Ra = (n) => (hc << BigInt(n)) - hc;
function cy(n, e, t) {
  if (typeof n != "number" || n < 2)
    throw new Error("hashLen must be a number");
  if (typeof e != "number" || e < 2)
    throw new Error("qByteLen must be a number");
  if (typeof t != "function")
    throw new Error("hmacFn must be a function");
  const r = (f) => new Uint8Array(f), s = (f) => Uint8Array.of(f);
  let i = r(n), o = r(n), a = 0;
  const l = () => {
    i.fill(1), o.fill(0), a = 0;
  }, c = (...f) => t(o, i, ...f), u = (f = r(0)) => {
    o = c(s(0), f), i = c(), f.length !== 0 && (o = c(s(1), f), i = c());
  }, d = () => {
    if (a++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let f = 0;
    const p = [];
    for (; f < e; ) {
      i = c();
      const y = i.slice();
      p.push(y), f += i.length;
    }
    return An(...p);
  };
  return (f, p) => {
    l(), u(f);
    let y;
    for (; !(y = p(d())); )
      u();
    return l(), y;
  };
}
function qi(n, e, t = {}) {
  if (!n || typeof n != "object")
    throw new Error("expected valid options object");
  function r(s, i, o) {
    const a = n[s];
    if (o && a === void 0)
      return;
    const l = typeof a;
    if (l !== i || a === null)
      throw new Error(`param "${s}" is invalid: expected ${i}, got ${l}`);
  }
  Object.entries(e).forEach(([s, i]) => r(s, i, !1)), Object.entries(t).forEach(([s, i]) => r(s, i, !0));
}
function Yo(n) {
  const e = /* @__PURE__ */ new WeakMap();
  return (t, ...r) => {
    const s = e.get(t);
    if (s !== void 0)
      return s;
    const i = n(t, ...r);
    return e.set(t, i), i;
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Er = BigInt(0), tr = BigInt(1), is = /* @__PURE__ */ BigInt(2), uy = /* @__PURE__ */ BigInt(3), Jf = /* @__PURE__ */ BigInt(4), Qf = /* @__PURE__ */ BigInt(5), e0 = /* @__PURE__ */ BigInt(8);
function wt(n, e) {
  const t = n % e;
  return t >= Er ? t : e + t;
}
function xt(n, e, t) {
  let r = n;
  for (; e-- > Er; )
    r *= r, r %= t;
  return r;
}
function _d(n, e) {
  if (n === Er)
    throw new Error("invert: expected non-zero number");
  if (e <= Er)
    throw new Error("invert: expected positive modulus, got " + e);
  let t = wt(n, e), r = e, s = Er, i = tr;
  for (; t !== Er; ) {
    const a = r / t, l = r % t, c = s - i * a;
    r = t, t = l, s = i, i = c;
  }
  if (r !== tr)
    throw new Error("invert: does not exist");
  return wt(s, e);
}
function t0(n, e) {
  const t = (n.ORDER + tr) / Jf, r = n.pow(e, t);
  if (!n.eql(n.sqr(r), e))
    throw new Error("Cannot find square root");
  return r;
}
function dy(n, e) {
  const t = (n.ORDER - Qf) / e0, r = n.mul(e, is), s = n.pow(r, t), i = n.mul(e, s), o = n.mul(n.mul(i, is), s), a = n.mul(i, n.sub(o, n.ONE));
  if (!n.eql(n.sqr(a), e))
    throw new Error("Cannot find square root");
  return a;
}
function hy(n) {
  if (n < BigInt(3))
    throw new Error("sqrt is not defined for small field");
  let e = n - tr, t = 0;
  for (; e % is === Er; )
    e /= is, t++;
  let r = is;
  const s = ri(n);
  for (; Ld(s, r) === 1; )
    if (r++ > 1e3)
      throw new Error("Cannot find square root: probably non-prime P");
  if (t === 1)
    return t0;
  let i = s.pow(r, e);
  const o = (e + tr) / is;
  return function(l, c) {
    if (l.is0(c))
      return c;
    if (Ld(l, c) !== 1)
      throw new Error("Cannot find square root");
    let u = t, d = l.mul(l.ONE, i), h = l.pow(c, e), f = l.pow(c, o);
    for (; !l.eql(h, l.ONE); ) {
      if (l.is0(h))
        return l.ZERO;
      let p = 1, y = l.sqr(h);
      for (; !l.eql(y, l.ONE); )
        if (p++, y = l.sqr(y), p === u)
          throw new Error("Cannot find square root");
      const m = tr << BigInt(u - p - 1), b = l.pow(d, m);
      u = p, d = l.sqr(b), h = l.mul(h, d), f = l.mul(f, b);
    }
    return f;
  };
}
function fy(n) {
  return n % Jf === uy ? t0 : n % e0 === Qf ? dy : hy(n);
}
const gy = (n, e) => (wt(n, e) & tr) === tr, py = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function my(n) {
  const e = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "number",
    BITS: "number"
  }, t = py.reduce((r, s) => (r[s] = "function", r), e);
  return qi(n, t), n;
}
function yy(n, e, t) {
  if (t < Er)
    throw new Error("invalid exponent, negatives unsupported");
  if (t === Er)
    return n.ONE;
  if (t === tr)
    return e;
  let r = n.ONE, s = e;
  for (; t > Er; )
    t & tr && (r = n.mul(r, s)), s = n.sqr(s), t >>= tr;
  return r;
}
function r0(n, e, t = !1) {
  const r = new Array(e.length).fill(t ? n.ZERO : void 0), s = e.reduce((o, a, l) => n.is0(a) ? o : (r[l] = o, n.mul(o, a)), n.ONE), i = n.inv(s);
  return e.reduceRight((o, a, l) => n.is0(a) ? o : (r[l] = n.mul(o, r[l]), n.mul(o, a)), i), r;
}
function Ld(n, e) {
  const t = (n.ORDER - tr) / is, r = n.pow(e, t), s = n.eql(r, n.ONE), i = n.eql(r, n.ZERO), o = n.eql(r, n.neg(n.ONE));
  if (!s && !i && !o)
    throw new Error("invalid Legendre symbol result");
  return s ? 1 : i ? 0 : -1;
}
function vy(n, e) {
  e !== void 0 && dc(e);
  const t = e !== void 0 ? e : n.toString(2).length, r = Math.ceil(t / 8);
  return { nBitLength: t, nByteLength: r };
}
function ri(n, e, t = !1, r = {}) {
  if (n <= Er)
    throw new Error("invalid field: expected ORDER > 0, got " + n);
  let s, i;
  if (typeof e == "object" && e != null) {
    if (r.sqrt || t)
      throw new Error("cannot specify opts in two arguments");
    const u = e;
    u.BITS && (s = u.BITS), u.sqrt && (i = u.sqrt), typeof u.isLE == "boolean" && (t = u.isLE);
  } else
    typeof e == "number" && (s = e), r.sqrt && (i = r.sqrt);
  const { nBitLength: o, nByteLength: a } = vy(n, s);
  if (a > 2048)
    throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let l;
  const c = Object.freeze({
    ORDER: n,
    isLE: t,
    BITS: o,
    BYTES: a,
    MASK: Ra(o),
    ZERO: Er,
    ONE: tr,
    create: (u) => wt(u, n),
    isValid: (u) => {
      if (typeof u != "bigint")
        throw new Error("invalid field element: expected bigint, got " + typeof u);
      return Er <= u && u < n;
    },
    is0: (u) => u === Er,
    // is valid and invertible
    isValidNot0: (u) => !c.is0(u) && c.isValid(u),
    isOdd: (u) => (u & tr) === tr,
    neg: (u) => wt(-u, n),
    eql: (u, d) => u === d,
    sqr: (u) => wt(u * u, n),
    add: (u, d) => wt(u + d, n),
    sub: (u, d) => wt(u - d, n),
    mul: (u, d) => wt(u * d, n),
    pow: (u, d) => yy(c, u, d),
    div: (u, d) => wt(u * _d(d, n), n),
    // Same as above, but doesn't normalize
    sqrN: (u) => u * u,
    addN: (u, d) => u + d,
    subN: (u, d) => u - d,
    mulN: (u, d) => u * d,
    inv: (u) => _d(u, n),
    sqrt: i || ((u) => (l || (l = fy(n)), l(c, u))),
    toBytes: (u) => t ? La(u, a) : cu(u, a),
    fromBytes: (u) => {
      if (u.length !== a)
        throw new Error("Field.fromBytes: expected " + a + " bytes, got " + u.length);
      return t ? Si(u) : _a(u);
    },
    // TODO: we don't need it here, move out to separate fn
    invertBatch: (u) => r0(c, u),
    // We can't move this out because Fp6, Fp12 implement it
    // and it's unclear what to return in there.
    cmov: (u, d, h) => h ? d : u
  });
  return Object.freeze(c);
}
function n0(n) {
  if (typeof n != "bigint")
    throw new Error("field order must be bigint");
  const e = n.toString(2).length;
  return Math.ceil(e / 8);
}
function s0(n) {
  const e = n0(n);
  return e + Math.ceil(e / 2);
}
function xy(n, e, t = !1) {
  const r = n.length, s = n0(e), i = s0(e);
  if (r < 16 || r < i || r > 1024)
    throw new Error("expected " + i + "-1024 bytes of input, got " + r);
  const o = t ? Si(n) : _a(n), a = wt(o, e - tr) + tr;
  return t ? La(a, s) : cu(a, s);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const zs = BigInt(0), os = BigInt(1);
function fi(n, e) {
  const t = e.negate();
  return n ? t : e;
}
function i0(n, e, t) {
  const r = e === "pz" ? (o) => o.pz : (o) => o.ez, s = r0(n.Fp, t.map(r));
  return t.map((o, a) => o.toAffine(s[a])).map(n.fromAffine);
}
function o0(n, e) {
  if (!Number.isSafeInteger(n) || n <= 0 || n > e)
    throw new Error("invalid window size, expected [1.." + e + "], got W=" + n);
}
function hl(n, e) {
  o0(n, e);
  const t = Math.ceil(e / n) + 1, r = 2 ** (n - 1), s = 2 ** n, i = Ra(n), o = BigInt(n);
  return { windows: t, windowSize: r, mask: i, maxNumber: s, shiftBy: o };
}
function Rd(n, e, t) {
  const { windowSize: r, mask: s, maxNumber: i, shiftBy: o } = t;
  let a = Number(n & s), l = n >> o;
  a > r && (a -= i, l += os);
  const c = e * r, u = c + Math.abs(a) - 1, d = a === 0, h = a < 0, f = e % 2 !== 0;
  return { nextN: l, offset: u, isZero: d, isNeg: h, isNegF: f, offsetF: c };
}
function Ey(n, e) {
  if (!Array.isArray(n))
    throw new Error("array expected");
  n.forEach((t, r) => {
    if (!(t instanceof e))
      throw new Error("invalid point at index " + r);
  });
}
function Sy(n, e) {
  if (!Array.isArray(n))
    throw new Error("array of scalars expected");
  n.forEach((t, r) => {
    if (!e.isValid(t))
      throw new Error("invalid scalar at index " + r);
  });
}
const fl = /* @__PURE__ */ new WeakMap(), a0 = /* @__PURE__ */ new WeakMap();
function gl(n) {
  return a0.get(n) || 1;
}
function Cd(n) {
  if (n !== zs)
    throw new Error("invalid wNAF");
}
function l0(n, e) {
  return {
    constTimeNegate: fi,
    hasPrecomputes(t) {
      return gl(t) !== 1;
    },
    // non-const time multiplication ladder
    unsafeLadder(t, r, s = n.ZERO) {
      let i = t;
      for (; r > zs; )
        r & os && (s = s.add(i)), i = i.double(), r >>= os;
      return s;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param elm Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(t, r) {
      const { windows: s, windowSize: i } = hl(r, e), o = [];
      let a = t, l = a;
      for (let c = 0; c < s; c++) {
        l = a, o.push(l);
        for (let u = 1; u < i; u++)
          l = l.add(a), o.push(l);
        a = l.double();
      }
      return o;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(t, r, s) {
      let i = n.ZERO, o = n.BASE;
      const a = hl(t, e);
      for (let l = 0; l < a.windows; l++) {
        const { nextN: c, offset: u, isZero: d, isNeg: h, isNegF: f, offsetF: p } = Rd(s, l, a);
        s = c, d ? o = o.add(fi(f, r[p])) : i = i.add(fi(h, r[u]));
      }
      return Cd(s), { p: i, f: o };
    },
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */
    wNAFUnsafe(t, r, s, i = n.ZERO) {
      const o = hl(t, e);
      for (let a = 0; a < o.windows && s !== zs; a++) {
        const { nextN: l, offset: c, isZero: u, isNeg: d } = Rd(s, a, o);
        if (s = l, !u) {
          const h = r[c];
          i = i.add(d ? h.negate() : h);
        }
      }
      return Cd(s), i;
    },
    getPrecomputes(t, r, s) {
      let i = fl.get(r);
      return i || (i = this.precomputeWindow(r, t), t !== 1 && (typeof s == "function" && (i = s(i)), fl.set(r, i))), i;
    },
    wNAFCached(t, r, s) {
      const i = gl(t);
      return this.wNAF(i, this.getPrecomputes(i, t, s), r);
    },
    wNAFCachedUnsafe(t, r, s, i) {
      const o = gl(t);
      return o === 1 ? this.unsafeLadder(t, r, i) : this.wNAFUnsafe(o, this.getPrecomputes(o, t, s), r, i);
    },
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    setWindowSize(t, r) {
      o0(r, e), a0.set(t, r), fl.delete(t);
    }
  };
}
function by(n, e, t, r) {
  let s = e, i = n.ZERO, o = n.ZERO;
  for (; t > zs || r > zs; )
    t & os && (i = i.add(s)), r & os && (o = o.add(s)), s = s.double(), t >>= os, r >>= os;
  return { p1: i, p2: o };
}
function c0(n, e, t, r) {
  Ey(t, n), Sy(r, e);
  const s = t.length, i = r.length;
  if (s !== i)
    throw new Error("arrays of points and scalars must have equal length");
  const o = n.ZERO, a = ly(BigInt(s));
  let l = 1;
  a > 12 ? l = a - 3 : a > 4 ? l = a - 2 : a > 0 && (l = 2);
  const c = Ra(l), u = new Array(Number(c) + 1).fill(o), d = Math.floor((e.BITS - 1) / l) * l;
  let h = o;
  for (let f = d; f >= 0; f -= l) {
    u.fill(o);
    for (let y = 0; y < i; y++) {
      const m = r[y], b = Number(m >> BigInt(f) & c);
      u[b] = u[b].add(t[y]);
    }
    let p = o;
    for (let y = u.length - 1, m = o; y > 0; y--)
      m = m.add(u[y]), p = p.add(m);
    if (h = h.add(p), f !== 0)
      for (let y = 0; y < l; y++)
        h = h.double();
  }
  return h;
}
function kd(n, e) {
  if (e) {
    if (e.ORDER !== n)
      throw new Error("Field.ORDER must match order: Fp == p, Fn == n");
    return my(e), e;
  } else
    return ri(n);
}
function u0(n, e, t = {}) {
  if (!e || typeof e != "object")
    throw new Error(`expected valid ${n} CURVE object`);
  for (const a of ["p", "n", "h"]) {
    const l = e[a];
    if (!(typeof l == "bigint" && l > zs))
      throw new Error(`CURVE.${a} must be positive bigint`);
  }
  const r = kd(e.p, t.Fp), s = kd(e.n, t.Fn), o = ["Gx", "Gy", "a", n === "weierstrass" ? "b" : "d"];
  for (const a of o)
    if (!r.isValid(e[a]))
      throw new Error(`CURVE.${a} must be valid field element of CURVE.Fp`);
  return { Fp: r, Fn: s };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Zr = BigInt(0), ur = BigInt(1), pl = BigInt(2), Ty = BigInt(8), wy = { zip215: !0 };
function Ay(n, e, t, r) {
  const s = n.sqr(t), i = n.sqr(r), o = n.add(n.mul(e.a, s), i), a = n.add(n.ONE, n.mul(e.d, n.mul(s, i)));
  return n.eql(o, a);
}
function Iy(n, e = {}) {
  const { Fp: t, Fn: r } = u0("edwards", n, e), { h: s, n: i } = n;
  qi(e, {}, { uvRatio: "function" });
  const o = pl << BigInt(r.BYTES * 8) - ur, a = (y) => t.create(y), l = e.uvRatio || ((y, m) => {
    try {
      return { isValid: !0, value: t.sqrt(t.div(y, m)) };
    } catch {
      return { isValid: !1, value: Zr };
    }
  });
  if (!Ay(t, n, n.Gx, n.Gy))
    throw new Error("bad curve params: generator point");
  function c(y, m, b = !1) {
    const C = b ? ur : Zr;
    return Bs("coordinate " + y, m, C, o), m;
  }
  function u(y) {
    if (!(y instanceof f))
      throw new Error("ExtendedPoint expected");
  }
  const d = Yo((y, m) => {
    const { ex: b, ey: C, ez: A } = y, P = y.is0();
    m == null && (m = P ? Ty : t.inv(A));
    const I = a(b * m), U = a(C * m), j = a(A * m);
    if (P)
      return { x: Zr, y: ur };
    if (j !== ur)
      throw new Error("invZ was invalid");
    return { x: I, y: U };
  }), h = Yo((y) => {
    const { a: m, d: b } = n;
    if (y.is0())
      throw new Error("bad point: ZERO");
    const { ex: C, ey: A, ez: P, et: I } = y, U = a(C * C), j = a(A * A), G = a(P * P), F = a(G * G), B = a(U * m), V = a(G * a(B + j)), H = a(F + a(b * a(U * j)));
    if (V !== H)
      throw new Error("bad point: equation left != right (1)");
    const L = a(C * A), g = a(P * I);
    if (L !== g)
      throw new Error("bad point: equation left != right (2)");
    return !0;
  });
  class f {
    constructor(m, b, C, A) {
      this.ex = c("x", m), this.ey = c("y", b), this.ez = c("z", C, !0), this.et = c("t", A), Object.freeze(this);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static fromAffine(m) {
      if (m instanceof f)
        throw new Error("extended point not allowed");
      const { x: b, y: C } = m || {};
      return c("x", b), c("y", C), new f(b, C, ur, a(b * C));
    }
    static normalizeZ(m) {
      return i0(f, "ez", m);
    }
    // Multiscalar Multiplication
    static msm(m, b) {
      return c0(f, r, m, b);
    }
    // "Private method", don't use it directly
    _setWindowSize(m) {
      this.precompute(m);
    }
    precompute(m = 8, b = !0) {
      return p.setWindowSize(this, m), b || this.multiply(pl), this;
    }
    // Not required for fromHex(), which always creates valid points.
    // Could be useful for fromAffine().
    assertValidity() {
      h(this);
    }
    // Compare one point to another.
    equals(m) {
      u(m);
      const { ex: b, ey: C, ez: A } = this, { ex: P, ey: I, ez: U } = m, j = a(b * U), G = a(P * A), F = a(C * U), B = a(I * A);
      return j === G && F === B;
    }
    is0() {
      return this.equals(f.ZERO);
    }
    negate() {
      return new f(a(-this.ex), this.ey, this.ez, a(-this.et));
    }
    // Fast algo for doubling Extended Point.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
    // Cost: 4M + 4S + 1*a + 6add + 1*2.
    double() {
      const { a: m } = n, { ex: b, ey: C, ez: A } = this, P = a(b * b), I = a(C * C), U = a(pl * a(A * A)), j = a(m * P), G = b + C, F = a(a(G * G) - P - I), B = j + I, V = B - U, H = j - I, L = a(F * V), g = a(B * H), x = a(F * H), w = a(V * B);
      return new f(L, g, w, x);
    }
    // Fast algo for adding 2 Extended Points.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
    // Cost: 9M + 1*a + 1*d + 7add.
    add(m) {
      u(m);
      const { a: b, d: C } = n, { ex: A, ey: P, ez: I, et: U } = this, { ex: j, ey: G, ez: F, et: B } = m, V = a(A * j), H = a(P * G), L = a(U * C * B), g = a(I * F), x = a((A + P) * (j + G) - V - H), w = g - L, _ = g + L, D = a(H - b * V), O = a(x * w), N = a(_ * D), R = a(x * D), v = a(w * _);
      return new f(O, N, v, R);
    }
    subtract(m) {
      return this.add(m.negate());
    }
    // Constant-time multiplication.
    multiply(m) {
      const b = m;
      Bs("scalar", b, ur, i);
      const { p: C, f: A } = p.wNAFCached(this, b, f.normalizeZ);
      return f.normalizeZ([C, A])[0];
    }
    // Non-constant-time multiplication. Uses double-and-add algorithm.
    // It's faster, but should only be used when you don't care about
    // an exposed private key e.g. sig verification.
    // Does NOT allow scalars higher than CURVE.n.
    // Accepts optional accumulator to merge with multiply (important for sparse scalars)
    multiplyUnsafe(m, b = f.ZERO) {
      const C = m;
      return Bs("scalar", C, Zr, i), C === Zr ? f.ZERO : this.is0() || C === ur ? this : p.wNAFCachedUnsafe(this, C, f.normalizeZ, b);
    }
    // Checks if point is of small order.
    // If you add something to small order point, you will have "dirty"
    // point with torsion component.
    // Multiplies point by cofactor and checks if the result is 0.
    isSmallOrder() {
      return this.multiplyUnsafe(s).is0();
    }
    // Multiplies point by curve order and checks if the result is 0.
    // Returns `false` is the point is dirty.
    isTorsionFree() {
      return p.wNAFCachedUnsafe(this, i).is0();
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    toAffine(m) {
      return d(this, m);
    }
    clearCofactor() {
      return s === ur ? this : this.multiplyUnsafe(s);
    }
    static fromBytes(m, b = !1) {
      return ln(m), this.fromHex(m, b);
    }
    // Converts hash string or Uint8Array to Point.
    // Uses algo from RFC8032 5.1.3.
    static fromHex(m, b = !1) {
      const { d: C, a: A } = n, P = t.BYTES;
      m = Tt("pointHex", m, P), fs("zip215", b);
      const I = m.slice(), U = m[P - 1];
      I[P - 1] = U & -129;
      const j = Si(I), G = b ? o : t.ORDER;
      Bs("pointHex.y", j, Zr, G);
      const F = a(j * j), B = a(F - ur), V = a(C * F - A);
      let { isValid: H, value: L } = l(B, V);
      if (!H)
        throw new Error("Point.fromHex: invalid y coordinate");
      const g = (L & ur) === ur, x = (U & 128) !== 0;
      if (!b && L === Zr && x)
        throw new Error("Point.fromHex: x=0 and x_0=1");
      return x !== g && (L = a(-L)), f.fromAffine({ x: L, y: j });
    }
    static fromPrivateScalar(m) {
      return f.BASE.multiply(m);
    }
    toBytes() {
      const { x: m, y: b } = this.toAffine(), C = La(b, t.BYTES);
      return C[C.length - 1] |= m & ur ? 128 : 0, C;
    }
    /** @deprecated use `toBytes` */
    toRawBytes() {
      return this.toBytes();
    }
    toHex() {
      return qs(this.toBytes());
    }
    toString() {
      return `<Point ${this.is0() ? "ZERO" : this.toHex()}>`;
    }
  }
  f.BASE = new f(n.Gx, n.Gy, ur, a(n.Gx * n.Gy)), f.ZERO = new f(Zr, ur, ur, Zr), f.Fp = t, f.Fn = r;
  const p = l0(f, r.BYTES * 8);
  return f;
}
function _y(n, e) {
  qi(e, {
    hash: "function"
  }, {
    adjustScalarBytes: "function",
    randomBytes: "function",
    domain: "function",
    prehash: "function",
    mapToCurve: "function"
  });
  const { prehash: t, hash: r } = e, { BASE: s, Fp: i, Fn: o } = n, a = o.ORDER, l = e.randomBytes || qf, c = e.adjustScalarBytes || ((I) => I), u = e.domain || ((I, U, j) => {
    if (fs("phflag", j), U.length || j)
      throw new Error("Contexts/pre-hash are not supported");
    return I;
  });
  function d(I) {
    return o.create(I);
  }
  function h(I) {
    return d(Si(I));
  }
  function f(I) {
    const U = i.BYTES;
    I = Tt("private key", I, U);
    const j = Tt("hashed private key", r(I), 2 * U), G = c(j.slice(0, U)), F = j.slice(U, 2 * U), B = h(G);
    return { head: G, prefix: F, scalar: B };
  }
  function p(I) {
    const { head: U, prefix: j, scalar: G } = f(I), F = s.multiply(G), B = F.toBytes();
    return { head: U, prefix: j, scalar: G, point: F, pointBytes: B };
  }
  function y(I) {
    return p(I).pointBytes;
  }
  function m(I = Uint8Array.of(), ...U) {
    const j = An(...U);
    return h(r(u(j, Tt("context", I), !!t)));
  }
  function b(I, U, j = {}) {
    I = Tt("message", I), t && (I = t(I));
    const { prefix: G, scalar: F, pointBytes: B } = p(U), V = m(j.context, G, I), H = s.multiply(V).toBytes(), L = m(j.context, H, B, I), g = d(V + L * F);
    Bs("signature.s", g, Zr, a);
    const x = i.BYTES, w = An(H, La(g, x));
    return Tt("result", w, x * 2);
  }
  const C = wy;
  function A(I, U, j, G = C) {
    const { context: F, zip215: B } = G, V = i.BYTES;
    I = Tt("signature", I, 2 * V), U = Tt("message", U), j = Tt("publicKey", j, V), B !== void 0 && fs("zip215", B), t && (U = t(U));
    const H = Si(I.slice(V, 2 * V));
    let L, g, x;
    try {
      L = n.fromHex(j, B), g = n.fromHex(I.slice(0, V), B), x = s.multiplyUnsafe(H);
    } catch {
      return !1;
    }
    if (!B && L.isSmallOrder())
      return !1;
    const w = m(F, g.toBytes(), L.toBytes(), U);
    return g.add(L.multiplyUnsafe(w)).subtract(x).clearCofactor().is0();
  }
  return s.precompute(8), { getPublicKey: y, sign: b, verify: A, utils: {
    getExtendedPublicKey: p,
    /** ed25519 priv keys are uniform 32b. No need to check for modulo bias, like in secp256k1. */
    randomPrivateKey: () => l(i.BYTES),
    /**
     * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
     * values. This slows down first getPublicKey() by milliseconds (see Speed section),
     * but allows to speed-up subsequent getPublicKey() calls up to 20x.
     * @param windowSize 2, 4, 8, 16
     */
    precompute(I = 8, U = n.BASE) {
      return U.precompute(I, !1);
    }
  }, Point: n };
}
function Ly(n) {
  const e = {
    a: n.a,
    d: n.d,
    p: n.Fp.ORDER,
    n: n.n,
    h: n.h,
    Gx: n.Gx,
    Gy: n.Gy
  }, t = n.Fp, r = ri(e.n, n.nBitLength, !0), s = { Fp: t, Fn: r, uvRatio: n.uvRatio }, i = {
    hash: n.hash,
    randomBytes: n.randomBytes,
    adjustScalarBytes: n.adjustScalarBytes,
    domain: n.domain,
    prehash: n.prehash,
    mapToCurve: n.mapToCurve
  };
  return { CURVE: e, curveOpts: s, eddsaOpts: i };
}
function Ry(n, e) {
  return Object.assign({}, e, { ExtendedPoint: e.Point, CURVE: n });
}
function Cy(n) {
  const { CURVE: e, curveOpts: t, eddsaOpts: r } = Ly(n), s = Iy(e, t), i = _y(s, r);
  return Ry(n, i);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
BigInt(0);
const ky = BigInt(1), Dd = BigInt(2);
BigInt(3);
const Dy = BigInt(5), Py = BigInt(8), Ca = {
  p: BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffed"),
  n: BigInt("0x1000000000000000000000000000000014def9dea2f79cd65812631a5cf5d3ed"),
  h: Py,
  a: BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffec"),
  d: BigInt("0x52036cee2b6ffe738cc740797779e89800700a4d4141d8ab75eb4dca135978a3"),
  Gx: BigInt("0x216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a"),
  Gy: BigInt("0x6666666666666666666666666666666666666666666666666666666666666658")
};
function My(n) {
  const e = BigInt(10), t = BigInt(20), r = BigInt(40), s = BigInt(80), i = Ca.p, a = n * n % i * n % i, l = xt(a, Dd, i) * a % i, c = xt(l, ky, i) * n % i, u = xt(c, Dy, i) * c % i, d = xt(u, e, i) * u % i, h = xt(d, t, i) * d % i, f = xt(h, r, i) * h % i, p = xt(f, s, i) * f % i, y = xt(p, s, i) * f % i, m = xt(y, e, i) * u % i;
  return { pow_p_5_8: xt(m, Dd, i) * n % i, b2: a };
}
function Oy(n) {
  return n[0] &= 248, n[31] &= 127, n[31] |= 64, n;
}
const Pd = /* @__PURE__ */ BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
function By(n, e) {
  const t = Ca.p, r = wt(e * e * e, t), s = wt(r * r * e, t), i = My(n * s).pow_p_5_8;
  let o = wt(n * r * i, t);
  const a = wt(e * o * o, t), l = o, c = wt(o * Pd, t), u = a === n, d = a === wt(-n, t), h = a === wt(-n * Pd, t);
  return u && (o = l), (d || h) && (o = c), gy(o, t) && (o = wt(-o, t)), { isValid: u || d, value: o };
}
const Fy = ri(Ca.p, void 0, !0), Ny = {
  ...Ca,
  Fp: Fy,
  hash: oy,
  adjustScalarBytes: Oy,
  // dom2
  // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
  // Constant-time, u/√v
  uvRatio: By
}, zi = Cy(Ny);
var uu = { exports: {} };
const Uy = {}, $y = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Uy
}, Symbol.toStringTag, { value: "Module" })), Gy = /* @__PURE__ */ Xc($y);
uu.exports;
(function(n) {
  (function(e, t) {
    function r(L, g) {
      if (!L) throw new Error(g || "Assertion failed");
    }
    function s(L, g) {
      L.super_ = g;
      var x = function() {
      };
      x.prototype = g.prototype, L.prototype = new x(), L.prototype.constructor = L;
    }
    function i(L, g, x) {
      if (i.isBN(L))
        return L;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, L !== null && ((g === "le" || g === "be") && (x = g, g = 10), this._init(L || 0, g || 10, x || "be"));
    }
    typeof e == "object" ? e.exports = i : t.BN = i, i.BN = i, i.wordSize = 26;
    var o;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? o = window.Buffer : o = Gy.Buffer;
    } catch {
    }
    i.isBN = function(g) {
      return g instanceof i ? !0 : g !== null && typeof g == "object" && g.constructor.wordSize === i.wordSize && Array.isArray(g.words);
    }, i.max = function(g, x) {
      return g.cmp(x) > 0 ? g : x;
    }, i.min = function(g, x) {
      return g.cmp(x) < 0 ? g : x;
    }, i.prototype._init = function(g, x, w) {
      if (typeof g == "number")
        return this._initNumber(g, x, w);
      if (typeof g == "object")
        return this._initArray(g, x, w);
      x === "hex" && (x = 16), r(x === (x | 0) && x >= 2 && x <= 36), g = g.toString().replace(/\s+/g, "");
      var _ = 0;
      g[0] === "-" && (_++, this.negative = 1), _ < g.length && (x === 16 ? this._parseHex(g, _, w) : (this._parseBase(g, x, _), w === "le" && this._initArray(this.toArray(), x, w)));
    }, i.prototype._initNumber = function(g, x, w) {
      g < 0 && (this.negative = 1, g = -g), g < 67108864 ? (this.words = [g & 67108863], this.length = 1) : g < 4503599627370496 ? (this.words = [
        g & 67108863,
        g / 67108864 & 67108863
      ], this.length = 2) : (r(g < 9007199254740992), this.words = [
        g & 67108863,
        g / 67108864 & 67108863,
        1
      ], this.length = 3), w === "le" && this._initArray(this.toArray(), x, w);
    }, i.prototype._initArray = function(g, x, w) {
      if (r(typeof g.length == "number"), g.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(g.length / 3), this.words = new Array(this.length);
      for (var _ = 0; _ < this.length; _++)
        this.words[_] = 0;
      var D, O, N = 0;
      if (w === "be")
        for (_ = g.length - 1, D = 0; _ >= 0; _ -= 3)
          O = g[_] | g[_ - 1] << 8 | g[_ - 2] << 16, this.words[D] |= O << N & 67108863, this.words[D + 1] = O >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, D++);
      else if (w === "le")
        for (_ = 0, D = 0; _ < g.length; _ += 3)
          O = g[_] | g[_ + 1] << 8 | g[_ + 2] << 16, this.words[D] |= O << N & 67108863, this.words[D + 1] = O >>> 26 - N & 67108863, N += 24, N >= 26 && (N -= 26, D++);
      return this._strip();
    };
    function a(L, g) {
      var x = L.charCodeAt(g);
      if (x >= 48 && x <= 57)
        return x - 48;
      if (x >= 65 && x <= 70)
        return x - 55;
      if (x >= 97 && x <= 102)
        return x - 87;
      r(!1, "Invalid character in " + L);
    }
    function l(L, g, x) {
      var w = a(L, x);
      return x - 1 >= g && (w |= a(L, x - 1) << 4), w;
    }
    i.prototype._parseHex = function(g, x, w) {
      this.length = Math.ceil((g.length - x) / 6), this.words = new Array(this.length);
      for (var _ = 0; _ < this.length; _++)
        this.words[_] = 0;
      var D = 0, O = 0, N;
      if (w === "be")
        for (_ = g.length - 1; _ >= x; _ -= 2)
          N = l(g, x, _) << D, this.words[O] |= N & 67108863, D >= 18 ? (D -= 18, O += 1, this.words[O] |= N >>> 26) : D += 8;
      else {
        var R = g.length - x;
        for (_ = R % 2 === 0 ? x + 1 : x; _ < g.length; _ += 2)
          N = l(g, x, _) << D, this.words[O] |= N & 67108863, D >= 18 ? (D -= 18, O += 1, this.words[O] |= N >>> 26) : D += 8;
      }
      this._strip();
    };
    function c(L, g, x, w) {
      for (var _ = 0, D = 0, O = Math.min(L.length, x), N = g; N < O; N++) {
        var R = L.charCodeAt(N) - 48;
        _ *= w, R >= 49 ? D = R - 49 + 10 : R >= 17 ? D = R - 17 + 10 : D = R, r(R >= 0 && D < w, "Invalid character"), _ += D;
      }
      return _;
    }
    i.prototype._parseBase = function(g, x, w) {
      this.words = [0], this.length = 1;
      for (var _ = 0, D = 1; D <= 67108863; D *= x)
        _++;
      _--, D = D / x | 0;
      for (var O = g.length - w, N = O % _, R = Math.min(O, O - N) + w, v = 0, M = w; M < R; M += _)
        v = c(g, M, M + _, x), this.imuln(D), this.words[0] + v < 67108864 ? this.words[0] += v : this._iaddn(v);
      if (N !== 0) {
        var te = 1;
        for (v = c(g, M, g.length, x), M = 0; M < N; M++)
          te *= x;
        this.imuln(te), this.words[0] + v < 67108864 ? this.words[0] += v : this._iaddn(v);
      }
      this._strip();
    }, i.prototype.copy = function(g) {
      g.words = new Array(this.length);
      for (var x = 0; x < this.length; x++)
        g.words[x] = this.words[x];
      g.length = this.length, g.negative = this.negative, g.red = this.red;
    };
    function u(L, g) {
      L.words = g.words, L.length = g.length, L.negative = g.negative, L.red = g.red;
    }
    if (i.prototype._move = function(g) {
      u(g, this);
    }, i.prototype.clone = function() {
      var g = new i(null);
      return this.copy(g), g;
    }, i.prototype._expand = function(g) {
      for (; this.length < g; )
        this.words[this.length++] = 0;
      return this;
    }, i.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, i.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        i.prototype[Symbol.for("nodejs.util.inspect.custom")] = d;
      } catch {
        i.prototype.inspect = d;
      }
    else
      i.prototype.inspect = d;
    function d() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var h = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], f = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], p = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    i.prototype.toString = function(g, x) {
      g = g || 10, x = x | 0 || 1;
      var w;
      if (g === 16 || g === "hex") {
        w = "";
        for (var _ = 0, D = 0, O = 0; O < this.length; O++) {
          var N = this.words[O], R = ((N << _ | D) & 16777215).toString(16);
          D = N >>> 24 - _ & 16777215, _ += 2, _ >= 26 && (_ -= 26, O--), D !== 0 || O !== this.length - 1 ? w = h[6 - R.length] + R + w : w = R + w;
        }
        for (D !== 0 && (w = D.toString(16) + w); w.length % x !== 0; )
          w = "0" + w;
        return this.negative !== 0 && (w = "-" + w), w;
      }
      if (g === (g | 0) && g >= 2 && g <= 36) {
        var v = f[g], M = p[g];
        w = "";
        var te = this.clone();
        for (te.negative = 0; !te.isZero(); ) {
          var ee = te.modrn(M).toString(g);
          te = te.idivn(M), te.isZero() ? w = ee + w : w = h[v - ee.length] + ee + w;
        }
        for (this.isZero() && (w = "0" + w); w.length % x !== 0; )
          w = "0" + w;
        return this.negative !== 0 && (w = "-" + w), w;
      }
      r(!1, "Base should be between 2 and 36");
    }, i.prototype.toNumber = function() {
      var g = this.words[0];
      return this.length === 2 ? g += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? g += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && r(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -g : g;
    }, i.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, o && (i.prototype.toBuffer = function(g, x) {
      return this.toArrayLike(o, g, x);
    }), i.prototype.toArray = function(g, x) {
      return this.toArrayLike(Array, g, x);
    };
    var y = function(g, x) {
      return g.allocUnsafe ? g.allocUnsafe(x) : new g(x);
    };
    i.prototype.toArrayLike = function(g, x, w) {
      this._strip();
      var _ = this.byteLength(), D = w || Math.max(1, _);
      r(_ <= D, "byte array longer than desired length"), r(D > 0, "Requested array length <= 0");
      var O = y(g, D), N = x === "le" ? "LE" : "BE";
      return this["_toArrayLike" + N](O, _), O;
    }, i.prototype._toArrayLikeLE = function(g, x) {
      for (var w = 0, _ = 0, D = 0, O = 0; D < this.length; D++) {
        var N = this.words[D] << O | _;
        g[w++] = N & 255, w < g.length && (g[w++] = N >> 8 & 255), w < g.length && (g[w++] = N >> 16 & 255), O === 6 ? (w < g.length && (g[w++] = N >> 24 & 255), _ = 0, O = 0) : (_ = N >>> 24, O += 2);
      }
      if (w < g.length)
        for (g[w++] = _; w < g.length; )
          g[w++] = 0;
    }, i.prototype._toArrayLikeBE = function(g, x) {
      for (var w = g.length - 1, _ = 0, D = 0, O = 0; D < this.length; D++) {
        var N = this.words[D] << O | _;
        g[w--] = N & 255, w >= 0 && (g[w--] = N >> 8 & 255), w >= 0 && (g[w--] = N >> 16 & 255), O === 6 ? (w >= 0 && (g[w--] = N >> 24 & 255), _ = 0, O = 0) : (_ = N >>> 24, O += 2);
      }
      if (w >= 0)
        for (g[w--] = _; w >= 0; )
          g[w--] = 0;
    }, Math.clz32 ? i.prototype._countBits = function(g) {
      return 32 - Math.clz32(g);
    } : i.prototype._countBits = function(g) {
      var x = g, w = 0;
      return x >= 4096 && (w += 13, x >>>= 13), x >= 64 && (w += 7, x >>>= 7), x >= 8 && (w += 4, x >>>= 4), x >= 2 && (w += 2, x >>>= 2), w + x;
    }, i.prototype._zeroBits = function(g) {
      if (g === 0) return 26;
      var x = g, w = 0;
      return x & 8191 || (w += 13, x >>>= 13), x & 127 || (w += 7, x >>>= 7), x & 15 || (w += 4, x >>>= 4), x & 3 || (w += 2, x >>>= 2), x & 1 || w++, w;
    }, i.prototype.bitLength = function() {
      var g = this.words[this.length - 1], x = this._countBits(g);
      return (this.length - 1) * 26 + x;
    };
    function m(L) {
      for (var g = new Array(L.bitLength()), x = 0; x < g.length; x++) {
        var w = x / 26 | 0, _ = x % 26;
        g[x] = L.words[w] >>> _ & 1;
      }
      return g;
    }
    i.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var g = 0, x = 0; x < this.length; x++) {
        var w = this._zeroBits(this.words[x]);
        if (g += w, w !== 26) break;
      }
      return g;
    }, i.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, i.prototype.toTwos = function(g) {
      return this.negative !== 0 ? this.abs().inotn(g).iaddn(1) : this.clone();
    }, i.prototype.fromTwos = function(g) {
      return this.testn(g - 1) ? this.notn(g).iaddn(1).ineg() : this.clone();
    }, i.prototype.isNeg = function() {
      return this.negative !== 0;
    }, i.prototype.neg = function() {
      return this.clone().ineg();
    }, i.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, i.prototype.iuor = function(g) {
      for (; this.length < g.length; )
        this.words[this.length++] = 0;
      for (var x = 0; x < g.length; x++)
        this.words[x] = this.words[x] | g.words[x];
      return this._strip();
    }, i.prototype.ior = function(g) {
      return r((this.negative | g.negative) === 0), this.iuor(g);
    }, i.prototype.or = function(g) {
      return this.length > g.length ? this.clone().ior(g) : g.clone().ior(this);
    }, i.prototype.uor = function(g) {
      return this.length > g.length ? this.clone().iuor(g) : g.clone().iuor(this);
    }, i.prototype.iuand = function(g) {
      var x;
      this.length > g.length ? x = g : x = this;
      for (var w = 0; w < x.length; w++)
        this.words[w] = this.words[w] & g.words[w];
      return this.length = x.length, this._strip();
    }, i.prototype.iand = function(g) {
      return r((this.negative | g.negative) === 0), this.iuand(g);
    }, i.prototype.and = function(g) {
      return this.length > g.length ? this.clone().iand(g) : g.clone().iand(this);
    }, i.prototype.uand = function(g) {
      return this.length > g.length ? this.clone().iuand(g) : g.clone().iuand(this);
    }, i.prototype.iuxor = function(g) {
      var x, w;
      this.length > g.length ? (x = this, w = g) : (x = g, w = this);
      for (var _ = 0; _ < w.length; _++)
        this.words[_] = x.words[_] ^ w.words[_];
      if (this !== x)
        for (; _ < x.length; _++)
          this.words[_] = x.words[_];
      return this.length = x.length, this._strip();
    }, i.prototype.ixor = function(g) {
      return r((this.negative | g.negative) === 0), this.iuxor(g);
    }, i.prototype.xor = function(g) {
      return this.length > g.length ? this.clone().ixor(g) : g.clone().ixor(this);
    }, i.prototype.uxor = function(g) {
      return this.length > g.length ? this.clone().iuxor(g) : g.clone().iuxor(this);
    }, i.prototype.inotn = function(g) {
      r(typeof g == "number" && g >= 0);
      var x = Math.ceil(g / 26) | 0, w = g % 26;
      this._expand(x), w > 0 && x--;
      for (var _ = 0; _ < x; _++)
        this.words[_] = ~this.words[_] & 67108863;
      return w > 0 && (this.words[_] = ~this.words[_] & 67108863 >> 26 - w), this._strip();
    }, i.prototype.notn = function(g) {
      return this.clone().inotn(g);
    }, i.prototype.setn = function(g, x) {
      r(typeof g == "number" && g >= 0);
      var w = g / 26 | 0, _ = g % 26;
      return this._expand(w + 1), x ? this.words[w] = this.words[w] | 1 << _ : this.words[w] = this.words[w] & ~(1 << _), this._strip();
    }, i.prototype.iadd = function(g) {
      var x;
      if (this.negative !== 0 && g.negative === 0)
        return this.negative = 0, x = this.isub(g), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && g.negative !== 0)
        return g.negative = 0, x = this.isub(g), g.negative = 1, x._normSign();
      var w, _;
      this.length > g.length ? (w = this, _ = g) : (w = g, _ = this);
      for (var D = 0, O = 0; O < _.length; O++)
        x = (w.words[O] | 0) + (_.words[O] | 0) + D, this.words[O] = x & 67108863, D = x >>> 26;
      for (; D !== 0 && O < w.length; O++)
        x = (w.words[O] | 0) + D, this.words[O] = x & 67108863, D = x >>> 26;
      if (this.length = w.length, D !== 0)
        this.words[this.length] = D, this.length++;
      else if (w !== this)
        for (; O < w.length; O++)
          this.words[O] = w.words[O];
      return this;
    }, i.prototype.add = function(g) {
      var x;
      return g.negative !== 0 && this.negative === 0 ? (g.negative = 0, x = this.sub(g), g.negative ^= 1, x) : g.negative === 0 && this.negative !== 0 ? (this.negative = 0, x = g.sub(this), this.negative = 1, x) : this.length > g.length ? this.clone().iadd(g) : g.clone().iadd(this);
    }, i.prototype.isub = function(g) {
      if (g.negative !== 0) {
        g.negative = 0;
        var x = this.iadd(g);
        return g.negative = 1, x._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(g), this.negative = 1, this._normSign();
      var w = this.cmp(g);
      if (w === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var _, D;
      w > 0 ? (_ = this, D = g) : (_ = g, D = this);
      for (var O = 0, N = 0; N < D.length; N++)
        x = (_.words[N] | 0) - (D.words[N] | 0) + O, O = x >> 26, this.words[N] = x & 67108863;
      for (; O !== 0 && N < _.length; N++)
        x = (_.words[N] | 0) + O, O = x >> 26, this.words[N] = x & 67108863;
      if (O === 0 && N < _.length && _ !== this)
        for (; N < _.length; N++)
          this.words[N] = _.words[N];
      return this.length = Math.max(this.length, N), _ !== this && (this.negative = 1), this._strip();
    }, i.prototype.sub = function(g) {
      return this.clone().isub(g);
    };
    function b(L, g, x) {
      x.negative = g.negative ^ L.negative;
      var w = L.length + g.length | 0;
      x.length = w, w = w - 1 | 0;
      var _ = L.words[0] | 0, D = g.words[0] | 0, O = _ * D, N = O & 67108863, R = O / 67108864 | 0;
      x.words[0] = N;
      for (var v = 1; v < w; v++) {
        for (var M = R >>> 26, te = R & 67108863, ee = Math.min(v, g.length - 1), ne = Math.max(0, v - L.length + 1); ne <= ee; ne++) {
          var Ce = v - ne | 0;
          _ = L.words[Ce] | 0, D = g.words[ne] | 0, O = _ * D + te, M += O / 67108864 | 0, te = O & 67108863;
        }
        x.words[v] = te | 0, R = M | 0;
      }
      return R !== 0 ? x.words[v] = R | 0 : x.length--, x._strip();
    }
    var C = function(g, x, w) {
      var _ = g.words, D = x.words, O = w.words, N = 0, R, v, M, te = _[0] | 0, ee = te & 8191, ne = te >>> 13, Ce = _[1] | 0, ve = Ce & 8191, Ae = Ce >>> 13, qt = _[2] | 0, qe = qt & 8191, ct = qt >>> 13, Ge = _[3] | 0, ye = Ge & 8191, Be = Ge >>> 13, me = _[4] | 0, xe = me & 8191, Pe = me >>> 13, Qe = _[5] | 0, be = Qe & 8191, Me = Qe >>> 13, pt = _[6] | 0, et = pt & 8191, tt = pt >>> 13, at = _[7] | 0, Ve = at & 8191, k = at >>> 13, E = _[8] | 0, S = E & 8191, $ = E >>> 13, W = _[9] | 0, z = W & 8191, J = W >>> 13, Fe = D[0] | 0, ke = Fe & 8191, _e = Fe >>> 13, dt = D[1] | 0, we = dt & 8191, At = dt >>> 13, rd = D[2] | 0, It = rd & 8191, _t = rd >>> 13, nd = D[3] | 0, Lt = nd & 8191, Rt = nd >>> 13, sd = D[4] | 0, Ct = sd & 8191, kt = sd >>> 13, id = D[5] | 0, Dt = id & 8191, Pt = id >>> 13, od = D[6] | 0, Mt = od & 8191, Ot = od >>> 13, ad = D[7] | 0, Bt = ad & 8191, Ft = ad >>> 13, ld = D[8] | 0, Nt = ld & 8191, Ut = ld >>> 13, cd = D[9] | 0, $t = cd & 8191, Gt = cd >>> 13;
      w.negative = g.negative ^ x.negative, w.length = 19, R = Math.imul(ee, ke), v = Math.imul(ee, _e), v = v + Math.imul(ne, ke) | 0, M = Math.imul(ne, _e);
      var Va = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (Va >>> 26) | 0, Va &= 67108863, R = Math.imul(ve, ke), v = Math.imul(ve, _e), v = v + Math.imul(Ae, ke) | 0, M = Math.imul(Ae, _e), R = R + Math.imul(ee, we) | 0, v = v + Math.imul(ee, At) | 0, v = v + Math.imul(ne, we) | 0, M = M + Math.imul(ne, At) | 0;
      var Ka = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (Ka >>> 26) | 0, Ka &= 67108863, R = Math.imul(qe, ke), v = Math.imul(qe, _e), v = v + Math.imul(ct, ke) | 0, M = Math.imul(ct, _e), R = R + Math.imul(ve, we) | 0, v = v + Math.imul(ve, At) | 0, v = v + Math.imul(Ae, we) | 0, M = M + Math.imul(Ae, At) | 0, R = R + Math.imul(ee, It) | 0, v = v + Math.imul(ee, _t) | 0, v = v + Math.imul(ne, It) | 0, M = M + Math.imul(ne, _t) | 0;
      var Ha = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (Ha >>> 26) | 0, Ha &= 67108863, R = Math.imul(ye, ke), v = Math.imul(ye, _e), v = v + Math.imul(Be, ke) | 0, M = Math.imul(Be, _e), R = R + Math.imul(qe, we) | 0, v = v + Math.imul(qe, At) | 0, v = v + Math.imul(ct, we) | 0, M = M + Math.imul(ct, At) | 0, R = R + Math.imul(ve, It) | 0, v = v + Math.imul(ve, _t) | 0, v = v + Math.imul(Ae, It) | 0, M = M + Math.imul(Ae, _t) | 0, R = R + Math.imul(ee, Lt) | 0, v = v + Math.imul(ee, Rt) | 0, v = v + Math.imul(ne, Lt) | 0, M = M + Math.imul(ne, Rt) | 0;
      var Wa = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (Wa >>> 26) | 0, Wa &= 67108863, R = Math.imul(xe, ke), v = Math.imul(xe, _e), v = v + Math.imul(Pe, ke) | 0, M = Math.imul(Pe, _e), R = R + Math.imul(ye, we) | 0, v = v + Math.imul(ye, At) | 0, v = v + Math.imul(Be, we) | 0, M = M + Math.imul(Be, At) | 0, R = R + Math.imul(qe, It) | 0, v = v + Math.imul(qe, _t) | 0, v = v + Math.imul(ct, It) | 0, M = M + Math.imul(ct, _t) | 0, R = R + Math.imul(ve, Lt) | 0, v = v + Math.imul(ve, Rt) | 0, v = v + Math.imul(Ae, Lt) | 0, M = M + Math.imul(Ae, Rt) | 0, R = R + Math.imul(ee, Ct) | 0, v = v + Math.imul(ee, kt) | 0, v = v + Math.imul(ne, Ct) | 0, M = M + Math.imul(ne, kt) | 0;
      var qa = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (qa >>> 26) | 0, qa &= 67108863, R = Math.imul(be, ke), v = Math.imul(be, _e), v = v + Math.imul(Me, ke) | 0, M = Math.imul(Me, _e), R = R + Math.imul(xe, we) | 0, v = v + Math.imul(xe, At) | 0, v = v + Math.imul(Pe, we) | 0, M = M + Math.imul(Pe, At) | 0, R = R + Math.imul(ye, It) | 0, v = v + Math.imul(ye, _t) | 0, v = v + Math.imul(Be, It) | 0, M = M + Math.imul(Be, _t) | 0, R = R + Math.imul(qe, Lt) | 0, v = v + Math.imul(qe, Rt) | 0, v = v + Math.imul(ct, Lt) | 0, M = M + Math.imul(ct, Rt) | 0, R = R + Math.imul(ve, Ct) | 0, v = v + Math.imul(ve, kt) | 0, v = v + Math.imul(Ae, Ct) | 0, M = M + Math.imul(Ae, kt) | 0, R = R + Math.imul(ee, Dt) | 0, v = v + Math.imul(ee, Pt) | 0, v = v + Math.imul(ne, Dt) | 0, M = M + Math.imul(ne, Pt) | 0;
      var za = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (za >>> 26) | 0, za &= 67108863, R = Math.imul(et, ke), v = Math.imul(et, _e), v = v + Math.imul(tt, ke) | 0, M = Math.imul(tt, _e), R = R + Math.imul(be, we) | 0, v = v + Math.imul(be, At) | 0, v = v + Math.imul(Me, we) | 0, M = M + Math.imul(Me, At) | 0, R = R + Math.imul(xe, It) | 0, v = v + Math.imul(xe, _t) | 0, v = v + Math.imul(Pe, It) | 0, M = M + Math.imul(Pe, _t) | 0, R = R + Math.imul(ye, Lt) | 0, v = v + Math.imul(ye, Rt) | 0, v = v + Math.imul(Be, Lt) | 0, M = M + Math.imul(Be, Rt) | 0, R = R + Math.imul(qe, Ct) | 0, v = v + Math.imul(qe, kt) | 0, v = v + Math.imul(ct, Ct) | 0, M = M + Math.imul(ct, kt) | 0, R = R + Math.imul(ve, Dt) | 0, v = v + Math.imul(ve, Pt) | 0, v = v + Math.imul(Ae, Dt) | 0, M = M + Math.imul(Ae, Pt) | 0, R = R + Math.imul(ee, Mt) | 0, v = v + Math.imul(ee, Ot) | 0, v = v + Math.imul(ne, Mt) | 0, M = M + Math.imul(ne, Ot) | 0;
      var Ya = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (Ya >>> 26) | 0, Ya &= 67108863, R = Math.imul(Ve, ke), v = Math.imul(Ve, _e), v = v + Math.imul(k, ke) | 0, M = Math.imul(k, _e), R = R + Math.imul(et, we) | 0, v = v + Math.imul(et, At) | 0, v = v + Math.imul(tt, we) | 0, M = M + Math.imul(tt, At) | 0, R = R + Math.imul(be, It) | 0, v = v + Math.imul(be, _t) | 0, v = v + Math.imul(Me, It) | 0, M = M + Math.imul(Me, _t) | 0, R = R + Math.imul(xe, Lt) | 0, v = v + Math.imul(xe, Rt) | 0, v = v + Math.imul(Pe, Lt) | 0, M = M + Math.imul(Pe, Rt) | 0, R = R + Math.imul(ye, Ct) | 0, v = v + Math.imul(ye, kt) | 0, v = v + Math.imul(Be, Ct) | 0, M = M + Math.imul(Be, kt) | 0, R = R + Math.imul(qe, Dt) | 0, v = v + Math.imul(qe, Pt) | 0, v = v + Math.imul(ct, Dt) | 0, M = M + Math.imul(ct, Pt) | 0, R = R + Math.imul(ve, Mt) | 0, v = v + Math.imul(ve, Ot) | 0, v = v + Math.imul(Ae, Mt) | 0, M = M + Math.imul(Ae, Ot) | 0, R = R + Math.imul(ee, Bt) | 0, v = v + Math.imul(ee, Ft) | 0, v = v + Math.imul(ne, Bt) | 0, M = M + Math.imul(ne, Ft) | 0;
      var Za = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (Za >>> 26) | 0, Za &= 67108863, R = Math.imul(S, ke), v = Math.imul(S, _e), v = v + Math.imul($, ke) | 0, M = Math.imul($, _e), R = R + Math.imul(Ve, we) | 0, v = v + Math.imul(Ve, At) | 0, v = v + Math.imul(k, we) | 0, M = M + Math.imul(k, At) | 0, R = R + Math.imul(et, It) | 0, v = v + Math.imul(et, _t) | 0, v = v + Math.imul(tt, It) | 0, M = M + Math.imul(tt, _t) | 0, R = R + Math.imul(be, Lt) | 0, v = v + Math.imul(be, Rt) | 0, v = v + Math.imul(Me, Lt) | 0, M = M + Math.imul(Me, Rt) | 0, R = R + Math.imul(xe, Ct) | 0, v = v + Math.imul(xe, kt) | 0, v = v + Math.imul(Pe, Ct) | 0, M = M + Math.imul(Pe, kt) | 0, R = R + Math.imul(ye, Dt) | 0, v = v + Math.imul(ye, Pt) | 0, v = v + Math.imul(Be, Dt) | 0, M = M + Math.imul(Be, Pt) | 0, R = R + Math.imul(qe, Mt) | 0, v = v + Math.imul(qe, Ot) | 0, v = v + Math.imul(ct, Mt) | 0, M = M + Math.imul(ct, Ot) | 0, R = R + Math.imul(ve, Bt) | 0, v = v + Math.imul(ve, Ft) | 0, v = v + Math.imul(Ae, Bt) | 0, M = M + Math.imul(Ae, Ft) | 0, R = R + Math.imul(ee, Nt) | 0, v = v + Math.imul(ee, Ut) | 0, v = v + Math.imul(ne, Nt) | 0, M = M + Math.imul(ne, Ut) | 0;
      var Xa = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (Xa >>> 26) | 0, Xa &= 67108863, R = Math.imul(z, ke), v = Math.imul(z, _e), v = v + Math.imul(J, ke) | 0, M = Math.imul(J, _e), R = R + Math.imul(S, we) | 0, v = v + Math.imul(S, At) | 0, v = v + Math.imul($, we) | 0, M = M + Math.imul($, At) | 0, R = R + Math.imul(Ve, It) | 0, v = v + Math.imul(Ve, _t) | 0, v = v + Math.imul(k, It) | 0, M = M + Math.imul(k, _t) | 0, R = R + Math.imul(et, Lt) | 0, v = v + Math.imul(et, Rt) | 0, v = v + Math.imul(tt, Lt) | 0, M = M + Math.imul(tt, Rt) | 0, R = R + Math.imul(be, Ct) | 0, v = v + Math.imul(be, kt) | 0, v = v + Math.imul(Me, Ct) | 0, M = M + Math.imul(Me, kt) | 0, R = R + Math.imul(xe, Dt) | 0, v = v + Math.imul(xe, Pt) | 0, v = v + Math.imul(Pe, Dt) | 0, M = M + Math.imul(Pe, Pt) | 0, R = R + Math.imul(ye, Mt) | 0, v = v + Math.imul(ye, Ot) | 0, v = v + Math.imul(Be, Mt) | 0, M = M + Math.imul(Be, Ot) | 0, R = R + Math.imul(qe, Bt) | 0, v = v + Math.imul(qe, Ft) | 0, v = v + Math.imul(ct, Bt) | 0, M = M + Math.imul(ct, Ft) | 0, R = R + Math.imul(ve, Nt) | 0, v = v + Math.imul(ve, Ut) | 0, v = v + Math.imul(Ae, Nt) | 0, M = M + Math.imul(Ae, Ut) | 0, R = R + Math.imul(ee, $t) | 0, v = v + Math.imul(ee, Gt) | 0, v = v + Math.imul(ne, $t) | 0, M = M + Math.imul(ne, Gt) | 0;
      var Ja = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (Ja >>> 26) | 0, Ja &= 67108863, R = Math.imul(z, we), v = Math.imul(z, At), v = v + Math.imul(J, we) | 0, M = Math.imul(J, At), R = R + Math.imul(S, It) | 0, v = v + Math.imul(S, _t) | 0, v = v + Math.imul($, It) | 0, M = M + Math.imul($, _t) | 0, R = R + Math.imul(Ve, Lt) | 0, v = v + Math.imul(Ve, Rt) | 0, v = v + Math.imul(k, Lt) | 0, M = M + Math.imul(k, Rt) | 0, R = R + Math.imul(et, Ct) | 0, v = v + Math.imul(et, kt) | 0, v = v + Math.imul(tt, Ct) | 0, M = M + Math.imul(tt, kt) | 0, R = R + Math.imul(be, Dt) | 0, v = v + Math.imul(be, Pt) | 0, v = v + Math.imul(Me, Dt) | 0, M = M + Math.imul(Me, Pt) | 0, R = R + Math.imul(xe, Mt) | 0, v = v + Math.imul(xe, Ot) | 0, v = v + Math.imul(Pe, Mt) | 0, M = M + Math.imul(Pe, Ot) | 0, R = R + Math.imul(ye, Bt) | 0, v = v + Math.imul(ye, Ft) | 0, v = v + Math.imul(Be, Bt) | 0, M = M + Math.imul(Be, Ft) | 0, R = R + Math.imul(qe, Nt) | 0, v = v + Math.imul(qe, Ut) | 0, v = v + Math.imul(ct, Nt) | 0, M = M + Math.imul(ct, Ut) | 0, R = R + Math.imul(ve, $t) | 0, v = v + Math.imul(ve, Gt) | 0, v = v + Math.imul(Ae, $t) | 0, M = M + Math.imul(Ae, Gt) | 0;
      var Qa = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (Qa >>> 26) | 0, Qa &= 67108863, R = Math.imul(z, It), v = Math.imul(z, _t), v = v + Math.imul(J, It) | 0, M = Math.imul(J, _t), R = R + Math.imul(S, Lt) | 0, v = v + Math.imul(S, Rt) | 0, v = v + Math.imul($, Lt) | 0, M = M + Math.imul($, Rt) | 0, R = R + Math.imul(Ve, Ct) | 0, v = v + Math.imul(Ve, kt) | 0, v = v + Math.imul(k, Ct) | 0, M = M + Math.imul(k, kt) | 0, R = R + Math.imul(et, Dt) | 0, v = v + Math.imul(et, Pt) | 0, v = v + Math.imul(tt, Dt) | 0, M = M + Math.imul(tt, Pt) | 0, R = R + Math.imul(be, Mt) | 0, v = v + Math.imul(be, Ot) | 0, v = v + Math.imul(Me, Mt) | 0, M = M + Math.imul(Me, Ot) | 0, R = R + Math.imul(xe, Bt) | 0, v = v + Math.imul(xe, Ft) | 0, v = v + Math.imul(Pe, Bt) | 0, M = M + Math.imul(Pe, Ft) | 0, R = R + Math.imul(ye, Nt) | 0, v = v + Math.imul(ye, Ut) | 0, v = v + Math.imul(Be, Nt) | 0, M = M + Math.imul(Be, Ut) | 0, R = R + Math.imul(qe, $t) | 0, v = v + Math.imul(qe, Gt) | 0, v = v + Math.imul(ct, $t) | 0, M = M + Math.imul(ct, Gt) | 0;
      var el = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (el >>> 26) | 0, el &= 67108863, R = Math.imul(z, Lt), v = Math.imul(z, Rt), v = v + Math.imul(J, Lt) | 0, M = Math.imul(J, Rt), R = R + Math.imul(S, Ct) | 0, v = v + Math.imul(S, kt) | 0, v = v + Math.imul($, Ct) | 0, M = M + Math.imul($, kt) | 0, R = R + Math.imul(Ve, Dt) | 0, v = v + Math.imul(Ve, Pt) | 0, v = v + Math.imul(k, Dt) | 0, M = M + Math.imul(k, Pt) | 0, R = R + Math.imul(et, Mt) | 0, v = v + Math.imul(et, Ot) | 0, v = v + Math.imul(tt, Mt) | 0, M = M + Math.imul(tt, Ot) | 0, R = R + Math.imul(be, Bt) | 0, v = v + Math.imul(be, Ft) | 0, v = v + Math.imul(Me, Bt) | 0, M = M + Math.imul(Me, Ft) | 0, R = R + Math.imul(xe, Nt) | 0, v = v + Math.imul(xe, Ut) | 0, v = v + Math.imul(Pe, Nt) | 0, M = M + Math.imul(Pe, Ut) | 0, R = R + Math.imul(ye, $t) | 0, v = v + Math.imul(ye, Gt) | 0, v = v + Math.imul(Be, $t) | 0, M = M + Math.imul(Be, Gt) | 0;
      var tl = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (tl >>> 26) | 0, tl &= 67108863, R = Math.imul(z, Ct), v = Math.imul(z, kt), v = v + Math.imul(J, Ct) | 0, M = Math.imul(J, kt), R = R + Math.imul(S, Dt) | 0, v = v + Math.imul(S, Pt) | 0, v = v + Math.imul($, Dt) | 0, M = M + Math.imul($, Pt) | 0, R = R + Math.imul(Ve, Mt) | 0, v = v + Math.imul(Ve, Ot) | 0, v = v + Math.imul(k, Mt) | 0, M = M + Math.imul(k, Ot) | 0, R = R + Math.imul(et, Bt) | 0, v = v + Math.imul(et, Ft) | 0, v = v + Math.imul(tt, Bt) | 0, M = M + Math.imul(tt, Ft) | 0, R = R + Math.imul(be, Nt) | 0, v = v + Math.imul(be, Ut) | 0, v = v + Math.imul(Me, Nt) | 0, M = M + Math.imul(Me, Ut) | 0, R = R + Math.imul(xe, $t) | 0, v = v + Math.imul(xe, Gt) | 0, v = v + Math.imul(Pe, $t) | 0, M = M + Math.imul(Pe, Gt) | 0;
      var rl = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (rl >>> 26) | 0, rl &= 67108863, R = Math.imul(z, Dt), v = Math.imul(z, Pt), v = v + Math.imul(J, Dt) | 0, M = Math.imul(J, Pt), R = R + Math.imul(S, Mt) | 0, v = v + Math.imul(S, Ot) | 0, v = v + Math.imul($, Mt) | 0, M = M + Math.imul($, Ot) | 0, R = R + Math.imul(Ve, Bt) | 0, v = v + Math.imul(Ve, Ft) | 0, v = v + Math.imul(k, Bt) | 0, M = M + Math.imul(k, Ft) | 0, R = R + Math.imul(et, Nt) | 0, v = v + Math.imul(et, Ut) | 0, v = v + Math.imul(tt, Nt) | 0, M = M + Math.imul(tt, Ut) | 0, R = R + Math.imul(be, $t) | 0, v = v + Math.imul(be, Gt) | 0, v = v + Math.imul(Me, $t) | 0, M = M + Math.imul(Me, Gt) | 0;
      var nl = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (nl >>> 26) | 0, nl &= 67108863, R = Math.imul(z, Mt), v = Math.imul(z, Ot), v = v + Math.imul(J, Mt) | 0, M = Math.imul(J, Ot), R = R + Math.imul(S, Bt) | 0, v = v + Math.imul(S, Ft) | 0, v = v + Math.imul($, Bt) | 0, M = M + Math.imul($, Ft) | 0, R = R + Math.imul(Ve, Nt) | 0, v = v + Math.imul(Ve, Ut) | 0, v = v + Math.imul(k, Nt) | 0, M = M + Math.imul(k, Ut) | 0, R = R + Math.imul(et, $t) | 0, v = v + Math.imul(et, Gt) | 0, v = v + Math.imul(tt, $t) | 0, M = M + Math.imul(tt, Gt) | 0;
      var sl = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (sl >>> 26) | 0, sl &= 67108863, R = Math.imul(z, Bt), v = Math.imul(z, Ft), v = v + Math.imul(J, Bt) | 0, M = Math.imul(J, Ft), R = R + Math.imul(S, Nt) | 0, v = v + Math.imul(S, Ut) | 0, v = v + Math.imul($, Nt) | 0, M = M + Math.imul($, Ut) | 0, R = R + Math.imul(Ve, $t) | 0, v = v + Math.imul(Ve, Gt) | 0, v = v + Math.imul(k, $t) | 0, M = M + Math.imul(k, Gt) | 0;
      var il = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (il >>> 26) | 0, il &= 67108863, R = Math.imul(z, Nt), v = Math.imul(z, Ut), v = v + Math.imul(J, Nt) | 0, M = Math.imul(J, Ut), R = R + Math.imul(S, $t) | 0, v = v + Math.imul(S, Gt) | 0, v = v + Math.imul($, $t) | 0, M = M + Math.imul($, Gt) | 0;
      var ol = (N + R | 0) + ((v & 8191) << 13) | 0;
      N = (M + (v >>> 13) | 0) + (ol >>> 26) | 0, ol &= 67108863, R = Math.imul(z, $t), v = Math.imul(z, Gt), v = v + Math.imul(J, $t) | 0, M = Math.imul(J, Gt);
      var al = (N + R | 0) + ((v & 8191) << 13) | 0;
      return N = (M + (v >>> 13) | 0) + (al >>> 26) | 0, al &= 67108863, O[0] = Va, O[1] = Ka, O[2] = Ha, O[3] = Wa, O[4] = qa, O[5] = za, O[6] = Ya, O[7] = Za, O[8] = Xa, O[9] = Ja, O[10] = Qa, O[11] = el, O[12] = tl, O[13] = rl, O[14] = nl, O[15] = sl, O[16] = il, O[17] = ol, O[18] = al, N !== 0 && (O[19] = N, w.length++), w;
    };
    Math.imul || (C = b);
    function A(L, g, x) {
      x.negative = g.negative ^ L.negative, x.length = L.length + g.length;
      for (var w = 0, _ = 0, D = 0; D < x.length - 1; D++) {
        var O = _;
        _ = 0;
        for (var N = w & 67108863, R = Math.min(D, g.length - 1), v = Math.max(0, D - L.length + 1); v <= R; v++) {
          var M = D - v, te = L.words[M] | 0, ee = g.words[v] | 0, ne = te * ee, Ce = ne & 67108863;
          O = O + (ne / 67108864 | 0) | 0, Ce = Ce + N | 0, N = Ce & 67108863, O = O + (Ce >>> 26) | 0, _ += O >>> 26, O &= 67108863;
        }
        x.words[D] = N, w = O, O = _;
      }
      return w !== 0 ? x.words[D] = w : x.length--, x._strip();
    }
    function P(L, g, x) {
      return A(L, g, x);
    }
    i.prototype.mulTo = function(g, x) {
      var w, _ = this.length + g.length;
      return this.length === 10 && g.length === 10 ? w = C(this, g, x) : _ < 63 ? w = b(this, g, x) : _ < 1024 ? w = A(this, g, x) : w = P(this, g, x), w;
    }, i.prototype.mul = function(g) {
      var x = new i(null);
      return x.words = new Array(this.length + g.length), this.mulTo(g, x);
    }, i.prototype.mulf = function(g) {
      var x = new i(null);
      return x.words = new Array(this.length + g.length), P(this, g, x);
    }, i.prototype.imul = function(g) {
      return this.clone().mulTo(g, this);
    }, i.prototype.imuln = function(g) {
      var x = g < 0;
      x && (g = -g), r(typeof g == "number"), r(g < 67108864);
      for (var w = 0, _ = 0; _ < this.length; _++) {
        var D = (this.words[_] | 0) * g, O = (D & 67108863) + (w & 67108863);
        w >>= 26, w += D / 67108864 | 0, w += O >>> 26, this.words[_] = O & 67108863;
      }
      return w !== 0 && (this.words[_] = w, this.length++), this.length = g === 0 ? 1 : this.length, x ? this.ineg() : this;
    }, i.prototype.muln = function(g) {
      return this.clone().imuln(g);
    }, i.prototype.sqr = function() {
      return this.mul(this);
    }, i.prototype.isqr = function() {
      return this.imul(this.clone());
    }, i.prototype.pow = function(g) {
      var x = m(g);
      if (x.length === 0) return new i(1);
      for (var w = this, _ = 0; _ < x.length && x[_] === 0; _++, w = w.sqr())
        ;
      if (++_ < x.length)
        for (var D = w.sqr(); _ < x.length; _++, D = D.sqr())
          x[_] !== 0 && (w = w.mul(D));
      return w;
    }, i.prototype.iushln = function(g) {
      r(typeof g == "number" && g >= 0);
      var x = g % 26, w = (g - x) / 26, _ = 67108863 >>> 26 - x << 26 - x, D;
      if (x !== 0) {
        var O = 0;
        for (D = 0; D < this.length; D++) {
          var N = this.words[D] & _, R = (this.words[D] | 0) - N << x;
          this.words[D] = R | O, O = N >>> 26 - x;
        }
        O && (this.words[D] = O, this.length++);
      }
      if (w !== 0) {
        for (D = this.length - 1; D >= 0; D--)
          this.words[D + w] = this.words[D];
        for (D = 0; D < w; D++)
          this.words[D] = 0;
        this.length += w;
      }
      return this._strip();
    }, i.prototype.ishln = function(g) {
      return r(this.negative === 0), this.iushln(g);
    }, i.prototype.iushrn = function(g, x, w) {
      r(typeof g == "number" && g >= 0);
      var _;
      x ? _ = (x - x % 26) / 26 : _ = 0;
      var D = g % 26, O = Math.min((g - D) / 26, this.length), N = 67108863 ^ 67108863 >>> D << D, R = w;
      if (_ -= O, _ = Math.max(0, _), R) {
        for (var v = 0; v < O; v++)
          R.words[v] = this.words[v];
        R.length = O;
      }
      if (O !== 0) if (this.length > O)
        for (this.length -= O, v = 0; v < this.length; v++)
          this.words[v] = this.words[v + O];
      else
        this.words[0] = 0, this.length = 1;
      var M = 0;
      for (v = this.length - 1; v >= 0 && (M !== 0 || v >= _); v--) {
        var te = this.words[v] | 0;
        this.words[v] = M << 26 - D | te >>> D, M = te & N;
      }
      return R && M !== 0 && (R.words[R.length++] = M), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, i.prototype.ishrn = function(g, x, w) {
      return r(this.negative === 0), this.iushrn(g, x, w);
    }, i.prototype.shln = function(g) {
      return this.clone().ishln(g);
    }, i.prototype.ushln = function(g) {
      return this.clone().iushln(g);
    }, i.prototype.shrn = function(g) {
      return this.clone().ishrn(g);
    }, i.prototype.ushrn = function(g) {
      return this.clone().iushrn(g);
    }, i.prototype.testn = function(g) {
      r(typeof g == "number" && g >= 0);
      var x = g % 26, w = (g - x) / 26, _ = 1 << x;
      if (this.length <= w) return !1;
      var D = this.words[w];
      return !!(D & _);
    }, i.prototype.imaskn = function(g) {
      r(typeof g == "number" && g >= 0);
      var x = g % 26, w = (g - x) / 26;
      if (r(this.negative === 0, "imaskn works only with positive numbers"), this.length <= w)
        return this;
      if (x !== 0 && w++, this.length = Math.min(w, this.length), x !== 0) {
        var _ = 67108863 ^ 67108863 >>> x << x;
        this.words[this.length - 1] &= _;
      }
      return this._strip();
    }, i.prototype.maskn = function(g) {
      return this.clone().imaskn(g);
    }, i.prototype.iaddn = function(g) {
      return r(typeof g == "number"), r(g < 67108864), g < 0 ? this.isubn(-g) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= g ? (this.words[0] = g - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(g), this.negative = 1, this) : this._iaddn(g);
    }, i.prototype._iaddn = function(g) {
      this.words[0] += g;
      for (var x = 0; x < this.length && this.words[x] >= 67108864; x++)
        this.words[x] -= 67108864, x === this.length - 1 ? this.words[x + 1] = 1 : this.words[x + 1]++;
      return this.length = Math.max(this.length, x + 1), this;
    }, i.prototype.isubn = function(g) {
      if (r(typeof g == "number"), r(g < 67108864), g < 0) return this.iaddn(-g);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(g), this.negative = 1, this;
      if (this.words[0] -= g, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var x = 0; x < this.length && this.words[x] < 0; x++)
          this.words[x] += 67108864, this.words[x + 1] -= 1;
      return this._strip();
    }, i.prototype.addn = function(g) {
      return this.clone().iaddn(g);
    }, i.prototype.subn = function(g) {
      return this.clone().isubn(g);
    }, i.prototype.iabs = function() {
      return this.negative = 0, this;
    }, i.prototype.abs = function() {
      return this.clone().iabs();
    }, i.prototype._ishlnsubmul = function(g, x, w) {
      var _ = g.length + w, D;
      this._expand(_);
      var O, N = 0;
      for (D = 0; D < g.length; D++) {
        O = (this.words[D + w] | 0) + N;
        var R = (g.words[D] | 0) * x;
        O -= R & 67108863, N = (O >> 26) - (R / 67108864 | 0), this.words[D + w] = O & 67108863;
      }
      for (; D < this.length - w; D++)
        O = (this.words[D + w] | 0) + N, N = O >> 26, this.words[D + w] = O & 67108863;
      if (N === 0) return this._strip();
      for (r(N === -1), N = 0, D = 0; D < this.length; D++)
        O = -(this.words[D] | 0) + N, N = O >> 26, this.words[D] = O & 67108863;
      return this.negative = 1, this._strip();
    }, i.prototype._wordDiv = function(g, x) {
      var w = this.length - g.length, _ = this.clone(), D = g, O = D.words[D.length - 1] | 0, N = this._countBits(O);
      w = 26 - N, w !== 0 && (D = D.ushln(w), _.iushln(w), O = D.words[D.length - 1] | 0);
      var R = _.length - D.length, v;
      if (x !== "mod") {
        v = new i(null), v.length = R + 1, v.words = new Array(v.length);
        for (var M = 0; M < v.length; M++)
          v.words[M] = 0;
      }
      var te = _.clone()._ishlnsubmul(D, 1, R);
      te.negative === 0 && (_ = te, v && (v.words[R] = 1));
      for (var ee = R - 1; ee >= 0; ee--) {
        var ne = (_.words[D.length + ee] | 0) * 67108864 + (_.words[D.length + ee - 1] | 0);
        for (ne = Math.min(ne / O | 0, 67108863), _._ishlnsubmul(D, ne, ee); _.negative !== 0; )
          ne--, _.negative = 0, _._ishlnsubmul(D, 1, ee), _.isZero() || (_.negative ^= 1);
        v && (v.words[ee] = ne);
      }
      return v && v._strip(), _._strip(), x !== "div" && w !== 0 && _.iushrn(w), {
        div: v || null,
        mod: _
      };
    }, i.prototype.divmod = function(g, x, w) {
      if (r(!g.isZero()), this.isZero())
        return {
          div: new i(0),
          mod: new i(0)
        };
      var _, D, O;
      return this.negative !== 0 && g.negative === 0 ? (O = this.neg().divmod(g, x), x !== "mod" && (_ = O.div.neg()), x !== "div" && (D = O.mod.neg(), w && D.negative !== 0 && D.iadd(g)), {
        div: _,
        mod: D
      }) : this.negative === 0 && g.negative !== 0 ? (O = this.divmod(g.neg(), x), x !== "mod" && (_ = O.div.neg()), {
        div: _,
        mod: O.mod
      }) : this.negative & g.negative ? (O = this.neg().divmod(g.neg(), x), x !== "div" && (D = O.mod.neg(), w && D.negative !== 0 && D.isub(g)), {
        div: O.div,
        mod: D
      }) : g.length > this.length || this.cmp(g) < 0 ? {
        div: new i(0),
        mod: this
      } : g.length === 1 ? x === "div" ? {
        div: this.divn(g.words[0]),
        mod: null
      } : x === "mod" ? {
        div: null,
        mod: new i(this.modrn(g.words[0]))
      } : {
        div: this.divn(g.words[0]),
        mod: new i(this.modrn(g.words[0]))
      } : this._wordDiv(g, x);
    }, i.prototype.div = function(g) {
      return this.divmod(g, "div", !1).div;
    }, i.prototype.mod = function(g) {
      return this.divmod(g, "mod", !1).mod;
    }, i.prototype.umod = function(g) {
      return this.divmod(g, "mod", !0).mod;
    }, i.prototype.divRound = function(g) {
      var x = this.divmod(g);
      if (x.mod.isZero()) return x.div;
      var w = x.div.negative !== 0 ? x.mod.isub(g) : x.mod, _ = g.ushrn(1), D = g.andln(1), O = w.cmp(_);
      return O < 0 || D === 1 && O === 0 ? x.div : x.div.negative !== 0 ? x.div.isubn(1) : x.div.iaddn(1);
    }, i.prototype.modrn = function(g) {
      var x = g < 0;
      x && (g = -g), r(g <= 67108863);
      for (var w = (1 << 26) % g, _ = 0, D = this.length - 1; D >= 0; D--)
        _ = (w * _ + (this.words[D] | 0)) % g;
      return x ? -_ : _;
    }, i.prototype.modn = function(g) {
      return this.modrn(g);
    }, i.prototype.idivn = function(g) {
      var x = g < 0;
      x && (g = -g), r(g <= 67108863);
      for (var w = 0, _ = this.length - 1; _ >= 0; _--) {
        var D = (this.words[_] | 0) + w * 67108864;
        this.words[_] = D / g | 0, w = D % g;
      }
      return this._strip(), x ? this.ineg() : this;
    }, i.prototype.divn = function(g) {
      return this.clone().idivn(g);
    }, i.prototype.egcd = function(g) {
      r(g.negative === 0), r(!g.isZero());
      var x = this, w = g.clone();
      x.negative !== 0 ? x = x.umod(g) : x = x.clone();
      for (var _ = new i(1), D = new i(0), O = new i(0), N = new i(1), R = 0; x.isEven() && w.isEven(); )
        x.iushrn(1), w.iushrn(1), ++R;
      for (var v = w.clone(), M = x.clone(); !x.isZero(); ) {
        for (var te = 0, ee = 1; !(x.words[0] & ee) && te < 26; ++te, ee <<= 1) ;
        if (te > 0)
          for (x.iushrn(te); te-- > 0; )
            (_.isOdd() || D.isOdd()) && (_.iadd(v), D.isub(M)), _.iushrn(1), D.iushrn(1);
        for (var ne = 0, Ce = 1; !(w.words[0] & Ce) && ne < 26; ++ne, Ce <<= 1) ;
        if (ne > 0)
          for (w.iushrn(ne); ne-- > 0; )
            (O.isOdd() || N.isOdd()) && (O.iadd(v), N.isub(M)), O.iushrn(1), N.iushrn(1);
        x.cmp(w) >= 0 ? (x.isub(w), _.isub(O), D.isub(N)) : (w.isub(x), O.isub(_), N.isub(D));
      }
      return {
        a: O,
        b: N,
        gcd: w.iushln(R)
      };
    }, i.prototype._invmp = function(g) {
      r(g.negative === 0), r(!g.isZero());
      var x = this, w = g.clone();
      x.negative !== 0 ? x = x.umod(g) : x = x.clone();
      for (var _ = new i(1), D = new i(0), O = w.clone(); x.cmpn(1) > 0 && w.cmpn(1) > 0; ) {
        for (var N = 0, R = 1; !(x.words[0] & R) && N < 26; ++N, R <<= 1) ;
        if (N > 0)
          for (x.iushrn(N); N-- > 0; )
            _.isOdd() && _.iadd(O), _.iushrn(1);
        for (var v = 0, M = 1; !(w.words[0] & M) && v < 26; ++v, M <<= 1) ;
        if (v > 0)
          for (w.iushrn(v); v-- > 0; )
            D.isOdd() && D.iadd(O), D.iushrn(1);
        x.cmp(w) >= 0 ? (x.isub(w), _.isub(D)) : (w.isub(x), D.isub(_));
      }
      var te;
      return x.cmpn(1) === 0 ? te = _ : te = D, te.cmpn(0) < 0 && te.iadd(g), te;
    }, i.prototype.gcd = function(g) {
      if (this.isZero()) return g.abs();
      if (g.isZero()) return this.abs();
      var x = this.clone(), w = g.clone();
      x.negative = 0, w.negative = 0;
      for (var _ = 0; x.isEven() && w.isEven(); _++)
        x.iushrn(1), w.iushrn(1);
      do {
        for (; x.isEven(); )
          x.iushrn(1);
        for (; w.isEven(); )
          w.iushrn(1);
        var D = x.cmp(w);
        if (D < 0) {
          var O = x;
          x = w, w = O;
        } else if (D === 0 || w.cmpn(1) === 0)
          break;
        x.isub(w);
      } while (!0);
      return w.iushln(_);
    }, i.prototype.invm = function(g) {
      return this.egcd(g).a.umod(g);
    }, i.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, i.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, i.prototype.andln = function(g) {
      return this.words[0] & g;
    }, i.prototype.bincn = function(g) {
      r(typeof g == "number");
      var x = g % 26, w = (g - x) / 26, _ = 1 << x;
      if (this.length <= w)
        return this._expand(w + 1), this.words[w] |= _, this;
      for (var D = _, O = w; D !== 0 && O < this.length; O++) {
        var N = this.words[O] | 0;
        N += D, D = N >>> 26, N &= 67108863, this.words[O] = N;
      }
      return D !== 0 && (this.words[O] = D, this.length++), this;
    }, i.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, i.prototype.cmpn = function(g) {
      var x = g < 0;
      if (this.negative !== 0 && !x) return -1;
      if (this.negative === 0 && x) return 1;
      this._strip();
      var w;
      if (this.length > 1)
        w = 1;
      else {
        x && (g = -g), r(g <= 67108863, "Number is too big");
        var _ = this.words[0] | 0;
        w = _ === g ? 0 : _ < g ? -1 : 1;
      }
      return this.negative !== 0 ? -w | 0 : w;
    }, i.prototype.cmp = function(g) {
      if (this.negative !== 0 && g.negative === 0) return -1;
      if (this.negative === 0 && g.negative !== 0) return 1;
      var x = this.ucmp(g);
      return this.negative !== 0 ? -x | 0 : x;
    }, i.prototype.ucmp = function(g) {
      if (this.length > g.length) return 1;
      if (this.length < g.length) return -1;
      for (var x = 0, w = this.length - 1; w >= 0; w--) {
        var _ = this.words[w] | 0, D = g.words[w] | 0;
        if (_ !== D) {
          _ < D ? x = -1 : _ > D && (x = 1);
          break;
        }
      }
      return x;
    }, i.prototype.gtn = function(g) {
      return this.cmpn(g) === 1;
    }, i.prototype.gt = function(g) {
      return this.cmp(g) === 1;
    }, i.prototype.gten = function(g) {
      return this.cmpn(g) >= 0;
    }, i.prototype.gte = function(g) {
      return this.cmp(g) >= 0;
    }, i.prototype.ltn = function(g) {
      return this.cmpn(g) === -1;
    }, i.prototype.lt = function(g) {
      return this.cmp(g) === -1;
    }, i.prototype.lten = function(g) {
      return this.cmpn(g) <= 0;
    }, i.prototype.lte = function(g) {
      return this.cmp(g) <= 0;
    }, i.prototype.eqn = function(g) {
      return this.cmpn(g) === 0;
    }, i.prototype.eq = function(g) {
      return this.cmp(g) === 0;
    }, i.red = function(g) {
      return new V(g);
    }, i.prototype.toRed = function(g) {
      return r(!this.red, "Already a number in reduction context"), r(this.negative === 0, "red works only with positives"), g.convertTo(this)._forceRed(g);
    }, i.prototype.fromRed = function() {
      return r(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, i.prototype._forceRed = function(g) {
      return this.red = g, this;
    }, i.prototype.forceRed = function(g) {
      return r(!this.red, "Already a number in reduction context"), this._forceRed(g);
    }, i.prototype.redAdd = function(g) {
      return r(this.red, "redAdd works only with red numbers"), this.red.add(this, g);
    }, i.prototype.redIAdd = function(g) {
      return r(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, g);
    }, i.prototype.redSub = function(g) {
      return r(this.red, "redSub works only with red numbers"), this.red.sub(this, g);
    }, i.prototype.redISub = function(g) {
      return r(this.red, "redISub works only with red numbers"), this.red.isub(this, g);
    }, i.prototype.redShl = function(g) {
      return r(this.red, "redShl works only with red numbers"), this.red.shl(this, g);
    }, i.prototype.redMul = function(g) {
      return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, g), this.red.mul(this, g);
    }, i.prototype.redIMul = function(g) {
      return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, g), this.red.imul(this, g);
    }, i.prototype.redSqr = function() {
      return r(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, i.prototype.redISqr = function() {
      return r(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, i.prototype.redSqrt = function() {
      return r(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, i.prototype.redInvm = function() {
      return r(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, i.prototype.redNeg = function() {
      return r(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, i.prototype.redPow = function(g) {
      return r(this.red && !g.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, g);
    };
    var I = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function U(L, g) {
      this.name = L, this.p = new i(g, 16), this.n = this.p.bitLength(), this.k = new i(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    U.prototype._tmp = function() {
      var g = new i(null);
      return g.words = new Array(Math.ceil(this.n / 13)), g;
    }, U.prototype.ireduce = function(g) {
      var x = g, w;
      do
        this.split(x, this.tmp), x = this.imulK(x), x = x.iadd(this.tmp), w = x.bitLength();
      while (w > this.n);
      var _ = w < this.n ? -1 : x.ucmp(this.p);
      return _ === 0 ? (x.words[0] = 0, x.length = 1) : _ > 0 ? x.isub(this.p) : x.strip !== void 0 ? x.strip() : x._strip(), x;
    }, U.prototype.split = function(g, x) {
      g.iushrn(this.n, 0, x);
    }, U.prototype.imulK = function(g) {
      return g.imul(this.k);
    };
    function j() {
      U.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    s(j, U), j.prototype.split = function(g, x) {
      for (var w = 4194303, _ = Math.min(g.length, 9), D = 0; D < _; D++)
        x.words[D] = g.words[D];
      if (x.length = _, g.length <= 9) {
        g.words[0] = 0, g.length = 1;
        return;
      }
      var O = g.words[9];
      for (x.words[x.length++] = O & w, D = 10; D < g.length; D++) {
        var N = g.words[D] | 0;
        g.words[D - 10] = (N & w) << 4 | O >>> 22, O = N;
      }
      O >>>= 22, g.words[D - 10] = O, O === 0 && g.length > 10 ? g.length -= 10 : g.length -= 9;
    }, j.prototype.imulK = function(g) {
      g.words[g.length] = 0, g.words[g.length + 1] = 0, g.length += 2;
      for (var x = 0, w = 0; w < g.length; w++) {
        var _ = g.words[w] | 0;
        x += _ * 977, g.words[w] = x & 67108863, x = _ * 64 + (x / 67108864 | 0);
      }
      return g.words[g.length - 1] === 0 && (g.length--, g.words[g.length - 1] === 0 && g.length--), g;
    };
    function G() {
      U.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    s(G, U);
    function F() {
      U.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    s(F, U);
    function B() {
      U.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    s(B, U), B.prototype.imulK = function(g) {
      for (var x = 0, w = 0; w < g.length; w++) {
        var _ = (g.words[w] | 0) * 19 + x, D = _ & 67108863;
        _ >>>= 26, g.words[w] = D, x = _;
      }
      return x !== 0 && (g.words[g.length++] = x), g;
    }, i._prime = function(g) {
      if (I[g]) return I[g];
      var x;
      if (g === "k256")
        x = new j();
      else if (g === "p224")
        x = new G();
      else if (g === "p192")
        x = new F();
      else if (g === "p25519")
        x = new B();
      else
        throw new Error("Unknown prime " + g);
      return I[g] = x, x;
    };
    function V(L) {
      if (typeof L == "string") {
        var g = i._prime(L);
        this.m = g.p, this.prime = g;
      } else
        r(L.gtn(1), "modulus must be greater than 1"), this.m = L, this.prime = null;
    }
    V.prototype._verify1 = function(g) {
      r(g.negative === 0, "red works only with positives"), r(g.red, "red works only with red numbers");
    }, V.prototype._verify2 = function(g, x) {
      r((g.negative | x.negative) === 0, "red works only with positives"), r(
        g.red && g.red === x.red,
        "red works only with red numbers"
      );
    }, V.prototype.imod = function(g) {
      return this.prime ? this.prime.ireduce(g)._forceRed(this) : (u(g, g.umod(this.m)._forceRed(this)), g);
    }, V.prototype.neg = function(g) {
      return g.isZero() ? g.clone() : this.m.sub(g)._forceRed(this);
    }, V.prototype.add = function(g, x) {
      this._verify2(g, x);
      var w = g.add(x);
      return w.cmp(this.m) >= 0 && w.isub(this.m), w._forceRed(this);
    }, V.prototype.iadd = function(g, x) {
      this._verify2(g, x);
      var w = g.iadd(x);
      return w.cmp(this.m) >= 0 && w.isub(this.m), w;
    }, V.prototype.sub = function(g, x) {
      this._verify2(g, x);
      var w = g.sub(x);
      return w.cmpn(0) < 0 && w.iadd(this.m), w._forceRed(this);
    }, V.prototype.isub = function(g, x) {
      this._verify2(g, x);
      var w = g.isub(x);
      return w.cmpn(0) < 0 && w.iadd(this.m), w;
    }, V.prototype.shl = function(g, x) {
      return this._verify1(g), this.imod(g.ushln(x));
    }, V.prototype.imul = function(g, x) {
      return this._verify2(g, x), this.imod(g.imul(x));
    }, V.prototype.mul = function(g, x) {
      return this._verify2(g, x), this.imod(g.mul(x));
    }, V.prototype.isqr = function(g) {
      return this.imul(g, g.clone());
    }, V.prototype.sqr = function(g) {
      return this.mul(g, g);
    }, V.prototype.sqrt = function(g) {
      if (g.isZero()) return g.clone();
      var x = this.m.andln(3);
      if (r(x % 2 === 1), x === 3) {
        var w = this.m.add(new i(1)).iushrn(2);
        return this.pow(g, w);
      }
      for (var _ = this.m.subn(1), D = 0; !_.isZero() && _.andln(1) === 0; )
        D++, _.iushrn(1);
      r(!_.isZero());
      var O = new i(1).toRed(this), N = O.redNeg(), R = this.m.subn(1).iushrn(1), v = this.m.bitLength();
      for (v = new i(2 * v * v).toRed(this); this.pow(v, R).cmp(N) !== 0; )
        v.redIAdd(N);
      for (var M = this.pow(v, _), te = this.pow(g, _.addn(1).iushrn(1)), ee = this.pow(g, _), ne = D; ee.cmp(O) !== 0; ) {
        for (var Ce = ee, ve = 0; Ce.cmp(O) !== 0; ve++)
          Ce = Ce.redSqr();
        r(ve < ne);
        var Ae = this.pow(M, new i(1).iushln(ne - ve - 1));
        te = te.redMul(Ae), M = Ae.redSqr(), ee = ee.redMul(M), ne = ve;
      }
      return te;
    }, V.prototype.invm = function(g) {
      var x = g._invmp(this.m);
      return x.negative !== 0 ? (x.negative = 0, this.imod(x).redNeg()) : this.imod(x);
    }, V.prototype.pow = function(g, x) {
      if (x.isZero()) return new i(1).toRed(this);
      if (x.cmpn(1) === 0) return g.clone();
      var w = 4, _ = new Array(1 << w);
      _[0] = new i(1).toRed(this), _[1] = g;
      for (var D = 2; D < _.length; D++)
        _[D] = this.mul(_[D - 1], g);
      var O = _[0], N = 0, R = 0, v = x.bitLength() % 26;
      for (v === 0 && (v = 26), D = x.length - 1; D >= 0; D--) {
        for (var M = x.words[D], te = v - 1; te >= 0; te--) {
          var ee = M >> te & 1;
          if (O !== _[0] && (O = this.sqr(O)), ee === 0 && N === 0) {
            R = 0;
            continue;
          }
          N <<= 1, N |= ee, R++, !(R !== w && (D !== 0 || te !== 0)) && (O = this.mul(O, _[N]), R = 0, N = 0);
        }
        v = 26;
      }
      return O;
    }, V.prototype.convertTo = function(g) {
      var x = g.umod(this.m);
      return x === g ? x.clone() : x;
    }, V.prototype.convertFrom = function(g) {
      var x = g.clone();
      return x.red = null, x;
    }, i.mont = function(g) {
      return new H(g);
    };
    function H(L) {
      V.call(this, L), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new i(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    s(H, V), H.prototype.convertTo = function(g) {
      return this.imod(g.ushln(this.shift));
    }, H.prototype.convertFrom = function(g) {
      var x = this.imod(g.mul(this.rinv));
      return x.red = null, x;
    }, H.prototype.imul = function(g, x) {
      if (g.isZero() || x.isZero())
        return g.words[0] = 0, g.length = 1, g;
      var w = g.imul(x), _ = w.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), D = w.isub(_).iushrn(this.shift), O = D;
      return D.cmp(this.m) >= 0 ? O = D.isub(this.m) : D.cmpn(0) < 0 && (O = D.iadd(this.m)), O._forceRed(this);
    }, H.prototype.mul = function(g, x) {
      if (g.isZero() || x.isZero()) return new i(0)._forceRed(this);
      var w = g.mul(x), _ = w.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), D = w.isub(_).iushrn(this.shift), O = D;
      return D.cmp(this.m) >= 0 ? O = D.isub(this.m) : D.cmpn(0) < 0 && (O = D.iadd(this.m)), O._forceRed(this);
    }, H.prototype.invm = function(g) {
      var x = this.imod(g._invmp(this.m).mul(this.r2));
      return x._forceRed(this);
    };
  })(n, Hr);
})(uu);
var d0 = uu.exports;
const Md = /* @__PURE__ */ Zc(d0);
var fc = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(n, e) {
  var t = $e, r = t.Buffer;
  function s(o, a) {
    for (var l in o)
      a[l] = o[l];
  }
  r.from && r.alloc && r.allocUnsafe && r.allocUnsafeSlow ? n.exports = t : (s(t, e), e.Buffer = i);
  function i(o, a, l) {
    return r(o, a, l);
  }
  i.prototype = Object.create(r.prototype), s(r, i), i.from = function(o, a, l) {
    if (typeof o == "number")
      throw new TypeError("Argument must not be a number");
    return r(o, a, l);
  }, i.alloc = function(o, a, l) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    var c = r(o);
    return a !== void 0 ? typeof l == "string" ? c.fill(a, l) : c.fill(a) : c.fill(0), c;
  }, i.allocUnsafe = function(o) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    return r(o);
  }, i.allocUnsafeSlow = function(o) {
    if (typeof o != "number")
      throw new TypeError("Argument must be a number");
    return t.SlowBuffer(o);
  };
})(fc, fc.exports);
var jy = fc.exports, no = jy.Buffer;
function Vy(n) {
  if (n.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var e = new Uint8Array(256), t = 0; t < e.length; t++)
    e[t] = 255;
  for (var r = 0; r < n.length; r++) {
    var s = n.charAt(r), i = s.charCodeAt(0);
    if (e[i] !== 255)
      throw new TypeError(s + " is ambiguous");
    e[i] = r;
  }
  var o = n.length, a = n.charAt(0), l = Math.log(o) / Math.log(256), c = Math.log(256) / Math.log(o);
  function u(f) {
    if ((Array.isArray(f) || f instanceof Uint8Array) && (f = no.from(f)), !no.isBuffer(f))
      throw new TypeError("Expected Buffer");
    if (f.length === 0)
      return "";
    for (var p = 0, y = 0, m = 0, b = f.length; m !== b && f[m] === 0; )
      m++, p++;
    for (var C = (b - m) * c + 1 >>> 0, A = new Uint8Array(C); m !== b; ) {
      for (var P = f[m], I = 0, U = C - 1; (P !== 0 || I < y) && U !== -1; U--, I++)
        P += 256 * A[U] >>> 0, A[U] = P % o >>> 0, P = P / o >>> 0;
      if (P !== 0)
        throw new Error("Non-zero carry");
      y = I, m++;
    }
    for (var j = C - y; j !== C && A[j] === 0; )
      j++;
    for (var G = a.repeat(p); j < C; ++j)
      G += n.charAt(A[j]);
    return G;
  }
  function d(f) {
    if (typeof f != "string")
      throw new TypeError("Expected String");
    if (f.length === 0)
      return no.alloc(0);
    for (var p = 0, y = 0, m = 0; f[p] === a; )
      y++, p++;
    for (var b = (f.length - p) * l + 1 >>> 0, C = new Uint8Array(b); p < f.length; ) {
      var A = f.charCodeAt(p);
      if (A > 255)
        return;
      var P = e[A];
      if (P === 255)
        return;
      for (var I = 0, U = b - 1; (P !== 0 || I < m) && U !== -1; U--, I++)
        P += o * C[U] >>> 0, C[U] = P % 256 >>> 0, P = P / 256 >>> 0;
      if (P !== 0)
        throw new Error("Non-zero carry");
      m = I, p++;
    }
    for (var j = b - m; j !== b && C[j] === 0; )
      j++;
    var G = no.allocUnsafe(y + (b - j));
    G.fill(0, 0, y);
    for (var F = y; j !== b; )
      G[F++] = C[j++];
    return G;
  }
  function h(f) {
    var p = d(f);
    if (p)
      return p;
    throw new Error("Non-base" + o + " character");
  }
  return {
    encode: u,
    decodeUnsafe: d,
    decode: h
  };
}
var h0 = Vy, Ky = h0, Hy = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", Wy = Ky(Hy);
const hr = /* @__PURE__ */ Zc(Wy), Od = Zf;
var er = {}, qy = h0, zy = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", Yy = qy(zy);
function Tn(n, e, t) {
  return e <= n && n <= t;
}
function ka(n) {
  if (n === void 0) return {};
  if (n === Object(n)) return n;
  throw TypeError("Could not convert argument to dictionary");
}
function Zy(n) {
  for (var e = String(n), t = e.length, r = 0, s = []; r < t; ) {
    var i = e.charCodeAt(r);
    if (i < 55296 || i > 57343)
      s.push(i);
    else if (56320 <= i && i <= 57343)
      s.push(65533);
    else if (55296 <= i && i <= 56319)
      if (r === t - 1)
        s.push(65533);
      else {
        var o = n.charCodeAt(r + 1);
        if (56320 <= o && o <= 57343) {
          var a = i & 1023, l = o & 1023;
          s.push(65536 + (a << 10) + l), r += 1;
        } else
          s.push(65533);
      }
    r += 1;
  }
  return s;
}
function Xy(n) {
  for (var e = "", t = 0; t < n.length; ++t) {
    var r = n[t];
    r <= 65535 ? e += String.fromCharCode(r) : (r -= 65536, e += String.fromCharCode(
      (r >> 10) + 55296,
      (r & 1023) + 56320
    ));
  }
  return e;
}
var Zo = -1;
function du(n) {
  this.tokens = [].slice.call(n);
}
du.prototype = {
  /**
   * @return {boolean} True if end-of-stream has been hit.
   */
  endOfStream: function() {
    return !this.tokens.length;
  },
  /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */
  read: function() {
    return this.tokens.length ? this.tokens.shift() : Zo;
  },
  /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */
  prepend: function(n) {
    if (Array.isArray(n))
      for (var e = (
        /**@type {!Array.<number>}*/
        n
      ); e.length; )
        this.tokens.unshift(e.pop());
    else
      this.tokens.unshift(n);
  },
  /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */
  push: function(n) {
    if (Array.isArray(n))
      for (var e = (
        /**@type {!Array.<number>}*/
        n
      ); e.length; )
        this.tokens.push(e.shift());
    else
      this.tokens.push(n);
  }
};
var Ys = -1;
function ml(n, e) {
  if (n)
    throw TypeError("Decoder error");
  return e || 65533;
}
var Xo = "utf-8";
function Jo(n, e) {
  if (!(this instanceof Jo))
    return new Jo(n, e);
  if (n = n !== void 0 ? String(n).toLowerCase() : Xo, n !== Xo)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  e = ka(e), this._streaming = !1, this._BOMseen = !1, this._decoder = null, this._fatal = !!e.fatal, this._ignoreBOM = !!e.ignoreBOM, Object.defineProperty(this, "encoding", { value: "utf-8" }), Object.defineProperty(this, "fatal", { value: this._fatal }), Object.defineProperty(this, "ignoreBOM", { value: this._ignoreBOM });
}
Jo.prototype = {
  /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */
  decode: function(e, t) {
    var r;
    typeof e == "object" && e instanceof ArrayBuffer ? r = new Uint8Array(e) : typeof e == "object" && "buffer" in e && e.buffer instanceof ArrayBuffer ? r = new Uint8Array(
      e.buffer,
      e.byteOffset,
      e.byteLength
    ) : r = new Uint8Array(0), t = ka(t), this._streaming || (this._decoder = new Jy({ fatal: this._fatal }), this._BOMseen = !1), this._streaming = !!t.stream;
    for (var s = new du(r), i = [], o; !s.endOfStream() && (o = this._decoder.handler(s, s.read()), o !== Ys); )
      o !== null && (Array.isArray(o) ? i.push.apply(
        i,
        /**@type {!Array.<number>}*/
        o
      ) : i.push(o));
    if (!this._streaming) {
      do {
        if (o = this._decoder.handler(s, s.read()), o === Ys)
          break;
        o !== null && (Array.isArray(o) ? i.push.apply(
          i,
          /**@type {!Array.<number>}*/
          o
        ) : i.push(o));
      } while (!s.endOfStream());
      this._decoder = null;
    }
    return i.length && ["utf-8"].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen && (i[0] === 65279 ? (this._BOMseen = !0, i.shift()) : this._BOMseen = !0), Xy(i);
  }
};
function Qo(n, e) {
  if (!(this instanceof Qo))
    return new Qo(n, e);
  if (n = n !== void 0 ? String(n).toLowerCase() : Xo, n !== Xo)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  e = ka(e), this._streaming = !1, this._encoder = null, this._options = { fatal: !!e.fatal }, Object.defineProperty(this, "encoding", { value: "utf-8" });
}
Qo.prototype = {
  /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */
  encode: function(e, t) {
    e = e ? String(e) : "", t = ka(t), this._streaming || (this._encoder = new Qy(this._options)), this._streaming = !!t.stream;
    for (var r = [], s = new du(Zy(e)), i; !s.endOfStream() && (i = this._encoder.handler(s, s.read()), i !== Ys); )
      Array.isArray(i) ? r.push.apply(
        r,
        /**@type {!Array.<number>}*/
        i
      ) : r.push(i);
    if (!this._streaming) {
      for (; i = this._encoder.handler(s, s.read()), i !== Ys; )
        Array.isArray(i) ? r.push.apply(
          r,
          /**@type {!Array.<number>}*/
          i
        ) : r.push(i);
      this._encoder = null;
    }
    return new Uint8Array(r);
  }
};
function Jy(n) {
  var e = n.fatal, t = 0, r = 0, s = 0, i = 128, o = 191;
  this.handler = function(a, l) {
    if (l === Zo && s !== 0)
      return s = 0, ml(e);
    if (l === Zo)
      return Ys;
    if (s === 0) {
      if (Tn(l, 0, 127))
        return l;
      if (Tn(l, 194, 223))
        s = 1, t = l - 192;
      else if (Tn(l, 224, 239))
        l === 224 && (i = 160), l === 237 && (o = 159), s = 2, t = l - 224;
      else if (Tn(l, 240, 244))
        l === 240 && (i = 144), l === 244 && (o = 143), s = 3, t = l - 240;
      else
        return ml(e);
      return t = t << 6 * s, null;
    }
    if (!Tn(l, i, o))
      return t = s = r = 0, i = 128, o = 191, a.prepend(l), ml(e);
    if (i = 128, o = 191, r += 1, t += l - 128 << 6 * (s - r), r !== s)
      return null;
    var c = t;
    return t = s = r = 0, c;
  };
}
function Qy(n) {
  n.fatal, this.handler = function(e, t) {
    if (t === Zo)
      return Ys;
    if (Tn(t, 0, 127))
      return t;
    var r, s;
    Tn(t, 128, 2047) ? (r = 1, s = 192) : Tn(t, 2048, 65535) ? (r = 2, s = 224) : Tn(t, 65536, 1114111) && (r = 3, s = 240);
    for (var i = [(t >> 6 * r) + s]; r > 0; ) {
      var o = t >> 6 * (r - 1);
      i.push(128 | o & 63), r -= 1;
    }
    return i;
  };
}
const ev = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TextDecoder: Jo,
  TextEncoder: Qo
}, Symbol.toStringTag, { value: "Module" })), tv = /* @__PURE__ */ Xc(ev);
var rv = Hr && Hr.__createBinding || (Object.create ? function(n, e, t, r) {
  r === void 0 && (r = t), Object.defineProperty(n, r, { enumerable: !0, get: function() {
    return e[t];
  } });
} : function(n, e, t, r) {
  r === void 0 && (r = t), n[r] = e[t];
}), nv = Hr && Hr.__setModuleDefault || (Object.create ? function(n, e) {
  Object.defineProperty(n, "default", { enumerable: !0, value: e });
} : function(n, e) {
  n.default = e;
}), dn = Hr && Hr.__decorate || function(n, e, t, r) {
  var s = arguments.length, i = s < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, t) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(n, e, t, r);
  else for (var a = n.length - 1; a >= 0; a--) (o = n[a]) && (i = (s < 3 ? o(i) : s > 3 ? o(e, t, i) : o(e, t)) || i);
  return s > 3 && i && Object.defineProperty(e, t, i), i;
}, sv = Hr && Hr.__importStar || function(n) {
  if (n && n.__esModule) return n;
  var e = {};
  if (n != null) for (var t in n) t !== "default" && Object.hasOwnProperty.call(n, t) && rv(e, n, t);
  return nv(e, n), e;
}, f0 = Hr && Hr.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(er, "__esModule", { value: !0 });
var g0 = er.deserializeUnchecked = E0 = er.deserialize = x0 = er.serialize = er.BinaryReader = er.BinaryWriter = er.BorshError = er.baseDecode = er.baseEncode = void 0;
const Kn = f0(d0), p0 = f0(Yy), iv = sv(tv), ov = typeof TextDecoder != "function" ? iv.TextDecoder : TextDecoder, av = new ov("utf-8", { fatal: !0 });
function lv(n) {
  return typeof n == "string" && (n = Buffer.from(n, "utf8")), p0.default.encode(Buffer.from(n));
}
er.baseEncode = lv;
function cv(n) {
  return Buffer.from(p0.default.decode(n));
}
er.baseDecode = cv;
const yl = 1024;
class fr extends Error {
  constructor(e) {
    super(e), this.fieldPath = [], this.originalMessage = e;
  }
  addToFieldPath(e) {
    this.fieldPath.splice(0, 0, e), this.message = this.originalMessage + ": " + this.fieldPath.join(".");
  }
}
er.BorshError = fr;
class m0 {
  constructor() {
    this.buf = Buffer.alloc(yl), this.length = 0;
  }
  maybeResize() {
    this.buf.length < 16 + this.length && (this.buf = Buffer.concat([this.buf, Buffer.alloc(yl)]));
  }
  writeU8(e) {
    this.maybeResize(), this.buf.writeUInt8(e, this.length), this.length += 1;
  }
  writeU16(e) {
    this.maybeResize(), this.buf.writeUInt16LE(e, this.length), this.length += 2;
  }
  writeU32(e) {
    this.maybeResize(), this.buf.writeUInt32LE(e, this.length), this.length += 4;
  }
  writeU64(e) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new Kn.default(e).toArray("le", 8)));
  }
  writeU128(e) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new Kn.default(e).toArray("le", 16)));
  }
  writeU256(e) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new Kn.default(e).toArray("le", 32)));
  }
  writeU512(e) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new Kn.default(e).toArray("le", 64)));
  }
  writeBuffer(e) {
    this.buf = Buffer.concat([
      Buffer.from(this.buf.subarray(0, this.length)),
      e,
      Buffer.alloc(yl)
    ]), this.length += e.length;
  }
  writeString(e) {
    this.maybeResize();
    const t = Buffer.from(e, "utf8");
    this.writeU32(t.length), this.writeBuffer(t);
  }
  writeFixedArray(e) {
    this.writeBuffer(Buffer.from(e));
  }
  writeArray(e, t) {
    this.maybeResize(), this.writeU32(e.length);
    for (const r of e)
      this.maybeResize(), t(r);
  }
  toArray() {
    return this.buf.subarray(0, this.length);
  }
}
er.BinaryWriter = m0;
function hn(n, e, t) {
  const r = t.value;
  t.value = function(...s) {
    try {
      return r.apply(this, s);
    } catch (i) {
      if (i instanceof RangeError) {
        const o = i.code;
        if (["ERR_BUFFER_OUT_OF_BOUNDS", "ERR_OUT_OF_RANGE"].indexOf(o) >= 0)
          throw new fr("Reached the end of buffer when deserializing");
      }
      throw i;
    }
  };
}
class Cr {
  constructor(e) {
    this.buf = e, this.offset = 0;
  }
  readU8() {
    const e = this.buf.readUInt8(this.offset);
    return this.offset += 1, e;
  }
  readU16() {
    const e = this.buf.readUInt16LE(this.offset);
    return this.offset += 2, e;
  }
  readU32() {
    const e = this.buf.readUInt32LE(this.offset);
    return this.offset += 4, e;
  }
  readU64() {
    const e = this.readBuffer(8);
    return new Kn.default(e, "le");
  }
  readU128() {
    const e = this.readBuffer(16);
    return new Kn.default(e, "le");
  }
  readU256() {
    const e = this.readBuffer(32);
    return new Kn.default(e, "le");
  }
  readU512() {
    const e = this.readBuffer(64);
    return new Kn.default(e, "le");
  }
  readBuffer(e) {
    if (this.offset + e > this.buf.length)
      throw new fr(`Expected buffer length ${e} isn't within bounds`);
    const t = this.buf.slice(this.offset, this.offset + e);
    return this.offset += e, t;
  }
  readString() {
    const e = this.readU32(), t = this.readBuffer(e);
    try {
      return av.decode(t);
    } catch (r) {
      throw new fr(`Error decoding UTF-8 string: ${r}`);
    }
  }
  readFixedArray(e) {
    return new Uint8Array(this.readBuffer(e));
  }
  readArray(e) {
    const t = this.readU32(), r = Array();
    for (let s = 0; s < t; ++s)
      r.push(e());
    return r;
  }
}
dn([
  hn
], Cr.prototype, "readU8", null);
dn([
  hn
], Cr.prototype, "readU16", null);
dn([
  hn
], Cr.prototype, "readU32", null);
dn([
  hn
], Cr.prototype, "readU64", null);
dn([
  hn
], Cr.prototype, "readU128", null);
dn([
  hn
], Cr.prototype, "readU256", null);
dn([
  hn
], Cr.prototype, "readU512", null);
dn([
  hn
], Cr.prototype, "readString", null);
dn([
  hn
], Cr.prototype, "readFixedArray", null);
dn([
  hn
], Cr.prototype, "readArray", null);
er.BinaryReader = Cr;
function y0(n) {
  return n.charAt(0).toUpperCase() + n.slice(1);
}
function ts(n, e, t, r, s) {
  try {
    if (typeof r == "string")
      s[`write${y0(r)}`](t);
    else if (r instanceof Array)
      if (typeof r[0] == "number") {
        if (t.length !== r[0])
          throw new fr(`Expecting byte array of length ${r[0]}, but got ${t.length} bytes`);
        s.writeFixedArray(t);
      } else if (r.length === 2 && typeof r[1] == "number") {
        if (t.length !== r[1])
          throw new fr(`Expecting byte array of length ${r[1]}, but got ${t.length} bytes`);
        for (let i = 0; i < r[1]; i++)
          ts(n, null, t[i], r[0], s);
      } else
        s.writeArray(t, (i) => {
          ts(n, e, i, r[0], s);
        });
    else if (r.kind !== void 0)
      switch (r.kind) {
        case "option": {
          t == null ? s.writeU8(0) : (s.writeU8(1), ts(n, e, t, r.type, s));
          break;
        }
        case "map": {
          s.writeU32(t.size), t.forEach((i, o) => {
            ts(n, e, o, r.key, s), ts(n, e, i, r.value, s);
          });
          break;
        }
        default:
          throw new fr(`FieldType ${r} unrecognized`);
      }
    else
      v0(n, t, s);
  } catch (i) {
    throw i instanceof fr && i.addToFieldPath(e), i;
  }
}
function v0(n, e, t) {
  if (typeof e.borshSerialize == "function") {
    e.borshSerialize(t);
    return;
  }
  const r = n.get(e.constructor);
  if (!r)
    throw new fr(`Class ${e.constructor.name} is missing in schema`);
  if (r.kind === "struct")
    r.fields.map(([s, i]) => {
      ts(n, s, e[s], i, t);
    });
  else if (r.kind === "enum") {
    const s = e[r.field];
    for (let i = 0; i < r.values.length; ++i) {
      const [o, a] = r.values[i];
      if (o === s) {
        t.writeU8(i), ts(n, o, e[o], a, t);
        break;
      }
    }
  } else
    throw new fr(`Unexpected schema kind: ${r.kind} for ${e.constructor.name}`);
}
function uv(n, e, t = m0) {
  const r = new t();
  return v0(n, e, r), r.toArray();
}
var x0 = er.serialize = uv;
function rs(n, e, t, r) {
  try {
    if (typeof t == "string")
      return r[`read${y0(t)}`]();
    if (t instanceof Array) {
      if (typeof t[0] == "number")
        return r.readFixedArray(t[0]);
      if (typeof t[1] == "number") {
        const s = [];
        for (let i = 0; i < t[1]; i++)
          s.push(rs(n, null, t[0], r));
        return s;
      } else
        return r.readArray(() => rs(n, e, t[0], r));
    }
    if (t.kind === "option")
      return r.readU8() ? rs(n, e, t.type, r) : void 0;
    if (t.kind === "map") {
      let s = /* @__PURE__ */ new Map();
      const i = r.readU32();
      for (let o = 0; o < i; o++) {
        const a = rs(n, e, t.key, r), l = rs(n, e, t.value, r);
        s.set(a, l);
      }
      return s;
    }
    return hu(n, t, r);
  } catch (s) {
    throw s instanceof fr && s.addToFieldPath(e), s;
  }
}
function hu(n, e, t) {
  if (typeof e.borshDeserialize == "function")
    return e.borshDeserialize(t);
  const r = n.get(e);
  if (!r)
    throw new fr(`Class ${e.name} is missing in schema`);
  if (r.kind === "struct") {
    const s = {};
    for (const [i, o] of n.get(e).fields)
      s[i] = rs(n, i, o, t);
    return new e(s);
  }
  if (r.kind === "enum") {
    const s = t.readU8();
    if (s >= r.values.length)
      throw new fr(`Enum index: ${s} is out of range`);
    const [i, o] = r.values[s], a = rs(n, i, o, t);
    return new e({ [i]: a });
  }
  throw new fr(`Unexpected schema kind: ${r.kind} for ${e.constructor.name}`);
}
function dv(n, e, t, r = Cr) {
  const s = new r(t), i = hu(n, e, s);
  if (s.offset < t.length)
    throw new fr(`Unexpected ${t.length - s.offset} bytes after deserialized data`);
  return i;
}
var E0 = er.deserialize = dv;
function hv(n, e, t, r = Cr) {
  const s = new r(t);
  return hu(n, e, s);
}
g0 = er.deserializeUnchecked = hv;
var X = {};
Object.defineProperty(X, "__esModule", { value: !0 });
X.s16 = X.s8 = X.nu64be = X.u48be = X.u40be = X.u32be = X.u24be = X.u16be = Qt = X.nu64 = X.u48 = X.u40 = Ee = X.u32 = X.u24 = Mr = X.u16 = Je = X.u8 = as = X.offset = X.greedy = X.Constant = X.UTF8 = X.CString = X.Blob = X.Boolean = X.BitField = X.BitStructure = X.VariantLayout = X.Union = X.UnionLayoutDiscriminator = X.UnionDiscriminator = X.Structure = X.Sequence = X.DoubleBE = X.Double = X.FloatBE = X.Float = X.NearInt64BE = X.NearInt64 = X.NearUInt64BE = X.NearUInt64 = X.IntBE = X.Int = X.UIntBE = X.UInt = X.OffsetLayout = X.GreedyCount = X.ExternalLayout = X.bindConstructorLayout = X.nameWithProperty = X.Layout = X.uint8ArrayToBuffer = X.checkUint8Array = void 0;
X.constant = X.utf8 = X.cstr = gt = X.blob = X.unionLayoutDiscriminator = X.union = gr = X.seq = X.bits = pe = X.struct = X.f64be = X.f64 = X.f32be = X.f32 = X.ns64be = X.s48be = X.s40be = X.s32be = X.s24be = X.s16be = br = X.ns64 = X.s48 = X.s40 = X.s32 = X.s24 = void 0;
const fu = $e;
function ni(n) {
  if (!(n instanceof Uint8Array))
    throw new TypeError("b must be a Uint8Array");
}
X.checkUint8Array = ni;
function Xe(n) {
  return ni(n), fu.Buffer.from(n.buffer, n.byteOffset, n.length);
}
X.uint8ArrayToBuffer = Xe;
class it {
  constructor(e, t) {
    if (!Number.isInteger(e))
      throw new TypeError("span must be an integer");
    this.span = e, this.property = t;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Uint8Array} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(e, t) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(e) {
    const t = Object.create(this.constructor.prototype);
    return Object.assign(t, this), t.property = e, t;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(e) {
  }
}
X.Layout = it;
function gu(n, e) {
  return e.property ? n + "[" + e.property + "]" : n;
}
X.nameWithProperty = gu;
function fv(n, e) {
  if (typeof n != "function")
    throw new TypeError("Class must be constructor");
  if (Object.prototype.hasOwnProperty.call(n, "layout_"))
    throw new Error("Class is already bound to a layout");
  if (!(e && e instanceof it))
    throw new TypeError("layout must be a Layout");
  if (Object.prototype.hasOwnProperty.call(e, "boundConstructor_"))
    throw new Error("layout is already bound to a constructor");
  n.layout_ = e, e.boundConstructor_ = n, e.makeDestinationObject = () => new n(), Object.defineProperty(n.prototype, "encode", {
    value(t, r) {
      return e.encode(this, t, r);
    },
    writable: !0
  }), Object.defineProperty(n, "decode", {
    value(t, r) {
      return e.decode(t, r);
    },
    writable: !0
  });
}
X.bindConstructorLayout = fv;
class xr extends it {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
}
X.ExternalLayout = xr;
class S0 extends xr {
  constructor(e = 1, t) {
    if (!Number.isInteger(e) || 0 >= e)
      throw new TypeError("elementSpan must be a (positive) integer");
    super(-1, t), this.elementSpan = e;
  }
  /** @override */
  isCount() {
    return !0;
  }
  /** @override */
  decode(e, t = 0) {
    ni(e);
    const r = e.length - t;
    return Math.floor(r / this.elementSpan);
  }
  /** @override */
  encode(e, t, r) {
    return 0;
  }
}
X.GreedyCount = S0;
class pu extends xr {
  constructor(e, t = 0, r) {
    if (!(e instanceof it))
      throw new TypeError("layout must be a Layout");
    if (!Number.isInteger(t))
      throw new TypeError("offset must be integer or undefined");
    super(e.span, r || e.property), this.layout = e, this.offset = t;
  }
  /** @override */
  isCount() {
    return this.layout instanceof Br || this.layout instanceof Kr;
  }
  /** @override */
  decode(e, t = 0) {
    return this.layout.decode(e, t + this.offset);
  }
  /** @override */
  encode(e, t, r = 0) {
    return this.layout.encode(e, t, r + this.offset);
  }
}
X.OffsetLayout = pu;
class Br extends it {
  constructor(e, t) {
    if (super(e, t), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, t = 0) {
    return Xe(e).readUIntLE(t, this.span);
  }
  /** @override */
  encode(e, t, r = 0) {
    return Xe(t).writeUIntLE(e, r, this.span), this.span;
  }
}
X.UInt = Br;
class Kr extends it {
  constructor(e, t) {
    if (super(e, t), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, t = 0) {
    return Xe(e).readUIntBE(t, this.span);
  }
  /** @override */
  encode(e, t, r = 0) {
    return Xe(t).writeUIntBE(e, r, this.span), this.span;
  }
}
X.UIntBE = Kr;
class ps extends it {
  constructor(e, t) {
    if (super(e, t), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, t = 0) {
    return Xe(e).readIntLE(t, this.span);
  }
  /** @override */
  encode(e, t, r = 0) {
    return Xe(t).writeIntLE(e, r, this.span), this.span;
  }
}
X.Int = ps;
class si extends it {
  constructor(e, t) {
    if (super(e, t), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, t = 0) {
    return Xe(e).readIntBE(t, this.span);
  }
  /** @override */
  encode(e, t, r = 0) {
    return Xe(t).writeIntBE(e, r, this.span), this.span;
  }
}
X.IntBE = si;
const gc = Math.pow(2, 32);
function Da(n) {
  const e = Math.floor(n / gc), t = n - e * gc;
  return { hi32: e, lo32: t };
}
function Pa(n, e) {
  return n * gc + e;
}
class b0 extends it {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, t = 0) {
    const r = Xe(e), s = r.readUInt32LE(t), i = r.readUInt32LE(t + 4);
    return Pa(i, s);
  }
  /** @override */
  encode(e, t, r = 0) {
    const s = Da(e), i = Xe(t);
    return i.writeUInt32LE(s.lo32, r), i.writeUInt32LE(s.hi32, r + 4), 8;
  }
}
X.NearUInt64 = b0;
class T0 extends it {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, t = 0) {
    const r = Xe(e), s = r.readUInt32BE(t), i = r.readUInt32BE(t + 4);
    return Pa(s, i);
  }
  /** @override */
  encode(e, t, r = 0) {
    const s = Da(e), i = Xe(t);
    return i.writeUInt32BE(s.hi32, r), i.writeUInt32BE(s.lo32, r + 4), 8;
  }
}
X.NearUInt64BE = T0;
class w0 extends it {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, t = 0) {
    const r = Xe(e), s = r.readUInt32LE(t), i = r.readInt32LE(t + 4);
    return Pa(i, s);
  }
  /** @override */
  encode(e, t, r = 0) {
    const s = Da(e), i = Xe(t);
    return i.writeUInt32LE(s.lo32, r), i.writeInt32LE(s.hi32, r + 4), 8;
  }
}
X.NearInt64 = w0;
class A0 extends it {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, t = 0) {
    const r = Xe(e), s = r.readInt32BE(t), i = r.readUInt32BE(t + 4);
    return Pa(s, i);
  }
  /** @override */
  encode(e, t, r = 0) {
    const s = Da(e), i = Xe(t);
    return i.writeInt32BE(s.hi32, r), i.writeUInt32BE(s.lo32, r + 4), 8;
  }
}
X.NearInt64BE = A0;
class I0 extends it {
  constructor(e) {
    super(4, e);
  }
  /** @override */
  decode(e, t = 0) {
    return Xe(e).readFloatLE(t);
  }
  /** @override */
  encode(e, t, r = 0) {
    return Xe(t).writeFloatLE(e, r), 4;
  }
}
X.Float = I0;
class _0 extends it {
  constructor(e) {
    super(4, e);
  }
  /** @override */
  decode(e, t = 0) {
    return Xe(e).readFloatBE(t);
  }
  /** @override */
  encode(e, t, r = 0) {
    return Xe(t).writeFloatBE(e, r), 4;
  }
}
X.FloatBE = _0;
class L0 extends it {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, t = 0) {
    return Xe(e).readDoubleLE(t);
  }
  /** @override */
  encode(e, t, r = 0) {
    return Xe(t).writeDoubleLE(e, r), 8;
  }
}
X.Double = L0;
class R0 extends it {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, t = 0) {
    return Xe(e).readDoubleBE(t);
  }
  /** @override */
  encode(e, t, r = 0) {
    return Xe(t).writeDoubleBE(e, r), 8;
  }
}
X.DoubleBE = R0;
class C0 extends it {
  constructor(e, t, r) {
    if (!(e instanceof it))
      throw new TypeError("elementLayout must be a Layout");
    if (!(t instanceof xr && t.isCount() || Number.isInteger(t) && 0 <= t))
      throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
    let s = -1;
    !(t instanceof xr) && 0 < e.span && (s = t * e.span), super(s, r), this.elementLayout = e, this.count = t;
  }
  /** @override */
  getSpan(e, t = 0) {
    if (0 <= this.span)
      return this.span;
    let r = 0, s = this.count;
    if (s instanceof xr && (s = s.decode(e, t)), 0 < this.elementLayout.span)
      r = s * this.elementLayout.span;
    else {
      let i = 0;
      for (; i < s; )
        r += this.elementLayout.getSpan(e, t + r), ++i;
    }
    return r;
  }
  /** @override */
  decode(e, t = 0) {
    const r = [];
    let s = 0, i = this.count;
    for (i instanceof xr && (i = i.decode(e, t)); s < i; )
      r.push(this.elementLayout.decode(e, t)), t += this.elementLayout.getSpan(e, t), s += 1;
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, t, r = 0) {
    const s = this.elementLayout, i = e.reduce((o, a) => o + s.encode(a, t, r + o), 0);
    return this.count instanceof xr && this.count.encode(e.length, t, r), i;
  }
}
X.Sequence = C0;
class k0 extends it {
  constructor(e, t, r) {
    if (!(Array.isArray(e) && e.reduce((i, o) => i && o instanceof it, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof t == "boolean" && r === void 0 && (r = t, t = void 0);
    for (const i of e)
      if (0 > i.span && i.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let s = -1;
    try {
      s = e.reduce((i, o) => i + o.getSpan(), 0);
    } catch {
    }
    super(s, t), this.fields = e, this.decodePrefixes = !!r;
  }
  /** @override */
  getSpan(e, t = 0) {
    if (0 <= this.span)
      return this.span;
    let r = 0;
    try {
      r = this.fields.reduce((s, i) => {
        const o = i.getSpan(e, t);
        return t += o, s + o;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return r;
  }
  /** @override */
  decode(e, t = 0) {
    ni(e);
    const r = this.makeDestinationObject();
    for (const s of this.fields)
      if (s.property !== void 0 && (r[s.property] = s.decode(e, t)), t += s.getSpan(e, t), this.decodePrefixes && e.length === t)
        break;
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(e, t, r = 0) {
    const s = r;
    let i = 0, o = 0;
    for (const a of this.fields) {
      let l = a.span;
      if (o = 0 < l ? l : 0, a.property !== void 0) {
        const c = e[a.property];
        c !== void 0 && (o = a.encode(c, t, r), 0 > l && (l = a.getSpan(t, r)));
      }
      i = r, r += l;
    }
    return i + o - s;
  }
  /** @override */
  fromArray(e) {
    const t = this.makeDestinationObject();
    for (const r of this.fields)
      r.property !== void 0 && 0 < e.length && (t[r.property] = e.shift());
    return t;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    for (const t of this.fields)
      if (t.property === e)
        return t;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    let t = 0;
    for (const r of this.fields) {
      if (r.property === e)
        return t;
      0 > r.span ? t = -1 : 0 <= t && (t += r.span);
    }
  }
}
X.Structure = k0;
class mu {
  constructor(e) {
    this.property = e;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode(e, t) {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode(e, t, r) {
    throw new Error("UnionDiscriminator is abstract");
  }
}
X.UnionDiscriminator = mu;
class ea extends mu {
  constructor(e, t) {
    if (!(e instanceof xr && e.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(t || e.property || "variant"), this.layout = e;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(e, t) {
    return this.layout.decode(e, t);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(e, t, r) {
    return this.layout.encode(e, t, r);
  }
}
X.UnionLayoutDiscriminator = ea;
class yu extends it {
  constructor(e, t, r) {
    let s;
    if (e instanceof Br || e instanceof Kr)
      s = new ea(new pu(e));
    else if (e instanceof xr && e.isCount())
      s = new ea(e);
    else if (e instanceof mu)
      s = e;
    else
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (t === void 0 && (t = null), !(t === null || t instanceof it))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (t !== null) {
      if (0 > t.span)
        throw new Error("defaultLayout must have constant span");
      t.property === void 0 && (t = t.replicate("content"));
    }
    let i = -1;
    t && (i = t.span, 0 <= i && (e instanceof Br || e instanceof Kr) && (i += s.layout.span)), super(i, r), this.discriminator = s, this.usesPrefixDiscriminator = e instanceof Br || e instanceof Kr, this.defaultLayout = t, this.registry = {};
    let o = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(a) {
      return o(a);
    }, this.configGetSourceVariant = function(a) {
      o = a.bind(this);
    };
  }
  /** @override */
  getSpan(e, t = 0) {
    if (0 <= this.span)
      return this.span;
    const r = this.getVariant(e, t);
    if (!r)
      throw new Error("unable to determine span for unrecognized variant");
    return r.getSpan(e, t);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisfied rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(e) {
    if (Object.prototype.hasOwnProperty.call(e, this.discriminator.property)) {
      if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(e, this.defaultLayout.property))
        return;
      const t = this.registry[e[this.discriminator.property]];
      if (t && (!t.layout || t.property && Object.prototype.hasOwnProperty.call(e, t.property)))
        return t;
    } else
      for (const t in this.registry) {
        const r = this.registry[t];
        if (r.property && Object.prototype.hasOwnProperty.call(e, r.property))
          return r;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(e, t = 0) {
    let r;
    const s = this.discriminator, i = s.decode(e, t), o = this.registry[i];
    if (o === void 0) {
      const a = this.defaultLayout;
      let l = 0;
      this.usesPrefixDiscriminator && (l = s.layout.span), r = this.makeDestinationObject(), r[s.property] = i, r[a.property] = a.decode(e, t + l);
    } else
      r = o.decode(e, t);
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(e, t, r = 0) {
    const s = this.getSourceVariant(e);
    if (s === void 0) {
      const i = this.discriminator, o = this.defaultLayout;
      let a = 0;
      return this.usesPrefixDiscriminator && (a = i.layout.span), i.encode(e[i.property], t, r), a + o.encode(e[o.property], t, r + a);
    }
    return s.encode(e, t, r);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(e, t, r) {
    const s = new D0(this, e, t, r);
    return this.registry[e] = s, s;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Uint8Array)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Uint8Array}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(e, t = 0) {
    let r;
    return e instanceof Uint8Array ? r = this.discriminator.decode(e, t) : r = e, this.registry[r];
  }
}
X.Union = yu;
class D0 extends it {
  constructor(e, t, r, s) {
    if (!(e instanceof yu))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(t) || 0 > t)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof r == "string" && s === void 0 && (s = r, r = null), r) {
      if (!(r instanceof it))
        throw new TypeError("layout must be a Layout");
      if (e.defaultLayout !== null && 0 <= r.span && r.span > e.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof s != "string")
        throw new TypeError("variant must have a String property");
    }
    let i = e.span;
    0 > e.span && (i = r ? r.span : 0, 0 <= i && e.usesPrefixDiscriminator && (i += e.discriminator.layout.span)), super(i, s), this.union = e, this.variant = t, this.layout = r || null;
  }
  /** @override */
  getSpan(e, t = 0) {
    if (0 <= this.span)
      return this.span;
    let r = 0;
    this.union.usesPrefixDiscriminator && (r = this.union.discriminator.layout.span);
    let s = 0;
    return this.layout && (s = this.layout.getSpan(e, t + r)), r + s;
  }
  /** @override */
  decode(e, t = 0) {
    const r = this.makeDestinationObject();
    if (this !== this.union.getVariant(e, t))
      throw new Error("variant mismatch");
    let s = 0;
    return this.union.usesPrefixDiscriminator && (s = this.union.discriminator.layout.span), this.layout ? r[this.property] = this.layout.decode(e, t + s) : this.property ? r[this.property] = !0 : this.union.usesPrefixDiscriminator && (r[this.union.discriminator.property] = this.variant), r;
  }
  /** @override */
  encode(e, t, r = 0) {
    let s = 0;
    if (this.union.usesPrefixDiscriminator && (s = this.union.discriminator.layout.span), this.layout && !Object.prototype.hasOwnProperty.call(e, this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, t, r);
    let i = s;
    if (this.layout && (this.layout.encode(e[this.property], t, r + s), i += this.layout.getSpan(t, r + s), 0 <= this.union.span && i > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return i;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(e) {
    if (this.layout)
      return this.layout.fromArray(e);
  }
}
X.VariantLayout = D0;
function Ps(n) {
  return 0 > n && (n += 4294967296), n;
}
class vu extends it {
  constructor(e, t, r) {
    if (!(e instanceof Br || e instanceof Kr))
      throw new TypeError("word must be a UInt or UIntBE layout");
    if (typeof t == "string" && r === void 0 && (r = t, t = !1), 4 < e.span)
      throw new RangeError("word cannot exceed 32 bits");
    super(e.span, r), this.word = e, this.msb = !!t, this.fields = [];
    let s = 0;
    this._packedSetValue = function(i) {
      return s = Ps(i), this;
    }, this._packedGetValue = function() {
      return s;
    };
  }
  /** @override */
  decode(e, t = 0) {
    const r = this.makeDestinationObject(), s = this.word.decode(e, t);
    this._packedSetValue(s);
    for (const i of this.fields)
      i.property !== void 0 && (r[i.property] = i.decode(e));
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */
  encode(e, t, r = 0) {
    const s = this.word.decode(t, r);
    this._packedSetValue(s);
    for (const i of this.fields)
      if (i.property !== void 0) {
        const o = e[i.property];
        o !== void 0 && i.encode(o);
      }
    return this.word.encode(this._packedGetValue(), t, r);
  }
  /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */
  addField(e, t) {
    const r = new xu(this, e, t);
    return this.fields.push(r), r;
  }
  /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */
  // `Boolean` conflicts with the native primitive type
  // eslint-disable-next-line @typescript-eslint/ban-types
  addBoolean(e) {
    const t = new P0(this, e);
    return this.fields.push(t), t;
  }
  /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */
  fieldFor(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    for (const t of this.fields)
      if (t.property === e)
        return t;
  }
}
X.BitStructure = vu;
class xu {
  constructor(e, t, r) {
    if (!(e instanceof vu))
      throw new TypeError("container must be a BitStructure");
    if (!Number.isInteger(t) || 0 >= t)
      throw new TypeError("bits must be positive integer");
    const s = 8 * e.span, i = e.fields.reduce((o, a) => o + a.bits, 0);
    if (t + i > s)
      throw new Error("bits too long for span remainder (" + (s - i) + " of " + s + " remain)");
    this.container = e, this.bits = t, this.valueMask = (1 << t) - 1, t === 32 && (this.valueMask = 4294967295), this.start = i, this.container.msb && (this.start = s - i - t), this.wordMask = Ps(this.valueMask << this.start), this.property = r;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field. */
  decode(e, t) {
    const r = this.container._packedGetValue();
    return Ps(r & this.wordMask) >>> this.start;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */
  encode(e) {
    if (typeof e != "number" || !Number.isInteger(e) || e !== Ps(e & this.valueMask))
      throw new TypeError(gu("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
    const t = this.container._packedGetValue(), r = Ps(e << this.start);
    this.container._packedSetValue(Ps(t & ~this.wordMask) | r);
  }
}
X.BitField = xu;
let P0 = class extends xu {
  constructor(e, t) {
    super(e, 1, t);
  }
  /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */
  decode(e, t) {
    return !!super.decode(e, t);
  }
  /** @override */
  encode(e) {
    typeof e == "boolean" && (e = +e), super.encode(e);
  }
};
X.Boolean = P0;
let M0 = class extends it {
  constructor(e, t) {
    if (!(e instanceof xr && e.isCount() || Number.isInteger(e) && 0 <= e))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let r = -1;
    e instanceof xr || (r = e), super(r, t), this.length = e;
  }
  /** @override */
  getSpan(e, t) {
    let r = this.span;
    return 0 > r && (r = this.length.decode(e, t)), r;
  }
  /** @override */
  decode(e, t = 0) {
    let r = this.span;
    return 0 > r && (r = this.length.decode(e, t)), Xe(e).slice(t, t + r);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, t, r) {
    let s = this.length;
    if (this.length instanceof xr && (s = e.length), !(e instanceof Uint8Array && s === e.length))
      throw new TypeError(gu("Blob.encode", this) + " requires (length " + s + ") Uint8Array as src");
    if (r + s > t.length)
      throw new RangeError("encoding overruns Uint8Array");
    const i = Xe(e);
    return Xe(t).write(i.toString("hex"), r, s, "hex"), this.length instanceof xr && this.length.encode(s, t, r), s;
  }
};
X.Blob = M0;
class O0 extends it {
  constructor(e) {
    super(-1, e);
  }
  /** @override */
  getSpan(e, t = 0) {
    ni(e);
    let r = t;
    for (; r < e.length && e[r] !== 0; )
      r += 1;
    return 1 + r - t;
  }
  /** @override */
  decode(e, t = 0) {
    const r = this.getSpan(e, t);
    return Xe(e).slice(t, t + r - 1).toString("utf-8");
  }
  /** @override */
  encode(e, t, r = 0) {
    typeof e != "string" && (e = String(e));
    const s = fu.Buffer.from(e, "utf8"), i = s.length;
    if (r + i > t.length)
      throw new RangeError("encoding overruns Buffer");
    const o = Xe(t);
    return s.copy(o, r), o[r + i] = 0, i + 1;
  }
}
X.CString = O0;
class B0 extends it {
  constructor(e, t) {
    if (typeof e == "string" && t === void 0 && (t = e, e = void 0), e === void 0)
      e = -1;
    else if (!Number.isInteger(e))
      throw new TypeError("maxSpan must be an integer");
    super(-1, t), this.maxSpan = e;
  }
  /** @override */
  getSpan(e, t = 0) {
    return ni(e), e.length - t;
  }
  /** @override */
  decode(e, t = 0) {
    const r = this.getSpan(e, t);
    if (0 <= this.maxSpan && this.maxSpan < r)
      throw new RangeError("text length exceeds maxSpan");
    return Xe(e).slice(t, t + r).toString("utf-8");
  }
  /** @override */
  encode(e, t, r = 0) {
    typeof e != "string" && (e = String(e));
    const s = fu.Buffer.from(e, "utf8"), i = s.length;
    if (0 <= this.maxSpan && this.maxSpan < i)
      throw new RangeError("text length exceeds maxSpan");
    if (r + i > t.length)
      throw new RangeError("encoding overruns Buffer");
    return s.copy(Xe(t), r), i;
  }
}
X.UTF8 = B0;
class F0 extends it {
  constructor(e, t) {
    super(0, t), this.value = e;
  }
  /** @override */
  decode(e, t) {
    return this.value;
  }
  /** @override */
  encode(e, t, r) {
    return 0;
  }
}
X.Constant = F0;
X.greedy = (n, e) => new S0(n, e);
var as = X.offset = (n, e, t) => new pu(n, e, t), Je = X.u8 = (n) => new Br(1, n), Mr = X.u16 = (n) => new Br(2, n);
X.u24 = (n) => new Br(3, n);
var Ee = X.u32 = (n) => new Br(4, n);
X.u40 = (n) => new Br(5, n);
X.u48 = (n) => new Br(6, n);
var Qt = X.nu64 = (n) => new b0(n);
X.u16be = (n) => new Kr(2, n);
X.u24be = (n) => new Kr(3, n);
X.u32be = (n) => new Kr(4, n);
X.u40be = (n) => new Kr(5, n);
X.u48be = (n) => new Kr(6, n);
X.nu64be = (n) => new T0(n);
X.s8 = (n) => new ps(1, n);
X.s16 = (n) => new ps(2, n);
X.s24 = (n) => new ps(3, n);
X.s32 = (n) => new ps(4, n);
X.s40 = (n) => new ps(5, n);
X.s48 = (n) => new ps(6, n);
var br = X.ns64 = (n) => new w0(n);
X.s16be = (n) => new si(2, n);
X.s24be = (n) => new si(3, n);
X.s32be = (n) => new si(4, n);
X.s40be = (n) => new si(5, n);
X.s48be = (n) => new si(6, n);
X.ns64be = (n) => new A0(n);
X.f32 = (n) => new I0(n);
X.f32be = (n) => new _0(n);
X.f64 = (n) => new L0(n);
X.f64be = (n) => new R0(n);
var pe = X.struct = (n, e, t) => new k0(n, e, t);
X.bits = (n, e, t) => new vu(n, e, t);
var gr = X.seq = (n, e, t) => new C0(n, e, t);
X.union = (n, e, t) => new yu(n, e, t);
X.unionLayoutDiscriminator = (n, e) => new ea(n, e);
var gt = X.blob = (n, e) => new M0(n, e);
X.cstr = (n) => new O0(n);
X.utf8 = (n, e) => new B0(n, e);
X.constant = (n, e) => new F0(n, e);
var gv = 8078e3, pv = 8078001, mv = 8078004, yv = 8078005, vv = 8078006, xv = 8078011;
function N0(n) {
  return Array.isArray(n) ? "%5B" + n.map(N0).join(
    "%2C%20"
    /* ", " */
  ) + /* "]" */
  "%5D" : typeof n == "bigint" ? `${n}n` : encodeURIComponent(
    String(
      n != null && Object.getPrototypeOf(n) === null ? (
        // Plain objects with no prototype don't have a `toString` method.
        // Convert them before stringifying them.
        { ...n }
      ) : n
    )
  );
}
function Ev([n, e]) {
  return `${n}=${N0(e)}`;
}
function Sv(n) {
  const e = Object.entries(n).map(Ev).join("&");
  return btoa(e);
}
function bv(n, e = {}) {
  {
    let t = `Solana error #${n}; Decode this error by running \`npx @solana/errors decode -- ${n}`;
    return Object.keys(e).length && (t += ` '${Sv(e)}'`), `${t}\``;
  }
}
var Us = class extends Error {
  constructor(...[e, t]) {
    let r, s;
    if (t) {
      const { cause: o, ...a } = t;
      o && (s = { cause: o }), Object.keys(a).length > 0 && (r = a);
    }
    const i = bv(e, r);
    super(i, s);
    /**
     * Indicates the root cause of this {@link SolanaError}, if any.
     *
     * For example, a transaction error might have an instruction error as its root cause. In this
     * case, you will be able to access the instruction error on the transaction error as `cause`.
     */
    kn(this, "cause", this.cause);
    /**
     * Contains context that can assist in understanding or recovering from a {@link SolanaError}.
     */
    kn(this, "context");
    this.context = {
      __code: e,
      ...r
    }, this.name = "SolanaError";
  }
};
function Tv(n, e) {
  return "fixedSize" in e ? e.fixedSize : e.getSizeFromValue(n);
}
function wv(n) {
  return Object.freeze({
    ...n,
    encode: (e) => {
      const t = new Uint8Array(Tv(e, n));
      return n.write(e, t, 0), t;
    }
  });
}
function Av(n) {
  return Object.freeze({
    ...n,
    decode: (e, t = 0) => n.read(e, t)[0]
  });
}
function _s(n) {
  return "fixedSize" in n && typeof n.fixedSize == "number";
}
function Iv(n, e) {
  if (_s(n) !== _s(e))
    throw new Us(mv);
  if (_s(n) && _s(e) && n.fixedSize !== e.fixedSize)
    throw new Us(yv, {
      decoderFixedSize: e.fixedSize,
      encoderFixedSize: n.fixedSize
    });
  if (!_s(n) && !_s(e) && n.maxSize !== e.maxSize)
    throw new Us(vv, {
      decoderMaxSize: e.maxSize,
      encoderMaxSize: n.maxSize
    });
  return {
    ...e,
    ...n,
    decode: e.decode,
    encode: n.encode,
    read: e.read,
    write: n.write
  };
}
function _v(n, e, t = 0) {
  if (e.length - t <= 0)
    throw new Us(gv, {
      codecDescription: n
    });
}
function Lv(n, e, t, r = 0) {
  const s = t.length - r;
  if (s < e)
    throw new Us(pv, {
      bytesLength: s,
      codecDescription: n,
      expected: e
    });
}
function Rv(n, e, t, r) {
  if (r < e || r > t)
    throw new Us(xv, {
      codecDescription: n,
      max: t,
      min: e,
      value: r
    });
}
function U0(n) {
  return (n == null ? void 0 : n.endian) !== 1;
}
function Cv(n) {
  return wv({
    fixedSize: n.size,
    write(e, t, r) {
      n.range && Rv(n.name, n.range[0], n.range[1], e);
      const s = new ArrayBuffer(n.size);
      return n.set(new DataView(s), e, U0(n.config)), t.set(new Uint8Array(s), r), r + n.size;
    }
  });
}
function kv(n) {
  return Av({
    fixedSize: n.size,
    read(e, t = 0) {
      _v(n.name, e, t), Lv(n.name, n.size, e, t);
      const r = new DataView(Dv(e, t, n.size));
      return [n.get(r, U0(n.config)), t + n.size];
    }
  });
}
function Dv(n, e, t) {
  const r = n.byteOffset + (e ?? 0), s = t ?? n.byteLength;
  return n.buffer.slice(r, r + s);
}
var Pv = (n = {}) => Cv({
  config: n,
  name: "u64",
  range: [0n, BigInt("0xffffffffffffffff")],
  set: (e, t, r) => e.setBigUint64(0, BigInt(t), r),
  size: 8
}), Mv = (n = {}) => kv({
  config: n,
  get: (e, t) => e.getBigUint64(0, t),
  name: "u64",
  size: 8
}), Ov = (n = {}) => Iv(Pv(n), Mv(n));
class Bv extends TypeError {
  constructor(e, t) {
    let r;
    const { message: s, explanation: i, ...o } = e, { path: a } = e, l = a.length === 0 ? s : `At path: ${a.join(".")} -- ${s}`;
    super(i ?? l), i != null && (this.cause = l), Object.assign(this, o), this.name = this.constructor.name, this.failures = () => r ?? (r = [e, ...t()]);
  }
}
function Fv(n) {
  return Yi(n) && typeof n[Symbol.iterator] == "function";
}
function Yi(n) {
  return typeof n == "object" && n != null;
}
function ta(n) {
  return Yi(n) && !Array.isArray(n);
}
function Wr(n) {
  return typeof n == "symbol" ? n.toString() : typeof n == "string" ? JSON.stringify(n) : `${n}`;
}
function Nv(n) {
  const { done: e, value: t } = n.next();
  return e ? void 0 : t;
}
function Uv(n, e, t, r) {
  if (n === !0)
    return;
  n === !1 ? n = {} : typeof n == "string" && (n = { message: n });
  const { path: s, branch: i } = e, { type: o } = t, { refinement: a, message: l = `Expected a value of type \`${o}\`${a ? ` with refinement \`${a}\`` : ""}, but received: \`${Wr(r)}\`` } = n;
  return {
    value: r,
    type: o,
    refinement: a,
    key: s[s.length - 1],
    path: s,
    branch: i,
    ...n,
    message: l
  };
}
function* Bd(n, e, t, r) {
  Fv(n) || (n = [n]);
  for (const s of n) {
    const i = Uv(s, e, t, r);
    i && (yield i);
  }
}
function* Eu(n, e, t = {}) {
  const { path: r = [], branch: s = [n], coerce: i = !1, mask: o = !1 } = t, a = { path: r, branch: s, mask: o };
  i && (n = e.coercer(n, a));
  let l = "valid";
  for (const c of e.validator(n, a))
    c.explanation = t.message, l = "not_valid", yield [c, void 0];
  for (let [c, u, d] of e.entries(n, a)) {
    const h = Eu(u, d, {
      path: c === void 0 ? r : [...r, c],
      branch: c === void 0 ? s : [...s, u],
      coerce: i,
      mask: o,
      message: t.message
    });
    for (const f of h)
      f[0] ? (l = f[0].refinement != null ? "not_refined" : "not_valid", yield [f[0], void 0]) : i && (u = f[1], c === void 0 ? n = u : n instanceof Map ? n.set(c, u) : n instanceof Set ? n.add(u) : Yi(n) && (u !== void 0 || c in n) && (n[c] = u));
  }
  if (l !== "not_valid")
    for (const c of e.refiner(n, a))
      c.explanation = t.message, l = "not_refined", yield [c, void 0];
  l === "valid" && (yield [void 0, n]);
}
let fn = class {
  constructor(e) {
    const { type: t, schema: r, validator: s, refiner: i, coercer: o = (l) => l, entries: a = function* () {
    } } = e;
    this.type = t, this.schema = r, this.entries = a, this.coercer = o, s ? this.validator = (l, c) => {
      const u = s(l, c);
      return Bd(u, c, this, l);
    } : this.validator = () => [], i ? this.refiner = (l, c) => {
      const u = i(l, c);
      return Bd(u, c, this, l);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(e, t) {
    return $v(e, this, t);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(e, t) {
    return bi(e, this, t);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(e) {
    return $0(e, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema. Masking applies recursively to
   * props of `object` structs only.
   */
  mask(e, t) {
    return Gv(e, this, t);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `coerce` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful. Also, `mask` will turn on
   * masking of the unknown `object` props recursively if passed.
   */
  validate(e, t = {}) {
    return Zi(e, this, t);
  }
};
function $v(n, e, t) {
  const r = Zi(n, e, { message: t });
  if (r[0])
    throw r[0];
}
function bi(n, e, t) {
  const r = Zi(n, e, { coerce: !0, message: t });
  if (r[0])
    throw r[0];
  return r[1];
}
function Gv(n, e, t) {
  const r = Zi(n, e, { coerce: !0, mask: !0, message: t });
  if (r[0])
    throw r[0];
  return r[1];
}
function $0(n, e) {
  return !Zi(n, e)[0];
}
function Zi(n, e, t = {}) {
  const r = Eu(n, e, t), s = Nv(r);
  return s[0] ? [new Bv(s[0], function* () {
    for (const o of r)
      o[0] && (yield o[0]);
  }), void 0] : [void 0, s[1]];
}
function ms(n, e) {
  return new fn({ type: n, schema: null, validator: e });
}
function jv() {
  return ms("any", () => !0);
}
function ce(n) {
  return new fn({
    type: "array",
    schema: n,
    *entries(e) {
      if (n && Array.isArray(e))
        for (const [t, r] of e.entries())
          yield [t, r, n];
    },
    coercer(e) {
      return Array.isArray(e) ? e.slice() : e;
    },
    validator(e) {
      return Array.isArray(e) || `Expected an array value, but received: ${Wr(e)}`;
    }
  });
}
function cn() {
  return ms("boolean", (n) => typeof n == "boolean");
}
function Su(n) {
  return ms("instance", (e) => e instanceof n || `Expected a \`${n.name}\` instance, but received: ${Wr(e)}`);
}
function vt(n) {
  const e = Wr(n), t = typeof n;
  return new fn({
    type: "literal",
    schema: t === "string" || t === "number" || t === "boolean" ? n : null,
    validator(r) {
      return r === n || `Expected the literal \`${e}\`, but received: ${Wr(r)}`;
    }
  });
}
function Vv() {
  return ms("never", () => !1);
}
function ue(n) {
  return new fn({
    ...n,
    validator: (e, t) => e === null || n.validator(e, t),
    refiner: (e, t) => e === null || n.refiner(e, t)
  });
}
function Z() {
  return ms("number", (n) => typeof n == "number" && !isNaN(n) || `Expected a number, but received: ${Wr(n)}`);
}
function Se(n) {
  return new fn({
    ...n,
    validator: (e, t) => e === void 0 || n.validator(e, t),
    refiner: (e, t) => e === void 0 || n.refiner(e, t)
  });
}
function G0(n, e) {
  return new fn({
    type: "record",
    schema: null,
    *entries(t) {
      if (Yi(t))
        for (const r in t) {
          const s = t[r];
          yield [r, r, n], yield [r, s, e];
        }
    },
    validator(t) {
      return ta(t) || `Expected an object, but received: ${Wr(t)}`;
    },
    coercer(t) {
      return ta(t) ? { ...t } : t;
    }
  });
}
function ie() {
  return ms("string", (n) => typeof n == "string" || `Expected a string, but received: ${Wr(n)}`);
}
function bu(n) {
  const e = Vv();
  return new fn({
    type: "tuple",
    schema: null,
    *entries(t) {
      if (Array.isArray(t)) {
        const r = Math.max(n.length, t.length);
        for (let s = 0; s < r; s++)
          yield [s, t[s], n[s] || e];
      }
    },
    validator(t) {
      return Array.isArray(t) || `Expected an array, but received: ${Wr(t)}`;
    },
    coercer(t) {
      return Array.isArray(t) ? t.slice() : t;
    }
  });
}
function re(n) {
  const e = Object.keys(n);
  return new fn({
    type: "type",
    schema: n,
    *entries(t) {
      if (Yi(t))
        for (const r of e)
          yield [r, t[r], n[r]];
    },
    validator(t) {
      return ta(t) || `Expected an object, but received: ${Wr(t)}`;
    },
    coercer(t) {
      return ta(t) ? { ...t } : t;
    }
  });
}
function pr(n) {
  const e = n.map((t) => t.type).join(" | ");
  return new fn({
    type: "union",
    schema: null,
    coercer(t, r) {
      for (const s of n) {
        const [i, o] = s.validate(t, {
          coerce: !0,
          mask: r.mask
        });
        if (!i)
          return o;
      }
      return t;
    },
    validator(t, r) {
      const s = [];
      for (const i of n) {
        const [...o] = Eu(t, i, r), [a] = o;
        if (a[0])
          for (const [l] of o)
            l && s.push(l);
        else
          return [];
      }
      return [
        `Expected the value to satisfy a union of \`${e}\`, but received: ${Wr(t)}`,
        ...s
      ];
    }
  });
}
function ii() {
  return ms("unknown", () => !0);
}
function Xi(n, e, t) {
  return new fn({
    ...n,
    coercer: (r, s) => $0(r, e) ? n.coercer(t(r, s), s) : n.coercer(r, s)
  });
}
var so, Kv = new Uint8Array(16);
function j0() {
  if (!so && (so = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !so))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return so(Kv);
}
const Hv = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Ma(n) {
  return typeof n == "string" && Hv.test(n);
}
var Jt = [];
for (var vl = 0; vl < 256; ++vl)
  Jt.push((vl + 256).toString(16).substr(1));
function Oa(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, t = (Jt[n[e + 0]] + Jt[n[e + 1]] + Jt[n[e + 2]] + Jt[n[e + 3]] + "-" + Jt[n[e + 4]] + Jt[n[e + 5]] + "-" + Jt[n[e + 6]] + Jt[n[e + 7]] + "-" + Jt[n[e + 8]] + Jt[n[e + 9]] + "-" + Jt[n[e + 10]] + Jt[n[e + 11]] + Jt[n[e + 12]] + Jt[n[e + 13]] + Jt[n[e + 14]] + Jt[n[e + 15]]).toLowerCase();
  if (!Ma(t))
    throw TypeError("Stringified UUID is invalid");
  return t;
}
var Fd, xl, El = 0, Sl = 0;
function Wv(n, e, t) {
  var r = e && t || 0, s = e || new Array(16);
  n = n || {};
  var i = n.node || Fd, o = n.clockseq !== void 0 ? n.clockseq : xl;
  if (i == null || o == null) {
    var a = n.random || (n.rng || j0)();
    i == null && (i = Fd = [a[0] | 1, a[1], a[2], a[3], a[4], a[5]]), o == null && (o = xl = (a[6] << 8 | a[7]) & 16383);
  }
  var l = n.msecs !== void 0 ? n.msecs : Date.now(), c = n.nsecs !== void 0 ? n.nsecs : Sl + 1, u = l - El + (c - Sl) / 1e4;
  if (u < 0 && n.clockseq === void 0 && (o = o + 1 & 16383), (u < 0 || l > El) && n.nsecs === void 0 && (c = 0), c >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  El = l, Sl = c, xl = o, l += 122192928e5;
  var d = ((l & 268435455) * 1e4 + c) % 4294967296;
  s[r++] = d >>> 24 & 255, s[r++] = d >>> 16 & 255, s[r++] = d >>> 8 & 255, s[r++] = d & 255;
  var h = l / 4294967296 * 1e4 & 268435455;
  s[r++] = h >>> 8 & 255, s[r++] = h & 255, s[r++] = h >>> 24 & 15 | 16, s[r++] = h >>> 16 & 255, s[r++] = o >>> 8 | 128, s[r++] = o & 255;
  for (var f = 0; f < 6; ++f)
    s[r + f] = i[f];
  return e || Oa(s);
}
function V0(n) {
  if (!Ma(n))
    throw TypeError("Invalid UUID");
  var e, t = new Uint8Array(16);
  return t[0] = (e = parseInt(n.slice(0, 8), 16)) >>> 24, t[1] = e >>> 16 & 255, t[2] = e >>> 8 & 255, t[3] = e & 255, t[4] = (e = parseInt(n.slice(9, 13), 16)) >>> 8, t[5] = e & 255, t[6] = (e = parseInt(n.slice(14, 18), 16)) >>> 8, t[7] = e & 255, t[8] = (e = parseInt(n.slice(19, 23), 16)) >>> 8, t[9] = e & 255, t[10] = (e = parseInt(n.slice(24, 36), 16)) / 1099511627776 & 255, t[11] = e / 4294967296 & 255, t[12] = e >>> 24 & 255, t[13] = e >>> 16 & 255, t[14] = e >>> 8 & 255, t[15] = e & 255, t;
}
function qv(n) {
  n = unescape(encodeURIComponent(n));
  for (var e = [], t = 0; t < n.length; ++t)
    e.push(n.charCodeAt(t));
  return e;
}
var zv = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", Yv = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function K0(n, e, t) {
  function r(s, i, o, a) {
    if (typeof s == "string" && (s = qv(s)), typeof i == "string" && (i = V0(i)), i.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var l = new Uint8Array(16 + s.length);
    if (l.set(i), l.set(s, i.length), l = t(l), l[6] = l[6] & 15 | e, l[8] = l[8] & 63 | 128, o) {
      a = a || 0;
      for (var c = 0; c < 16; ++c)
        o[a + c] = l[c];
      return o;
    }
    return Oa(l);
  }
  try {
    r.name = n;
  } catch {
  }
  return r.DNS = zv, r.URL = Yv, r;
}
function Zv(n) {
  if (typeof n == "string") {
    var e = unescape(encodeURIComponent(n));
    n = new Uint8Array(e.length);
    for (var t = 0; t < e.length; ++t)
      n[t] = e.charCodeAt(t);
  }
  return Xv(Jv(Qv(n), n.length * 8));
}
function Xv(n) {
  for (var e = [], t = n.length * 32, r = "0123456789abcdef", s = 0; s < t; s += 8) {
    var i = n[s >> 5] >>> s % 32 & 255, o = parseInt(r.charAt(i >>> 4 & 15) + r.charAt(i & 15), 16);
    e.push(o);
  }
  return e;
}
function H0(n) {
  return (n + 64 >>> 9 << 4) + 14 + 1;
}
function Jv(n, e) {
  n[e >> 5] |= 128 << e % 32, n[H0(e) - 1] = e;
  for (var t = 1732584193, r = -271733879, s = -1732584194, i = 271733878, o = 0; o < n.length; o += 16) {
    var a = t, l = r, c = s, u = i;
    t = nr(t, r, s, i, n[o], 7, -680876936), i = nr(i, t, r, s, n[o + 1], 12, -389564586), s = nr(s, i, t, r, n[o + 2], 17, 606105819), r = nr(r, s, i, t, n[o + 3], 22, -1044525330), t = nr(t, r, s, i, n[o + 4], 7, -176418897), i = nr(i, t, r, s, n[o + 5], 12, 1200080426), s = nr(s, i, t, r, n[o + 6], 17, -1473231341), r = nr(r, s, i, t, n[o + 7], 22, -45705983), t = nr(t, r, s, i, n[o + 8], 7, 1770035416), i = nr(i, t, r, s, n[o + 9], 12, -1958414417), s = nr(s, i, t, r, n[o + 10], 17, -42063), r = nr(r, s, i, t, n[o + 11], 22, -1990404162), t = nr(t, r, s, i, n[o + 12], 7, 1804603682), i = nr(i, t, r, s, n[o + 13], 12, -40341101), s = nr(s, i, t, r, n[o + 14], 17, -1502002290), r = nr(r, s, i, t, n[o + 15], 22, 1236535329), t = sr(t, r, s, i, n[o + 1], 5, -165796510), i = sr(i, t, r, s, n[o + 6], 9, -1069501632), s = sr(s, i, t, r, n[o + 11], 14, 643717713), r = sr(r, s, i, t, n[o], 20, -373897302), t = sr(t, r, s, i, n[o + 5], 5, -701558691), i = sr(i, t, r, s, n[o + 10], 9, 38016083), s = sr(s, i, t, r, n[o + 15], 14, -660478335), r = sr(r, s, i, t, n[o + 4], 20, -405537848), t = sr(t, r, s, i, n[o + 9], 5, 568446438), i = sr(i, t, r, s, n[o + 14], 9, -1019803690), s = sr(s, i, t, r, n[o + 3], 14, -187363961), r = sr(r, s, i, t, n[o + 8], 20, 1163531501), t = sr(t, r, s, i, n[o + 13], 5, -1444681467), i = sr(i, t, r, s, n[o + 2], 9, -51403784), s = sr(s, i, t, r, n[o + 7], 14, 1735328473), r = sr(r, s, i, t, n[o + 12], 20, -1926607734), t = ir(t, r, s, i, n[o + 5], 4, -378558), i = ir(i, t, r, s, n[o + 8], 11, -2022574463), s = ir(s, i, t, r, n[o + 11], 16, 1839030562), r = ir(r, s, i, t, n[o + 14], 23, -35309556), t = ir(t, r, s, i, n[o + 1], 4, -1530992060), i = ir(i, t, r, s, n[o + 4], 11, 1272893353), s = ir(s, i, t, r, n[o + 7], 16, -155497632), r = ir(r, s, i, t, n[o + 10], 23, -1094730640), t = ir(t, r, s, i, n[o + 13], 4, 681279174), i = ir(i, t, r, s, n[o], 11, -358537222), s = ir(s, i, t, r, n[o + 3], 16, -722521979), r = ir(r, s, i, t, n[o + 6], 23, 76029189), t = ir(t, r, s, i, n[o + 9], 4, -640364487), i = ir(i, t, r, s, n[o + 12], 11, -421815835), s = ir(s, i, t, r, n[o + 15], 16, 530742520), r = ir(r, s, i, t, n[o + 2], 23, -995338651), t = or(t, r, s, i, n[o], 6, -198630844), i = or(i, t, r, s, n[o + 7], 10, 1126891415), s = or(s, i, t, r, n[o + 14], 15, -1416354905), r = or(r, s, i, t, n[o + 5], 21, -57434055), t = or(t, r, s, i, n[o + 12], 6, 1700485571), i = or(i, t, r, s, n[o + 3], 10, -1894986606), s = or(s, i, t, r, n[o + 10], 15, -1051523), r = or(r, s, i, t, n[o + 1], 21, -2054922799), t = or(t, r, s, i, n[o + 8], 6, 1873313359), i = or(i, t, r, s, n[o + 15], 10, -30611744), s = or(s, i, t, r, n[o + 6], 15, -1560198380), r = or(r, s, i, t, n[o + 13], 21, 1309151649), t = or(t, r, s, i, n[o + 4], 6, -145523070), i = or(i, t, r, s, n[o + 11], 10, -1120210379), s = or(s, i, t, r, n[o + 2], 15, 718787259), r = or(r, s, i, t, n[o + 9], 21, -343485551), t = Hn(t, a), r = Hn(r, l), s = Hn(s, c), i = Hn(i, u);
  }
  return [t, r, s, i];
}
function Qv(n) {
  if (n.length === 0)
    return [];
  for (var e = n.length * 8, t = new Uint32Array(H0(e)), r = 0; r < e; r += 8)
    t[r >> 5] |= (n[r / 8] & 255) << r % 32;
  return t;
}
function Hn(n, e) {
  var t = (n & 65535) + (e & 65535), r = (n >> 16) + (e >> 16) + (t >> 16);
  return r << 16 | t & 65535;
}
function ex(n, e) {
  return n << e | n >>> 32 - e;
}
function Ba(n, e, t, r, s, i) {
  return Hn(ex(Hn(Hn(e, n), Hn(r, i)), s), t);
}
function nr(n, e, t, r, s, i, o) {
  return Ba(e & t | ~e & r, n, e, s, i, o);
}
function sr(n, e, t, r, s, i, o) {
  return Ba(e & r | t & ~r, n, e, s, i, o);
}
function ir(n, e, t, r, s, i, o) {
  return Ba(e ^ t ^ r, n, e, s, i, o);
}
function or(n, e, t, r, s, i, o) {
  return Ba(t ^ (e | ~r), n, e, s, i, o);
}
var tx = K0("v3", 48, Zv);
function rx(n, e, t) {
  n = n || {};
  var r = n.random || (n.rng || j0)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, e) {
    t = t || 0;
    for (var s = 0; s < 16; ++s)
      e[t + s] = r[s];
    return e;
  }
  return Oa(r);
}
function nx(n, e, t, r) {
  switch (n) {
    case 0:
      return e & t ^ ~e & r;
    case 1:
      return e ^ t ^ r;
    case 2:
      return e & t ^ e & r ^ t & r;
    case 3:
      return e ^ t ^ r;
  }
}
function bl(n, e) {
  return n << e | n >>> 32 - e;
}
function sx(n) {
  var e = [1518500249, 1859775393, 2400959708, 3395469782], t = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof n == "string") {
    var r = unescape(encodeURIComponent(n));
    n = [];
    for (var s = 0; s < r.length; ++s)
      n.push(r.charCodeAt(s));
  } else Array.isArray(n) || (n = Array.prototype.slice.call(n));
  n.push(128);
  for (var i = n.length / 4 + 2, o = Math.ceil(i / 16), a = new Array(o), l = 0; l < o; ++l) {
    for (var c = new Uint32Array(16), u = 0; u < 16; ++u)
      c[u] = n[l * 64 + u * 4] << 24 | n[l * 64 + u * 4 + 1] << 16 | n[l * 64 + u * 4 + 2] << 8 | n[l * 64 + u * 4 + 3];
    a[l] = c;
  }
  a[o - 1][14] = (n.length - 1) * 8 / Math.pow(2, 32), a[o - 1][14] = Math.floor(a[o - 1][14]), a[o - 1][15] = (n.length - 1) * 8 & 4294967295;
  for (var d = 0; d < o; ++d) {
    for (var h = new Uint32Array(80), f = 0; f < 16; ++f)
      h[f] = a[d][f];
    for (var p = 16; p < 80; ++p)
      h[p] = bl(h[p - 3] ^ h[p - 8] ^ h[p - 14] ^ h[p - 16], 1);
    for (var y = t[0], m = t[1], b = t[2], C = t[3], A = t[4], P = 0; P < 80; ++P) {
      var I = Math.floor(P / 20), U = bl(y, 5) + nx(I, m, b, C) + A + e[I] + h[P] >>> 0;
      A = C, C = b, b = bl(m, 30) >>> 0, m = y, y = U;
    }
    t[0] = t[0] + y >>> 0, t[1] = t[1] + m >>> 0, t[2] = t[2] + b >>> 0, t[3] = t[3] + C >>> 0, t[4] = t[4] + A >>> 0;
  }
  return [t[0] >> 24 & 255, t[0] >> 16 & 255, t[0] >> 8 & 255, t[0] & 255, t[1] >> 24 & 255, t[1] >> 16 & 255, t[1] >> 8 & 255, t[1] & 255, t[2] >> 24 & 255, t[2] >> 16 & 255, t[2] >> 8 & 255, t[2] & 255, t[3] >> 24 & 255, t[3] >> 16 & 255, t[3] >> 8 & 255, t[3] & 255, t[4] >> 24 & 255, t[4] >> 16 & 255, t[4] >> 8 & 255, t[4] & 255];
}
var ix = K0("v5", 80, sx);
const ox = "00000000-0000-0000-0000-000000000000";
function ax(n) {
  if (!Ma(n))
    throw TypeError("Invalid UUID");
  return parseInt(n.substr(14, 1), 16);
}
const lx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: ox,
  parse: V0,
  stringify: Oa,
  v1: Wv,
  v3: tx,
  v4: rx,
  v5: ix,
  validate: Ma,
  version: ax
}, Symbol.toStringTag, { value: "Module" })), W0 = /* @__PURE__ */ Xc(lx), cx = W0.v4, ux = function(n, e, t, r) {
  if (typeof n != "string")
    throw new TypeError(n + " must be a string");
  r = r || {};
  const s = typeof r.version == "number" ? r.version : 2;
  if (s !== 1 && s !== 2)
    throw new TypeError(s + " must be 1 or 2");
  const i = {
    method: n
  };
  if (s === 2 && (i.jsonrpc = "2.0"), e) {
    if (typeof e != "object" && !Array.isArray(e))
      throw new TypeError(e + " must be an object, array or omitted");
    i.params = e;
  }
  if (typeof t > "u") {
    const o = typeof r.generator == "function" ? r.generator : function() {
      return cx();
    };
    i.id = o(i, r);
  } else s === 2 && t === null ? r.notificationIdNull && (i.id = null) : i.id = t;
  return i;
};
var dx = ux;
const hx = W0.v4, fx = dx, ra = function(n, e) {
  if (!(this instanceof ra))
    return new ra(n, e);
  e || (e = {}), this.options = {
    reviver: typeof e.reviver < "u" ? e.reviver : null,
    replacer: typeof e.replacer < "u" ? e.replacer : null,
    generator: typeof e.generator < "u" ? e.generator : function() {
      return hx();
    },
    version: typeof e.version < "u" ? e.version : 2,
    notificationIdNull: typeof e.notificationIdNull == "boolean" ? e.notificationIdNull : !1
  }, this.callServer = n;
};
ra.prototype.request = function(n, e, t, r) {
  const s = this;
  let i = null;
  const o = Array.isArray(n) && typeof e == "function";
  if (this.options.version === 1 && o)
    throw new TypeError("JSON-RPC 1.0 does not support batching");
  if (o || !o && n && typeof n == "object" && typeof e == "function")
    r = e, i = n;
  else {
    typeof t == "function" && (r = t, t = void 0);
    const c = typeof r == "function";
    try {
      i = fx(n, e, t, {
        generator: this.options.generator,
        version: this.options.version,
        notificationIdNull: this.options.notificationIdNull
      });
    } catch (u) {
      if (c)
        return r(u);
      throw u;
    }
    if (!c)
      return i;
  }
  let l;
  try {
    l = JSON.stringify(i, this.options.replacer);
  } catch (c) {
    return r(c);
  }
  return this.callServer(l, function(c, u) {
    s._parseResponse(c, u, r);
  }), i;
};
ra.prototype._parseResponse = function(n, e, t) {
  if (n) {
    t(n);
    return;
  }
  if (!e)
    return t();
  let r;
  try {
    r = JSON.parse(e, this.options.reviver);
  } catch (s) {
    return t(s);
  }
  if (t.length === 3)
    if (Array.isArray(r)) {
      const s = function(o) {
        return typeof o.error < "u";
      }, i = function(o) {
        return !s(o);
      };
      return t(null, r.filter(s), r.filter(i));
    } else
      return t(null, r.error, r.result);
  t(null, r);
};
var q0 = { exports: {} };
(function(n) {
  var e = Object.prototype.hasOwnProperty, t = "~";
  function r() {
  }
  Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (t = !1));
  function s(l, c, u) {
    this.fn = l, this.context = c, this.once = u || !1;
  }
  function i(l, c, u, d, h) {
    if (typeof u != "function")
      throw new TypeError("The listener must be a function");
    var f = new s(u, d || l, h), p = t ? t + c : c;
    return l._events[p] ? l._events[p].fn ? l._events[p] = [l._events[p], f] : l._events[p].push(f) : (l._events[p] = f, l._eventsCount++), l;
  }
  function o(l, c) {
    --l._eventsCount === 0 ? l._events = new r() : delete l._events[c];
  }
  function a() {
    this._events = new r(), this._eventsCount = 0;
  }
  a.prototype.eventNames = function() {
    var c = [], u, d;
    if (this._eventsCount === 0) return c;
    for (d in u = this._events)
      e.call(u, d) && c.push(t ? d.slice(1) : d);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(u)) : c;
  }, a.prototype.listeners = function(c) {
    var u = t ? t + c : c, d = this._events[u];
    if (!d) return [];
    if (d.fn) return [d.fn];
    for (var h = 0, f = d.length, p = new Array(f); h < f; h++)
      p[h] = d[h].fn;
    return p;
  }, a.prototype.listenerCount = function(c) {
    var u = t ? t + c : c, d = this._events[u];
    return d ? d.fn ? 1 : d.length : 0;
  }, a.prototype.emit = function(c, u, d, h, f, p) {
    var y = t ? t + c : c;
    if (!this._events[y]) return !1;
    var m = this._events[y], b = arguments.length, C, A;
    if (m.fn) {
      switch (m.once && this.removeListener(c, m.fn, void 0, !0), b) {
        case 1:
          return m.fn.call(m.context), !0;
        case 2:
          return m.fn.call(m.context, u), !0;
        case 3:
          return m.fn.call(m.context, u, d), !0;
        case 4:
          return m.fn.call(m.context, u, d, h), !0;
        case 5:
          return m.fn.call(m.context, u, d, h, f), !0;
        case 6:
          return m.fn.call(m.context, u, d, h, f, p), !0;
      }
      for (A = 1, C = new Array(b - 1); A < b; A++)
        C[A - 1] = arguments[A];
      m.fn.apply(m.context, C);
    } else {
      var P = m.length, I;
      for (A = 0; A < P; A++)
        switch (m[A].once && this.removeListener(c, m[A].fn, void 0, !0), b) {
          case 1:
            m[A].fn.call(m[A].context);
            break;
          case 2:
            m[A].fn.call(m[A].context, u);
            break;
          case 3:
            m[A].fn.call(m[A].context, u, d);
            break;
          case 4:
            m[A].fn.call(m[A].context, u, d, h);
            break;
          default:
            if (!C) for (I = 1, C = new Array(b - 1); I < b; I++)
              C[I - 1] = arguments[I];
            m[A].fn.apply(m[A].context, C);
        }
    }
    return !0;
  }, a.prototype.on = function(c, u, d) {
    return i(this, c, u, d, !1);
  }, a.prototype.once = function(c, u, d) {
    return i(this, c, u, d, !0);
  }, a.prototype.removeListener = function(c, u, d, h) {
    var f = t ? t + c : c;
    if (!this._events[f]) return this;
    if (!u)
      return o(this, f), this;
    var p = this._events[f];
    if (p.fn)
      p.fn === u && (!h || p.once) && (!d || p.context === d) && o(this, f);
    else {
      for (var y = 0, m = [], b = p.length; y < b; y++)
        (p[y].fn !== u || h && !p[y].once || d && p[y].context !== d) && m.push(p[y]);
      m.length ? this._events[f] = m.length === 1 ? m[0] : m : o(this, f);
    }
    return this;
  }, a.prototype.removeAllListeners = function(c) {
    var u;
    return c ? (u = t ? t + c : c, this._events[u] && o(this, u)) : (this._events = new r(), this._eventsCount = 0), this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = t, a.EventEmitter = a, n.exports = a;
})(q0);
var gx = q0.exports;
const z0 = /* @__PURE__ */ Zc(gx);
class Y0 extends Hf {
  constructor(e, t) {
    super(), this.finished = !1, this.destroyed = !1, $1(e);
    const r = au(t);
    if (this.iHash = e.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const s = this.blockLen, i = new Uint8Array(s);
    i.set(r.length > s ? e.create().update(r).digest() : r);
    for (let o = 0; o < i.length; o++)
      i[o] ^= 54;
    this.iHash.update(i), this.oHash = e.create();
    for (let o = 0; o < i.length; o++)
      i[o] ^= 106;
    this.oHash.update(i), Ws(i);
  }
  update(e) {
    return zo(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    zo(this), ln(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: t, iHash: r, finished: s, destroyed: i, blockLen: o, outputLen: a } = this;
    return e = e, e.finished = s, e.destroyed = i, e.blockLen = o, e.outputLen = a, e.oHash = t._cloneInto(e.oHash), e.iHash = r._cloneInto(e.iHash), e;
  }
  clone() {
    return this._cloneInto();
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const Z0 = (n, e, t) => new Y0(n, e).update(t).digest();
Z0.create = (n, e) => new Y0(n, e);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function Nd(n) {
  n.lowS !== void 0 && fs("lowS", n.lowS), n.prehash !== void 0 && fs("prehash", n.prehash);
}
class px extends Error {
  constructor(e = "") {
    super(e);
  }
}
const bn = {
  // asn.1 DER encoding utils
  Err: px,
  // Basic building block is TLV (Tag-Length-Value)
  _tlv: {
    encode: (n, e) => {
      const { Err: t } = bn;
      if (n < 0 || n > 256)
        throw new t("tlv.encode: wrong tag");
      if (e.length & 1)
        throw new t("tlv.encode: unpadded data");
      const r = e.length / 2, s = ro(r);
      if (s.length / 2 & 128)
        throw new t("tlv.encode: long form length too big");
      const i = r > 127 ? ro(s.length / 2 | 128) : "";
      return ro(n) + i + s + e;
    },
    // v - value, l - left bytes (unparsed)
    decode(n, e) {
      const { Err: t } = bn;
      let r = 0;
      if (n < 0 || n > 256)
        throw new t("tlv.encode: wrong tag");
      if (e.length < 2 || e[r++] !== n)
        throw new t("tlv.decode: wrong tlv");
      const s = e[r++], i = !!(s & 128);
      let o = 0;
      if (!i)
        o = s;
      else {
        const l = s & 127;
        if (!l)
          throw new t("tlv.decode(long): indefinite length not supported");
        if (l > 4)
          throw new t("tlv.decode(long): byte length is too big");
        const c = e.subarray(r, r + l);
        if (c.length !== l)
          throw new t("tlv.decode: length bytes not complete");
        if (c[0] === 0)
          throw new t("tlv.decode(long): zero leftmost byte");
        for (const u of c)
          o = o << 8 | u;
        if (r += l, o < 128)
          throw new t("tlv.decode(long): not minimal encoding");
      }
      const a = e.subarray(r, r + o);
      if (a.length !== o)
        throw new t("tlv.decode: wrong value length");
      return { v: a, l: e.subarray(r + o) };
    }
  },
  // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
  // since we always use positive integers here. It must always be empty:
  // - add zero byte if exists
  // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
  _int: {
    encode(n) {
      const { Err: e } = bn;
      if (n < gi)
        throw new e("integer: negative integers are not allowed");
      let t = ro(n);
      if (Number.parseInt(t[0], 16) & 8 && (t = "00" + t), t.length & 1)
        throw new e("unexpected DER parsing assertion: unpadded hex");
      return t;
    },
    decode(n) {
      const { Err: e } = bn;
      if (n[0] & 128)
        throw new e("invalid signature integer: negative");
      if (n[0] === 0 && !(n[1] & 128))
        throw new e("invalid signature integer: unnecessary leading zero");
      return _a(n);
    }
  },
  toSig(n) {
    const { Err: e, _int: t, _tlv: r } = bn, s = Tt("signature", n), { v: i, l: o } = r.decode(48, s);
    if (o.length)
      throw new e("invalid signature: left bytes after parsing");
    const { v: a, l } = r.decode(2, i), { v: c, l: u } = r.decode(2, l);
    if (u.length)
      throw new e("invalid signature: left bytes after parsing");
    return { r: t.decode(a), s: t.decode(c) };
  },
  hexFromSig(n) {
    const { _tlv: e, _int: t } = bn, r = e.encode(2, t.encode(n.r)), s = e.encode(2, t.encode(n.s)), i = r + s;
    return e.encode(48, i);
  }
}, gi = BigInt(0), pi = BigInt(1), mx = BigInt(2), io = BigInt(3), yx = BigInt(4);
function vx(n, e, t) {
  function r(s) {
    const i = n.sqr(s), o = n.mul(i, s);
    return n.add(n.add(o, n.mul(s, e)), t);
  }
  return r;
}
function X0(n, e, t) {
  const { BYTES: r } = n;
  function s(i) {
    let o;
    if (typeof i == "bigint")
      o = i;
    else {
      let a = Tt("private key", i);
      if (e) {
        if (!e.includes(a.length * 2))
          throw new Error("invalid private key");
        const l = new Uint8Array(r);
        l.set(a, l.length - a.length), a = l;
      }
      try {
        o = n.fromBytes(a);
      } catch {
        throw new Error(`invalid private key: expected ui8a of size ${r}, got ${typeof i}`);
      }
    }
    if (t && (o = n.create(o)), !n.isValidNot0(o))
      throw new Error("invalid private key: out of range [1..N-1]");
    return o;
  }
  return s;
}
function xx(n, e = {}) {
  const { Fp: t, Fn: r } = u0("weierstrass", n, e), { h: s, n: i } = n;
  qi(e, {}, {
    allowInfinityPoint: "boolean",
    clearCofactor: "function",
    isTorsionFree: "function",
    fromBytes: "function",
    toBytes: "function",
    endo: "object",
    wrapPrivateKey: "boolean"
  });
  const { endo: o } = e;
  if (o && (!t.is0(n.a) || typeof o.beta != "bigint" || typeof o.splitScalar != "function"))
    throw new Error('invalid endo: expected "beta": bigint and "splitScalar": function');
  function a() {
    if (!t.isOdd)
      throw new Error("compression is not supported: Field does not have .isOdd()");
  }
  function l(G, F, B) {
    const { x: V, y: H } = F.toAffine(), L = t.toBytes(V);
    if (fs("isCompressed", B), B) {
      a();
      const g = !t.isOdd(H);
      return An(J0(g), L);
    } else
      return An(Uint8Array.of(4), L, t.toBytes(H));
  }
  function c(G) {
    ln(G);
    const F = t.BYTES, B = F + 1, V = 2 * F + 1, H = G.length, L = G[0], g = G.subarray(1);
    if (H === B && (L === 2 || L === 3)) {
      const x = t.fromBytes(g);
      if (!t.isValid(x))
        throw new Error("bad point: is not on curve, wrong x");
      const w = h(x);
      let _;
      try {
        _ = t.sqrt(w);
      } catch (N) {
        const R = N instanceof Error ? ": " + N.message : "";
        throw new Error("bad point: is not on curve, sqrt error" + R);
      }
      a();
      const D = t.isOdd(_);
      return (L & 1) === 1 !== D && (_ = t.neg(_)), { x, y: _ };
    } else if (H === V && L === 4) {
      const x = t.fromBytes(g.subarray(F * 0, F * 1)), w = t.fromBytes(g.subarray(F * 1, F * 2));
      if (!f(x, w))
        throw new Error("bad point: is not on curve");
      return { x, y: w };
    } else
      throw new Error(`bad point: got length ${H}, expected compressed=${B} or uncompressed=${V}`);
  }
  const u = e.toBytes || l, d = e.fromBytes || c, h = vx(t, n.a, n.b);
  function f(G, F) {
    const B = t.sqr(F), V = h(G);
    return t.eql(B, V);
  }
  if (!f(n.Gx, n.Gy))
    throw new Error("bad curve params: generator point");
  const p = t.mul(t.pow(n.a, io), yx), y = t.mul(t.sqr(n.b), BigInt(27));
  if (t.is0(t.add(p, y)))
    throw new Error("bad curve params: a or b");
  function m(G, F, B = !1) {
    if (!t.isValid(F) || B && t.is0(F))
      throw new Error(`bad point coordinate ${G}`);
    return F;
  }
  function b(G) {
    if (!(G instanceof I))
      throw new Error("ProjectivePoint expected");
  }
  const C = Yo((G, F) => {
    const { px: B, py: V, pz: H } = G;
    if (t.eql(H, t.ONE))
      return { x: B, y: V };
    const L = G.is0();
    F == null && (F = L ? t.ONE : t.inv(H));
    const g = t.mul(B, F), x = t.mul(V, F), w = t.mul(H, F);
    if (L)
      return { x: t.ZERO, y: t.ZERO };
    if (!t.eql(w, t.ONE))
      throw new Error("invZ was invalid");
    return { x: g, y: x };
  }), A = Yo((G) => {
    if (G.is0()) {
      if (e.allowInfinityPoint && !t.is0(G.py))
        return;
      throw new Error("bad point: ZERO");
    }
    const { x: F, y: B } = G.toAffine();
    if (!t.isValid(F) || !t.isValid(B))
      throw new Error("bad point: x or y not field elements");
    if (!f(F, B))
      throw new Error("bad point: equation left != right");
    if (!G.isTorsionFree())
      throw new Error("bad point: not in prime-order subgroup");
    return !0;
  });
  function P(G, F, B, V, H) {
    return B = new I(t.mul(B.px, G), B.py, B.pz), F = fi(V, F), B = fi(H, B), F.add(B);
  }
  class I {
    /** Does NOT validate if the point is valid. Use `.assertValidity()`. */
    constructor(F, B, V) {
      this.px = m("x", F), this.py = m("y", B, !0), this.pz = m("z", V), Object.freeze(this);
    }
    /** Does NOT validate if the point is valid. Use `.assertValidity()`. */
    static fromAffine(F) {
      const { x: B, y: V } = F || {};
      if (!F || !t.isValid(B) || !t.isValid(V))
        throw new Error("invalid affine point");
      if (F instanceof I)
        throw new Error("projective point not allowed");
      return t.is0(B) && t.is0(V) ? I.ZERO : new I(B, V, t.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static normalizeZ(F) {
      return i0(I, "pz", F);
    }
    static fromBytes(F) {
      return ln(F), I.fromHex(F);
    }
    /** Converts hash string or Uint8Array to Point. */
    static fromHex(F) {
      const B = I.fromAffine(d(Tt("pointHex", F)));
      return B.assertValidity(), B;
    }
    /** Multiplies generator point by privateKey. */
    static fromPrivateKey(F) {
      const B = X0(r, e.allowedPrivateKeyLengths, e.wrapPrivateKey);
      return I.BASE.multiply(B(F));
    }
    /** Multiscalar Multiplication */
    static msm(F, B) {
      return c0(I, r, F, B);
    }
    /**
     *
     * @param windowSize
     * @param isLazy true will defer table computation until the first multiplication
     * @returns
     */
    precompute(F = 8, B = !0) {
      return j.setWindowSize(this, F), B || this.multiply(io), this;
    }
    /** "Private method", don't use it directly */
    _setWindowSize(F) {
      this.precompute(F);
    }
    // TODO: return `this`
    /** A point on curve is valid if it conforms to equation. */
    assertValidity() {
      A(this);
    }
    hasEvenY() {
      const { y: F } = this.toAffine();
      if (!t.isOdd)
        throw new Error("Field doesn't support isOdd");
      return !t.isOdd(F);
    }
    /** Compare one point to another. */
    equals(F) {
      b(F);
      const { px: B, py: V, pz: H } = this, { px: L, py: g, pz: x } = F, w = t.eql(t.mul(B, x), t.mul(L, H)), _ = t.eql(t.mul(V, x), t.mul(g, H));
      return w && _;
    }
    /** Flips point to one corresponding to (x, -y) in Affine coordinates. */
    negate() {
      return new I(this.px, t.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: F, b: B } = n, V = t.mul(B, io), { px: H, py: L, pz: g } = this;
      let x = t.ZERO, w = t.ZERO, _ = t.ZERO, D = t.mul(H, H), O = t.mul(L, L), N = t.mul(g, g), R = t.mul(H, L);
      return R = t.add(R, R), _ = t.mul(H, g), _ = t.add(_, _), x = t.mul(F, _), w = t.mul(V, N), w = t.add(x, w), x = t.sub(O, w), w = t.add(O, w), w = t.mul(x, w), x = t.mul(R, x), _ = t.mul(V, _), N = t.mul(F, N), R = t.sub(D, N), R = t.mul(F, R), R = t.add(R, _), _ = t.add(D, D), D = t.add(_, D), D = t.add(D, N), D = t.mul(D, R), w = t.add(w, D), N = t.mul(L, g), N = t.add(N, N), D = t.mul(N, R), x = t.sub(x, D), _ = t.mul(N, O), _ = t.add(_, _), _ = t.add(_, _), new I(x, w, _);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(F) {
      b(F);
      const { px: B, py: V, pz: H } = this, { px: L, py: g, pz: x } = F;
      let w = t.ZERO, _ = t.ZERO, D = t.ZERO;
      const O = n.a, N = t.mul(n.b, io);
      let R = t.mul(B, L), v = t.mul(V, g), M = t.mul(H, x), te = t.add(B, V), ee = t.add(L, g);
      te = t.mul(te, ee), ee = t.add(R, v), te = t.sub(te, ee), ee = t.add(B, H);
      let ne = t.add(L, x);
      return ee = t.mul(ee, ne), ne = t.add(R, M), ee = t.sub(ee, ne), ne = t.add(V, H), w = t.add(g, x), ne = t.mul(ne, w), w = t.add(v, M), ne = t.sub(ne, w), D = t.mul(O, ee), w = t.mul(N, M), D = t.add(w, D), w = t.sub(v, D), D = t.add(v, D), _ = t.mul(w, D), v = t.add(R, R), v = t.add(v, R), M = t.mul(O, M), ee = t.mul(N, ee), v = t.add(v, M), M = t.sub(R, M), M = t.mul(O, M), ee = t.add(ee, M), R = t.mul(v, ee), _ = t.add(_, R), R = t.mul(ne, ee), w = t.mul(te, w), w = t.sub(w, R), R = t.mul(te, v), D = t.mul(ne, D), D = t.add(D, R), new I(w, _, D);
    }
    subtract(F) {
      return this.add(F.negate());
    }
    is0() {
      return this.equals(I.ZERO);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(F) {
      const { endo: B } = e;
      if (!r.isValidNot0(F))
        throw new Error("invalid scalar: out of range");
      let V, H;
      const L = (g) => j.wNAFCached(this, g, I.normalizeZ);
      if (B) {
        const { k1neg: g, k1: x, k2neg: w, k2: _ } = B.splitScalar(F), { p: D, f: O } = L(x), { p: N, f: R } = L(_);
        H = O.add(R), V = P(B.beta, D, N, g, w);
      } else {
        const { p: g, f: x } = L(F);
        V = g, H = x;
      }
      return I.normalizeZ([V, H])[0];
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(F) {
      const { endo: B } = e, V = this;
      if (!r.isValid(F))
        throw new Error("invalid scalar: out of range");
      if (F === gi || V.is0())
        return I.ZERO;
      if (F === pi)
        return V;
      if (j.hasPrecomputes(this))
        return this.multiply(F);
      if (B) {
        const { k1neg: H, k1: L, k2neg: g, k2: x } = B.splitScalar(F), { p1: w, p2: _ } = by(I, V, L, x);
        return P(B.beta, w, _, H, g);
      } else
        return j.wNAFCachedUnsafe(V, F);
    }
    multiplyAndAddUnsafe(F, B, V) {
      const H = this.multiplyUnsafe(B).add(F.multiplyUnsafe(V));
      return H.is0() ? void 0 : H;
    }
    /**
     * Converts Projective point to affine (x, y) coordinates.
     * @param invertedZ Z^-1 (inverted zero) - optional, precomputation is useful for invertBatch
     */
    toAffine(F) {
      return C(this, F);
    }
    /**
     * Checks whether Point is free of torsion elements (is in prime subgroup).
     * Always torsion-free for cofactor=1 curves.
     */
    isTorsionFree() {
      const { isTorsionFree: F } = e;
      return s === pi ? !0 : F ? F(I, this) : j.wNAFCachedUnsafe(this, i).is0();
    }
    clearCofactor() {
      const { clearCofactor: F } = e;
      return s === pi ? this : F ? F(I, this) : this.multiplyUnsafe(s);
    }
    toBytes(F = !0) {
      return fs("isCompressed", F), this.assertValidity(), u(I, this, F);
    }
    /** @deprecated use `toBytes` */
    toRawBytes(F = !0) {
      return this.toBytes(F);
    }
    toHex(F = !0) {
      return qs(this.toBytes(F));
    }
    toString() {
      return `<Point ${this.is0() ? "ZERO" : this.toHex()}>`;
    }
  }
  I.BASE = new I(n.Gx, n.Gy, t.ONE), I.ZERO = new I(t.ZERO, t.ONE, t.ZERO), I.Fp = t, I.Fn = r;
  const U = r.BITS, j = l0(I, e.endo ? Math.ceil(U / 2) : U);
  return I;
}
function J0(n) {
  return Uint8Array.of(n ? 2 : 3);
}
function Ex(n, e, t = {}) {
  qi(e, { hash: "function" }, {
    hmac: "function",
    lowS: "boolean",
    randomBytes: "function",
    bits2int: "function",
    bits2int_modN: "function"
  });
  const r = e.randomBytes || qf, s = e.hmac || ((V, ...H) => Z0(e.hash, V, An(...H))), { Fp: i, Fn: o } = n, { ORDER: a, BITS: l } = o;
  function c(V) {
    const H = a >> pi;
    return V > H;
  }
  function u(V) {
    return c(V) ? o.neg(V) : V;
  }
  function d(V, H) {
    if (!o.isValidNot0(H))
      throw new Error(`invalid signature ${V}: out of range 1..CURVE.n`);
  }
  class h {
    constructor(H, L, g) {
      d("r", H), d("s", L), this.r = H, this.s = L, g != null && (this.recovery = g), Object.freeze(this);
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(H) {
      const L = o.BYTES, g = Tt("compactSignature", H, L * 2);
      return new h(o.fromBytes(g.subarray(0, L)), o.fromBytes(g.subarray(L, L * 2)));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(H) {
      const { r: L, s: g } = bn.toSig(Tt("DER", H));
      return new h(L, g);
    }
    /**
     * @todo remove
     * @deprecated
     */
    assertValidity() {
    }
    addRecoveryBit(H) {
      return new h(this.r, this.s, H);
    }
    // ProjPointType<bigint>
    recoverPublicKey(H) {
      const L = i.ORDER, { r: g, s: x, recovery: w } = this;
      if (w == null || ![0, 1, 2, 3].includes(w))
        throw new Error("recovery id invalid");
      if (a * mx < L && w > 1)
        throw new Error("recovery id is ambiguous for h>1 curve");
      const D = w === 2 || w === 3 ? g + a : g;
      if (!i.isValid(D))
        throw new Error("recovery id 2 or 3 invalid");
      const O = i.toBytes(D), N = n.fromHex(An(J0((w & 1) === 0), O)), R = o.inv(D), v = A(Tt("msgHash", H)), M = o.create(-v * R), te = o.create(x * R), ee = n.BASE.multiplyUnsafe(M).add(N.multiplyUnsafe(te));
      if (ee.is0())
        throw new Error("point at infinify");
      return ee.assertValidity(), ee;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return c(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new h(this.r, o.neg(this.s), this.recovery) : this;
    }
    toBytes(H) {
      if (H === "compact")
        return An(o.toBytes(this.r), o.toBytes(this.s));
      if (H === "der")
        return ou(bn.hexFromSig(this));
      throw new Error("invalid format");
    }
    // DER-encoded
    toDERRawBytes() {
      return this.toBytes("der");
    }
    toDERHex() {
      return qs(this.toBytes("der"));
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return this.toBytes("compact");
    }
    toCompactHex() {
      return qs(this.toBytes("compact"));
    }
  }
  const f = X0(o, t.allowedPrivateKeyLengths, t.wrapPrivateKey), p = {
    isValidPrivateKey(V) {
      try {
        return f(V), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: f,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const V = a;
      return xy(r(s0(V)), V);
    },
    precompute(V = 8, H = n.BASE) {
      return H.precompute(V, !1);
    }
  };
  function y(V, H = !0) {
    return n.fromPrivateKey(V).toBytes(H);
  }
  function m(V) {
    if (typeof V == "bigint")
      return !1;
    if (V instanceof n)
      return !0;
    const L = Tt("key", V).length, g = i.BYTES, x = g + 1, w = 2 * g + 1;
    if (!(t.allowedPrivateKeyLengths || o.BYTES === x))
      return L === x || L === w;
  }
  function b(V, H, L = !0) {
    if (m(V) === !0)
      throw new Error("first arg must be private key");
    if (m(H) === !1)
      throw new Error("second arg must be public key");
    return n.fromHex(H).multiply(f(V)).toBytes(L);
  }
  const C = e.bits2int || function(V) {
    if (V.length > 8192)
      throw new Error("input is too large");
    const H = _a(V), L = V.length * 8 - l;
    return L > 0 ? H >> BigInt(L) : H;
  }, A = e.bits2int_modN || function(V) {
    return o.create(C(V));
  }, P = Ra(l);
  function I(V) {
    return Bs("num < 2^" + l, V, gi, P), o.toBytes(V);
  }
  function U(V, H, L = j) {
    if (["recovered", "canonical"].some((te) => te in L))
      throw new Error("sign() legacy options not supported");
    const { hash: g } = e;
    let { lowS: x, prehash: w, extraEntropy: _ } = L;
    x == null && (x = !0), V = Tt("msgHash", V), Nd(L), w && (V = Tt("prehashed msgHash", g(V)));
    const D = A(V), O = f(H), N = [I(O), I(D)];
    if (_ != null && _ !== !1) {
      const te = _ === !0 ? r(i.BYTES) : _;
      N.push(Tt("extraEntropy", te));
    }
    const R = An(...N), v = D;
    function M(te) {
      const ee = C(te);
      if (!o.isValidNot0(ee))
        return;
      const ne = o.inv(ee), Ce = n.BASE.multiply(ee).toAffine(), ve = o.create(Ce.x);
      if (ve === gi)
        return;
      const Ae = o.create(ne * o.create(v + ve * O));
      if (Ae === gi)
        return;
      let qt = (Ce.x === ve ? 0 : 2) | Number(Ce.y & pi), qe = Ae;
      return x && c(Ae) && (qe = u(Ae), qt ^= 1), new h(ve, qe, qt);
    }
    return { seed: R, k2sig: M };
  }
  const j = { lowS: e.lowS, prehash: !1 }, G = { lowS: e.lowS, prehash: !1 };
  function F(V, H, L = j) {
    const { seed: g, k2sig: x } = U(V, H, L);
    return cy(e.hash.outputLen, o.BYTES, s)(g, x);
  }
  n.BASE.precompute(8);
  function B(V, H, L, g = G) {
    const x = V;
    H = Tt("msgHash", H), L = Tt("publicKey", L), Nd(g);
    const { lowS: w, prehash: _, format: D } = g;
    if ("strict" in g)
      throw new Error("options.strict was renamed to lowS");
    if (D !== void 0 && !["compact", "der", "js"].includes(D))
      throw new Error('format must be "compact", "der" or "js"');
    const O = typeof x == "string" || iu(x), N = !O && !D && typeof x == "object" && x !== null && typeof x.r == "bigint" && typeof x.s == "bigint";
    if (!O && !N)
      throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
    let R, v;
    try {
      if (N)
        if (D === void 0 || D === "js")
          R = new h(x.r, x.s);
        else
          throw new Error("invalid format");
      if (O) {
        try {
          D !== "compact" && (R = h.fromDER(x));
        } catch (qe) {
          if (!(qe instanceof bn.Err))
            throw qe;
        }
        !R && D !== "der" && (R = h.fromCompact(x));
      }
      v = n.fromHex(L);
    } catch {
      return !1;
    }
    if (!R || w && R.hasHighS())
      return !1;
    _ && (H = e.hash(H));
    const { r: M, s: te } = R, ee = A(H), ne = o.inv(te), Ce = o.create(ee * ne), ve = o.create(M * ne), Ae = n.BASE.multiplyUnsafe(Ce).add(v.multiplyUnsafe(ve));
    return Ae.is0() ? !1 : o.create(Ae.x) === M;
  }
  return Object.freeze({
    getPublicKey: y,
    getSharedSecret: b,
    sign: F,
    verify: B,
    utils: p,
    Point: n,
    Signature: h
  });
}
function Sx(n) {
  const e = {
    a: n.a,
    b: n.b,
    p: n.Fp.ORDER,
    n: n.n,
    h: n.h,
    Gx: n.Gx,
    Gy: n.Gy
  }, t = n.Fp, r = ri(e.n, n.nBitLength), s = {
    Fp: t,
    Fn: r,
    allowedPrivateKeyLengths: n.allowedPrivateKeyLengths,
    allowInfinityPoint: n.allowInfinityPoint,
    endo: n.endo,
    wrapPrivateKey: n.wrapPrivateKey,
    isTorsionFree: n.isTorsionFree,
    clearCofactor: n.clearCofactor,
    fromBytes: n.fromBytes,
    toBytes: n.toBytes
  };
  return { CURVE: e, curveOpts: s };
}
function bx(n) {
  const { CURVE: e, curveOpts: t } = Sx(n), r = {
    hash: n.hash,
    hmac: n.hmac,
    randomBytes: n.randomBytes,
    lowS: n.lowS,
    bits2int: n.bits2int,
    bits2int_modN: n.bits2int_modN
  };
  return { CURVE: e, curveOpts: t, ecdsaOpts: r };
}
function Tx(n, e) {
  return Object.assign({}, e, {
    ProjectivePoint: e.Point,
    CURVE: n
  });
}
function wx(n) {
  const { CURVE: e, curveOpts: t, ecdsaOpts: r } = bx(n), s = xx(e, t), i = Ex(s, r, t);
  return Tx(n, i);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function Ax(n, e) {
  const t = (r) => wx({ ...n, hash: r });
  return { ...t(e), create: t };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const na = {
  p: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
  n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
  h: BigInt(1),
  a: BigInt(0),
  b: BigInt(7),
  Gx: BigInt("0x79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798"),
  Gy: BigInt("0x483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8")
};
BigInt(0);
const Ix = BigInt(1), pc = BigInt(2), Ud = (n, e) => (n + e / pc) / e;
function _x(n) {
  const e = na.p, t = BigInt(3), r = BigInt(6), s = BigInt(11), i = BigInt(22), o = BigInt(23), a = BigInt(44), l = BigInt(88), c = n * n * n % e, u = c * c * n % e, d = xt(u, t, e) * u % e, h = xt(d, t, e) * u % e, f = xt(h, pc, e) * c % e, p = xt(f, s, e) * f % e, y = xt(p, i, e) * p % e, m = xt(y, a, e) * y % e, b = xt(m, l, e) * m % e, C = xt(b, a, e) * y % e, A = xt(C, t, e) * u % e, P = xt(A, o, e) * p % e, I = xt(P, r, e) * c % e, U = xt(I, pc, e);
  if (!mc.eql(mc.sqr(U), n))
    throw new Error("Cannot find square root");
  return U;
}
const mc = ri(na.p, void 0, void 0, { sqrt: _x }), Lx = Ax({
  ...na,
  Fp: mc,
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  endo: {
    // Endomorphism, see above
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (n) => {
      const e = na.n, t = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), r = -Ix * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), s = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), i = t, o = BigInt("0x100000000000000000000000000000000"), a = Ud(i * n, e), l = Ud(-r * n, e);
      let c = wt(n - a * t - l * s, e), u = wt(-a * r - l * i, e);
      const d = c > o, h = u > o;
      if (d && (c = e - c), h && (u = e - u), c > o || u > o)
        throw new Error("splitScalar: Endomorphism failed, k=" + n);
      return { k1neg: d, k1: c, k2neg: h, k2: u };
    }
  }
}, Zf);
zi.utils.randomPrivateKey;
zi.getPublicKey;
function $d(n) {
  try {
    return zi.ExtendedPoint.fromHex(n), !0;
  } catch {
    return !1;
  }
}
const Q0 = (n, e) => zi.sign(n, e.slice(0, 32)), Rx = zi.verify, Tu = (n) => $e.Buffer.isBuffer(n) ? n : n instanceof Uint8Array ? $e.Buffer.from(n.buffer, n.byteOffset, n.byteLength) : $e.Buffer.from(n);
class Cx {
  constructor(e) {
    Object.assign(this, e);
  }
  encode() {
    return $e.Buffer.from(x0(_o, this));
  }
  static decode(e) {
    return E0(_o, this, e);
  }
  static decodeUnchecked(e) {
    return g0(_o, this, e);
  }
}
const _o = /* @__PURE__ */ new Map();
var eg;
const kx = 32, qn = 32;
function Dx(n) {
  return n._bn !== void 0;
}
let Gd = 1;
class De extends Cx {
  /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */
  constructor(e) {
    if (super({}), this._bn = void 0, Dx(e))
      this._bn = e._bn;
    else {
      if (typeof e == "string") {
        const t = hr.decode(e);
        if (t.length != qn)
          throw new Error("Invalid public key input");
        this._bn = new Md(t);
      } else
        this._bn = new Md(e);
      if (this._bn.byteLength() > qn)
        throw new Error("Invalid public key input");
    }
  }
  /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */
  static unique() {
    const e = new De(Gd);
    return Gd += 1, new De(e.toBuffer());
  }
  /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */
  /**
   * Checks if two publicKeys are equal
   */
  equals(e) {
    return this._bn.eq(e._bn);
  }
  /**
   * Return the base-58 representation of the public key
   */
  toBase58() {
    return hr.encode(this.toBytes());
  }
  toJSON() {
    return this.toBase58();
  }
  /**
   * Return the byte array representation of the public key in big endian
   */
  toBytes() {
    const e = this.toBuffer();
    return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
  }
  /**
   * Return the Buffer representation of the public key in big endian
   */
  toBuffer() {
    const e = this._bn.toArrayLike($e.Buffer);
    if (e.length === qn)
      return e;
    const t = $e.Buffer.alloc(32);
    return e.copy(t, 32 - e.length), t;
  }
  get [Symbol.toStringTag]() {
    return `PublicKey(${this.toString()})`;
  }
  /**
   * Return the base-58 representation of the public key
   */
  toString() {
    return this.toBase58();
  }
  /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */
  /* eslint-disable require-await */
  static async createWithSeed(e, t, r) {
    const s = $e.Buffer.concat([e.toBuffer(), $e.Buffer.from(t), r.toBuffer()]), i = Od(s);
    return new De(i);
  }
  /**
   * Derive a program address from seeds and a program ID.
   */
  /* eslint-disable require-await */
  static createProgramAddressSync(e, t) {
    let r = $e.Buffer.alloc(0);
    e.forEach(function(i) {
      if (i.length > kx)
        throw new TypeError("Max seed length exceeded");
      r = $e.Buffer.concat([r, Tu(i)]);
    }), r = $e.Buffer.concat([r, t.toBuffer(), $e.Buffer.from("ProgramDerivedAddress")]);
    const s = Od(r);
    if ($d(s))
      throw new Error("Invalid seeds, address must fall off the curve");
    return new De(s);
  }
  /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */
  /* eslint-disable require-await */
  static async createProgramAddress(e, t) {
    return this.createProgramAddressSync(e, t);
  }
  /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */
  static findProgramAddressSync(e, t) {
    let r = 255, s;
    for (; r != 0; ) {
      try {
        const i = e.concat($e.Buffer.from([r]));
        s = this.createProgramAddressSync(i, t);
      } catch (i) {
        if (i instanceof TypeError)
          throw i;
        r--;
        continue;
      }
      return [s, r];
    }
    throw new Error("Unable to find a viable program address nonce");
  }
  /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */
  static async findProgramAddress(e, t) {
    return this.findProgramAddressSync(e, t);
  }
  /**
   * Check that a pubkey is on the ed25519 curve.
   */
  static isOnCurve(e) {
    const t = new De(e);
    return $d(t.toBytes());
  }
}
eg = De;
De.default = new eg("11111111111111111111111111111111");
_o.set(De, {
  kind: "struct",
  fields: [["_bn", "u256"]]
});
new De("BPFLoader1111111111111111111111111111111111");
const $s = 1232, wu = 127, sa = 64;
class ia {
  constructor(e, t) {
    this.staticAccountKeys = void 0, this.accountKeysFromLookups = void 0, this.staticAccountKeys = e, this.accountKeysFromLookups = t;
  }
  keySegments() {
    const e = [this.staticAccountKeys];
    return this.accountKeysFromLookups && (e.push(this.accountKeysFromLookups.writable), e.push(this.accountKeysFromLookups.readonly)), e;
  }
  get(e) {
    for (const t of this.keySegments()) {
      if (e < t.length)
        return t[e];
      e -= t.length;
    }
  }
  get length() {
    return this.keySegments().flat().length;
  }
  compileInstructions(e) {
    if (this.length > 256)
      throw new Error("Account index overflow encountered during compilation");
    const r = /* @__PURE__ */ new Map();
    this.keySegments().flat().forEach((i, o) => {
      r.set(i.toBase58(), o);
    });
    const s = (i) => {
      const o = r.get(i.toBase58());
      if (o === void 0) throw new Error("Encountered an unknown instruction account key during compilation");
      return o;
    };
    return e.map((i) => ({
      programIdIndex: s(i.programId),
      accountKeyIndexes: i.keys.map((o) => s(o.pubkey)),
      data: i.data
    }));
  }
}
const He = (n = "publicKey") => gt(32, n), Px = (n = "signature") => gt(64, n), Fs = (n = "string") => {
  const e = pe([Ee("length"), Ee("lengthPadding"), gt(as(Ee(), -8), "chars")], n), t = e.decode.bind(e), r = e.encode.bind(e), s = e;
  return s.decode = (i, o) => t(i, o).chars.toString(), s.encode = (i, o, a) => {
    const l = {
      chars: $e.Buffer.from(i, "utf8")
    };
    return r(l, o, a);
  }, s.alloc = (i) => Ee().span + Ee().span + $e.Buffer.from(i, "utf8").length, s;
}, Mx = (n = "authorized") => pe([He("staker"), He("withdrawer")], n), Ox = (n = "lockup") => pe([br("unixTimestamp"), br("epoch"), He("custodian")], n), Bx = (n = "voteInit") => pe([He("nodePubkey"), He("authorizedVoter"), He("authorizedWithdrawer"), Je("commission")], n), Fx = (n = "voteAuthorizeWithSeedArgs") => pe([Ee("voteAuthorizationType"), He("currentAuthorityDerivedKeyOwnerPubkey"), Fs("currentAuthorityDerivedKeySeed"), He("newAuthorized")], n);
function Tr(n) {
  let e = 0, t = 0;
  for (; ; ) {
    let r = n.shift();
    if (e |= (r & 127) << t * 7, t += 1, !(r & 128))
      break;
  }
  return e;
}
function wr(n, e) {
  let t = e;
  for (; ; ) {
    let r = t & 127;
    if (t >>= 7, t == 0) {
      n.push(r);
      break;
    } else
      r |= 128, n.push(r);
  }
}
function Kt(n, e) {
  if (!n)
    throw new Error(e || "Assertion failed");
}
class Fa {
  constructor(e, t) {
    this.payer = void 0, this.keyMetaMap = void 0, this.payer = e, this.keyMetaMap = t;
  }
  static compile(e, t) {
    const r = /* @__PURE__ */ new Map(), s = (o) => {
      const a = o.toBase58();
      let l = r.get(a);
      return l === void 0 && (l = {
        isSigner: !1,
        isWritable: !1,
        isInvoked: !1
      }, r.set(a, l)), l;
    }, i = s(t);
    i.isSigner = !0, i.isWritable = !0;
    for (const o of e) {
      s(o.programId).isInvoked = !0;
      for (const a of o.keys) {
        const l = s(a.pubkey);
        l.isSigner || (l.isSigner = a.isSigner), l.isWritable || (l.isWritable = a.isWritable);
      }
    }
    return new Fa(t, r);
  }
  getMessageComponents() {
    const e = [...this.keyMetaMap.entries()];
    Kt(e.length <= 256, "Max static account keys length exceeded");
    const t = e.filter(([, l]) => l.isSigner && l.isWritable), r = e.filter(([, l]) => l.isSigner && !l.isWritable), s = e.filter(([, l]) => !l.isSigner && l.isWritable), i = e.filter(([, l]) => !l.isSigner && !l.isWritable), o = {
      numRequiredSignatures: t.length + r.length,
      numReadonlySignedAccounts: r.length,
      numReadonlyUnsignedAccounts: i.length
    };
    {
      Kt(t.length > 0, "Expected at least one writable signer key");
      const [l] = t[0];
      Kt(l === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
    }
    const a = [...t.map(([l]) => new De(l)), ...r.map(([l]) => new De(l)), ...s.map(([l]) => new De(l)), ...i.map(([l]) => new De(l))];
    return [o, a];
  }
  extractTableLookup(e) {
    const [t, r] = this.drainKeysFoundInLookupTable(e.state.addresses, (o) => !o.isSigner && !o.isInvoked && o.isWritable), [s, i] = this.drainKeysFoundInLookupTable(e.state.addresses, (o) => !o.isSigner && !o.isInvoked && !o.isWritable);
    if (!(t.length === 0 && s.length === 0))
      return [{
        accountKey: e.key,
        writableIndexes: t,
        readonlyIndexes: s
      }, {
        writable: r,
        readonly: i
      }];
  }
  /** @internal */
  drainKeysFoundInLookupTable(e, t) {
    const r = new Array(), s = new Array();
    for (const [i, o] of this.keyMetaMap.entries())
      if (t(o)) {
        const a = new De(i), l = e.findIndex((c) => c.equals(a));
        l >= 0 && (Kt(l < 256, "Max lookup table index exceeded"), r.push(l), s.push(a), this.keyMetaMap.delete(i));
      }
    return [r, s];
  }
}
const tg = "Reached end of buffer unexpectedly";
function wn(n) {
  if (n.length === 0)
    throw new Error(tg);
  return n.shift();
}
function Ar(n, ...e) {
  const [t] = e;
  if (e.length === 2 ? t + (e[1] ?? 0) > n.length : t >= n.length)
    throw new Error(tg);
  return n.splice(...e);
}
class Zs {
  constructor(e) {
    this.header = void 0, this.accountKeys = void 0, this.recentBlockhash = void 0, this.instructions = void 0, this.indexToProgramIds = /* @__PURE__ */ new Map(), this.header = e.header, this.accountKeys = e.accountKeys.map((t) => new De(t)), this.recentBlockhash = e.recentBlockhash, this.instructions = e.instructions, this.instructions.forEach((t) => this.indexToProgramIds.set(t.programIdIndex, this.accountKeys[t.programIdIndex]));
  }
  get version() {
    return "legacy";
  }
  get staticAccountKeys() {
    return this.accountKeys;
  }
  get compiledInstructions() {
    return this.instructions.map((e) => ({
      programIdIndex: e.programIdIndex,
      accountKeyIndexes: e.accounts,
      data: hr.decode(e.data)
    }));
  }
  get addressTableLookups() {
    return [];
  }
  getAccountKeys() {
    return new ia(this.staticAccountKeys);
  }
  static compile(e) {
    const t = Fa.compile(e.instructions, e.payerKey), [r, s] = t.getMessageComponents(), o = new ia(s).compileInstructions(e.instructions).map((a) => ({
      programIdIndex: a.programIdIndex,
      accounts: a.accountKeyIndexes,
      data: hr.encode(a.data)
    }));
    return new Zs({
      header: r,
      accountKeys: s,
      recentBlockhash: e.recentBlockhash,
      instructions: o
    });
  }
  isAccountSigner(e) {
    return e < this.header.numRequiredSignatures;
  }
  isAccountWritable(e) {
    const t = this.header.numRequiredSignatures;
    if (e >= this.header.numRequiredSignatures) {
      const r = e - t, i = this.accountKeys.length - t - this.header.numReadonlyUnsignedAccounts;
      return r < i;
    } else {
      const r = t - this.header.numReadonlySignedAccounts;
      return e < r;
    }
  }
  isProgramId(e) {
    return this.indexToProgramIds.has(e);
  }
  programIds() {
    return [...this.indexToProgramIds.values()];
  }
  nonProgramIds() {
    return this.accountKeys.filter((e, t) => !this.isProgramId(t));
  }
  serialize() {
    const e = this.accountKeys.length;
    let t = [];
    wr(t, e);
    const r = this.instructions.map((d) => {
      const {
        accounts: h,
        programIdIndex: f
      } = d, p = Array.from(hr.decode(d.data));
      let y = [];
      wr(y, h.length);
      let m = [];
      return wr(m, p.length), {
        programIdIndex: f,
        keyIndicesCount: $e.Buffer.from(y),
        keyIndices: h,
        dataLength: $e.Buffer.from(m),
        data: p
      };
    });
    let s = [];
    wr(s, r.length);
    let i = $e.Buffer.alloc($s);
    $e.Buffer.from(s).copy(i);
    let o = s.length;
    r.forEach((d) => {
      const f = pe([Je("programIdIndex"), gt(d.keyIndicesCount.length, "keyIndicesCount"), gr(Je("keyIndex"), d.keyIndices.length, "keyIndices"), gt(d.dataLength.length, "dataLength"), gr(Je("userdatum"), d.data.length, "data")]).encode(d, i, o);
      o += f;
    }), i = i.slice(0, o);
    const a = pe([gt(1, "numRequiredSignatures"), gt(1, "numReadonlySignedAccounts"), gt(1, "numReadonlyUnsignedAccounts"), gt(t.length, "keyCount"), gr(He("key"), e, "keys"), He("recentBlockhash")]), l = {
      numRequiredSignatures: $e.Buffer.from([this.header.numRequiredSignatures]),
      numReadonlySignedAccounts: $e.Buffer.from([this.header.numReadonlySignedAccounts]),
      numReadonlyUnsignedAccounts: $e.Buffer.from([this.header.numReadonlyUnsignedAccounts]),
      keyCount: $e.Buffer.from(t),
      keys: this.accountKeys.map((d) => Tu(d.toBytes())),
      recentBlockhash: hr.decode(this.recentBlockhash)
    };
    let c = $e.Buffer.alloc(2048);
    const u = a.encode(l, c);
    return i.copy(c, u), c.slice(0, u + i.length);
  }
  /**
   * Decode a compiled message into a Message object.
   */
  static from(e) {
    let t = [...e];
    const r = wn(t);
    if (r !== (r & wu))
      throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
    const s = wn(t), i = wn(t), o = Tr(t);
    let a = [];
    for (let h = 0; h < o; h++) {
      const f = Ar(t, 0, qn);
      a.push(new De($e.Buffer.from(f)));
    }
    const l = Ar(t, 0, qn), c = Tr(t);
    let u = [];
    for (let h = 0; h < c; h++) {
      const f = wn(t), p = Tr(t), y = Ar(t, 0, p), m = Tr(t), b = Ar(t, 0, m), C = hr.encode($e.Buffer.from(b));
      u.push({
        programIdIndex: f,
        accounts: y,
        data: C
      });
    }
    const d = {
      header: {
        numRequiredSignatures: r,
        numReadonlySignedAccounts: s,
        numReadonlyUnsignedAccounts: i
      },
      recentBlockhash: hr.encode($e.Buffer.from(l)),
      accountKeys: a,
      instructions: u
    };
    return new Zs(d);
  }
}
class oa {
  constructor(e) {
    this.header = void 0, this.staticAccountKeys = void 0, this.recentBlockhash = void 0, this.compiledInstructions = void 0, this.addressTableLookups = void 0, this.header = e.header, this.staticAccountKeys = e.staticAccountKeys, this.recentBlockhash = e.recentBlockhash, this.compiledInstructions = e.compiledInstructions, this.addressTableLookups = e.addressTableLookups;
  }
  get version() {
    return 0;
  }
  get numAccountKeysFromLookups() {
    let e = 0;
    for (const t of this.addressTableLookups)
      e += t.readonlyIndexes.length + t.writableIndexes.length;
    return e;
  }
  getAccountKeys(e) {
    let t;
    if (e && "accountKeysFromLookups" in e && e.accountKeysFromLookups) {
      if (this.numAccountKeysFromLookups != e.accountKeysFromLookups.writable.length + e.accountKeysFromLookups.readonly.length)
        throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
      t = e.accountKeysFromLookups;
    } else if (e && "addressLookupTableAccounts" in e && e.addressLookupTableAccounts)
      t = this.resolveAddressTableLookups(e.addressLookupTableAccounts);
    else if (this.addressTableLookups.length > 0)
      throw new Error("Failed to get account keys because address table lookups were not resolved");
    return new ia(this.staticAccountKeys, t);
  }
  isAccountSigner(e) {
    return e < this.header.numRequiredSignatures;
  }
  isAccountWritable(e) {
    const t = this.header.numRequiredSignatures, r = this.staticAccountKeys.length;
    if (e >= r) {
      const s = e - r, i = this.addressTableLookups.reduce((o, a) => o + a.writableIndexes.length, 0);
      return s < i;
    } else if (e >= this.header.numRequiredSignatures) {
      const s = e - t, o = r - t - this.header.numReadonlyUnsignedAccounts;
      return s < o;
    } else {
      const s = t - this.header.numReadonlySignedAccounts;
      return e < s;
    }
  }
  resolveAddressTableLookups(e) {
    const t = {
      writable: [],
      readonly: []
    };
    for (const r of this.addressTableLookups) {
      const s = e.find((i) => i.key.equals(r.accountKey));
      if (!s)
        throw new Error(`Failed to find address lookup table account for table key ${r.accountKey.toBase58()}`);
      for (const i of r.writableIndexes)
        if (i < s.state.addresses.length)
          t.writable.push(s.state.addresses[i]);
        else
          throw new Error(`Failed to find address for index ${i} in address lookup table ${r.accountKey.toBase58()}`);
      for (const i of r.readonlyIndexes)
        if (i < s.state.addresses.length)
          t.readonly.push(s.state.addresses[i]);
        else
          throw new Error(`Failed to find address for index ${i} in address lookup table ${r.accountKey.toBase58()}`);
    }
    return t;
  }
  static compile(e) {
    const t = Fa.compile(e.instructions, e.payerKey), r = new Array(), s = {
      writable: new Array(),
      readonly: new Array()
    }, i = e.addressLookupTableAccounts || [];
    for (const u of i) {
      const d = t.extractTableLookup(u);
      if (d !== void 0) {
        const [h, {
          writable: f,
          readonly: p
        }] = d;
        r.push(h), s.writable.push(...f), s.readonly.push(...p);
      }
    }
    const [o, a] = t.getMessageComponents(), c = new ia(a, s).compileInstructions(e.instructions);
    return new oa({
      header: o,
      staticAccountKeys: a,
      recentBlockhash: e.recentBlockhash,
      compiledInstructions: c,
      addressTableLookups: r
    });
  }
  serialize() {
    const e = Array();
    wr(e, this.staticAccountKeys.length);
    const t = this.serializeInstructions(), r = Array();
    wr(r, this.compiledInstructions.length);
    const s = this.serializeAddressTableLookups(), i = Array();
    wr(i, this.addressTableLookups.length);
    const o = pe([Je("prefix"), pe([Je("numRequiredSignatures"), Je("numReadonlySignedAccounts"), Je("numReadonlyUnsignedAccounts")], "header"), gt(e.length, "staticAccountKeysLength"), gr(He(), this.staticAccountKeys.length, "staticAccountKeys"), He("recentBlockhash"), gt(r.length, "instructionsLength"), gt(t.length, "serializedInstructions"), gt(i.length, "addressTableLookupsLength"), gt(s.length, "serializedAddressTableLookups")]), a = new Uint8Array($s), c = o.encode({
      prefix: 128,
      header: this.header,
      staticAccountKeysLength: new Uint8Array(e),
      staticAccountKeys: this.staticAccountKeys.map((u) => u.toBytes()),
      recentBlockhash: hr.decode(this.recentBlockhash),
      instructionsLength: new Uint8Array(r),
      serializedInstructions: t,
      addressTableLookupsLength: new Uint8Array(i),
      serializedAddressTableLookups: s
    }, a);
    return a.slice(0, c);
  }
  serializeInstructions() {
    let e = 0;
    const t = new Uint8Array($s);
    for (const r of this.compiledInstructions) {
      const s = Array();
      wr(s, r.accountKeyIndexes.length);
      const i = Array();
      wr(i, r.data.length);
      const o = pe([Je("programIdIndex"), gt(s.length, "encodedAccountKeyIndexesLength"), gr(Je(), r.accountKeyIndexes.length, "accountKeyIndexes"), gt(i.length, "encodedDataLength"), gt(r.data.length, "data")]);
      e += o.encode({
        programIdIndex: r.programIdIndex,
        encodedAccountKeyIndexesLength: new Uint8Array(s),
        accountKeyIndexes: r.accountKeyIndexes,
        encodedDataLength: new Uint8Array(i),
        data: r.data
      }, t, e);
    }
    return t.slice(0, e);
  }
  serializeAddressTableLookups() {
    let e = 0;
    const t = new Uint8Array($s);
    for (const r of this.addressTableLookups) {
      const s = Array();
      wr(s, r.writableIndexes.length);
      const i = Array();
      wr(i, r.readonlyIndexes.length);
      const o = pe([He("accountKey"), gt(s.length, "encodedWritableIndexesLength"), gr(Je(), r.writableIndexes.length, "writableIndexes"), gt(i.length, "encodedReadonlyIndexesLength"), gr(Je(), r.readonlyIndexes.length, "readonlyIndexes")]);
      e += o.encode({
        accountKey: r.accountKey.toBytes(),
        encodedWritableIndexesLength: new Uint8Array(s),
        writableIndexes: r.writableIndexes,
        encodedReadonlyIndexesLength: new Uint8Array(i),
        readonlyIndexes: r.readonlyIndexes
      }, t, e);
    }
    return t.slice(0, e);
  }
  static deserialize(e) {
    let t = [...e];
    const r = wn(t), s = r & wu;
    Kt(r !== s, "Expected versioned message but received legacy message");
    const i = s;
    Kt(i === 0, `Expected versioned message with version 0 but found version ${i}`);
    const o = {
      numRequiredSignatures: wn(t),
      numReadonlySignedAccounts: wn(t),
      numReadonlyUnsignedAccounts: wn(t)
    }, a = [], l = Tr(t);
    for (let p = 0; p < l; p++)
      a.push(new De(Ar(t, 0, qn)));
    const c = hr.encode(Ar(t, 0, qn)), u = Tr(t), d = [];
    for (let p = 0; p < u; p++) {
      const y = wn(t), m = Tr(t), b = Ar(t, 0, m), C = Tr(t), A = new Uint8Array(Ar(t, 0, C));
      d.push({
        programIdIndex: y,
        accountKeyIndexes: b,
        data: A
      });
    }
    const h = Tr(t), f = [];
    for (let p = 0; p < h; p++) {
      const y = new De(Ar(t, 0, qn)), m = Tr(t), b = Ar(t, 0, m), C = Tr(t), A = Ar(t, 0, C);
      f.push({
        accountKey: y,
        writableIndexes: b,
        readonlyIndexes: A
      });
    }
    return new oa({
      header: o,
      staticAccountKeys: a,
      recentBlockhash: c,
      compiledInstructions: d,
      addressTableLookups: f
    });
  }
}
const Au = {
  deserializeMessageVersion(n) {
    const e = n[0], t = e & wu;
    return t === e ? "legacy" : t;
  },
  deserialize: (n) => {
    const e = Au.deserializeMessageVersion(n);
    if (e === "legacy")
      return Zs.from(n);
    if (e === 0)
      return oa.deserialize(n);
    throw new Error(`Transaction message version ${e} deserialization is not supported`);
  }
}, Nx = $e.Buffer.alloc(sa).fill(0);
class jd {
  constructor(e) {
    this.keys = void 0, this.programId = void 0, this.data = $e.Buffer.alloc(0), this.programId = e.programId, this.keys = e.keys, e.data && (this.data = e.data);
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      keys: this.keys.map(({
        pubkey: e,
        isSigner: t,
        isWritable: r
      }) => ({
        pubkey: e.toJSON(),
        isSigner: t,
        isWritable: r
      })),
      programId: this.programId.toJSON(),
      data: [...this.data]
    };
  }
}
class aa {
  /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */
  get signature() {
    return this.signatures.length > 0 ? this.signatures[0].signature : null;
  }
  /**
   * The transaction fee payer
   */
  // Construct a transaction with a blockhash and lastValidBlockHeight
  // Construct a transaction using a durable nonce
  /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */
  /**
   * Construct an empty Transaction
   */
  constructor(e) {
    if (this.signatures = [], this.feePayer = void 0, this.instructions = [], this.recentBlockhash = void 0, this.lastValidBlockHeight = void 0, this.nonceInfo = void 0, this.minNonceContextSlot = void 0, this._message = void 0, this._json = void 0, !!e)
      if (e.feePayer && (this.feePayer = e.feePayer), e.signatures && (this.signatures = e.signatures), Object.prototype.hasOwnProperty.call(e, "nonceInfo")) {
        const {
          minContextSlot: t,
          nonceInfo: r
        } = e;
        this.minNonceContextSlot = t, this.nonceInfo = r;
      } else if (Object.prototype.hasOwnProperty.call(e, "lastValidBlockHeight")) {
        const {
          blockhash: t,
          lastValidBlockHeight: r
        } = e;
        this.recentBlockhash = t, this.lastValidBlockHeight = r;
      } else {
        const {
          recentBlockhash: t,
          nonceInfo: r
        } = e;
        r && (this.nonceInfo = r), this.recentBlockhash = t;
      }
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      recentBlockhash: this.recentBlockhash || null,
      feePayer: this.feePayer ? this.feePayer.toJSON() : null,
      nonceInfo: this.nonceInfo ? {
        nonce: this.nonceInfo.nonce,
        nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
      } : null,
      instructions: this.instructions.map((e) => e.toJSON()),
      signers: this.signatures.map(({
        publicKey: e
      }) => e.toJSON())
    };
  }
  /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */
  add(...e) {
    if (e.length === 0)
      throw new Error("No instructions");
    return e.forEach((t) => {
      "instructions" in t ? this.instructions = this.instructions.concat(t.instructions) : "data" in t && "programId" in t && "keys" in t ? this.instructions.push(t) : this.instructions.push(new jd(t));
    }), this;
  }
  /**
   * Compile transaction data
   */
  compileMessage() {
    if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json))
      return this._message;
    let e, t;
    if (this.nonceInfo ? (e = this.nonceInfo.nonce, this.instructions[0] != this.nonceInfo.nonceInstruction ? t = [this.nonceInfo.nonceInstruction, ...this.instructions] : t = this.instructions) : (e = this.recentBlockhash, t = this.instructions), !e)
      throw new Error("Transaction recentBlockhash required");
    t.length < 1 && console.warn("No instructions provided");
    let r;
    if (this.feePayer)
      r = this.feePayer;
    else if (this.signatures.length > 0 && this.signatures[0].publicKey)
      r = this.signatures[0].publicKey;
    else
      throw new Error("Transaction fee payer required");
    for (let y = 0; y < t.length; y++)
      if (t[y].programId === void 0)
        throw new Error(`Transaction instruction index ${y} has undefined program id`);
    const s = [], i = [];
    t.forEach((y) => {
      y.keys.forEach((b) => {
        i.push({
          ...b
        });
      });
      const m = y.programId.toString();
      s.includes(m) || s.push(m);
    }), s.forEach((y) => {
      i.push({
        pubkey: new De(y),
        isSigner: !1,
        isWritable: !1
      });
    });
    const o = [];
    i.forEach((y) => {
      const m = y.pubkey.toString(), b = o.findIndex((C) => C.pubkey.toString() === m);
      b > -1 ? (o[b].isWritable = o[b].isWritable || y.isWritable, o[b].isSigner = o[b].isSigner || y.isSigner) : o.push(y);
    }), o.sort(function(y, m) {
      if (y.isSigner !== m.isSigner)
        return y.isSigner ? -1 : 1;
      if (y.isWritable !== m.isWritable)
        return y.isWritable ? -1 : 1;
      const b = {
        localeMatcher: "best fit",
        usage: "sort",
        sensitivity: "variant",
        ignorePunctuation: !1,
        numeric: !1,
        caseFirst: "lower"
      };
      return y.pubkey.toBase58().localeCompare(m.pubkey.toBase58(), "en", b);
    });
    const a = o.findIndex((y) => y.pubkey.equals(r));
    if (a > -1) {
      const [y] = o.splice(a, 1);
      y.isSigner = !0, y.isWritable = !0, o.unshift(y);
    } else
      o.unshift({
        pubkey: r,
        isSigner: !0,
        isWritable: !0
      });
    for (const y of this.signatures) {
      const m = o.findIndex((b) => b.pubkey.equals(y.publicKey));
      if (m > -1)
        o[m].isSigner || (o[m].isSigner = !0, console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release."));
      else
        throw new Error(`unknown signer: ${y.publicKey.toString()}`);
    }
    let l = 0, c = 0, u = 0;
    const d = [], h = [];
    o.forEach(({
      pubkey: y,
      isSigner: m,
      isWritable: b
    }) => {
      m ? (d.push(y.toString()), l += 1, b || (c += 1)) : (h.push(y.toString()), b || (u += 1));
    });
    const f = d.concat(h), p = t.map((y) => {
      const {
        data: m,
        programId: b
      } = y;
      return {
        programIdIndex: f.indexOf(b.toString()),
        accounts: y.keys.map((C) => f.indexOf(C.pubkey.toString())),
        data: hr.encode(m)
      };
    });
    return p.forEach((y) => {
      Kt(y.programIdIndex >= 0), y.accounts.forEach((m) => Kt(m >= 0));
    }), new Zs({
      header: {
        numRequiredSignatures: l,
        numReadonlySignedAccounts: c,
        numReadonlyUnsignedAccounts: u
      },
      accountKeys: f,
      recentBlockhash: e,
      instructions: p
    });
  }
  /**
   * @internal
   */
  _compile() {
    const e = this.compileMessage(), t = e.accountKeys.slice(0, e.header.numRequiredSignatures);
    return this.signatures.length === t.length && this.signatures.every((s, i) => t[i].equals(s.publicKey)) || (this.signatures = t.map((r) => ({
      signature: null,
      publicKey: r
    }))), e;
  }
  /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */
  serializeMessage() {
    return this._compile().serialize();
  }
  /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */
  async getEstimatedFee(e) {
    return (await e.getFeeForMessage(this.compileMessage())).value;
  }
  /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */
  setSigners(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const t = /* @__PURE__ */ new Set();
    this.signatures = e.filter((r) => {
      const s = r.toString();
      return t.has(s) ? !1 : (t.add(s), !0);
    }).map((r) => ({
      signature: null,
      publicKey: r
    }));
  }
  /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */
  sign(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const t = /* @__PURE__ */ new Set(), r = [];
    for (const i of e) {
      const o = i.publicKey.toString();
      t.has(o) || (t.add(o), r.push(i));
    }
    this.signatures = r.map((i) => ({
      signature: null,
      publicKey: i.publicKey
    }));
    const s = this._compile();
    this._partialSign(s, ...r);
  }
  /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */
  partialSign(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const t = /* @__PURE__ */ new Set(), r = [];
    for (const i of e) {
      const o = i.publicKey.toString();
      t.has(o) || (t.add(o), r.push(i));
    }
    const s = this._compile();
    this._partialSign(s, ...r);
  }
  /**
   * @internal
   */
  _partialSign(e, ...t) {
    const r = e.serialize();
    t.forEach((s) => {
      const i = Q0(r, s.secretKey);
      this._addSignature(s.publicKey, Tu(i));
    });
  }
  /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */
  addSignature(e, t) {
    this._compile(), this._addSignature(e, t);
  }
  /**
   * @internal
   */
  _addSignature(e, t) {
    Kt(t.length === 64);
    const r = this.signatures.findIndex((s) => e.equals(s.publicKey));
    if (r < 0)
      throw new Error(`unknown signer: ${e.toString()}`);
    this.signatures[r].signature = $e.Buffer.from(t);
  }
  /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */
  verifySignatures(e = !0) {
    return !this._getMessageSignednessErrors(this.serializeMessage(), e);
  }
  /**
   * @internal
   */
  _getMessageSignednessErrors(e, t) {
    const r = {};
    for (const {
      signature: s,
      publicKey: i
    } of this.signatures)
      s === null ? t && (r.missing || (r.missing = [])).push(i) : Rx(s, e, i.toBytes()) || (r.invalid || (r.invalid = [])).push(i);
    return r.invalid || r.missing ? r : void 0;
  }
  /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */
  serialize(e) {
    const {
      requireAllSignatures: t,
      verifySignatures: r
    } = Object.assign({
      requireAllSignatures: !0,
      verifySignatures: !0
    }, e), s = this.serializeMessage();
    if (r) {
      const i = this._getMessageSignednessErrors(s, t);
      if (i) {
        let o = "Signature verification failed.";
        throw i.invalid && (o += `
Invalid signature for public key${i.invalid.length === 1 ? "" : "(s)"} [\`${i.invalid.map((a) => a.toBase58()).join("`, `")}\`].`), i.missing && (o += `
Missing signature for public key${i.missing.length === 1 ? "" : "(s)"} [\`${i.missing.map((a) => a.toBase58()).join("`, `")}\`].`), new Error(o);
      }
    }
    return this._serialize(s);
  }
  /**
   * @internal
   */
  _serialize(e) {
    const {
      signatures: t
    } = this, r = [];
    wr(r, t.length);
    const s = r.length + t.length * 64 + e.length, i = $e.Buffer.alloc(s);
    return Kt(t.length < 256), $e.Buffer.from(r).copy(i, 0), t.forEach(({
      signature: o
    }, a) => {
      o !== null && (Kt(o.length === 64, "signature has invalid length"), $e.Buffer.from(o).copy(i, r.length + a * 64));
    }), e.copy(i, r.length + t.length * 64), Kt(i.length <= $s, `Transaction too large: ${i.length} > ${$s}`), i;
  }
  /**
   * Deprecated method
   * @internal
   */
  get keys() {
    return Kt(this.instructions.length === 1), this.instructions[0].keys.map((e) => e.pubkey);
  }
  /**
   * Deprecated method
   * @internal
   */
  get programId() {
    return Kt(this.instructions.length === 1), this.instructions[0].programId;
  }
  /**
   * Deprecated method
   * @internal
   */
  get data() {
    return Kt(this.instructions.length === 1), this.instructions[0].data;
  }
  /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */
  static from(e) {
    let t = [...e];
    const r = Tr(t);
    let s = [];
    for (let i = 0; i < r; i++) {
      const o = Ar(t, 0, sa);
      s.push(hr.encode($e.Buffer.from(o)));
    }
    return aa.populate(Zs.from(t), s);
  }
  /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */
  static populate(e, t = []) {
    const r = new aa();
    return r.recentBlockhash = e.recentBlockhash, e.header.numRequiredSignatures > 0 && (r.feePayer = e.accountKeys[0]), t.forEach((s, i) => {
      const o = {
        signature: s == hr.encode(Nx) ? null : hr.decode(s),
        publicKey: e.accountKeys[i]
      };
      r.signatures.push(o);
    }), e.instructions.forEach((s) => {
      const i = s.accounts.map((o) => {
        const a = e.accountKeys[o];
        return {
          pubkey: a,
          isSigner: r.signatures.some((l) => l.publicKey.toString() === a.toString()) || e.isAccountSigner(o),
          isWritable: e.isAccountWritable(o)
        };
      });
      r.instructions.push(new jd({
        keys: i,
        programId: e.accountKeys[s.programIdIndex],
        data: hr.decode(s.data)
      }));
    }), r._message = e, r._json = r.toJSON(), r;
  }
}
class Iu {
  get version() {
    return this.message.version;
  }
  constructor(e, t) {
    if (this.signatures = void 0, this.message = void 0, t !== void 0)
      Kt(t.length === e.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures"), this.signatures = t;
    else {
      const r = [];
      for (let s = 0; s < e.header.numRequiredSignatures; s++)
        r.push(new Uint8Array(sa));
      this.signatures = r;
    }
    this.message = e;
  }
  serialize() {
    const e = this.message.serialize(), t = Array();
    wr(t, this.signatures.length);
    const r = pe([gt(t.length, "encodedSignaturesLength"), gr(Px(), this.signatures.length, "signatures"), gt(e.length, "serializedMessage")]), s = new Uint8Array(2048), i = r.encode({
      encodedSignaturesLength: new Uint8Array(t),
      signatures: this.signatures,
      serializedMessage: e
    }, s);
    return s.slice(0, i);
  }
  static deserialize(e) {
    let t = [...e];
    const r = [], s = Tr(t);
    for (let o = 0; o < s; o++)
      r.push(new Uint8Array(Ar(t, 0, sa)));
    const i = Au.deserialize(new Uint8Array(t));
    return new Iu(i, r);
  }
  sign(e) {
    const t = this.message.serialize(), r = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
    for (const s of e) {
      const i = r.findIndex((o) => o.equals(s.publicKey));
      Kt(i >= 0, `Cannot sign with non signer key ${s.publicKey.toBase58()}`), this.signatures[i] = Q0(t, s.secretKey);
    }
  }
  addSignature(e, t) {
    Kt(t.byteLength === 64, "Signature must be 64 bytes long");
    const s = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures).findIndex((i) => i.equals(e));
    Kt(s >= 0, `Can not add signature; \`${e.toBase58()}\` is not required to sign this transaction`), this.signatures[s] = t;
  }
}
new De("SysvarC1ock11111111111111111111111111111111");
new De("SysvarEpochSchedu1e111111111111111111111111");
new De("Sysvar1nstructions1111111111111111111111111");
new De("SysvarRecentB1ockHashes11111111111111111111");
new De("SysvarRent111111111111111111111111111111111");
new De("SysvarRewards111111111111111111111111111111");
new De("SysvarS1otHashes111111111111111111111111111");
new De("SysvarS1otHistory11111111111111111111111111");
new De("SysvarStakeHistory1111111111111111111111111");
const Ux = Qt("lamportsPerSignature"), $x = pe([Ee("version"), Ee("state"), He("authorizedPubkey"), He("nonce"), pe([Ux], "feeCalculator")]);
$x.span;
function Xs(n) {
  const e = gt(8, n), t = e.decode.bind(e), r = e.encode.bind(e), s = e, i = Ov();
  return s.decode = (o, a) => {
    const l = t(o, a);
    return i.decode(l);
  }, s.encode = (o, a, l) => {
    const c = i.encode(o);
    return r(c, a, l);
  }, s;
}
Object.freeze({
  Create: {
    index: 0,
    layout: pe([Ee("instruction"), br("lamports"), br("space"), He("programId")])
  },
  Assign: {
    index: 1,
    layout: pe([Ee("instruction"), He("programId")])
  },
  Transfer: {
    index: 2,
    layout: pe([Ee("instruction"), Xs("lamports")])
  },
  CreateWithSeed: {
    index: 3,
    layout: pe([Ee("instruction"), He("base"), Fs("seed"), br("lamports"), br("space"), He("programId")])
  },
  AdvanceNonceAccount: {
    index: 4,
    layout: pe([Ee("instruction")])
  },
  WithdrawNonceAccount: {
    index: 5,
    layout: pe([Ee("instruction"), br("lamports")])
  },
  InitializeNonceAccount: {
    index: 6,
    layout: pe([Ee("instruction"), He("authorized")])
  },
  AuthorizeNonceAccount: {
    index: 7,
    layout: pe([Ee("instruction"), He("authorized")])
  },
  Allocate: {
    index: 8,
    layout: pe([Ee("instruction"), br("space")])
  },
  AllocateWithSeed: {
    index: 9,
    layout: pe([Ee("instruction"), He("base"), Fs("seed"), br("space"), He("programId")])
  },
  AssignWithSeed: {
    index: 10,
    layout: pe([Ee("instruction"), He("base"), Fs("seed"), He("programId")])
  },
  TransferWithSeed: {
    index: 11,
    layout: pe([Ee("instruction"), Xs("lamports"), Fs("seed"), He("programId")])
  },
  UpgradeNonceAccount: {
    index: 12,
    layout: pe([Ee("instruction")])
  }
});
new De("11111111111111111111111111111111");
new De("BPFLoader2111111111111111111111111111111111");
pe([
  Ee("typeIndex"),
  Xs("deactivationSlot"),
  Qt("lastExtendedSlot"),
  Je("lastExtendedStartIndex"),
  Je(),
  // option
  gr(He(), as(Je(), -1), "authority")
]);
const bt = Xi(Su(De), ie(), (n) => new De(n)), rg = bu([ie(), vt("base64")]), _u = Xi(Su($e.Buffer), rg, (n) => $e.Buffer.from(n[0], "base64"));
function ng(n) {
  return pr([re({
    jsonrpc: vt("2.0"),
    id: ie(),
    result: n
  }), re({
    jsonrpc: vt("2.0"),
    id: ie(),
    error: re({
      code: ii(),
      message: ie(),
      data: Se(jv())
    })
  })]);
}
const Gx = ng(ii());
function ut(n) {
  return Xi(ng(n), Gx, (e) => "error" in e ? e : {
    ...e,
    result: bi(e.result, n)
  });
}
function qr(n) {
  return ut(re({
    context: re({
      slot: Z()
    }),
    value: n
  }));
}
function Na(n) {
  return re({
    context: re({
      slot: Z()
    }),
    value: n
  });
}
const jx = re({
  foundation: Z(),
  foundationTerm: Z(),
  initial: Z(),
  taper: Z(),
  terminal: Z()
});
ut(ce(ue(re({
  epoch: Z(),
  effectiveSlot: Z(),
  amount: Z(),
  postBalance: Z(),
  commission: Se(ue(Z()))
}))));
const Vx = ce(re({
  slot: Z(),
  prioritizationFee: Z()
})), Kx = re({
  total: Z(),
  validator: Z(),
  foundation: Z(),
  epoch: Z()
}), Hx = re({
  epoch: Z(),
  slotIndex: Z(),
  slotsInEpoch: Z(),
  absoluteSlot: Z(),
  blockHeight: Se(Z()),
  transactionCount: Se(Z())
}), Wx = re({
  slotsPerEpoch: Z(),
  leaderScheduleSlotOffset: Z(),
  warmup: cn(),
  firstNormalEpoch: Z(),
  firstNormalSlot: Z()
}), qx = G0(ie(), ce(Z())), ys = ue(pr([re({}), ie()])), zx = re({
  err: ys
}), Yx = vt("receivedSignature");
re({
  "solana-core": ie(),
  "feature-set": Se(Z())
});
const Zx = re({
  program: ie(),
  programId: bt,
  parsed: ii()
}), Xx = re({
  programId: bt,
  accounts: ce(bt),
  data: ie()
});
qr(re({
  err: ue(pr([re({}), ie()])),
  logs: ue(ce(ie())),
  accounts: Se(ue(ce(ue(re({
    executable: cn(),
    owner: ie(),
    lamports: Z(),
    data: ce(ie()),
    rentEpoch: Se(Z())
  }))))),
  unitsConsumed: Se(Z()),
  returnData: Se(ue(re({
    programId: ie(),
    data: bu([ie(), vt("base64")])
  }))),
  innerInstructions: Se(ue(ce(re({
    index: Z(),
    instructions: ce(pr([Zx, Xx]))
  }))))
}));
qr(re({
  byIdentity: G0(ie(), ce(Z())),
  range: re({
    firstSlot: Z(),
    lastSlot: Z()
  })
}));
ut(jx);
ut(Kx);
ut(Vx);
ut(Hx);
ut(Wx);
ut(qx);
ut(Z());
qr(re({
  total: Z(),
  circulating: Z(),
  nonCirculating: Z(),
  nonCirculatingAccounts: ce(bt)
}));
const Jx = re({
  amount: ie(),
  uiAmount: ue(Z()),
  decimals: Z(),
  uiAmountString: Se(ie())
});
qr(ce(re({
  address: bt,
  amount: ie(),
  uiAmount: ue(Z()),
  decimals: Z(),
  uiAmountString: Se(ie())
})));
qr(ce(re({
  pubkey: bt,
  account: re({
    executable: cn(),
    owner: bt,
    lamports: Z(),
    data: _u,
    rentEpoch: Z()
  })
})));
const yc = re({
  program: ie(),
  parsed: ii(),
  space: Z()
});
qr(ce(re({
  pubkey: bt,
  account: re({
    executable: cn(),
    owner: bt,
    lamports: Z(),
    data: yc,
    rentEpoch: Z()
  })
})));
qr(ce(re({
  lamports: Z(),
  address: bt
})));
const Lu = re({
  executable: cn(),
  owner: bt,
  lamports: Z(),
  data: _u,
  rentEpoch: Z()
});
re({
  pubkey: bt,
  account: Lu
});
const Qx = Xi(pr([Su($e.Buffer), yc]), pr([rg, yc]), (n) => Array.isArray(n) ? bi(n, _u) : n), eE = re({
  executable: cn(),
  owner: bt,
  lamports: Z(),
  data: Qx,
  rentEpoch: Z()
});
re({
  pubkey: bt,
  account: eE
});
re({
  state: pr([vt("active"), vt("inactive"), vt("activating"), vt("deactivating")]),
  active: Z(),
  inactive: Z()
});
ut(ce(re({
  signature: ie(),
  slot: Z(),
  err: ys,
  memo: ue(ie()),
  blockTime: Se(ue(Z()))
})));
ut(ce(re({
  signature: ie(),
  slot: Z(),
  err: ys,
  memo: ue(ie()),
  blockTime: Se(ue(Z()))
})));
re({
  subscription: Z(),
  result: Na(Lu)
});
const tE = re({
  pubkey: bt,
  account: Lu
});
re({
  subscription: Z(),
  result: Na(tE)
});
const rE = re({
  parent: Z(),
  slot: Z(),
  root: Z()
});
re({
  subscription: Z(),
  result: rE
});
const nE = pr([re({
  type: pr([vt("firstShredReceived"), vt("completed"), vt("optimisticConfirmation"), vt("root")]),
  slot: Z(),
  timestamp: Z()
}), re({
  type: vt("createdBank"),
  parent: Z(),
  slot: Z(),
  timestamp: Z()
}), re({
  type: vt("frozen"),
  slot: Z(),
  timestamp: Z(),
  stats: re({
    numTransactionEntries: Z(),
    numSuccessfulTransactions: Z(),
    numFailedTransactions: Z(),
    maxTransactionsPerEntry: Z()
  })
}), re({
  type: vt("dead"),
  slot: Z(),
  timestamp: Z(),
  err: ie()
})]);
re({
  subscription: Z(),
  result: nE
});
re({
  subscription: Z(),
  result: Na(pr([zx, Yx]))
});
re({
  subscription: Z(),
  result: Z()
});
re({
  pubkey: ie(),
  gossip: ue(ie()),
  tpu: ue(ie()),
  rpc: ue(ie()),
  version: ue(ie())
});
const Vd = re({
  votePubkey: ie(),
  nodePubkey: ie(),
  activatedStake: Z(),
  epochVoteAccount: cn(),
  epochCredits: ce(bu([Z(), Z(), Z()])),
  commission: Z(),
  lastVote: Z(),
  rootSlot: ue(Z())
});
ut(re({
  current: ce(Vd),
  delinquent: ce(Vd)
}));
const sE = pr([vt("processed"), vt("confirmed"), vt("finalized")]), iE = re({
  slot: Z(),
  confirmations: ue(Z()),
  err: ys,
  confirmationStatus: Se(sE)
});
qr(ce(ue(iE)));
ut(Z());
const sg = re({
  accountKey: bt,
  writableIndexes: ce(Z()),
  readonlyIndexes: ce(Z())
}), Ru = re({
  signatures: ce(ie()),
  message: re({
    accountKeys: ce(ie()),
    header: re({
      numRequiredSignatures: Z(),
      numReadonlySignedAccounts: Z(),
      numReadonlyUnsignedAccounts: Z()
    }),
    instructions: ce(re({
      accounts: ce(Z()),
      data: ie(),
      programIdIndex: Z()
    })),
    recentBlockhash: ie(),
    addressTableLookups: Se(ce(sg))
  })
}), ig = re({
  pubkey: bt,
  signer: cn(),
  writable: cn(),
  source: Se(pr([vt("transaction"), vt("lookupTable")]))
}), og = re({
  accountKeys: ce(ig),
  signatures: ce(ie())
}), ag = re({
  parsed: ii(),
  program: ie(),
  programId: bt
}), lg = re({
  accounts: ce(bt),
  data: ie(),
  programId: bt
}), oE = pr([lg, ag]), aE = pr([re({
  parsed: ii(),
  program: ie(),
  programId: ie()
}), re({
  accounts: ce(ie()),
  data: ie(),
  programId: ie()
})]), cg = Xi(oE, aE, (n) => "accounts" in n ? bi(n, lg) : bi(n, ag)), ug = re({
  signatures: ce(ie()),
  message: re({
    accountKeys: ce(ig),
    instructions: ce(cg),
    recentBlockhash: ie(),
    addressTableLookups: Se(ue(ce(sg)))
  })
}), la = re({
  accountIndex: Z(),
  mint: ie(),
  owner: Se(ie()),
  programId: Se(ie()),
  uiTokenAmount: Jx
}), dg = re({
  writable: ce(bt),
  readonly: ce(bt)
}), Ua = re({
  err: ys,
  fee: Z(),
  innerInstructions: Se(ue(ce(re({
    index: Z(),
    instructions: ce(re({
      accounts: ce(Z()),
      data: ie(),
      programIdIndex: Z()
    }))
  })))),
  preBalances: ce(Z()),
  postBalances: ce(Z()),
  logMessages: Se(ue(ce(ie()))),
  preTokenBalances: Se(ue(ce(la))),
  postTokenBalances: Se(ue(ce(la))),
  loadedAddresses: Se(dg),
  computeUnitsConsumed: Se(Z())
}), Cu = re({
  err: ys,
  fee: Z(),
  innerInstructions: Se(ue(ce(re({
    index: Z(),
    instructions: ce(cg)
  })))),
  preBalances: ce(Z()),
  postBalances: ce(Z()),
  logMessages: Se(ue(ce(ie()))),
  preTokenBalances: Se(ue(ce(la))),
  postTokenBalances: Se(ue(ce(la))),
  loadedAddresses: Se(dg),
  computeUnitsConsumed: Se(Z())
}), oi = pr([vt(0), vt("legacy")]), vs = re({
  pubkey: ie(),
  lamports: Z(),
  postBalance: ue(Z()),
  rewardType: ue(ie()),
  commission: Se(ue(Z()))
});
ut(ue(re({
  blockhash: ie(),
  previousBlockhash: ie(),
  parentSlot: Z(),
  transactions: ce(re({
    transaction: Ru,
    meta: ue(Ua),
    version: Se(oi)
  })),
  rewards: Se(ce(vs)),
  blockTime: ue(Z()),
  blockHeight: ue(Z())
})));
ut(ue(re({
  blockhash: ie(),
  previousBlockhash: ie(),
  parentSlot: Z(),
  rewards: Se(ce(vs)),
  blockTime: ue(Z()),
  blockHeight: ue(Z())
})));
ut(ue(re({
  blockhash: ie(),
  previousBlockhash: ie(),
  parentSlot: Z(),
  transactions: ce(re({
    transaction: og,
    meta: ue(Ua),
    version: Se(oi)
  })),
  rewards: Se(ce(vs)),
  blockTime: ue(Z()),
  blockHeight: ue(Z())
})));
ut(ue(re({
  blockhash: ie(),
  previousBlockhash: ie(),
  parentSlot: Z(),
  transactions: ce(re({
    transaction: ug,
    meta: ue(Cu),
    version: Se(oi)
  })),
  rewards: Se(ce(vs)),
  blockTime: ue(Z()),
  blockHeight: ue(Z())
})));
ut(ue(re({
  blockhash: ie(),
  previousBlockhash: ie(),
  parentSlot: Z(),
  transactions: ce(re({
    transaction: og,
    meta: ue(Cu),
    version: Se(oi)
  })),
  rewards: Se(ce(vs)),
  blockTime: ue(Z()),
  blockHeight: ue(Z())
})));
ut(ue(re({
  blockhash: ie(),
  previousBlockhash: ie(),
  parentSlot: Z(),
  rewards: Se(ce(vs)),
  blockTime: ue(Z()),
  blockHeight: ue(Z())
})));
ut(ue(re({
  blockhash: ie(),
  previousBlockhash: ie(),
  parentSlot: Z(),
  transactions: ce(re({
    transaction: Ru,
    meta: ue(Ua)
  })),
  rewards: Se(ce(vs)),
  blockTime: ue(Z())
})));
ut(ue(re({
  blockhash: ie(),
  previousBlockhash: ie(),
  parentSlot: Z(),
  signatures: ce(ie()),
  blockTime: ue(Z())
})));
ut(ue(re({
  slot: Z(),
  meta: ue(Ua),
  blockTime: Se(ue(Z())),
  transaction: Ru,
  version: Se(oi)
})));
ut(ue(re({
  slot: Z(),
  transaction: ug,
  meta: ue(Cu),
  blockTime: Se(ue(Z())),
  version: Se(oi)
})));
qr(re({
  blockhash: ie(),
  lastValidBlockHeight: Z()
}));
qr(cn());
const lE = re({
  slot: Z(),
  numTransactions: Z(),
  numSlots: Z(),
  samplePeriodSecs: Z()
});
ut(ce(lE));
qr(ue(re({
  feeCalculator: re({
    lamportsPerSignature: Z()
  })
})));
ut(ie());
ut(ie());
const cE = re({
  err: ys,
  logs: ce(ie()),
  signature: ie()
});
re({
  result: Na(cE),
  subscription: Z()
});
Object.freeze({
  CreateLookupTable: {
    index: 0,
    layout: pe([Ee("instruction"), Xs("recentSlot"), Je("bumpSeed")])
  },
  FreezeLookupTable: {
    index: 1,
    layout: pe([Ee("instruction")])
  },
  ExtendLookupTable: {
    index: 2,
    layout: pe([Ee("instruction"), Xs(), gr(He(), as(Ee(), -8), "addresses")])
  },
  DeactivateLookupTable: {
    index: 3,
    layout: pe([Ee("instruction")])
  },
  CloseLookupTable: {
    index: 4,
    layout: pe([Ee("instruction")])
  }
});
new De("AddressLookupTab1e1111111111111111111111111");
Object.freeze({
  RequestUnits: {
    index: 0,
    layout: pe([Je("instruction"), Ee("units"), Ee("additionalFee")])
  },
  RequestHeapFrame: {
    index: 1,
    layout: pe([Je("instruction"), Ee("bytes")])
  },
  SetComputeUnitLimit: {
    index: 2,
    layout: pe([Je("instruction"), Ee("units")])
  },
  SetComputeUnitPrice: {
    index: 3,
    layout: pe([Je("instruction"), Xs("microLamports")])
  }
});
new De("ComputeBudget111111111111111111111111111111");
pe([Je("numSignatures"), Je("padding"), Mr("signatureOffset"), Mr("signatureInstructionIndex"), Mr("publicKeyOffset"), Mr("publicKeyInstructionIndex"), Mr("messageDataOffset"), Mr("messageDataSize"), Mr("messageInstructionIndex")]);
new De("Ed25519SigVerify111111111111111111111111111");
Lx.utils.isValidPrivateKey;
pe([Je("numSignatures"), Mr("signatureOffset"), Je("signatureInstructionIndex"), Mr("ethAddressOffset"), Je("ethAddressInstructionIndex"), Mr("messageDataOffset"), Mr("messageDataSize"), Je("messageInstructionIndex"), gt(20, "ethAddress"), gt(64, "signature"), Je("recoveryId")]);
new De("KeccakSecp256k11111111111111111111111111111");
var hg;
new De("StakeConfig11111111111111111111111111111111");
class fg {
  /**
   * Create a new Lockup object
   */
  constructor(e, t, r) {
    this.unixTimestamp = void 0, this.epoch = void 0, this.custodian = void 0, this.unixTimestamp = e, this.epoch = t, this.custodian = r;
  }
  /**
   * Default, inactive Lockup value
   */
}
hg = fg;
fg.default = new hg(0, 0, De.default);
Object.freeze({
  Initialize: {
    index: 0,
    layout: pe([Ee("instruction"), Mx(), Ox()])
  },
  Authorize: {
    index: 1,
    layout: pe([Ee("instruction"), He("newAuthorized"), Ee("stakeAuthorizationType")])
  },
  Delegate: {
    index: 2,
    layout: pe([Ee("instruction")])
  },
  Split: {
    index: 3,
    layout: pe([Ee("instruction"), br("lamports")])
  },
  Withdraw: {
    index: 4,
    layout: pe([Ee("instruction"), br("lamports")])
  },
  Deactivate: {
    index: 5,
    layout: pe([Ee("instruction")])
  },
  Merge: {
    index: 7,
    layout: pe([Ee("instruction")])
  },
  AuthorizeWithSeed: {
    index: 8,
    layout: pe([Ee("instruction"), He("newAuthorized"), Ee("stakeAuthorizationType"), Fs("authoritySeed"), He("authorityOwner")])
  }
});
new De("Stake11111111111111111111111111111111111111");
Object.freeze({
  InitializeAccount: {
    index: 0,
    layout: pe([Ee("instruction"), Bx()])
  },
  Authorize: {
    index: 1,
    layout: pe([Ee("instruction"), He("newAuthorized"), Ee("voteAuthorizationType")])
  },
  Withdraw: {
    index: 3,
    layout: pe([Ee("instruction"), br("lamports")])
  },
  UpdateValidatorIdentity: {
    index: 4,
    layout: pe([Ee("instruction")])
  },
  AuthorizeWithSeed: {
    index: 10,
    layout: pe([Ee("instruction"), Fx()])
  }
});
new De("Vote111111111111111111111111111111111111111");
new De("Va1idator1nfo111111111111111111111111111111");
re({
  name: ie(),
  website: Se(ie()),
  details: Se(ie()),
  iconUrl: Se(ie()),
  keybaseUsername: Se(ie())
});
new De("Vote111111111111111111111111111111111111111");
pe([
  He("nodePubkey"),
  He("authorizedWithdrawer"),
  Je("commission"),
  Qt(),
  // votes.length
  gr(pe([Qt("slot"), Ee("confirmationCount")]), as(Ee(), -8), "votes"),
  Je("rootSlotValid"),
  Qt("rootSlot"),
  Qt(),
  // authorizedVoters.length
  gr(pe([Qt("epoch"), He("authorizedVoter")]), as(Ee(), -8), "authorizedVoters"),
  pe([gr(pe([He("authorizedPubkey"), Qt("epochOfLastAuthorizedSwitch"), Qt("targetEpoch")]), 32, "buf"), Qt("idx"), Je("isEmpty")], "priorVoters"),
  Qt(),
  // epochCredits.length
  gr(pe([Qt("epoch"), Qt("credits"), Qt("prevCredits")]), as(Ee(), -8), "epochCredits"),
  pe([Qt("slot"), Qt("timestamp")], "lastTimestamp")
]);
const uE = (n) => ({
  request: n,
  signMessage: (e) => n({ method: "signMessage", params: { message: e } }),
  signTransaction: (e) => n({ method: "signTransaction", params: { transaction: e } }),
  signAndSendTransaction: (e) => n({
    method: "signAndSendTransaction",
    params: e
  })
});
function Kd(n) {
  return Buffer.from(n.serialize({
    verifySignatures: !1
  })).toString("base64");
}
function dE(n) {
  const e = Buffer.from(n, "base64");
  return Au.deserializeMessageVersion(e) === "legacy" ? Iu.deserialize(e) : aa.from(e);
}
function hE(n) {
  return async (t) => {
    if (t.method === "connect")
      return await n(t);
    if (t.method === "signMessage")
      return await n(t);
    if (t.method === "signAndSendTransaction") {
      const { transaction: r } = t.params, s = {
        transaction: Kd(r)
      };
      return await n({
        method: "signAndSendTransaction",
        params: s
      });
    }
    if (t.method === "signTransaction") {
      const { transaction: r } = t.params, s = {
        transaction: Kd(r)
      }, { signedTransaction: i } = await n({
        method: "signTransaction",
        params: s
      });
      return { signedTransaction: dE(i) };
    }
  };
}
const fE = ({ miniAppHost: n, emitter: e }) => {
  let t, r = null;
  return {
    visible: !1,
    get onback() {
      return r;
    },
    set onback(s) {
      r && e.removeListener("backNavigationTriggered", r), r = s, s && e.addListener("backNavigationTriggered", s);
    },
    async show() {
      await n.updateBackState({
        visible: !0
      }), this.visible = !0;
    },
    async hide() {
      await n.updateBackState({
        visible: !1
      }), this.visible = !1;
    },
    async enableWebNavigation() {
      t = gE({
        back: this,
        emitter: e
      });
    },
    async disableWebNavigation() {
      t == null || t(), t = void 0;
    }
  };
};
function gE({ emitter: n, back: e }) {
  const t = pE();
  if (t)
    return mE({ emitter: n, back: e, navigation: t });
  if (typeof window < "u")
    return yE({ emitter: n, back: e, window });
}
function pE() {
  if (typeof window < "u" && window.navigation !== void 0)
    return window.navigation;
}
function mE({ emitter: n, back: e, navigation: t }) {
  function r() {
    t.canGoBack ? e.show() : e.hide();
  }
  function s() {
    e.visible && t.canGoBack && t.back();
  }
  return t.addEventListener("navigatesuccess", r), n.addListener("backNavigationTriggered", s), () => {
    t.removeEventListener("navigatesuccess", r), n.removeListener("backNavigationTriggered", s);
  };
}
function yE({ emitter: n, back: e, window: t }) {
  e.show();
  function r() {
    e.visible && t.history.back();
  }
  return n.addListener("backNavigationTriggered", r), () => {
    n.removeListener("backNavigationTriggered", r);
  };
}
const vE = "0.1.1";
function xE() {
  return vE;
}
let EE = class vc extends Error {
  constructor(e, t = {}) {
    const r = (() => {
      var l;
      if (t.cause instanceof vc) {
        if (t.cause.details)
          return t.cause.details;
        if (t.cause.shortMessage)
          return t.cause.shortMessage;
      }
      return (l = t.cause) != null && l.message ? t.cause.message : t.details;
    })(), s = t.cause instanceof vc && t.cause.docsPath || t.docsPath, o = `https://oxlib.sh${s ?? ""}`, a = [
      e || "An error occurred.",
      ...t.metaMessages ? ["", ...t.metaMessages] : [],
      ...r || s ? [
        "",
        r ? `Details: ${r}` : void 0,
        s ? `See: ${o}` : void 0
      ] : []
    ].filter((l) => typeof l == "string").join(`
`);
    super(a, t.cause ? { cause: t.cause } : void 0), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docs", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseError"
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: `ox@${xE()}`
    }), this.cause = t.cause, this.details = r, this.docs = o, this.docsPath = s, this.shortMessage = e;
  }
  walk(e) {
    return gg(this, e);
  }
};
function gg(n, e) {
  return e != null && e(n) ? n : n && typeof n == "object" && "cause" in n && n.cause ? gg(n.cause, e) : e ? null : n;
}
function pg(n, e = {}) {
  const { raw: t = !1 } = e, r = n;
  if (t)
    return n;
  if (r.error) {
    const { code: s } = r.error, i = s === Js.code ? Js : s === Ti.code ? Ti : s === Di.code ? Di : s === Ci.code ? Ci : s === Li.code ? Li : s === ki.code ? ki : s === _i.code ? _i : s === Pi.code ? Pi : s === wi.code ? wi : s === Ai.code ? Ai : s === Ii.code ? Ii : s === Ri.code ? Ri : Sr;
    throw new i(r.error);
  }
  return r.result;
}
let Sr = class extends Error {
  constructor(e) {
    const { code: t, message: r, data: s } = e;
    super(r), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcResponse.BaseError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.code = t, this.data = s;
  }
};
class Ti extends Sr {
  constructor(e = {}) {
    super({
      message: "Missing or invalid parameters.",
      ...e,
      code: Ti.code
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: -32e3
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcResponse.InvalidInputError"
    });
  }
}
Object.defineProperty(Ti, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32e3
});
class wi extends Sr {
  constructor(e = {}) {
    super({
      message: "Requested resource not found.",
      ...e,
      code: wi.code
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: -32001
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcResponse.ResourceNotFoundError"
    });
  }
}
Object.defineProperty(wi, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32001
});
class Ai extends Sr {
  constructor(e = {}) {
    super({
      message: "Requested resource not available.",
      ...e,
      code: Ai.code
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: -32002
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcResponse.ResourceUnavailableError"
    });
  }
}
Object.defineProperty(Ai, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32002
});
class Ii extends Sr {
  constructor(e = {}) {
    super({
      message: "Transaction creation failed.",
      ...e,
      code: Ii.code
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: -32003
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcResponse.TransactionRejectedError"
    });
  }
}
Object.defineProperty(Ii, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32003
});
class _i extends Sr {
  constructor(e = {}) {
    super({
      message: "Method is not implemented.",
      ...e,
      code: _i.code
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: -32004
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcResponse.MethodNotSupportedError"
    });
  }
}
Object.defineProperty(_i, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32004
});
class Li extends Sr {
  constructor(e = {}) {
    super({
      message: "Rate limit exceeded.",
      ...e,
      code: Li.code
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: -32005
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcResponse.LimitExceededError"
    });
  }
}
Object.defineProperty(Li, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32005
});
class Ri extends Sr {
  constructor(e = {}) {
    super({
      message: "JSON-RPC version not supported.",
      ...e,
      code: Ri.code
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: -32006
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcResponse.VersionNotSupportedError"
    });
  }
}
Object.defineProperty(Ri, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32006
});
class Ci extends Sr {
  constructor(e = {}) {
    super({
      message: "Input is not a valid JSON-RPC request.",
      ...e,
      code: Ci.code
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: -32600
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcResponse.InvalidRequestError"
    });
  }
}
Object.defineProperty(Ci, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32600
});
class ki extends Sr {
  constructor(e = {}) {
    super({
      message: "Method does not exist.",
      ...e,
      code: ki.code
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: -32601
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcResponse.MethodNotFoundError"
    });
  }
}
Object.defineProperty(ki, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32601
});
class Di extends Sr {
  constructor(e = {}) {
    super({
      message: "Invalid method parameters.",
      ...e,
      code: Di.code
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: -32602
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcResponse.InvalidParamsError"
    });
  }
}
Object.defineProperty(Di, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32602
});
class Js extends Sr {
  constructor(e = {}) {
    super({
      message: "Internal JSON-RPC error.",
      ...e,
      code: Js.code
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: -32603
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcResponse.InternalErrorError"
    });
  }
}
Object.defineProperty(Js, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32603
});
class Pi extends Sr {
  constructor(e = {}) {
    super({
      message: "Failed to parse JSON-RPC response.",
      ...e,
      code: Pi.code
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: -32700
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcResponse.ParseError"
    });
  }
}
Object.defineProperty(Pi, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32700
});
class xs extends Error {
  constructor(e, t) {
    super(t), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderRpcError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.code = e, this.details = t;
  }
}
class mg extends xs {
  constructor({ message: e = "The user rejected the request." } = {}) {
    super(4001, e), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Provider.UserRejectedRequestError"
    });
  }
}
Object.defineProperty(mg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4001
});
class yg extends xs {
  constructor({ message: e = "The requested method and/or account has not been authorized by the user." } = {}) {
    super(4100, e), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Provider.UnauthorizedError"
    });
  }
}
Object.defineProperty(yg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4100
});
class vg extends xs {
  constructor({ message: e = "The provider does not support the requested method." } = {}) {
    super(4200, e), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Provider.UnsupportedMethodError"
    });
  }
}
Object.defineProperty(vg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4200
});
class xg extends xs {
  constructor({ message: e = "The provider is disconnected from all chains." } = {}) {
    super(4900, e), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Provider.DisconnectedError"
    });
  }
}
Object.defineProperty(xg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4900
});
class Eg extends xs {
  constructor({ message: e = "The provider is not connected to the requested chain." } = {}) {
    super(4901, e), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Provider.ChainDisconnectedError"
    });
  }
}
Object.defineProperty(Eg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4901
});
function SE() {
  const n = new z0();
  return {
    get eventNames() {
      return n.eventNames.bind(n);
    },
    get listenerCount() {
      return n.listenerCount.bind(n);
    },
    get listeners() {
      return n.listeners.bind(n);
    },
    addListener: n.addListener.bind(n),
    emit: n.emit.bind(n),
    off: n.off.bind(n),
    on: n.on.bind(n),
    once: n.once.bind(n),
    removeAllListeners: n.removeAllListeners.bind(n),
    removeListener: n.removeListener.bind(n)
  };
}
function bE(n, e = {}) {
  var r, s;
  const { includeEvents: t = !0 } = e;
  if (!n)
    throw new TE();
  return {
    ...t ? {
      on: (r = n.on) == null ? void 0 : r.bind(n),
      removeListener: (s = n.removeListener) == null ? void 0 : s.bind(n)
    } : {},
    async request(i) {
      const o = await n.request(i);
      return o && typeof o == "object" && "jsonrpc" in o ? pg(o) : o;
    }
  };
}
class TE extends EE {
  constructor() {
    super("`provider` is undefined."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Provider.IsUndefinedError"
    });
  }
}
function wE(n = {}) {
  let e = n.id ?? 0;
  return {
    prepare(t) {
      return AE({
        id: e++,
        ...t
      });
    },
    get id() {
      return e;
    }
  };
}
function AE(n) {
  return {
    ...n,
    jsonrpc: "2.0"
  };
}
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
const Sg = Symbol("Comlink.proxy"), IE = Symbol("Comlink.endpoint"), _E = Symbol("Comlink.releaseProxy"), Tl = Symbol("Comlink.finalizer"), Lo = Symbol("Comlink.thrown"), bg = (n) => typeof n == "object" && n !== null || typeof n == "function", LE = {
  canHandle: (n) => bg(n) && n[Sg],
  serialize(n) {
    const { port1: e, port2: t } = new MessageChannel();
    return wg(n, e), [t, [t]];
  },
  deserialize(n) {
    return n.start(), Ig(n);
  }
}, RE = {
  canHandle: (n) => bg(n) && Lo in n,
  serialize({ value: n }) {
    let e;
    return n instanceof Error ? e = {
      isError: !0,
      value: {
        message: n.message,
        name: n.name,
        stack: n.stack
      }
    } : e = { isError: !1, value: n }, [e, []];
  },
  deserialize(n) {
    throw n.isError ? Object.assign(new Error(n.value.message), n.value) : n.value;
  }
}, Tg = /* @__PURE__ */ new Map([
  ["proxy", LE],
  ["throw", RE]
]);
function CE(n, e) {
  for (const t of n)
    if (e === t || t === "*" || t instanceof RegExp && t.test(e))
      return !0;
  return !1;
}
function wg(n, e = globalThis, t = ["*"]) {
  e.addEventListener("message", function r(s) {
    if (!s || !s.data)
      return;
    if (!CE(t, s.origin)) {
      console.warn(`Invalid origin '${s.origin}' for comlink proxy`);
      return;
    }
    const { id: i, type: o, path: a } = Object.assign({ path: [] }, s.data), l = (s.data.argumentList || []).map(ns);
    let c;
    try {
      const u = a.slice(0, -1).reduce((h, f) => h[f], n), d = a.reduce((h, f) => h[f], n);
      switch (o) {
        case "GET":
          c = d;
          break;
        case "SET":
          u[a.slice(-1)[0]] = ns(s.data.value), c = !0;
          break;
        case "APPLY":
          c = d.apply(u, l);
          break;
        case "CONSTRUCT":
          {
            const h = new d(...l);
            c = BE(h);
          }
          break;
        case "ENDPOINT":
          {
            const { port1: h, port2: f } = new MessageChannel();
            wg(n, f), c = OE(h, [h]);
          }
          break;
        case "RELEASE":
          c = void 0;
          break;
        default:
          return;
      }
    } catch (u) {
      c = { value: u, [Lo]: 0 };
    }
    Promise.resolve(c).catch((u) => ({ value: u, [Lo]: 0 })).then((u) => {
      const [d, h] = da(u);
      e.postMessage(Object.assign(Object.assign({}, d), { id: i }), h), o === "RELEASE" && (e.removeEventListener("message", r), Ag(e), Tl in n && typeof n[Tl] == "function" && n[Tl]());
    }).catch((u) => {
      const [d, h] = da({
        value: new TypeError("Unserializable return value"),
        [Lo]: 0
      });
      e.postMessage(Object.assign(Object.assign({}, d), { id: i }), h);
    });
  }), e.start && e.start();
}
function kE(n) {
  return n.constructor.name === "MessagePort";
}
function Ag(n) {
  kE(n) && n.close();
}
function Ig(n, e) {
  const t = /* @__PURE__ */ new Map();
  return n.addEventListener("message", function(s) {
    const { data: i } = s;
    if (!i || !i.id)
      return;
    const o = t.get(i.id);
    if (o)
      try {
        o(i);
      } finally {
        t.delete(i.id);
      }
  }), xc(n, t, [], e);
}
function oo(n) {
  if (n)
    throw new Error("Proxy has been released and is not useable");
}
function _g(n) {
  return Ms(n, /* @__PURE__ */ new Map(), {
    type: "RELEASE"
  }).then(() => {
    Ag(n);
  });
}
const ca = /* @__PURE__ */ new WeakMap(), ua = "FinalizationRegistry" in globalThis && new FinalizationRegistry((n) => {
  const e = (ca.get(n) || 0) - 1;
  ca.set(n, e), e === 0 && _g(n);
});
function DE(n, e) {
  const t = (ca.get(e) || 0) + 1;
  ca.set(e, t), ua && ua.register(n, e, n);
}
function PE(n) {
  ua && ua.unregister(n);
}
function xc(n, e, t = [], r = function() {
}) {
  let s = !1;
  const i = new Proxy(r, {
    get(o, a) {
      if (oo(s), a === _E)
        return () => {
          PE(i), _g(n), e.clear(), s = !0;
        };
      if (a === "then") {
        if (t.length === 0)
          return { then: () => i };
        const l = Ms(n, e, {
          type: "GET",
          path: t.map((c) => c.toString())
        }).then(ns);
        return l.then.bind(l);
      }
      return xc(n, e, [...t, a]);
    },
    set(o, a, l) {
      oo(s);
      const [c, u] = da(l);
      return Ms(n, e, {
        type: "SET",
        path: [...t, a].map((d) => d.toString()),
        value: c
      }, u).then(ns);
    },
    apply(o, a, l) {
      oo(s);
      const c = t[t.length - 1];
      if (c === IE)
        return Ms(n, e, {
          type: "ENDPOINT"
        }).then(ns);
      if (c === "bind")
        return xc(n, e, t.slice(0, -1));
      const [u, d] = Hd(l);
      return Ms(n, e, {
        type: "APPLY",
        path: t.map((h) => h.toString()),
        argumentList: u
      }, d).then(ns);
    },
    construct(o, a) {
      oo(s);
      const [l, c] = Hd(a);
      return Ms(n, e, {
        type: "CONSTRUCT",
        path: t.map((u) => u.toString()),
        argumentList: l
      }, c).then(ns);
    }
  });
  return DE(i, n), i;
}
function ME(n) {
  return Array.prototype.concat.apply([], n);
}
function Hd(n) {
  const e = n.map(da);
  return [e.map((t) => t[0]), ME(e.map((t) => t[1]))];
}
const Lg = /* @__PURE__ */ new WeakMap();
function OE(n, e) {
  return Lg.set(n, e), n;
}
function BE(n) {
  return Object.assign(n, { [Sg]: !0 });
}
function FE(n, e = globalThis, t = "*") {
  return {
    postMessage: (r, s) => n.postMessage(r, t, s),
    addEventListener: e.addEventListener.bind(e),
    removeEventListener: e.removeEventListener.bind(e)
  };
}
function da(n) {
  for (const [e, t] of Tg)
    if (t.canHandle(n)) {
      const [r, s] = t.serialize(n);
      return [
        {
          type: "HANDLER",
          name: e,
          value: r
        },
        s
      ];
    }
  return [
    {
      type: "RAW",
      value: n
    },
    Lg.get(n) || []
  ];
}
function ns(n) {
  switch (n.type) {
    case "HANDLER":
      return Tg.get(n.name).deserialize(n.value);
    case "RAW":
      return n.value;
  }
}
function Ms(n, e, t, r) {
  return new Promise((s) => {
    const i = NE();
    e.set(i, s), n.start && n.start(), n.postMessage(Object.assign({ id: i }, t), r);
  });
}
function NE() {
  return new Array(4).fill(0).map(() => Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(16)).join("-");
}
const UE = {
  postMessage() {
  },
  addEventListener: () => {
  },
  removeEventListener: () => {
  }
}, $E = {
  postMessage: (n) => {
    window.ReactNativeWebView.postMessage(JSON.stringify(n));
  },
  addEventListener: (n, e, ...t) => {
    document.addEventListener("FarcasterFrameCallback", e, ...t);
  },
  removeEventListener: (n, e) => {
    document.removeEventListener("FarcasterFrameCallback", e);
  }
}, GE = typeof window > "u" ? UE : window != null && window.ReactNativeWebView ? $E : FE((window == null ? void 0 : window.parent) ?? window), Ne = Ig(GE), ku = SE(), jE = wE();
function VE({ code: n, details: e }) {
  switch (n) {
    case 4001:
      return new mg();
    case 4100:
      return new yg();
    case 4200:
      return new vg();
    case 4900:
      return new xg();
    case 4901:
      return new Eg();
    default:
      return new xs(n, e ?? "Unknown provider RPC error");
  }
}
const Mi = bE({
  ...ku,
  async request(n) {
    const e = jE.prepare(n);
    try {
      const t = await Ne.ethProviderRequestV2(e).then((r) => pg(r, { request: e, raw: !0 }));
      if (t.error)
        throw VE(t.error);
      return t.result;
    } catch (t) {
      if (t instanceof Error && t.message.match(/cannot read property 'apply'/i))
        return await Ne.ethProviderRequest(e);
      throw t instanceof xs || t instanceof Sr ? t : new Js({
        message: t instanceof Error ? t.message : void 0
      });
    }
  }
});
async function KE() {
  try {
    const n = await Ne.getCapabilities();
    return !n.includes("wallet.getEthereumProvider") && !n.includes("wallet.getEvmProvider") ? void 0 : Mi;
  } catch {
    return Mi;
  }
}
function Rg(n) {
  const e = new CustomEvent("eip6963:announceProvider", { detail: Object.freeze(n) });
  window.dispatchEvent(e);
  const t = () => window.dispatchEvent(e);
  return window.addEventListener("eip6963:requestProvider", t), () => window.removeEventListener("eip6963:requestProvider", t);
}
typeof document < "u" && (document.addEventListener("eip6963:requestProvider", () => {
  Ne.eip6963RequestProvider();
}), document.addEventListener("FarcasterFrameEthProviderEvent", (n) => {
  if (n instanceof MessageEvent) {
    const e = n.data;
    ku.emit(e.event, ...e.params);
  }
}), document.addEventListener("FarcasterFrameEvent", (n) => {
  if (n instanceof MessageEvent) {
    const e = n.data;
    e.event === "eip6963:announceProvider" && Rg({
      info: e.info,
      provider: Mi
    });
  }
}));
typeof window < "u" && (window.addEventListener("eip6963:requestProvider", () => {
  Ne.eip6963RequestProvider();
}), window.addEventListener("message", (n) => {
  if (n instanceof MessageEvent && n.data.type === "frameEthProviderEvent") {
    const e = n.data;
    ku.emit(e.event, ...e.params);
  }
}), window.addEventListener("message", (n) => {
  if (n instanceof MessageEvent && n.data.type === "frameEvent") {
    const e = n.data.event;
    e.event === "eip6963:announceProvider" && Rg({
      info: e.info,
      provider: Mi
    });
  }
}));
new TextEncoder();
const Cg = new TextDecoder(), HE = (n) => {
  const e = atob(n), t = new Uint8Array(e.length);
  for (let r = 0; r < e.length; r++)
    t[r] = e.charCodeAt(r);
  return t;
}, WE = (n) => {
  let e = n;
  e instanceof Uint8Array && (e = Cg.decode(e)), e = e.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return HE(e);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
}, qE = WE;
function zE(n) {
  return typeof n == "object" && n !== null;
}
function YE(n) {
  if (!zE(n) || Object.prototype.toString.call(n) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(n) === null)
    return !0;
  let e = n;
  for (; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(n) === e;
}
class mr extends Error {
  constructor(e, t) {
    var r;
    super(e, t), this.code = "ERR_JOSE_GENERIC", this.name = this.constructor.name, (r = Error.captureStackTrace) == null || r.call(Error, this, this.constructor);
  }
}
mr.code = "ERR_JOSE_GENERIC";
class ZE extends mr {
  constructor(e, t, r = "unspecified", s = "unspecified") {
    super(e, { cause: { claim: r, reason: s, payload: t } }), this.code = "ERR_JWT_CLAIM_VALIDATION_FAILED", this.claim = r, this.reason = s, this.payload = t;
  }
}
ZE.code = "ERR_JWT_CLAIM_VALIDATION_FAILED";
class XE extends mr {
  constructor(e, t, r = "unspecified", s = "unspecified") {
    super(e, { cause: { claim: r, reason: s, payload: t } }), this.code = "ERR_JWT_EXPIRED", this.claim = r, this.reason = s, this.payload = t;
  }
}
XE.code = "ERR_JWT_EXPIRED";
class JE extends mr {
  constructor() {
    super(...arguments), this.code = "ERR_JOSE_ALG_NOT_ALLOWED";
  }
}
JE.code = "ERR_JOSE_ALG_NOT_ALLOWED";
class QE extends mr {
  constructor() {
    super(...arguments), this.code = "ERR_JOSE_NOT_SUPPORTED";
  }
}
QE.code = "ERR_JOSE_NOT_SUPPORTED";
class eS extends mr {
  constructor(e = "decryption operation failed", t) {
    super(e, t), this.code = "ERR_JWE_DECRYPTION_FAILED";
  }
}
eS.code = "ERR_JWE_DECRYPTION_FAILED";
class tS extends mr {
  constructor() {
    super(...arguments), this.code = "ERR_JWE_INVALID";
  }
}
tS.code = "ERR_JWE_INVALID";
class rS extends mr {
  constructor() {
    super(...arguments), this.code = "ERR_JWS_INVALID";
  }
}
rS.code = "ERR_JWS_INVALID";
class Nn extends mr {
  constructor() {
    super(...arguments), this.code = "ERR_JWT_INVALID";
  }
}
Nn.code = "ERR_JWT_INVALID";
class nS extends mr {
  constructor() {
    super(...arguments), this.code = "ERR_JWK_INVALID";
  }
}
nS.code = "ERR_JWK_INVALID";
class sS extends mr {
  constructor() {
    super(...arguments), this.code = "ERR_JWKS_INVALID";
  }
}
sS.code = "ERR_JWKS_INVALID";
class iS extends mr {
  constructor(e = "no applicable key found in the JSON Web Key Set", t) {
    super(e, t), this.code = "ERR_JWKS_NO_MATCHING_KEY";
  }
}
iS.code = "ERR_JWKS_NO_MATCHING_KEY";
class oS extends mr {
  constructor(e = "multiple matching keys found in the JSON Web Key Set", t) {
    super(e, t), this.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
  }
}
oS.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
class aS extends mr {
  constructor(e = "request timed out", t) {
    super(e, t), this.code = "ERR_JWKS_TIMEOUT";
  }
}
aS.code = "ERR_JWKS_TIMEOUT";
class lS extends mr {
  constructor(e = "signature verification failed", t) {
    super(e, t), this.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
  }
}
lS.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
function cS(n) {
  if (typeof n != "string")
    throw new Nn("JWTs must use Compact JWS serialization, JWT must be a string");
  const { 1: e, length: t } = n.split(".");
  if (t === 5)
    throw new Nn("Only JWTs using Compact JWS serialization can be decoded");
  if (t !== 3)
    throw new Nn("Invalid JWT");
  if (!e)
    throw new Nn("JWTs must contain a payload");
  let r;
  try {
    r = qE(e);
  } catch {
    throw new Nn("Failed to base64url decode the payload");
  }
  let s;
  try {
    s = JSON.parse(Cg.decode(r));
  } catch {
    throw new Nn("Failed to parse the decoded payload as JSON");
  }
  if (!YE(s))
    throw new Nn("Invalid JWT Claims Set");
  return s;
}
function uS(n) {
  return cS(n);
}
class $a extends Error {
  constructor(e, t = {}) {
    const r = (() => {
      var i;
      if (t.cause instanceof $a) {
        if (t.cause.details)
          return t.cause.details;
        if (t.cause.shortMessage)
          return t.cause.shortMessage;
      }
      return t.cause && "details" in t.cause && typeof t.cause.details == "string" ? t.cause.details : (i = t.cause) != null && i.message ? t.cause.message : t.details;
    })(), s = [
      e || "An error occurred.",
      ...t.metaMessages ? ["", ...t.metaMessages] : [],
      ...r ? [
        "",
        r ? `Details: ${r}` : void 0
      ] : []
    ].filter((i) => typeof i == "string").join(`
`);
    super(s, t.cause ? { cause: t.cause } : void 0), this.name = "BaseError", this.cause = t.cause, this.details = r, this.shortMessage = e;
  }
}
class kg extends $a {
  constructor({ status: e }) {
    super(`Request failed with status ${e}`), this.name = "RequestFailedError";
  }
}
class dS extends $a {
  constructor(e) {
    super(e), this.name = "InvalidToken";
  }
}
async function hS({ origin: n }) {
  const e = await fetch(`${n}/nonce`, {
    method: "POST"
  });
  if (!e.ok)
    throw new kg({ status: e.status });
  return await e.json();
}
async function fS({ origin: n }, e) {
  const t = await fetch(`${n}/verify-siwf`, {
    method: "POST",
    headers: new Headers({ "Content-Type": "application/json" }),
    body: JSON.stringify(e)
  });
  if (!t.ok)
    throw new kg({ status: t.status });
  const r = await t.json();
  if (r.valid === !1)
    throw new dS(r.message ?? "unknown");
  return { token: r.token };
}
function gS(n = {}) {
  return {
    origin: n.origin ?? "https://auth.farcaster.xyz"
  };
}
function pS(n = {}) {
  const e = gS(n);
  return {
    generateNonce: () => hS(e),
    verifySiwf: (t) => fS(e, t)
  };
}
const mS = /^(?:(?<scheme>[a-zA-Z][a-zA-Z0-9+-.]*):\/\/)?(?<domain>[a-zA-Z0-9+-.]*(?::[0-9]{1,5})?) (?:wants you to sign in with your Ethereum account:\n)(?<address>0x[a-fA-F0-9]{40})\n\n(?:(?<statement>.*)\n\n)?/, yS = /(?:URI: (?<uri>.+))\n(?:Version: (?<version>.+))\n(?:Chain ID: (?<chainId>\d+))\n(?:Nonce: (?<nonce>[a-zA-Z0-9]+))\n(?:Issued At: (?<issuedAt>.+))(?:\nExpiration Time: (?<expirationTime>.+))?(?:\nNot Before: (?<notBefore>.+))?(?:\nRequest ID: (?<requestId>.+))?/;
function vS(n) {
  var d, h, f;
  const { scheme: e, statement: t, ...r } = ((d = n.match(mS)) == null ? void 0 : d.groups) ?? {}, { chainId: s, expirationTime: i, issuedAt: o, notBefore: a, requestId: l, ...c } = ((h = n.match(yS)) == null ? void 0 : h.groups) ?? {}, u = (f = n.split("Resources:")[1]) == null ? void 0 : f.split(`
- `).slice(1);
  return {
    ...r,
    ...c,
    ...s ? { chainId: Number(s) } : {},
    ...i ? { expirationTime: new Date(i) } : {},
    ...o ? { issuedAt: new Date(o) } : {},
    ...a ? { notBefore: new Date(a) } : {},
    ...l ? { requestId: l } : {},
    ...u ? { resources: u } : {},
    ...e ? { scheme: e } : {},
    ...t ? { statement: t } : {}
  };
}
const Wd = /* @__PURE__ */ (() => {
  let n, e;
  async function t(r) {
    const s = pS({
      origin: r.quickAuthServerOrigin
    }), { nonce: i } = await s.generateNonce(), o = await Ne.signIn({
      nonce: i,
      acceptAuthAddress: !0
    });
    if (o.result) {
      const a = vS(o.result.message);
      if (!a.domain)
        throw new Error("Missing domain on SIWE message");
      const l = await s.verifySiwf({
        domain: a.domain,
        message: o.result.message,
        signature: o.result.signature
      });
      return n = {
        token: l.token,
        payload: uS(l.token)
      }, l;
    }
    throw o.error.type === "rejected_by_user" ? new Of() : new Error("Unreachable");
  }
  return {
    get token() {
      if (n && new Date(n.payload.exp * 1e3) > new Date(Date.now() + 15e3))
        return n.token;
    },
    async getToken(r = {}) {
      const s = r.force ?? !1;
      return n && !s && new Date(n.payload.exp * 1e3) > new Date(Date.now() + 15e3) ? { token: n.token } : (e || (e = t(r)), e.finally(() => {
        e = void 0;
      }), e);
    },
    async fetch(r, s) {
      const { token: i } = await this.getToken(), o = new Headers(s == null ? void 0 : s.headers);
      return o.set("Authorization", `Bearer ${i}`), fetch(r, {
        ...s,
        headers: o
      });
    }
  };
})();
function xS() {
  const n = new z0();
  return {
    get eventNames() {
      return n.eventNames.bind(n);
    },
    get listenerCount() {
      return n.listenerCount.bind(n);
    },
    get listeners() {
      return n.listeners.bind(n);
    },
    addListener: n.addListener.bind(n),
    emit: n.emit.bind(n),
    off: n.off.bind(n),
    on: n.on.bind(n),
    once: n.once.bind(n),
    removeAllListeners: n.removeAllListeners.bind(n),
    removeListener: n.removeListener.bind(n)
  };
}
const cr = xS(), { solanaProviderRequest: qd } = Ne;
let Dg;
qd && (Dg = uE(hE(qd)));
async function zd() {
  let n;
  try {
    n = await Ne.getCapabilities();
  } catch {
  }
  if (n != null && n.includes("wallet.getSolanaProvider"))
    return Dg;
}
let Yd = null;
async function ES(n = 50) {
  if (Yd === !0)
    return !0;
  if (typeof window > "u" || !window.ReactNativeWebView && window === window.parent)
    return !1;
  const e = await Promise.race([
    Ne.context.then((t) => !!t),
    // Check if context resolves to truthy
    new Promise((t) => {
      setTimeout(() => t(!1), n);
    })
  ]).catch(() => !1);
  return e && (Yd = !0), e;
}
const Zd = async () => {
  const n = await Ne.addFrame();
  if (n.result)
    return n.result;
  throw n.error.type === "invalid_domain_manifest" ? new Om() : n.error.type === "rejected_by_user" ? new Bm() : new Error("Unreachable");
}, ht = {
  ...cr,
  getCapabilities: Ne.getCapabilities,
  getChains: Ne.getChains,
  isInMiniApp: ES,
  context: Ne.context,
  back: fE({ miniAppHost: Ne, emitter: cr }),
  quickAuth: Wd,
  actions: {
    setPrimaryButton: Ne.setPrimaryButton.bind(Ne),
    ready: async (n = {}) => await Ne.ready(n),
    close: Ne.close.bind(Ne),
    viewCast: Ne.viewCast.bind(Ne),
    viewProfile: Ne.viewProfile.bind(Ne),
    openMiniApp: Ne.openMiniApp.bind(Ne),
    signIn: async (n) => {
      const e = await Ne.signIn(n);
      if (e.result)
        return e.result;
      throw e.error.type === "rejected_by_user" ? new Of() : new Error("Unreachable");
    },
    openUrl: (n) => {
      const e = typeof n == "string" ? n : n.url;
      return Ne.openUrl(e.trim());
    },
    addFrame: Zd,
    addMiniApp: Zd,
    composeCast(n = {}) {
      return Ne.composeCast(n);
    },
    viewToken: Ne.viewToken.bind(Ne),
    sendToken: Ne.sendToken.bind(Ne),
    swapToken: Ne.swapToken.bind(Ne)
  },
  experimental: {
    getSolanaProvider: zd,
    quickAuth(n) {
      return Wd.getToken(n);
    }
  },
  wallet: {
    ethProvider: Mi,
    getEthereumProvider: KE,
    getSolanaProvider: zd
  },
  haptics: {
    impactOccurred: Ne.impactOccurred.bind(Ne),
    notificationOccurred: Ne.notificationOccurred.bind(Ne),
    selectionChanged: Ne.selectionChanged.bind(Ne)
  }
};
typeof document < "u" && document.addEventListener("FarcasterFrameEvent", (n) => {
  if (n instanceof MessageEvent) {
    const e = n.data;
    e.event === "primary_button_clicked" ? cr.emit("primaryButtonClicked") : e.event === "miniapp_added" ? cr.emit("miniAppAdded", {
      notificationDetails: e.notificationDetails
    }) : e.event === "miniapp_add_rejected" ? cr.emit("miniAppAddRejected", { reason: e.reason }) : e.event === "miniapp_removed" ? cr.emit("miniAppRemoved") : e.event === "notifications_enabled" ? cr.emit("notificationsEnabled", {
      notificationDetails: e.notificationDetails
    }) : e.event === "notifications_disabled" ? cr.emit("notificationsDisabled") : e.event === "back_navigation_triggered" && cr.emit("backNavigationTriggered");
  }
});
typeof window < "u" && window.addEventListener("message", (n) => {
  if (n instanceof MessageEvent && n.data.type === "frameEvent") {
    const e = n.data.event;
    e.event === "primary_button_clicked" ? cr.emit("primaryButtonClicked") : e.event === "miniapp_added" ? cr.emit("miniAppAdded", {
      notificationDetails: e.notificationDetails
    }) : e.event === "miniapp_add_rejected" ? cr.emit("miniAppAddRejected", { reason: e.reason }) : e.event === "miniapp_removed" ? cr.emit("miniAppRemoved") : e.event === "notifications_enabled" ? cr.emit("notificationsEnabled", {
      notificationDetails: e.notificationDetails
    }) : e.event === "notifications_disabled" ? cr.emit("notificationsDisabled") : e.event === "back_navigation_triggered" && cr.emit("backNavigationTriggered");
  }
});
function SS(n) {
  if (typeof window > "u")
    return;
  const e = (t) => n(t.detail);
  return window.addEventListener("eip6963:announceProvider", e), window.dispatchEvent(new CustomEvent("eip6963:requestProvider")), () => window.removeEventListener("eip6963:announceProvider", e);
}
function bS() {
  const n = /* @__PURE__ */ new Set();
  let e = [];
  const t = () => SS((s) => {
    e.some(({ info: i }) => i.uuid === s.info.uuid) || (e = [...e, s], n.forEach((i) => i(e, { added: [s] })));
  });
  let r = t();
  return {
    _listeners() {
      return n;
    },
    clear() {
      n.forEach((s) => s([], { removed: [...e] })), e = [];
    },
    destroy() {
      this.clear(), n.clear(), r == null || r();
    },
    findProvider({ rdns: s }) {
      return e.find((i) => i.info.rdns === s);
    },
    getProviders() {
      return e;
    },
    reset() {
      this.clear(), r == null || r(), r = t();
    },
    subscribe(s, { emitImmediately: i } = {}) {
      return n.add(s), i && s(e, { added: e }), () => n.delete(s);
    }
  };
}
function TS(n, e = {}, t) {
  const r = {
    event_type: n,
    api_key: "0c4fe46171b9bb8eca2ca61eb71f2e19",
    time: Date.now(),
    user_id: t,
    ...Object.keys(e).length && {
      event_properties: e
    }
  };
  fetch("https://api2.amplitude.com/2/httpapi", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      api_key: "0c4fe46171b9bb8eca2ca61eb71f2e19",
      events: [r]
    })
  }).catch((s) => {
    console.error("Amplitude tracking error:", s);
  });
}
const Pg = Aa({
  analyticsEnabled: !1,
  backButtonEnabled: !1
}), Mg = ot.createContext(void 0);
function wS() {
  const {
    analyticsEnabled: n,
    backButtonEnabled: e
  } = Wi(Pg), [t, r] = We(!1), [s, i] = We(null), [o, a] = We(!1), [l, c] = We(null), [u, d] = We(""), [h, f] = We({}), [p, y] = We(""), [m, b] = We([]), [C, A] = We(""), P = ft((g, x = {}, w) => {
    n && TS(g, x, w);
  }, [n]), I = ft((g) => {
    b((x) => [...x, g]), A(g), P("navigation.setActiveTab", {
      ...h,
      toTab: g,
      historyLength: m.length + 1
    }, p);
  }, [P, h, p, m.length]), U = ft(() => {
    b((g) => {
      if (g.length === 0)
        return g;
      const x = g.slice(0, -1), w = x.length > 0 ? x[x.length - 1] : "";
      return A(w), P("navigation.navBack", {
        ...h,
        fromTab: g[g.length - 1],
        toTab: w,
        historyLength: x.length
      }, p), x;
    });
  }, [P, h, p]), j = ft((g) => {
    b([g]), A(g), P("navigation.setInitialTab", {
      ...h,
      tab: g
    }, p);
  }, [P, h, p]), G = ft(async (g) => {
    await ht.isInMiniApp() ? await ht.actions.openUrl(g) : window.open(g, "_blank");
  }, []), F = ft(async () => {
    await ht.isInMiniApp() ? await ht.actions.close() : window.close();
  }, []), B = ft(async (g) => (P("haptics.impactOccurred", {
    ...h,
    hapticType: g
  }, p), ht.haptics.impactOccurred(g)), [P, h, p]), V = ft(async (g) => (P("haptics.notificationOccurred", {
    ...h,
    hapticType: g
  }, p), ht.haptics.notificationOccurred(g)), [P, h, p]), H = ft(async () => (P("haptics.selectionChanged", {
    ...h
  }, p), ht.haptics.selectionChanged()), [P, h, p]), L = ft(async (g, x) => (x && n && P("cast.composed", {
    ...h,
    castText: g == null ? void 0 : g.text,
    source: x
  }, p), ht.actions.composeCast(g)), [n, P, h, p]);
  return Et(() => {
    const g = async () => {
      var R, v;
      const x = await ht.context;
      i(x);
      const w = new URLSearchParams(window.location.search), _ = w.get("utm_source"), D = w.get("utm_medium"), O = w.get("utm_campaign");
      if (_ === "neynar" && (D != null && D.startsWith("share-cast-"))) {
        const M = D.replace("share-cast-", "");
        (R = x == null ? void 0 : x.user) != null && R.fid && P("cast.shared", {
          ...h,
          sharedByFid: M
        }, p);
      }
      if (_ === "neynar" && O && ((v = x == null ? void 0 : x.user) != null && v.fid)) {
        const M = `neynar_notification_tracked_${O}`;
        if (!localStorage.getItem(M))
          try {
            const ee = await fetch("https://api.neynar.com/v2/farcaster/frame/notifications/open", {
              method: "POST",
              headers: {
                "content-type": "application/json"
              },
              body: JSON.stringify({
                campaign_id: O,
                fid: x.user.fid,
                app_fid: x.client.clientFid
              })
            });
            ee.ok ? localStorage.setItem(M, "true") : console.error("Failed to mark notification as opened: ", await ee.text());
          } catch (ee) {
            console.error("Error marking notification as opened: ", ee);
          }
      }
      ht.on("miniAppAdded", ({
        notificationDetails: M
      }) => {
        a(!0), c(M ?? null), d("Frame added"), P("frame.added", h, p);
      }), ht.on("miniAppAddRejected", ({
        reason: M
      }) => {
        a(!1), d(`Frame add rejected: ${M}`), P("frame.add.rejected", h, p);
      }), ht.on("miniAppRemoved", () => {
        a(!1), d("Frame removed"), P("frame.removed", h, p);
      }), ht.on("notificationsEnabled", ({
        notificationDetails: M
      }) => {
        c(M ?? null), d("Notifications enabled"), P("notifications.enabled", h, p);
      }), ht.on("notificationsDisabled", () => {
        c(null), d("Notifications disabled"), P("notifications.disabled", h, p);
      }), ht.on("primaryButtonClicked", () => {
        d("Primary button clicked"), P("primary-button.clicked", h, p);
      }), ht.back.onback = () => {
        P("back-button.clicked", h, p), U();
      }, e && await ht.back.show(), bS().subscribe((M) => {
      }), await ht.actions.ready({}), r(!0);
    };
    if (ht && !t)
      return g(), () => {
        ht.removeAllListeners(), ht.back.onback = null, ht.back.hide();
      };
  }, [ht, h, p, t, P, U, e]), Et(() => {
    s != null && s.user && (s != null && s.client) && (f({
      username: s.user.username,
      clientFid: s.client.clientFid
    }), y(`${s.user.fid}`), P("frame.opened", {
      username: s.user.username,
      clientFid: s.client.clientFid,
      location: s.location,
      added: s.client.added
    }, `${s.user.fid}`));
  }, [s, P]), {
    ...ht,
    isSDKLoaded: t,
    context: s,
    added: o,
    notificationDetails: l,
    lastEvent: u,
    currentTab: C,
    setActiveTab: I,
    setInitialTab: j,
    haptics: {
      impactOccurred: B,
      notificationOccurred: V,
      selectionChanged: H
    },
    actions: {
      ...ht.actions,
      openUrl: G,
      close: F,
      composeCast: L
    }
  };
}
function AS({
  children: n
}) {
  const e = wS();
  return e.isSDKLoaded ? /* @__PURE__ */ K.jsx(Mg.Provider, {
    value: e,
    children: n
  }) : null;
}
function mL({
  children: n,
  analyticsEnabled: e = !1,
  backButtonEnabled: t = !1
}) {
  const r = Ln(() => ({
    analyticsEnabled: e,
    backButtonEnabled: t
  }), [e, t]);
  return /* @__PURE__ */ K.jsx(Pg.Provider, {
    value: r,
    children: /* @__PURE__ */ K.jsx(AS, {
      children: n
    })
  });
}
function yL() {
  const n = Wi(Mg);
  if (n === void 0)
    throw new Error("useMiniApp must be used within a MiniAppProvider");
  return n;
}
var Og = /* @__PURE__ */ ((n) => (n.Light = "light", n.Dark = "dark", n))(Og || {}), _n = /* @__PURE__ */ ((n) => (n.FARCASTER = "farcaster", n.NEYNAR = "neynar", n.WARPCAST = "warpcast", n))(_n || {});
function Du(n, e = "", {
  serialize: t = JSON.stringify,
  deserialize: r = JSON.parse
} = {}) {
  const [s, i] = We(() => {
    if (typeof window > "u")
      return e;
    try {
      const l = window.localStorage.getItem(n);
      return l ? r(l) : e;
    } catch (l) {
      return console.error("Error reading from localStorage", l), e;
    }
  });
  return [s, (l) => {
    try {
      const c = l instanceof Function ? l(s) : l;
      i(c), typeof window < "u" && window.localStorage.setItem(n, t(c));
    } catch (c) {
      console.error("Error writing to localStorage", c);
    }
  }, () => {
    try {
      window.localStorage.removeItem(n), i(e);
    } catch (l) {
      console.error("Error removing from localStorage", l);
    }
  }];
}
var ai = /* @__PURE__ */ ((n) => (n.NEYNAR_AUTHENTICATED_USER = "neynar_authenticated_user", n))(ai || {});
const Bg = Aa(void 0), IS = ({
  children: n,
  _setIsAuthenticated: e,
  _setUser: t,
  _onAuthSuccess: r,
  _onSignout: s
}) => {
  const {
    isAuthenticated: i
  } = gn(), [o, a] = We(!1), [l, c] = We(null), [u] = Du(ai.NEYNAR_AUTHENTICATED_USER);
  Et(() => {
    e(o);
  }, [o]), Et(() => {
    a(i);
  }, [i]), Et(() => {
    u ? (c(u), a(!0)) : (c(null), a(!1));
  }, []), Et(() => {
    t(l);
  }, [l]);
  const d = (p) => {
    r && r(p);
  }, h = (p) => {
    s && s(p);
  }, f = Ln(() => ({
    isAuthenticated: o,
    user: l,
    setIsAuthenticated: a,
    setUser: c,
    onAuthSuccess: d,
    onSignout: h
  }), [o, l]);
  return /* @__PURE__ */ K.jsx(Bg.Provider, {
    value: f,
    children: n
  });
}, Fg = () => {
  const n = Wi(Bg);
  if (!n)
    throw new Error("useAuth must be used within a AuthContextProvider");
  return n;
}, _S = /* @__PURE__ */ oe("div")({
  classes: ["tbaom7c"]
}), LS = /* @__PURE__ */ oe("div")({
  classes: ["t1ff44zi"],
  variants: [{
    props: {
      type: "success"
    },
    className: "t1ff44zi-1"
  }, {
    props: {
      type: "error"
    },
    className: "t1ff44zi-2"
  }, {
    props: {
      type: "warning"
    },
    className: "t1ff44zi-3"
  }, {
    props: {
      type: "info"
    },
    className: "t1ff44zi-4"
  }]
});
var Ng = /* @__PURE__ */ ((n) => (n.Success = "success", n.Error = "error", n.Warning = "warning", n.Info = "info", n))(Ng || {});
const Ug = Aa(void 0), vL = ({
  children: n,
  settings: {
    clientId: e,
    defaultTheme: t = Og.Light,
    eventsCallbacks: r
  }
}) => {
  const [s] = We(e), [i, o] = We(!1), [a, l] = We(t), [c, u] = We([]), [d, h] = We(null), f = (A, P) => {
    const I = {
      type: A,
      message: P
    };
    u((U) => [...U, I]), setTimeout(() => p(I), 5e3);
  }, p = (A) => {
    u((P) => P.filter((I) => I !== A));
  };
  Et(() => {
    const A = document.querySelector(":root");
    A && (a === "light" ? (A.classList.add("theme-light"), A.classList.remove("theme-dark")) : a === "dark" && (A.classList.add("theme-dark"), A.classList.remove("theme-light")));
  }, [a]);
  const y = (A) => {
    o(A);
  }, m = (A) => {
    h(A);
  }, b = () => {
    if (d) {
      const {
        signer_uuid: A,
        ...P
      } = d;
      h(null), o(!1), localStorage.removeItem(ai.NEYNAR_AUTHENTICATED_USER), r != null && r.onSignout && r.onSignout(P);
    }
  }, C = Ln(() => ({
    client_id: s,
    theme: a,
    isAuthenticated: i,
    user: d,
    setTheme: l,
    showToast: f,
    logoutUser: b
  }), [s, a, i, d, l, f, b]);
  return /* @__PURE__ */ K.jsx(Ug.Provider, {
    value: C,
    children: /* @__PURE__ */ K.jsxs(IS, {
      _setIsAuthenticated: y,
      _setUser: m,
      _onAuthSuccess: r == null ? void 0 : r.onAuthSuccess,
      _onSignout: r == null ? void 0 : r.onSignout,
      children: [n, /* @__PURE__ */ K.jsx(_S, {
        children: c.map((A, P) => /* @__PURE__ */ K.jsx(LS, {
          type: A.type,
          children: A.message
        }, P))
      })]
    })
  });
}, gn = () => {
  const n = Wi(Ug);
  if (!n)
    throw new Error("useNeynarContext must be used within a NeynarContextProvider");
  return n;
}, RS = () => /* @__PURE__ */ K.jsxs("svg", {
  width: "18",
  height: "17",
  viewBox: "0 0 18 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ K.jsx("path", {
    d: "M13.7222 0H4.27778C2.19137 0 0.5 1.69137 0.5 3.77778V13.2222C0.5 15.3086 2.19137 17 4.27778 17H13.7222C15.8086 17 17.5 15.3086 17.5 13.2222V3.77778C17.5 1.69137 15.8086 0 13.7222 0Z",
    fill: "#855DCD"
  }), /* @__PURE__ */ K.jsx("path", {
    d: "M4.88281 2.64453H13.1184V14.3556H11.9095V8.9912H11.8976C11.764 7.50859 10.518 6.34675 9.00059 6.34675C7.4832 6.34675 6.23717 7.50859 6.10356 8.9912H6.0917V14.3556H4.88281V2.64453Z",
    fill: "white"
  }), /* @__PURE__ */ K.jsx("path", {
    d: "M2.69141 4.30664L3.18252 5.96886H3.59807V12.6933C3.38943 12.6933 3.2203 12.8625 3.2203 13.0711V13.5244H3.14474C2.9361 13.5244 2.76696 13.6936 2.76696 13.9022V14.3555H6.99807V13.9022C6.99807 13.6936 6.82893 13.5244 6.6203 13.5244H6.54474V13.0711C6.54474 12.8625 6.3756 12.6933 6.16696 12.6933H5.71363V4.30664H2.69141Z",
    fill: "white"
  }), /* @__PURE__ */ K.jsx("path", {
    d: "M11.9854 12.6933C11.7768 12.6933 11.6076 12.8625 11.6076 13.0711V13.5244H11.5321C11.3235 13.5244 11.1543 13.6936 11.1543 13.9022V14.3555H15.3854V13.9022C15.3854 13.6936 15.2162 13.5244 15.0076 13.5244H14.9321V13.0711C14.9321 12.8625 14.7629 12.6933 14.5543 12.6933V5.96886H14.9699L15.461 4.30664H12.4387V12.6933H11.9854Z",
    fill: "white"
  })]
}), Xd = () => /* @__PURE__ */ K.jsxs("svg", {
  width: "32",
  height: "17",
  viewBox: "0 0 50 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ K.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3744 13.7311C38.3744 16.1209 37.7639 18.368 36.6904 20.3252C32.5685 19.8525 27.847 18.9503 22.8999 17.6247C20.4058 16.9564 18.0151 16.2236 15.7697 15.4495L15.7693 15.4486C15.7579 15.445 15.7465 15.4413 15.7351 15.4376C15.6448 15.4064 15.5547 15.3752 15.4649 15.3439C12.8978 14.399 11.2356 12.2056 11.4168 10.0315L11.4482 10.0399L11.4215 10.0133C13.0427 4.23612 18.3483 0 24.6434 0C32.2268 0 38.3744 6.14762 38.3744 13.7311Z",
    fill: "black"
  }), /* @__PURE__ */ K.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3804 17.2987C12.4882 16.5313 13.9658 16.1804 15.5002 16.3953C17.7731 17.156 20.1682 17.8782 22.6535 18.5441C27.397 19.8151 31.9584 20.7444 36.0833 21.3275C33.623 25.0252 29.4177 27.4619 24.6434 27.4619C18.294 27.4619 12.9511 23.1524 11.3804 17.2987Z",
    fill: "black"
  }), /* @__PURE__ */ K.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0917 13.4458C41.6461 12.6648 39.9756 11.8759 38.1233 11.1029C38.0363 10.6544 37.9275 10.2136 37.7981 9.78174C39.9806 10.6648 41.9403 11.5752 43.6139 12.4794C45.7007 13.6069 47.3703 14.7394 48.4714 15.816C49.5356 16.8566 50.2295 18.0063 49.93 19.1241C49.6304 20.2419 48.4547 20.8906 47.0128 21.2597C45.5209 21.6415 43.5087 21.7875 41.1377 21.7206C39.6046 21.6773 37.9082 21.5444 36.0864 21.3234C36.3086 20.9891 36.5165 20.6446 36.7094 20.2906C38.3134 20.4733 39.8091 20.5841 41.1687 20.6225C43.4946 20.6882 45.3908 20.5409 46.7404 20.1955C48.14 19.8373 48.7389 19.3249 48.8689 18.8398C48.9989 18.3547 48.7364 17.6115 47.7034 16.6015C46.7073 15.6275 45.1388 14.5519 43.0917 13.4458ZM8.86229 3.16772C10.7583 3.22128 12.9038 3.41177 15.2278 3.73661C14.8974 4.04803 14.5824 4.37566 14.2841 4.71822C12.3016 4.46314 10.4678 4.312 8.83127 4.26577C6.50541 4.20006 4.6092 4.34737 3.25958 4.69279C1.86001 5.05099 1.26107 5.56342 1.13109 6.04849C1.00112 6.53356 1.2636 7.27681 2.29657 8.2868C3.29267 9.26075 4.86118 10.3364 6.90828 11.4425C6.94181 11.4606 6.97546 11.4787 7.00923 11.4968C6.84251 11.5938 6.72574 11.7161 6.66353 11.8645C6.57791 12.0688 6.60013 12.3121 6.72013 12.5874C6.60757 12.5279 6.49623 12.4684 6.38612 12.4089C4.29926 11.2814 2.62971 10.1489 1.5286 9.07223C0.464367 8.03166 -0.229485 6.882 0.0700354 5.76418C0.369556 4.64635 1.54528 3.99764 2.98722 3.6286C4.47911 3.24677 6.49126 3.10074 8.86229 3.16772Z",
    fill: "black"
  }), /* @__PURE__ */ K.jsx("ellipse", {
    cx: "5.94866",
    cy: "11.5309",
    rx: "3.76009",
    ry: "0.575832",
    transform: "rotate(29.2824 5.94866 11.5309)",
    fill: "black"
  })]
}), CS = () => /* @__PURE__ */ K.jsxs("svg", {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ K.jsx("mask", {
    id: "mask0_875_48",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "17",
    height: "17",
    children: /* @__PURE__ */ K.jsx("path", {
      d: "M16.9947 0H0V16.9947H16.9947V0Z",
      fill: "white"
    })
  }), /* @__PURE__ */ K.jsxs("g", {
    mask: "url(#mask0_875_48)",
    children: [/* @__PURE__ */ K.jsx("path", {
      d: "M12.7871 16.9947H4.20765C1.88755 16.9947 0 15.1073 0 12.7871V4.20771C0 1.88756 1.88755 0 4.20765 0H12.7871C15.1072 0 16.9947 1.88756 16.9947 4.20771V12.7871C16.9947 15.1073 15.1072 16.9947 12.7871 16.9947Z",
      fill: "#472A91"
    }), /* @__PURE__ */ K.jsx("path", {
      d: "M11.1523 5.37891L10.3143 8.52601L9.47364 5.37891H7.53893L6.69017 8.54919L5.84419 5.37891H3.64062L5.68823 12.3371H7.58931L8.49835 9.10599L9.40736 12.3371H11.3125L13.3557 5.37891H11.1523Z",
      fill: "white"
    })]
  })]
});
var kS = {};
const Ec = /* @__PURE__ */ oe("img")({
  classes: ["ippfsqr"]
}), DS = /* @__PURE__ */ oe("button")({
  classes: ["b1yzssjb"]
}), PS = /* @__PURE__ */ oe("div")({
  classes: ["m1xn8b2e"]
}), MS = /* @__PURE__ */ oe("button")({
  classes: ["mwuiqyg"]
}), OS = (n, e) => {
  if (e)
    return e;
  switch (n) {
    case _n.FARCASTER:
      return "Sign in with Farcaster";
    case _n.NEYNAR:
      return "Sign in with Neynar";
    case _n.WARPCAST:
      return "Sign in with Warpcast";
    default:
      return "Sign in with Neynar";
  }
}, BS = (n, e, t) => {
  if (e)
    return e;
  if (t)
    return /* @__PURE__ */ K.jsx(Ec, {
      src: t,
      alt: "Custom logo"
    });
  switch (n) {
    case _n.FARCASTER:
      return /* @__PURE__ */ K.jsx(RS, {});
    case _n.NEYNAR:
      return /* @__PURE__ */ K.jsx(Xd, {});
    case _n.WARPCAST:
      return /* @__PURE__ */ K.jsx(CS, {});
    default:
      return /* @__PURE__ */ K.jsx(Xd, {});
  }
}, FS = ({
  children: n,
  label: e,
  variant: t = _n.NEYNAR,
  icon: r,
  customLogoUrl: s,
  modalStyle: i = {},
  modalButtonStyle: o = {},
  ...a
}) => {
  const {
    client_id: l,
    user: c,
    isAuthenticated: u
  } = gn(), {
    setIsAuthenticated: d,
    setUser: h,
    onAuthSuccess: f,
    onSignout: p
  } = Fg(), [y, m, b] = Du(ai.NEYNAR_AUTHENTICATED_USER), [C, A] = We(!1), P = lr(null), I = `${kS.NEYNAR_LOGIN_URL ?? "https://app.neynar.com/login"}?client_id=${l}`, U = new URL(I).origin, j = lr(null), G = ft(async (g) => {
    var x;
    if (g.origin === U && g.data && g.data.is_authenticated) {
      d(!0), (x = P.current) == null || x.close(), window.removeEventListener("message", G);
      const w = {
        signer_uuid: g.data.signer_uuid,
        ...g.data.user
      };
      m(w), h(w), f({
        user: w
      });
    }
  }, [l, d]), F = ft(() => {
    const w = window.screen.width / 2 - 300, D = `width=600,height=700,top=${window.screen.height / 2 - 700 / 2},left=${w}`;
    if (P.current = window.open(I, "_blank", D), !P.current) {
      console.error("Failed to open the authentication window. Please check your pop-up blocker settings.");
      return;
    }
    window.addEventListener("message", G, !1);
  }, [l, G]), B = () => {
    if (c) {
      const g = c;
      b(), d(!1), H();
      const {
        signer_uuid: x,
        ...w
      } = g;
      p(w);
    }
  }, V = () => A(!0), H = () => A(!1);
  Et(() => () => {
    window.removeEventListener("message", G);
  }, [G]);
  const L = ft((g) => {
    j.current && !j.current.contains(g.target) && H();
  }, []);
  return Et(() => (C ? document.addEventListener("mousedown", L) : document.removeEventListener("mousedown", L), () => {
    document.removeEventListener("mousedown", L);
  }), [C, L]), /* @__PURE__ */ K.jsxs(K.Fragment, {
    children: [C && /* @__PURE__ */ K.jsxs(PS, {
      style: i,
      ref: j,
      children: [/* @__PURE__ */ K.jsx(Ec, {
        src: c == null ? void 0 : c.pfp_url,
        alt: c == null ? void 0 : c.username
      }), /* @__PURE__ */ K.jsxs("span", {
        children: ["@", c == null ? void 0 : c.username]
      }), /* @__PURE__ */ K.jsx(MS, {
        style: o,
        onClick: B,
        children: "Sign out"
      })]
    }), /* @__PURE__ */ K.jsx(DS, {
      onClick: u ? V : F,
      ...a,
      children: u ? /* @__PURE__ */ K.jsxs(K.Fragment, {
        children: [/* @__PURE__ */ K.jsx(Ec, {
          src: c == null ? void 0 : c.pfp_url,
          alt: `${c == null ? void 0 : c.username} profile picture`
        }), /* @__PURE__ */ K.jsxs("span", {
          style: {
            marginLeft: "10px"
          },
          children: ["@", c == null ? void 0 : c.username]
        })]
      }) : /* @__PURE__ */ K.jsxs(K.Fragment, {
        children: [BS(t, r, s), /* @__PURE__ */ K.jsx("span", {
          style: {
            marginLeft: "5px"
          },
          children: OS(t, e)
        })]
      })
    })]
  });
}, ha = /* @__PURE__ */ oe("img")({
  classes: ["a11pt0xp"],
  vars: {
    "a11pt0xp-0": [(n, e = Xr) => n.width || "45px", !1],
    "a11pt0xp-1": [(n, e = Xr) => n.width || "45px", !1]
  }
}), Jd = "https://farcaster.xyz", $g = /(^|\s)\/\w+/g, Gg = /@\w+(\.eth)?/g, jg = /((https?:\/\/)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\/[^\s]*)?)/g, Qd = new RegExp(`(${$g.source})|(${Gg.source})|(${jg.source})`, "g"), NS = (n) => $g.test(n) ? `${Jd}/~/channel${n.trim()}` : Gg.test(n) ? `${Jd}/${n.substring(1)}` : jg.test(n) ? n.startsWith("http") ? n : `http://${n}` : "", US = /* @__PURE__ */ oe("a")({
  classes: ["s4xymqs"]
}), $S = (n) => n.filter((e) => e.url).map((e) => e.url), GS = (n, e) => {
  if (!n) return [];
  const t = $S(e), r = [];
  let s = 0, i;
  for (; (i = Qd.exec(n)) !== null; ) {
    const o = i.index;
    s < o && r.push(n.slice(s, o));
    const a = i[0].trim();
    if (t.includes(a))
      r.push(a);
    else {
      const l = NS(a);
      r.push(/* @__PURE__ */ K.jsx(US, {
        href: l,
        target: "_blank",
        children: a
      }, o));
    }
    s = Qd.lastIndex;
  }
  return s < n.length && r.push(n.slice(s)), r;
}, Fr = /* @__PURE__ */ oe("div")({
  classes: ["be87m0m"],
  vars: {
    "be87m0m-0": [(n, e = Xr) => n.alignItems || "flex-start", !1],
    "be87m0m-1": [(n, e = Xr) => n.justifyContent || "flex-start", !1],
    "be87m0m-2": [(n, e = Xr) => n.flexGrow || "initial", !0],
    "be87m0m-3": [(n, e = Xr) => n.flexShrink || "initial", !0],
    "be87m0m-4": [(n, e = Xr) => n.spacing ?? n.spacingVertical ?? n.spacingTop ?? "0px", !1],
    "be87m0m-5": [(n, e = Xr) => n.spacing ?? n.spacingHorizontal ?? n.spacingRight ?? "0px", !1],
    "be87m0m-6": [(n, e = Xr) => n.spacing ?? n.spacingVertical ?? n.spacingBottom ?? "0px", !1],
    "be87m0m-7": [(n, e = Xr) => n.spacing ?? n.spacingHorizontal ?? n.spacingLeft ?? "0px", !1]
  }
}), jS = () => Fr, jr = /* @__PURE__ */ oe(jS())({
  classes: ["ha1dvpi"]
}), ae = Number.isFinite || function(n) {
  return typeof n == "number" && isFinite(n);
}, VS = Number.isSafeInteger || function(n) {
  return typeof n == "number" && Math.abs(n) <= KS;
}, KS = Number.MAX_SAFE_INTEGER || 9007199254740991;
let ge = /* @__PURE__ */ function(n) {
  return n.NETWORK_ERROR = "networkError", n.MEDIA_ERROR = "mediaError", n.KEY_SYSTEM_ERROR = "keySystemError", n.MUX_ERROR = "muxError", n.OTHER_ERROR = "otherError", n;
}({}), Y = /* @__PURE__ */ function(n) {
  return n.KEY_SYSTEM_NO_KEYS = "keySystemNoKeys", n.KEY_SYSTEM_NO_ACCESS = "keySystemNoAccess", n.KEY_SYSTEM_NO_SESSION = "keySystemNoSession", n.KEY_SYSTEM_NO_CONFIGURED_LICENSE = "keySystemNoConfiguredLicense", n.KEY_SYSTEM_LICENSE_REQUEST_FAILED = "keySystemLicenseRequestFailed", n.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED = "keySystemServerCertificateRequestFailed", n.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED = "keySystemServerCertificateUpdateFailed", n.KEY_SYSTEM_SESSION_UPDATE_FAILED = "keySystemSessionUpdateFailed", n.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED = "keySystemStatusOutputRestricted", n.KEY_SYSTEM_STATUS_INTERNAL_ERROR = "keySystemStatusInternalError", n.KEY_SYSTEM_DESTROY_MEDIA_KEYS_ERROR = "keySystemDestroyMediaKeysError", n.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR = "keySystemDestroyCloseSessionError", n.KEY_SYSTEM_DESTROY_REMOVE_SESSION_ERROR = "keySystemDestroyRemoveSessionError", n.MANIFEST_LOAD_ERROR = "manifestLoadError", n.MANIFEST_LOAD_TIMEOUT = "manifestLoadTimeOut", n.MANIFEST_PARSING_ERROR = "manifestParsingError", n.MANIFEST_INCOMPATIBLE_CODECS_ERROR = "manifestIncompatibleCodecsError", n.LEVEL_EMPTY_ERROR = "levelEmptyError", n.LEVEL_LOAD_ERROR = "levelLoadError", n.LEVEL_LOAD_TIMEOUT = "levelLoadTimeOut", n.LEVEL_PARSING_ERROR = "levelParsingError", n.LEVEL_SWITCH_ERROR = "levelSwitchError", n.AUDIO_TRACK_LOAD_ERROR = "audioTrackLoadError", n.AUDIO_TRACK_LOAD_TIMEOUT = "audioTrackLoadTimeOut", n.SUBTITLE_LOAD_ERROR = "subtitleTrackLoadError", n.SUBTITLE_TRACK_LOAD_TIMEOUT = "subtitleTrackLoadTimeOut", n.FRAG_LOAD_ERROR = "fragLoadError", n.FRAG_LOAD_TIMEOUT = "fragLoadTimeOut", n.FRAG_DECRYPT_ERROR = "fragDecryptError", n.FRAG_PARSING_ERROR = "fragParsingError", n.FRAG_GAP = "fragGap", n.REMUX_ALLOC_ERROR = "remuxAllocError", n.KEY_LOAD_ERROR = "keyLoadError", n.KEY_LOAD_TIMEOUT = "keyLoadTimeOut", n.BUFFER_ADD_CODEC_ERROR = "bufferAddCodecError", n.BUFFER_INCOMPATIBLE_CODECS_ERROR = "bufferIncompatibleCodecsError", n.BUFFER_APPEND_ERROR = "bufferAppendError", n.BUFFER_APPENDING_ERROR = "bufferAppendingError", n.BUFFER_STALLED_ERROR = "bufferStalledError", n.BUFFER_FULL_ERROR = "bufferFullError", n.BUFFER_SEEK_OVER_HOLE = "bufferSeekOverHole", n.BUFFER_NUDGE_ON_STALL = "bufferNudgeOnStall", n.ASSET_LIST_LOAD_ERROR = "assetListLoadError", n.ASSET_LIST_LOAD_TIMEOUT = "assetListLoadTimeout", n.ASSET_LIST_PARSING_ERROR = "assetListParsingError", n.INTERSTITIAL_ASSET_ITEM_ERROR = "interstitialAssetItemError", n.INTERNAL_EXCEPTION = "internalException", n.INTERNAL_ABORTED = "aborted", n.ATTACH_MEDIA_ERROR = "attachMediaError", n.UNKNOWN = "unknown", n;
}({}), T = /* @__PURE__ */ function(n) {
  return n.MEDIA_ATTACHING = "hlsMediaAttaching", n.MEDIA_ATTACHED = "hlsMediaAttached", n.MEDIA_DETACHING = "hlsMediaDetaching", n.MEDIA_DETACHED = "hlsMediaDetached", n.MEDIA_ENDED = "hlsMediaEnded", n.STALL_RESOLVED = "hlsStallResolved", n.BUFFER_RESET = "hlsBufferReset", n.BUFFER_CODECS = "hlsBufferCodecs", n.BUFFER_CREATED = "hlsBufferCreated", n.BUFFER_APPENDING = "hlsBufferAppending", n.BUFFER_APPENDED = "hlsBufferAppended", n.BUFFER_EOS = "hlsBufferEos", n.BUFFERED_TO_END = "hlsBufferedToEnd", n.BUFFER_FLUSHING = "hlsBufferFlushing", n.BUFFER_FLUSHED = "hlsBufferFlushed", n.MANIFEST_LOADING = "hlsManifestLoading", n.MANIFEST_LOADED = "hlsManifestLoaded", n.MANIFEST_PARSED = "hlsManifestParsed", n.LEVEL_SWITCHING = "hlsLevelSwitching", n.LEVEL_SWITCHED = "hlsLevelSwitched", n.LEVEL_LOADING = "hlsLevelLoading", n.LEVEL_LOADED = "hlsLevelLoaded", n.LEVEL_UPDATED = "hlsLevelUpdated", n.LEVEL_PTS_UPDATED = "hlsLevelPtsUpdated", n.LEVELS_UPDATED = "hlsLevelsUpdated", n.AUDIO_TRACKS_UPDATED = "hlsAudioTracksUpdated", n.AUDIO_TRACK_SWITCHING = "hlsAudioTrackSwitching", n.AUDIO_TRACK_SWITCHED = "hlsAudioTrackSwitched", n.AUDIO_TRACK_LOADING = "hlsAudioTrackLoading", n.AUDIO_TRACK_LOADED = "hlsAudioTrackLoaded", n.AUDIO_TRACK_UPDATED = "hlsAudioTrackUpdated", n.SUBTITLE_TRACKS_UPDATED = "hlsSubtitleTracksUpdated", n.SUBTITLE_TRACKS_CLEARED = "hlsSubtitleTracksCleared", n.SUBTITLE_TRACK_SWITCH = "hlsSubtitleTrackSwitch", n.SUBTITLE_TRACK_LOADING = "hlsSubtitleTrackLoading", n.SUBTITLE_TRACK_LOADED = "hlsSubtitleTrackLoaded", n.SUBTITLE_TRACK_UPDATED = "hlsSubtitleTrackUpdated", n.SUBTITLE_FRAG_PROCESSED = "hlsSubtitleFragProcessed", n.CUES_PARSED = "hlsCuesParsed", n.NON_NATIVE_TEXT_TRACKS_FOUND = "hlsNonNativeTextTracksFound", n.INIT_PTS_FOUND = "hlsInitPtsFound", n.FRAG_LOADING = "hlsFragLoading", n.FRAG_LOAD_EMERGENCY_ABORTED = "hlsFragLoadEmergencyAborted", n.FRAG_LOADED = "hlsFragLoaded", n.FRAG_DECRYPTED = "hlsFragDecrypted", n.FRAG_PARSING_INIT_SEGMENT = "hlsFragParsingInitSegment", n.FRAG_PARSING_USERDATA = "hlsFragParsingUserdata", n.FRAG_PARSING_METADATA = "hlsFragParsingMetadata", n.FRAG_PARSED = "hlsFragParsed", n.FRAG_BUFFERED = "hlsFragBuffered", n.FRAG_CHANGED = "hlsFragChanged", n.FPS_DROP = "hlsFpsDrop", n.FPS_DROP_LEVEL_CAPPING = "hlsFpsDropLevelCapping", n.MAX_AUTO_LEVEL_UPDATED = "hlsMaxAutoLevelUpdated", n.ERROR = "hlsError", n.DESTROYING = "hlsDestroying", n.KEY_LOADING = "hlsKeyLoading", n.KEY_LOADED = "hlsKeyLoaded", n.LIVE_BACK_BUFFER_REACHED = "hlsLiveBackBufferReached", n.BACK_BUFFER_REACHED = "hlsBackBufferReached", n.STEERING_MANIFEST_LOADED = "hlsSteeringManifestLoaded", n.ASSET_LIST_LOADING = "hlsAssetListLoading", n.ASSET_LIST_LOADED = "hlsAssetListLoaded", n.INTERSTITIALS_UPDATED = "hlsInterstitialsUpdated", n.INTERSTITIALS_BUFFERED_TO_BOUNDARY = "hlsInterstitialsBufferedToBoundary", n.INTERSTITIAL_ASSET_PLAYER_CREATED = "hlsInterstitialAssetPlayerCreated", n.INTERSTITIAL_STARTED = "hlsInterstitialStarted", n.INTERSTITIAL_ASSET_STARTED = "hlsInterstitialAssetStarted", n.INTERSTITIAL_ASSET_ENDED = "hlsInterstitialAssetEnded", n.INTERSTITIAL_ASSET_ERROR = "hlsInterstitialAssetError", n.INTERSTITIAL_ENDED = "hlsInterstitialEnded", n.INTERSTITIALS_PRIMARY_RESUMED = "hlsInterstitialsPrimaryResumed", n.PLAYOUT_LIMIT_REACHED = "hlsPlayoutLimitReached", n.EVENT_CUE_ENTER = "hlsEventCueEnter", n;
}({});
var Ke = {
  MANIFEST: "manifest",
  LEVEL: "level",
  AUDIO_TRACK: "audioTrack",
  SUBTITLE_TRACK: "subtitleTrack"
}, he = {
  MAIN: "main",
  AUDIO: "audio",
  SUBTITLE: "subtitle"
};
class Ls {
  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  constructor(e, t = 0, r = 0) {
    this.halfLife = void 0, this.alpha_ = void 0, this.estimate_ = void 0, this.totalWeight_ = void 0, this.halfLife = e, this.alpha_ = e ? Math.exp(Math.log(0.5) / e) : 0, this.estimate_ = t, this.totalWeight_ = r;
  }
  sample(e, t) {
    const r = Math.pow(this.alpha_, e);
    this.estimate_ = t * (1 - r) + r * this.estimate_, this.totalWeight_ += e;
  }
  getTotalWeight() {
    return this.totalWeight_;
  }
  getEstimate() {
    if (this.alpha_) {
      const e = 1 - Math.pow(this.alpha_, this.totalWeight_);
      if (e)
        return this.estimate_ / e;
    }
    return this.estimate_;
  }
}
class HS {
  constructor(e, t, r, s = 100) {
    this.defaultEstimate_ = void 0, this.minWeight_ = void 0, this.minDelayMs_ = void 0, this.slow_ = void 0, this.fast_ = void 0, this.defaultTTFB_ = void 0, this.ttfb_ = void 0, this.defaultEstimate_ = r, this.minWeight_ = 1e-3, this.minDelayMs_ = 50, this.slow_ = new Ls(e), this.fast_ = new Ls(t), this.defaultTTFB_ = s, this.ttfb_ = new Ls(e);
  }
  update(e, t) {
    const {
      slow_: r,
      fast_: s,
      ttfb_: i
    } = this;
    r.halfLife !== e && (this.slow_ = new Ls(e, r.getEstimate(), r.getTotalWeight())), s.halfLife !== t && (this.fast_ = new Ls(t, s.getEstimate(), s.getTotalWeight())), i.halfLife !== e && (this.ttfb_ = new Ls(e, i.getEstimate(), i.getTotalWeight()));
  }
  sample(e, t) {
    e = Math.max(e, this.minDelayMs_);
    const r = 8 * t, s = e / 1e3, i = r / s;
    this.fast_.sample(s, i), this.slow_.sample(s, i);
  }
  sampleTTFB(e) {
    const t = e / 1e3, r = Math.sqrt(2) * Math.exp(-Math.pow(t, 2) / 2);
    this.ttfb_.sample(r, Math.max(e, 5));
  }
  canEstimate() {
    return this.fast_.getTotalWeight() >= this.minWeight_;
  }
  getEstimate() {
    return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
  }
  getEstimateTTFB() {
    return this.ttfb_.getTotalWeight() >= this.minWeight_ ? this.ttfb_.getEstimate() : this.defaultTTFB_;
  }
  get defaultEstimate() {
    return this.defaultEstimate_;
  }
  destroy() {
  }
}
function WS(n, e, t) {
  return (e = zS(e)) in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}
function st() {
  return st = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, st.apply(null, arguments);
}
function eh(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function rt(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? eh(Object(t), !0).forEach(function(r) {
      WS(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : eh(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function qS(n, e) {
  if (typeof n != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function zS(n) {
  var e = qS(n, "string");
  return typeof e == "symbol" ? e : e + "";
}
class Cn {
  constructor(e, t) {
    this.trace = void 0, this.debug = void 0, this.log = void 0, this.warn = void 0, this.info = void 0, this.error = void 0;
    const r = `[${e}]:`;
    this.trace = $n, this.debug = t.debug.bind(null, r), this.log = t.log.bind(null, r), this.warn = t.warn.bind(null, r), this.info = t.info.bind(null, r), this.error = t.error.bind(null, r);
  }
}
const $n = function() {
}, YS = {
  trace: $n,
  debug: $n,
  log: $n,
  warn: $n,
  info: $n,
  error: $n
};
function Sc() {
  return st({}, YS);
}
function ZS(n, e) {
  const t = self.console[n];
  return t ? t.bind(self.console, `${e ? "[" + e + "] " : ""}[${n}] >`) : $n;
}
function th(n, e, t) {
  return e[n] ? e[n].bind(e) : ZS(n, t);
}
const bc = Sc();
function XS(n, e, t) {
  const r = Sc();
  if (typeof console == "object" && n === !0 || typeof n == "object") {
    const s = [
      // Remove out from list here to hard-disable a log-level
      // 'trace',
      "debug",
      "log",
      "info",
      "warn",
      "error"
    ];
    s.forEach((i) => {
      r[i] = th(i, n, t);
    });
    try {
      r.log(`Debug logs enabled for "${e}" in hls.js version 1.6.5`);
    } catch {
      return Sc();
    }
    s.forEach((i) => {
      bc[i] = th(i, n);
    });
  } else
    st(bc, r);
  return r;
}
const Ze = bc;
function Zn(n = !0) {
  return typeof self > "u" ? void 0 : (n || !self.MediaSource) && self.ManagedMediaSource || self.MediaSource || self.WebKitMediaSource;
}
function JS(n) {
  return typeof self < "u" && n === self.ManagedMediaSource;
}
function Vg(n, e) {
  const t = Object.keys(n), r = Object.keys(e), s = t.length, i = r.length;
  return !s || !i || s === i && !t.some((o) => r.indexOf(o) === -1);
}
function Lr(n, e = !1) {
  if (typeof TextDecoder < "u") {
    const c = new TextDecoder("utf-8").decode(n);
    if (e) {
      const u = c.indexOf("\0");
      return u !== -1 ? c.substring(0, u) : c;
    }
    return c.replace(/\0/g, "");
  }
  const t = n.length;
  let r, s, i, o = "", a = 0;
  for (; a < t; ) {
    if (r = n[a++], r === 0 && e)
      return o;
    if (r === 0 || r === 3)
      continue;
    switch (r >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        o += String.fromCharCode(r);
        break;
      case 12:
      case 13:
        s = n[a++], o += String.fromCharCode((r & 31) << 6 | s & 63);
        break;
      case 14:
        s = n[a++], i = n[a++], o += String.fromCharCode((r & 15) << 12 | (s & 63) << 6 | (i & 63) << 0);
        break;
    }
  }
  return o;
}
const Qr = {
  hexDump: function(n) {
    let e = "";
    for (let t = 0; t < n.length; t++) {
      let r = n[t].toString(16);
      r.length < 2 && (r = "0" + r), e += r;
    }
    return e;
  }
};
function QS(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var wl = { exports: {} }, rh;
function eb() {
  return rh || (rh = 1, function(n, e) {
    (function(t) {
      var r = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, s = /^(?=([^\/?#]*))\1([^]*)$/, i = /(?:\/|^)\.(?=\/)/g, o = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, a = {
        // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
        // E.g
        // With opts.alwaysNormalize = false (default, spec compliant)
        // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
        // With opts.alwaysNormalize = true (not spec compliant)
        // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
        buildAbsoluteURL: function(l, c, u) {
          if (u = u || {}, l = l.trim(), c = c.trim(), !c) {
            if (!u.alwaysNormalize)
              return l;
            var d = a.parseURL(l);
            if (!d)
              throw new Error("Error trying to parse base URL.");
            return d.path = a.normalizePath(
              d.path
            ), a.buildURLFromParts(d);
          }
          var h = a.parseURL(c);
          if (!h)
            throw new Error("Error trying to parse relative URL.");
          if (h.scheme)
            return u.alwaysNormalize ? (h.path = a.normalizePath(h.path), a.buildURLFromParts(h)) : c;
          var f = a.parseURL(l);
          if (!f)
            throw new Error("Error trying to parse base URL.");
          if (!f.netLoc && f.path && f.path[0] !== "/") {
            var p = s.exec(f.path);
            f.netLoc = p[1], f.path = p[2];
          }
          f.netLoc && !f.path && (f.path = "/");
          var y = {
            // 2c) Otherwise, the embedded URL inherits the scheme of
            // the base URL.
            scheme: f.scheme,
            netLoc: h.netLoc,
            path: null,
            params: h.params,
            query: h.query,
            fragment: h.fragment
          };
          if (!h.netLoc && (y.netLoc = f.netLoc, h.path[0] !== "/"))
            if (!h.path)
              y.path = f.path, h.params || (y.params = f.params, h.query || (y.query = f.query));
            else {
              var m = f.path, b = m.substring(0, m.lastIndexOf("/") + 1) + h.path;
              y.path = a.normalizePath(b);
            }
          return y.path === null && (y.path = u.alwaysNormalize ? a.normalizePath(h.path) : h.path), a.buildURLFromParts(y);
        },
        parseURL: function(l) {
          var c = r.exec(l);
          return c ? {
            scheme: c[1] || "",
            netLoc: c[2] || "",
            path: c[3] || "",
            params: c[4] || "",
            query: c[5] || "",
            fragment: c[6] || ""
          } : null;
        },
        normalizePath: function(l) {
          for (l = l.split("").reverse().join("").replace(i, ""); l.length !== (l = l.replace(o, "")).length; )
            ;
          return l.split("").reverse().join("");
        },
        buildURLFromParts: function(l) {
          return l.scheme + l.netLoc + l.path + l.params + l.query + l.fragment;
        }
      };
      n.exports = a;
    })();
  }(wl)), wl.exports;
}
var Pu = eb();
class Mu {
  constructor() {
    this.aborted = !1, this.loaded = 0, this.retry = 0, this.total = 0, this.chunkCount = 0, this.bwEstimate = 0, this.loading = {
      start: 0,
      first: 0,
      end: 0
    }, this.parsing = {
      start: 0,
      end: 0
    }, this.buffering = {
      start: 0,
      first: 0,
      end: 0
    };
  }
}
var lt = {
  AUDIO: "audio",
  VIDEO: "video",
  AUDIOVIDEO: "audiovideo"
};
class Kg {
  constructor(e) {
    this._byteRange = null, this._url = null, this._stats = null, this._streams = null, this.base = void 0, this.relurl = void 0, typeof e == "string" && (e = {
      url: e
    }), this.base = e, rb(this, "stats");
  }
  // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
  setByteRange(e, t) {
    const r = e.split("@", 2);
    let s;
    r.length === 1 ? s = (t == null ? void 0 : t.byteRangeEndOffset) || 0 : s = parseInt(r[1]), this._byteRange = [s, parseInt(r[0]) + s];
  }
  get baseurl() {
    return this.base.url;
  }
  get byteRange() {
    return this._byteRange === null ? [] : this._byteRange;
  }
  get byteRangeStartOffset() {
    return this.byteRange[0];
  }
  get byteRangeEndOffset() {
    return this.byteRange[1];
  }
  get elementaryStreams() {
    return this._streams === null && (this._streams = {
      [lt.AUDIO]: null,
      [lt.VIDEO]: null,
      [lt.AUDIOVIDEO]: null
    }), this._streams;
  }
  set elementaryStreams(e) {
    this._streams = e;
  }
  get hasStats() {
    return this._stats !== null;
  }
  get hasStreams() {
    return this._streams !== null;
  }
  get stats() {
    return this._stats === null && (this._stats = new Mu()), this._stats;
  }
  set stats(e) {
    this._stats = e;
  }
  get url() {
    return !this._url && this.baseurl && this.relurl && (this._url = Pu.buildAbsoluteURL(this.baseurl, this.relurl, {
      alwaysNormalize: !0
    })), this._url || "";
  }
  set url(e) {
    this._url = e;
  }
  clearElementaryStreamInfo() {
    const {
      elementaryStreams: e
    } = this;
    e[lt.AUDIO] = null, e[lt.VIDEO] = null, e[lt.AUDIOVIDEO] = null;
  }
}
function Yt(n) {
  return n.sn !== "initSegment";
}
class Al extends Kg {
  constructor(e, t) {
    super(t), this._decryptdata = null, this._programDateTime = null, this._ref = null, this._bitrate = void 0, this.rawProgramDateTime = null, this.tagList = [], this.duration = 0, this.sn = 0, this.levelkeys = void 0, this.type = void 0, this.loader = null, this.keyLoader = null, this.level = -1, this.cc = 0, this.startPTS = void 0, this.endPTS = void 0, this.startDTS = void 0, this.endDTS = void 0, this.start = 0, this.playlistOffset = 0, this.deltaPTS = void 0, this.maxStartPTS = void 0, this.minEndPTS = void 0, this.data = void 0, this.bitrateTest = !1, this.title = null, this.initSegment = null, this.endList = void 0, this.gap = void 0, this.urlId = 0, this.type = e;
  }
  get byteLength() {
    if (this.hasStats) {
      const e = this.stats.total;
      if (e)
        return e;
    }
    if (this.byteRange) {
      const e = this.byteRange[0], t = this.byteRange[1];
      if (ae(e) && ae(t))
        return t - e;
    }
    return null;
  }
  get bitrate() {
    return this.byteLength ? this.byteLength * 8 / this.duration : this._bitrate ? this._bitrate : null;
  }
  set bitrate(e) {
    this._bitrate = e;
  }
  get decryptdata() {
    const {
      levelkeys: e
    } = this;
    if (!e && !this._decryptdata)
      return null;
    if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
      const t = this.levelkeys.identity;
      if (t)
        this._decryptdata = t.getDecryptData(this.sn);
      else {
        const r = Object.keys(this.levelkeys);
        if (r.length === 1)
          return this._decryptdata = this.levelkeys[r[0]].getDecryptData(this.sn);
      }
    }
    return this._decryptdata;
  }
  get end() {
    return this.start + this.duration;
  }
  get endProgramDateTime() {
    if (this.programDateTime === null)
      return null;
    const e = ae(this.duration) ? this.duration : 0;
    return this.programDateTime + e * 1e3;
  }
  get encrypted() {
    var e;
    if ((e = this._decryptdata) != null && e.encrypted)
      return !0;
    if (this.levelkeys) {
      const t = Object.keys(this.levelkeys), r = t.length;
      if (r > 1 || r === 1 && this.levelkeys[t[0]].encrypted)
        return !0;
    }
    return !1;
  }
  get programDateTime() {
    return this._programDateTime === null && this.rawProgramDateTime && (this.programDateTime = Date.parse(this.rawProgramDateTime)), this._programDateTime;
  }
  set programDateTime(e) {
    if (!ae(e)) {
      this._programDateTime = this.rawProgramDateTime = null;
      return;
    }
    this._programDateTime = e;
  }
  get ref() {
    return Yt(this) ? (this._ref || (this._ref = {
      base: this.base,
      start: this.start,
      duration: this.duration,
      sn: this.sn,
      programDateTime: this.programDateTime
    }), this._ref) : null;
  }
  addStart(e) {
    this.setStart(this.start + e);
  }
  setStart(e) {
    this.start = e, this._ref && (this._ref.start = e);
  }
  setDuration(e) {
    this.duration = e, this._ref && (this._ref.duration = e);
  }
  setKeyFormat(e) {
    if (this.levelkeys) {
      const t = this.levelkeys[e];
      t && !this._decryptdata && (this._decryptdata = t.getDecryptData(this.sn));
    }
  }
  abortRequests() {
    var e, t;
    (e = this.loader) == null || e.abort(), (t = this.keyLoader) == null || t.abort();
  }
  setElementaryStreamInfo(e, t, r, s, i, o = !1) {
    const {
      elementaryStreams: a
    } = this, l = a[e];
    if (!l) {
      a[e] = {
        startPTS: t,
        endPTS: r,
        startDTS: s,
        endDTS: i,
        partial: o
      };
      return;
    }
    l.startPTS = Math.min(l.startPTS, t), l.endPTS = Math.max(l.endPTS, r), l.startDTS = Math.min(l.startDTS, s), l.endDTS = Math.max(l.endDTS, i);
  }
}
class tb extends Kg {
  constructor(e, t, r, s, i) {
    super(r), this.fragOffset = 0, this.duration = 0, this.gap = !1, this.independent = !1, this.relurl = void 0, this.fragment = void 0, this.index = void 0, this.duration = e.decimalFloatingPoint("DURATION"), this.gap = e.bool("GAP"), this.independent = e.bool("INDEPENDENT"), this.relurl = e.enumeratedString("URI"), this.fragment = t, this.index = s;
    const o = e.enumeratedString("BYTERANGE");
    o && this.setByteRange(o, i), i && (this.fragOffset = i.fragOffset + i.duration);
  }
  get start() {
    return this.fragment.start + this.fragOffset;
  }
  get end() {
    return this.start + this.duration;
  }
  get loaded() {
    const {
      elementaryStreams: e
    } = this;
    return !!(e.audio || e.video || e.audiovideo);
  }
}
function Hg(n, e) {
  const t = Object.getPrototypeOf(n);
  if (t) {
    const r = Object.getOwnPropertyDescriptor(t, e);
    return r || Hg(t, e);
  }
}
function rb(n, e) {
  const t = Hg(n, e);
  t && (t.enumerable = !0, Object.defineProperty(n, e, t));
}
const fa = Math.pow(2, 32) - 1, nb = [].push, Wg = {
  video: 1,
  audio: 2,
  id3: 3,
  text: 4
};
function Vt(n) {
  return String.fromCharCode.apply(null, n);
}
function qg(n, e) {
  const t = n[e] << 8 | n[e + 1];
  return t < 0 ? 65536 + t : t;
}
function Te(n, e) {
  const t = zg(n, e);
  return t < 0 ? 4294967296 + t : t;
}
function nh(n, e) {
  let t = Te(n, e);
  return t *= Math.pow(2, 32), t += Te(n, e + 4), t;
}
function zg(n, e) {
  return n[e] << 24 | n[e + 1] << 16 | n[e + 2] << 8 | n[e + 3];
}
function Il(n, e, t) {
  n[e] = t >> 24, n[e + 1] = t >> 16 & 255, n[e + 2] = t >> 8 & 255, n[e + 3] = t & 255;
}
function sb(n) {
  const e = n.byteLength;
  for (let t = 0; t < e; ) {
    const r = Te(n, t);
    if (r > 8 && n[t + 4] === 109 && n[t + 5] === 111 && n[t + 6] === 111 && n[t + 7] === 102)
      return !0;
    t = r > 1 ? t + r : e;
  }
  return !1;
}
function Oe(n, e) {
  const t = [];
  if (!e.length)
    return t;
  const r = n.byteLength;
  for (let s = 0; s < r; ) {
    const i = Te(n, s), o = Vt(n.subarray(s + 4, s + 8)), a = i > 1 ? s + i : r;
    if (o === e[0])
      if (e.length === 1)
        t.push(n.subarray(s + 8, a));
      else {
        const l = Oe(n.subarray(s + 8, a), e.slice(1));
        l.length && nb.apply(t, l);
      }
    s = a;
  }
  return t;
}
function ib(n) {
  const e = [], t = n[0];
  let r = 8;
  const s = Te(n, r);
  r += 4;
  let i = 0, o = 0;
  t === 0 ? (i = Te(n, r), o = Te(n, r + 4), r += 8) : (i = nh(n, r), o = nh(n, r + 8), r += 16), r += 2;
  let a = n.length + o;
  const l = qg(n, r);
  r += 2;
  for (let c = 0; c < l; c++) {
    let u = r;
    const d = Te(n, u);
    u += 4;
    const h = d & 2147483647;
    if ((d & 2147483648) >>> 31 === 1)
      return Ze.warn("SIDX has hierarchical references (not supported)"), null;
    const p = Te(n, u);
    u += 4, e.push({
      referenceSize: h,
      subsegmentDuration: p,
      // unscaled
      info: {
        duration: p / s,
        start: a,
        end: a + h - 1
      }
    }), a += h, u += 4, r = u;
  }
  return {
    earliestPresentationTime: i,
    timescale: s,
    version: t,
    referencesCount: l,
    references: e
  };
}
function Yg(n) {
  const e = [], t = Oe(n, ["moov", "trak"]);
  for (let s = 0; s < t.length; s++) {
    const i = t[s], o = Oe(i, ["tkhd"])[0];
    if (o) {
      let a = o[0];
      const l = Te(o, a === 0 ? 12 : 20), c = Oe(i, ["mdia", "mdhd"])[0];
      if (c) {
        a = c[0];
        const u = Te(c, a === 0 ? 12 : 20), d = Oe(i, ["mdia", "hdlr"])[0];
        if (d) {
          const h = Vt(d.subarray(8, 12)), f = {
            soun: lt.AUDIO,
            vide: lt.VIDEO
          }[h], p = Oe(i, ["mdia", "minf", "stbl", "stsd"])[0], y = ob(p);
          f ? (e[l] = {
            timescale: u,
            type: f,
            stsd: y
          }, e[f] = rt({
            timescale: u,
            id: l
          }, y)) : e[l] = {
            timescale: u,
            type: h,
            stsd: y
          };
        }
      }
    }
  }
  return Oe(n, ["moov", "mvex", "trex"]).forEach((s) => {
    const i = Te(s, 4), o = e[i];
    o && (o.default = {
      duration: Te(s, 12),
      flags: Te(s, 20)
    });
  }), e;
}
function ob(n) {
  const e = n.subarray(8), t = e.subarray(86), r = Vt(e.subarray(4, 8));
  let s = r, i;
  const o = r === "enca" || r === "encv";
  if (o) {
    const c = Oe(e, [r])[0].subarray(r === "enca" ? 28 : 78);
    Oe(c, ["sinf"]).forEach((d) => {
      const h = Oe(d, ["schm"])[0];
      if (h) {
        const f = Vt(h.subarray(4, 8));
        if (f === "cbcs" || f === "cenc") {
          const p = Oe(d, ["frma"])[0];
          p && (s = Vt(p));
        }
      }
    });
  }
  const a = s;
  switch (s) {
    case "avc1":
    case "avc2":
    case "avc3":
    case "avc4": {
      const l = Oe(t, ["avcC"])[0];
      l && l.length > 3 && (s += "." + lo(l[1]) + lo(l[2]) + lo(l[3]), i = ao(a === "avc1" ? "dva1" : "dvav", t));
      break;
    }
    case "mp4a": {
      const l = Oe(e, [r])[0], c = Oe(l.subarray(28), ["esds"])[0];
      if (c && c.length > 7) {
        let u = 4;
        if (c[u++] !== 3)
          break;
        u = _l(c, u), u += 2;
        const d = c[u++];
        if (d & 128 && (u += 2), d & 64 && (u += c[u++]), c[u++] !== 4)
          break;
        u = _l(c, u);
        const h = c[u++];
        if (h === 64)
          s += "." + lo(h);
        else
          break;
        if (u += 12, c[u++] !== 5)
          break;
        u = _l(c, u);
        const f = c[u++];
        let p = (f & 248) >> 3;
        p === 31 && (p += 1 + ((f & 7) << 3) + ((c[u] & 224) >> 5)), s += "." + p;
      }
      break;
    }
    case "hvc1":
    case "hev1": {
      const l = Oe(t, ["hvcC"])[0];
      if (l && l.length > 12) {
        const c = l[1], u = ["", "A", "B", "C"][c >> 6], d = c & 31, h = Te(l, 2), f = (c & 32) >> 5 ? "H" : "L", p = l[12], y = l.subarray(6, 12);
        s += "." + u + d, s += "." + ab(h).toString(16).toUpperCase(), s += "." + f + p;
        let m = "";
        for (let b = y.length; b--; ) {
          const C = y[b];
          (C || m) && (m = "." + C.toString(16).toUpperCase() + m);
        }
        s += m;
      }
      i = ao(a == "hev1" ? "dvhe" : "dvh1", t);
      break;
    }
    case "dvh1":
    case "dvhe":
    case "dvav":
    case "dva1":
    case "dav1": {
      s = ao(s, t) || s;
      break;
    }
    case "vp09": {
      const l = Oe(t, ["vpcC"])[0];
      if (l && l.length > 6) {
        const c = l[4], u = l[5], d = l[6] >> 4 & 15;
        s += "." + Jr(c) + "." + Jr(u) + "." + Jr(d);
      }
      break;
    }
    case "av01": {
      const l = Oe(t, ["av1C"])[0];
      if (l && l.length > 2) {
        const c = l[1] >>> 5, u = l[1] & 31, d = l[2] >>> 7 ? "H" : "M", h = (l[2] & 64) >> 6, f = (l[2] & 32) >> 5, p = c === 2 && h ? f ? 12 : 10 : h ? 10 : 8, y = (l[2] & 16) >> 4, m = (l[2] & 8) >> 3, b = (l[2] & 4) >> 2, C = l[2] & 3;
        s += "." + c + "." + Jr(u) + d + "." + Jr(p) + "." + y + "." + m + b + C + "." + Jr(1) + "." + Jr(1) + "." + Jr(1) + "." + 0, i = ao("dav1", t);
      }
      break;
    }
  }
  return {
    codec: s,
    encrypted: o,
    supplemental: i
  };
}
function ao(n, e) {
  const t = Oe(e, ["dvvC"]), r = t.length ? t[0] : Oe(e, ["dvcC"])[0];
  if (r) {
    const s = r[2] >> 1 & 127, i = r[2] << 5 & 32 | r[3] >> 3 & 31;
    return n + "." + Jr(s) + "." + Jr(i);
  }
}
function ab(n) {
  let e = 0;
  for (let t = 0; t < 32; t++)
    e |= (n >> t & 1) << 31 - t;
  return e >>> 0;
}
function _l(n, e) {
  const t = e + 5;
  for (; n[e++] & 128 && e < t; )
    ;
  return e;
}
function lo(n) {
  return ("0" + n.toString(16).toUpperCase()).slice(-2);
}
function Jr(n) {
  return (n < 10 ? "0" : "") + n;
}
function lb(n, e) {
  if (!n || !e)
    return n;
  const t = e.keyId;
  return t && e.isCommonEncryption && Oe(n, ["moov", "trak"]).forEach((s) => {
    const o = Oe(s, ["mdia", "minf", "stbl", "stsd"])[0].subarray(8);
    let a = Oe(o, ["enca"]);
    const l = a.length > 0;
    l || (a = Oe(o, ["encv"])), a.forEach((c) => {
      const u = l ? c.subarray(28) : c.subarray(78);
      Oe(u, ["sinf"]).forEach((h) => {
        const f = Zg(h);
        if (f) {
          const p = f.subarray(8, 24);
          p.some((y) => y !== 0) || (Ze.log(`[eme] Patching keyId in 'enc${l ? "a" : "v"}>sinf>>tenc' box: ${Qr.hexDump(p)} -> ${Qr.hexDump(t)}`), f.set(t, 8));
        }
      });
    });
  }), n;
}
function Zg(n) {
  const e = Oe(n, ["schm"])[0];
  if (e) {
    const t = Vt(e.subarray(4, 8));
    if (t === "cbcs" || t === "cenc")
      return Oe(n, ["schi", "tenc"])[0];
  }
  return null;
}
function cb(n, e, t) {
  const r = {}, s = Oe(n, ["moof", "traf"]);
  for (let i = 0; i < s.length; i++) {
    const o = s[i], a = Oe(o, ["tfhd"])[0], l = Te(a, 4), c = e[l];
    if (!c)
      continue;
    const u = r[l] || (r[l] = {
      start: NaN,
      duration: 0,
      sampleCount: 0,
      timescale: c.timescale,
      type: c.type
    }), d = Oe(o, ["tfdt"])[0];
    if (d) {
      const A = d[0];
      let P = Te(d, 4);
      A === 1 && (P === fa ? t.warn("[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time") : (P *= fa + 1, P += Te(d, 8))), ae(P) && (!ae(u.start) || P < u.start) && (u.start = P);
    }
    const h = c.default, f = Te(a, 0) | (h == null ? void 0 : h.flags);
    let p = (h == null ? void 0 : h.duration) || 0;
    f & 8 && (f & 2 ? p = Te(a, 12) : p = Te(a, 8));
    const y = Oe(o, ["trun"]);
    let m = u.start || 0, b = 0, C = p;
    for (let A = 0; A < y.length; A++) {
      const P = y[A], I = Te(P, 4), U = u.sampleCount;
      u.sampleCount += I;
      const j = P[3] & 1, G = P[3] & 4, F = P[2] & 1, B = P[2] & 2, V = P[2] & 4, H = P[2] & 8;
      let L = 8, g = I;
      for (j && (L += 4), G && I && (!(P[L + 1] & 1) && u.keyFrameIndex === void 0 && (u.keyFrameIndex = U), L += 4, F ? (C = Te(P, L), L += 4) : C = p, B && (L += 4), H && (L += 4), m += C, b += C, g--); g--; )
        F ? (C = Te(P, L), L += 4) : C = p, B && (L += 4), V && (P[L + 1] & 1 || u.keyFrameIndex === void 0 && (u.keyFrameIndex = u.sampleCount - (g + 1), u.keyFrameStart = m), L += 4), H && (L += 4), m += C, b += C;
      !b && p && (b += p * I);
    }
    u.duration += b;
  }
  if (!Object.keys(r).some((i) => r[i].duration)) {
    let i = 1 / 0, o = 0;
    const a = Oe(n, ["sidx"]);
    for (let l = 0; l < a.length; l++) {
      const c = ib(a[l]);
      if (c != null && c.references) {
        i = Math.min(i, c.earliestPresentationTime / c.timescale);
        const u = c.references.reduce((d, h) => d + h.info.duration || 0, 0);
        o = Math.max(o, u + c.earliestPresentationTime / c.timescale);
      }
    }
    o && ae(o) && Object.keys(r).forEach((l) => {
      r[l].duration || (r[l].duration = o * r[l].timescale - r[l].start);
    });
  }
  return r;
}
function ub(n, e, t) {
  Oe(e, ["moof", "traf"]).forEach((r) => {
    Oe(r, ["tfhd"]).forEach((s) => {
      const i = Te(s, 4), o = n[i];
      if (!o)
        return;
      const a = o.timescale || 9e4;
      Oe(r, ["tfdt"]).forEach((l) => {
        const c = l[0], u = t * a;
        if (u) {
          let d = Te(l, 4);
          if (c === 0)
            d -= u, d = Math.max(d, 0), Il(l, 4, d);
          else {
            d *= Math.pow(2, 32), d += Te(l, 8), d -= u, d = Math.max(d, 0);
            const h = Math.floor(d / (fa + 1)), f = Math.floor(d % (fa + 1));
            Il(l, 4, h), Il(l, 8, f);
          }
        }
      });
    });
  });
}
function db(n) {
  const e = {
    valid: null,
    remainder: null
  }, t = Oe(n, ["moof"]);
  if (t.length < 2)
    return e.remainder = n, e;
  const r = t[t.length - 1];
  return e.valid = n.slice(0, r.byteOffset - 8), e.remainder = n.slice(r.byteOffset - 8), e;
}
function Nr(n, e) {
  const t = new Uint8Array(n.length + e.length);
  return t.set(n), t.set(e, n.length), t;
}
function sh(n, e) {
  const t = [], r = e.samples, s = e.timescale, i = e.id;
  let o = !1;
  return Oe(r, ["moof"]).map((l) => {
    const c = l.byteOffset - 8;
    Oe(l, ["traf"]).map((d) => {
      const h = Oe(d, ["tfdt"]).map((f) => {
        const p = f[0];
        let y = Te(f, 4);
        return p === 1 && (y *= Math.pow(2, 32), y += Te(f, 8)), y / s;
      })[0];
      return h !== void 0 && (n = h), Oe(d, ["tfhd"]).map((f) => {
        const p = Te(f, 4), y = Te(f, 0) & 16777215, m = (y & 1) !== 0, b = (y & 2) !== 0, C = (y & 8) !== 0;
        let A = 0;
        const P = (y & 16) !== 0;
        let I = 0;
        const U = (y & 32) !== 0;
        let j = 8;
        p === i && (m && (j += 8), b && (j += 4), C && (A = Te(f, j), j += 4), P && (I = Te(f, j), j += 4), U && (j += 4), e.type === "video" && (o = Ga(e.codec)), Oe(d, ["trun"]).map((G) => {
          const F = G[0], B = Te(G, 0) & 16777215, V = (B & 1) !== 0;
          let H = 0;
          const L = (B & 4) !== 0, g = (B & 256) !== 0;
          let x = 0;
          const w = (B & 512) !== 0;
          let _ = 0;
          const D = (B & 1024) !== 0, O = (B & 2048) !== 0;
          let N = 0;
          const R = Te(G, 4);
          let v = 8;
          V && (H = Te(G, v), v += 4), L && (v += 4);
          let M = H + c;
          for (let te = 0; te < R; te++) {
            if (g ? (x = Te(G, v), v += 4) : x = A, w ? (_ = Te(G, v), v += 4) : _ = I, D && (v += 4), O && (F === 0 ? N = Te(G, v) : N = zg(G, v), v += 4), e.type === lt.VIDEO) {
              let ee = 0;
              for (; ee < _; ) {
                const ne = Te(r, M);
                if (M += 4, hb(o, r[M])) {
                  const Ce = r.subarray(M, M + ne);
                  Ou(Ce, o ? 2 : 1, n + N / s, t);
                }
                M += ne, ee += ne + 4;
              }
            }
            n += x / s;
          }
        }));
      });
    });
  }), t;
}
function Ga(n) {
  if (!n)
    return !1;
  const e = n.substring(0, 4);
  return e === "hvc1" || e === "hev1" || // Dolby Vision
  e === "dvh1" || e === "dvhe";
}
function hb(n, e) {
  if (n) {
    const t = e >> 1 & 63;
    return t === 39 || t === 40;
  } else
    return (e & 31) === 6;
}
function Ou(n, e, t, r) {
  const s = Xg(n);
  let i = 0;
  i += e;
  let o = 0, a = 0, l = 0;
  for (; i < s.length; ) {
    o = 0;
    do {
      if (i >= s.length)
        break;
      l = s[i++], o += l;
    } while (l === 255);
    a = 0;
    do {
      if (i >= s.length)
        break;
      l = s[i++], a += l;
    } while (l === 255);
    const c = s.length - i;
    let u = i;
    if (a < c)
      i += a;
    else if (a > c) {
      Ze.error(`Malformed SEI payload. ${a} is too small, only ${c} bytes left to parse.`);
      break;
    }
    if (o === 4) {
      if (s[u++] === 181) {
        const h = qg(s, u);
        if (u += 2, h === 49) {
          const f = Te(s, u);
          if (u += 4, f === 1195456820) {
            const p = s[u++];
            if (p === 3) {
              const y = s[u++], m = 31 & y, b = 64 & y, C = b ? 2 + m * 3 : 0, A = new Uint8Array(C);
              if (b) {
                A[0] = y;
                for (let P = 1; P < C; P++)
                  A[P] = s[u++];
              }
              r.push({
                type: p,
                payloadType: o,
                pts: t,
                bytes: A
              });
            }
          }
        }
      }
    } else if (o === 5 && a > 16) {
      const d = [];
      for (let p = 0; p < 16; p++) {
        const y = s[u++].toString(16);
        d.push(y.length == 1 ? "0" + y : y), (p === 3 || p === 5 || p === 7 || p === 9) && d.push("-");
      }
      const h = a - 16, f = new Uint8Array(h);
      for (let p = 0; p < h; p++)
        f[p] = s[u++];
      r.push({
        payloadType: o,
        pts: t,
        uuid: d.join(""),
        userData: Lr(f),
        userDataBytes: f
      });
    }
  }
}
function Xg(n) {
  const e = n.byteLength, t = [];
  let r = 1;
  for (; r < e - 2; )
    n[r] === 0 && n[r + 1] === 0 && n[r + 2] === 3 ? (t.push(r + 2), r += 2) : r++;
  if (t.length === 0)
    return n;
  const s = e - t.length, i = new Uint8Array(s);
  let o = 0;
  for (r = 0; r < s; o++, r++)
    o === t[0] && (o++, t.shift()), i[r] = n[o];
  return i;
}
function fb(n) {
  const e = n[0];
  let t = "", r = "", s = 0, i = 0, o = 0, a = 0, l = 0, c = 0;
  if (e === 0) {
    for (; Vt(n.subarray(c, c + 1)) !== "\0"; )
      t += Vt(n.subarray(c, c + 1)), c += 1;
    for (t += Vt(n.subarray(c, c + 1)), c += 1; Vt(n.subarray(c, c + 1)) !== "\0"; )
      r += Vt(n.subarray(c, c + 1)), c += 1;
    r += Vt(n.subarray(c, c + 1)), c += 1, s = Te(n, 12), i = Te(n, 16), a = Te(n, 20), l = Te(n, 24), c = 28;
  } else if (e === 1) {
    c += 4, s = Te(n, c), c += 4;
    const d = Te(n, c);
    c += 4;
    const h = Te(n, c);
    for (c += 4, o = 2 ** 32 * d + h, VS(o) || (o = Number.MAX_SAFE_INTEGER, Ze.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box")), a = Te(n, c), c += 4, l = Te(n, c), c += 4; Vt(n.subarray(c, c + 1)) !== "\0"; )
      t += Vt(n.subarray(c, c + 1)), c += 1;
    for (t += Vt(n.subarray(c, c + 1)), c += 1; Vt(n.subarray(c, c + 1)) !== "\0"; )
      r += Vt(n.subarray(c, c + 1)), c += 1;
    r += Vt(n.subarray(c, c + 1)), c += 1;
  }
  const u = n.subarray(c, n.byteLength);
  return {
    schemeIdUri: t,
    value: r,
    timeScale: s,
    presentationTime: o,
    presentationTimeDelta: i,
    eventDuration: a,
    id: l,
    payload: u
  };
}
function gb(n, ...e) {
  const t = e.length;
  let r = 8, s = t;
  for (; s--; )
    r += e[s].byteLength;
  const i = new Uint8Array(r);
  for (i[0] = r >> 24 & 255, i[1] = r >> 16 & 255, i[2] = r >> 8 & 255, i[3] = r & 255, i.set(n, 4), s = 0, r = 8; s < t; s++)
    i.set(e[s], r), r += e[s].byteLength;
  return i;
}
function pb(n, e, t) {
  if (n.byteLength !== 16)
    throw new RangeError("Invalid system id");
  let r, s;
  r = 0, s = new Uint8Array();
  let i;
  r > 0 ? (i = new Uint8Array(4), e.length > 0 && new DataView(i.buffer).setUint32(0, e.length, !1)) : i = new Uint8Array();
  const o = new Uint8Array(4);
  return t && t.byteLength > 0 && new DataView(o.buffer).setUint32(0, t.byteLength, !1), gb(
    [112, 115, 115, 104],
    new Uint8Array([
      r,
      0,
      0,
      0
      // Flags
    ]),
    n,
    // 16 bytes
    i,
    s,
    o,
    t || new Uint8Array()
  );
}
function mb(n) {
  const e = [];
  if (n instanceof ArrayBuffer) {
    const t = n.byteLength;
    let r = 0;
    for (; r + 32 < t; ) {
      const s = new DataView(n, r), i = yb(s);
      e.push(i), r += i.size;
    }
  }
  return e;
}
function yb(n) {
  const e = n.getUint32(0), t = n.byteOffset, r = n.byteLength;
  if (r < e)
    return {
      offset: t,
      size: r
    };
  if (n.getUint32(4) !== 1886614376)
    return {
      offset: t,
      size: e
    };
  const i = n.getUint32(8) >>> 24;
  if (i !== 0 && i !== 1)
    return {
      offset: t,
      size: e
    };
  const o = n.buffer, a = Qr.hexDump(new Uint8Array(o, t + 12, 16)), l = n.getUint32(28);
  let c = null, u = null;
  if (i === 0) {
    if (e - 32 < l || l < 22)
      return {
        offset: t,
        size: e
      };
    u = new Uint8Array(o, t + 32, l);
  } else if (i === 1) {
    if (!l || r < t + 32 + l * 16 + 16)
      return {
        offset: t,
        size: e
      };
    c = [];
    for (let d = 0; d < l; d++)
      c.push(new Uint8Array(o, t + 32 + d * 16, 16));
  }
  return {
    version: i,
    systemId: a,
    kids: c,
    data: u,
    offset: t,
    size: e
  };
}
const Jg = () => /\(Windows.+Firefox\//i.test(navigator.userAgent), Qs = {
  audio: {
    a3ds: 1,
    "ac-3": 0.95,
    "ac-4": 1,
    alac: 0.9,
    alaw: 1,
    dra1: 1,
    "dts+": 1,
    "dts-": 1,
    dtsc: 1,
    dtse: 1,
    dtsh: 1,
    "ec-3": 0.9,
    enca: 1,
    fLaC: 0.9,
    // MP4-RA listed codec entry for FLAC
    flac: 0.9,
    // legacy browser codec name for FLAC
    FLAC: 0.9,
    // some manifests may list "FLAC" with Apple's tools
    g719: 1,
    g726: 1,
    m4ae: 1,
    mha1: 1,
    mha2: 1,
    mhm1: 1,
    mhm2: 1,
    mlpa: 1,
    mp4a: 1,
    "raw ": 1,
    Opus: 1,
    opus: 1,
    // browsers expect this to be lowercase despite MP4RA says 'Opus'
    samr: 1,
    sawb: 1,
    sawp: 1,
    sevc: 1,
    sqcp: 1,
    ssmv: 1,
    twos: 1,
    ulaw: 1
  },
  video: {
    avc1: 1,
    avc2: 1,
    avc3: 1,
    avc4: 1,
    avcp: 1,
    av01: 0.8,
    dav1: 0.8,
    drac: 1,
    dva1: 1,
    dvav: 1,
    dvh1: 0.7,
    dvhe: 0.7,
    encv: 1,
    hev1: 0.75,
    hvc1: 0.75,
    mjp2: 1,
    mp4v: 1,
    mvc1: 1,
    mvc2: 1,
    mvc3: 1,
    mvc4: 1,
    resv: 1,
    rv60: 1,
    s263: 1,
    svc1: 1,
    svc2: 1,
    "vc-1": 1,
    vp08: 1,
    vp09: 0.9
  },
  text: {
    stpp: 1,
    wvtt: 1
  }
};
function Qg(n, e) {
  const t = Qs[e];
  return !!t && !!t[n.slice(0, 4)];
}
function Tc(n, e, t = !0) {
  return !n.split(",").some((r) => !ep(r, e, t));
}
function ep(n, e, t = !0) {
  var r;
  const s = Zn(t);
  return (r = s == null ? void 0 : s.isTypeSupported(Oi(n, e))) != null ? r : !1;
}
function Oi(n, e) {
  return `${e}/mp4;codecs=${n}`;
}
function ih(n) {
  if (n) {
    const e = n.substring(0, 4);
    return Qs.video[e];
  }
  return 2;
}
function ga(n) {
  const e = Jg();
  return n.split(",").reduce((t, r) => {
    const i = e && Ga(r) ? 9 : Qs.video[r];
    return i ? (i * 2 + t) / (t ? 3 : 2) : (Qs.audio[r] + t) / (t ? 2 : 1);
  }, 0);
}
const Ll = {};
function vb(n, e = !0) {
  if (Ll[n])
    return Ll[n];
  const t = {
    // Idealy fLaC and Opus would be first (spec-compliant) but
    // some browsers will report that fLaC is supported then fail.
    // see: https://bugs.chromium.org/p/chromium/issues/detail?id=1422728
    flac: ["flac", "fLaC", "FLAC"],
    opus: ["opus", "Opus"],
    // Replace audio codec info if browser does not support mp4a.40.34,
    // and demuxer can fallback to 'audio/mpeg' or 'audio/mp4;codecs="mp3"'
    "mp4a.40.34": ["mp3"]
  }[n];
  for (let s = 0; s < t.length; s++) {
    var r;
    if (ep(t[s], "audio", e))
      return Ll[n] = t[s], t[s];
    if (t[s] === "mp3" && (r = Zn(e)) != null && r.isTypeSupported("audio/mpeg"))
      return "";
  }
  return n;
}
const xb = /flac|opus|mp4a\.40\.34/i;
function pa(n, e = !0) {
  return n.replace(xb, (t) => vb(t.toLowerCase(), e));
}
function Eb(n, e) {
  const t = [];
  if (n) {
    const r = n.split(",");
    for (let s = 0; s < r.length; s++)
      Qg(r[s], "video") || t.push(r[s]);
  }
  return e && t.push(e), t.join(",");
}
function Ro(n, e) {
  if (n && (n.length > 4 || ["ac-3", "ec-3", "alac", "fLaC", "Opus"].indexOf(n) !== -1))
    return n;
  if (e) {
    const t = e.split(",");
    if (t.length > 1) {
      if (n) {
        for (let r = t.length; r--; )
          if (t[r].substring(0, 4) === n.substring(0, 4))
            return t[r];
      }
      return t[0];
    }
  }
  return e || n;
}
function Sb(n) {
  const e = n.split(",");
  for (let t = 0; t < e.length; t++) {
    const r = e[t].split(".");
    r.length > 2 && r[0] === "avc1" && (e[t] = `avc1.${parseInt(r[1]).toString(16)}${("000" + parseInt(r[2]).toString(16)).slice(-4)}`);
  }
  return e.join(",");
}
function bb(n) {
  if (n.startsWith("av01.")) {
    const e = n.split("."), t = ["0", "111", "01", "01", "01", "0"];
    for (let r = e.length; r > 4 && r < 10; r++)
      e[r] = t[r - 4];
    return e.join(".");
  }
  return n;
}
function oh(n) {
  const e = Zn(n) || {
    isTypeSupported: () => !1
  };
  return {
    mpeg: e.isTypeSupported("audio/mpeg"),
    mp3: e.isTypeSupported('audio/mp4; codecs="mp3"'),
    ac3: e.isTypeSupported('audio/mp4; codecs="ac-3"')
  };
}
function tp(n) {
  return n.replace(/^.+codecs=["']?([^"']+).*$/, "$1");
}
const rp = {
  supported: !0,
  configurations: [],
  decodingInfoResults: [{
    supported: !0,
    powerEfficient: !0,
    smooth: !0
  }]
};
function np(n, e) {
  return {
    supported: !1,
    configurations: e,
    decodingInfoResults: [{
      supported: !1,
      smooth: !1,
      powerEfficient: !1
    }],
    error: n
  };
}
const ah = {};
function Tb(n, e, t, r, s, i) {
  const o = n.audioCodec ? n.audioGroups : null, a = i == null ? void 0 : i.audioCodec, l = i == null ? void 0 : i.channels, c = l ? parseInt(l) : a ? 1 / 0 : 2;
  let u = null;
  if (o != null && o.length)
    try {
      o.length === 1 && o[0] ? u = e.groups[o[0]].channels : u = o.reduce((d, h) => {
        if (h) {
          const f = e.groups[h];
          if (!f)
            throw new Error(`Audio track group ${h} not found`);
          Object.keys(f.channels).forEach((p) => {
            d[p] = (d[p] || 0) + f.channels[p];
          });
        }
        return d;
      }, {
        2: 0
      });
    } catch {
      return !0;
    }
  return n.videoCodec !== void 0 && (n.width > 1920 && n.height > 1088 || n.height > 1920 && n.width > 1088 || n.frameRate > Math.max(r, 30) || n.videoRange !== "SDR" && n.videoRange !== t || n.bitrate > Math.max(s, 8e6)) || !!u && ae(c) && Object.keys(u).some((d) => parseInt(d) > c);
}
function sp(n, e, t) {
  const r = n.videoCodec, s = n.audioCodec;
  if (!r && !s || !t)
    return Promise.resolve(rp);
  const i = [];
  if (r) {
    const o = {
      width: n.width,
      height: n.height,
      bitrate: Math.ceil(Math.max(n.bitrate * 0.9, n.averageBitrate)),
      // Assume a framerate of 30fps since MediaCapabilities will not accept Level default of 0.
      framerate: n.frameRate || 30
    }, a = n.videoRange;
    a !== "SDR" && (o.transferFunction = a.toLowerCase());
    const l = r.split(","), c = navigator.userAgent;
    if (l.some((u) => Ga(u)) && Jg())
      return Promise.resolve(np(new Error(`Overriding Windows Firefox HEVC MediaCapabilities result based on user-agent sting: (${c})`), i));
    i.push.apply(i, l.map((u) => ({
      type: "media-source",
      video: rt(rt({}, o), {}, {
        contentType: Oi(bb(u), "video")
      })
    })));
  }
  return s && n.audioGroups && n.audioGroups.forEach((o) => {
    var a;
    o && ((a = e.groups[o]) == null || a.tracks.forEach((l) => {
      if (l.groupId === o) {
        const c = l.channels || "", u = parseFloat(c);
        ae(u) && u > 2 && i.push.apply(i, s.split(",").map((d) => ({
          type: "media-source",
          audio: {
            contentType: Oi(d, "audio"),
            channels: "" + u
            // spatialRendering:
            //   audioCodec === 'ec-3' && channels.indexOf('JOC'),
          }
        })));
      }
    }));
  }), Promise.all(i.map((o) => {
    const a = wb(o);
    return ah[a] || (ah[a] = t.decodingInfo(o));
  })).then((o) => ({
    supported: !o.some((a) => !a.supported),
    configurations: i,
    decodingInfoResults: o
  })).catch((o) => ({
    supported: !1,
    configurations: i,
    decodingInfoResults: [],
    error: o
  }));
}
function wb(n) {
  const {
    audio: e,
    video: t
  } = n, r = t || e;
  if (r) {
    const s = tp(r.contentType);
    if (t)
      return `r${t.height}x${t.width}f${Math.ceil(t.framerate)}${t.transferFunction || "sd"}_${s}_${Math.ceil(t.bitrate / 1e5)}`;
    if (e)
      return `c${e.channels}${e.spatialRendering ? "s" : "n"}_${s}`;
  }
  return "";
}
const wc = ["NONE", "TYPE-0", "TYPE-1", null];
function Ab(n) {
  return wc.indexOf(n) > -1;
}
const ma = ["SDR", "PQ", "HLG"];
function Ib(n) {
  return !!n && ma.indexOf(n) > -1;
}
var Co = {
  No: "",
  Yes: "YES",
  v2: "v2"
};
function lh(n) {
  const {
    canSkipUntil: e,
    canSkipDateRanges: t,
    age: r
  } = n, s = r < e / 2;
  return e && s ? t ? Co.v2 : Co.Yes : Co.No;
}
class ch {
  constructor(e, t, r) {
    this.msn = void 0, this.part = void 0, this.skip = void 0, this.msn = e, this.part = t, this.skip = r;
  }
  addDirectives(e) {
    const t = new self.URL(e);
    return this.msn !== void 0 && t.searchParams.set("_HLS_msn", this.msn.toString()), this.part !== void 0 && t.searchParams.set("_HLS_part", this.part.toString()), this.skip && t.searchParams.set("_HLS_skip", this.skip), t.href;
  }
}
class Bi {
  constructor(e) {
    if (this._attrs = void 0, this.audioCodec = void 0, this.bitrate = void 0, this.codecSet = void 0, this.url = void 0, this.frameRate = void 0, this.height = void 0, this.id = void 0, this.name = void 0, this.supplemental = void 0, this.videoCodec = void 0, this.width = void 0, this.details = void 0, this.fragmentError = 0, this.loadError = 0, this.loaded = void 0, this.realBitrate = 0, this.supportedPromise = void 0, this.supportedResult = void 0, this._avgBitrate = 0, this._audioGroups = void 0, this._subtitleGroups = void 0, this._urlId = 0, this.url = [e.url], this._attrs = [e.attrs], this.bitrate = e.bitrate, e.details && (this.details = e.details), this.id = e.id || 0, this.name = e.name, this.width = e.width || 0, this.height = e.height || 0, this.frameRate = e.attrs.optionalFloat("FRAME-RATE", 0), this._avgBitrate = e.attrs.decimalInteger("AVERAGE-BANDWIDTH"), this.audioCodec = e.audioCodec, this.videoCodec = e.videoCodec, this.codecSet = [e.videoCodec, e.audioCodec].filter((r) => !!r).map((r) => r.substring(0, 4)).join(","), "supplemental" in e) {
      var t;
      this.supplemental = e.supplemental;
      const r = (t = e.supplemental) == null ? void 0 : t.videoCodec;
      r && r !== e.videoCodec && (this.codecSet += `,${r.substring(0, 4)}`);
    }
    this.addGroupId("audio", e.attrs.AUDIO), this.addGroupId("text", e.attrs.SUBTITLES);
  }
  get maxBitrate() {
    return Math.max(this.realBitrate, this.bitrate);
  }
  get averageBitrate() {
    return this._avgBitrate || this.realBitrate || this.bitrate;
  }
  get attrs() {
    return this._attrs[0];
  }
  get codecs() {
    return this.attrs.CODECS || "";
  }
  get pathwayId() {
    return this.attrs["PATHWAY-ID"] || ".";
  }
  get videoRange() {
    return this.attrs["VIDEO-RANGE"] || "SDR";
  }
  get score() {
    return this.attrs.optionalFloat("SCORE", 0);
  }
  get uri() {
    return this.url[0] || "";
  }
  hasAudioGroup(e) {
    return uh(this._audioGroups, e);
  }
  hasSubtitleGroup(e) {
    return uh(this._subtitleGroups, e);
  }
  get audioGroups() {
    return this._audioGroups;
  }
  get subtitleGroups() {
    return this._subtitleGroups;
  }
  addGroupId(e, t) {
    if (t) {
      if (e === "audio") {
        let r = this._audioGroups;
        r || (r = this._audioGroups = []), r.indexOf(t) === -1 && r.push(t);
      } else if (e === "text") {
        let r = this._subtitleGroups;
        r || (r = this._subtitleGroups = []), r.indexOf(t) === -1 && r.push(t);
      }
    }
  }
  // Deprecated methods (retained for backwards compatibility)
  get urlId() {
    return 0;
  }
  set urlId(e) {
  }
  get audioGroupIds() {
    return this.audioGroups ? [this.audioGroupId] : void 0;
  }
  get textGroupIds() {
    return this.subtitleGroups ? [this.textGroupId] : void 0;
  }
  get audioGroupId() {
    var e;
    return (e = this.audioGroups) == null ? void 0 : e[0];
  }
  get textGroupId() {
    var e;
    return (e = this.subtitleGroups) == null ? void 0 : e[0];
  }
  addFallback() {
  }
}
function uh(n, e) {
  return !e || !n ? !1 : n.indexOf(e) !== -1;
}
function _b() {
  if (typeof matchMedia == "function") {
    const n = matchMedia("(dynamic-range: high)"), e = matchMedia("bad query");
    if (n.media !== e.media)
      return n.matches === !0;
  }
  return !1;
}
function Lb(n, e) {
  let t = !1, r = [];
  if (n && (t = n !== "SDR", r = [n]), e) {
    r = e.allowedVideoRanges || ma.slice(0);
    const s = r.join("") !== "SDR" && !e.videoCodec;
    t = e.preferHDR !== void 0 ? e.preferHDR : s && _b(), t || (r = ["SDR"]);
  }
  return {
    preferHDR: t,
    allowedVideoRanges: r
  };
}
const Rb = (n) => {
  const e = /* @__PURE__ */ new WeakSet();
  return (t, r) => {
    if (n && (r = n(t, r)), typeof r == "object" && r !== null) {
      if (e.has(r))
        return;
      e.add(r);
    }
    return r;
  };
}, mt = (n, e) => JSON.stringify(n, Rb(e));
function Cb(n, e, t, r, s) {
  const i = Object.keys(n), o = r == null ? void 0 : r.channels, a = r == null ? void 0 : r.audioCodec, l = s == null ? void 0 : s.videoCodec, c = o && parseInt(o) === 2;
  let u = !1, d = !1, h = 1 / 0, f = 1 / 0, p = 1 / 0, y = 1 / 0, m = 0, b = [];
  const {
    preferHDR: C,
    allowedVideoRanges: A
  } = Lb(e, s);
  for (let G = i.length; G--; ) {
    const F = n[i[G]];
    u || (u = F.channels[2] > 0), h = Math.min(h, F.minHeight), f = Math.min(f, F.minFramerate), p = Math.min(p, F.minBitrate), A.filter((V) => F.videoRanges[V] > 0).length > 0 && (d = !0);
  }
  h = ae(h) ? h : 0, f = ae(f) ? f : 0;
  const P = Math.max(1080, h), I = Math.max(30, f);
  p = ae(p) ? p : t, t = Math.max(p, t), d || (e = void 0);
  const U = i.length > 1;
  return {
    codecSet: i.reduce((G, F) => {
      const B = n[F];
      if (F === G)
        return G;
      if (b = d ? A.filter((V) => B.videoRanges[V] > 0) : [], U) {
        if (B.minBitrate > t)
          return Yr(F, `min bitrate of ${B.minBitrate} > current estimate of ${t}`), G;
        if (!B.hasDefaultAudio)
          return Yr(F, "no renditions with default or auto-select sound found"), G;
        if (a && F.indexOf(a.substring(0, 4)) % 5 !== 0)
          return Yr(F, `audio codec preference "${a}" not found`), G;
        if (o && !c) {
          if (!B.channels[o])
            return Yr(F, `no renditions with ${o} channel sound found (channels options: ${Object.keys(B.channels)})`), G;
        } else if ((!a || c) && u && B.channels[2] === 0)
          return Yr(F, "no renditions with stereo sound found"), G;
        if (B.minHeight > P)
          return Yr(F, `min resolution of ${B.minHeight} > maximum of ${P}`), G;
        if (B.minFramerate > I)
          return Yr(F, `min framerate of ${B.minFramerate} > maximum of ${I}`), G;
        if (!b.some((V) => B.videoRanges[V] > 0))
          return Yr(F, `no variants with VIDEO-RANGE of ${mt(b)} found`), G;
        if (l && F.indexOf(l.substring(0, 4)) % 5 !== 0)
          return Yr(F, `video codec preference "${l}" not found`), G;
        if (B.maxScore < m)
          return Yr(F, `max score of ${B.maxScore} < selected max of ${m}`), G;
      }
      return G && (ga(F) >= ga(G) || B.fragmentError > n[G].fragmentError) ? G : (y = B.minIndex, m = B.maxScore, F);
    }, void 0),
    videoRanges: b,
    preferHDR: C,
    minFramerate: f,
    minBitrate: p,
    minIndex: y
  };
}
function Yr(n, e) {
  Ze.log(`[abr] start candidates with "${n}" ignored because ${e}`);
}
function ip(n) {
  return n.reduce((e, t) => {
    let r = e.groups[t.groupId];
    r || (r = e.groups[t.groupId] = {
      tracks: [],
      channels: {
        2: 0
      },
      hasDefault: !1,
      hasAutoSelect: !1
    }), r.tracks.push(t);
    const s = t.channels || "2";
    return r.channels[s] = (r.channels[s] || 0) + 1, r.hasDefault = r.hasDefault || t.default, r.hasAutoSelect = r.hasAutoSelect || t.autoselect, r.hasDefault && (e.hasDefaultAudio = !0), r.hasAutoSelect && (e.hasAutoSelectAudio = !0), e;
  }, {
    hasDefaultAudio: !1,
    hasAutoSelectAudio: !1,
    groups: {}
  });
}
function kb(n, e, t, r) {
  return n.slice(t, r + 1).reduce((s, i, o) => {
    if (!i.codecSet)
      return s;
    const a = i.audioGroups;
    let l = s[i.codecSet];
    l || (s[i.codecSet] = l = {
      minBitrate: 1 / 0,
      minHeight: 1 / 0,
      minFramerate: 1 / 0,
      minIndex: o,
      maxScore: 0,
      videoRanges: {
        SDR: 0
      },
      channels: {
        2: 0
      },
      hasDefaultAudio: !a,
      fragmentError: 0
    }), l.minBitrate = Math.min(l.minBitrate, i.bitrate);
    const c = Math.min(i.height, i.width);
    return l.minHeight = Math.min(l.minHeight, c), l.minFramerate = Math.min(l.minFramerate, i.frameRate), l.minIndex = Math.min(l.minIndex, o), l.maxScore = Math.max(l.maxScore, i.score), l.fragmentError += i.fragmentError, l.videoRanges[i.videoRange] = (l.videoRanges[i.videoRange] || 0) + 1, a && a.forEach((u) => {
      if (!u)
        return;
      const d = e.groups[u];
      d && (l.hasDefaultAudio = l.hasDefaultAudio || e.hasDefaultAudio ? d.hasDefault : d.hasAutoSelect || !e.hasDefaultAudio && !e.hasAutoSelectAudio, Object.keys(d.channels).forEach((h) => {
        l.channels[h] = (l.channels[h] || 0) + d.channels[h];
      }));
    }), s;
  }, {});
}
function dh(n) {
  if (!n)
    return n;
  const {
    lang: e,
    assocLang: t,
    characteristics: r,
    channels: s,
    audioCodec: i
  } = n;
  return {
    lang: e,
    assocLang: t,
    characteristics: r,
    channels: s,
    audioCodec: i
  };
}
function sn(n, e, t) {
  if ("attrs" in n) {
    const r = e.indexOf(n);
    if (r !== -1)
      return r;
  }
  for (let r = 0; r < e.length; r++) {
    const s = e[r];
    if (ls(n, s, t))
      return r;
  }
  return -1;
}
function ls(n, e, t) {
  const {
    groupId: r,
    name: s,
    lang: i,
    assocLang: o,
    default: a
  } = n, l = n.forced;
  return (r === void 0 || e.groupId === r) && (s === void 0 || e.name === s) && (i === void 0 || Db(i, e.lang)) && (i === void 0 || e.assocLang === o) && (a === void 0 || e.default === a) && (l === void 0 || e.forced === l) && (!("characteristics" in n) || Pb(n.characteristics || "", e.characteristics)) && (t === void 0 || t(n, e));
}
function Db(n, e = "--") {
  return n.length === e.length ? n === e : n.startsWith(e) || e.startsWith(n);
}
function Pb(n, e = "") {
  const t = n.split(","), r = e.split(",");
  return t.length === r.length && !t.some((s) => r.indexOf(s) === -1);
}
function es(n, e) {
  const {
    audioCodec: t,
    channels: r
  } = n;
  return (t === void 0 || (e.audioCodec || "").substring(0, 4) === t.substring(0, 4)) && (r === void 0 || r === (e.channels || "2"));
}
function Mb(n, e, t, r, s) {
  const i = e[r], a = e.reduce((h, f, p) => {
    const y = f.uri;
    return (h[y] || (h[y] = [])).push(p), h;
  }, {})[i.uri];
  a.length > 1 && (r = Math.max.apply(Math, a));
  const l = i.videoRange, c = i.frameRate, u = i.codecSet.substring(0, 4), d = hh(e, r, (h) => {
    if (h.videoRange !== l || h.frameRate !== c || h.codecSet.substring(0, 4) !== u)
      return !1;
    const f = h.audioGroups, p = t.filter((y) => !f || f.indexOf(y.groupId) !== -1);
    return sn(n, p, s) > -1;
  });
  return d > -1 ? d : hh(e, r, (h) => {
    const f = h.audioGroups, p = t.filter((y) => !f || f.indexOf(y.groupId) !== -1);
    return sn(n, p, s) > -1;
  });
}
function hh(n, e, t) {
  for (let r = e; r > -1; r--)
    if (t(n[r]))
      return r;
  for (let r = e + 1; r < n.length; r++)
    if (t(n[r]))
      return r;
  return -1;
}
function ya(n, e) {
  var t;
  return !!n && n !== ((t = e.loadLevelObj) == null ? void 0 : t.uri);
}
class Ob extends Cn {
  constructor(e) {
    super("abr", e.logger), this.hls = void 0, this.lastLevelLoadSec = 0, this.lastLoadedFragLevel = -1, this.firstSelection = -1, this._nextAutoLevel = -1, this.nextAutoLevelKey = "", this.audioTracksByGroup = null, this.codecTiers = null, this.timer = -1, this.fragCurrent = null, this.partCurrent = null, this.bitrateTestDelay = 0, this.rebufferNotice = -1, this.bwEstimator = void 0, this._abandonRulesCheck = (t) => {
      var r;
      const {
        fragCurrent: s,
        partCurrent: i,
        hls: o
      } = this, {
        autoLevelEnabled: a,
        media: l
      } = o;
      if (!s || !l)
        return;
      const c = performance.now(), u = i ? i.stats : s.stats, d = i ? i.duration : s.duration, h = c - u.loading.start, f = o.minAutoLevel, p = s.level, y = this._nextAutoLevel;
      if (u.aborted || u.loaded && u.loaded === u.total || p <= f) {
        this.clearTimer(), this._nextAutoLevel = -1;
        return;
      }
      if (!a)
        return;
      const m = y > -1 && y !== p, b = !!t || m;
      if (!b && (l.paused || !l.playbackRate || !l.readyState))
        return;
      const C = o.mainForwardBufferInfo;
      if (!b && C === null)
        return;
      const A = this.bwEstimator.getEstimateTTFB(), P = Math.abs(l.playbackRate);
      if (h <= Math.max(A, 1e3 * (d / (P * 2))))
        return;
      const I = C ? C.len / P : 0, U = u.loading.first ? u.loading.first - u.loading.start : -1, j = u.loaded && U > -1, G = this.getBwEstimate(), F = o.levels, B = F[p], V = Math.max(u.loaded, Math.round(d * (s.bitrate || B.averageBitrate) / 8));
      let H = j ? h - U : h;
      H < 1 && j && (H = Math.min(h, u.loaded * 8 / G));
      const L = j ? u.loaded * 1e3 / H : 0, g = A / 1e3, x = L ? (V - u.loaded) / L : V * 8 / G + g;
      if (x <= I)
        return;
      const w = L ? L * 8 : G, _ = ((r = (t == null ? void 0 : t.details) || this.hls.latestLevelDetails) == null ? void 0 : r.live) === !0, D = this.hls.config.abrBandWidthUpFactor;
      let O = Number.POSITIVE_INFINITY, N;
      for (N = p - 1; N > f; N--) {
        const te = F[N].maxBitrate, ee = !F[N].details || _;
        if (O = this.getTimeToLoadFrag(g, w, d * te, ee), O < Math.min(I, d + g))
          break;
      }
      if (O >= x || O > d * 10)
        return;
      j ? this.bwEstimator.sample(h - Math.min(A, U), u.loaded) : this.bwEstimator.sampleTTFB(h);
      const R = F[N].maxBitrate;
      this.getBwEstimate() * D > R && this.resetEstimator(R);
      const v = this.findBestLevel(R, f, N, 0, I, 1, 1);
      v > -1 && (N = v), this.warn(`Fragment ${s.sn}${i ? " part " + i.index : ""} of level ${p} is loading too slowly;
      Fragment duration: ${s.duration.toFixed(3)}
      Time to underbuffer: ${I.toFixed(3)} s
      Estimated load time for current fragment: ${x.toFixed(3)} s
      Estimated load time for down switch fragment: ${O.toFixed(3)} s
      TTFB estimate: ${U | 0} ms
      Current BW estimate: ${ae(G) ? G | 0 : "Unknown"} bps
      New BW estimate: ${this.getBwEstimate() | 0} bps
      Switching to level ${N} @ ${R | 0} bps`), o.nextLoadLevel = o.nextAutoLevel = N, this.clearTimer();
      const M = () => {
        if (this.clearTimer(), this.fragCurrent === s && this.hls.loadLevel === N && N > 0) {
          const te = this.getStarvationDelay();
          if (this.warn(`Aborting inflight request ${N > 0 ? "and switching down" : ""}
      Fragment duration: ${s.duration.toFixed(3)} s
      Time to underbuffer: ${te.toFixed(3)} s`), s.abortRequests(), this.fragCurrent = this.partCurrent = null, N > f) {
            let ee = this.findBestLevel(this.hls.levels[f].bitrate, f, N, 0, te, 1, 1);
            ee === -1 && (ee = f), this.hls.nextLoadLevel = this.hls.nextAutoLevel = ee, this.resetEstimator(this.hls.levels[ee].bitrate);
          }
        }
      };
      m || x > O * 2 ? M() : this.timer = self.setInterval(M, O * 1e3), o.trigger(T.FRAG_LOAD_EMERGENCY_ABORTED, {
        frag: s,
        part: i,
        stats: u
      });
    }, this.hls = e, this.bwEstimator = this.initEstimator(), this.registerListeners();
  }
  resetEstimator(e) {
    e && (this.log(`setting initial bwe to ${e}`), this.hls.config.abrEwmaDefaultEstimate = e), this.firstSelection = -1, this.bwEstimator = this.initEstimator();
  }
  initEstimator() {
    const e = this.hls.config;
    return new HS(e.abrEwmaSlowVoD, e.abrEwmaFastVoD, e.abrEwmaDefaultEstimate);
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.FRAG_LOADING, this.onFragLoading, this), e.on(T.FRAG_LOADED, this.onFragLoaded, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this), e.on(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(T.LEVEL_LOADED, this.onLevelLoaded, this), e.on(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(T.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this), e.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.FRAG_LOADING, this.onFragLoading, this), e.off(T.FRAG_LOADED, this.onFragLoaded, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this), e.off(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(T.LEVEL_LOADED, this.onLevelLoaded, this), e.off(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(T.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this), e.off(T.ERROR, this.onError, this));
  }
  destroy() {
    this.unregisterListeners(), this.clearTimer(), this.hls = this._abandonRulesCheck = null, this.fragCurrent = this.partCurrent = null;
  }
  onManifestLoading(e, t) {
    this.lastLoadedFragLevel = -1, this.firstSelection = -1, this.lastLevelLoadSec = 0, this.fragCurrent = this.partCurrent = null, this.onLevelsUpdated(), this.clearTimer();
  }
  onLevelsUpdated() {
    this.lastLoadedFragLevel > -1 && this.fragCurrent && (this.lastLoadedFragLevel = this.fragCurrent.level), this._nextAutoLevel = -1, this.onMaxAutoLevelUpdated(), this.codecTiers = null, this.audioTracksByGroup = null;
  }
  onMaxAutoLevelUpdated() {
    this.firstSelection = -1, this.nextAutoLevelKey = "";
  }
  onFragLoading(e, t) {
    const r = t.frag;
    if (!this.ignoreFragment(r)) {
      if (!r.bitrateTest) {
        var s;
        this.fragCurrent = r, this.partCurrent = (s = t.part) != null ? s : null;
      }
      this.clearTimer(), this.timer = self.setInterval(this._abandonRulesCheck, 100);
    }
  }
  onLevelSwitching(e, t) {
    this.clearTimer();
  }
  onError(e, t) {
    if (!t.fatal)
      switch (t.details) {
        case Y.BUFFER_ADD_CODEC_ERROR:
        case Y.BUFFER_APPEND_ERROR:
          this.lastLoadedFragLevel = -1, this.firstSelection = -1;
          break;
        case Y.FRAG_LOAD_TIMEOUT: {
          const r = t.frag, {
            fragCurrent: s,
            partCurrent: i
          } = this;
          if (r && s && r.sn === s.sn && r.level === s.level) {
            const o = performance.now(), a = i ? i.stats : r.stats, l = o - a.loading.start, c = a.loading.first ? a.loading.first - a.loading.start : -1;
            if (a.loaded && c > -1) {
              const d = this.bwEstimator.getEstimateTTFB();
              this.bwEstimator.sample(l - Math.min(d, c), a.loaded);
            } else
              this.bwEstimator.sampleTTFB(l);
          }
          break;
        }
      }
  }
  getTimeToLoadFrag(e, t, r, s) {
    const i = e + r / t, o = s ? e + this.lastLevelLoadSec : 0;
    return i + o;
  }
  onLevelLoaded(e, t) {
    const r = this.hls.config, {
      loading: s
    } = t.stats, i = s.end - s.first;
    ae(i) && (this.lastLevelLoadSec = i / 1e3), t.details.live ? this.bwEstimator.update(r.abrEwmaSlowLive, r.abrEwmaFastLive) : this.bwEstimator.update(r.abrEwmaSlowVoD, r.abrEwmaFastVoD), this.timer > -1 && this._abandonRulesCheck(t.levelInfo);
  }
  onFragLoaded(e, {
    frag: t,
    part: r
  }) {
    const s = r ? r.stats : t.stats;
    if (t.type === he.MAIN && this.bwEstimator.sampleTTFB(s.loading.first - s.loading.start), !this.ignoreFragment(t)) {
      if (this.clearTimer(), t.level === this._nextAutoLevel && (this._nextAutoLevel = -1), this.firstSelection = -1, this.hls.config.abrMaxWithRealBitrate) {
        const i = r ? r.duration : t.duration, o = this.hls.levels[t.level], a = (o.loaded ? o.loaded.bytes : 0) + s.loaded, l = (o.loaded ? o.loaded.duration : 0) + i;
        o.loaded = {
          bytes: a,
          duration: l
        }, o.realBitrate = Math.round(8 * a / l);
      }
      if (t.bitrateTest) {
        const i = {
          stats: s,
          frag: t,
          part: r,
          id: t.type
        };
        this.onFragBuffered(T.FRAG_BUFFERED, i), t.bitrateTest = !1;
      } else
        this.lastLoadedFragLevel = t.level;
    }
  }
  onFragBuffered(e, t) {
    const {
      frag: r,
      part: s
    } = t, i = s != null && s.stats.loaded ? s.stats : r.stats;
    if (i.aborted || this.ignoreFragment(r))
      return;
    const o = i.parsing.end - i.loading.start - Math.min(i.loading.first - i.loading.start, this.bwEstimator.getEstimateTTFB());
    this.bwEstimator.sample(o, i.loaded), i.bwEstimate = this.getBwEstimate(), r.bitrateTest ? this.bitrateTestDelay = o / 1e3 : this.bitrateTestDelay = 0;
  }
  ignoreFragment(e) {
    return e.type !== he.MAIN || e.sn === "initSegment";
  }
  clearTimer() {
    this.timer > -1 && (self.clearInterval(this.timer), this.timer = -1);
  }
  get firstAutoLevel() {
    const {
      maxAutoLevel: e,
      minAutoLevel: t
    } = this.hls, r = this.getBwEstimate(), s = this.hls.config.maxStarvationDelay, i = this.findBestLevel(r, t, e, 0, s, 1, 1);
    if (i > -1)
      return i;
    const o = this.hls.firstLevel, a = Math.min(Math.max(o, t), e);
    return this.warn(`Could not find best starting auto level. Defaulting to first in playlist ${o} clamped to ${a}`), a;
  }
  get forcedAutoLevel() {
    return this.nextAutoLevelKey ? -1 : this._nextAutoLevel;
  }
  // return next auto level
  get nextAutoLevel() {
    const e = this.forcedAutoLevel, r = this.bwEstimator.canEstimate(), s = this.lastLoadedFragLevel > -1;
    if (e !== -1 && (!r || !s || this.nextAutoLevelKey === this.getAutoLevelKey()))
      return e;
    const i = r && s ? this.getNextABRAutoLevel() : this.firstAutoLevel;
    if (e !== -1) {
      const o = this.hls.levels;
      if (o.length > Math.max(e, i) && o[e].loadError <= o[i].loadError)
        return e;
    }
    return this._nextAutoLevel = i, this.nextAutoLevelKey = this.getAutoLevelKey(), i;
  }
  getAutoLevelKey() {
    return `${this.getBwEstimate()}_${this.getStarvationDelay().toFixed(2)}`;
  }
  getNextABRAutoLevel() {
    const {
      fragCurrent: e,
      partCurrent: t,
      hls: r
    } = this;
    if (r.levels.length <= 1)
      return r.loadLevel;
    const {
      maxAutoLevel: s,
      config: i,
      minAutoLevel: o
    } = r, a = t ? t.duration : e ? e.duration : 0, l = this.getBwEstimate(), c = this.getStarvationDelay();
    let u = i.abrBandWidthFactor, d = i.abrBandWidthUpFactor;
    if (c) {
      const m = this.findBestLevel(l, o, s, c, 0, u, d);
      if (m >= 0)
        return this.rebufferNotice = -1, m;
    }
    let h = a ? Math.min(a, i.maxStarvationDelay) : i.maxStarvationDelay;
    if (!c) {
      const m = this.bitrateTestDelay;
      m && (h = (a ? Math.min(a, i.maxLoadingDelay) : i.maxLoadingDelay) - m, this.info(`bitrate test took ${Math.round(1e3 * m)}ms, set first fragment max fetchDuration to ${Math.round(1e3 * h)} ms`), u = d = 1);
    }
    const f = this.findBestLevel(l, o, s, c, h, u, d);
    if (this.rebufferNotice !== f && (this.rebufferNotice = f, this.info(`${c ? "rebuffering expected" : "buffer is empty"}, optimal quality level ${f}`)), f > -1)
      return f;
    const p = r.levels[o], y = r.loadLevelObj;
    return y && (p == null ? void 0 : p.bitrate) < y.bitrate ? o : r.loadLevel;
  }
  getStarvationDelay() {
    const e = this.hls, t = e.media;
    if (!t)
      return 1 / 0;
    const r = t && t.playbackRate !== 0 ? Math.abs(t.playbackRate) : 1, s = e.mainForwardBufferInfo;
    return (s ? s.len : 0) / r;
  }
  getBwEstimate() {
    return this.bwEstimator.canEstimate() ? this.bwEstimator.getEstimate() : this.hls.config.abrEwmaDefaultEstimate;
  }
  findBestLevel(e, t, r, s, i, o, a) {
    var l;
    const c = s + i, u = this.lastLoadedFragLevel, d = u === -1 ? this.hls.firstLevel : u, {
      fragCurrent: h,
      partCurrent: f
    } = this, {
      levels: p,
      allAudioTracks: y,
      loadLevel: m,
      config: b
    } = this.hls;
    if (p.length === 1)
      return 0;
    const C = p[d], A = !!((l = this.hls.latestLevelDetails) != null && l.live), P = m === -1 || u === -1;
    let I, U = "SDR", j = (C == null ? void 0 : C.frameRate) || 0;
    const {
      audioPreference: G,
      videoPreference: F
    } = b, B = this.audioTracksByGroup || (this.audioTracksByGroup = ip(y));
    let V = -1;
    if (P) {
      if (this.firstSelection !== -1)
        return this.firstSelection;
      const w = this.codecTiers || (this.codecTiers = kb(p, B, t, r)), _ = Cb(w, U, e, G, F), {
        codecSet: D,
        videoRanges: O,
        minFramerate: N,
        minBitrate: R,
        minIndex: v,
        preferHDR: M
      } = _;
      V = v, I = D, U = M ? O[O.length - 1] : O[0], j = N, e = Math.max(e, R), this.log(`picked start tier ${mt(_)}`);
    } else
      I = C == null ? void 0 : C.codecSet, U = C == null ? void 0 : C.videoRange;
    const H = f ? f.duration : h ? h.duration : 0, L = this.bwEstimator.getEstimateTTFB() / 1e3, g = [];
    for (let w = r; w >= t; w--) {
      var x;
      const _ = p[w], D = w > d;
      if (!_)
        continue;
      if (b.useMediaCapabilities && !_.supportedResult && !_.supportedPromise) {
        const ee = navigator.mediaCapabilities;
        typeof (ee == null ? void 0 : ee.decodingInfo) == "function" && (Tb(_, B, U, j, e, G) || Ga(_.videoCodec)) ? (_.supportedPromise = sp(_, B, ee), _.supportedPromise.then((ne) => {
          if (!this.hls)
            return;
          _.supportedResult = ne;
          const Ce = this.hls.levels, ve = Ce.indexOf(_);
          ne.error ? this.warn(`MediaCapabilities decodingInfo error: "${ne.error}" for level ${ve} ${mt(ne)}`) : ne.supported || (this.warn(`Unsupported MediaCapabilities decodingInfo result for level ${ve} ${mt(ne)}`), ve > -1 && Ce.length > 1 && (this.log(`Removing unsupported level ${ve}`), this.hls.removeLevel(ve), this.hls.loadLevel === -1 && (this.hls.nextLoadLevel = 0)));
        })) : _.supportedResult = rp;
      }
      if ((I && _.codecSet !== I || U && _.videoRange !== U || D && j > _.frameRate || !D && j > 0 && j < _.frameRate || _.supportedResult && !((x = _.supportedResult.decodingInfoResults) != null && x[0].smooth)) && (!P || w !== V)) {
        g.push(w);
        continue;
      }
      const O = _.details, N = (f ? O == null ? void 0 : O.partTarget : O == null ? void 0 : O.averagetargetduration) || H;
      let R;
      D ? R = a * e : R = o * e;
      const v = H && s >= H * 2 && i === 0 ? _.averageBitrate : _.maxBitrate, M = this.getTimeToLoadFrag(L, R, v * N, O === void 0);
      if (
        // if adjusted bw is greater than level bitrate AND
        R >= v && // no level change, or new level has no error history
        (w === u || _.loadError === 0 && _.fragmentError === 0) && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
        // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
        // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
        (M <= L || !ae(M) || A && !this.bitrateTestDelay || M < c)
      ) {
        const ee = this.forcedAutoLevel;
        return w !== m && (ee === -1 || ee !== m) && (g.length && this.trace(`Skipped level(s) ${g.join(",")} of ${r} max with CODECS and VIDEO-RANGE:"${p[g[0]].codecs}" ${p[g[0]].videoRange}; not compatible with "${I}" ${U}`), this.info(`switch candidate:${d}->${w} adjustedbw(${Math.round(R)})-bitrate=${Math.round(R - v)} ttfb:${L.toFixed(1)} avgDuration:${N.toFixed(1)} maxFetchDuration:${c.toFixed(1)} fetchDuration:${M.toFixed(1)} firstSelection:${P} codecSet:${_.codecSet} videoRange:${_.videoRange} hls.loadLevel:${m}`)), P && (this.firstSelection = w), w;
      }
    }
    return -1;
  }
  set nextAutoLevel(e) {
    const t = this.deriveNextAutoLevel(e);
    this._nextAutoLevel !== t && (this.nextAutoLevelKey = "", this._nextAutoLevel = t);
  }
  deriveNextAutoLevel(e) {
    const {
      maxAutoLevel: t,
      minAutoLevel: r
    } = this.hls;
    return Math.min(Math.max(e, r), t);
  }
}
const op = {
  /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */
  search: function(n, e) {
    let t = 0, r = n.length - 1, s = null, i = null;
    for (; t <= r; ) {
      s = (t + r) / 2 | 0, i = n[s];
      const o = e(i);
      if (o > 0)
        t = s + 1;
      else if (o < 0)
        r = s - 1;
      else
        return i;
    }
    return null;
  }
};
function Bb(n, e, t) {
  if (e === null || !Array.isArray(n) || !n.length || !ae(e))
    return null;
  const r = n[0].programDateTime;
  if (e < (r || 0))
    return null;
  const s = n[n.length - 1].endProgramDateTime;
  if (e >= (s || 0))
    return null;
  for (let i = 0; i < n.length; ++i) {
    const o = n[i];
    if (Nb(e, t, o))
      return o;
  }
  return null;
}
function gs(n, e, t = 0, r = 0, s = 5e-3) {
  let i = null;
  if (n) {
    i = e[1 + n.sn - e[0].sn] || null;
    const a = n.endDTS - t;
    a > 0 && a < 15e-7 && (t += 15e-7), i && n.level !== i.level && i.end <= n.end && (i = e[2 + n.sn - e[0].sn] || null);
  } else t === 0 && e[0].start === 0 && (i = e[0]);
  if (i && ((!n || n.level === i.level) && fh(t, r, i) === 0 || Fb(i, n, Math.min(s, r))))
    return i;
  const o = op.search(e, fh.bind(null, t, r));
  return o && (o !== n || !i) ? o : i;
}
function Fb(n, e, t) {
  if (e && e.start === 0 && e.level < n.level && (e.endPTS || 0) > 0) {
    const r = e.tagList.reduce((s, i) => (i[0] === "INF" && (s += parseFloat(i[1])), s), t);
    return n.start <= r;
  }
  return !1;
}
function fh(n = 0, e = 0, t) {
  if (t.start <= n && t.start + t.duration > n)
    return 0;
  const r = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0));
  return t.start + t.duration - r <= n ? 1 : t.start - r > n && t.start ? -1 : 0;
}
function Nb(n, e, t) {
  const r = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0)) * 1e3;
  return (t.endProgramDateTime || 0) - r > n;
}
function ap(n, e, t) {
  if (n && n.startCC <= e && n.endCC >= e) {
    let r = n.fragments;
    const {
      fragmentHint: s
    } = n;
    s && (r = r.concat(s));
    let i;
    return op.search(r, (o) => o.cc < e ? 1 : o.cc > e ? -1 : (i = o, o.end <= t ? 1 : o.start > t ? -1 : 0)), i || null;
  }
  return null;
}
function va(n) {
  switch (n.details) {
    case Y.FRAG_LOAD_TIMEOUT:
    case Y.KEY_LOAD_TIMEOUT:
    case Y.LEVEL_LOAD_TIMEOUT:
    case Y.MANIFEST_LOAD_TIMEOUT:
      return !0;
  }
  return !1;
}
function gh(n, e) {
  const t = va(e);
  return n.default[`${t ? "timeout" : "error"}Retry`];
}
function Bu(n, e) {
  const t = n.backoff === "linear" ? 1 : Math.pow(2, e);
  return Math.min(t * n.retryDelayMs, n.maxRetryDelayMs);
}
function ph(n) {
  return rt(rt({}, n), {
    errorRetry: null,
    timeoutRetry: null
  });
}
function xa(n, e, t, r) {
  if (!n)
    return !1;
  const s = r == null ? void 0 : r.code, i = e < n.maxNumRetry && (Ub(s) || !!t);
  return n.shouldRetry ? n.shouldRetry(n, e, t, r, i) : i;
}
function Ub(n) {
  return n === 0 && navigator.onLine === !1 || !!n && (n < 400 || n > 499);
}
var ar = {
  DoNothing: 0,
  SendAlternateToPenaltyBox: 2,
  RemoveAlternatePermanently: 3,
  RetryRequest: 5
}, Gr = {
  None: 0,
  MoveAllAlternatesMatchingHost: 1,
  MoveAllAlternatesMatchingHDCP: 2
};
class $b extends Cn {
  constructor(e) {
    super("error-controller", e.logger), this.hls = void 0, this.playlistError = 0, this.penalizedRenditions = {}, this.hls = e, this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(T.ERROR, this.onError, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(T.ERROR, this.onError, this), e.off(T.ERROR, this.onErrorOut, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.LEVEL_UPDATED, this.onLevelUpdated, this));
  }
  destroy() {
    this.unregisterListeners(), this.hls = null, this.penalizedRenditions = {};
  }
  startLoad(e) {
  }
  stopLoad() {
    this.playlistError = 0;
  }
  getVariantLevelIndex(e) {
    return (e == null ? void 0 : e.type) === he.MAIN ? e.level : this.hls.loadLevel;
  }
  onManifestLoading() {
    this.playlistError = 0, this.penalizedRenditions = {};
  }
  onLevelUpdated() {
    this.playlistError = 0;
  }
  onError(e, t) {
    var r;
    if (t.fatal)
      return;
    const s = this.hls, i = t.context;
    switch (t.details) {
      case Y.FRAG_LOAD_ERROR:
      case Y.FRAG_LOAD_TIMEOUT:
      case Y.KEY_LOAD_ERROR:
      case Y.KEY_LOAD_TIMEOUT:
        t.errorAction = this.getFragRetryOrSwitchAction(t);
        return;
      case Y.FRAG_PARSING_ERROR:
        if ((r = t.frag) != null && r.gap) {
          t.errorAction = Fi();
          return;
        }
      case Y.FRAG_GAP:
      case Y.FRAG_DECRYPT_ERROR: {
        t.errorAction = this.getFragRetryOrSwitchAction(t), t.errorAction.action = ar.SendAlternateToPenaltyBox;
        return;
      }
      case Y.LEVEL_EMPTY_ERROR:
      case Y.LEVEL_PARSING_ERROR:
        {
          var o, a;
          const c = t.parent === he.MAIN ? t.level : s.loadLevel;
          t.details === Y.LEVEL_EMPTY_ERROR && ((o = t.context) != null && (a = o.levelDetails) != null && a.live) ? t.errorAction = this.getPlaylistRetryOrSwitchAction(t, c) : (t.levelRetry = !1, t.errorAction = this.getLevelSwitchAction(t, c));
        }
        return;
      case Y.LEVEL_LOAD_ERROR:
      case Y.LEVEL_LOAD_TIMEOUT:
        typeof (i == null ? void 0 : i.level) == "number" && (t.errorAction = this.getPlaylistRetryOrSwitchAction(t, i.level));
        return;
      case Y.AUDIO_TRACK_LOAD_ERROR:
      case Y.AUDIO_TRACK_LOAD_TIMEOUT:
      case Y.SUBTITLE_LOAD_ERROR:
      case Y.SUBTITLE_TRACK_LOAD_TIMEOUT:
        if (i) {
          const c = s.loadLevelObj;
          if (c && (i.type === Ke.AUDIO_TRACK && c.hasAudioGroup(i.groupId) || i.type === Ke.SUBTITLE_TRACK && c.hasSubtitleGroup(i.groupId))) {
            t.errorAction = this.getPlaylistRetryOrSwitchAction(t, s.loadLevel), t.errorAction.action = ar.SendAlternateToPenaltyBox, t.errorAction.flags = Gr.MoveAllAlternatesMatchingHost;
            return;
          }
        }
        return;
      case Y.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
        {
          const c = s.loadLevelObj, u = c == null ? void 0 : c.attrs["HDCP-LEVEL"];
          u ? t.errorAction = {
            action: ar.SendAlternateToPenaltyBox,
            flags: Gr.MoveAllAlternatesMatchingHDCP,
            hdcpLevel: u
          } : this.keySystemError(t);
        }
        return;
      case Y.BUFFER_ADD_CODEC_ERROR:
      case Y.REMUX_ALLOC_ERROR:
      case Y.BUFFER_APPEND_ERROR:
        if (!t.errorAction) {
          var l;
          t.errorAction = this.getLevelSwitchAction(t, (l = t.level) != null ? l : s.loadLevel);
        }
        return;
      case Y.INTERNAL_EXCEPTION:
      case Y.BUFFER_APPENDING_ERROR:
      case Y.BUFFER_FULL_ERROR:
      case Y.LEVEL_SWITCH_ERROR:
      case Y.BUFFER_STALLED_ERROR:
      case Y.BUFFER_SEEK_OVER_HOLE:
      case Y.BUFFER_NUDGE_ON_STALL:
        t.errorAction = Fi();
        return;
    }
    t.type === ge.KEY_SYSTEM_ERROR && this.keySystemError(t);
  }
  keySystemError(e) {
    const t = this.getVariantLevelIndex(e.frag);
    e.levelRetry = !1, e.errorAction = this.getLevelSwitchAction(e, t);
  }
  getPlaylistRetryOrSwitchAction(e, t) {
    const r = this.hls, s = gh(r.config.playlistLoadPolicy, e), i = this.playlistError++;
    if (xa(s, i, va(e), e.response))
      return {
        action: ar.RetryRequest,
        flags: Gr.None,
        retryConfig: s,
        retryCount: i
      };
    const a = this.getLevelSwitchAction(e, t);
    return s && (a.retryConfig = s, a.retryCount = i), a;
  }
  getFragRetryOrSwitchAction(e) {
    const t = this.hls, r = this.getVariantLevelIndex(e.frag), s = t.levels[r], {
      fragLoadPolicy: i,
      keyLoadPolicy: o
    } = t.config, a = gh(e.details.startsWith("key") ? o : i, e), l = t.levels.reduce((u, d) => u + d.fragmentError, 0);
    if (s && (e.details !== Y.FRAG_GAP && s.fragmentError++, xa(a, l, va(e), e.response)))
      return {
        action: ar.RetryRequest,
        flags: Gr.None,
        retryConfig: a,
        retryCount: l
      };
    const c = this.getLevelSwitchAction(e, r);
    return a && (c.retryConfig = a, c.retryCount = l), c;
  }
  getLevelSwitchAction(e, t) {
    const r = this.hls;
    t == null && (t = r.loadLevel);
    const s = this.hls.levels[t];
    if (s) {
      var i, o;
      const c = e.details;
      s.loadError++, c === Y.BUFFER_APPEND_ERROR && s.fragmentError++;
      let u = -1;
      const {
        levels: d,
        loadLevel: h,
        minAutoLevel: f,
        maxAutoLevel: p
      } = r;
      !r.autoLevelEnabled && !r.config.preserveManualLevelOnError && (r.loadLevel = -1);
      const y = (i = e.frag) == null ? void 0 : i.type, b = (y === he.AUDIO && c === Y.FRAG_PARSING_ERROR || e.sourceBufferName === "audio" && (c === Y.BUFFER_ADD_CODEC_ERROR || c === Y.BUFFER_APPEND_ERROR)) && d.some(({
        audioCodec: U
      }) => s.audioCodec !== U), A = e.sourceBufferName === "video" && (c === Y.BUFFER_ADD_CODEC_ERROR || c === Y.BUFFER_APPEND_ERROR) && d.some(({
        codecSet: U,
        audioCodec: j
      }) => s.codecSet !== U && s.audioCodec === j), {
        type: P,
        groupId: I
      } = (o = e.context) != null ? o : {};
      for (let U = d.length; U--; ) {
        const j = (U + h) % d.length;
        if (j !== h && j >= f && j <= p && d[j].loadError === 0) {
          var a, l;
          const G = d[j];
          if (c === Y.FRAG_GAP && y === he.MAIN && e.frag) {
            const F = d[j].details;
            if (F) {
              const B = gs(e.frag, F.fragments, e.frag.start);
              if (B != null && B.gap)
                continue;
            }
          } else {
            if (P === Ke.AUDIO_TRACK && G.hasAudioGroup(I) || P === Ke.SUBTITLE_TRACK && G.hasSubtitleGroup(I))
              continue;
            if (y === he.AUDIO && (a = s.audioGroups) != null && a.some((F) => G.hasAudioGroup(F)) || y === he.SUBTITLE && (l = s.subtitleGroups) != null && l.some((F) => G.hasSubtitleGroup(F)) || b && s.audioCodec === G.audioCodec || !b && s.audioCodec !== G.audioCodec || A && s.codecSet === G.codecSet)
              continue;
          }
          u = j;
          break;
        }
      }
      if (u > -1 && r.loadLevel !== u)
        return e.levelRetry = !0, this.playlistError = 0, {
          action: ar.SendAlternateToPenaltyBox,
          flags: Gr.None,
          nextAutoLevel: u
        };
    }
    return {
      action: ar.SendAlternateToPenaltyBox,
      flags: Gr.MoveAllAlternatesMatchingHost
    };
  }
  onErrorOut(e, t) {
    var r;
    switch ((r = t.errorAction) == null ? void 0 : r.action) {
      case ar.DoNothing:
        break;
      case ar.SendAlternateToPenaltyBox:
        this.sendAlternateToPenaltyBox(t), !t.errorAction.resolved && t.details !== Y.FRAG_GAP ? t.fatal = !0 : /MediaSource readyState: ended/.test(t.error.message) && (this.warn(`MediaSource ended after "${t.sourceBufferName}" sourceBuffer append error. Attempting to recover from media error.`), this.hls.recoverMediaError());
        break;
    }
    if (t.fatal) {
      this.hls.stopLoad();
      return;
    }
  }
  sendAlternateToPenaltyBox(e) {
    const t = this.hls, r = e.errorAction;
    if (!r)
      return;
    const {
      flags: s,
      hdcpLevel: i,
      nextAutoLevel: o
    } = r;
    switch (s) {
      case Gr.None:
        this.switchLevel(e, o);
        break;
      case Gr.MoveAllAlternatesMatchingHDCP:
        i && (t.maxHdcpLevel = wc[wc.indexOf(i) - 1], r.resolved = !0), this.warn(`Restricting playback to HDCP-LEVEL of "${t.maxHdcpLevel}" or lower`);
        break;
    }
    r.resolved || this.switchLevel(e, o);
  }
  switchLevel(e, t) {
    if (t !== void 0 && e.errorAction && (this.warn(`switching to level ${t} after ${e.details}`), this.hls.nextAutoLevel = t, e.errorAction.resolved = !0, this.hls.nextLoadLevel = this.hls.nextAutoLevel, e.details === Y.BUFFER_ADD_CODEC_ERROR && e.mimeType && e.sourceBufferName !== "audiovideo")) {
      const r = tp(e.mimeType), s = this.hls.levels;
      for (let i = s.length; i--; )
        s[i][`${e.sourceBufferName}Codec`] === r && this.hls.removeLevel(i);
    }
  }
}
function Fi(n) {
  const e = {
    action: ar.DoNothing,
    flags: Gr.None
  };
  return n && (e.resolved = !0), e;
}
var Ht = {
  NOT_LOADED: "NOT_LOADED",
  APPENDING: "APPENDING",
  PARTIAL: "PARTIAL",
  OK: "OK"
};
class Gb {
  constructor(e) {
    this.activePartLists = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.fragments = /* @__PURE__ */ Object.create(null), this.timeRanges = /* @__PURE__ */ Object.create(null), this.bufferPadding = 0.2, this.hls = void 0, this.hasGaps = !1, this.hls = e, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.BUFFER_APPENDED, this.onBufferAppended, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this), e.on(T.FRAG_LOADED, this.onFragLoaded, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.BUFFER_APPENDED, this.onBufferAppended, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this), e.off(T.FRAG_LOADED, this.onFragLoaded, this);
  }
  destroy() {
    this._unregisterListeners(), this.fragments = // @ts-ignore
    this.activePartLists = // @ts-ignore
    this.endListFragments = this.timeRanges = null;
  }
  /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */
  getAppendedFrag(e, t) {
    const r = this.activePartLists[t];
    if (r)
      for (let s = r.length; s--; ) {
        const i = r[s];
        if (!i)
          break;
        const o = i.end;
        if (i.start <= e && o !== null && e <= o)
          return i;
      }
    return this.getBufferedFrag(e, t);
  }
  /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */
  getBufferedFrag(e, t) {
    return this.getFragAtPos(e, t, !0);
  }
  getFragAtPos(e, t, r) {
    const {
      fragments: s
    } = this, i = Object.keys(s);
    for (let o = i.length; o--; ) {
      const a = s[i[o]];
      if ((a == null ? void 0 : a.body.type) === t && (!r || a.buffered)) {
        const l = a.body;
        if (l.start <= e && e <= l.end)
          return l;
      }
    }
    return null;
  }
  /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */
  detectEvictedFragments(e, t, r, s, i) {
    this.timeRanges && (this.timeRanges[e] = t);
    const o = (s == null ? void 0 : s.fragment.sn) || -1;
    Object.keys(this.fragments).forEach((a) => {
      const l = this.fragments[a];
      if (!l || o >= l.body.sn)
        return;
      if (!l.buffered && (!l.loaded || i)) {
        l.body.type === r && this.removeFragment(l.body);
        return;
      }
      const c = l.range[e];
      if (c) {
        if (c.time.length === 0) {
          this.removeFragment(l.body);
          return;
        }
        c.time.some((u) => {
          const d = !this.isTimeBuffered(u.startPTS, u.endPTS, t);
          return d && this.removeFragment(l.body), d;
        });
      }
    });
  }
  /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */
  detectPartialFragments(e) {
    const t = this.timeRanges;
    if (!t || e.frag.sn === "initSegment")
      return;
    const r = e.frag, s = Rs(r), i = this.fragments[s];
    if (!i || i.buffered && r.gap)
      return;
    const o = !r.relurl;
    Object.keys(t).forEach((a) => {
      const l = r.elementaryStreams[a];
      if (!l)
        return;
      const c = t[a], u = o || l.partial === !0;
      i.range[a] = this.getBufferedTimes(r, e.part, u, c);
    }), i.loaded = null, Object.keys(i.range).length ? (i.buffered = !0, (i.body.endList = r.endList || i.body.endList) && (this.endListFragments[i.body.type] = i), co(i) || this.removeParts(r.sn - 1, r.type)) : this.removeFragment(i.body);
  }
  removeParts(e, t) {
    const r = this.activePartLists[t];
    r && (this.activePartLists[t] = mh(r, (s) => s.fragment.sn >= e));
  }
  fragBuffered(e, t) {
    const r = Rs(e);
    let s = this.fragments[r];
    !s && t && (s = this.fragments[r] = {
      body: e,
      appendedPTS: null,
      loaded: null,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    }, e.gap && (this.hasGaps = !0)), s && (s.loaded = null, s.buffered = !0);
  }
  getBufferedTimes(e, t, r, s) {
    const i = {
      time: [],
      partial: r
    }, o = e.start, a = e.end, l = e.minEndPTS || a, c = e.maxStartPTS || o;
    for (let u = 0; u < s.length; u++) {
      const d = s.start(u) - this.bufferPadding, h = s.end(u) + this.bufferPadding;
      if (c >= d && l <= h) {
        i.time.push({
          startPTS: Math.max(o, s.start(u)),
          endPTS: Math.min(a, s.end(u))
        });
        break;
      } else if (o < h && a > d) {
        const f = Math.max(o, s.start(u)), p = Math.min(a, s.end(u));
        p > f && (i.partial = !0, i.time.push({
          startPTS: f,
          endPTS: p
        }));
      } else if (a <= d)
        break;
    }
    return i;
  }
  /**
   * Gets the partial fragment for a certain time
   */
  getPartialFragment(e) {
    let t = null, r, s, i, o = 0;
    const {
      bufferPadding: a,
      fragments: l
    } = this;
    return Object.keys(l).forEach((c) => {
      const u = l[c];
      u && co(u) && (s = u.body.start - a, i = u.body.end + a, e >= s && e <= i && (r = Math.min(e - s, i - e), o <= r && (t = u.body, o = r)));
    }), t;
  }
  isEndListAppended(e) {
    const t = this.endListFragments[e];
    return t !== void 0 && (t.buffered || co(t));
  }
  getState(e) {
    const t = Rs(e), r = this.fragments[t];
    return r ? r.buffered ? co(r) ? Ht.PARTIAL : Ht.OK : Ht.APPENDING : Ht.NOT_LOADED;
  }
  isTimeBuffered(e, t, r) {
    let s, i;
    for (let o = 0; o < r.length; o++) {
      if (s = r.start(o) - this.bufferPadding, i = r.end(o) + this.bufferPadding, e >= s && t <= i)
        return !0;
      if (t <= s)
        return !1;
    }
    return !1;
  }
  onManifestLoading() {
    this.removeAllFragments();
  }
  onFragLoaded(e, t) {
    if (t.frag.sn === "initSegment" || t.frag.bitrateTest)
      return;
    const r = t.frag, s = t.part ? null : t, i = Rs(r);
    this.fragments[i] = {
      body: r,
      appendedPTS: null,
      loaded: s,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    };
  }
  onBufferAppended(e, t) {
    const {
      frag: r,
      part: s,
      timeRanges: i,
      type: o
    } = t;
    if (r.sn === "initSegment")
      return;
    const a = r.type;
    if (s) {
      let c = this.activePartLists[a];
      c || (this.activePartLists[a] = c = []), c.push(s);
    }
    this.timeRanges = i;
    const l = i[o];
    this.detectEvictedFragments(o, l, a, s);
  }
  onFragBuffered(e, t) {
    this.detectPartialFragments(t);
  }
  hasFragment(e) {
    const t = Rs(e);
    return !!this.fragments[t];
  }
  hasFragments(e) {
    const {
      fragments: t
    } = this, r = Object.keys(t);
    if (!e)
      return r.length > 0;
    for (let s = r.length; s--; ) {
      const i = t[r[s]];
      if ((i == null ? void 0 : i.body.type) === e)
        return !0;
    }
    return !1;
  }
  hasParts(e) {
    var t;
    return !!((t = this.activePartLists[e]) != null && t.length);
  }
  removeFragmentsInRange(e, t, r, s, i) {
    s && !this.hasGaps || Object.keys(this.fragments).forEach((o) => {
      const a = this.fragments[o];
      if (!a)
        return;
      const l = a.body;
      l.type !== r || s && !l.gap || l.start < t && l.end > e && (a.buffered || i) && this.removeFragment(l);
    });
  }
  removeFragment(e) {
    const t = Rs(e);
    e.clearElementaryStreamInfo();
    const r = this.activePartLists[e.type];
    if (r) {
      const s = e.sn;
      this.activePartLists[e.type] = mh(r, (i) => i.fragment.sn !== s);
    }
    delete this.fragments[t], e.endList && delete this.endListFragments[e.type];
  }
  removeAllFragments() {
    var e, t;
    this.fragments = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.activePartLists = /* @__PURE__ */ Object.create(null), this.hasGaps = !1;
    const r = (e = this.hls) == null || (t = e.latestLevelDetails) == null ? void 0 : t.partList;
    r && r.forEach((s) => s.clearElementaryStreamInfo());
  }
}
function co(n) {
  var e, t, r;
  return n.buffered && (n.body.gap || ((e = n.range.video) == null ? void 0 : e.partial) || ((t = n.range.audio) == null ? void 0 : t.partial) || ((r = n.range.audiovideo) == null ? void 0 : r.partial));
}
function Rs(n) {
  return `${n.type}_${n.level}_${n.sn}`;
}
function mh(n, e) {
  return n.filter((t) => {
    const r = e(t);
    return r || t.clearElementaryStreamInfo(), r;
  });
}
var Xn = {
  cbc: 0,
  ctr: 1
};
class jb {
  constructor(e, t, r) {
    this.subtle = void 0, this.aesIV = void 0, this.aesMode = void 0, this.subtle = e, this.aesIV = t, this.aesMode = r;
  }
  decrypt(e, t) {
    switch (this.aesMode) {
      case Xn.cbc:
        return this.subtle.decrypt({
          name: "AES-CBC",
          iv: this.aesIV
        }, t, e);
      case Xn.ctr:
        return this.subtle.decrypt(
          {
            name: "AES-CTR",
            counter: this.aesIV,
            length: 64
          },
          //64 : NIST SP800-38A standard suggests that the counter should occupy half of the counter block
          t,
          e
        );
      default:
        throw new Error(`[AESCrypto] invalid aes mode ${this.aesMode}`);
    }
  }
}
function Vb(n) {
  const e = n.byteLength, t = e && new DataView(n.buffer).getUint8(e - 1);
  return t ? n.slice(0, e - t) : n;
}
class Kb {
  constructor() {
    this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.ksRows = 0, this.keySize = 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.initTable();
  }
  // Using view.getUint32() also swaps the byte order.
  uint8ArrayToUint32Array_(e) {
    const t = new DataView(e), r = new Uint32Array(4);
    for (let s = 0; s < 4; s++)
      r[s] = t.getUint32(s * 4);
    return r;
  }
  initTable() {
    const e = this.sBox, t = this.invSBox, r = this.subMix, s = r[0], i = r[1], o = r[2], a = r[3], l = this.invSubMix, c = l[0], u = l[1], d = l[2], h = l[3], f = new Uint32Array(256);
    let p = 0, y = 0, m = 0;
    for (m = 0; m < 256; m++)
      m < 128 ? f[m] = m << 1 : f[m] = m << 1 ^ 283;
    for (m = 0; m < 256; m++) {
      let b = y ^ y << 1 ^ y << 2 ^ y << 3 ^ y << 4;
      b = b >>> 8 ^ b & 255 ^ 99, e[p] = b, t[b] = p;
      const C = f[p], A = f[C], P = f[A];
      let I = f[b] * 257 ^ b * 16843008;
      s[p] = I << 24 | I >>> 8, i[p] = I << 16 | I >>> 16, o[p] = I << 8 | I >>> 24, a[p] = I, I = P * 16843009 ^ A * 65537 ^ C * 257 ^ p * 16843008, c[b] = I << 24 | I >>> 8, u[b] = I << 16 | I >>> 16, d[b] = I << 8 | I >>> 24, h[b] = I, p ? (p = C ^ f[f[f[P ^ C]]], y ^= f[f[y]]) : p = y = 1;
    }
  }
  expandKey(e) {
    const t = this.uint8ArrayToUint32Array_(e);
    let r = !0, s = 0;
    for (; s < t.length && r; )
      r = t[s] === this.key[s], s++;
    if (r)
      return;
    this.key = t;
    const i = this.keySize = t.length;
    if (i !== 4 && i !== 6 && i !== 8)
      throw new Error("Invalid aes key size=" + i);
    const o = this.ksRows = (i + 6 + 1) * 4;
    let a, l;
    const c = this.keySchedule = new Uint32Array(o), u = this.invKeySchedule = new Uint32Array(o), d = this.sBox, h = this.rcon, f = this.invSubMix, p = f[0], y = f[1], m = f[2], b = f[3];
    let C, A;
    for (a = 0; a < o; a++) {
      if (a < i) {
        C = c[a] = t[a];
        continue;
      }
      A = C, a % i === 0 ? (A = A << 8 | A >>> 24, A = d[A >>> 24] << 24 | d[A >>> 16 & 255] << 16 | d[A >>> 8 & 255] << 8 | d[A & 255], A ^= h[a / i | 0] << 24) : i > 6 && a % i === 4 && (A = d[A >>> 24] << 24 | d[A >>> 16 & 255] << 16 | d[A >>> 8 & 255] << 8 | d[A & 255]), c[a] = C = (c[a - i] ^ A) >>> 0;
    }
    for (l = 0; l < o; l++)
      a = o - l, l & 3 ? A = c[a] : A = c[a - 4], l < 4 || a <= 4 ? u[l] = A : u[l] = p[d[A >>> 24]] ^ y[d[A >>> 16 & 255]] ^ m[d[A >>> 8 & 255]] ^ b[d[A & 255]], u[l] = u[l] >>> 0;
  }
  // Adding this as a method greatly improves performance.
  networkToHostOrderSwap(e) {
    return e << 24 | (e & 65280) << 8 | (e & 16711680) >> 8 | e >>> 24;
  }
  decrypt(e, t, r) {
    const s = this.keySize + 6, i = this.invKeySchedule, o = this.invSBox, a = this.invSubMix, l = a[0], c = a[1], u = a[2], d = a[3], h = this.uint8ArrayToUint32Array_(r);
    let f = h[0], p = h[1], y = h[2], m = h[3];
    const b = new Int32Array(e), C = new Int32Array(b.length);
    let A, P, I, U, j, G, F, B, V, H, L, g, x, w;
    const _ = this.networkToHostOrderSwap;
    for (; t < b.length; ) {
      for (V = _(b[t]), H = _(b[t + 1]), L = _(b[t + 2]), g = _(b[t + 3]), j = V ^ i[0], G = g ^ i[1], F = L ^ i[2], B = H ^ i[3], x = 4, w = 1; w < s; w++)
        A = l[j >>> 24] ^ c[G >> 16 & 255] ^ u[F >> 8 & 255] ^ d[B & 255] ^ i[x], P = l[G >>> 24] ^ c[F >> 16 & 255] ^ u[B >> 8 & 255] ^ d[j & 255] ^ i[x + 1], I = l[F >>> 24] ^ c[B >> 16 & 255] ^ u[j >> 8 & 255] ^ d[G & 255] ^ i[x + 2], U = l[B >>> 24] ^ c[j >> 16 & 255] ^ u[G >> 8 & 255] ^ d[F & 255] ^ i[x + 3], j = A, G = P, F = I, B = U, x = x + 4;
      A = o[j >>> 24] << 24 ^ o[G >> 16 & 255] << 16 ^ o[F >> 8 & 255] << 8 ^ o[B & 255] ^ i[x], P = o[G >>> 24] << 24 ^ o[F >> 16 & 255] << 16 ^ o[B >> 8 & 255] << 8 ^ o[j & 255] ^ i[x + 1], I = o[F >>> 24] << 24 ^ o[B >> 16 & 255] << 16 ^ o[j >> 8 & 255] << 8 ^ o[G & 255] ^ i[x + 2], U = o[B >>> 24] << 24 ^ o[j >> 16 & 255] << 16 ^ o[G >> 8 & 255] << 8 ^ o[F & 255] ^ i[x + 3], C[t] = _(A ^ f), C[t + 1] = _(U ^ p), C[t + 2] = _(I ^ y), C[t + 3] = _(P ^ m), f = V, p = H, y = L, m = g, t = t + 4;
    }
    return C.buffer;
  }
}
class Hb {
  constructor(e, t, r) {
    this.subtle = void 0, this.key = void 0, this.aesMode = void 0, this.subtle = e, this.key = t, this.aesMode = r;
  }
  expandKey() {
    const e = Wb(this.aesMode);
    return this.subtle.importKey("raw", this.key, {
      name: e
    }, !1, ["encrypt", "decrypt"]);
  }
}
function Wb(n) {
  switch (n) {
    case Xn.cbc:
      return "AES-CBC";
    case Xn.ctr:
      return "AES-CTR";
    default:
      throw new Error(`[FastAESKey] invalid aes mode ${n}`);
  }
}
const qb = 16;
class Fu {
  constructor(e, {
    removePKCS7Padding: t = !0
  } = {}) {
    if (this.logEnabled = !0, this.removePKCS7Padding = void 0, this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null, this.useSoftware = void 0, this.enableSoftwareAES = void 0, this.enableSoftwareAES = e.enableSoftwareAES, this.removePKCS7Padding = t, t)
      try {
        const r = self.crypto;
        r && (this.subtle = r.subtle || r.webkitSubtle);
      } catch {
      }
    this.useSoftware = !this.subtle;
  }
  destroy() {
    this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null;
  }
  isSync() {
    return this.useSoftware;
  }
  flush() {
    const {
      currentResult: e,
      remainderData: t
    } = this;
    if (!e || t)
      return this.reset(), null;
    const r = new Uint8Array(e);
    return this.reset(), this.removePKCS7Padding ? Vb(r) : r;
  }
  reset() {
    this.currentResult = null, this.currentIV = null, this.remainderData = null, this.softwareDecrypter && (this.softwareDecrypter = null);
  }
  decrypt(e, t, r, s) {
    return this.useSoftware ? new Promise((i, o) => {
      const a = ArrayBuffer.isView(e) ? e : new Uint8Array(e);
      this.softwareDecrypt(a, t, r, s);
      const l = this.flush();
      l ? i(l.buffer) : o(new Error("[softwareDecrypt] Failed to decrypt data"));
    }) : this.webCryptoDecrypt(new Uint8Array(e), t, r, s);
  }
  // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
  // data is handled in the flush() call
  softwareDecrypt(e, t, r, s) {
    const {
      currentIV: i,
      currentResult: o,
      remainderData: a
    } = this;
    if (s !== Xn.cbc || t.byteLength !== 16)
      return Ze.warn("SoftwareDecrypt: can only handle AES-128-CBC"), null;
    this.logOnce("JS AES decrypt"), a && (e = Nr(a, e), this.remainderData = null);
    const l = this.getValidChunk(e);
    if (!l.length)
      return null;
    i && (r = i);
    let c = this.softwareDecrypter;
    c || (c = this.softwareDecrypter = new Kb()), c.expandKey(t);
    const u = o;
    return this.currentResult = c.decrypt(l.buffer, 0, r), this.currentIV = l.slice(-16).buffer, u || null;
  }
  webCryptoDecrypt(e, t, r, s) {
    if (this.key !== t || !this.fastAesKey) {
      if (!this.subtle)
        return Promise.resolve(this.onWebCryptoError(e, t, r, s));
      this.key = t, this.fastAesKey = new Hb(this.subtle, t, s);
    }
    return this.fastAesKey.expandKey().then((i) => this.subtle ? (this.logOnce("WebCrypto AES decrypt"), new jb(this.subtle, new Uint8Array(r), s).decrypt(e.buffer, i)) : Promise.reject(new Error("web crypto not initialized"))).catch((i) => (Ze.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${i.name}: ${i.message}`), this.onWebCryptoError(e, t, r, s)));
  }
  onWebCryptoError(e, t, r, s) {
    const i = this.enableSoftwareAES;
    if (i) {
      this.useSoftware = !0, this.logEnabled = !0, this.softwareDecrypt(e, t, r, s);
      const o = this.flush();
      if (o)
        return o.buffer;
    }
    throw new Error("WebCrypto" + (i ? " and softwareDecrypt" : "") + ": failed to decrypt data");
  }
  getValidChunk(e) {
    let t = e;
    const r = e.length - e.length % qb;
    return r !== e.length && (t = e.slice(0, r), this.remainderData = e.slice(r)), t;
  }
  logOnce(e) {
    this.logEnabled && (Ze.log(`[decrypter]: ${e}`), this.logEnabled = !1);
  }
}
const yh = Math.pow(2, 17);
class zb {
  constructor(e) {
    this.config = void 0, this.loader = null, this.partLoadTimeout = -1, this.config = e;
  }
  destroy() {
    this.loader && (this.loader.destroy(), this.loader = null);
  }
  abort() {
    this.loader && this.loader.abort();
  }
  load(e, t) {
    const r = e.url;
    if (!r)
      return Promise.reject(new En({
        type: ge.NETWORK_ERROR,
        details: Y.FRAG_LOAD_ERROR,
        fatal: !1,
        frag: e,
        error: new Error(`Fragment does not have a ${r ? "part list" : "url"}`),
        networkDetails: null
      }));
    this.abort();
    const s = this.config, i = s.fLoader, o = s.loader;
    return new Promise((a, l) => {
      if (this.loader && this.loader.destroy(), e.gap)
        if (e.tagList.some((p) => p[0] === "GAP")) {
          l(xh(e));
          return;
        } else
          e.gap = !1;
      const c = this.loader = i ? new i(s) : new o(s), u = vh(e);
      e.loader = c;
      const d = ph(s.fragLoadPolicy.default), h = {
        loadPolicy: d,
        timeout: d.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: e.sn === "initSegment" ? 1 / 0 : yh
      };
      e.stats = c.stats;
      const f = {
        onSuccess: (p, y, m, b) => {
          this.resetLoader(e, c);
          let C = p.data;
          m.resetIV && e.decryptdata && (e.decryptdata.iv = new Uint8Array(C.slice(0, 16)), C = C.slice(16)), a({
            frag: e,
            part: null,
            payload: C,
            networkDetails: b
          });
        },
        onError: (p, y, m, b) => {
          this.resetLoader(e, c), l(new En({
            type: ge.NETWORK_ERROR,
            details: Y.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            response: rt({
              url: r,
              data: void 0
            }, p),
            error: new Error(`HTTP Error ${p.code} ${p.text}`),
            networkDetails: m,
            stats: b
          }));
        },
        onAbort: (p, y, m) => {
          this.resetLoader(e, c), l(new En({
            type: ge.NETWORK_ERROR,
            details: Y.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            error: new Error("Aborted"),
            networkDetails: m,
            stats: p
          }));
        },
        onTimeout: (p, y, m) => {
          this.resetLoader(e, c), l(new En({
            type: ge.NETWORK_ERROR,
            details: Y.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            error: new Error(`Timeout after ${h.timeout}ms`),
            networkDetails: m,
            stats: p
          }));
        }
      };
      t && (f.onProgress = (p, y, m, b) => t({
        frag: e,
        part: null,
        payload: m,
        networkDetails: b
      })), c.load(u, h, f);
    });
  }
  loadPart(e, t, r) {
    this.abort();
    const s = this.config, i = s.fLoader, o = s.loader;
    return new Promise((a, l) => {
      if (this.loader && this.loader.destroy(), e.gap || t.gap) {
        l(xh(e, t));
        return;
      }
      const c = this.loader = i ? new i(s) : new o(s), u = vh(e, t);
      e.loader = c;
      const d = ph(s.fragLoadPolicy.default), h = {
        loadPolicy: d,
        timeout: d.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: yh
      };
      t.stats = c.stats, c.load(u, h, {
        onSuccess: (f, p, y, m) => {
          this.resetLoader(e, c), this.updateStatsFromPart(e, t);
          const b = {
            frag: e,
            part: t,
            payload: f.data,
            networkDetails: m
          };
          r(b), a(b);
        },
        onError: (f, p, y, m) => {
          this.resetLoader(e, c), l(new En({
            type: ge.NETWORK_ERROR,
            details: Y.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            part: t,
            response: rt({
              url: u.url,
              data: void 0
            }, f),
            error: new Error(`HTTP Error ${f.code} ${f.text}`),
            networkDetails: y,
            stats: m
          }));
        },
        onAbort: (f, p, y) => {
          e.stats.aborted = t.stats.aborted, this.resetLoader(e, c), l(new En({
            type: ge.NETWORK_ERROR,
            details: Y.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error("Aborted"),
            networkDetails: y,
            stats: f
          }));
        },
        onTimeout: (f, p, y) => {
          this.resetLoader(e, c), l(new En({
            type: ge.NETWORK_ERROR,
            details: Y.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error(`Timeout after ${h.timeout}ms`),
            networkDetails: y,
            stats: f
          }));
        }
      });
    });
  }
  updateStatsFromPart(e, t) {
    const r = e.stats, s = t.stats, i = s.total;
    if (r.loaded += s.loaded, i) {
      const l = Math.round(e.duration / t.duration), c = Math.min(Math.round(r.loaded / i), l), d = (l - c) * Math.round(r.loaded / c);
      r.total = r.loaded + d;
    } else
      r.total = Math.max(r.loaded, r.total);
    const o = r.loading, a = s.loading;
    o.start ? o.first += a.first - a.start : (o.start = a.start, o.first = a.first), o.end = a.end;
  }
  resetLoader(e, t) {
    e.loader = null, this.loader === t && (self.clearTimeout(this.partLoadTimeout), this.loader = null), t.destroy();
  }
}
function vh(n, e = null) {
  const t = e || n, r = {
    frag: n,
    part: e,
    responseType: "arraybuffer",
    url: t.url,
    headers: {},
    rangeStart: 0,
    rangeEnd: 0
  }, s = t.byteRangeStartOffset, i = t.byteRangeEndOffset;
  if (ae(s) && ae(i)) {
    var o;
    let a = s, l = i;
    if (n.sn === "initSegment" && Yb((o = n.decryptdata) == null ? void 0 : o.method)) {
      const c = i - s;
      c % 16 && (l = i + (16 - c % 16)), s !== 0 && (r.resetIV = !0, a = s - 16);
    }
    r.rangeStart = a, r.rangeEnd = l;
  }
  return r;
}
function xh(n, e) {
  const t = new Error(`GAP ${n.gap ? "tag" : "attribute"} found`), r = {
    type: ge.MEDIA_ERROR,
    details: Y.FRAG_GAP,
    fatal: !1,
    frag: n,
    error: t,
    networkDetails: null
  };
  return e && (r.part = e), (e || n).stats.aborted = !0, new En(r);
}
function Yb(n) {
  return n === "AES-128" || n === "AES-256";
}
class En extends Error {
  constructor(e) {
    super(e.error.message), this.data = void 0, this.data = e;
  }
}
class lp extends Cn {
  constructor(e, t) {
    super(e, t), this._boundTick = void 0, this._tickTimer = null, this._tickInterval = null, this._tickCallCount = 0, this._boundTick = this.tick.bind(this);
  }
  destroy() {
    this.onHandlerDestroying(), this.onHandlerDestroyed();
  }
  onHandlerDestroying() {
    this.clearNextTick(), this.clearInterval();
  }
  onHandlerDestroyed() {
  }
  hasInterval() {
    return !!this._tickInterval;
  }
  hasNextTick() {
    return !!this._tickTimer;
  }
  /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */
  setInterval(e) {
    return this._tickInterval ? !1 : (this._tickCallCount = 0, this._tickInterval = self.setInterval(this._boundTick, e), !0);
  }
  /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */
  clearInterval() {
    return this._tickInterval ? (self.clearInterval(this._tickInterval), this._tickInterval = null, !0) : !1;
  }
  /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */
  clearNextTick() {
    return this._tickTimer ? (self.clearTimeout(this._tickTimer), this._tickTimer = null, !0) : !1;
  }
  /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */
  tick() {
    this._tickCallCount++, this._tickCallCount === 1 && (this.doTick(), this._tickCallCount > 1 && this.tickImmediate(), this._tickCallCount = 0);
  }
  tickImmediate() {
    this.clearNextTick(), this._tickTimer = self.setTimeout(this._boundTick, 0);
  }
  /**
   * For subclass to implement task logic
   * @abstract
   */
  doTick() {
  }
}
class Nu {
  constructor(e, t, r, s = 0, i = -1, o = !1) {
    this.level = void 0, this.sn = void 0, this.part = void 0, this.id = void 0, this.size = void 0, this.partial = void 0, this.transmuxing = uo(), this.buffering = {
      audio: uo(),
      video: uo(),
      audiovideo: uo()
    }, this.level = e, this.sn = t, this.id = r, this.size = s, this.part = i, this.partial = o;
  }
}
function uo() {
  return {
    start: 0,
    executeStart: 0,
    executeEnd: 0,
    end: 0
  };
}
const Eh = {
  length: 0,
  start: () => 0,
  end: () => 0
};
class Le {
  /**
   * Return true if `media`'s buffered include `position`
   */
  static isBuffered(e, t) {
    if (e) {
      const r = Le.getBuffered(e);
      for (let s = r.length; s--; )
        if (t >= r.start(s) && t <= r.end(s))
          return !0;
    }
    return !1;
  }
  static bufferedRanges(e) {
    if (e) {
      const t = Le.getBuffered(e);
      return Le.timeRangesToArray(t);
    }
    return [];
  }
  static timeRangesToArray(e) {
    const t = [];
    for (let r = 0; r < e.length; r++)
      t.push({
        start: e.start(r),
        end: e.end(r)
      });
    return t;
  }
  static bufferInfo(e, t, r) {
    if (e) {
      const s = Le.bufferedRanges(e);
      if (s.length)
        return Le.bufferedInfo(s, t, r);
    }
    return {
      len: 0,
      start: t,
      end: t,
      bufferedIndex: -1
    };
  }
  static bufferedInfo(e, t, r) {
    t = Math.max(0, t), e.length > 1 && e.sort((u, d) => u.start - d.start || d.end - u.end);
    let s = -1, i = [];
    if (r)
      for (let u = 0; u < e.length; u++) {
        t >= e[u].start && t <= e[u].end && (s = u);
        const d = i.length;
        if (d) {
          const h = i[d - 1].end;
          e[u].start - h < r ? e[u].end > h && (i[d - 1].end = e[u].end) : i.push(e[u]);
        } else
          i.push(e[u]);
      }
    else
      i = e;
    let o = 0, a, l = t, c = t;
    for (let u = 0; u < i.length; u++) {
      const d = i[u].start, h = i[u].end;
      if (s === -1 && t >= d && t <= h && (s = u), t + r >= d && t < h)
        l = d, c = h, o = c - t;
      else if (t + r < d) {
        a = d;
        break;
      }
    }
    return {
      len: o,
      start: l || 0,
      end: c || 0,
      nextStart: a,
      buffered: e,
      bufferedIndex: s
    };
  }
  /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */
  static getBuffered(e) {
    try {
      return e.buffered || Eh;
    } catch (t) {
      return Ze.log("failed to get media.buffered", t), Eh;
    }
  }
}
const cp = /\{\$([a-zA-Z0-9-_]+)\}/g;
function Sh(n) {
  return cp.test(n);
}
function Ac(n, e) {
  if (n.variableList !== null || n.hasVariableRefs) {
    const t = n.variableList;
    return e.replace(cp, (r) => {
      const s = r.substring(2, r.length - 1), i = t == null ? void 0 : t[s];
      return i === void 0 ? (n.playlistParsingError || (n.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${s}"`)), r) : i;
    });
  }
  return e;
}
function bh(n, e, t) {
  let r = n.variableList;
  r || (n.variableList = r = {});
  let s, i;
  if ("QUERYPARAM" in e) {
    s = e.QUERYPARAM;
    try {
      const o = new self.URL(t).searchParams;
      if (o.has(s))
        i = o.get(s);
      else
        throw new Error(`"${s}" does not match any query parameter in URI: "${t}"`);
    } catch (o) {
      n.playlistParsingError || (n.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${o.message}`));
    }
  } else
    s = e.NAME, i = e.VALUE;
  s in r ? n.playlistParsingError || (n.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${s}"`)) : r[s] = i || "";
}
function Zb(n, e, t) {
  const r = e.IMPORT;
  if (t && r in t) {
    let s = n.variableList;
    s || (n.variableList = s = {}), s[r] = t[r];
  } else
    n.playlistParsingError || (n.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${r}"`));
}
const Xb = /^(\d+)x(\d+)$/, Th = /(.+?)=(".*?"|.*?)(?:,|$)/g;
class yt {
  constructor(e, t) {
    typeof e == "string" && (e = yt.parseAttrList(e, t)), st(this, e);
  }
  get clientAttrs() {
    return Object.keys(this).filter((e) => e.substring(0, 2) === "X-");
  }
  decimalInteger(e) {
    const t = parseInt(this[e], 10);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  hexadecimalInteger(e) {
    if (this[e]) {
      let t = (this[e] || "0x").slice(2);
      t = (t.length & 1 ? "0" : "") + t;
      const r = new Uint8Array(t.length / 2);
      for (let s = 0; s < t.length / 2; s++)
        r[s] = parseInt(t.slice(s * 2, s * 2 + 2), 16);
      return r;
    }
    return null;
  }
  hexadecimalIntegerAsNumber(e) {
    const t = parseInt(this[e], 16);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  decimalFloatingPoint(e) {
    return parseFloat(this[e]);
  }
  optionalFloat(e, t) {
    const r = this[e];
    return r ? parseFloat(r) : t;
  }
  enumeratedString(e) {
    return this[e];
  }
  enumeratedStringList(e, t) {
    const r = this[e];
    return (r ? r.split(/[ ,]+/) : []).reduce((s, i) => (s[i.toLowerCase()] = !0, s), t);
  }
  bool(e) {
    return this[e] === "YES";
  }
  decimalResolution(e) {
    const t = Xb.exec(this[e]);
    if (t !== null)
      return {
        width: parseInt(t[1], 10),
        height: parseInt(t[2], 10)
      };
  }
  static parseAttrList(e, t) {
    let r;
    const s = {}, i = '"';
    for (Th.lastIndex = 0; (r = Th.exec(e)) !== null; ) {
      const o = r[1].trim();
      let a = r[2];
      const l = a.indexOf(i) === 0 && a.lastIndexOf(i) === a.length - 1;
      let c = !1;
      if (l)
        a = a.slice(1, -1);
      else
        switch (o) {
          case "IV":
          case "SCTE35-CMD":
          case "SCTE35-IN":
          case "SCTE35-OUT":
            c = !0;
        }
      if (t && (l || c))
        a = Ac(t, a);
      else if (!c && !l)
        switch (o) {
          case "CLOSED-CAPTIONS":
            if (a === "NONE")
              break;
          case "ALLOWED-CPC":
          case "CLASS":
          case "ASSOC-LANGUAGE":
          case "AUDIO":
          case "BYTERANGE":
          case "CHANNELS":
          case "CHARACTERISTICS":
          case "CODECS":
          case "DATA-ID":
          case "END-DATE":
          case "GROUP-ID":
          case "ID":
          case "IMPORT":
          case "INSTREAM-ID":
          case "KEYFORMAT":
          case "KEYFORMATVERSIONS":
          case "LANGUAGE":
          case "NAME":
          case "PATHWAY-ID":
          case "QUERYPARAM":
          case "RECENTLY-REMOVED-DATERANGES":
          case "SERVER-URI":
          case "STABLE-RENDITION-ID":
          case "STABLE-VARIANT-ID":
          case "START-DATE":
          case "SUBTITLES":
          case "SUPPLEMENTAL-CODECS":
          case "URI":
          case "VALUE":
          case "VIDEO":
          case "X-ASSET-LIST":
          case "X-ASSET-URI":
            Ze.warn(`${e}: attribute ${o} is missing quotes`);
        }
      s[o] = a;
    }
    return s;
  }
}
const Jb = "com.apple.hls.interstitial";
function Qb(n) {
  return n !== "ID" && n !== "CLASS" && n !== "CUE" && n !== "START-DATE" && n !== "DURATION" && n !== "END-DATE" && n !== "END-ON-NEXT";
}
function eT(n) {
  return n === "SCTE35-OUT" || n === "SCTE35-IN" || n === "SCTE35-CMD";
}
class up {
  constructor(e, t, r = 0) {
    var s;
    if (this.attr = void 0, this.tagAnchor = void 0, this.tagOrder = void 0, this._startDate = void 0, this._endDate = void 0, this._dateAtEnd = void 0, this._cue = void 0, this._badValueForSameId = void 0, this.tagAnchor = (t == null ? void 0 : t.tagAnchor) || null, this.tagOrder = (s = t == null ? void 0 : t.tagOrder) != null ? s : r, t) {
      const i = t.attr;
      for (const o in i)
        if (Object.prototype.hasOwnProperty.call(e, o) && e[o] !== i[o]) {
          Ze.warn(`DATERANGE tag attribute: "${o}" does not match for tags with ID: "${e.ID}"`), this._badValueForSameId = o;
          break;
        }
      e = st(new yt({}), i, e);
    }
    if (this.attr = e, t ? (this._startDate = t._startDate, this._cue = t._cue, this._endDate = t._endDate, this._dateAtEnd = t._dateAtEnd) : this._startDate = new Date(e["START-DATE"]), "END-DATE" in this.attr) {
      const i = (t == null ? void 0 : t.endDate) || new Date(this.attr["END-DATE"]);
      ae(i.getTime()) && (this._endDate = i);
    }
  }
  get id() {
    return this.attr.ID;
  }
  get class() {
    return this.attr.CLASS;
  }
  get cue() {
    const e = this._cue;
    return e === void 0 ? this._cue = this.attr.enumeratedStringList(this.attr.CUE ? "CUE" : "X-CUE", {
      pre: !1,
      post: !1,
      once: !1
    }) : e;
  }
  get startTime() {
    const {
      tagAnchor: e
    } = this;
    return e === null || e.programDateTime === null ? (Ze.warn(`Expected tagAnchor Fragment with PDT set for DateRange "${this.id}": ${e}`), NaN) : e.start + (this.startDate.getTime() - e.programDateTime) / 1e3;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    const e = this._endDate || this._dateAtEnd;
    if (e)
      return e;
    const t = this.duration;
    return t !== null ? this._dateAtEnd = new Date(this._startDate.getTime() + t * 1e3) : null;
  }
  get duration() {
    if ("DURATION" in this.attr) {
      const e = this.attr.decimalFloatingPoint("DURATION");
      if (ae(e))
        return e;
    } else if (this._endDate)
      return (this._endDate.getTime() - this._startDate.getTime()) / 1e3;
    return null;
  }
  get plannedDuration() {
    return "PLANNED-DURATION" in this.attr ? this.attr.decimalFloatingPoint("PLANNED-DURATION") : null;
  }
  get endOnNext() {
    return this.attr.bool("END-ON-NEXT");
  }
  get isInterstitial() {
    return this.class === Jb;
  }
  get isValid() {
    return !!this.id && !this._badValueForSameId && ae(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class) && (!this.attr.CUE || !this.cue.pre && !this.cue.post || this.cue.pre !== this.cue.post) && (!this.isInterstitial || "X-ASSET-URI" in this.attr || "X-ASSET-LIST" in this.attr);
  }
}
const tT = 10;
class rT {
  constructor(e) {
    this.PTSKnown = !1, this.alignedSliding = !1, this.averagetargetduration = void 0, this.endCC = 0, this.endSN = 0, this.fragments = void 0, this.fragmentHint = void 0, this.partList = null, this.dateRanges = void 0, this.dateRangeTagCount = 0, this.live = !0, this.requestScheduled = -1, this.ageHeader = 0, this.advancedDateTime = void 0, this.updated = !0, this.advanced = !0, this.misses = 0, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = void 0, this.m3u8 = "", this.version = null, this.canBlockReload = !1, this.canSkipUntil = 0, this.canSkipDateRanges = !1, this.skippedSegments = 0, this.recentlyRemovedDateranges = void 0, this.partHoldBack = 0, this.holdBack = 0, this.partTarget = 0, this.preloadHint = void 0, this.renditionReports = void 0, this.tuneInGoal = 0, this.deltaUpdateFailed = void 0, this.driftStartTime = 0, this.driftEndTime = 0, this.driftStart = 0, this.driftEnd = 0, this.encryptedFragments = void 0, this.playlistParsingError = null, this.variableList = null, this.hasVariableRefs = !1, this.appliedTimelineOffset = void 0, this.fragments = [], this.encryptedFragments = [], this.dateRanges = {}, this.url = e;
  }
  reloaded(e) {
    if (!e) {
      this.advanced = !0, this.updated = !0;
      return;
    }
    const t = this.lastPartSn - e.lastPartSn, r = this.lastPartIndex - e.lastPartIndex;
    this.updated = this.endSN !== e.endSN || !!r || !!t || !this.live, this.advanced = this.endSN > e.endSN || t > 0 || t === 0 && r > 0, this.updated || this.advanced ? this.misses = Math.floor(e.misses * 0.6) : this.misses = e.misses + 1;
  }
  get hasProgramDateTime() {
    return this.fragments.length ? ae(this.fragments[this.fragments.length - 1].programDateTime) : !1;
  }
  get levelTargetDuration() {
    return this.averagetargetduration || this.targetduration || tT;
  }
  get drift() {
    const e = this.driftEndTime - this.driftStartTime;
    return e > 0 ? (this.driftEnd - this.driftStart) * 1e3 / e : 1;
  }
  get edge() {
    return this.partEnd || this.fragmentEnd;
  }
  get partEnd() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].end : this.fragmentEnd;
  }
  get fragmentEnd() {
    var e;
    return (e = this.fragments) != null && e.length ? this.fragments[this.fragments.length - 1].end : 0;
  }
  get fragmentStart() {
    var e;
    return (e = this.fragments) != null && e.length ? this.fragments[0].start : 0;
  }
  get age() {
    return this.advancedDateTime ? Math.max(Date.now() - this.advancedDateTime, 0) / 1e3 : 0;
  }
  get lastPartIndex() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].index : -1;
  }
  get maxPartIndex() {
    const e = this.partList;
    if (e) {
      const t = this.lastPartIndex;
      if (t !== -1) {
        for (let r = e.length; r--; )
          if (e[r].index > t)
            return e[r].index;
        return t;
      }
    }
    return 0;
  }
  get lastPartSn() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].fragment.sn : this.endSN;
  }
  get expired() {
    if (this.live && this.age && this.misses < 3) {
      const e = this.partEnd - this.fragmentStart;
      return this.age > Math.max(e, this.totalduration) + this.levelTargetDuration;
    }
    return !1;
  }
}
function Gs(n) {
  return n === "AES-128" || n === "AES-256" || n === "AES-256-CTR";
}
function Uu(n) {
  switch (n) {
    case "AES-128":
    case "AES-256":
      return Xn.cbc;
    case "AES-256-CTR":
      return Xn.ctr;
    default:
      throw new Error(`invalid full segment method ${n}`);
  }
}
function $u(n) {
  return Uint8Array.from(atob(n), (e) => e.charCodeAt(0));
}
function Ic(n) {
  return Uint8Array.from(unescape(encodeURIComponent(n)), (e) => e.charCodeAt(0));
}
function nT(n) {
  const e = Ic(n).subarray(0, 16), t = new Uint8Array(16);
  return t.set(e, 16 - e.length), t;
}
function sT(n) {
  const e = function(r, s, i) {
    const o = r[s];
    r[s] = r[i], r[i] = o;
  };
  e(n, 0, 3), e(n, 1, 2), e(n, 4, 5), e(n, 6, 7);
}
function iT(n) {
  const e = n.split(":");
  let t = null;
  if (e[0] === "data" && e.length === 2) {
    const r = e[1].split(";"), s = r[r.length - 1].split(",");
    if (s.length === 2) {
      const i = s[0] === "base64", o = s[1];
      i ? (r.splice(-1, 1), t = $u(o)) : t = nT(o);
    }
  }
  return t;
}
const Ea = typeof self < "u" ? self : void 0;
var nt = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.fps",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "com.widevine.alpha"
}, vr = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.streamingkeydelivery",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function ko(n) {
  switch (n) {
    case vr.FAIRPLAY:
      return nt.FAIRPLAY;
    case vr.PLAYREADY:
      return nt.PLAYREADY;
    case vr.WIDEVINE:
      return nt.WIDEVINE;
    case vr.CLEARKEY:
      return nt.CLEARKEY;
  }
}
var ho = {
  CENC: "1077efecc0b24d02ace33c1e52e2fb4b",
  CLEARKEY: "e2719d58a985b3c9781ab030af78d30e",
  PLAYREADY: "9a04f07998404286ab92e65be0885f95",
  WIDEVINE: "edef8ba979d64acea3c827dcd51d21ed"
};
function Rl(n) {
  if (n === ho.WIDEVINE)
    return nt.WIDEVINE;
  if (n === ho.PLAYREADY)
    return nt.PLAYREADY;
  if (n === ho.CENC || n === ho.CLEARKEY)
    return nt.CLEARKEY;
}
function fo(n) {
  switch (n) {
    case nt.FAIRPLAY:
      return vr.FAIRPLAY;
    case nt.PLAYREADY:
      return vr.PLAYREADY;
    case nt.WIDEVINE:
      return vr.WIDEVINE;
    case nt.CLEARKEY:
      return vr.CLEARKEY;
  }
}
function di(n) {
  const {
    drmSystems: e,
    widevineLicenseUrl: t
  } = n, r = e ? [nt.FAIRPLAY, nt.WIDEVINE, nt.PLAYREADY, nt.CLEARKEY].filter((s) => !!e[s]) : [];
  return !r[nt.WIDEVINE] && t && r.push(nt.WIDEVINE), r;
}
const dp = function(n) {
  return Ea != null && (n = Ea.navigator) != null && n.requestMediaKeySystemAccess ? self.navigator.requestMediaKeySystemAccess.bind(self.navigator) : null;
}();
function oT(n, e, t, r) {
  let s;
  switch (n) {
    case nt.FAIRPLAY:
      s = ["cenc", "sinf"];
      break;
    case nt.WIDEVINE:
    case nt.PLAYREADY:
      s = ["cenc"];
      break;
    case nt.CLEARKEY:
      s = ["cenc", "keyids"];
      break;
    default:
      throw new Error(`Unknown key-system: ${n}`);
  }
  return aT(s, e, t, r);
}
function aT(n, e, t, r) {
  return [{
    initDataTypes: n,
    persistentState: r.persistentState || "optional",
    distinctiveIdentifier: r.distinctiveIdentifier || "optional",
    sessionTypes: r.sessionTypes || [r.sessionType || "temporary"],
    audioCapabilities: e.map((i) => ({
      contentType: `audio/mp4; codecs=${i}`,
      robustness: r.audioRobustness || "",
      encryptionScheme: r.audioEncryptionScheme || null
    })),
    videoCapabilities: t.map((i) => ({
      contentType: `video/mp4; codecs=${i}`,
      robustness: r.videoRobustness || "",
      encryptionScheme: r.videoEncryptionScheme || null
    }))
  }];
}
function lT(n) {
  var e;
  return n.sessionType === "persistent-license" || !!((e = n.sessionTypes) != null && e.some((t) => t === "persistent-license"));
}
function hp(n) {
  const e = new Uint16Array(n.buffer, n.byteOffset, n.byteLength / 2), t = String.fromCharCode.apply(null, Array.from(e)), r = t.substring(t.indexOf("<"), t.length), o = new DOMParser().parseFromString(r, "text/xml").getElementsByTagName("KID")[0];
  if (o) {
    const a = o.childNodes[0] ? o.childNodes[0].nodeValue : o.getAttribute("VALUE");
    if (a) {
      const l = $u(a).subarray(0, 16);
      return sT(l), l;
    }
  }
  return null;
}
let go = {};
class Ni {
  static clearKeyUriToKeyIdMap() {
    go = {};
  }
  constructor(e, t, r, s = [1], i = null) {
    this.uri = void 0, this.method = void 0, this.keyFormat = void 0, this.keyFormatVersions = void 0, this.encrypted = void 0, this.isCommonEncryption = void 0, this.iv = null, this.key = null, this.keyId = null, this.pssh = null, this.method = e, this.uri = t, this.keyFormat = r, this.keyFormatVersions = s, this.iv = i, this.encrypted = e ? e !== "NONE" : !1, this.isCommonEncryption = this.encrypted && !Gs(e);
  }
  isSupported() {
    if (this.method) {
      if (Gs(this.method) || this.method === "NONE")
        return !0;
      if (this.keyFormat === "identity")
        return this.method === "SAMPLE-AES";
      switch (this.keyFormat) {
        case vr.FAIRPLAY:
        case vr.WIDEVINE:
        case vr.PLAYREADY:
        case vr.CLEARKEY:
          return ["ISO-23001-7", "SAMPLE-AES", "SAMPLE-AES-CENC", "SAMPLE-AES-CTR"].indexOf(this.method) !== -1;
      }
    }
    return !1;
  }
  getDecryptData(e) {
    if (!this.encrypted || !this.uri)
      return null;
    if (Gs(this.method) && this.uri && !this.iv) {
      typeof e != "number" && (Ze.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`), e = 0);
      const r = cT(e);
      return new Ni(this.method, this.uri, "identity", this.keyFormatVersions, r);
    }
    const t = iT(this.uri);
    if (t)
      switch (this.keyFormat) {
        case vr.WIDEVINE:
          this.pssh = t, t.length >= 22 && (this.keyId = t.subarray(t.length - 22, t.length - 6));
          break;
        case vr.PLAYREADY: {
          const r = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]);
          this.pssh = pb(r, null, t), this.keyId = hp(t);
          break;
        }
        default: {
          let r = t.subarray(0, 16);
          if (r.length !== 16) {
            const s = new Uint8Array(16);
            s.set(r, 16 - r.length), r = s;
          }
          this.keyId = r;
          break;
        }
      }
    if (!this.keyId || this.keyId.byteLength !== 16) {
      let r = go[this.uri];
      if (!r) {
        const s = Object.keys(go).length % Number.MAX_SAFE_INTEGER;
        r = new Uint8Array(16), new DataView(r.buffer, 12, 4).setUint32(0, s), go[this.uri] = r;
      }
      this.keyId = r;
    }
    return this;
  }
}
function cT(n) {
  const e = new Uint8Array(16);
  for (let t = 12; t < 16; t++)
    e[t] = n >> 8 * (15 - t) & 255;
  return e;
}
const wh = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g, Ah = /#EXT-X-MEDIA:(.*)/g, uT = /^#EXT(?:INF|-X-TARGETDURATION):/m, Cl = new RegExp([
  /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
  // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
  /(?!#) *(\S[^\r\n]*)/.source,
  // segment URI, group 3 => the URI (note newline is not eaten)
  /#.*/.source
  // All other non-segment oriented tags will match with all groups empty
].join("|"), "g"), dT = new RegExp([/#EXT-X-(PROGRAM-DATE-TIME|BYTERANGE|DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join("|"));
class on {
  static findGroup(e, t) {
    for (let r = 0; r < e.length; r++) {
      const s = e[r];
      if (s.id === t)
        return s;
    }
  }
  static resolve(e, t) {
    return Pu.buildAbsoluteURL(t, e, {
      alwaysNormalize: !0
    });
  }
  static isMediaPlaylist(e) {
    return uT.test(e);
  }
  static parseMasterPlaylist(e, t) {
    const r = Sh(e), s = {
      contentSteering: null,
      levels: [],
      playlistParsingError: null,
      sessionData: null,
      sessionKeys: null,
      startTimeOffset: null,
      variableList: null,
      hasVariableRefs: r
    }, i = [];
    wh.lastIndex = 0;
    let o;
    for (; (o = wh.exec(e)) != null; )
      if (o[1]) {
        var a;
        const c = new yt(o[1], s), u = Ac(s, o[2]), d = {
          attrs: c,
          bitrate: c.decimalInteger("BANDWIDTH") || c.decimalInteger("AVERAGE-BANDWIDTH"),
          name: c.NAME,
          url: on.resolve(u, t)
        }, h = c.decimalResolution("RESOLUTION");
        h && (d.width = h.width, d.height = h.height), Lh(c.CODECS, d);
        const f = c["SUPPLEMENTAL-CODECS"];
        f && (d.supplemental = {}, Lh(f, d.supplemental)), (a = d.unknownCodecs) != null && a.length || i.push(d), s.levels.push(d);
      } else if (o[3]) {
        const c = o[3], u = o[4];
        switch (c) {
          case "SESSION-DATA": {
            const d = new yt(u, s), h = d["DATA-ID"];
            h && (s.sessionData === null && (s.sessionData = {}), s.sessionData[h] = d);
            break;
          }
          case "SESSION-KEY": {
            const d = Ih(u, t, s);
            d.encrypted && d.isSupported() ? (s.sessionKeys === null && (s.sessionKeys = []), s.sessionKeys.push(d)) : Ze.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${u}"`);
            break;
          }
          case "DEFINE": {
            {
              const d = new yt(u, s);
              bh(s, d, t);
            }
            break;
          }
          case "CONTENT-STEERING": {
            const d = new yt(u, s);
            s.contentSteering = {
              uri: on.resolve(d["SERVER-URI"], t),
              pathwayId: d["PATHWAY-ID"] || "."
            };
            break;
          }
          case "START": {
            s.startTimeOffset = _h(u);
            break;
          }
        }
      }
    const l = i.length > 0 && i.length < s.levels.length;
    return s.levels = l ? i : s.levels, s.levels.length === 0 && (s.playlistParsingError = new Error("no levels found in manifest")), s;
  }
  static parseMasterPlaylistMedia(e, t, r) {
    let s;
    const i = {}, o = r.levels, a = {
      AUDIO: o.map((c) => ({
        id: c.attrs.AUDIO,
        audioCodec: c.audioCodec
      })),
      SUBTITLES: o.map((c) => ({
        id: c.attrs.SUBTITLES,
        textCodec: c.textCodec
      })),
      "CLOSED-CAPTIONS": []
    };
    let l = 0;
    for (Ah.lastIndex = 0; (s = Ah.exec(e)) !== null; ) {
      const c = new yt(s[1], r), u = c.TYPE;
      if (u) {
        const d = a[u], h = i[u] || [];
        i[u] = h;
        const f = c.LANGUAGE, p = c["ASSOC-LANGUAGE"], y = c.CHANNELS, m = c.CHARACTERISTICS, b = c["INSTREAM-ID"], C = {
          attrs: c,
          bitrate: 0,
          id: l++,
          groupId: c["GROUP-ID"] || "",
          name: c.NAME || f || "",
          type: u,
          default: c.bool("DEFAULT"),
          autoselect: c.bool("AUTOSELECT"),
          forced: c.bool("FORCED"),
          lang: f,
          url: c.URI ? on.resolve(c.URI, t) : ""
        };
        if (p && (C.assocLang = p), y && (C.channels = y), m && (C.characteristics = m), b && (C.instreamId = b), d != null && d.length) {
          const A = on.findGroup(d, C.groupId) || d[0];
          Rh(C, A, "audioCodec"), Rh(C, A, "textCodec");
        }
        h.push(C);
      }
    }
    return i;
  }
  static parseLevelPlaylist(e, t, r, s, i, o) {
    var a;
    const l = {
      url: t
    }, c = new rT(t), u = c.fragments, d = [];
    let h = null, f = 0, p = 0, y = 0, m = 0, b = 0, C = null, A = new Al(s, l), P, I, U, j = -1, G = !1, F = null, B;
    if (Cl.lastIndex = 0, c.m3u8 = e, c.hasVariableRefs = Sh(e), ((a = Cl.exec(e)) == null ? void 0 : a[0]) !== "#EXTM3U")
      return c.playlistParsingError = new Error("Missing format identifier #EXTM3U"), c;
    for (; (P = Cl.exec(e)) !== null; ) {
      G && (G = !1, A = new Al(s, l), A.playlistOffset = y, A.start = y, A.sn = f, A.cc = m, b && (A.bitrate = b), A.level = r, h && (A.initSegment = h, h.rawProgramDateTime && (A.rawProgramDateTime = h.rawProgramDateTime, h.rawProgramDateTime = null), F && (A.setByteRange(F), F = null)));
      const g = P[1];
      if (g) {
        A.duration = parseFloat(g);
        const x = (" " + P[2]).slice(1);
        A.title = x || null, A.tagList.push(x ? ["INF", g, x] : ["INF", g]);
      } else if (P[3]) {
        if (ae(A.duration)) {
          A.playlistOffset = y, A.start = y, U && kh(A, U, c), A.sn = f, A.level = r, A.cc = m, u.push(A);
          const x = (" " + P[3]).slice(1);
          A.relurl = Ac(c, x), _c(A, C, d), C = A, y += A.duration, f++, p = 0, G = !0;
        }
      } else {
        if (P = P[0].match(dT), !P) {
          Ze.warn("No matches on slow regex match for level playlist!");
          continue;
        }
        for (I = 1; I < P.length && P[I] === void 0; I++)
          ;
        const x = (" " + P[I]).slice(1), w = (" " + P[I + 1]).slice(1), _ = P[I + 2] ? (" " + P[I + 2]).slice(1) : null;
        switch (x) {
          case "BYTERANGE":
            C ? A.setByteRange(w, C) : A.setByteRange(w);
            break;
          case "PROGRAM-DATE-TIME":
            A.rawProgramDateTime = w, A.tagList.push(["PROGRAM-DATE-TIME", w]), j === -1 && (j = u.length);
            break;
          case "PLAYLIST-TYPE":
            c.type && yn(c, x, P), c.type = w.toUpperCase();
            break;
          case "MEDIA-SEQUENCE":
            c.startSN !== 0 ? yn(c, x, P) : u.length > 0 && Dh(c, x, P), f = c.startSN = parseInt(w);
            break;
          case "SKIP": {
            c.skippedSegments && yn(c, x, P);
            const D = new yt(w, c), O = D.decimalInteger("SKIPPED-SEGMENTS");
            if (ae(O)) {
              c.skippedSegments += O;
              for (let R = O; R--; )
                u.push(null);
              f += O;
            }
            const N = D.enumeratedString("RECENTLY-REMOVED-DATERANGES");
            N && (c.recentlyRemovedDateranges = (c.recentlyRemovedDateranges || []).concat(N.split("	")));
            break;
          }
          case "TARGETDURATION":
            c.targetduration !== 0 && yn(c, x, P), c.targetduration = Math.max(parseInt(w), 1);
            break;
          case "VERSION":
            c.version !== null && yn(c, x, P), c.version = parseInt(w);
            break;
          case "INDEPENDENT-SEGMENTS":
            break;
          case "ENDLIST":
            c.live || yn(c, x, P), c.live = !1;
            break;
          case "#":
            (w || _) && A.tagList.push(_ ? [w, _] : [w]);
            break;
          case "DISCONTINUITY":
            m++, A.tagList.push(["DIS"]);
            break;
          case "GAP":
            A.gap = !0, A.tagList.push([x]);
            break;
          case "BITRATE":
            A.tagList.push([x, w]), b = parseInt(w) * 1e3, ae(b) ? A.bitrate = b : b = 0;
            break;
          case "DATERANGE": {
            const D = new yt(w, c), O = new up(D, c.dateRanges[D.ID], c.dateRangeTagCount);
            c.dateRangeTagCount++, O.isValid || c.skippedSegments ? c.dateRanges[O.id] = O : Ze.warn(`Ignoring invalid DATERANGE tag: "${w}"`), A.tagList.push(["EXT-X-DATERANGE", w]);
            break;
          }
          case "DEFINE": {
            {
              const D = new yt(w, c);
              "IMPORT" in D ? Zb(c, D, o) : bh(c, D, t);
            }
            break;
          }
          case "DISCONTINUITY-SEQUENCE":
            c.startCC !== 0 ? yn(c, x, P) : u.length > 0 && Dh(c, x, P), c.startCC = m = parseInt(w);
            break;
          case "KEY": {
            const D = Ih(w, t, c);
            if (D.isSupported()) {
              if (D.method === "NONE") {
                U = void 0;
                break;
              }
              U || (U = {}), U[D.keyFormat] && (U = st({}, U)), U[D.keyFormat] = D;
            } else
              Ze.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${w}"`);
            break;
          }
          case "START":
            c.startTimeOffset = _h(w);
            break;
          case "MAP": {
            const D = new yt(w, c);
            if (A.duration) {
              const O = new Al(s, l);
              Ch(O, D, r, U), h = O, A.initSegment = h, h.rawProgramDateTime && !A.rawProgramDateTime && (A.rawProgramDateTime = h.rawProgramDateTime);
            } else {
              const O = A.byteRangeEndOffset;
              if (O) {
                const N = A.byteRangeStartOffset;
                F = `${O - N}@${N}`;
              } else
                F = null;
              Ch(A, D, r, U), h = A, G = !0;
            }
            h.cc = m;
            break;
          }
          case "SERVER-CONTROL": {
            B && yn(c, x, P), B = new yt(w), c.canBlockReload = B.bool("CAN-BLOCK-RELOAD"), c.canSkipUntil = B.optionalFloat("CAN-SKIP-UNTIL", 0), c.canSkipDateRanges = c.canSkipUntil > 0 && B.bool("CAN-SKIP-DATERANGES"), c.partHoldBack = B.optionalFloat("PART-HOLD-BACK", 0), c.holdBack = B.optionalFloat("HOLD-BACK", 0);
            break;
          }
          case "PART-INF": {
            c.partTarget && yn(c, x, P);
            const D = new yt(w);
            c.partTarget = D.decimalFloatingPoint("PART-TARGET");
            break;
          }
          case "PART": {
            let D = c.partList;
            D || (D = c.partList = []);
            const O = p > 0 ? D[D.length - 1] : void 0, N = p++, R = new yt(w, c), v = new tb(R, A, l, N, O);
            D.push(v), A.duration += v.duration;
            break;
          }
          case "PRELOAD-HINT": {
            const D = new yt(w, c);
            c.preloadHint = D;
            break;
          }
          case "RENDITION-REPORT": {
            const D = new yt(w, c);
            c.renditionReports = c.renditionReports || [], c.renditionReports.push(D);
            break;
          }
          default:
            Ze.warn(`line parsed but not handled: ${P}`);
            break;
        }
      }
    }
    C && !C.relurl ? (u.pop(), y -= C.duration, c.partList && (c.fragmentHint = C)) : c.partList && (_c(A, C, d), A.cc = m, c.fragmentHint = A, U && kh(A, U, c)), c.targetduration || (c.playlistParsingError = new Error("#EXT-X-TARGETDURATION is required"));
    const V = u.length, H = u[0], L = u[V - 1];
    if (y += c.skippedSegments * c.targetduration, y > 0 && V && L) {
      c.averagetargetduration = y / V;
      const g = L.sn;
      c.endSN = g !== "initSegment" ? g : 0, c.live || (L.endList = !0), H && c.startCC === void 0 && (c.startCC = H.cc), j > 0 && (fT(u, j), H && d.unshift(H));
    } else
      c.endSN = 0, c.startCC = 0;
    return c.fragmentHint && (y += c.fragmentHint.duration), c.totalduration = y, d.length && c.dateRangeTagCount && H && fp(d, c), c.endCC = m, c;
  }
}
function fp(n, e) {
  const t = n.length;
  if (!t)
    return;
  const r = n[t - 1], s = e.live ? 1 / 0 : e.totalduration, i = Object.keys(e.dateRanges);
  for (let o = i.length; o--; ) {
    const a = e.dateRanges[i[o]], l = a.startDate.getTime();
    a.tagAnchor = r.ref;
    for (let c = t; c--; ) {
      const u = hT(e, l, n, c, s);
      if (u !== -1) {
        a.tagAnchor = e.fragments[u].ref;
        break;
      }
    }
  }
}
function hT(n, e, t, r, s) {
  const i = t[r];
  if (i) {
    const a = i.programDateTime;
    if (e >= a || r === 0) {
      var o;
      const l = (((o = t[r + 1]) == null ? void 0 : o.start) || s) - i.start;
      if (e <= a + l * 1e3) {
        const c = t[r].sn - n.startSN, u = n.fragments;
        if (u.length > t.length) {
          const h = (t[r + 1] || u[u.length - 1]).sn - n.startSN;
          for (let f = h; f > c; f--) {
            const p = u[f].programDateTime;
            if (e >= p && e < p + u[f].duration * 1e3)
              return f;
          }
        }
        return c;
      }
    }
  }
  return -1;
}
function Ih(n, e, t) {
  var r, s;
  const i = new yt(n, t), o = (r = i.METHOD) != null ? r : "", a = i.URI, l = i.hexadecimalInteger("IV"), c = i.KEYFORMATVERSIONS, u = (s = i.KEYFORMAT) != null ? s : "identity";
  a && i.IV && !l && Ze.error(`Invalid IV: ${i.IV}`);
  const d = a ? on.resolve(a, e) : "", h = (c || "1").split("/").map(Number).filter(Number.isFinite);
  return new Ni(o, d, u, h, l);
}
function _h(n) {
  const t = new yt(n).decimalFloatingPoint("TIME-OFFSET");
  return ae(t) ? t : null;
}
function Lh(n, e) {
  let t = (n || "").split(/[ ,]+/).filter((r) => r);
  ["video", "audio", "text"].forEach((r) => {
    const s = t.filter((i) => Qg(i, r));
    s.length && (e[`${r}Codec`] = s.map((i) => i.split("/")[0]).join(","), t = t.filter((i) => s.indexOf(i) === -1));
  }), e.unknownCodecs = t;
}
function Rh(n, e, t) {
  const r = e[t];
  r && (n[t] = r);
}
function fT(n, e) {
  let t = n[e];
  for (let r = e; r--; ) {
    const s = n[r];
    if (!s)
      return;
    s.programDateTime = t.programDateTime - s.duration * 1e3, t = s;
  }
}
function _c(n, e, t) {
  n.rawProgramDateTime ? t.push(n) : e != null && e.programDateTime && (n.programDateTime = e.endProgramDateTime);
}
function Ch(n, e, t, r) {
  n.relurl = e.URI, e.BYTERANGE && n.setByteRange(e.BYTERANGE), n.level = t, n.sn = "initSegment", r && (n.levelkeys = r), n.initSegment = null;
}
function kh(n, e, t) {
  n.levelkeys = e;
  const {
    encryptedFragments: r
  } = t;
  (!r.length || r[r.length - 1].levelkeys !== e) && Object.keys(e).some((s) => e[s].isCommonEncryption) && r.push(n);
}
function yn(n, e, t) {
  n.playlistParsingError = new Error(`#EXT-X-${e} must not appear more than once (${t[0]})`);
}
function Dh(n, e, t) {
  n.playlistParsingError = new Error(`#EXT-X-${e} must appear before the first Media Segment (${t[0]})`);
}
function kl(n, e) {
  const t = e.startPTS;
  if (ae(t)) {
    let r = 0, s;
    e.sn > n.sn ? (r = t - n.start, s = n) : (r = n.start - t, s = e), s.duration !== r && s.setDuration(r);
  } else e.sn > n.sn ? n.cc === e.cc && n.minEndPTS ? e.setStart(n.start + (n.minEndPTS - n.start)) : e.setStart(n.start + n.duration) : e.setStart(Math.max(n.start - e.duration, 0));
}
function gp(n, e, t, r, s, i) {
  r - t <= 0 && (Ze.warn("Fragment should have a positive duration", e), r = t + e.duration, i = s + e.duration);
  let a = t, l = r;
  const c = e.startPTS, u = e.endPTS;
  if (ae(c)) {
    const m = Math.abs(c - t);
    ae(e.deltaPTS) ? e.deltaPTS = Math.max(m, e.deltaPTS) : e.deltaPTS = m, a = Math.max(t, c), t = Math.min(t, c), s = Math.min(s, e.startDTS), l = Math.min(r, u), r = Math.max(r, u), i = Math.max(i, e.endDTS);
  }
  const d = t - e.start;
  e.start !== 0 && e.setStart(t), e.setDuration(r - e.start), e.startPTS = t, e.maxStartPTS = a, e.startDTS = s, e.endPTS = r, e.minEndPTS = l, e.endDTS = i;
  const h = e.sn;
  if (!n || h < n.startSN || h > n.endSN)
    return 0;
  let f;
  const p = h - n.startSN, y = n.fragments;
  for (y[p] = e, f = p; f > 0; f--)
    kl(y[f], y[f - 1]);
  for (f = p; f < y.length - 1; f++)
    kl(y[f], y[f + 1]);
  return n.fragmentHint && kl(y[y.length - 1], n.fragmentHint), n.PTSKnown = n.alignedSliding = !0, d;
}
function gT(n, e) {
  if (n === e)
    return;
  let t = null;
  const r = n.fragments;
  for (let c = r.length - 1; c >= 0; c--) {
    const u = r[c].initSegment;
    if (u) {
      t = u;
      break;
    }
  }
  n.fragmentHint && delete n.fragmentHint.endPTS;
  let s;
  yT(n, e, (c, u, d, h) => {
    if ((!e.startCC || e.skippedSegments) && u.cc !== c.cc) {
      const f = c.cc - u.cc;
      for (let p = d; p < h.length; p++)
        h[p].cc += f;
      e.endCC = h[h.length - 1].cc;
    }
    ae(c.startPTS) && ae(c.endPTS) && (u.setStart(u.startPTS = c.startPTS), u.startDTS = c.startDTS, u.maxStartPTS = c.maxStartPTS, u.endPTS = c.endPTS, u.endDTS = c.endDTS, u.minEndPTS = c.minEndPTS, u.setDuration(c.endPTS - c.startPTS), u.duration && (s = u), e.PTSKnown = e.alignedSliding = !0), c.hasStreams && (u.elementaryStreams = c.elementaryStreams), u.loader = c.loader, c.hasStats && (u.stats = c.stats), c.initSegment && (u.initSegment = c.initSegment, t = c.initSegment);
  });
  const i = e.fragments, o = e.fragmentHint ? i.concat(e.fragmentHint) : i;
  if (t && o.forEach((c) => {
    var u;
    c && (!c.initSegment || c.initSegment.relurl === ((u = t) == null ? void 0 : u.relurl)) && (c.initSegment = t);
  }), e.skippedSegments) {
    if (e.deltaUpdateFailed = i.some((c) => !c), e.deltaUpdateFailed) {
      Ze.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
      for (let c = e.skippedSegments; c--; )
        i.shift();
      e.startSN = i[0].sn;
    } else {
      e.canSkipDateRanges && (e.dateRanges = pT(n.dateRanges, e));
      const c = n.fragments.filter((u) => u.rawProgramDateTime);
      if (n.hasProgramDateTime && !e.hasProgramDateTime)
        for (let u = 1; u < o.length; u++)
          o[u].programDateTime === null && _c(o[u], o[u - 1], c);
      fp(c, e);
    }
    e.endCC = i[i.length - 1].cc;
  }
  if (!e.startCC) {
    var a;
    const c = yp(n, e.startSN - 1);
    e.startCC = (a = c == null ? void 0 : c.cc) != null ? a : i[0].cc;
  }
  mT(n.partList, e.partList, (c, u) => {
    u.elementaryStreams = c.elementaryStreams, u.stats = c.stats;
  }), s ? gp(e, s, s.startPTS, s.endPTS, s.startDTS, s.endDTS) : pp(n, e), i.length && (e.totalduration = e.edge - i[0].start), e.driftStartTime = n.driftStartTime, e.driftStart = n.driftStart;
  const l = e.advancedDateTime;
  if (e.advanced && l) {
    const c = e.edge;
    e.driftStart || (e.driftStartTime = l, e.driftStart = c), e.driftEndTime = l, e.driftEnd = c;
  } else
    e.driftEndTime = n.driftEndTime, e.driftEnd = n.driftEnd, e.advancedDateTime = n.advancedDateTime;
  e.requestScheduled === -1 && (e.requestScheduled = n.requestScheduled);
}
function pT(n, e) {
  const {
    dateRanges: t,
    recentlyRemovedDateranges: r
  } = e, s = st({}, n);
  r && r.forEach((a) => {
    delete s[a];
  });
  const o = Object.keys(s).length;
  return o && Object.keys(t).forEach((a) => {
    const l = s[a], c = new up(t[a].attr, l);
    c.isValid ? (s[a] = c, l || (c.tagOrder += o)) : Ze.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${mt(t[a].attr)}"`);
  }), s;
}
function mT(n, e, t) {
  if (n && e) {
    let r = 0;
    for (let s = 0, i = n.length; s <= i; s++) {
      const o = n[s], a = e[s + r];
      o && a && o.index === a.index && o.fragment.sn === a.fragment.sn ? t(o, a) : r--;
    }
  }
}
function yT(n, e, t) {
  const r = e.skippedSegments, s = Math.max(n.startSN, e.startSN) - e.startSN, i = (n.fragmentHint ? 1 : 0) + (r ? e.endSN : Math.min(n.endSN, e.endSN)) - e.startSN, o = e.startSN - n.startSN, a = e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments, l = n.fragmentHint ? n.fragments.concat(n.fragmentHint) : n.fragments;
  for (let c = s; c <= i; c++) {
    const u = l[o + c];
    let d = a[c];
    if (r && !d && u && (d = e.fragments[c] = u), u && d) {
      if (t(u, d, c, a), u.url && u.url !== d.url) {
        e.playlistParsingError = Ph(`media sequence mismatch ${d.sn}:`, n, e, u, d);
        return;
      } else if (u.cc !== d.cc) {
        e.playlistParsingError = Ph(`discontinuity sequence mismatch (${u.cc}!=${d.cc})`, n, e, u, d);
        return;
      }
    }
  }
}
function Ph(n, e, t, r, s) {
  return new Error(`${n} ${s.url}
Playlist starting @${e.startSN}
${e.m3u8}

Playlist starting @${t.startSN}
${t.m3u8}`);
}
function pp(n, e, t = !0) {
  const r = e.startSN + e.skippedSegments - n.startSN, s = n.fragments, i = r >= 0;
  let o = 0;
  if (i && r < s.length)
    o = s[r].start;
  else if (i && e.startSN === n.endSN + 1)
    o = n.fragmentEnd;
  else if (i && t)
    o = n.fragmentStart + r * e.levelTargetDuration;
  else if (!e.skippedSegments && e.fragmentStart === 0)
    o = n.fragmentStart;
  else
    return;
  Lc(e, o);
}
function Lc(n, e) {
  if (e) {
    const t = n.fragments;
    for (let r = n.skippedSegments; r < t.length; r++)
      t[r].addStart(e);
    n.fragmentHint && n.fragmentHint.addStart(e);
  }
}
function mp(n, e = 1 / 0) {
  let t = 1e3 * n.targetduration;
  if (n.updated) {
    const r = n.fragments;
    if (r.length && t * 4 > e) {
      const i = r[r.length - 1].duration * 1e3;
      i < t && (t = i);
    }
  } else
    t /= 2;
  return Math.round(t);
}
function yp(n, e, t) {
  if (!n)
    return null;
  let r = n.fragments[e - n.startSN];
  return r || (r = n.fragmentHint, r && r.sn === e) ? r : e < n.startSN && t && t.sn === e ? t : null;
}
function Mh(n, e, t) {
  return n ? vp(n.partList, e, t) : null;
}
function vp(n, e, t) {
  if (n)
    for (let r = n.length; r--; ) {
      const s = n[r];
      if (s.index === t && s.fragment.sn === e)
        return s;
    }
  return null;
}
function xp(n) {
  n.forEach((e, t) => {
    var r;
    (r = e.details) == null || r.fragments.forEach((s) => {
      s.level = t, s.initSegment && (s.initSegment.level = t);
    });
  });
}
function mi(n, e) {
  for (let r = 0, s = n.length; r < s; r++) {
    var t;
    if (((t = n[r]) == null ? void 0 : t.cc) === e)
      return n[r];
  }
  return null;
}
function vT(n, e) {
  return !!(n && e.startCC < n.endCC && e.endCC > n.startCC);
}
function Oh(n, e) {
  if (n) {
    const t = n.start + e;
    n.start = n.startPTS = t, n.endPTS = t + n.duration;
  }
}
function Ep(n, e) {
  const t = e.fragments;
  for (let r = 0, s = t.length; r < s; r++)
    Oh(t[r], n);
  e.fragmentHint && Oh(e.fragmentHint, n), e.alignedSliding = !0;
}
function xT(n, e) {
  n && (Sp(e, n), !e.alignedSliding && n && Sa(e, n), !e.alignedSliding && n && !e.skippedSegments && pp(n, e, !1));
}
function Sp(n, e) {
  if (!vT(e, n))
    return;
  const t = Math.min(e.endCC, n.endCC), r = mi(e.fragments, t), s = mi(n.fragments, t);
  if (!r || !s)
    return;
  Ze.log(`Aligning playlist at start of dicontinuity sequence ${t}`);
  const i = r.start - s.start;
  Ep(i, n);
}
function Sa(n, e) {
  if (!n.hasProgramDateTime || !e.hasProgramDateTime)
    return;
  const t = n.fragments, r = e.fragments;
  if (!t.length || !r.length)
    return;
  let s, i;
  const o = Math.min(e.endCC, n.endCC);
  e.startCC < o && n.startCC < o && (s = mi(r, o), i = mi(t, o)), (!s || !i) && (s = r[Math.floor(r.length / 2)], i = mi(t, s.cc) || t[Math.floor(t.length / 2)]);
  const a = s.programDateTime, l = i.programDateTime;
  if (!a || !l)
    return;
  const c = (l - a) / 1e3 - (i.start - s.start);
  Ep(c, n);
}
const ET = {
  toString: function(n) {
    let e = "";
    const t = n.length;
    for (let r = 0; r < t; r++)
      e += `[${n.start(r).toFixed(3)}-${n.end(r).toFixed(3)}]`;
    return e;
  }
}, Q = {
  STOPPED: "STOPPED",
  IDLE: "IDLE",
  KEY_LOADING: "KEY_LOADING",
  FRAG_LOADING: "FRAG_LOADING",
  FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
  WAITING_TRACK: "WAITING_TRACK",
  PARSING: "PARSING",
  PARSED: "PARSED",
  ENDED: "ENDED",
  ERROR: "ERROR",
  WAITING_INIT_PTS: "WAITING_INIT_PTS",
  WAITING_LEVEL: "WAITING_LEVEL"
};
class Gu extends lp {
  constructor(e, t, r, s, i) {
    super(s, e.logger), this.hls = void 0, this.fragPrevious = null, this.fragCurrent = null, this.fragmentTracker = void 0, this.transmuxer = null, this._state = Q.STOPPED, this.playlistType = void 0, this.media = null, this.mediaBuffer = null, this.config = void 0, this.bitrateTest = !1, this.lastCurrentTime = 0, this.nextLoadPosition = 0, this.startPosition = 0, this.startTimeOffset = null, this.retryDate = 0, this.levels = null, this.fragmentLoader = void 0, this.keyLoader = void 0, this.levelLastLoaded = null, this.startFragRequested = !1, this.decrypter = void 0, this.initPTS = [], this.buffering = !0, this.loadingParts = !1, this.loopSn = void 0, this.onMediaSeeking = () => {
      const {
        config: o,
        fragCurrent: a,
        media: l,
        mediaBuffer: c,
        state: u
      } = this, d = l ? l.currentTime : 0, h = Le.bufferInfo(c || l, d, o.maxBufferHole);
      if (this.log(`media seeking to ${ae(d) ? d.toFixed(3) : d}, state: ${u}`), this.state === Q.ENDED)
        this.resetLoadingState();
      else if (a) {
        const f = o.maxFragLookUpTolerance, p = a.start - f, y = a.start + a.duration + f;
        if (!h.len || y < h.start || p > h.end) {
          const m = d > y;
          (d < p || m) && (m && a.loader && (this.log("seeking outside of buffer while fragment load in progress, cancel fragment load"), a.abortRequests(), this.resetLoadingState()), this.fragPrevious = null);
        }
      }
      if (l) {
        this.fragmentTracker.removeFragmentsInRange(d, 1 / 0, this.playlistType, !0);
        const f = this.lastCurrentTime;
        if (d > f && (this.lastCurrentTime = d), !this.loadingParts) {
          const p = Math.max(h.end, d), y = this.shouldLoadParts(this.getLevelDetails(), p);
          y && (this.log(`LL-Part loading ON after seeking to ${d.toFixed(2)} with buffer @${p.toFixed(2)}`), this.loadingParts = y);
        }
      }
      !this.hls.hasEnoughToStart && !h.len && (this.log(`setting startPosition to ${d} because of seek before start`), this.nextLoadPosition = this.startPosition = d), this.tickImmediate();
    }, this.onMediaEnded = () => {
      this.log("setting startPosition to 0 because media ended"), this.startPosition = this.lastCurrentTime = 0;
    }, this.playlistType = i, this.hls = e, this.fragmentLoader = new zb(e.config), this.keyLoader = r, this.fragmentTracker = t, this.config = e.config, this.decrypter = new Fu(e.config);
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(T.ERROR, this.onError, this);
  }
  doTick() {
    this.onTickEnd();
  }
  onTickEnd() {
  }
  startLoad(e) {
  }
  stopLoad() {
    if (this.state === Q.STOPPED)
      return;
    this.fragmentLoader.abort(), this.keyLoader.abort(this.playlistType);
    const e = this.fragCurrent;
    e != null && e.loader && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.resetTransmuxer(), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = Q.STOPPED;
  }
  get startPositionValue() {
    const {
      nextLoadPosition: e,
      startPosition: t
    } = this;
    return t === -1 && e ? e : t;
  }
  get bufferingEnabled() {
    return this.buffering;
  }
  pauseBuffering() {
    this.buffering = !1;
  }
  resumeBuffering() {
    this.buffering = !0;
  }
  get inFlightFrag() {
    return {
      frag: this.fragCurrent,
      state: this.state
    };
  }
  _streamEnded(e, t) {
    if (t.live || !this.media)
      return !1;
    const r = e.end || 0, s = this.config.timelineOffset || 0;
    if (r <= s)
      return !1;
    const i = e.buffered;
    this.config.maxBufferHole && i && i.length > 1 && (e = Le.bufferedInfo(i, e.start, 0));
    const o = e.nextStart;
    if (o && o > s && o < t.edge || this.media.currentTime < e.start)
      return !1;
    const l = t.partList;
    if (l != null && l.length) {
      const u = l[l.length - 1];
      return Le.isBuffered(this.media, u.start + u.duration / 2);
    }
    const c = t.fragments[t.fragments.length - 1].type;
    return this.fragmentTracker.isEndListAppended(c);
  }
  getLevelDetails() {
    if (this.levels && this.levelLastLoaded !== null) {
      var e;
      return (e = this.levelLastLoaded) == null ? void 0 : e.details;
    }
  }
  get timelineOffset() {
    const e = this.config.timelineOffset;
    if (e) {
      var t;
      return ((t = this.getLevelDetails()) == null ? void 0 : t.appliedTimelineOffset) || e;
    }
    return 0;
  }
  onMediaAttached(e, t) {
    const r = this.media = this.mediaBuffer = t.media;
    r.removeEventListener("seeking", this.onMediaSeeking), r.removeEventListener("ended", this.onMediaEnded), r.addEventListener("seeking", this.onMediaSeeking), r.addEventListener("ended", this.onMediaEnded);
    const s = this.config;
    this.levels && s.autoStartLoad && this.state === Q.STOPPED && this.startLoad(s.startPosition);
  }
  onMediaDetaching(e, t) {
    const r = !!t.transferMedia, s = this.media;
    if (s !== null) {
      if (s.ended && (this.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), s.removeEventListener("seeking", this.onMediaSeeking), s.removeEventListener("ended", this.onMediaEnded), this.keyLoader && !r && this.keyLoader.detach(), this.media = this.mediaBuffer = null, this.loopSn = void 0, r) {
        this.resetLoadingState(), this.resetTransmuxer();
        return;
      }
      this.loadingParts = !1, this.fragmentTracker.removeAllFragments(), this.stopLoad();
    }
  }
  onManifestLoading() {
    this.initPTS = [], this.levels = this.levelLastLoaded = this.fragCurrent = null, this.lastCurrentTime = this.startPosition = 0, this.startFragRequested = !1;
  }
  onError(e, t) {
  }
  onManifestLoaded(e, t) {
    this.startTimeOffset = t.startTimeOffset;
  }
  onHandlerDestroying() {
    this.stopLoad(), this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null), super.onHandlerDestroying(), this.hls = this.onMediaSeeking = this.onMediaEnded = null;
  }
  onHandlerDestroyed() {
    this.state = Q.STOPPED, this.fragmentLoader && this.fragmentLoader.destroy(), this.keyLoader && this.keyLoader.destroy(), this.decrypter && this.decrypter.destroy(), this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null, super.onHandlerDestroyed();
  }
  loadFragment(e, t, r) {
    this.startFragRequested = !0, this._loadFragForPlayback(e, t, r);
  }
  _loadFragForPlayback(e, t, r) {
    const s = (i) => {
      const o = i.frag;
      if (this.fragContextChanged(o)) {
        this.warn(`${o.type} sn: ${o.sn}${i.part ? " part: " + i.part.index : ""} of ${this.fragInfo(o, !1, i.part)}) was dropped during download.`), this.fragmentTracker.removeFragment(o);
        return;
      }
      o.stats.chunkCount++, this._handleFragmentLoadProgress(i);
    };
    this._doFragLoad(e, t, r, s).then((i) => {
      if (!i)
        return;
      const o = this.state, a = i.frag;
      if (this.fragContextChanged(a)) {
        (o === Q.FRAG_LOADING || !this.fragCurrent && o === Q.PARSING) && (this.fragmentTracker.removeFragment(a), this.state = Q.IDLE);
        return;
      }
      "payload" in i && (this.log(`Loaded ${a.type} sn: ${a.sn} of ${this.playlistLabel()} ${a.level}`), this.hls.trigger(T.FRAG_LOADED, i)), this._handleFragmentLoadComplete(i);
    }).catch((i) => {
      this.state === Q.STOPPED || this.state === Q.ERROR || (this.warn(`Frag error: ${(i == null ? void 0 : i.message) || i}`), this.resetFragmentLoading(e));
    });
  }
  clearTrackerIfNeeded(e) {
    var t;
    const {
      fragmentTracker: r
    } = this;
    if (r.getState(e) === Ht.APPENDING) {
      const i = e.type, o = this.getFwdBufferInfo(this.mediaBuffer, i), a = Math.max(e.duration, o ? o.len : this.config.maxBufferLength), l = this.backtrackFragment;
      ((l ? e.sn - l.sn : 0) === 1 || this.reduceMaxBufferLength(a, e.duration)) && r.removeFragment(e);
    } else ((t = this.mediaBuffer) == null ? void 0 : t.buffered.length) === 0 ? r.removeAllFragments() : r.hasParts(e.type) && (r.detectPartialFragments({
      frag: e,
      part: null,
      stats: e.stats,
      id: e.type
    }), r.getState(e) === Ht.PARTIAL && r.removeFragment(e));
  }
  checkLiveUpdate(e) {
    if (e.updated && !e.live) {
      const t = e.fragments[e.fragments.length - 1];
      this.fragmentTracker.detectPartialFragments({
        frag: t,
        part: null,
        stats: t.stats,
        id: t.type
      });
    }
    e.fragments[0] || (e.deltaUpdateFailed = !0);
  }
  waitForLive(e) {
    const t = e.details;
    return (t == null ? void 0 : t.live) && t.type !== "EVENT" && (this.levelLastLoaded !== e || t.expired);
  }
  flushMainBuffer(e, t, r = null) {
    if (!(e - t))
      return;
    const s = {
      startOffset: e,
      endOffset: t,
      type: r
    };
    this.hls.trigger(T.BUFFER_FLUSHING, s);
  }
  _loadInitSegment(e, t) {
    this._doFragLoad(e, t).then((r) => {
      const s = r == null ? void 0 : r.frag;
      if (!s || this.fragContextChanged(s) || !this.levels)
        throw new Error("init load aborted");
      return r;
    }).then((r) => {
      const {
        hls: s
      } = this, {
        frag: i,
        payload: o
      } = r, a = i.decryptdata;
      if (o && o.byteLength > 0 && a != null && a.key && a.iv && Gs(a.method)) {
        const l = self.performance.now();
        return this.decrypter.decrypt(new Uint8Array(o), a.key.buffer, a.iv.buffer, Uu(a.method)).catch((c) => {
          throw s.trigger(T.ERROR, {
            type: ge.MEDIA_ERROR,
            details: Y.FRAG_DECRYPT_ERROR,
            fatal: !1,
            error: c,
            reason: c.message,
            frag: i
          }), c;
        }).then((c) => {
          const u = self.performance.now();
          return s.trigger(T.FRAG_DECRYPTED, {
            frag: i,
            payload: c,
            stats: {
              tstart: l,
              tdecrypt: u
            }
          }), r.payload = c, this.completeInitSegmentLoad(r);
        });
      }
      return this.completeInitSegmentLoad(r);
    }).catch((r) => {
      this.state === Q.STOPPED || this.state === Q.ERROR || (this.warn(r), this.resetFragmentLoading(e));
    });
  }
  completeInitSegmentLoad(e) {
    const {
      levels: t
    } = this;
    if (!t)
      throw new Error("init load aborted, missing levels");
    const r = e.frag.stats;
    this.state !== Q.STOPPED && (this.state = Q.IDLE), e.frag.data = new Uint8Array(e.payload), r.parsing.start = r.buffering.start = self.performance.now(), r.parsing.end = r.buffering.end = self.performance.now(), this.tick();
  }
  fragContextChanged(e) {
    const {
      fragCurrent: t
    } = this;
    return !e || !t || e.sn !== t.sn || e.level !== t.level;
  }
  fragBufferedComplete(e, t) {
    const r = this.mediaBuffer ? this.mediaBuffer : this.media;
    if (this.log(`Buffered ${e.type} sn: ${e.sn}${t ? " part: " + t.index : ""} of ${this.fragInfo(e, !1, t)} > buffer:${r ? ET.toString(Le.getBuffered(r)) : "(detached)"})`), Yt(e)) {
      var s;
      if (e.type !== he.SUBTITLE) {
        const o = e.elementaryStreams;
        if (!Object.keys(o).some((a) => !!o[a])) {
          this.state = Q.IDLE;
          return;
        }
      }
      const i = (s = this.levels) == null ? void 0 : s[e.level];
      i != null && i.fragmentError && (this.log(`Resetting level fragment error count of ${i.fragmentError} on frag buffered`), i.fragmentError = 0);
    }
    this.state = Q.IDLE;
  }
  _handleFragmentLoadComplete(e) {
    const {
      transmuxer: t
    } = this;
    if (!t)
      return;
    const {
      frag: r,
      part: s,
      partsLoaded: i
    } = e, o = !i || i.length === 0 || i.some((l) => !l), a = new Nu(r.level, r.sn, r.stats.chunkCount + 1, 0, s ? s.index : -1, !o);
    t.flush(a);
  }
  _handleFragmentLoadProgress(e) {
  }
  _doFragLoad(e, t, r = null, s) {
    var i;
    this.fragCurrent = e;
    const o = t == null ? void 0 : t.details;
    if (!this.levels || !o)
      throw new Error(`frag load aborted, missing level${o ? "" : " detail"}s`);
    let a = null;
    e.encrypted && !((i = e.decryptdata) != null && i.key) ? (this.log(`Loading key for ${e.sn} of [${o.startSN}-${o.endSN}], ${this.playlistLabel()} ${e.level}`), this.state = Q.KEY_LOADING, this.fragCurrent = e, a = this.keyLoader.load(e).then((d) => {
      if (!this.fragContextChanged(d.frag))
        return this.hls.trigger(T.KEY_LOADED, d), this.state === Q.KEY_LOADING && (this.state = Q.IDLE), d;
    }), this.hls.trigger(T.KEY_LOADING, {
      frag: e
    }), this.fragCurrent === null && (a = Promise.reject(new Error("frag load aborted, context changed in KEY_LOADING")))) : e.encrypted || (a = this.keyLoader.loadClear(e, o.encryptedFragments), a && this.log("[eme] blocking frag load until media-keys acquired"));
    const l = this.fragPrevious;
    if (Yt(e) && (!l || e.sn !== l.sn)) {
      const d = this.shouldLoadParts(t.details, e.end);
      d !== this.loadingParts && (this.log(`LL-Part loading ${d ? "ON" : "OFF"} loading sn ${l == null ? void 0 : l.sn}->${e.sn}`), this.loadingParts = d);
    }
    if (r = Math.max(e.start, r || 0), this.loadingParts && Yt(e)) {
      const d = o.partList;
      if (d && s) {
        r > e.end && o.fragmentHint && (e = o.fragmentHint);
        const h = this.getNextPart(d, e, r);
        if (h > -1) {
          const f = d[h];
          e = this.fragCurrent = f.fragment, this.log(`Loading ${e.type} sn: ${e.sn} part: ${f.index} (${h}/${d.length - 1}) of ${this.fragInfo(e, !1, f)}) cc: ${e.cc} [${o.startSN}-${o.endSN}], target: ${parseFloat(r.toFixed(3))}`), this.nextLoadPosition = f.start + f.duration, this.state = Q.FRAG_LOADING;
          let p;
          return a ? p = a.then((y) => !y || this.fragContextChanged(y.frag) ? null : this.doFragPartsLoad(e, f, t, s)).catch((y) => this.handleFragLoadError(y)) : p = this.doFragPartsLoad(e, f, t, s).catch((y) => this.handleFragLoadError(y)), this.hls.trigger(T.FRAG_LOADING, {
            frag: e,
            part: f,
            targetBufferTime: r
          }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING parts")) : p;
        } else if (!e.url || this.loadedEndOfParts(d, r))
          return Promise.resolve(null);
      }
    }
    if (Yt(e) && this.loadingParts)
      this.log(`LL-Part loading OFF after next part miss @${r.toFixed(2)}`), this.loadingParts = !1;
    else if (!e.url)
      return Promise.resolve(null);
    this.log(`Loading ${e.type} sn: ${e.sn} of ${this.fragInfo(e, !1)}) cc: ${e.cc} ${o ? "[" + o.startSN + "-" + o.endSN + "]" : ""}, target: ${parseFloat(r.toFixed(3))}`), ae(e.sn) && !this.bitrateTest && (this.nextLoadPosition = e.start + e.duration), this.state = Q.FRAG_LOADING;
    const c = this.config.progressive;
    let u;
    return c && a ? u = a.then((d) => !d || this.fragContextChanged(d == null ? void 0 : d.frag) ? null : this.fragmentLoader.load(e, s)).catch((d) => this.handleFragLoadError(d)) : u = Promise.all([this.fragmentLoader.load(e, c ? s : void 0), a]).then(([d]) => (!c && d && s && s(d), d)).catch((d) => this.handleFragLoadError(d)), this.hls.trigger(T.FRAG_LOADING, {
      frag: e,
      targetBufferTime: r
    }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING")) : u;
  }
  doFragPartsLoad(e, t, r, s) {
    return new Promise((i, o) => {
      var a;
      const l = [], c = (a = r.details) == null ? void 0 : a.partList, u = (d) => {
        this.fragmentLoader.loadPart(e, d, s).then((h) => {
          l[d.index] = h;
          const f = h.part;
          this.hls.trigger(T.FRAG_LOADED, h);
          const p = Mh(r.details, e.sn, d.index + 1) || vp(c, e.sn, d.index + 1);
          if (p)
            u(p);
          else
            return i({
              frag: e,
              part: f,
              partsLoaded: l
            });
        }).catch(o);
      };
      u(t);
    });
  }
  handleFragLoadError(e) {
    if ("data" in e) {
      const t = e.data;
      e.data && t.details === Y.INTERNAL_ABORTED ? this.handleFragLoadAborted(t.frag, t.part) : this.hls.trigger(T.ERROR, t);
    } else
      this.hls.trigger(T.ERROR, {
        type: ge.OTHER_ERROR,
        details: Y.INTERNAL_EXCEPTION,
        err: e,
        error: e,
        fatal: !0
      });
    return null;
  }
  _handleTransmuxerFlush(e) {
    const t = this.getCurrentContext(e);
    if (!t || this.state !== Q.PARSING) {
      !this.fragCurrent && this.state !== Q.STOPPED && this.state !== Q.ERROR && (this.state = Q.IDLE);
      return;
    }
    const {
      frag: r,
      part: s,
      level: i
    } = t, o = self.performance.now();
    r.stats.parsing.end = o, s && (s.stats.parsing.end = o);
    const a = this.getLevelDetails(), c = a && r.sn > a.endSN || this.shouldLoadParts(a, r.end);
    c !== this.loadingParts && (this.log(`LL-Part loading ${c ? "ON" : "OFF"} after parsing segment ending @${r.end.toFixed(2)}`), this.loadingParts = c), this.updateLevelTiming(r, s, i, e.partial);
  }
  shouldLoadParts(e, t) {
    if (this.config.lowLatencyMode) {
      if (!e)
        return this.loadingParts;
      if (e != null && e.partList) {
        var r;
        const i = e.partList[0], o = i.end + (((r = e.fragmentHint) == null ? void 0 : r.duration) || 0);
        if (t >= o) {
          var s;
          if ((this.hls.hasEnoughToStart ? ((s = this.media) == null ? void 0 : s.currentTime) || this.lastCurrentTime : this.getLoadPosition()) > i.start - i.fragment.duration)
            return !0;
        }
      }
    }
    return !1;
  }
  getCurrentContext(e) {
    const {
      levels: t,
      fragCurrent: r
    } = this, {
      level: s,
      sn: i,
      part: o
    } = e;
    if (!(t != null && t[s]))
      return this.warn(`Levels object was unset while buffering fragment ${i} of ${this.playlistLabel()} ${s}. The current chunk will not be buffered.`), null;
    const a = t[s], l = a.details, c = o > -1 ? Mh(l, i, o) : null, u = c ? c.fragment : yp(l, i, r);
    return u ? (r && r !== u && (u.stats = r.stats), {
      frag: u,
      part: c,
      level: a
    }) : null;
  }
  bufferFragmentData(e, t, r, s, i) {
    var o;
    if (!e || this.state !== Q.PARSING)
      return;
    const {
      data1: a,
      data2: l
    } = e;
    let c = a;
    if (a && l && (c = Nr(a, l)), !((o = c) != null && o.length))
      return;
    const u = {
      type: e.type,
      frag: t,
      part: r,
      chunkMeta: s,
      parent: t.type,
      data: c
    };
    if (this.hls.trigger(T.BUFFER_APPENDING, u), e.dropped && e.independent && !r) {
      if (i)
        return;
      this.flushBufferGap(t);
    }
  }
  flushBufferGap(e) {
    const t = this.media;
    if (!t)
      return;
    if (!Le.isBuffered(t, t.currentTime)) {
      this.flushMainBuffer(0, e.start);
      return;
    }
    const r = t.currentTime, s = Le.bufferInfo(t, r, 0), i = e.duration, o = Math.min(this.config.maxFragLookUpTolerance * 2, i * 0.25), a = Math.max(Math.min(e.start - o, s.end - o), r + o);
    e.start - a > o && this.flushMainBuffer(a, e.start);
  }
  getFwdBufferInfo(e, t) {
    var r;
    const s = this.getLoadPosition();
    if (!ae(s))
      return null;
    const o = this.lastCurrentTime > s || (r = this.media) != null && r.paused ? 0 : this.config.maxBufferHole;
    return this.getFwdBufferInfoAtPos(e, s, t, o);
  }
  getFwdBufferInfoAtPos(e, t, r, s) {
    const i = Le.bufferInfo(e, t, s);
    if (i.len === 0 && i.nextStart !== void 0) {
      const o = this.fragmentTracker.getBufferedFrag(t, r);
      if (o && (i.nextStart <= o.end || o.gap)) {
        const a = Math.max(Math.min(i.nextStart, o.end) - t, s);
        return Le.bufferInfo(e, t, a);
      }
    }
    return i;
  }
  getMaxBufferLength(e) {
    const {
      config: t
    } = this;
    let r;
    return e ? r = Math.max(8 * t.maxBufferSize / e, t.maxBufferLength) : r = t.maxBufferLength, Math.min(r, t.maxMaxBufferLength);
  }
  reduceMaxBufferLength(e, t) {
    const r = this.config, s = Math.max(Math.min(e - t, r.maxBufferLength), t), i = Math.max(e - t * 3, r.maxMaxBufferLength / 2, s);
    return i >= s ? (r.maxMaxBufferLength = i, this.warn(`Reduce max buffer length to ${i}s`), !0) : !1;
  }
  getAppendedFrag(e, t = he.MAIN) {
    var r;
    const s = (r = this.fragmentTracker) == null ? void 0 : r.getAppendedFrag(e, t);
    return s && "fragment" in s ? s.fragment : s;
  }
  getNextFragment(e, t) {
    const r = t.fragments, s = r.length;
    if (!s)
      return null;
    const {
      config: i
    } = this, o = r[0].start, a = i.lowLatencyMode && !!t.partList;
    let l = null;
    if (t.live) {
      const d = i.initialLiveManifestSize;
      if (s < d)
        return this.warn(`Not enough fragments to start playback (have: ${s}, need: ${d})`), null;
      if (!t.PTSKnown && !this.startFragRequested && this.startPosition === -1 || e < o) {
        var c;
        a && !this.loadingParts && (this.log("LL-Part loading ON for initial live fragment"), this.loadingParts = !0), l = this.getInitialLiveFragment(t);
        const h = this.hls.startPosition, f = this.hls.liveSyncPosition, p = l ? (h !== -1 && h >= o ? h : f) || l.start : e;
        this.log(`Setting startPosition to ${p} to match start frag at live edge. mainStart: ${h} liveSyncPosition: ${f} frag.start: ${(c = l) == null ? void 0 : c.start}`), this.startPosition = this.nextLoadPosition = p;
      }
    } else e <= o && (l = r[0]);
    if (!l) {
      const d = this.loadingParts ? t.partEnd : t.fragmentEnd;
      l = this.getFragmentAtPosition(e, d, t);
    }
    let u = this.filterReplacedPrimary(l, t);
    if (!u && l) {
      const d = l.sn - t.startSN;
      u = this.filterReplacedPrimary(r[d + 1] || null, t);
    }
    return this.mapToInitFragWhenRequired(u);
  }
  isLoopLoading(e, t) {
    const r = this.fragmentTracker.getState(e);
    return (r === Ht.OK || r === Ht.PARTIAL && !!e.gap) && this.nextLoadPosition > t;
  }
  getNextFragmentLoopLoading(e, t, r, s, i) {
    let o = null;
    if (e.gap && (o = this.getNextFragment(this.nextLoadPosition, t), o && !o.gap && r.nextStart)) {
      const a = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, r.nextStart, s, 0);
      if (a !== null && r.len + a.len >= i) {
        const l = o.sn;
        return this.loopSn !== l && (this.log(`buffer full after gaps in "${s}" playlist starting at sn: ${l}`), this.loopSn = l), null;
      }
    }
    return this.loopSn = void 0, o;
  }
  get primaryPrefetch() {
    if (Bh(this.hls.config)) {
      var e, t;
      if ((e = this.hls.interstitialsManager) == null || (t = e.playingItem) == null ? void 0 : t.event)
        return !0;
    }
    return !1;
  }
  filterReplacedPrimary(e, t) {
    if (!e)
      return e;
    if (Bh(this.hls.config) && e.type !== he.SUBTITLE) {
      const r = this.hls.interstitialsManager, s = r == null ? void 0 : r.bufferingItem;
      if (s) {
        const o = s.event;
        if (o) {
          if (o.appendInPlace || Math.abs(e.start - s.start) > 1 || s.start === 0)
            return null;
        } else if (e.end <= s.start && (t == null ? void 0 : t.live) === !1 || e.start > s.end && s.nextEvent && (s.nextEvent.appendInPlace || e.start - s.end > 1))
          return null;
      }
      const i = r == null ? void 0 : r.playerQueue;
      if (i)
        for (let o = i.length; o--; ) {
          const a = i[o].interstitial;
          if (a.appendInPlace && e.start >= a.startTime && e.end <= a.resumeTime)
            return null;
        }
    }
    return e;
  }
  mapToInitFragWhenRequired(e) {
    return e != null && e.initSegment && !(e != null && e.initSegment.data) && !this.bitrateTest ? e.initSegment : e;
  }
  getNextPart(e, t, r) {
    let s = -1, i = !1, o = !0;
    for (let a = 0, l = e.length; a < l; a++) {
      const c = e[a];
      if (o = o && !c.independent, s > -1 && r < c.start)
        break;
      const u = c.loaded;
      u ? s = -1 : (i || c.independent || o) && c.fragment === t && (s = a), i = u;
    }
    return s;
  }
  loadedEndOfParts(e, t) {
    const r = e[e.length - 1];
    return r && t > r.start && r.loaded;
  }
  /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */
  getInitialLiveFragment(e) {
    const t = e.fragments, r = this.fragPrevious;
    let s = null;
    if (r) {
      if (e.hasProgramDateTime && (this.log(`Live playlist, switching playlist, load frag with same PDT: ${r.programDateTime}`), s = Bb(t, r.endProgramDateTime, this.config.maxFragLookUpTolerance)), !s) {
        const i = r.sn + 1;
        if (i >= e.startSN && i <= e.endSN) {
          const o = t[i - e.startSN];
          r.cc === o.cc && (s = o, this.log(`Live playlist, switching playlist, load frag with next SN: ${s.sn}`));
        }
        s || (s = ap(e, r.cc, r.end), s && this.log(`Live playlist, switching playlist, load frag with same CC: ${s.sn}`));
      }
    } else {
      const i = this.hls.liveSyncPosition;
      i !== null && (s = this.getFragmentAtPosition(i, this.bitrateTest ? e.fragmentEnd : e.edge, e));
    }
    return s;
  }
  /*
  This method finds the best matching fragment given the provided position.
   */
  getFragmentAtPosition(e, t, r) {
    const {
      config: s
    } = this;
    let {
      fragPrevious: i
    } = this, {
      fragments: o,
      endSN: a
    } = r;
    const {
      fragmentHint: l
    } = r, {
      maxFragLookUpTolerance: c
    } = s, u = r.partList, d = !!(this.loadingParts && u != null && u.length && l);
    d && l && !this.bitrateTest && u[u.length - 1].fragment.sn === l.sn && (o = o.concat(l), a = l.sn);
    let h;
    if (e < t) {
      var f;
      const y = e < this.lastCurrentTime || e > t - c || (f = this.media) != null && f.paused || !this.startFragRequested ? 0 : c;
      h = gs(i, o, e, y);
    } else
      h = o[o.length - 1];
    if (h) {
      const p = h.sn - r.startSN, y = this.fragmentTracker.getState(h);
      if ((y === Ht.OK || y === Ht.PARTIAL && h.gap) && (i = h), i && h.sn === i.sn && (!d || u[0].fragment.sn > h.sn || !r.live && !d) && i && h.level === i.level) {
        const b = o[p + 1];
        h.sn < a && this.fragmentTracker.getState(b) !== Ht.OK ? h = b : h = null;
      }
    }
    return h;
  }
  alignPlaylists(e, t, r) {
    const s = e.fragments.length;
    if (!s)
      return this.warn("No fragments in live playlist"), 0;
    const i = e.fragmentStart, o = !t, a = e.alignedSliding && ae(i);
    if (o || !a && !i) {
      xT(r, e);
      const l = e.fragmentStart;
      return this.log(`Live playlist sliding: ${l.toFixed(2)} start-sn: ${t ? t.startSN : "na"}->${e.startSN} fragments: ${s}`), l;
    }
    return i;
  }
  waitForCdnTuneIn(e) {
    return e.live && e.canBlockReload && e.partTarget && e.tuneInGoal > Math.max(e.partHoldBack, e.partTarget * 3);
  }
  setStartPosition(e, t) {
    let r = this.startPosition;
    r < t && (r = -1);
    const s = this.timelineOffset;
    if (r === -1) {
      const i = this.startTimeOffset !== null, o = i ? this.startTimeOffset : e.startTimeOffset;
      o !== null && ae(o) ? (r = t + o, o < 0 && (r += e.edge), r = Math.min(Math.max(t, r), t + e.totalduration), this.log(`Setting startPosition to ${r} for start time offset ${o} found in ${i ? "multivariant" : "media"} playlist`), this.startPosition = r) : e.live ? (r = this.hls.liveSyncPosition || t, this.log(`Setting startPosition to -1 to start at live edge ${r}`), this.startPosition = -1) : (this.log("setting startPosition to 0 by default"), this.startPosition = r = 0), this.lastCurrentTime = r + s;
    }
    this.nextLoadPosition = r + s;
  }
  getLoadPosition() {
    var e;
    const {
      media: t
    } = this;
    let r = 0;
    return (e = this.hls) != null && e.hasEnoughToStart && t ? r = t.currentTime : this.nextLoadPosition >= 0 && (r = this.nextLoadPosition), r;
  }
  handleFragLoadAborted(e, t) {
    this.transmuxer && e.type === this.playlistType && Yt(e) && e.stats.aborted && (this.warn(`Fragment ${e.sn}${t ? " part " + t.index : ""} of ${this.playlistLabel()} ${e.level} was aborted`), this.resetFragmentLoading(e));
  }
  resetFragmentLoading(e) {
    (!this.fragCurrent || !this.fragContextChanged(e) && this.state !== Q.FRAG_LOADING_WAITING_RETRY) && (this.state = Q.IDLE);
  }
  onFragmentOrKeyLoadError(e, t) {
    if (t.chunkMeta && !t.frag) {
      const p = this.getCurrentContext(t.chunkMeta);
      p && (t.frag = p.frag);
    }
    const r = t.frag;
    if (!r || r.type !== e || !this.levels)
      return;
    if (this.fragContextChanged(r)) {
      var s;
      this.warn(`Frag load error must match current frag to retry ${r.url} > ${(s = this.fragCurrent) == null ? void 0 : s.url}`);
      return;
    }
    const i = t.details === Y.FRAG_GAP;
    i && this.fragmentTracker.fragBuffered(r, !0);
    const o = t.errorAction, {
      action: a,
      flags: l,
      retryCount: c = 0,
      retryConfig: u
    } = o || {}, d = !!o && !!u, h = d && a === ar.RetryRequest, f = d && !o.resolved && l === Gr.MoveAllAlternatesMatchingHost;
    if (!h && f && Yt(r) && !r.endList)
      this.resetFragmentErrors(e), this.treatAsGap(r), o.resolved = !0;
    else if ((h || f) && c < u.maxNumRetry) {
      this.resetStartWhenNotLoaded(this.levelLastLoaded);
      const p = Bu(u, c);
      this.warn(`Fragment ${r.sn} of ${e} ${r.level} errored with ${t.details}, retrying loading ${c + 1}/${u.maxNumRetry} in ${p}ms`), o.resolved = !0, this.retryDate = self.performance.now() + p, this.state = Q.FRAG_LOADING_WAITING_RETRY;
    } else if (u && o)
      if (this.resetFragmentErrors(e), c < u.maxNumRetry)
        !i && a !== ar.RemoveAlternatePermanently && (o.resolved = !0);
      else {
        this.warn(`${t.details} reached or exceeded max retry (${c})`);
        return;
      }
    else a === ar.SendAlternateToPenaltyBox ? this.state = Q.WAITING_LEVEL : this.state = Q.ERROR;
    this.tickImmediate();
  }
  reduceLengthAndFlushBuffer(e) {
    if (this.state === Q.PARSING || this.state === Q.PARSED) {
      const t = e.frag, r = e.parent, s = this.getFwdBufferInfo(this.mediaBuffer, r), i = s && s.len > 0.5;
      i && this.reduceMaxBufferLength(s.len, (t == null ? void 0 : t.duration) || 10);
      const o = !i;
      return o && this.warn(`Buffer full error while media.currentTime is not buffered, flush ${r} buffer`), t && (this.fragmentTracker.removeFragment(t), this.nextLoadPosition = t.start), this.resetLoadingState(), o;
    }
    return !1;
  }
  resetFragmentErrors(e) {
    e === he.AUDIO && (this.fragCurrent = null), this.hls.hasEnoughToStart || (this.startFragRequested = !1), this.state !== Q.STOPPED && (this.state = Q.IDLE);
  }
  afterBufferFlushed(e, t, r) {
    if (!e)
      return;
    const s = Le.getBuffered(e);
    this.fragmentTracker.detectEvictedFragments(t, s, r), this.state === Q.ENDED && this.resetLoadingState();
  }
  resetLoadingState() {
    this.log("Reset loading state"), this.fragCurrent = null, this.fragPrevious = null, this.state !== Q.STOPPED && (this.state = Q.IDLE);
  }
  resetStartWhenNotLoaded(e) {
    if (!this.hls.hasEnoughToStart) {
      this.startFragRequested = !1;
      const t = e ? e.details : null;
      t != null && t.live ? (this.log("resetting startPosition for live start"), this.startPosition = -1, this.setStartPosition(t, t.fragmentStart), this.resetLoadingState()) : this.nextLoadPosition = this.startPosition;
    }
  }
  resetWhenMissingContext(e) {
    this.warn(`The loading context changed while buffering fragment ${e.sn} of ${this.playlistLabel()} ${e.level}. This chunk will not be buffered.`), this.removeUnbufferedFrags(), this.resetStartWhenNotLoaded(this.levelLastLoaded), this.resetLoadingState();
  }
  removeUnbufferedFrags(e = 0) {
    this.fragmentTracker.removeFragmentsInRange(e, 1 / 0, this.playlistType, !1, !0);
  }
  updateLevelTiming(e, t, r, s) {
    const i = r.details;
    if (!i) {
      this.warn("level.details undefined");
      return;
    }
    if (!Object.keys(e.elementaryStreams).reduce((l, c) => {
      const u = e.elementaryStreams[c];
      if (u) {
        const d = u.endPTS - u.startPTS;
        if (d <= 0)
          return this.warn(`Could not parse fragment ${e.sn} ${c} duration reliably (${d})`), l || !1;
        const h = s ? 0 : gp(i, e, u.startPTS, u.endPTS, u.startDTS, u.endDTS);
        return this.hls.trigger(T.LEVEL_PTS_UPDATED, {
          details: i,
          level: r,
          drift: h,
          type: c,
          frag: e,
          start: u.startPTS,
          end: u.endPTS
        }), !0;
      }
      return l;
    }, !1)) {
      var a;
      if (r.fragmentError === 0 && this.treatAsGap(e, r), ((a = this.transmuxer) == null ? void 0 : a.error) === null) {
        const l = new Error(`Found no media in fragment ${e.sn} of ${this.playlistLabel()} ${e.level} resetting transmuxer to fallback to playlist timing`);
        if (this.warn(l.message), this.hls.trigger(T.ERROR, {
          type: ge.MEDIA_ERROR,
          details: Y.FRAG_PARSING_ERROR,
          fatal: !1,
          error: l,
          frag: e,
          reason: `Found no media in msn ${e.sn} of ${this.playlistLabel()} "${r.url}"`
        }), !this.hls)
          return;
        this.resetTransmuxer();
      }
    }
    this.state = Q.PARSED, this.log(`Parsed ${e.type} sn: ${e.sn}${t ? " part: " + t.index : ""} of ${this.fragInfo(e, !1, t)})`), this.hls.trigger(T.FRAG_PARSED, {
      frag: e,
      part: t
    });
  }
  playlistLabel() {
    return this.playlistType === he.MAIN ? "level" : "track";
  }
  fragInfo(e, t = !0, r) {
    var s, i;
    return `${this.playlistLabel()} ${e.level} (${r ? "part" : "frag"}:[${((s = t && !r ? e.startPTS : (r || e).start) != null ? s : NaN).toFixed(3)}-${((i = t && !r ? e.endPTS : (r || e).end) != null ? i : NaN).toFixed(3)}]${r && e.type === "main" ? "INDEPENDENT=" + (r.independent ? "YES" : "NO") : ""}`;
  }
  treatAsGap(e, t) {
    t && t.fragmentError++, e.gap = !0, this.fragmentTracker.removeFragment(e), this.fragmentTracker.fragBuffered(e, !0);
  }
  resetTransmuxer() {
    var e;
    (e = this.transmuxer) == null || e.reset();
  }
  recoverWorkerError(e) {
    e.event === "demuxerWorker" && (this.fragmentTracker.removeAllFragments(), this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null), this.resetStartWhenNotLoaded(this.levelLastLoaded), this.resetLoadingState());
  }
  set state(e) {
    const t = this._state;
    t !== e && (this._state = e, this.log(`${t}->${e}`));
  }
  get state() {
    return this._state;
  }
}
function Bh(n) {
  return !!n.interstitialsController && n.enableInterstitialPlayback !== !1;
}
class bp {
  constructor() {
    this.chunks = [], this.dataLength = 0;
  }
  push(e) {
    this.chunks.push(e), this.dataLength += e.length;
  }
  flush() {
    const {
      chunks: e,
      dataLength: t
    } = this;
    let r;
    if (e.length)
      e.length === 1 ? r = e[0] : r = ST(e, t);
    else return new Uint8Array(0);
    return this.reset(), r;
  }
  reset() {
    this.chunks.length = 0, this.dataLength = 0;
  }
}
function ST(n, e) {
  const t = new Uint8Array(e);
  let r = 0;
  for (let s = 0; s < n.length; s++) {
    const i = n[s];
    t.set(i, r), r += i.length;
  }
  return t;
}
var Dl = { exports: {} }, Fh;
function bT() {
  return Fh || (Fh = 1, function(n) {
    var e = Object.prototype.hasOwnProperty, t = "~";
    function r() {
    }
    Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (t = !1));
    function s(l, c, u) {
      this.fn = l, this.context = c, this.once = u || !1;
    }
    function i(l, c, u, d, h) {
      if (typeof u != "function")
        throw new TypeError("The listener must be a function");
      var f = new s(u, d || l, h), p = t ? t + c : c;
      return l._events[p] ? l._events[p].fn ? l._events[p] = [l._events[p], f] : l._events[p].push(f) : (l._events[p] = f, l._eventsCount++), l;
    }
    function o(l, c) {
      --l._eventsCount === 0 ? l._events = new r() : delete l._events[c];
    }
    function a() {
      this._events = new r(), this._eventsCount = 0;
    }
    a.prototype.eventNames = function() {
      var c = [], u, d;
      if (this._eventsCount === 0) return c;
      for (d in u = this._events)
        e.call(u, d) && c.push(t ? d.slice(1) : d);
      return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(u)) : c;
    }, a.prototype.listeners = function(c) {
      var u = t ? t + c : c, d = this._events[u];
      if (!d) return [];
      if (d.fn) return [d.fn];
      for (var h = 0, f = d.length, p = new Array(f); h < f; h++)
        p[h] = d[h].fn;
      return p;
    }, a.prototype.listenerCount = function(c) {
      var u = t ? t + c : c, d = this._events[u];
      return d ? d.fn ? 1 : d.length : 0;
    }, a.prototype.emit = function(c, u, d, h, f, p) {
      var y = t ? t + c : c;
      if (!this._events[y]) return !1;
      var m = this._events[y], b = arguments.length, C, A;
      if (m.fn) {
        switch (m.once && this.removeListener(c, m.fn, void 0, !0), b) {
          case 1:
            return m.fn.call(m.context), !0;
          case 2:
            return m.fn.call(m.context, u), !0;
          case 3:
            return m.fn.call(m.context, u, d), !0;
          case 4:
            return m.fn.call(m.context, u, d, h), !0;
          case 5:
            return m.fn.call(m.context, u, d, h, f), !0;
          case 6:
            return m.fn.call(m.context, u, d, h, f, p), !0;
        }
        for (A = 1, C = new Array(b - 1); A < b; A++)
          C[A - 1] = arguments[A];
        m.fn.apply(m.context, C);
      } else {
        var P = m.length, I;
        for (A = 0; A < P; A++)
          switch (m[A].once && this.removeListener(c, m[A].fn, void 0, !0), b) {
            case 1:
              m[A].fn.call(m[A].context);
              break;
            case 2:
              m[A].fn.call(m[A].context, u);
              break;
            case 3:
              m[A].fn.call(m[A].context, u, d);
              break;
            case 4:
              m[A].fn.call(m[A].context, u, d, h);
              break;
            default:
              if (!C) for (I = 1, C = new Array(b - 1); I < b; I++)
                C[I - 1] = arguments[I];
              m[A].fn.apply(m[A].context, C);
          }
      }
      return !0;
    }, a.prototype.on = function(c, u, d) {
      return i(this, c, u, d, !1);
    }, a.prototype.once = function(c, u, d) {
      return i(this, c, u, d, !0);
    }, a.prototype.removeListener = function(c, u, d, h) {
      var f = t ? t + c : c;
      if (!this._events[f]) return this;
      if (!u)
        return o(this, f), this;
      var p = this._events[f];
      if (p.fn)
        p.fn === u && (!h || p.once) && (!d || p.context === d) && o(this, f);
      else {
        for (var y = 0, m = [], b = p.length; y < b; y++)
          (p[y].fn !== u || h && !p[y].once || d && p[y].context !== d) && m.push(p[y]);
        m.length ? this._events[f] = m.length === 1 ? m[0] : m : o(this, f);
      }
      return this;
    }, a.prototype.removeAllListeners = function(c) {
      var u;
      return c ? (u = t ? t + c : c, this._events[u] && o(this, u)) : (this._events = new r(), this._eventsCount = 0), this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = t, a.EventEmitter = a, n.exports = a;
  }(Dl)), Dl.exports;
}
var TT = bT(), ju = /* @__PURE__ */ QS(TT);
const Ui = "1.6.5", ei = {};
function wT() {
  return typeof __HLS_WORKER_BUNDLE__ == "function";
}
function AT() {
  const n = ei[Ui];
  if (n)
    return n.clientCount++, n;
  const e = new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`], {
    type: "text/javascript"
  }), t = self.URL.createObjectURL(e), s = {
    worker: new self.Worker(t),
    objectURL: t,
    clientCount: 1
  };
  return ei[Ui] = s, s;
}
function IT(n) {
  const e = ei[n];
  if (e)
    return e.clientCount++, e;
  const t = new self.URL(n, self.location.href).href, s = {
    worker: new self.Worker(t),
    scriptURL: t,
    clientCount: 1
  };
  return ei[n] = s, s;
}
function _T(n) {
  const e = ei[n || Ui];
  if (e && e.clientCount-- === 1) {
    const {
      worker: r,
      objectURL: s
    } = e;
    delete ei[n || Ui], s && self.URL.revokeObjectURL(s), r.terminate();
  }
}
function Tp(n, e) {
  return e + 10 <= n.length && n[e] === 51 && n[e + 1] === 68 && n[e + 2] === 73 && n[e + 3] < 255 && n[e + 4] < 255 && n[e + 6] < 128 && n[e + 7] < 128 && n[e + 8] < 128 && n[e + 9] < 128;
}
function Vu(n, e) {
  return e + 10 <= n.length && n[e] === 73 && n[e + 1] === 68 && n[e + 2] === 51 && n[e + 3] < 255 && n[e + 4] < 255 && n[e + 6] < 128 && n[e + 7] < 128 && n[e + 8] < 128 && n[e + 9] < 128;
}
function ja(n, e) {
  let t = 0;
  return t = (n[e] & 127) << 21, t |= (n[e + 1] & 127) << 14, t |= (n[e + 2] & 127) << 7, t |= n[e + 3] & 127, t;
}
function $i(n, e) {
  const t = e;
  let r = 0;
  for (; Vu(n, e); ) {
    r += 10;
    const s = ja(n, e + 6);
    r += s, Tp(n, e + 10) && (r += 10), e += r;
  }
  if (r > 0)
    return n.subarray(t, t + r);
}
function LT(n, e, t, r) {
  const s = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350], i = e[t + 2], o = i >> 2 & 15;
  if (o > 12) {
    const f = new Error(`invalid ADTS sampling index:${o}`);
    n.emit(T.ERROR, T.ERROR, {
      type: ge.MEDIA_ERROR,
      details: Y.FRAG_PARSING_ERROR,
      fatal: !0,
      error: f,
      reason: f.message
    });
    return;
  }
  const a = (i >> 6 & 3) + 1, l = e[t + 3] >> 6 & 3 | (i & 1) << 2, c = "mp4a.40." + a, u = s[o];
  let d = o;
  (a === 5 || a === 29) && (d -= 3);
  const h = [a << 3 | (d & 14) >> 1, (d & 1) << 7 | l << 3];
  return Ze.log(`manifest codec:${r}, parsed codec:${c}, channels:${l}, rate:${u} (ADTS object type:${a} sampling index:${o})`), {
    config: h,
    samplerate: u,
    channelCount: l,
    codec: c,
    parsedCodec: c,
    manifestCodec: r
  };
}
function wp(n, e) {
  return n[e] === 255 && (n[e + 1] & 246) === 240;
}
function Ap(n, e) {
  return n[e + 1] & 1 ? 7 : 9;
}
function Ku(n, e) {
  return (n[e + 3] & 3) << 11 | n[e + 4] << 3 | (n[e + 5] & 224) >>> 5;
}
function RT(n, e) {
  return e + 5 < n.length;
}
function ba(n, e) {
  return e + 1 < n.length && wp(n, e);
}
function CT(n, e) {
  return RT(n, e) && wp(n, e) && Ku(n, e) <= n.length - e;
}
function kT(n, e) {
  if (ba(n, e)) {
    const t = Ap(n, e);
    if (e + t >= n.length)
      return !1;
    const r = Ku(n, e);
    if (r <= t)
      return !1;
    const s = e + r;
    return s === n.length || ba(n, s);
  }
  return !1;
}
function Ip(n, e, t, r, s) {
  if (!n.samplerate) {
    const i = LT(e, t, r, s);
    if (!i)
      return;
    st(n, i);
  }
}
function _p(n) {
  return 1024 * 9e4 / n;
}
function DT(n, e) {
  const t = Ap(n, e);
  if (e + t <= n.length) {
    const r = Ku(n, e) - t;
    if (r > 0)
      return {
        headerLength: t,
        frameLength: r
      };
  }
}
function Lp(n, e, t, r, s) {
  const i = _p(n.samplerate), o = r + s * i, a = DT(e, t);
  let l;
  if (a) {
    const {
      frameLength: d,
      headerLength: h
    } = a, f = h + d, p = Math.max(0, t + f - e.length);
    p ? (l = new Uint8Array(f - h), l.set(e.subarray(t + h, e.length), 0)) : l = e.subarray(t + h, t + f);
    const y = {
      unit: l,
      pts: o
    };
    return p || n.samples.push(y), {
      sample: y,
      length: f,
      missing: p
    };
  }
  const c = e.length - t;
  return l = new Uint8Array(c), l.set(e.subarray(t, e.length), 0), {
    sample: {
      unit: l,
      pts: o
    },
    length: c,
    missing: -1
  };
}
function PT(n, e) {
  return Vu(n, e) && ja(n, e + 6) + 10 <= n.length - e;
}
function MT(n) {
  return n instanceof ArrayBuffer ? n : n.byteOffset == 0 && n.byteLength == n.buffer.byteLength ? n.buffer : new Uint8Array(n).buffer;
}
function Pl(n, e = 0, t = 1 / 0) {
  return OT(n, e, t, Uint8Array);
}
function OT(n, e, t, r) {
  const s = BT(n);
  let i = 1;
  "BYTES_PER_ELEMENT" in r && (i = r.BYTES_PER_ELEMENT);
  const o = FT(n) ? n.byteOffset : 0, a = (o + n.byteLength) / i, l = (o + e) / i, c = Math.floor(Math.max(0, Math.min(l, a))), u = Math.floor(Math.min(c + Math.max(t, 0), a));
  return new r(s, c, u - c);
}
function BT(n) {
  return n instanceof ArrayBuffer ? n : n.buffer;
}
function FT(n) {
  return n && n.buffer instanceof ArrayBuffer && n.byteLength !== void 0 && n.byteOffset !== void 0;
}
function NT(n) {
  const e = {
    key: n.type,
    description: "",
    data: "",
    mimeType: null,
    pictureType: null
  }, t = 3;
  if (n.size < 2)
    return;
  if (n.data[0] !== t) {
    console.log("Ignore frame with unrecognized character encoding");
    return;
  }
  const r = n.data.subarray(1).indexOf(0);
  if (r === -1)
    return;
  const s = Lr(Pl(n.data, 1, r)), i = n.data[2 + r], o = n.data.subarray(3 + r).indexOf(0);
  if (o === -1)
    return;
  const a = Lr(Pl(n.data, 3 + r, o));
  let l;
  return s === "-->" ? l = Lr(Pl(n.data, 4 + r + o)) : l = MT(n.data.subarray(4 + r + o)), e.mimeType = s, e.pictureType = i, e.description = a, e.data = l, e;
}
function UT(n) {
  if (n.size < 2)
    return;
  const e = Lr(n.data, !0), t = new Uint8Array(n.data.subarray(e.length + 1));
  return {
    key: n.type,
    info: e,
    data: t.buffer
  };
}
function $T(n) {
  if (n.size < 2)
    return;
  if (n.type === "TXXX") {
    let t = 1;
    const r = Lr(n.data.subarray(t), !0);
    t += r.length + 1;
    const s = Lr(n.data.subarray(t));
    return {
      key: n.type,
      info: r,
      data: s
    };
  }
  const e = Lr(n.data.subarray(1));
  return {
    key: n.type,
    info: "",
    data: e
  };
}
function GT(n) {
  if (n.type === "WXXX") {
    if (n.size < 2)
      return;
    let t = 1;
    const r = Lr(n.data.subarray(t), !0);
    t += r.length + 1;
    const s = Lr(n.data.subarray(t));
    return {
      key: n.type,
      info: r,
      data: s
    };
  }
  const e = Lr(n.data);
  return {
    key: n.type,
    info: "",
    data: e
  };
}
function jT(n) {
  return n.type === "PRIV" ? UT(n) : n.type[0] === "W" ? GT(n) : n.type === "APIC" ? NT(n) : $T(n);
}
function VT(n) {
  const e = String.fromCharCode(n[0], n[1], n[2], n[3]), t = ja(n, 4), r = 10;
  return {
    type: e,
    size: t,
    data: n.subarray(r, r + t)
  };
}
const po = 10, KT = 10;
function Rp(n) {
  let e = 0;
  const t = [];
  for (; Vu(n, e); ) {
    const r = ja(n, e + 6);
    n[e + 5] >> 6 & 1 && (e += po), e += po;
    const s = e + r;
    for (; e + KT < s; ) {
      const i = VT(n.subarray(e)), o = jT(i);
      o && t.push(o), e += i.size + po;
    }
    Tp(n, e) && (e += po);
  }
  return t;
}
function Cp(n) {
  return n && n.key === "PRIV" && n.info === "com.apple.streaming.transportStreamTimestamp";
}
function HT(n) {
  if (n.data.byteLength === 8) {
    const e = new Uint8Array(n.data), t = e[3] & 1;
    let r = (e[4] << 23) + (e[5] << 15) + (e[6] << 7) + e[7];
    return r /= 45, t && (r += 4772185884e-2), Math.round(r);
  }
}
function Hu(n) {
  const e = Rp(n);
  for (let t = 0; t < e.length; t++) {
    const r = e[t];
    if (Cp(r))
      return HT(r);
  }
}
let Ir = /* @__PURE__ */ function(n) {
  return n.audioId3 = "org.id3", n.dateRange = "com.apple.quicktime.HLS", n.emsg = "https://aomedia.org/emsg/ID3", n.misbklv = "urn:misb:KLV:bin:1910.1", n;
}({});
function en(n = "", e = 9e4) {
  return {
    type: n,
    id: -1,
    pid: -1,
    inputTimeScale: e,
    sequenceNumber: -1,
    samples: [],
    dropped: 0
  };
}
class Wu {
  constructor() {
    this._audioTrack = void 0, this._id3Track = void 0, this.frameIndex = 0, this.cachedData = null, this.basePTS = null, this.initPTS = null, this.lastPTS = null;
  }
  resetInitSegment(e, t, r, s) {
    this._id3Track = {
      type: "id3",
      id: 3,
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0
    };
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.resetContiguity();
  }
  resetContiguity() {
    this.basePTS = null, this.lastPTS = null, this.frameIndex = 0;
  }
  canParse(e, t) {
    return !1;
  }
  appendFrame(e, t, r) {
  }
  // feed incoming data to the front of the parsing pipeline
  demux(e, t) {
    this.cachedData && (e = Nr(this.cachedData, e), this.cachedData = null);
    let r = $i(e, 0), s = r ? r.length : 0, i;
    const o = this._audioTrack, a = this._id3Track, l = r ? Hu(r) : void 0, c = e.length;
    for ((this.basePTS === null || this.frameIndex === 0 && ae(l)) && (this.basePTS = WT(l, t, this.initPTS), this.lastPTS = this.basePTS), this.lastPTS === null && (this.lastPTS = this.basePTS), r && r.length > 0 && a.samples.push({
      pts: this.lastPTS,
      dts: this.lastPTS,
      data: r,
      type: Ir.audioId3,
      duration: Number.POSITIVE_INFINITY
    }); s < c; ) {
      if (this.canParse(e, s)) {
        const u = this.appendFrame(o, e, s);
        u ? (this.frameIndex++, this.lastPTS = u.sample.pts, s += u.length, i = s) : s = c;
      } else PT(e, s) ? (r = $i(e, s), a.samples.push({
        pts: this.lastPTS,
        dts: this.lastPTS,
        data: r,
        type: Ir.audioId3,
        duration: Number.POSITIVE_INFINITY
      }), s += r.length, i = s) : s++;
      if (s === c && i !== c) {
        const u = e.slice(i);
        this.cachedData ? this.cachedData = Nr(this.cachedData, u) : this.cachedData = u;
      }
    }
    return {
      audioTrack: o,
      videoTrack: en(),
      id3Track: a,
      textTrack: en()
    };
  }
  demuxSampleAes(e, t, r) {
    return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
  }
  flush(e) {
    const t = this.cachedData;
    return t && (this.cachedData = null, this.demux(t, 0)), {
      audioTrack: this._audioTrack,
      videoTrack: en(),
      id3Track: this._id3Track,
      textTrack: en()
    };
  }
  destroy() {
    this.cachedData = null, this._audioTrack = this._id3Track = void 0;
  }
}
const WT = (n, e, t) => {
  if (ae(n))
    return n * 90;
  const r = t ? t.baseTime * 9e4 / t.timescale : 0;
  return e * 9e4 + r;
};
let mo = null;
const qT = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160], zT = [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3], YT = [
  // MPEG 2.5
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // Reserved
  [
    0,
    // Reserved
    0,
    // Layer3
    0,
    // Layer2
    0
    // Layer1
  ],
  // MPEG 2
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // MPEG 1
  [
    0,
    // Reserved
    144,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ]
], ZT = [
  0,
  // Reserved
  1,
  // Layer3
  1,
  // Layer2
  4
  // Layer1
];
function kp(n, e, t, r, s) {
  if (t + 24 > e.length)
    return;
  const i = Dp(e, t);
  if (i && t + i.frameLength <= e.length) {
    const o = i.samplesPerFrame * 9e4 / i.sampleRate, a = r + s * o, l = {
      unit: e.subarray(t, t + i.frameLength),
      pts: a,
      dts: a
    };
    return n.config = [], n.channelCount = i.channelCount, n.samplerate = i.sampleRate, n.samples.push(l), {
      sample: l,
      length: i.frameLength,
      missing: 0
    };
  }
}
function Dp(n, e) {
  const t = n[e + 1] >> 3 & 3, r = n[e + 1] >> 1 & 3, s = n[e + 2] >> 4 & 15, i = n[e + 2] >> 2 & 3;
  if (t !== 1 && s !== 0 && s !== 15 && i !== 3) {
    const o = n[e + 2] >> 1 & 1, a = n[e + 3] >> 6, l = t === 3 ? 3 - r : r === 3 ? 3 : 4, c = qT[l * 14 + s - 1] * 1e3, d = zT[(t === 3 ? 0 : t === 2 ? 1 : 2) * 3 + i], h = a === 3 ? 1 : 2, f = YT[t][r], p = ZT[r], y = f * 8 * p, m = Math.floor(f * c / d + o) * p;
    if (mo === null) {
      const A = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      mo = A ? parseInt(A[1]) : 0;
    }
    return !!mo && mo <= 87 && r === 2 && c >= 224e3 && a === 0 && (n[e + 3] = n[e + 3] | 128), {
      sampleRate: d,
      channelCount: h,
      frameLength: m,
      samplesPerFrame: y
    };
  }
}
function qu(n, e) {
  return n[e] === 255 && (n[e + 1] & 224) === 224 && (n[e + 1] & 6) !== 0;
}
function Pp(n, e) {
  return e + 1 < n.length && qu(n, e);
}
function XT(n, e) {
  return qu(n, e) && 4 <= n.length - e;
}
function Mp(n, e) {
  if (e + 1 < n.length && qu(n, e)) {
    const r = Dp(n, e);
    let s = 4;
    r != null && r.frameLength && (s = r.frameLength);
    const i = e + s;
    return i === n.length || Pp(n, i);
  }
  return !1;
}
class JT extends Wu {
  constructor(e, t) {
    super(), this.observer = void 0, this.config = void 0, this.observer = e, this.config = t;
  }
  resetInitSegment(e, t, r, s) {
    super.resetInitSegment(e, t, r, s), this._audioTrack = {
      container: "audio/adts",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "aac",
      samples: [],
      manifestCodec: t,
      duration: s,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
  static probe(e, t) {
    if (!e)
      return !1;
    const r = $i(e, 0);
    let s = (r == null ? void 0 : r.length) || 0;
    if (Mp(e, s))
      return !1;
    for (let i = e.length; s < i; s++)
      if (kT(e, s))
        return t.log("ADTS sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return CT(e, t);
  }
  appendFrame(e, t, r) {
    Ip(e, this.observer, t, r, e.manifestCodec);
    const s = Lp(e, t, r, this.basePTS, this.frameIndex);
    if (s && s.missing === 0)
      return s;
  }
}
const Op = (n, e) => {
  let t = 0, r = 5;
  e += r;
  const s = new Uint32Array(1), i = new Uint32Array(1), o = new Uint8Array(1);
  for (; r > 0; ) {
    o[0] = n[e];
    const a = Math.min(r, 8), l = 8 - a;
    i[0] = 4278190080 >>> 24 + l << l, s[0] = (o[0] & i[0]) >> l, t = t ? t << a | s[0] : s[0], e += 1, r -= a;
  }
  return t;
};
class QT extends Wu {
  constructor(e) {
    super(), this.observer = void 0, this.observer = e;
  }
  resetInitSegment(e, t, r, s) {
    super.resetInitSegment(e, t, r, s), this._audioTrack = {
      container: "audio/ac-3",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "ac3",
      samples: [],
      manifestCodec: t,
      duration: s,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  canParse(e, t) {
    return t + 64 < e.length;
  }
  appendFrame(e, t, r) {
    const s = Bp(e, t, r, this.basePTS, this.frameIndex);
    if (s !== -1)
      return {
        sample: e.samples[e.samples.length - 1],
        length: s,
        missing: 0
      };
  }
  static probe(e) {
    if (!e)
      return !1;
    const t = $i(e, 0);
    if (!t)
      return !1;
    const r = t.length;
    return e[r] === 11 && e[r + 1] === 119 && Hu(t) !== void 0 && // check the bsid to confirm ac-3
    Op(e, r) < 16;
  }
}
function Bp(n, e, t, r, s) {
  if (t + 8 > e.length || e[t] !== 11 || e[t + 1] !== 119)
    return -1;
  const i = e[t + 4] >> 6;
  if (i >= 3)
    return -1;
  const a = [48e3, 44100, 32e3][i], l = e[t + 4] & 63, u = [64, 69, 96, 64, 70, 96, 80, 87, 120, 80, 88, 120, 96, 104, 144, 96, 105, 144, 112, 121, 168, 112, 122, 168, 128, 139, 192, 128, 140, 192, 160, 174, 240, 160, 175, 240, 192, 208, 288, 192, 209, 288, 224, 243, 336, 224, 244, 336, 256, 278, 384, 256, 279, 384, 320, 348, 480, 320, 349, 480, 384, 417, 576, 384, 418, 576, 448, 487, 672, 448, 488, 672, 512, 557, 768, 512, 558, 768, 640, 696, 960, 640, 697, 960, 768, 835, 1152, 768, 836, 1152, 896, 975, 1344, 896, 976, 1344, 1024, 1114, 1536, 1024, 1115, 1536, 1152, 1253, 1728, 1152, 1254, 1728, 1280, 1393, 1920, 1280, 1394, 1920][l * 3 + i] * 2;
  if (t + u > e.length)
    return -1;
  const d = e[t + 6] >> 5;
  let h = 0;
  d === 2 ? h += 2 : (d & 1 && d !== 1 && (h += 2), d & 4 && (h += 2));
  const f = (e[t + 6] << 8 | e[t + 7]) >> 12 - h & 1, y = [2, 1, 2, 3, 3, 4, 4, 5][d] + f, m = e[t + 5] >> 3, b = e[t + 5] & 7, C = new Uint8Array([i << 6 | m << 1 | b >> 2, (b & 3) << 6 | d << 3 | f << 2 | l >> 4, l << 4 & 224]), A = 1536 / a * 9e4, P = r + s * A, I = e.subarray(t, t + u);
  return n.config = C, n.channelCount = y, n.samplerate = a, n.samples.push({
    unit: I,
    pts: P
  }), u;
}
class e2 extends Wu {
  resetInitSegment(e, t, r, s) {
    super.resetInitSegment(e, t, r, s), this._audioTrack = {
      container: "audio/mpeg",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "mp3",
      samples: [],
      manifestCodec: t,
      duration: s,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  static probe(e) {
    if (!e)
      return !1;
    const t = $i(e, 0);
    let r = (t == null ? void 0 : t.length) || 0;
    if (t && e[r] === 11 && e[r + 1] === 119 && Hu(t) !== void 0 && // check the bsid to confirm ac-3 or ec-3 (not mp3)
    Op(e, r) <= 16)
      return !1;
    for (let s = e.length; r < s; r++)
      if (Mp(e, r))
        return Ze.log("MPEG Audio sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return XT(e, t);
  }
  appendFrame(e, t, r) {
    if (this.basePTS !== null)
      return kp(e, t, r, this.basePTS, this.frameIndex);
  }
}
const t2 = /\/emsg[-/]ID3/i;
class r2 {
  constructor(e, t) {
    this.remainderData = null, this.timeOffset = 0, this.config = void 0, this.videoTrack = void 0, this.audioTrack = void 0, this.id3Track = void 0, this.txtTrack = void 0, this.config = t;
  }
  resetTimeStamp() {
  }
  resetInitSegment(e, t, r, s) {
    const i = this.videoTrack = en("video", 1), o = this.audioTrack = en("audio", 1), a = this.txtTrack = en("text", 1);
    if (this.id3Track = en("id3", 1), this.timeOffset = 0, !(e != null && e.byteLength))
      return;
    const l = Yg(e);
    if (l.video) {
      const {
        id: c,
        timescale: u,
        codec: d,
        supplemental: h
      } = l.video;
      i.id = c, i.timescale = a.timescale = u, i.codec = d, i.supplemental = h;
    }
    if (l.audio) {
      const {
        id: c,
        timescale: u,
        codec: d
      } = l.audio;
      o.id = c, o.timescale = u, o.codec = d;
    }
    a.id = Wg.text, i.sampleDuration = 0, i.duration = o.duration = s;
  }
  resetContiguity() {
    this.remainderData = null;
  }
  static probe(e) {
    return sb(e);
  }
  demux(e, t) {
    this.timeOffset = t;
    let r = e;
    const s = this.videoTrack, i = this.txtTrack;
    if (this.config.progressive) {
      this.remainderData && (r = Nr(this.remainderData, e));
      const a = db(r);
      this.remainderData = a.remainder, s.samples = a.valid || new Uint8Array();
    } else
      s.samples = r;
    const o = this.extractID3Track(s, t);
    return i.samples = sh(t, s), {
      videoTrack: s,
      audioTrack: this.audioTrack,
      id3Track: o,
      textTrack: this.txtTrack
    };
  }
  flush() {
    const e = this.timeOffset, t = this.videoTrack, r = this.txtTrack;
    t.samples = this.remainderData || new Uint8Array(), this.remainderData = null;
    const s = this.extractID3Track(t, this.timeOffset);
    return r.samples = sh(e, t), {
      videoTrack: t,
      audioTrack: en(),
      id3Track: s,
      textTrack: en()
    };
  }
  extractID3Track(e, t) {
    const r = this.id3Track;
    if (e.samples.length) {
      const s = Oe(e.samples, ["emsg"]);
      s && s.forEach((i) => {
        const o = fb(i);
        if (t2.test(o.schemeIdUri)) {
          const a = Nh(o, t);
          let l = o.eventDuration === 4294967295 ? Number.POSITIVE_INFINITY : o.eventDuration / o.timeScale;
          l <= 1e-3 && (l = Number.POSITIVE_INFINITY);
          const c = o.payload;
          r.samples.push({
            data: c,
            len: c.byteLength,
            dts: a,
            pts: a,
            type: Ir.emsg,
            duration: l
          });
        } else if (this.config.enableEmsgKLVMetadata && o.schemeIdUri.startsWith("urn:misb:KLV:bin:1910.1")) {
          const a = Nh(o, t);
          r.samples.push({
            data: o.payload,
            len: o.payload.byteLength,
            dts: a,
            pts: a,
            type: Ir.misbklv,
            duration: Number.POSITIVE_INFINITY
          });
        }
      });
    }
    return r;
  }
  demuxSampleAes(e, t, r) {
    return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
  }
  destroy() {
    this.config = null, this.remainderData = null, this.videoTrack = this.audioTrack = this.id3Track = this.txtTrack = void 0;
  }
}
function Nh(n, e) {
  return ae(n.presentationTime) ? n.presentationTime / n.timeScale : e + n.presentationTimeDelta / n.timeScale;
}
class n2 {
  constructor(e, t, r) {
    this.keyData = void 0, this.decrypter = void 0, this.keyData = r, this.decrypter = new Fu(t, {
      removePKCS7Padding: !1
    });
  }
  decryptBuffer(e) {
    return this.decrypter.decrypt(e, this.keyData.key.buffer, this.keyData.iv.buffer, Xn.cbc);
  }
  // AAC - encrypt all full 16 bytes blocks starting from offset 16
  decryptAacSample(e, t, r) {
    const s = e[t].unit;
    if (s.length <= 16)
      return;
    const i = s.subarray(16, s.length - s.length % 16), o = i.buffer.slice(i.byteOffset, i.byteOffset + i.length);
    this.decryptBuffer(o).then((a) => {
      const l = new Uint8Array(a);
      s.set(l, 16), this.decrypter.isSync() || this.decryptAacSamples(e, t + 1, r);
    });
  }
  decryptAacSamples(e, t, r) {
    for (; ; t++) {
      if (t >= e.length) {
        r();
        return;
      }
      if (!(e[t].unit.length < 32) && (this.decryptAacSample(e, t, r), !this.decrypter.isSync()))
        return;
    }
  }
  // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
  getAvcEncryptedData(e) {
    const t = Math.floor((e.length - 48) / 160) * 16 + 16, r = new Int8Array(t);
    let s = 0;
    for (let i = 32; i < e.length - 16; i += 160, s += 16)
      r.set(e.subarray(i, i + 16), s);
    return r;
  }
  getAvcDecryptedUnit(e, t) {
    const r = new Uint8Array(t);
    let s = 0;
    for (let i = 32; i < e.length - 16; i += 160, s += 16)
      e.set(r.subarray(s, s + 16), i);
    return e;
  }
  decryptAvcSample(e, t, r, s, i) {
    const o = Xg(i.data), a = this.getAvcEncryptedData(o);
    this.decryptBuffer(a.buffer).then((l) => {
      i.data = this.getAvcDecryptedUnit(o, l), this.decrypter.isSync() || this.decryptAvcSamples(e, t, r + 1, s);
    });
  }
  decryptAvcSamples(e, t, r, s) {
    if (e instanceof Uint8Array)
      throw new Error("Cannot decrypt samples of type Uint8Array");
    for (; ; t++, r = 0) {
      if (t >= e.length) {
        s();
        return;
      }
      const i = e[t].units;
      for (; !(r >= i.length); r++) {
        const o = i[r];
        if (!(o.data.length <= 48 || o.type !== 1 && o.type !== 5) && (this.decryptAvcSample(e, t, r, s, o), !this.decrypter.isSync()))
          return;
      }
    }
  }
}
class Fp {
  constructor() {
    this.VideoSample = null;
  }
  createVideoSample(e, t, r) {
    return {
      key: e,
      frame: !1,
      pts: t,
      dts: r,
      units: [],
      length: 0
    };
  }
  getLastNalUnit(e) {
    var t;
    let r = this.VideoSample, s;
    if ((!r || r.units.length === 0) && (r = e[e.length - 1]), (t = r) != null && t.units) {
      const i = r.units;
      s = i[i.length - 1];
    }
    return s;
  }
  pushAccessUnit(e, t) {
    if (e.units.length && e.frame) {
      if (e.pts === void 0) {
        const r = t.samples, s = r.length;
        if (s) {
          const i = r[s - 1];
          e.pts = i.pts, e.dts = i.dts;
        } else {
          t.dropped++;
          return;
        }
      }
      t.samples.push(e);
    }
  }
  parseNALu(e, t, r) {
    const s = t.byteLength;
    let i = e.naluState || 0;
    const o = i, a = [];
    let l = 0, c, u, d, h = -1, f = 0;
    for (i === -1 && (h = 0, f = this.getNALuType(t, 0), i = 0, l = 1); l < s; ) {
      if (c = t[l++], !i) {
        i = c ? 0 : 1;
        continue;
      }
      if (i === 1) {
        i = c ? 0 : 2;
        continue;
      }
      if (!c)
        i = 3;
      else if (c === 1) {
        if (u = l - i - 1, h >= 0) {
          const p = {
            data: t.subarray(h, u),
            type: f
          };
          a.push(p);
        } else {
          const p = this.getLastNalUnit(e.samples);
          p && (o && l <= 4 - o && p.state && (p.data = p.data.subarray(0, p.data.byteLength - o)), u > 0 && (p.data = Nr(p.data, t.subarray(0, u)), p.state = 0));
        }
        l < s ? (d = this.getNALuType(t, l), h = l, f = d, i = 0) : i = -1;
      } else
        i = 0;
    }
    if (h >= 0 && i >= 0) {
      const p = {
        data: t.subarray(h, s),
        type: f,
        state: i
      };
      a.push(p);
    }
    if (a.length === 0) {
      const p = this.getLastNalUnit(e.samples);
      p && (p.data = Nr(p.data, t));
    }
    return e.naluState = i, a;
  }
}
class yi {
  constructor(e) {
    this.data = void 0, this.bytesAvailable = void 0, this.word = void 0, this.bitsAvailable = void 0, this.data = e, this.bytesAvailable = e.byteLength, this.word = 0, this.bitsAvailable = 0;
  }
  // ():void
  loadWord() {
    const e = this.data, t = this.bytesAvailable, r = e.byteLength - t, s = new Uint8Array(4), i = Math.min(4, t);
    if (i === 0)
      throw new Error("no bytes available");
    s.set(e.subarray(r, r + i)), this.word = new DataView(s.buffer).getUint32(0), this.bitsAvailable = i * 8, this.bytesAvailable -= i;
  }
  // (count:int):void
  skipBits(e) {
    let t;
    e = Math.min(e, this.bytesAvailable * 8 + this.bitsAvailable), this.bitsAvailable > e ? (this.word <<= e, this.bitsAvailable -= e) : (e -= this.bitsAvailable, t = e >> 3, e -= t << 3, this.bytesAvailable -= t, this.loadWord(), this.word <<= e, this.bitsAvailable -= e);
  }
  // (size:int):uint
  readBits(e) {
    let t = Math.min(this.bitsAvailable, e);
    const r = this.word >>> 32 - t;
    if (e > 32 && Ze.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= t, this.bitsAvailable > 0)
      this.word <<= t;
    else if (this.bytesAvailable > 0)
      this.loadWord();
    else
      throw new Error("no bits available");
    return t = e - t, t > 0 && this.bitsAvailable ? r << t | this.readBits(t) : r;
  }
  // ():uint
  skipLZ() {
    let e;
    for (e = 0; e < this.bitsAvailable; ++e)
      if (this.word & 2147483648 >>> e)
        return this.word <<= e, this.bitsAvailable -= e, e;
    return this.loadWord(), e + this.skipLZ();
  }
  // ():void
  skipUEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():void
  skipEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():uint
  readUEG() {
    const e = this.skipLZ();
    return this.readBits(e + 1) - 1;
  }
  // ():int
  readEG() {
    const e = this.readUEG();
    return 1 & e ? 1 + e >>> 1 : -1 * (e >>> 1);
  }
  // Some convenience functions
  // :Boolean
  readBoolean() {
    return this.readBits(1) === 1;
  }
  // ():int
  readUByte() {
    return this.readBits(8);
  }
  // ():int
  readUShort() {
    return this.readBits(16);
  }
  // ():int
  readUInt() {
    return this.readBits(32);
  }
}
class Uh extends Fp {
  parsePES(e, t, r, s) {
    const i = this.parseNALu(e, r.data, s);
    let o = this.VideoSample, a, l = !1;
    r.data = null, o && i.length && !e.audFound && (this.pushAccessUnit(o, e), o = this.VideoSample = this.createVideoSample(!1, r.pts, r.dts)), i.forEach((c) => {
      var u, d;
      switch (c.type) {
        case 1: {
          let y = !1;
          a = !0;
          const m = c.data;
          if (l && m.length > 4) {
            const b = this.readSliceType(m);
            (b === 2 || b === 4 || b === 7 || b === 9) && (y = !0);
          }
          if (y) {
            var h;
            (h = o) != null && h.frame && !o.key && (this.pushAccessUnit(o, e), o = this.VideoSample = null);
          }
          o || (o = this.VideoSample = this.createVideoSample(!0, r.pts, r.dts)), o.frame = !0, o.key = y;
          break;
        }
        case 5:
          a = !0, (u = o) != null && u.frame && !o.key && (this.pushAccessUnit(o, e), o = this.VideoSample = null), o || (o = this.VideoSample = this.createVideoSample(!0, r.pts, r.dts)), o.key = !0, o.frame = !0;
          break;
        case 6: {
          a = !0, Ou(c.data, 1, r.pts, t.samples);
          break;
        }
        case 7: {
          var f, p;
          a = !0, l = !0;
          const y = c.data, m = this.readSPS(y);
          if (!e.sps || e.width !== m.width || e.height !== m.height || ((f = e.pixelRatio) == null ? void 0 : f[0]) !== m.pixelRatio[0] || ((p = e.pixelRatio) == null ? void 0 : p[1]) !== m.pixelRatio[1]) {
            e.width = m.width, e.height = m.height, e.pixelRatio = m.pixelRatio, e.sps = [y];
            const b = y.subarray(1, 4);
            let C = "avc1.";
            for (let A = 0; A < 3; A++) {
              let P = b[A].toString(16);
              P.length < 2 && (P = "0" + P), C += P;
            }
            e.codec = C;
          }
          break;
        }
        case 8:
          a = !0, e.pps = [c.data];
          break;
        case 9:
          a = !0, e.audFound = !0, (d = o) != null && d.frame && (this.pushAccessUnit(o, e), o = null), o || (o = this.VideoSample = this.createVideoSample(!1, r.pts, r.dts));
          break;
        case 12:
          a = !0;
          break;
        default:
          a = !1;
          break;
      }
      o && a && o.units.push(c);
    }), s && o && (this.pushAccessUnit(o, e), this.VideoSample = null);
  }
  getNALuType(e, t) {
    return e[t] & 31;
  }
  readSliceType(e) {
    const t = new yi(e);
    return t.readUByte(), t.readUEG(), t.readUEG();
  }
  /**
   * The scaling list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */
  skipScalingList(e, t) {
    let r = 8, s = 8, i;
    for (let o = 0; o < e; o++)
      s !== 0 && (i = t.readEG(), s = (r + i + 256) % 256), r = s === 0 ? r : s;
  }
  /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */
  readSPS(e) {
    const t = new yi(e);
    let r = 0, s = 0, i = 0, o = 0, a, l, c;
    const u = t.readUByte.bind(t), d = t.readBits.bind(t), h = t.readUEG.bind(t), f = t.readBoolean.bind(t), p = t.skipBits.bind(t), y = t.skipEG.bind(t), m = t.skipUEG.bind(t), b = this.skipScalingList.bind(this);
    u();
    const C = u();
    if (d(5), p(3), u(), m(), C === 100 || C === 110 || C === 122 || C === 244 || C === 44 || C === 83 || C === 86 || C === 118 || C === 128) {
      const G = h();
      if (G === 3 && p(1), m(), m(), p(1), f())
        for (l = G !== 3 ? 8 : 12, c = 0; c < l; c++)
          f() && (c < 6 ? b(16, t) : b(64, t));
    }
    m();
    const A = h();
    if (A === 0)
      h();
    else if (A === 1)
      for (p(1), y(), y(), a = h(), c = 0; c < a; c++)
        y();
    m(), p(1);
    const P = h(), I = h(), U = d(1);
    U === 0 && p(1), p(1), f() && (r = h(), s = h(), i = h(), o = h());
    let j = [1, 1];
    if (f() && f())
      switch (u()) {
        case 1:
          j = [1, 1];
          break;
        case 2:
          j = [12, 11];
          break;
        case 3:
          j = [10, 11];
          break;
        case 4:
          j = [16, 11];
          break;
        case 5:
          j = [40, 33];
          break;
        case 6:
          j = [24, 11];
          break;
        case 7:
          j = [20, 11];
          break;
        case 8:
          j = [32, 11];
          break;
        case 9:
          j = [80, 33];
          break;
        case 10:
          j = [18, 11];
          break;
        case 11:
          j = [15, 11];
          break;
        case 12:
          j = [64, 33];
          break;
        case 13:
          j = [160, 99];
          break;
        case 14:
          j = [4, 3];
          break;
        case 15:
          j = [3, 2];
          break;
        case 16:
          j = [2, 1];
          break;
        case 255: {
          j = [u() << 8 | u(), u() << 8 | u()];
          break;
        }
      }
    return {
      width: Math.ceil((P + 1) * 16 - r * 2 - s * 2),
      height: (2 - U) * (I + 1) * 16 - (U ? 2 : 4) * (i + o),
      pixelRatio: j
    };
  }
}
class $h extends Fp {
  constructor(...e) {
    super(...e), this.initVPS = null;
  }
  parsePES(e, t, r, s) {
    const i = this.parseNALu(e, r.data, s);
    let o = this.VideoSample, a, l = !1;
    r.data = null, o && i.length && !e.audFound && (this.pushAccessUnit(o, e), o = this.VideoSample = this.createVideoSample(!1, r.pts, r.dts)), i.forEach((c) => {
      var u, d;
      switch (c.type) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
          o || (o = this.VideoSample = this.createVideoSample(!1, r.pts, r.dts)), o.frame = !0, a = !0;
          break;
        case 16:
        case 17:
        case 18:
        case 21:
          if (a = !0, l) {
            var h;
            (h = o) != null && h.frame && !o.key && (this.pushAccessUnit(o, e), o = this.VideoSample = null);
          }
          o || (o = this.VideoSample = this.createVideoSample(!0, r.pts, r.dts)), o.key = !0, o.frame = !0;
          break;
        case 19:
        case 20:
          a = !0, (u = o) != null && u.frame && !o.key && (this.pushAccessUnit(o, e), o = this.VideoSample = null), o || (o = this.VideoSample = this.createVideoSample(!0, r.pts, r.dts)), o.key = !0, o.frame = !0;
          break;
        case 39:
          a = !0, Ou(
            c.data,
            2,
            // NALu header size
            r.pts,
            t.samples
          );
          break;
        case 32:
          a = !0, e.vps || (typeof e.params != "object" && (e.params = {}), e.params = st(e.params, this.readVPS(c.data)), this.initVPS = c.data), e.vps = [c.data];
          break;
        case 33:
          if (a = !0, l = !0, e.vps !== void 0 && e.vps[0] !== this.initVPS && e.sps !== void 0 && !this.matchSPS(e.sps[0], c.data) && (this.initVPS = e.vps[0], e.sps = e.pps = void 0), !e.sps) {
            const f = this.readSPS(c.data);
            e.width = f.width, e.height = f.height, e.pixelRatio = f.pixelRatio, e.codec = f.codecString, e.sps = [], typeof e.params != "object" && (e.params = {});
            for (const p in f.params)
              e.params[p] = f.params[p];
          }
          this.pushParameterSet(e.sps, c.data, e.vps), o || (o = this.VideoSample = this.createVideoSample(!0, r.pts, r.dts)), o.key = !0;
          break;
        case 34:
          if (a = !0, typeof e.params == "object") {
            if (!e.pps) {
              e.pps = [];
              const f = this.readPPS(c.data);
              for (const p in f)
                e.params[p] = f[p];
            }
            this.pushParameterSet(e.pps, c.data, e.vps);
          }
          break;
        case 35:
          a = !0, e.audFound = !0, (d = o) != null && d.frame && (this.pushAccessUnit(o, e), o = null), o || (o = this.VideoSample = this.createVideoSample(!1, r.pts, r.dts));
          break;
        default:
          a = !1;
          break;
      }
      o && a && o.units.push(c);
    }), s && o && (this.pushAccessUnit(o, e), this.VideoSample = null);
  }
  pushParameterSet(e, t, r) {
    (r && r[0] === this.initVPS || !r && !e.length) && e.push(t);
  }
  getNALuType(e, t) {
    return (e[t] & 126) >>> 1;
  }
  ebsp2rbsp(e) {
    const t = new Uint8Array(e.byteLength);
    let r = 0;
    for (let s = 0; s < e.byteLength; s++)
      s >= 2 && e[s] === 3 && e[s - 1] === 0 && e[s - 2] === 0 || (t[r] = e[s], r++);
    return new Uint8Array(t.buffer, 0, r);
  }
  pushAccessUnit(e, t) {
    super.pushAccessUnit(e, t), this.initVPS && (this.initVPS = null);
  }
  readVPS(e) {
    const t = new yi(e);
    t.readUByte(), t.readUByte(), t.readBits(4), t.skipBits(2), t.readBits(6);
    const r = t.readBits(3), s = t.readBoolean();
    return {
      numTemporalLayers: r + 1,
      temporalIdNested: s
    };
  }
  readSPS(e) {
    const t = new yi(this.ebsp2rbsp(e));
    t.readUByte(), t.readUByte(), t.readBits(4);
    const r = t.readBits(3);
    t.readBoolean();
    const s = t.readBits(2), i = t.readBoolean(), o = t.readBits(5), a = t.readUByte(), l = t.readUByte(), c = t.readUByte(), u = t.readUByte(), d = t.readUByte(), h = t.readUByte(), f = t.readUByte(), p = t.readUByte(), y = t.readUByte(), m = t.readUByte(), b = t.readUByte(), C = [], A = [];
    for (let me = 0; me < r; me++)
      C.push(t.readBoolean()), A.push(t.readBoolean());
    if (r > 0)
      for (let me = r; me < 8; me++)
        t.readBits(2);
    for (let me = 0; me < r; me++)
      C[me] && (t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte()), A[me] && t.readUByte();
    t.readUEG();
    const P = t.readUEG();
    P == 3 && t.skipBits(1);
    const I = t.readUEG(), U = t.readUEG(), j = t.readBoolean();
    let G = 0, F = 0, B = 0, V = 0;
    j && (G += t.readUEG(), F += t.readUEG(), B += t.readUEG(), V += t.readUEG());
    const H = t.readUEG(), L = t.readUEG(), g = t.readUEG(), x = t.readBoolean();
    for (let me = x ? 0 : r; me <= r; me++)
      t.skipUEG(), t.skipUEG(), t.skipUEG();
    if (t.skipUEG(), t.skipUEG(), t.skipUEG(), t.skipUEG(), t.skipUEG(), t.skipUEG(), t.readBoolean() && t.readBoolean())
      for (let xe = 0; xe < 4; xe++)
        for (let Pe = 0; Pe < (xe === 3 ? 2 : 6); Pe++)
          if (!t.readBoolean())
            t.readUEG();
          else {
            const be = Math.min(64, 1 << 4 + (xe << 1));
            xe > 1 && t.readEG();
            for (let Me = 0; Me < be; Me++)
              t.readEG();
          }
    t.readBoolean(), t.readBoolean(), t.readBoolean() && (t.readUByte(), t.skipUEG(), t.skipUEG(), t.readBoolean());
    const D = t.readUEG();
    let O = 0;
    for (let me = 0; me < D; me++) {
      let xe = !1;
      if (me !== 0 && (xe = t.readBoolean()), xe) {
        me === D && t.readUEG(), t.readBoolean(), t.readUEG();
        let Pe = 0;
        for (let Qe = 0; Qe <= O; Qe++) {
          const be = t.readBoolean();
          let Me = !1;
          be || (Me = t.readBoolean()), (be || Me) && Pe++;
        }
        O = Pe;
      } else {
        const Pe = t.readUEG(), Qe = t.readUEG();
        O = Pe + Qe;
        for (let be = 0; be < Pe; be++)
          t.readUEG(), t.readBoolean();
        for (let be = 0; be < Qe; be++)
          t.readUEG(), t.readBoolean();
      }
    }
    if (t.readBoolean()) {
      const me = t.readUEG();
      for (let xe = 0; xe < me; xe++) {
        for (let Pe = 0; Pe < g + 4; Pe++)
          t.readBits(1);
        t.readBits(1);
      }
    }
    let R = 0, v = 1, M = 1, te = !0, ee = 1, ne = 0;
    t.readBoolean(), t.readBoolean();
    let Ce = !1;
    if (t.readBoolean()) {
      if (t.readBoolean()) {
        const pt = t.readUByte(), et = [1, 12, 10, 16, 40, 24, 20, 32, 80, 18, 15, 64, 160, 4, 3, 2], tt = [1, 11, 11, 11, 33, 11, 11, 11, 33, 11, 11, 33, 99, 3, 2, 1];
        pt > 0 && pt < 16 ? (v = et[pt - 1], M = tt[pt - 1]) : pt === 255 && (v = t.readBits(16), M = t.readBits(16));
      }
      if (t.readBoolean() && t.readBoolean(), t.readBoolean() && (t.readBits(3), t.readBoolean(), t.readBoolean() && (t.readUByte(), t.readUByte(), t.readUByte())), t.readBoolean() && (t.readUEG(), t.readUEG()), t.readBoolean(), t.readBoolean(), t.readBoolean(), Ce = t.readBoolean(), Ce && (G += t.readUEG(), F += t.readUEG(), B += t.readUEG(), V += t.readUEG()), t.readBoolean() && (ee = t.readBits(32), ne = t.readBits(32), t.readBoolean() && t.readUEG(), t.readBoolean())) {
        const tt = t.readBoolean(), at = t.readBoolean();
        let Ve = !1;
        (tt || at) && (Ve = t.readBoolean(), Ve && (t.readUByte(), t.readBits(5), t.readBoolean(), t.readBits(5)), t.readBits(4), t.readBits(4), Ve && t.readBits(4), t.readBits(5), t.readBits(5), t.readBits(5));
        for (let k = 0; k <= r; k++) {
          te = t.readBoolean();
          const E = te || t.readBoolean();
          let S = !1;
          E ? t.readEG() : S = t.readBoolean();
          const $ = S ? 1 : t.readUEG() + 1;
          if (tt)
            for (let W = 0; W < $; W++)
              t.readUEG(), t.readUEG(), Ve && (t.readUEG(), t.readUEG()), t.skipBits(1);
          if (at)
            for (let W = 0; W < $; W++)
              t.readUEG(), t.readUEG(), Ve && (t.readUEG(), t.readUEG()), t.skipBits(1);
        }
      }
      t.readBoolean() && (t.readBoolean(), t.readBoolean(), t.readBoolean(), R = t.readUEG());
    }
    let Ae = I, qt = U;
    if (j || Ce) {
      let me = 1, xe = 1;
      P === 1 ? me = xe = 2 : P == 2 && (me = 2), Ae = I - me * F - me * G, qt = U - xe * V - xe * B;
    }
    const qe = s ? ["A", "B", "C"][s] : "", ct = a << 24 | l << 16 | c << 8 | u;
    let Ge = 0;
    for (let me = 0; me < 32; me++)
      Ge = (Ge | (ct >> me & 1) << 31 - me) >>> 0;
    let ye = Ge.toString(16);
    return o === 1 && ye === "2" && (ye = "6"), {
      codecString: `hvc1.${qe}${o}.${ye}.${i ? "H" : "L"}${b}.B0`,
      params: {
        general_tier_flag: i,
        general_profile_idc: o,
        general_profile_space: s,
        general_profile_compatibility_flags: [a, l, c, u],
        general_constraint_indicator_flags: [d, h, f, p, y, m],
        general_level_idc: b,
        bit_depth: H + 8,
        bit_depth_luma_minus8: H,
        bit_depth_chroma_minus8: L,
        min_spatial_segmentation_idc: R,
        chroma_format_idc: P,
        frame_rate: {
          fixed: te,
          fps: ne / ee
        }
      },
      width: Ae,
      height: qt,
      pixelRatio: [v, M]
    };
  }
  readPPS(e) {
    const t = new yi(this.ebsp2rbsp(e));
    t.readUByte(), t.readUByte(), t.skipUEG(), t.skipUEG(), t.skipBits(2), t.skipBits(3), t.skipBits(2), t.skipUEG(), t.skipUEG(), t.skipEG(), t.skipBits(2), t.readBoolean() && t.skipUEG(), t.skipEG(), t.skipEG(), t.skipBits(4);
    const s = t.readBoolean(), i = t.readBoolean();
    let o = 1;
    return i && s ? o = 0 : i ? o = 3 : s && (o = 2), {
      parallelismType: o
    };
  }
  matchSPS(e, t) {
    return String.fromCharCode.apply(null, e).substr(3) === String.fromCharCode.apply(null, t).substr(3);
  }
}
const zt = 188;
class Gn {
  constructor(e, t, r, s) {
    this.logger = void 0, this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.sampleAes = null, this.pmtParsed = !1, this.audioCodec = void 0, this.videoCodec = void 0, this._pmtId = -1, this._videoTrack = void 0, this._audioTrack = void 0, this._id3Track = void 0, this._txtTrack = void 0, this.aacOverFlow = null, this.remainderData = null, this.videoParser = void 0, this.observer = e, this.config = t, this.typeSupported = r, this.logger = s, this.videoParser = null;
  }
  static probe(e, t) {
    const r = Gn.syncOffset(e);
    return r > 0 && t.warn(`MPEG2-TS detected but first sync word found @ offset ${r}`), r !== -1;
  }
  static syncOffset(e) {
    const t = e.length;
    let r = Math.min(zt * 5, t - zt) + 1, s = 0;
    for (; s < r; ) {
      let i = !1, o = -1, a = 0;
      for (let l = s; l < t; l += zt)
        if (e[l] === 71 && (t - l === zt || e[l + zt] === 71)) {
          if (a++, o === -1 && (o = l, o !== 0 && (r = Math.min(o + zt * 99, e.length - zt) + 1)), i || (i = Rc(e, l) === 0), i && a > 1 && (o === 0 && a > 2 || l + zt > r))
            return o;
        } else {
          if (a)
            return -1;
          break;
        }
      s++;
    }
    return -1;
  }
  /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */
  static createTrack(e, t) {
    return {
      container: e === "video" || e === "audio" ? "video/mp2t" : void 0,
      type: e,
      id: Wg[e],
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0,
      duration: e === "audio" ? t : void 0
    };
  }
  /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */
  resetInitSegment(e, t, r, s) {
    this.pmtParsed = !1, this._pmtId = -1, this._videoTrack = Gn.createTrack("video"), this._videoTrack.duration = s, this._audioTrack = Gn.createTrack("audio", s), this._id3Track = Gn.createTrack("id3"), this._txtTrack = Gn.createTrack("text"), this._audioTrack.segmentCodec = "aac", this.aacOverFlow = null, this.remainderData = null, this.audioCodec = t, this.videoCodec = r;
  }
  resetTimeStamp() {
  }
  resetContiguity() {
    const {
      _audioTrack: e,
      _videoTrack: t,
      _id3Track: r
    } = this;
    e && (e.pesData = null), t && (t.pesData = null), r && (r.pesData = null), this.aacOverFlow = null, this.remainderData = null;
  }
  demux(e, t, r = !1, s = !1) {
    r || (this.sampleAes = null);
    let i;
    const o = this._videoTrack, a = this._audioTrack, l = this._id3Track, c = this._txtTrack;
    let u = o.pid, d = o.pesData, h = a.pid, f = l.pid, p = a.pesData, y = l.pesData, m = null, b = this.pmtParsed, C = this._pmtId, A = e.length;
    if (this.remainderData && (e = Nr(this.remainderData, e), A = e.length, this.remainderData = null), A < zt && !s)
      return this.remainderData = e, {
        audioTrack: a,
        videoTrack: o,
        id3Track: l,
        textTrack: c
      };
    const P = Math.max(0, Gn.syncOffset(e));
    A -= (A - P) % zt, A < e.byteLength && !s && (this.remainderData = new Uint8Array(e.buffer, A, e.buffer.byteLength - A));
    let I = 0;
    for (let j = P; j < A; j += zt)
      if (e[j] === 71) {
        const G = !!(e[j + 1] & 64), F = Rc(e, j), B = (e[j + 3] & 48) >> 4;
        let V;
        if (B > 1) {
          if (V = j + 5 + e[j + 4], V === j + zt)
            continue;
        } else
          V = j + 4;
        switch (F) {
          case u:
            if (G) {
              if (d && (i = Cs(d, this.logger))) {
                if (this.videoParser === null)
                  switch (o.segmentCodec) {
                    case "avc":
                      this.videoParser = new Uh();
                      break;
                    case "hevc":
                      this.videoParser = new $h();
                      break;
                  }
                this.videoParser !== null && this.videoParser.parsePES(o, c, i, !1);
              }
              d = {
                data: [],
                size: 0
              };
            }
            d && (d.data.push(e.subarray(V, j + zt)), d.size += j + zt - V);
            break;
          case h:
            if (G) {
              if (p && (i = Cs(p, this.logger)))
                switch (a.segmentCodec) {
                  case "aac":
                    this.parseAACPES(a, i);
                    break;
                  case "mp3":
                    this.parseMPEGPES(a, i);
                    break;
                  case "ac3":
                    this.parseAC3PES(a, i);
                    break;
                }
              p = {
                data: [],
                size: 0
              };
            }
            p && (p.data.push(e.subarray(V, j + zt)), p.size += j + zt - V);
            break;
          case f:
            G && (y && (i = Cs(y, this.logger)) && this.parseID3PES(l, i), y = {
              data: [],
              size: 0
            }), y && (y.data.push(e.subarray(V, j + zt)), y.size += j + zt - V);
            break;
          case 0:
            G && (V += e[V] + 1), C = this._pmtId = s2(e, V);
            break;
          case C: {
            G && (V += e[V] + 1);
            const H = i2(e, V, this.typeSupported, r, this.observer, this.logger);
            u = H.videoPid, u > 0 && (o.pid = u, o.segmentCodec = H.segmentVideoCodec), h = H.audioPid, h > 0 && (a.pid = h, a.segmentCodec = H.segmentAudioCodec), f = H.id3Pid, f > 0 && (l.pid = f), m !== null && !b && (this.logger.warn(`MPEG-TS PMT found at ${j} after unknown PID '${m}'. Backtracking to sync byte @${P} to parse all TS packets.`), m = null, j = P - 188), b = this.pmtParsed = !0;
            break;
          }
          case 17:
          case 8191:
            break;
          default:
            m = F;
            break;
        }
      } else
        I++;
    I > 0 && Cc(this.observer, new Error(`Found ${I} TS packet/s that do not start with 0x47`), void 0, this.logger), o.pesData = d, a.pesData = p, l.pesData = y;
    const U = {
      audioTrack: a,
      videoTrack: o,
      id3Track: l,
      textTrack: c
    };
    return s && this.extractRemainingSamples(U), U;
  }
  flush() {
    const {
      remainderData: e
    } = this;
    this.remainderData = null;
    let t;
    return e ? t = this.demux(e, -1, !1, !0) : t = {
      videoTrack: this._videoTrack,
      audioTrack: this._audioTrack,
      id3Track: this._id3Track,
      textTrack: this._txtTrack
    }, this.extractRemainingSamples(t), this.sampleAes ? this.decrypt(t, this.sampleAes) : t;
  }
  extractRemainingSamples(e) {
    const {
      audioTrack: t,
      videoTrack: r,
      id3Track: s,
      textTrack: i
    } = e, o = r.pesData, a = t.pesData, l = s.pesData;
    let c;
    if (o && (c = Cs(o, this.logger))) {
      if (this.videoParser === null)
        switch (r.segmentCodec) {
          case "avc":
            this.videoParser = new Uh();
            break;
          case "hevc":
            this.videoParser = new $h();
            break;
        }
      this.videoParser !== null && (this.videoParser.parsePES(r, i, c, !0), r.pesData = null);
    } else
      r.pesData = o;
    if (a && (c = Cs(a, this.logger))) {
      switch (t.segmentCodec) {
        case "aac":
          this.parseAACPES(t, c);
          break;
        case "mp3":
          this.parseMPEGPES(t, c);
          break;
        case "ac3":
          this.parseAC3PES(t, c);
          break;
      }
      t.pesData = null;
    } else
      a != null && a.size && this.logger.log("last AAC PES packet truncated,might overlap between fragments"), t.pesData = a;
    l && (c = Cs(l, this.logger)) ? (this.parseID3PES(s, c), s.pesData = null) : s.pesData = l;
  }
  demuxSampleAes(e, t, r) {
    const s = this.demux(e, r, !0, !this.config.progressive), i = this.sampleAes = new n2(this.observer, this.config, t);
    return this.decrypt(s, i);
  }
  decrypt(e, t) {
    return new Promise((r) => {
      const {
        audioTrack: s,
        videoTrack: i
      } = e;
      s.samples && s.segmentCodec === "aac" ? t.decryptAacSamples(s.samples, 0, () => {
        i.samples ? t.decryptAvcSamples(i.samples, 0, 0, () => {
          r(e);
        }) : r(e);
      }) : i.samples && t.decryptAvcSamples(i.samples, 0, 0, () => {
        r(e);
      });
    });
  }
  destroy() {
    this.observer && this.observer.removeAllListeners(), this.config = this.logger = this.observer = null, this.aacOverFlow = this.videoParser = this.remainderData = this.sampleAes = null, this._videoTrack = this._audioTrack = this._id3Track = this._txtTrack = void 0;
  }
  parseAACPES(e, t) {
    let r = 0;
    const s = this.aacOverFlow;
    let i = t.data;
    if (s) {
      this.aacOverFlow = null;
      const d = s.missing, h = s.sample.unit.byteLength;
      if (d === -1)
        i = Nr(s.sample.unit, i);
      else {
        const f = h - d;
        s.sample.unit.set(i.subarray(0, d), f), e.samples.push(s.sample), r = s.missing;
      }
    }
    let o, a;
    for (o = r, a = i.length; o < a - 1 && !ba(i, o); o++)
      ;
    if (o !== r) {
      let d;
      const h = o < a - 1;
      if (h ? d = `AAC PES did not start with ADTS header,offset:${o}` : d = "No ADTS header found in AAC PES", Cc(this.observer, new Error(d), h, this.logger), !h)
        return;
    }
    Ip(e, this.observer, i, o, this.audioCodec);
    let l;
    if (t.pts !== void 0)
      l = t.pts;
    else if (s) {
      const d = _p(e.samplerate);
      l = s.sample.pts + d;
    } else {
      this.logger.warn("[tsdemuxer]: AAC PES unknown PTS");
      return;
    }
    let c = 0, u;
    for (; o < a; )
      if (u = Lp(e, i, o, l, c), o += u.length, u.missing) {
        this.aacOverFlow = u;
        break;
      } else
        for (c++; o < a - 1 && !ba(i, o); o++)
          ;
  }
  parseMPEGPES(e, t) {
    const r = t.data, s = r.length;
    let i = 0, o = 0;
    const a = t.pts;
    if (a === void 0) {
      this.logger.warn("[tsdemuxer]: MPEG PES unknown PTS");
      return;
    }
    for (; o < s; )
      if (Pp(r, o)) {
        const l = kp(e, r, o, a, i);
        if (l)
          o += l.length, i++;
        else
          break;
      } else
        o++;
  }
  parseAC3PES(e, t) {
    {
      const r = t.data, s = t.pts;
      if (s === void 0) {
        this.logger.warn("[tsdemuxer]: AC3 PES unknown PTS");
        return;
      }
      const i = r.length;
      let o = 0, a = 0, l;
      for (; a < i && (l = Bp(e, r, a, s, o++)) > 0; )
        a += l;
    }
  }
  parseID3PES(e, t) {
    if (t.pts === void 0) {
      this.logger.warn("[tsdemuxer]: ID3 PES unknown PTS");
      return;
    }
    const r = st({}, t, {
      type: this._videoTrack ? Ir.emsg : Ir.audioId3,
      duration: Number.POSITIVE_INFINITY
    });
    e.samples.push(r);
  }
}
function Rc(n, e) {
  return ((n[e + 1] & 31) << 8) + n[e + 2];
}
function s2(n, e) {
  return (n[e + 10] & 31) << 8 | n[e + 11];
}
function i2(n, e, t, r, s, i) {
  const o = {
    audioPid: -1,
    videoPid: -1,
    id3Pid: -1,
    segmentVideoCodec: "avc",
    segmentAudioCodec: "aac"
  }, a = (n[e + 1] & 15) << 8 | n[e + 2], l = e + 3 + a - 4, c = (n[e + 10] & 15) << 8 | n[e + 11];
  for (e += 12 + c; e < l; ) {
    const u = Rc(n, e), d = (n[e + 3] & 15) << 8 | n[e + 4];
    switch (n[e]) {
      case 207:
        if (!r) {
          Ml("ADTS AAC", i);
          break;
        }
      case 15:
        o.audioPid === -1 && (o.audioPid = u);
        break;
      case 21:
        o.id3Pid === -1 && (o.id3Pid = u);
        break;
      case 219:
        if (!r) {
          Ml("H.264", i);
          break;
        }
      case 27:
        o.videoPid === -1 && (o.videoPid = u);
        break;
      case 3:
      case 4:
        !t.mpeg && !t.mp3 ? i.log("MPEG audio found, not supported in this browser") : o.audioPid === -1 && (o.audioPid = u, o.segmentAudioCodec = "mp3");
        break;
      case 193:
        if (!r) {
          Ml("AC-3", i);
          break;
        }
      case 129:
        t.ac3 ? o.audioPid === -1 && (o.audioPid = u, o.segmentAudioCodec = "ac3") : i.log("AC-3 audio found, not supported in this browser");
        break;
      case 6:
        if (o.audioPid === -1 && d > 0) {
          let h = e + 5, f = d;
          for (; f > 2; ) {
            switch (n[h]) {
              case 106:
                t.ac3 !== !0 ? i.log("AC-3 audio found, not supported in this browser for now") : (o.audioPid = u, o.segmentAudioCodec = "ac3");
                break;
            }
            const y = n[h + 1] + 2;
            h += y, f -= y;
          }
        }
        break;
      case 194:
      case 135:
        return Cc(s, new Error("Unsupported EC-3 in M2TS found"), void 0, i), o;
      case 36:
        o.videoPid === -1 && (o.videoPid = u, o.segmentVideoCodec = "hevc", i.log("HEVC in M2TS found"));
        break;
    }
    e += d + 5;
  }
  return o;
}
function Cc(n, e, t, r) {
  r.warn(`parsing error: ${e.message}`), n.emit(T.ERROR, T.ERROR, {
    type: ge.MEDIA_ERROR,
    details: Y.FRAG_PARSING_ERROR,
    fatal: !1,
    levelRetry: t,
    error: e,
    reason: e.message
  });
}
function Ml(n, e) {
  e.log(`${n} with AES-128-CBC encryption found in unencrypted stream`);
}
function Cs(n, e) {
  let t = 0, r, s, i, o, a;
  const l = n.data;
  if (!n || n.size === 0)
    return null;
  for (; l[0].length < 19 && l.length > 1; )
    l[0] = Nr(l[0], l[1]), l.splice(1, 1);
  if (r = l[0], (r[0] << 16) + (r[1] << 8) + r[2] === 1) {
    if (s = (r[4] << 8) + r[5], s && s > n.size - 6)
      return null;
    const u = r[7];
    u & 192 && (o = (r[9] & 14) * 536870912 + // 1 << 29
    (r[10] & 255) * 4194304 + // 1 << 22
    (r[11] & 254) * 16384 + // 1 << 14
    (r[12] & 255) * 128 + // 1 << 7
    (r[13] & 254) / 2, u & 64 ? (a = (r[14] & 14) * 536870912 + // 1 << 29
    (r[15] & 255) * 4194304 + // 1 << 22
    (r[16] & 254) * 16384 + // 1 << 14
    (r[17] & 255) * 128 + // 1 << 7
    (r[18] & 254) / 2, o - a > 60 * 9e4 && (e.warn(`${Math.round((o - a) / 9e4)}s delta between PTS and DTS, align them`), o = a)) : a = o), i = r[8];
    let d = i + 9;
    if (n.size <= d)
      return null;
    n.size -= d;
    const h = new Uint8Array(n.size);
    for (let f = 0, p = l.length; f < p; f++) {
      r = l[f];
      let y = r.byteLength;
      if (d)
        if (d > y) {
          d -= y;
          continue;
        } else
          r = r.subarray(d), y -= d, d = 0;
      h.set(r, t), t += y;
    }
    return s && (s -= i + 3), {
      data: h,
      pts: o,
      dts: a,
      len: s
    };
  }
  return null;
}
class o2 {
  static getSilentFrame(e, t) {
    switch (e) {
      case "mp4a.40.2":
        if (t === 1)
          return new Uint8Array([0, 200, 0, 128, 35, 128]);
        if (t === 2)
          return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
        if (t === 3)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
        if (t === 4)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
        if (t === 5)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
        if (t === 6)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
        break;
      default:
        if (t === 1)
          return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 2)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 3)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        break;
    }
  }
}
const Bn = Math.pow(2, 32) - 1;
class q {
  static init() {
    q.types = {
      avc1: [],
      // codingname
      avcC: [],
      hvc1: [],
      hvcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      ".mp3": [],
      dac3: [],
      "ac-3": [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: [],
      smhd: []
    };
    let e;
    for (e in q.types)
      q.types.hasOwnProperty(e) && (q.types[e] = [e.charCodeAt(0), e.charCodeAt(1), e.charCodeAt(2), e.charCodeAt(3)]);
    const t = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      118,
      105,
      100,
      101,
      // handler_type: 'vide'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      86,
      105,
      100,
      101,
      111,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'VideoHandler'
    ]), r = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      115,
      111,
      117,
      110,
      // handler_type: 'soun'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      83,
      111,
      117,
      110,
      100,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'SoundHandler'
    ]);
    q.HDLR_TYPES = {
      video: t,
      audio: r
    };
    const s = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // entry_count
      0,
      0,
      0,
      12,
      // entry_size
      117,
      114,
      108,
      32,
      // 'url' type
      0,
      // version 0
      0,
      0,
      1
      // entry_flags
    ]), i = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0
      // entry_count
    ]);
    q.STTS = q.STSC = q.STCO = i, q.STSZ = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // sample_size
      0,
      0,
      0,
      0
      // sample_count
    ]), q.VMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      1,
      // flags
      0,
      0,
      // graphicsmode
      0,
      0,
      0,
      0,
      0,
      0
      // opcolor
    ]), q.SMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      // balance
      0,
      0
      // reserved
    ]), q.STSD = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1
    ]);
    const o = new Uint8Array([105, 115, 111, 109]), a = new Uint8Array([97, 118, 99, 49]), l = new Uint8Array([0, 0, 0, 1]);
    q.FTYP = q.box(q.types.ftyp, o, l, o, a), q.DINF = q.box(q.types.dinf, q.box(q.types.dref, s));
  }
  static box(e, ...t) {
    let r = 8, s = t.length;
    const i = s;
    for (; s--; )
      r += t[s].byteLength;
    const o = new Uint8Array(r);
    for (o[0] = r >> 24 & 255, o[1] = r >> 16 & 255, o[2] = r >> 8 & 255, o[3] = r & 255, o.set(e, 4), s = 0, r = 8; s < i; s++)
      o.set(t[s], r), r += t[s].byteLength;
    return o;
  }
  static hdlr(e) {
    return q.box(q.types.hdlr, q.HDLR_TYPES[e]);
  }
  static mdat(e) {
    return q.box(q.types.mdat, e);
  }
  static mdhd(e, t) {
    t *= e;
    const r = Math.floor(t / (Bn + 1)), s = Math.floor(t % (Bn + 1));
    return q.box(q.types.mdhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      r >> 24,
      r >> 16 & 255,
      r >> 8 & 255,
      r & 255,
      s >> 24,
      s >> 16 & 255,
      s >> 8 & 255,
      s & 255,
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]));
  }
  static mdia(e) {
    return q.box(q.types.mdia, q.mdhd(e.timescale || 0, e.duration || 0), q.hdlr(e.type), q.minf(e));
  }
  static mfhd(e) {
    return q.box(q.types.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      e >> 24,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255
      // sequence_number
    ]));
  }
  static minf(e) {
    return e.type === "audio" ? q.box(q.types.minf, q.box(q.types.smhd, q.SMHD), q.DINF, q.stbl(e)) : q.box(q.types.minf, q.box(q.types.vmhd, q.VMHD), q.DINF, q.stbl(e));
  }
  static moof(e, t, r) {
    return q.box(q.types.moof, q.mfhd(e), q.traf(r, t));
  }
  static moov(e) {
    let t = e.length;
    const r = [];
    for (; t--; )
      r[t] = q.trak(e[t]);
    return q.box.apply(null, [q.types.moov, q.mvhd(e[0].timescale || 0, e[0].duration || 0)].concat(r).concat(q.mvex(e)));
  }
  static mvex(e) {
    let t = e.length;
    const r = [];
    for (; t--; )
      r[t] = q.trex(e[t]);
    return q.box.apply(null, [q.types.mvex, ...r]);
  }
  static mvhd(e, t) {
    t *= e;
    const r = Math.floor(t / (Bn + 1)), s = Math.floor(t % (Bn + 1)), i = new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      r >> 24,
      r >> 16 & 255,
      r >> 8 & 255,
      r & 255,
      s >> 24,
      s >> 16 & 255,
      s >> 8 & 255,
      s & 255,
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return q.box(q.types.mvhd, i);
  }
  static sdtp(e) {
    const t = e.samples || [], r = new Uint8Array(4 + t.length);
    let s, i;
    for (s = 0; s < t.length; s++)
      i = t[s].flags, r[s + 4] = i.dependsOn << 4 | i.isDependedOn << 2 | i.hasRedundancy;
    return q.box(q.types.sdtp, r);
  }
  static stbl(e) {
    return q.box(q.types.stbl, q.stsd(e), q.box(q.types.stts, q.STTS), q.box(q.types.stsc, q.STSC), q.box(q.types.stsz, q.STSZ), q.box(q.types.stco, q.STCO));
  }
  static avc1(e) {
    let t = [], r = [], s, i, o;
    for (s = 0; s < e.sps.length; s++)
      i = e.sps[s], o = i.byteLength, t.push(o >>> 8 & 255), t.push(o & 255), t = t.concat(Array.prototype.slice.call(i));
    for (s = 0; s < e.pps.length; s++)
      i = e.pps[s], o = i.byteLength, r.push(o >>> 8 & 255), r.push(o & 255), r = r.concat(Array.prototype.slice.call(i));
    const a = q.box(q.types.avcC, new Uint8Array([
      1,
      // version
      t[3],
      // profile
      t[4],
      // profile compat
      t[5],
      // level
      255,
      // lengthSizeMinusOne, hard-coded to 4 bytes
      224 | e.sps.length
      // 3bit reserved (111) + numOfSequenceParameterSets
    ].concat(t).concat([
      e.pps.length
      // numOfPictureParameterSets
    ]).concat(r))), l = e.width, c = e.height, u = e.pixelRatio[0], d = e.pixelRatio[1];
    return q.box(
      q.types.avc1,
      new Uint8Array([
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        l >> 8 & 255,
        l & 255,
        // width
        c >> 8 & 255,
        c & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        18,
        100,
        97,
        105,
        108,
        // dailymotion/hls.js
        121,
        109,
        111,
        116,
        105,
        111,
        110,
        47,
        104,
        108,
        115,
        46,
        106,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
      ]),
      // pre_defined = -1
      a,
      q.box(q.types.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
      ])),
      // avgBitrate
      q.box(q.types.pasp, new Uint8Array([
        u >> 24,
        // hSpacing
        u >> 16 & 255,
        u >> 8 & 255,
        u & 255,
        d >> 24,
        // vSpacing
        d >> 16 & 255,
        d >> 8 & 255,
        d & 255
      ]))
    );
  }
  static esds(e) {
    const t = e.config;
    return new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      3,
      // descriptor_type
      25,
      // length
      0,
      1,
      // es_id
      0,
      // stream_priority
      4,
      // descriptor_type
      17,
      // length
      64,
      // codec : mpeg4_audio
      21,
      // stream_type
      0,
      0,
      0,
      // buffer_size
      0,
      0,
      0,
      0,
      // maxBitrate
      0,
      0,
      0,
      0,
      // avgBitrate
      5,
      // descriptor_type
      2,
      // length
      ...t,
      6,
      1,
      2
      // GASpecificConfig)); // length + audio config descriptor
    ]);
  }
  static audioStsd(e) {
    const t = e.samplerate || 0;
    return new Uint8Array([
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      // reserved
      0,
      1,
      // data_reference_index
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      e.channelCount || 0,
      // channelcount
      0,
      16,
      // sampleSize:16bits
      0,
      0,
      0,
      0,
      // reserved2
      t >> 8 & 255,
      t & 255,
      //
      0,
      0
    ]);
  }
  static mp4a(e) {
    return q.box(q.types.mp4a, q.audioStsd(e), q.box(q.types.esds, q.esds(e)));
  }
  static mp3(e) {
    return q.box(q.types[".mp3"], q.audioStsd(e));
  }
  static ac3(e) {
    return q.box(q.types["ac-3"], q.audioStsd(e), q.box(q.types.dac3, e.config));
  }
  static stsd(e) {
    const {
      segmentCodec: t
    } = e;
    if (e.type === "audio") {
      if (t === "aac")
        return q.box(q.types.stsd, q.STSD, q.mp4a(e));
      if (t === "ac3" && e.config)
        return q.box(q.types.stsd, q.STSD, q.ac3(e));
      if (t === "mp3" && e.codec === "mp3")
        return q.box(q.types.stsd, q.STSD, q.mp3(e));
    } else if (e.pps && e.sps) {
      if (t === "avc")
        return q.box(q.types.stsd, q.STSD, q.avc1(e));
      if (t === "hevc" && e.vps)
        return q.box(q.types.stsd, q.STSD, q.hvc1(e));
    } else
      throw new Error("video track missing pps or sps");
    throw new Error(`unsupported ${e.type} segment codec (${t}/${e.codec})`);
  }
  static tkhd(e) {
    const t = e.id, r = (e.duration || 0) * (e.timescale || 0), s = e.width || 0, i = e.height || 0, o = Math.floor(r / (Bn + 1)), a = Math.floor(r % (Bn + 1));
    return q.box(q.types.tkhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      t >> 24 & 255,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      o >> 24,
      o >> 16 & 255,
      o >> 8 & 255,
      o & 255,
      a >> 24,
      a >> 16 & 255,
      a >> 8 & 255,
      a & 255,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      0,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      s >> 8 & 255,
      s & 255,
      0,
      0,
      // width
      i >> 8 & 255,
      i & 255,
      0,
      0
      // height
    ]));
  }
  static traf(e, t) {
    const r = q.sdtp(e), s = e.id, i = Math.floor(t / (Bn + 1)), o = Math.floor(t % (Bn + 1));
    return q.box(
      q.types.traf,
      q.box(q.types.tfhd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        s >> 24,
        s >> 16 & 255,
        s >> 8 & 255,
        s & 255
        // track_ID
      ])),
      q.box(q.types.tfdt, new Uint8Array([
        1,
        // version 1
        0,
        0,
        0,
        // flags
        i >> 24,
        i >> 16 & 255,
        i >> 8 & 255,
        i & 255,
        o >> 24,
        o >> 16 & 255,
        o >> 8 & 255,
        o & 255
      ])),
      q.trun(e, r.length + 16 + // tfhd
      20 + // tfdt
      8 + // traf header
      16 + // mfhd
      8 + // moof header
      8),
      // mdat header
      r
    );
  }
  /**
   * Generate a track box.
   * @param track a track definition
   */
  static trak(e) {
    return e.duration = e.duration || 4294967295, q.box(q.types.trak, q.tkhd(e), q.mdia(e));
  }
  static trex(e) {
    const t = e.id;
    return q.box(q.types.trex, new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      t >> 24,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]));
  }
  static trun(e, t) {
    const r = e.samples || [], s = r.length, i = 12 + 16 * s, o = new Uint8Array(i);
    let a, l, c, u, d, h;
    for (t += 8 + i, o.set([
      e.type === "video" ? 1 : 0,
      // version 1 for video with signed-int sample_composition_time_offset
      0,
      15,
      1,
      // flags
      s >>> 24 & 255,
      s >>> 16 & 255,
      s >>> 8 & 255,
      s & 255,
      // sample_count
      t >>> 24 & 255,
      t >>> 16 & 255,
      t >>> 8 & 255,
      t & 255
      // data_offset
    ], 0), a = 0; a < s; a++)
      l = r[a], c = l.duration, u = l.size, d = l.flags, h = l.cts, o.set([
        c >>> 24 & 255,
        c >>> 16 & 255,
        c >>> 8 & 255,
        c & 255,
        // sample_duration
        u >>> 24 & 255,
        u >>> 16 & 255,
        u >>> 8 & 255,
        u & 255,
        // sample_size
        d.isLeading << 2 | d.dependsOn,
        d.isDependedOn << 6 | d.hasRedundancy << 4 | d.paddingValue << 1 | d.isNonSync,
        d.degradPrio & 61440,
        d.degradPrio & 15,
        // sample_flags
        h >>> 24 & 255,
        h >>> 16 & 255,
        h >>> 8 & 255,
        h & 255
        // sample_composition_time_offset
      ], 12 + 16 * a);
    return q.box(q.types.trun, o);
  }
  static initSegment(e) {
    q.types || q.init();
    const t = q.moov(e);
    return Nr(q.FTYP, t);
  }
  static hvc1(e) {
    const t = e.params, r = [e.vps, e.sps, e.pps], s = 4, i = new Uint8Array([1, t.general_profile_space << 6 | (t.general_tier_flag ? 32 : 0) | t.general_profile_idc, t.general_profile_compatibility_flags[0], t.general_profile_compatibility_flags[1], t.general_profile_compatibility_flags[2], t.general_profile_compatibility_flags[3], t.general_constraint_indicator_flags[0], t.general_constraint_indicator_flags[1], t.general_constraint_indicator_flags[2], t.general_constraint_indicator_flags[3], t.general_constraint_indicator_flags[4], t.general_constraint_indicator_flags[5], t.general_level_idc, 240 | t.min_spatial_segmentation_idc >> 8, 255 & t.min_spatial_segmentation_idc, 252 | t.parallelismType, 252 | t.chroma_format_idc, 248 | t.bit_depth_luma_minus8, 248 | t.bit_depth_chroma_minus8, 0, parseInt(t.frame_rate.fps), s - 1 | t.temporal_id_nested << 2 | t.num_temporal_layers << 3 | (t.frame_rate.fixed ? 64 : 0), r.length]);
    let o = i.length;
    for (let p = 0; p < r.length; p += 1) {
      o += 3;
      for (let y = 0; y < r[p].length; y += 1)
        o += 2 + r[p][y].length;
    }
    const a = new Uint8Array(o);
    a.set(i, 0), o = i.length;
    const l = r.length - 1;
    for (let p = 0; p < r.length; p += 1) {
      a.set(new Uint8Array([32 + p | (p === l ? 128 : 0), 0, r[p].length]), o), o += 3;
      for (let y = 0; y < r[p].length; y += 1)
        a.set(new Uint8Array([r[p][y].length >> 8, r[p][y].length & 255]), o), o += 2, a.set(r[p][y], o), o += r[p][y].length;
    }
    const c = q.box(q.types.hvcC, a), u = e.width, d = e.height, h = e.pixelRatio[0], f = e.pixelRatio[1];
    return q.box(
      q.types.hvc1,
      new Uint8Array([
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        u >> 8 & 255,
        u & 255,
        // width
        d >> 8 & 255,
        d & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        18,
        100,
        97,
        105,
        108,
        // dailymotion/hls.js
        121,
        109,
        111,
        116,
        105,
        111,
        110,
        47,
        104,
        108,
        115,
        46,
        106,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
      ]),
      // pre_defined = -1
      c,
      q.box(q.types.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
      ])),
      // avgBitrate
      q.box(q.types.pasp, new Uint8Array([
        h >> 24,
        // hSpacing
        h >> 16 & 255,
        h >> 8 & 255,
        h & 255,
        f >> 24,
        // vSpacing
        f >> 16 & 255,
        f >> 8 & 255,
        f & 255
      ]))
    );
  }
}
q.types = void 0;
q.HDLR_TYPES = void 0;
q.STTS = void 0;
q.STSC = void 0;
q.STCO = void 0;
q.STSZ = void 0;
q.VMHD = void 0;
q.SMHD = void 0;
q.STSD = void 0;
q.FTYP = void 0;
q.DINF = void 0;
const Np = 9e4;
function zu(n, e, t = 1, r = !1) {
  const s = n * e * t;
  return r ? Math.round(s) : s;
}
function a2(n, e, t = 1, r = !1) {
  return zu(n, e, 1 / t, r);
}
function ci(n, e = !1) {
  return zu(n, 1e3, 1 / Np, e);
}
function l2(n, e = 1) {
  return zu(n, Np, 1 / e);
}
const c2 = 10 * 1e3, u2 = 1024, d2 = 1152, h2 = 1536;
let ks = null, Ol = null;
function Gh(n, e, t, r) {
  return {
    duration: e,
    size: t,
    cts: r,
    flags: {
      isLeading: 0,
      isDependedOn: 0,
      hasRedundancy: 0,
      degradPrio: 0,
      dependsOn: n ? 2 : 1,
      isNonSync: n ? 0 : 1
    }
  };
}
class Do {
  constructor(e, t, r, s) {
    if (this.logger = void 0, this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.ISGenerated = !1, this._initPTS = null, this._initDTS = null, this.nextAvcDts = null, this.nextAudioPts = null, this.videoSampleDuration = null, this.isAudioContiguous = !1, this.isVideoContiguous = !1, this.videoTrackConfig = void 0, this.observer = e, this.config = t, this.typeSupported = r, this.logger = s, this.ISGenerated = !1, ks === null) {
      const o = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      ks = o ? parseInt(o[1]) : 0;
    }
    if (Ol === null) {
      const i = navigator.userAgent.match(/Safari\/(\d+)/i);
      Ol = i ? parseInt(i[1]) : 0;
    }
  }
  destroy() {
    this.config = this.videoTrackConfig = this._initPTS = this._initDTS = null;
  }
  resetTimeStamp(e) {
    this.logger.log("[mp4-remuxer]: initPTS & initDTS reset"), this._initPTS = this._initDTS = e;
  }
  resetNextTimestamp() {
    this.logger.log("[mp4-remuxer]: reset next timestamp"), this.isVideoContiguous = !1, this.isAudioContiguous = !1;
  }
  resetInitSegment() {
    this.logger.log("[mp4-remuxer]: ISGenerated flag reset"), this.ISGenerated = !1, this.videoTrackConfig = void 0;
  }
  getVideoStartPts(e) {
    let t = !1;
    const r = e[0].pts, s = e.reduce((i, o) => {
      let a = o.pts, l = a - i;
      return l < -4294967296 && (t = !0, a = Pr(a, r), l = a - i), l > 0 ? i : a;
    }, r);
    return t && this.logger.debug("PTS rollover detected"), s;
  }
  remux(e, t, r, s, i, o, a, l) {
    let c, u, d, h, f, p, y = i, m = i;
    const b = e.pid > -1, C = t.pid > -1, A = t.samples.length, P = e.samples.length > 0, I = a && A > 0 || A > 1;
    if ((!b || P) && (!C || I) || this.ISGenerated || a) {
      if (this.ISGenerated) {
        var j, G, F, B;
        const g = this.videoTrackConfig;
        (g && (t.width !== g.width || t.height !== g.height || ((j = t.pixelRatio) == null ? void 0 : j[0]) !== ((G = g.pixelRatio) == null ? void 0 : G[0]) || ((F = t.pixelRatio) == null ? void 0 : F[1]) !== ((B = g.pixelRatio) == null ? void 0 : B[1])) || !g && I || this.nextAudioPts === null && P) && this.resetInitSegment();
      }
      this.ISGenerated || (d = this.generateIS(e, t, i, o));
      const V = this.isVideoContiguous;
      let H = -1, L;
      if (I && (H = f2(t.samples), !V && this.config.forceKeyFrameOnDiscontinuity))
        if (p = !0, H > 0) {
          this.logger.warn(`[mp4-remuxer]: Dropped ${H} out of ${A} video samples due to a missing keyframe`);
          const g = this.getVideoStartPts(t.samples);
          t.samples = t.samples.slice(H), t.dropped += H, m += (t.samples[0].pts - g) / t.inputTimeScale, L = m;
        } else H === -1 && (this.logger.warn(`[mp4-remuxer]: No keyframe found out of ${A} video samples`), p = !1);
      if (this.ISGenerated) {
        if (P && I) {
          const g = this.getVideoStartPts(t.samples), w = (Pr(e.samples[0].pts, g) - g) / t.inputTimeScale;
          y += Math.max(0, w), m += Math.max(0, -w);
        }
        if (P) {
          if (e.samplerate || (this.logger.warn("[mp4-remuxer]: regenerate InitSegment as audio detected"), d = this.generateIS(e, t, i, o)), u = this.remuxAudio(e, y, this.isAudioContiguous, o, C || I || l === he.AUDIO ? m : void 0), I) {
            const g = u ? u.endPTS - u.startPTS : 0;
            t.inputTimeScale || (this.logger.warn("[mp4-remuxer]: regenerate InitSegment as video detected"), d = this.generateIS(e, t, i, o)), c = this.remuxVideo(t, m, V, g);
          }
        } else I && (c = this.remuxVideo(t, m, V, 0));
        c && (c.firstKeyFrame = H, c.independent = H !== -1, c.firstKeyFramePTS = L);
      }
    }
    return this.ISGenerated && this._initPTS && this._initDTS && (r.samples.length && (f = Up(r, i, this._initPTS, this._initDTS)), s.samples.length && (h = $p(s, i, this._initPTS))), {
      audio: u,
      video: c,
      initSegment: d,
      independent: p,
      text: h,
      id3: f
    };
  }
  generateIS(e, t, r, s) {
    const i = e.samples, o = t.samples, a = this.typeSupported, l = {}, c = this._initPTS;
    let u = !c || s, d = "audio/mp4", h, f, p, y;
    if (u && (h = f = 1 / 0), e.config && i.length) {
      switch (e.timescale = e.samplerate, e.segmentCodec) {
        case "mp3":
          a.mpeg ? (d = "audio/mpeg", e.codec = "") : a.mp3 && (e.codec = "mp3");
          break;
        case "ac3":
          e.codec = "ac-3";
          break;
      }
      l.audio = {
        id: "audio",
        container: d,
        codec: e.codec,
        initSegment: e.segmentCodec === "mp3" && a.mpeg ? new Uint8Array(0) : q.initSegment([e]),
        metadata: {
          channelCount: e.channelCount
        }
      }, u && (y = e.id, p = e.inputTimeScale, !c || p !== c.timescale ? h = f = i[0].pts - Math.round(p * r) : u = !1);
    }
    if (t.sps && t.pps && o.length) {
      if (t.timescale = t.inputTimeScale, l.video = {
        id: "main",
        container: "video/mp4",
        codec: t.codec,
        initSegment: q.initSegment([t]),
        metadata: {
          width: t.width,
          height: t.height
        }
      }, u)
        if (y = t.id, p = t.inputTimeScale, !c || p !== c.timescale) {
          const m = this.getVideoStartPts(o), b = Math.round(p * r);
          f = Math.min(f, Pr(o[0].dts, m) - b), h = Math.min(h, m - b);
        } else
          u = !1;
      this.videoTrackConfig = {
        width: t.width,
        height: t.height,
        pixelRatio: t.pixelRatio
      };
    }
    if (Object.keys(l).length)
      return this.ISGenerated = !0, u ? (this._initPTS = {
        baseTime: h,
        timescale: p
      }, this._initDTS = {
        baseTime: f,
        timescale: p
      }) : h = p = void 0, {
        tracks: l,
        initPTS: h,
        timescale: p,
        trackId: y
      };
  }
  remuxVideo(e, t, r, s) {
    const i = e.inputTimeScale, o = e.samples, a = [], l = o.length, c = this._initPTS;
    let u = this.nextAvcDts, d = 8, h = this.videoSampleDuration, f, p, y = Number.POSITIVE_INFINITY, m = Number.NEGATIVE_INFINITY, b = !1;
    if (!r || u === null) {
      const O = t * i, N = o[0].pts - Pr(o[0].dts, o[0].pts);
      ks && u !== null && Math.abs(O - N - u) < 15e3 ? r = !0 : u = O - N;
    }
    const C = c.baseTime * i / c.timescale;
    for (let O = 0; O < l; O++) {
      const N = o[O];
      N.pts = Pr(N.pts - C, u), N.dts = Pr(N.dts - C, u), N.dts < o[O > 0 ? O - 1 : O].dts && (b = !0);
    }
    b && o.sort(function(O, N) {
      const R = O.dts - N.dts, v = O.pts - N.pts;
      return R || v;
    }), f = o[0].dts, p = o[o.length - 1].dts;
    const A = p - f, P = A ? Math.round(A / (l - 1)) : h || e.inputTimeScale / 30;
    if (r) {
      const O = f - u, N = O > P, R = O < -1;
      if ((N || R) && (N ? this.logger.warn(`${(e.segmentCodec || "").toUpperCase()}: ${ci(O, !0)} ms (${O}dts) hole between fragments detected at ${t.toFixed(3)}`) : this.logger.warn(`${(e.segmentCodec || "").toUpperCase()}: ${ci(-O, !0)} ms (${O}dts) overlapping between fragments detected at ${t.toFixed(3)}`), !R || u >= o[0].pts || ks)) {
        f = u;
        const v = o[0].pts - O;
        if (N)
          o[0].dts = f, o[0].pts = v;
        else {
          let M = !0;
          for (let te = 0; te < o.length && !(o[te].dts > v && M); te++) {
            const ee = o[te].pts;
            if (o[te].dts -= O, o[te].pts -= O, te < o.length - 1) {
              const ne = o[te + 1].pts, Ce = o[te].pts, ve = ne <= Ce, Ae = ne <= ee;
              M = ve == Ae;
            }
          }
        }
        this.logger.log(`Video: Initial PTS/DTS adjusted: ${ci(v, !0)}/${ci(f, !0)}, delta: ${ci(O, !0)} ms`);
      }
    }
    f = Math.max(0, f);
    let I = 0, U = 0, j = f;
    for (let O = 0; O < l; O++) {
      const N = o[O], R = N.units, v = R.length;
      let M = 0;
      for (let te = 0; te < v; te++)
        M += R[te].data.length;
      U += M, I += v, N.length = M, N.dts < j ? (N.dts = j, j += P / 4 | 0 || 1) : j = N.dts, y = Math.min(N.pts, y), m = Math.max(N.pts, m);
    }
    p = o[l - 1].dts;
    const G = U + 4 * I + 8;
    let F;
    try {
      F = new Uint8Array(G);
    } catch (O) {
      this.observer.emit(T.ERROR, T.ERROR, {
        type: ge.MUX_ERROR,
        details: Y.REMUX_ALLOC_ERROR,
        fatal: !1,
        error: O,
        bytes: G,
        reason: `fail allocating video mdat ${G}`
      });
      return;
    }
    const B = new DataView(F.buffer);
    B.setUint32(0, G), F.set(q.types.mdat, 4);
    let V = !1, H = Number.POSITIVE_INFINITY, L = Number.POSITIVE_INFINITY, g = Number.NEGATIVE_INFINITY, x = Number.NEGATIVE_INFINITY;
    for (let O = 0; O < l; O++) {
      const N = o[O], R = N.units;
      let v = 0;
      for (let ee = 0, ne = R.length; ee < ne; ee++) {
        const Ce = R[ee], ve = Ce.data, Ae = Ce.data.byteLength;
        B.setUint32(d, Ae), d += 4, F.set(ve, d), d += Ae, v += 4 + Ae;
      }
      let M;
      if (O < l - 1)
        h = o[O + 1].dts - N.dts, M = o[O + 1].pts - N.pts;
      else {
        const ee = this.config, ne = O > 0 ? N.dts - o[O - 1].dts : P;
        if (M = O > 0 ? N.pts - o[O - 1].pts : P, ee.stretchShortVideoTrack && this.nextAudioPts !== null) {
          const Ce = Math.floor(ee.maxBufferHole * i), ve = (s ? y + s * i : this.nextAudioPts) - N.pts;
          ve > Ce ? (h = ve - ne, h < 0 ? h = ne : V = !0, this.logger.log(`[mp4-remuxer]: It is approximately ${ve / 90} ms to the next segment; using duration ${h / 90} ms for the last video frame.`)) : h = ne;
        } else
          h = ne;
      }
      const te = Math.round(N.pts - N.dts);
      H = Math.min(H, h), g = Math.max(g, h), L = Math.min(L, M), x = Math.max(x, M), a.push(Gh(N.key, h, v, te));
    }
    if (a.length) {
      if (ks) {
        if (ks < 70) {
          const O = a[0].flags;
          O.dependsOn = 2, O.isNonSync = 0;
        }
      } else if (Ol && x - L < g - H && P / g < 0.025 && a[0].cts === 0) {
        this.logger.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");
        let O = f;
        for (let N = 0, R = a.length; N < R; N++) {
          const v = O + a[N].duration, M = O + a[N].cts;
          if (N < R - 1) {
            const te = v + a[N + 1].cts;
            a[N].duration = te - M;
          } else
            a[N].duration = N ? a[N - 1].duration : P;
          a[N].cts = 0, O = v;
        }
      }
    }
    h = V || !h ? P : h, this.nextAvcDts = u = p + h, this.videoSampleDuration = h, this.isVideoContiguous = !0;
    const D = {
      data1: q.moof(e.sequenceNumber++, f, st(e, {
        samples: a
      })),
      data2: F,
      startPTS: y / i,
      endPTS: (m + h) / i,
      startDTS: f / i,
      endDTS: u / i,
      type: "video",
      hasAudio: !1,
      hasVideo: !0,
      nb: a.length,
      dropped: e.dropped
    };
    return e.samples = [], e.dropped = 0, D;
  }
  getSamplesPerFrame(e) {
    switch (e.segmentCodec) {
      case "mp3":
        return d2;
      case "ac3":
        return h2;
      default:
        return u2;
    }
  }
  remuxAudio(e, t, r, s, i) {
    const o = e.inputTimeScale, a = e.samplerate ? e.samplerate : o, l = o / a, c = this.getSamplesPerFrame(e), u = c * l, d = this._initPTS, h = e.segmentCodec === "mp3" && this.typeSupported.mpeg, f = [], p = i !== void 0;
    let y = e.samples, m = h ? 0 : 8, b = this.nextAudioPts || -1;
    const C = t * o, A = d.baseTime * o / d.timescale;
    if (this.isAudioContiguous = r = r || y.length && b > 0 && (s && Math.abs(C - b) < 9e3 || Math.abs(Pr(y[0].pts - A, C) - b) < 20 * u), y.forEach(function(w) {
      w.pts = Pr(w.pts - A, C);
    }), !r || b < 0) {
      if (y = y.filter((w) => w.pts >= 0), !y.length)
        return;
      i === 0 ? b = 0 : s && !p ? b = Math.max(0, C) : b = y[0].pts;
    }
    if (e.segmentCodec === "aac") {
      const w = this.config.maxAudioFramesDrift;
      for (let _ = 0, D = b; _ < y.length; _++) {
        const O = y[_], N = O.pts, R = N - D, v = Math.abs(1e3 * R / o);
        if (R <= -w * u && p)
          _ === 0 && (this.logger.warn(`Audio frame @ ${(N / o).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1e3 * R / o)} ms.`), this.nextAudioPts = b = D = N);
        else if (R >= w * u && v < c2 && p) {
          let M = Math.round(R / u);
          D = N - M * u, D < 0 && (M--, D += u), _ === 0 && (this.nextAudioPts = b = D), this.logger.warn(`[mp4-remuxer]: Injecting ${M} audio frame @ ${(D / o).toFixed(3)}s due to ${Math.round(1e3 * R / o)} ms gap.`);
          for (let te = 0; te < M; te++) {
            const ee = Math.max(D, 0);
            let ne = o2.getSilentFrame(e.parsedCodec || e.manifestCodec || e.codec, e.channelCount);
            ne || (this.logger.log("[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead."), ne = O.unit.subarray()), y.splice(_, 0, {
              unit: ne,
              pts: ee
            }), D += u, _++;
          }
        }
        O.pts = D, D += u;
      }
    }
    let P = null, I = null, U, j = 0, G = y.length;
    for (; G--; )
      j += y[G].unit.byteLength;
    for (let w = 0, _ = y.length; w < _; w++) {
      const D = y[w], O = D.unit;
      let N = D.pts;
      if (I !== null) {
        const v = f[w - 1];
        v.duration = Math.round((N - I) / l);
      } else if (r && e.segmentCodec === "aac" && (N = b), P = N, j > 0) {
        j += m;
        try {
          U = new Uint8Array(j);
        } catch (v) {
          this.observer.emit(T.ERROR, T.ERROR, {
            type: ge.MUX_ERROR,
            details: Y.REMUX_ALLOC_ERROR,
            fatal: !1,
            error: v,
            bytes: j,
            reason: `fail allocating audio mdat ${j}`
          });
          return;
        }
        h || (new DataView(U.buffer).setUint32(0, j), U.set(q.types.mdat, 4));
      } else
        return;
      U.set(O, m);
      const R = O.byteLength;
      m += R, f.push(Gh(!0, c, R, 0)), I = N;
    }
    const F = f.length;
    if (!F)
      return;
    const B = f[f.length - 1];
    this.nextAudioPts = b = I + l * B.duration;
    const V = h ? new Uint8Array(0) : q.moof(e.sequenceNumber++, P / l, st({}, e, {
      samples: f
    }));
    e.samples = [];
    const H = P / o, L = b / o, x = {
      data1: V,
      data2: U,
      startPTS: H,
      endPTS: L,
      startDTS: H,
      endDTS: L,
      type: "audio",
      hasAudio: !0,
      hasVideo: !1,
      nb: F
    };
    return this.isAudioContiguous = !0, x;
  }
}
function Pr(n, e) {
  let t;
  if (e === null)
    return n;
  for (e < n ? t = -8589934592 : t = 8589934592; Math.abs(n - e) > 4294967296; )
    n += t;
  return n;
}
function f2(n) {
  for (let e = 0; e < n.length; e++)
    if (n[e].key)
      return e;
  return -1;
}
function Up(n, e, t, r) {
  const s = n.samples.length;
  if (!s)
    return;
  const i = n.inputTimeScale;
  for (let a = 0; a < s; a++) {
    const l = n.samples[a];
    l.pts = Pr(l.pts - t.baseTime * i / t.timescale, e * i) / i, l.dts = Pr(l.dts - r.baseTime * i / r.timescale, e * i) / i;
  }
  const o = n.samples;
  return n.samples = [], {
    samples: o
  };
}
function $p(n, e, t) {
  const r = n.samples.length;
  if (!r)
    return;
  const s = n.inputTimeScale;
  for (let o = 0; o < r; o++) {
    const a = n.samples[o];
    a.pts = Pr(a.pts - t.baseTime * s / t.timescale, e * s) / s;
  }
  n.samples.sort((o, a) => o.pts - a.pts);
  const i = n.samples;
  return n.samples = [], {
    samples: i
  };
}
class g2 {
  constructor(e, t, r, s) {
    this.logger = void 0, this.emitInitSegment = !1, this.audioCodec = void 0, this.videoCodec = void 0, this.initData = void 0, this.initPTS = null, this.initTracks = void 0, this.lastEndTime = null, this.isVideoContiguous = !1, this.logger = s;
  }
  destroy() {
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.lastEndTime = null;
  }
  resetNextTimestamp() {
    this.isVideoContiguous = !1, this.lastEndTime = null;
  }
  resetInitSegment(e, t, r, s) {
    this.audioCodec = t, this.videoCodec = r, this.generateInitSegment(lb(e, s)), this.emitInitSegment = !0;
  }
  generateInitSegment(e) {
    let {
      audioCodec: t,
      videoCodec: r
    } = this;
    if (!(e != null && e.byteLength)) {
      this.initTracks = void 0, this.initData = void 0;
      return;
    }
    const s = this.initData = Yg(e);
    s.audio && (t = jh(s.audio, lt.AUDIO, this.logger)), s.video && (r = jh(s.video, lt.VIDEO, this.logger));
    const i = {};
    s.audio && s.video ? i.audiovideo = {
      container: "video/mp4",
      codec: t + "," + r,
      supplemental: s.video.supplemental,
      initSegment: e,
      id: "main"
    } : s.audio ? i.audio = {
      container: "audio/mp4",
      codec: t,
      initSegment: e,
      id: "audio"
    } : s.video ? i.video = {
      container: "video/mp4",
      codec: r,
      supplemental: s.video.supplemental,
      initSegment: e,
      id: "main"
    } : this.logger.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes."), this.initTracks = i;
  }
  remux(e, t, r, s, i, o) {
    var a, l;
    let {
      initPTS: c,
      lastEndTime: u
    } = this;
    const d = {
      audio: void 0,
      video: void 0,
      text: s,
      id3: r,
      initSegment: void 0
    };
    ae(u) || (u = this.lastEndTime = i || 0);
    const h = t.samples;
    if (!(h != null && h.length))
      return d;
    const f = {
      initPTS: void 0,
      timescale: void 0,
      trackId: void 0
    };
    let p = this.initData;
    if ((a = p) != null && a.length || (this.generateInitSegment(h), p = this.initData), !((l = p) != null && l.length))
      return this.logger.warn("[passthrough-remuxer.ts]: Failed to generate initSegment."), d;
    this.emitInitSegment && (f.tracks = this.initTracks, this.emitInitSegment = !1);
    const y = cb(h, p, this.logger), m = p.audio ? y[p.audio.id] : null, b = p.video ? y[p.video.id] : null, C = yo(b, 1 / 0), A = yo(m, 1 / 0), P = yo(b, 0, !0), I = yo(m, 0, !0);
    let U, j = i, G = 0;
    if (m && (!b || !c && A < C || c && c.trackId === p.audio.id) ? (f.trackId = p.audio.id, U = m, G = I - A) : b && (f.trackId = p.video.id, U = b, G = P - C), U) {
      const w = U.timescale;
      j = U.start / w, f.timescale = w, c || (f.initPTS = U.start - i * w, this.initPTS = c = {
        baseTime: f.initPTS,
        timescale: w,
        trackId: f.trackId
      });
    }
    (o || !c) && (p2(c, j, i, G) || f.timescale !== c.timescale) && (f.initPTS = j - i, c && c.timescale === 1 && this.logger.warn(`Adjusting initPTS @${i} from ${c.baseTime / c.timescale} to ${f.initPTS}`), this.initPTS = c = {
      baseTime: f.initPTS,
      timescale: 1
    });
    const F = e ? j - c.baseTime / c.timescale : u;
    ub(p, h, c.baseTime / c.timescale);
    const B = F + G;
    G > 0 ? this.lastEndTime = B : (this.logger.warn("Duration parsed from mp4 should be greater than zero"), this.resetNextTimestamp());
    const V = !!p.audio, H = !!p.video;
    let L = "";
    V && (L += "audio"), H && (L += "video");
    const g = {
      data1: h,
      startPTS: F,
      startDTS: F,
      endPTS: B,
      endDTS: B,
      type: L,
      hasAudio: V,
      hasVideo: H,
      nb: 1,
      dropped: 0
    };
    d.audio = V && !H ? g : void 0, d.video = H ? g : void 0;
    const x = b == null ? void 0 : b.sampleCount;
    if (x) {
      const w = b.keyFrameIndex, _ = w !== -1;
      g.nb = x, g.dropped = w === 0 || this.isVideoContiguous ? 0 : _ ? w : x, g.independent = _, g.firstKeyFrame = w, _ && b.keyFrameStart && (g.firstKeyFramePTS = b.keyFrameStart - c.baseTime / c.timescale), this.isVideoContiguous || (d.independent = _), this.isVideoContiguous || (this.isVideoContiguous = _), g.dropped && this.logger.warn(`fmp4 does not start with IDR: firstIDR ${w}/${x} dropped: ${g.dropped} pts: ${g.firstKeyFramePTS || "NA"}`);
    }
    return d.initSegment = f, d.id3 = Up(r, i, c, c), s.samples.length && (d.text = $p(s, i, c)), d;
  }
}
function yo(n, e, t = !1) {
  return (n == null ? void 0 : n.start) !== void 0 ? (n.start + (t ? n.duration : 0)) / n.timescale : e;
}
function p2(n, e, t, r) {
  if (n === null)
    return !0;
  const s = Math.max(r, 1), i = e - n.baseTime / n.timescale;
  return Math.abs(i - t) > s;
}
function jh(n, e, t) {
  const r = n == null ? void 0 : n.codec;
  return r && r.length > 4 ? r : e === lt.AUDIO ? r === "ec-3" || r === "ac-3" || r === "alac" ? r : r === "fLaC" || r === "Opus" ? pa(r, !1) : (t.warn(`Unhandled audio codec "${r}" in mp4 MAP`), r || "mp4a") : (t.warn(`Unhandled video codec "${r}" in mp4 MAP`), r || "avc1");
}
let Sn;
try {
  Sn = self.performance.now.bind(self.performance);
} catch {
  Sn = Date.now;
}
const Po = [{
  demux: r2,
  remux: g2
}, {
  demux: Gn,
  remux: Do
}, {
  demux: JT,
  remux: Do
}, {
  demux: e2,
  remux: Do
}];
Po.splice(2, 0, {
  demux: QT,
  remux: Do
});
class Vh {
  constructor(e, t, r, s, i, o) {
    this.asyncResult = !1, this.logger = void 0, this.observer = void 0, this.typeSupported = void 0, this.config = void 0, this.id = void 0, this.demuxer = void 0, this.remuxer = void 0, this.decrypter = void 0, this.probe = void 0, this.decryptionPromise = null, this.transmuxConfig = void 0, this.currentTransmuxState = void 0, this.observer = e, this.typeSupported = t, this.config = r, this.id = i, this.logger = o;
  }
  configure(e) {
    this.transmuxConfig = e, this.decrypter && this.decrypter.reset();
  }
  push(e, t, r, s) {
    const i = r.transmuxing;
    i.executeStart = Sn();
    let o = new Uint8Array(e);
    const {
      currentTransmuxState: a,
      transmuxConfig: l
    } = this;
    s && (this.currentTransmuxState = s);
    const {
      contiguous: c,
      discontinuity: u,
      trackSwitch: d,
      accurateTimeOffset: h,
      timeOffset: f,
      initSegmentChange: p
    } = s || a, {
      audioCodec: y,
      videoCodec: m,
      defaultInitPts: b,
      duration: C,
      initSegmentData: A
    } = l, P = m2(o, t);
    if (P && Gs(P.method)) {
      const G = this.getDecrypter(), F = Uu(P.method);
      if (G.isSync()) {
        let B = G.softwareDecrypt(o, P.key.buffer, P.iv.buffer, F);
        if (r.part > -1) {
          const H = G.flush();
          B = H && H.buffer;
        }
        if (!B)
          return i.executeEnd = Sn(), Bl(r);
        o = new Uint8Array(B);
      } else
        return this.asyncResult = !0, this.decryptionPromise = G.webCryptoDecrypt(o, P.key.buffer, P.iv.buffer, F).then((B) => {
          const V = this.push(B, null, r);
          return this.decryptionPromise = null, V;
        }), this.decryptionPromise;
    }
    const I = this.needsProbing(u, d);
    if (I) {
      const G = this.configureTransmuxer(o);
      if (G)
        return this.logger.warn(`[transmuxer] ${G.message}`), this.observer.emit(T.ERROR, T.ERROR, {
          type: ge.MEDIA_ERROR,
          details: Y.FRAG_PARSING_ERROR,
          fatal: !1,
          error: G,
          reason: G.message
        }), i.executeEnd = Sn(), Bl(r);
    }
    (u || d || p || I) && this.resetInitSegment(A, y, m, C, t), (u || p || I) && this.resetInitialTimestamp(b), c || this.resetContiguity();
    const U = this.transmux(o, P, f, h, r);
    this.asyncResult = Gi(U);
    const j = this.currentTransmuxState;
    return j.contiguous = !0, j.discontinuity = !1, j.trackSwitch = !1, i.executeEnd = Sn(), U;
  }
  // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
  flush(e) {
    const t = e.transmuxing;
    t.executeStart = Sn();
    const {
      decrypter: r,
      currentTransmuxState: s,
      decryptionPromise: i
    } = this;
    if (i)
      return this.asyncResult = !0, i.then(() => this.flush(e));
    const o = [], {
      timeOffset: a
    } = s;
    if (r) {
      const d = r.flush();
      d && o.push(this.push(d.buffer, null, e));
    }
    const {
      demuxer: l,
      remuxer: c
    } = this;
    if (!l || !c) {
      t.executeEnd = Sn();
      const d = [Bl(e)];
      return this.asyncResult ? Promise.resolve(d) : d;
    }
    const u = l.flush(a);
    return Gi(u) ? (this.asyncResult = !0, u.then((d) => (this.flushRemux(o, d, e), o))) : (this.flushRemux(o, u, e), this.asyncResult ? Promise.resolve(o) : o);
  }
  flushRemux(e, t, r) {
    const {
      audioTrack: s,
      videoTrack: i,
      id3Track: o,
      textTrack: a
    } = t, {
      accurateTimeOffset: l,
      timeOffset: c
    } = this.currentTransmuxState;
    this.logger.log(`[transmuxer.ts]: Flushed ${this.id} sn: ${r.sn}${r.part > -1 ? " part: " + r.part : ""} of ${this.id === he.MAIN ? "level" : "track"} ${r.level}`);
    const u = this.remuxer.remux(s, i, o, a, c, l, !0, this.id);
    e.push({
      remuxResult: u,
      chunkMeta: r
    }), r.transmuxing.executeEnd = Sn();
  }
  resetInitialTimestamp(e) {
    const {
      demuxer: t,
      remuxer: r
    } = this;
    !t || !r || (t.resetTimeStamp(e), r.resetTimeStamp(e));
  }
  resetContiguity() {
    const {
      demuxer: e,
      remuxer: t
    } = this;
    !e || !t || (e.resetContiguity(), t.resetNextTimestamp());
  }
  resetInitSegment(e, t, r, s, i) {
    const {
      demuxer: o,
      remuxer: a
    } = this;
    !o || !a || (o.resetInitSegment(e, t, r, s), a.resetInitSegment(e, t, r, i));
  }
  destroy() {
    this.demuxer && (this.demuxer.destroy(), this.demuxer = void 0), this.remuxer && (this.remuxer.destroy(), this.remuxer = void 0);
  }
  transmux(e, t, r, s, i) {
    let o;
    return t && t.method === "SAMPLE-AES" ? o = this.transmuxSampleAes(e, t, r, s, i) : o = this.transmuxUnencrypted(e, r, s, i), o;
  }
  transmuxUnencrypted(e, t, r, s) {
    const {
      audioTrack: i,
      videoTrack: o,
      id3Track: a,
      textTrack: l
    } = this.demuxer.demux(e, t, !1, !this.config.progressive);
    return {
      remuxResult: this.remuxer.remux(i, o, a, l, t, r, !1, this.id),
      chunkMeta: s
    };
  }
  transmuxSampleAes(e, t, r, s, i) {
    return this.demuxer.demuxSampleAes(e, t, r).then((o) => ({
      remuxResult: this.remuxer.remux(o.audioTrack, o.videoTrack, o.id3Track, o.textTrack, r, s, !1, this.id),
      chunkMeta: i
    }));
  }
  configureTransmuxer(e) {
    const {
      config: t,
      observer: r,
      typeSupported: s
    } = this;
    let i;
    for (let d = 0, h = Po.length; d < h; d++) {
      var o;
      if ((o = Po[d].demux) != null && o.probe(e, this.logger)) {
        i = Po[d];
        break;
      }
    }
    if (!i)
      return new Error("Failed to find demuxer by probing fragment data");
    const a = this.demuxer, l = this.remuxer, c = i.remux, u = i.demux;
    (!l || !(l instanceof c)) && (this.remuxer = new c(r, t, s, this.logger)), (!a || !(a instanceof u)) && (this.demuxer = new u(r, t, s, this.logger), this.probe = u.probe);
  }
  needsProbing(e, t) {
    return !this.demuxer || !this.remuxer || e || t;
  }
  getDecrypter() {
    let e = this.decrypter;
    return e || (e = this.decrypter = new Fu(this.config)), e;
  }
}
function m2(n, e) {
  let t = null;
  return n.byteLength > 0 && (e == null ? void 0 : e.key) != null && e.iv !== null && e.method != null && (t = e), t;
}
const Bl = (n) => ({
  remuxResult: {},
  chunkMeta: n
});
function Gi(n) {
  return "then" in n && n.then instanceof Function;
}
class y2 {
  constructor(e, t, r, s, i) {
    this.audioCodec = void 0, this.videoCodec = void 0, this.initSegmentData = void 0, this.duration = void 0, this.defaultInitPts = void 0, this.audioCodec = e, this.videoCodec = t, this.initSegmentData = r, this.duration = s, this.defaultInitPts = i || null;
  }
}
class v2 {
  constructor(e, t, r, s, i, o) {
    this.discontinuity = void 0, this.contiguous = void 0, this.accurateTimeOffset = void 0, this.trackSwitch = void 0, this.timeOffset = void 0, this.initSegmentChange = void 0, this.discontinuity = e, this.contiguous = t, this.accurateTimeOffset = r, this.trackSwitch = s, this.timeOffset = i, this.initSegmentChange = o;
  }
}
let Kh = 0;
class Gp {
  constructor(e, t, r, s) {
    this.error = null, this.hls = void 0, this.id = void 0, this.instanceNo = Kh++, this.observer = void 0, this.frag = null, this.part = null, this.useWorker = void 0, this.workerContext = null, this.transmuxer = null, this.onTransmuxComplete = void 0, this.onFlush = void 0, this.onWorkerMessage = (l) => {
      const c = l.data, u = this.hls;
      if (!(!u || !(c != null && c.event) || c.instanceNo !== this.instanceNo))
        switch (c.event) {
          case "init": {
            var d;
            const h = (d = this.workerContext) == null ? void 0 : d.objectURL;
            h && self.URL.revokeObjectURL(h);
            break;
          }
          case "transmuxComplete": {
            this.handleTransmuxComplete(c.data);
            break;
          }
          case "flush": {
            this.onFlush(c.data);
            break;
          }
          case "workerLog": {
            u.logger[c.data.logType] && u.logger[c.data.logType](c.data.message);
            break;
          }
          default: {
            c.data = c.data || {}, c.data.frag = this.frag, c.data.part = this.part, c.data.id = this.id, u.trigger(c.event, c.data);
            break;
          }
        }
    }, this.onWorkerError = (l) => {
      if (!this.hls)
        return;
      const c = new Error(`${l.message}  (${l.filename}:${l.lineno})`);
      this.hls.config.enableWorker = !1, this.hls.logger.warn(`Error in "${this.id}" Web Worker, fallback to inline`), this.hls.trigger(T.ERROR, {
        type: ge.OTHER_ERROR,
        details: Y.INTERNAL_EXCEPTION,
        fatal: !1,
        event: "demuxerWorker",
        error: c
      });
    };
    const i = e.config;
    this.hls = e, this.id = t, this.useWorker = !!i.enableWorker, this.onTransmuxComplete = r, this.onFlush = s;
    const o = (l, c) => {
      c = c || {}, c.frag = this.frag || void 0, l === T.ERROR && (c = c, c.parent = this.id, c.part = this.part, this.error = c.error), this.hls.trigger(l, c);
    };
    this.observer = new ju(), this.observer.on(T.FRAG_DECRYPTED, o), this.observer.on(T.ERROR, o);
    const a = oh(i.preferManagedMediaSource);
    if (this.useWorker && typeof Worker < "u") {
      const l = this.hls.logger;
      if (i.workerPath || wT()) {
        try {
          i.workerPath ? (l.log(`loading Web Worker ${i.workerPath} for "${t}"`), this.workerContext = IT(i.workerPath)) : (l.log(`injecting Web Worker for "${t}"`), this.workerContext = AT());
          const {
            worker: u
          } = this.workerContext;
          u.addEventListener("message", this.onWorkerMessage), u.addEventListener("error", this.onWorkerError), u.postMessage({
            instanceNo: this.instanceNo,
            cmd: "init",
            typeSupported: a,
            id: t,
            config: mt(i)
          });
        } catch (u) {
          l.warn(`Error setting up "${t}" Web Worker, fallback to inline`, u), this.terminateWorker(), this.error = null, this.transmuxer = new Vh(this.observer, a, i, "", t, e.logger);
        }
        return;
      }
    }
    this.transmuxer = new Vh(this.observer, a, i, "", t, e.logger);
  }
  reset() {
    if (this.frag = null, this.part = null, this.workerContext) {
      const e = this.instanceNo;
      this.instanceNo = Kh++;
      const t = this.hls.config, r = oh(t.preferManagedMediaSource);
      this.workerContext.worker.postMessage({
        instanceNo: this.instanceNo,
        cmd: "reset",
        resetNo: e,
        typeSupported: r,
        id: this.id,
        config: mt(t)
      });
    }
  }
  terminateWorker() {
    if (this.workerContext) {
      const {
        worker: e
      } = this.workerContext;
      this.workerContext = null, e.removeEventListener("message", this.onWorkerMessage), e.removeEventListener("error", this.onWorkerError), _T(this.hls.config.workerPath);
    }
  }
  destroy() {
    if (this.workerContext)
      this.terminateWorker(), this.onWorkerMessage = this.onWorkerError = null;
    else {
      const t = this.transmuxer;
      t && (t.destroy(), this.transmuxer = null);
    }
    const e = this.observer;
    e && e.removeAllListeners(), this.frag = null, this.part = null, this.observer = null, this.hls = null;
  }
  push(e, t, r, s, i, o, a, l, c, u) {
    var d, h;
    c.transmuxing.start = self.performance.now();
    const {
      instanceNo: f,
      transmuxer: p
    } = this, y = o ? o.start : i.start, m = i.decryptdata, b = this.frag, C = !(b && i.cc === b.cc), A = !(b && c.level === b.level), P = b ? c.sn - b.sn : -1, I = this.part ? c.part - this.part.index : -1, U = P === 0 && c.id > 1 && c.id === (b == null ? void 0 : b.stats.chunkCount), j = !A && (P === 1 || P === 0 && (I === 1 || U && I <= 0)), G = self.performance.now();
    (A || P || i.stats.parsing.start === 0) && (i.stats.parsing.start = G), o && (I || !j) && (o.stats.parsing.start = G);
    const F = !(b && ((d = i.initSegment) == null ? void 0 : d.url) === ((h = b.initSegment) == null ? void 0 : h.url)), B = new v2(C, j, l, A, y, F);
    if (!j || C || F) {
      this.hls.logger.log(`[transmuxer-interface]: Starting new transmux session for ${i.type} sn: ${c.sn}${c.part > -1 ? " part: " + c.part : ""} ${this.id === he.MAIN ? "level" : "track"}: ${c.level} id: ${c.id}
        discontinuity: ${C}
        trackSwitch: ${A}
        contiguous: ${j}
        accurateTimeOffset: ${l}
        timeOffset: ${y}
        initSegmentChange: ${F}`);
      const V = new y2(r, s, t, a, u);
      this.configureTransmuxer(V);
    }
    if (this.frag = i, this.part = o, this.workerContext)
      this.workerContext.worker.postMessage({
        instanceNo: f,
        cmd: "demux",
        data: e,
        decryptdata: m,
        chunkMeta: c,
        state: B
      }, e instanceof ArrayBuffer ? [e] : []);
    else if (p) {
      const V = p.push(e, m, c, B);
      Gi(V) ? V.then((H) => {
        this.handleTransmuxComplete(H);
      }).catch((H) => {
        this.transmuxerError(H, c, "transmuxer-interface push error");
      }) : this.handleTransmuxComplete(V);
    }
  }
  flush(e) {
    e.transmuxing.start = self.performance.now();
    const {
      instanceNo: t,
      transmuxer: r
    } = this;
    if (this.workerContext)
      this.workerContext.worker.postMessage({
        instanceNo: t,
        cmd: "flush",
        chunkMeta: e
      });
    else if (r) {
      const s = r.flush(e);
      Gi(s) ? s.then((i) => {
        this.handleFlushResult(i, e);
      }).catch((i) => {
        this.transmuxerError(i, e, "transmuxer-interface flush error");
      }) : this.handleFlushResult(s, e);
    }
  }
  transmuxerError(e, t, r) {
    this.hls && (this.error = e, this.hls.trigger(T.ERROR, {
      type: ge.MEDIA_ERROR,
      details: Y.FRAG_PARSING_ERROR,
      chunkMeta: t,
      frag: this.frag || void 0,
      part: this.part || void 0,
      fatal: !1,
      error: e,
      err: e,
      reason: r
    }));
  }
  handleFlushResult(e, t) {
    e.forEach((r) => {
      this.handleTransmuxComplete(r);
    }), this.onFlush(t);
  }
  configureTransmuxer(e) {
    const {
      instanceNo: t,
      transmuxer: r
    } = this;
    this.workerContext ? this.workerContext.worker.postMessage({
      instanceNo: t,
      cmd: "configure",
      config: e
    }) : r && r.configure(e);
  }
  handleTransmuxComplete(e) {
    e.chunkMeta.transmuxing.end = self.performance.now(), this.onTransmuxComplete(e);
  }
}
const Hh = 100;
class x2 extends Gu {
  constructor(e, t, r) {
    super(e, t, r, "audio-stream-controller", he.AUDIO), this.mainAnchor = null, this.mainFragLoading = null, this.audioOnly = !1, this.bufferedTrack = null, this.switchingTrack = null, this.trackId = -1, this.waitingData = null, this.mainDetails = null, this.flushing = !1, this.bufferFlushed = !1, this.cachedTrackLoadedData = null, this.registerListeners();
  }
  onHandlerDestroying() {
    this.unregisterListeners(), super.onHandlerDestroying(), this.resetItem();
  }
  resetItem() {
    this.mainDetails = this.mainAnchor = this.mainFragLoading = this.bufferedTrack = this.switchingTrack = this.waitingData = this.cachedTrackLoadedData = null;
  }
  registerListeners() {
    super.registerListeners();
    const {
      hls: e
    } = this;
    e.on(T.LEVEL_LOADED, this.onLevelLoaded, this), e.on(T.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.on(T.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(T.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(T.BUFFER_RESET, this.onBufferReset, this), e.on(T.BUFFER_CREATED, this.onBufferCreated, this), e.on(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(T.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(T.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(T.FRAG_LOADING, this.onFragLoading, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (super.unregisterListeners(), e.off(T.LEVEL_LOADED, this.onLevelLoaded, this), e.off(T.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.off(T.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(T.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(T.BUFFER_RESET, this.onBufferReset, this), e.off(T.BUFFER_CREATED, this.onBufferCreated, this), e.off(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(T.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(T.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(T.FRAG_LOADING, this.onFragLoading, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this));
  }
  // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
  onInitPtsFound(e, {
    frag: t,
    id: r,
    initPTS: s,
    timescale: i
  }) {
    if (r === he.MAIN) {
      const o = t.cc, a = this.fragCurrent;
      if (this.initPTS[o] = {
        baseTime: s,
        timescale: i
      }, this.log(`InitPTS for cc: ${o} found from main: ${s}/${i}`), this.mainAnchor = t, this.state === Q.WAITING_INIT_PTS) {
        const l = this.waitingData;
        (!l && !this.loadingParts || l && l.frag.cc !== o) && this.syncWithAnchor(t, l == null ? void 0 : l.frag);
      } else !this.hls.hasEnoughToStart && a && a.cc !== o ? (a.abortRequests(), this.syncWithAnchor(t, a)) : this.state === Q.IDLE && this.tick();
    }
  }
  getLoadPosition() {
    return !this.startFragRequested && this.nextLoadPosition >= 0 ? this.nextLoadPosition : super.getLoadPosition();
  }
  syncWithAnchor(e, t) {
    var r;
    const s = ((r = this.mainFragLoading) == null ? void 0 : r.frag) || null;
    if (t && (s == null ? void 0 : s.cc) === t.cc)
      return;
    const i = (s || e).cc, o = this.getLevelDetails(), a = this.getLoadPosition(), l = ap(o, i, a);
    l && (this.log(`Waiting fragment cc (${t == null ? void 0 : t.cc}) cancelled because video is at cc ${e.cc}`), this.startFragRequested = !1, this.nextLoadPosition = l.start, this.resetLoadingState(), this.state === Q.IDLE && this.doTickIdle());
  }
  startLoad(e, t) {
    if (!this.levels) {
      this.startPosition = e, this.state = Q.STOPPED;
      return;
    }
    const r = this.lastCurrentTime;
    this.stopLoad(), this.setInterval(Hh), r > 0 && e === -1 ? (this.log(`Override startPosition with lastCurrentTime @${r.toFixed(3)}`), e = r, this.state = Q.IDLE) : this.state = Q.WAITING_TRACK, this.nextLoadPosition = this.lastCurrentTime = e + this.timelineOffset, this.startPosition = t ? -1 : e, this.tick();
  }
  doTick() {
    switch (this.state) {
      case Q.IDLE:
        this.doTickIdle();
        break;
      case Q.WAITING_TRACK: {
        const {
          levels: t,
          trackId: r
        } = this, s = t == null ? void 0 : t[r], i = s == null ? void 0 : s.details;
        if (i && !this.waitForLive(s)) {
          if (this.waitForCdnTuneIn(i))
            break;
          this.state = Q.WAITING_INIT_PTS;
        }
        break;
      }
      case Q.FRAG_LOADING_WAITING_RETRY: {
        var e;
        const t = performance.now(), r = this.retryDate;
        if (!r || t >= r || (e = this.media) != null && e.seeking) {
          const {
            levels: s,
            trackId: i
          } = this;
          this.log("RetryDate reached, switch back to IDLE state"), this.resetStartWhenNotLoaded((s == null ? void 0 : s[i]) || null), this.state = Q.IDLE;
        }
        break;
      }
      case Q.WAITING_INIT_PTS: {
        const t = this.waitingData;
        if (t) {
          const {
            frag: r,
            part: s,
            cache: i,
            complete: o
          } = t, a = this.mainAnchor;
          if (this.initPTS[r.cc] !== void 0) {
            this.waitingData = null, this.state = Q.FRAG_LOADING;
            const l = i.flush().buffer, c = {
              frag: r,
              part: s,
              payload: l,
              networkDetails: null
            };
            this._handleFragmentLoadProgress(c), o && super._handleFragmentLoadComplete(c);
          } else a && a.cc !== t.frag.cc && this.syncWithAnchor(a, t.frag);
        } else
          this.state = Q.IDLE;
      }
    }
    this.onTickEnd();
  }
  resetLoadingState() {
    const e = this.waitingData;
    e && (this.fragmentTracker.removeFragment(e.frag), this.waitingData = null), super.resetLoadingState();
  }
  onTickEnd() {
    const {
      media: e
    } = this;
    e != null && e.readyState && (this.lastCurrentTime = e.currentTime);
  }
  doTickIdle() {
    var e;
    const {
      hls: t,
      levels: r,
      media: s,
      trackId: i
    } = this, o = t.config;
    if (!this.buffering || !s && !this.primaryPrefetch && (this.startFragRequested || !o.startFragPrefetch) || !(r != null && r[i]))
      return;
    const a = r[i], l = a.details;
    if (!l || this.waitForLive(a) || this.waitForCdnTuneIn(l)) {
      this.state = Q.WAITING_TRACK, this.startFragRequested = !1;
      return;
    }
    const c = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.bufferFlushed && c && (this.bufferFlushed = !1, this.afterBufferFlushed(c, lt.AUDIO, he.AUDIO));
    const u = this.getFwdBufferInfo(c, he.AUDIO);
    if (u === null)
      return;
    if (!this.switchingTrack && this._streamEnded(u, l)) {
      t.trigger(T.BUFFER_EOS, {
        type: "audio"
      }), this.state = Q.ENDED;
      return;
    }
    const d = u.len, h = t.maxBufferLength, f = l.fragments, p = f[0].start, y = this.getLoadPosition(), m = this.flushing ? y : u.end;
    if (this.switchingTrack && s) {
      const A = y;
      l.PTSKnown && A < p && (u.end > p || u.nextStart) && (this.log("Alt audio track ahead of main track, seek to start of alt audio track"), s.currentTime = p + 0.05);
    }
    if (d >= h && !this.switchingTrack && m < f[f.length - 1].start)
      return;
    let b = this.getNextFragment(m, l);
    if (b && this.isLoopLoading(b, m) && (b = this.getNextFragmentLoopLoading(b, l, u, he.MAIN, h)), !b) {
      this.bufferFlushed = !0;
      return;
    }
    let C = ((e = this.mainFragLoading) == null ? void 0 : e.frag) || null;
    if (!this.audioOnly && this.startFragRequested && C && Yt(b) && !b.endList && (!l.live || !this.loadingParts && m < this.hls.liveSyncPosition) && (this.fragmentTracker.getState(C) === Ht.OK && (this.mainFragLoading = C = null), C && Yt(C))) {
      if (b.start > C.end) {
        const P = this.fragmentTracker.getFragAtPos(m, he.MAIN);
        P && P.end > C.end && (C = P, this.mainFragLoading = {
          frag: P,
          targetBufferTime: null
        });
      }
      if (b.start > C.end)
        return;
    }
    this.loadFragment(b, a, m);
  }
  onMediaDetaching(e, t) {
    this.bufferFlushed = this.flushing = !1, super.onMediaDetaching(e, t);
  }
  onAudioTracksUpdated(e, {
    audioTracks: t
  }) {
    this.resetTransmuxer(), this.levels = t.map((r) => new Bi(r));
  }
  onAudioTrackSwitching(e, t) {
    const r = !!t.url;
    this.trackId = t.id;
    const {
      fragCurrent: s
    } = this;
    s && (s.abortRequests(), this.removeUnbufferedFrags(s.start)), this.resetLoadingState(), r ? (this.switchingTrack = t, this.flushAudioIfNeeded(t), this.state !== Q.STOPPED && (this.setInterval(Hh), this.state = Q.IDLE, this.tick())) : (this.resetTransmuxer(), this.switchingTrack = null, this.bufferedTrack = t, this.clearInterval());
  }
  onManifestLoading() {
    super.onManifestLoading(), this.bufferFlushed = this.flushing = this.audioOnly = !1, this.resetItem(), this.trackId = -1;
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details;
    const r = this.cachedTrackLoadedData;
    r && (this.cachedTrackLoadedData = null, this.onAudioTrackLoaded(T.AUDIO_TRACK_LOADED, r));
  }
  onAudioTrackLoaded(e, t) {
    var r;
    const {
      levels: s
    } = this, {
      details: i,
      id: o,
      groupId: a,
      track: l
    } = t;
    if (!s) {
      this.warn(`Audio tracks reset while loading track ${o} "${l.name}" of "${a}"`);
      return;
    }
    const c = this.mainDetails;
    if (!c || i.endCC > c.endCC || c.expired) {
      this.cachedTrackLoadedData = t, this.state !== Q.STOPPED && (this.state = Q.WAITING_TRACK);
      return;
    }
    this.cachedTrackLoadedData = null, this.log(`Audio track ${o} "${l.name}" of "${a}" loaded [${i.startSN},${i.endSN}]${i.lastPartSn ? `[part-${i.lastPartSn}-${i.lastPartIndex}]` : ""},duration:${i.totalduration}`);
    const u = s[o];
    let d = 0;
    if (i.live || (r = u.details) != null && r.live) {
      if (this.checkLiveUpdate(i), i.deltaUpdateFailed)
        return;
      if (u.details) {
        var h;
        d = this.alignPlaylists(i, u.details, (h = this.levelLastLoaded) == null ? void 0 : h.details);
      }
      i.alignedSliding || (Sp(i, c), i.alignedSliding || Sa(i, c), d = i.fragmentStart);
    }
    u.details = i, this.levelLastLoaded = u, this.startFragRequested || this.setStartPosition(c, d), this.hls.trigger(T.AUDIO_TRACK_UPDATED, {
      details: i,
      id: o,
      groupId: t.groupId
    }), this.state === Q.WAITING_TRACK && !this.waitForCdnTuneIn(i) && (this.state = Q.IDLE), this.tick();
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const r = e.frag, {
      part: s,
      payload: i
    } = e, {
      config: o,
      trackId: a,
      levels: l
    } = this;
    if (!l) {
      this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${r.sn} of level ${r.level} will not be buffered`);
      return;
    }
    const c = l[a];
    if (!c) {
      this.warn("Audio track is undefined on fragment load progress");
      return;
    }
    const u = c.details;
    if (!u) {
      this.warn("Audio track details undefined on fragment load progress"), this.removeUnbufferedFrags(r.start);
      return;
    }
    const d = o.defaultAudioCodec || c.audioCodec || "mp4a.40.2";
    let h = this.transmuxer;
    h || (h = this.transmuxer = new Gp(this.hls, he.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)));
    const f = this.initPTS[r.cc], p = (t = r.initSegment) == null ? void 0 : t.data;
    if (f !== void 0) {
      const m = s ? s.index : -1, b = m !== -1, C = new Nu(r.level, r.sn, r.stats.chunkCount, i.byteLength, m, b);
      h.push(i, p, d, "", r, s, u.totalduration, !1, C, f);
    } else {
      this.log(`Unknown video PTS for cc ${r.cc}, waiting for video PTS before demuxing audio frag ${r.sn} of [${u.startSN} ,${u.endSN}],track ${a}`);
      const {
        cache: y
      } = this.waitingData = this.waitingData || {
        frag: r,
        part: s,
        cache: new bp(),
        complete: !1
      };
      y.push(new Uint8Array(i)), this.state !== Q.STOPPED && (this.state = Q.WAITING_INIT_PTS);
    }
  }
  _handleFragmentLoadComplete(e) {
    if (this.waitingData) {
      this.waitingData.complete = !0;
      return;
    }
    super._handleFragmentLoadComplete(e);
  }
  onBufferReset() {
    this.mediaBuffer = null;
  }
  onBufferCreated(e, t) {
    this.bufferFlushed = this.flushing = !1;
    const r = t.tracks.audio;
    r && (this.mediaBuffer = r.buffer || null);
  }
  onFragLoading(e, t) {
    !this.audioOnly && t.frag.type === he.MAIN && Yt(t.frag) && (this.mainFragLoading = t, this.state === Q.IDLE && this.tick());
  }
  onFragBuffered(e, t) {
    const {
      frag: r,
      part: s
    } = t;
    if (r.type !== he.AUDIO) {
      !this.audioOnly && r.type === he.MAIN && !r.elementaryStreams.video && !r.elementaryStreams.audiovideo && (this.audioOnly = !0, this.mainFragLoading = null);
      return;
    }
    if (this.fragContextChanged(r)) {
      this.warn(`Fragment ${r.sn}${s ? " p: " + s.index : ""} of level ${r.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : "false"}`);
      return;
    }
    if (Yt(r)) {
      this.fragPrevious = r;
      const i = this.switchingTrack;
      i && (this.bufferedTrack = i, this.switchingTrack = null, this.hls.trigger(T.AUDIO_TRACK_SWITCHED, rt({}, i)));
    }
    this.fragBufferedComplete(r, s), this.media && this.tick();
  }
  onError(e, t) {
    var r;
    if (t.fatal) {
      this.state = Q.ERROR;
      return;
    }
    switch (t.details) {
      case Y.FRAG_GAP:
      case Y.FRAG_PARSING_ERROR:
      case Y.FRAG_DECRYPT_ERROR:
      case Y.FRAG_LOAD_ERROR:
      case Y.FRAG_LOAD_TIMEOUT:
      case Y.KEY_LOAD_ERROR:
      case Y.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(he.AUDIO, t);
        break;
      case Y.AUDIO_TRACK_LOAD_ERROR:
      case Y.AUDIO_TRACK_LOAD_TIMEOUT:
      case Y.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === Q.WAITING_TRACK && ((r = t.context) == null ? void 0 : r.type) === Ke.AUDIO_TRACK && (this.state = Q.IDLE);
        break;
      case Y.BUFFER_ADD_CODEC_ERROR:
      case Y.BUFFER_APPEND_ERROR:
        if (t.parent !== "audio")
          return;
        this.resetLoadingState();
        break;
      case Y.BUFFER_FULL_ERROR:
        if (t.parent !== "audio")
          return;
        this.reduceLengthAndFlushBuffer(t) && (this.bufferedTrack = null, super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"));
        break;
      case Y.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  onBufferFlushing(e, {
    type: t
  }) {
    t !== lt.VIDEO && (this.flushing = !0);
  }
  onBufferFlushed(e, {
    type: t
  }) {
    if (t !== lt.VIDEO) {
      this.flushing = !1, this.bufferFlushed = !0, this.state === Q.ENDED && (this.state = Q.IDLE);
      const r = this.mediaBuffer || this.media;
      r && (this.afterBufferFlushed(r, t, he.AUDIO), this.tick());
    }
  }
  _handleTransmuxComplete(e) {
    var t;
    const r = "audio", {
      hls: s
    } = this, {
      remuxResult: i,
      chunkMeta: o
    } = e, a = this.getCurrentContext(o);
    if (!a) {
      this.resetWhenMissingContext(o);
      return;
    }
    const {
      frag: l,
      part: c,
      level: u
    } = a, {
      details: d
    } = u, {
      audio: h,
      text: f,
      id3: p,
      initSegment: y
    } = i;
    if (this.fragContextChanged(l) || !d) {
      this.fragmentTracker.removeFragment(l);
      return;
    }
    if (this.state = Q.PARSING, this.switchingTrack && h && this.completeAudioSwitch(this.switchingTrack), y != null && y.tracks) {
      const m = l.initSegment || l;
      this._bufferInitSegment(u, y.tracks, m, o), s.trigger(T.FRAG_PARSING_INIT_SEGMENT, {
        frag: m,
        id: r,
        tracks: y.tracks
      });
    }
    if (h) {
      const {
        startPTS: m,
        endPTS: b,
        startDTS: C,
        endDTS: A
      } = h;
      c && (c.elementaryStreams[lt.AUDIO] = {
        startPTS: m,
        endPTS: b,
        startDTS: C,
        endDTS: A
      }), l.setElementaryStreamInfo(lt.AUDIO, m, b, C, A), this.bufferFragmentData(h, l, c, o);
    }
    if (p != null && (t = p.samples) != null && t.length) {
      const m = st({
        id: r,
        frag: l,
        details: d
      }, p);
      s.trigger(T.FRAG_PARSING_METADATA, m);
    }
    if (f) {
      const m = st({
        id: r,
        frag: l,
        details: d
      }, f);
      s.trigger(T.FRAG_PARSING_USERDATA, m);
    }
  }
  _bufferInitSegment(e, t, r, s) {
    if (this.state !== Q.PARSING || (t.video && delete t.video, t.audiovideo && delete t.audiovideo, !t.audio))
      return;
    const i = t.audio;
    i.id = he.AUDIO;
    const o = e.audioCodec;
    this.log(`Init audio buffer, container:${i.container}, codecs[level/parsed]=[${o}/${i.codec}]`), o && o.split(",").length === 1 && (i.levelCodec = o), this.hls.trigger(T.BUFFER_CODECS, t);
    const a = i.initSegment;
    if (a != null && a.byteLength) {
      const l = {
        type: "audio",
        frag: r,
        part: null,
        chunkMeta: s,
        parent: r.type,
        data: a
      };
      this.hls.trigger(T.BUFFER_APPENDING, l);
    }
    this.tickImmediate();
  }
  loadFragment(e, t, r) {
    const s = this.fragmentTracker.getState(e);
    if (this.switchingTrack || s === Ht.NOT_LOADED || s === Ht.PARTIAL) {
      var i;
      if (!Yt(e))
        this._loadInitSegment(e, t);
      else if ((i = t.details) != null && i.live && !this.initPTS[e.cc]) {
        this.log(`Waiting for video PTS in continuity counter ${e.cc} of live stream before loading audio fragment ${e.sn} of level ${this.trackId}`), this.state = Q.WAITING_INIT_PTS;
        const o = this.mainDetails;
        o && o.fragmentStart !== t.details.fragmentStart && Sa(t.details, o);
      } else
        super.loadFragment(e, t, r);
    } else
      this.clearTrackerIfNeeded(e);
  }
  flushAudioIfNeeded(e) {
    if (this.media && this.bufferedTrack) {
      const {
        name: t,
        lang: r,
        assocLang: s,
        characteristics: i,
        audioCodec: o,
        channels: a
      } = this.bufferedTrack;
      ls({
        name: t,
        lang: r,
        assocLang: s,
        characteristics: i,
        audioCodec: o,
        channels: a
      }, e, es) || (ya(e.url, this.hls) ? (this.log("Switching audio track : flushing all audio"), super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"), this.bufferedTrack = null) : this.bufferedTrack = e);
    }
  }
  completeAudioSwitch(e) {
    const {
      hls: t
    } = this;
    this.flushAudioIfNeeded(e), this.bufferedTrack = e, this.switchingTrack = null, t.trigger(T.AUDIO_TRACK_SWITCHED, rt({}, e));
  }
}
class Yu extends Cn {
  constructor(e, t) {
    super(t, e.logger), this.hls = void 0, this.canLoad = !1, this.timer = -1, this.hls = e;
  }
  destroy() {
    this.clearTimer(), this.hls = this.log = this.warn = null;
  }
  clearTimer() {
    this.timer !== -1 && (self.clearTimeout(this.timer), this.timer = -1);
  }
  startLoad() {
    this.canLoad = !0, this.loadPlaylist();
  }
  stopLoad() {
    this.canLoad = !1, this.clearTimer();
  }
  switchParams(e, t, r) {
    const s = t == null ? void 0 : t.renditionReports;
    if (s) {
      let i = -1;
      for (let o = 0; o < s.length; o++) {
        const a = s[o];
        let l;
        try {
          l = new self.URL(a.URI, t.url).href;
        } catch (c) {
          this.warn(`Could not construct new URL for Rendition Report: ${c}`), l = a.URI || "";
        }
        if (l === e) {
          i = o;
          break;
        } else l === e.substring(0, l.length) && (i = o);
      }
      if (i !== -1) {
        const o = s[i], a = parseInt(o["LAST-MSN"]) || (t == null ? void 0 : t.lastPartSn);
        let l = parseInt(o["LAST-PART"]) || (t == null ? void 0 : t.lastPartIndex);
        if (this.hls.config.lowLatencyMode) {
          const u = Math.min(t.age - t.partTarget, t.targetduration);
          l >= 0 && u > t.partTarget && (l += 1);
        }
        const c = r && lh(r);
        return new ch(a, l >= 0 ? l : void 0, c);
      }
    }
  }
  loadPlaylist(e) {
    this.clearTimer();
  }
  loadingPlaylist(e, t) {
    this.clearTimer();
  }
  shouldLoadPlaylist(e) {
    return this.canLoad && !!e && !!e.url && (!e.details || e.details.live);
  }
  getUrlWithDirectives(e, t) {
    if (t)
      try {
        return t.addDirectives(e);
      } catch (r) {
        this.warn(`Could not construct new URL with HLS Delivery Directives: ${r}`);
      }
    return e;
  }
  playlistLoaded(e, t, r) {
    const {
      details: s,
      stats: i
    } = t, o = self.performance.now(), a = i.loading.first ? Math.max(0, o - i.loading.first) : 0;
    s.advancedDateTime = Date.now() - a;
    const l = this.hls.config.timelineOffset;
    if (l !== s.appliedTimelineOffset) {
      const u = Math.max(l || 0, 0);
      s.appliedTimelineOffset = u, s.fragments.forEach((d) => {
        d.start = d.playlistOffset + u;
      });
    }
    if (s.live || r != null && r.live) {
      const u = "levelInfo" in t ? t.levelInfo : t.track;
      if (s.reloaded(r), r && s.fragments.length > 0) {
        gT(r, s);
        const C = s.playlistParsingError;
        if (C) {
          this.warn(C);
          const A = this.hls;
          if (!A.config.ignorePlaylistParsingErrors) {
            var c;
            const {
              networkDetails: P
            } = t;
            A.trigger(T.ERROR, {
              type: ge.NETWORK_ERROR,
              details: Y.LEVEL_PARSING_ERROR,
              fatal: !1,
              url: s.url,
              error: C,
              reason: C.message,
              level: t.level || void 0,
              parent: (c = s.fragments[0]) == null ? void 0 : c.type,
              networkDetails: P,
              stats: i
            });
            return;
          }
          s.playlistParsingError = null;
        }
      }
      s.requestScheduled === -1 && (s.requestScheduled = i.loading.start);
      const d = this.hls.mainForwardBufferInfo, h = d ? d.end - d.len : 0, f = (s.edge - h) * 1e3, p = mp(s, f);
      if (s.requestScheduled + p < o ? s.requestScheduled = o : s.requestScheduled += p, this.log(`live playlist ${e} ${s.advanced ? "REFRESHED " + s.lastPartSn + "-" + s.lastPartIndex : s.updated ? "UPDATED" : "MISSED"}`), !this.canLoad || !s.live)
        return;
      let y, m, b;
      if (s.canBlockReload && s.endSN && s.advanced) {
        const C = this.hls.config.lowLatencyMode, A = s.lastPartSn, P = s.endSN, I = s.lastPartIndex, U = I !== -1, j = A === P;
        U ? j ? (m = P + 1, b = C ? 0 : I) : (m = A, b = C ? I + 1 : s.maxPartIndex) : m = P + 1;
        const G = s.age, F = G + s.ageHeader;
        let B = Math.min(F - s.partTarget, s.targetduration * 1.5);
        if (B > 0) {
          if (F > s.targetduration * 3)
            this.log(`Playlist last advanced ${G.toFixed(2)}s ago. Omitting segment and part directives.`), m = void 0, b = void 0;
          else if (r != null && r.tuneInGoal && F - s.partTarget > r.tuneInGoal)
            this.warn(`CDN Tune-in goal increased from: ${r.tuneInGoal} to: ${B} with playlist age: ${s.age}`), B = 0;
          else {
            const V = Math.floor(B / s.targetduration);
            if (m += V, b !== void 0) {
              const H = Math.round(B % s.targetduration / s.partTarget);
              b += H;
            }
            this.log(`CDN Tune-in age: ${s.ageHeader}s last advanced ${G.toFixed(2)}s goal: ${B} skip sn ${V} to part ${b}`);
          }
          s.tuneInGoal = B;
        }
        if (y = this.getDeliveryDirectives(s, t.deliveryDirectives, m, b), C || !j) {
          s.requestScheduled = o, this.loadingPlaylist(u, y);
          return;
        }
      } else (s.canBlockReload || s.canSkipUntil) && (y = this.getDeliveryDirectives(s, t.deliveryDirectives, m, b));
      y && m !== void 0 && s.canBlockReload && (s.requestScheduled = i.loading.first + Math.max(p - a * 2, p / 2)), this.scheduleLoading(u, y, s);
    } else
      this.clearTimer();
  }
  scheduleLoading(e, t, r) {
    const s = r || e.details;
    if (!s) {
      this.loadingPlaylist(e, t);
      return;
    }
    const i = self.performance.now(), o = s.requestScheduled;
    if (i >= o) {
      this.loadingPlaylist(e, t);
      return;
    }
    const a = o - i;
    this.log(`reload live playlist ${e.name || e.bitrate + "bps"} in ${Math.round(a)} ms`), this.clearTimer(), this.timer = self.setTimeout(() => this.loadingPlaylist(e, t), a);
  }
  getDeliveryDirectives(e, t, r, s) {
    let i = lh(e);
    return t != null && t.skip && e.deltaUpdateFailed && (r = t.msn, s = t.part, i = Co.No), new ch(r, s, i);
  }
  checkRetry(e) {
    const t = e.details, r = va(e), s = e.errorAction, {
      action: i,
      retryCount: o = 0,
      retryConfig: a
    } = s || {}, l = !!s && !!a && (i === ar.RetryRequest || !s.resolved && i === ar.SendAlternateToPenaltyBox);
    if (l) {
      var c;
      if (o >= a.maxNumRetry)
        return !1;
      if (r && (c = e.context) != null && c.deliveryDirectives)
        this.warn(`Retrying playlist loading ${o + 1}/${a.maxNumRetry} after "${t}" without delivery-directives`), this.loadPlaylist();
      else {
        const u = Bu(a, o);
        this.clearTimer(), this.timer = self.setTimeout(() => this.loadPlaylist(), u), this.warn(`Retrying playlist loading ${o + 1}/${a.maxNumRetry} after "${t}" in ${u}ms`);
      }
      e.levelRetry = !0, s.resolved = !0;
    }
    return l;
  }
}
function jp(n, e) {
  if (n.length !== e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!ji(n[t].attrs, e[t].attrs))
      return !1;
  return !0;
}
function ji(n, e, t) {
  const r = n["STABLE-RENDITION-ID"];
  return r && !t ? r === e["STABLE-RENDITION-ID"] : !(t || ["LANGUAGE", "NAME", "CHARACTERISTICS", "AUTOSELECT", "DEFAULT", "FORCED", "ASSOC-LANGUAGE"]).some((s) => n[s] !== e[s]);
}
function kc(n, e) {
  return e.label.toLowerCase() === n.name.toLowerCase() && (!e.language || e.language.toLowerCase() === (n.lang || "").toLowerCase());
}
class E2 extends Yu {
  constructor(e) {
    super(e, "audio-track-controller"), this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.registerListeners();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.LEVEL_LOADING, this.onLevelLoading, this), e.on(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(T.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.LEVEL_LOADING, this.onLevelLoading, this), e.off(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(T.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(T.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, super.destroy();
  }
  onManifestLoading() {
    this.tracks = [], this.tracksInGroup = [], this.groupIds = null, this.currentTrack = null, this.trackId = -1, this.selectDefaultTrack = !0;
  }
  onManifestParsed(e, t) {
    this.tracks = t.audioTracks || [];
  }
  onAudioTrackLoaded(e, t) {
    const {
      id: r,
      groupId: s,
      details: i
    } = t, o = this.tracksInGroup[r];
    if (!o || o.groupId !== s) {
      this.warn(`Audio track with id:${r} and group:${s} not found in active group ${o == null ? void 0 : o.groupId}`);
      return;
    }
    const a = o.details;
    o.details = t.details, this.log(`Audio track ${r} "${o.name}" lang:${o.lang} group:${s} loaded [${i.startSN}-${i.endSN}]`), r === this.trackId && this.playlistLoaded(r, t, a);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!t)
      return;
    const r = t.audioGroups || null, s = this.groupIds;
    let i = this.currentTrack;
    if (!r || (s == null ? void 0 : s.length) !== (r == null ? void 0 : r.length) || r != null && r.some((a) => (s == null ? void 0 : s.indexOf(a)) === -1)) {
      this.groupIds = r, this.trackId = -1, this.currentTrack = null;
      const a = this.tracks.filter((h) => !r || r.indexOf(h.groupId) !== -1);
      if (a.length)
        this.selectDefaultTrack && !a.some((h) => h.default) && (this.selectDefaultTrack = !1), a.forEach((h, f) => {
          h.id = f;
        });
      else if (!i && !this.tracksInGroup.length)
        return;
      this.tracksInGroup = a;
      const l = this.hls.config.audioPreference;
      if (!i && l) {
        const h = sn(l, a, es);
        if (h > -1)
          i = a[h];
        else {
          const f = sn(l, this.tracks);
          i = this.tracks[f];
        }
      }
      let c = this.findTrackId(i);
      c === -1 && i && (c = this.findTrackId(null));
      const u = {
        audioTracks: a
      };
      this.log(`Updating audio tracks, ${a.length} track(s) found in group(s): ${r == null ? void 0 : r.join(",")}`), this.hls.trigger(T.AUDIO_TRACKS_UPDATED, u);
      const d = this.trackId;
      if (c !== -1 && d === -1)
        this.setAudioTrack(c);
      else if (a.length && d === -1) {
        var o;
        const h = new Error(`No audio track selected for current audio group-ID(s): ${(o = this.groupIds) == null ? void 0 : o.join(",")} track count: ${a.length}`);
        this.warn(h.message), this.hls.trigger(T.ERROR, {
          type: ge.MEDIA_ERROR,
          details: Y.AUDIO_TRACK_LOAD_ERROR,
          fatal: !0,
          error: h
        });
      }
    }
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === Ke.AUDIO_TRACK && t.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(t.context.groupId) !== -1) && this.checkRetry(t);
  }
  get allAudioTracks() {
    return this.tracks;
  }
  get audioTracks() {
    return this.tracksInGroup;
  }
  get audioTrack() {
    return this.trackId;
  }
  set audioTrack(e) {
    this.selectDefaultTrack = !1, this.setAudioTrack(e);
  }
  setAudioOption(e) {
    const t = this.hls;
    if (t.config.audioPreference = e, e) {
      const r = this.allAudioTracks;
      if (this.selectDefaultTrack = !1, r.length) {
        const s = this.currentTrack;
        if (s && ls(e, s, es))
          return s;
        const i = sn(e, this.tracksInGroup, es);
        if (i > -1) {
          const o = this.tracksInGroup[i];
          return this.setAudioTrack(i), o;
        } else if (s) {
          let o = t.loadLevel;
          o === -1 && (o = t.firstAutoLevel);
          const a = Mb(e, t.levels, r, o, es);
          if (a === -1)
            return null;
          t.nextLoadLevel = a;
        }
        if (e.channels || e.audioCodec) {
          const o = sn(e, r);
          if (o > -1)
            return r[o];
        }
      }
    }
    return null;
  }
  setAudioTrack(e) {
    const t = this.tracksInGroup;
    if (e < 0 || e >= t.length) {
      this.warn(`Invalid audio track id: ${e}`);
      return;
    }
    this.selectDefaultTrack = !1;
    const r = this.currentTrack, s = t[e], i = s.details && !s.details.live;
    if (e === this.trackId && s === r && i || (this.log(`Switching to audio-track ${e} "${s.name}" lang:${s.lang} group:${s.groupId} channels:${s.channels}`), this.trackId = e, this.currentTrack = s, this.hls.trigger(T.AUDIO_TRACK_SWITCHING, rt({}, s)), i))
      return;
    const o = this.switchParams(s.url, r == null ? void 0 : r.details, s.details);
    this.loadPlaylist(o);
  }
  findTrackId(e) {
    const t = this.tracksInGroup;
    for (let r = 0; r < t.length; r++) {
      const s = t[r];
      if (!(this.selectDefaultTrack && !s.default) && (!e || ls(e, s, es)))
        return r;
    }
    if (e) {
      const {
        name: r,
        lang: s,
        assocLang: i,
        characteristics: o,
        audioCodec: a,
        channels: l
      } = e;
      for (let c = 0; c < t.length; c++) {
        const u = t[c];
        if (ls({
          name: r,
          lang: s,
          assocLang: i,
          characteristics: o,
          audioCodec: a,
          channels: l
        }, u, es))
          return c;
      }
      for (let c = 0; c < t.length; c++) {
        const u = t[c];
        if (ji(e.attrs, u.attrs, ["LANGUAGE", "ASSOC-LANGUAGE", "CHARACTERISTICS"]))
          return c;
      }
      for (let c = 0; c < t.length; c++) {
        const u = t[c];
        if (ji(e.attrs, u.attrs, ["LANGUAGE"]))
          return c;
      }
    }
    return -1;
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const t = this.currentTrack;
    this.shouldLoadPlaylist(t) && ya(t.url, this.hls) && this.scheduleLoading(t, e);
  }
  loadingPlaylist(e, t) {
    super.loadingPlaylist(e, t);
    const r = e.id, s = e.groupId, i = this.getUrlWithDirectives(e.url, t), o = e.details, a = o == null ? void 0 : o.age;
    this.log(`Loading audio-track ${r} "${e.name}" lang:${e.lang} group:${s}${(t == null ? void 0 : t.msn) !== void 0 ? " at sn " + t.msn + " part " + t.part : ""}${a && o.live ? " age " + a.toFixed(1) + (o.type && " " + o.type || "") : ""} ${i}`), this.hls.trigger(T.AUDIO_TRACK_LOADING, {
      url: i,
      id: r,
      groupId: s,
      deliveryDirectives: t || null,
      track: e
    });
  }
}
class S2 {
  constructor(e) {
    this.tracks = void 0, this.queues = {
      video: [],
      audio: [],
      audiovideo: []
    }, this.tracks = e;
  }
  destroy() {
    this.tracks = this.queues = null;
  }
  append(e, t, r) {
    if (this.queues === null || this.tracks === null)
      return;
    const s = this.queues[t];
    s.push(e), s.length === 1 && !r && this.executeNext(t);
  }
  appendBlocker(e) {
    return new Promise((t) => {
      const r = {
        label: "async-blocker",
        execute: t,
        onStart: () => {
        },
        onComplete: () => {
        },
        onError: () => {
        }
      };
      this.append(r, e);
    });
  }
  prependBlocker(e) {
    return new Promise((t) => {
      if (this.queues) {
        const r = {
          label: "async-blocker-prepend",
          execute: t,
          onStart: () => {
          },
          onComplete: () => {
          },
          onError: () => {
          }
        };
        this.queues[e].unshift(r);
      }
    });
  }
  removeBlockers() {
    this.queues !== null && [this.queues.video, this.queues.audio, this.queues.audiovideo].forEach((e) => {
      var t;
      const r = (t = e[0]) == null ? void 0 : t.label;
      (r === "async-blocker" || r === "async-blocker-prepend") && (e[0].execute(), e.splice(0, 1));
    });
  }
  unblockAudio(e) {
    if (this.queues === null)
      return;
    this.queues.audio[0] === e && this.shiftAndExecuteNext("audio");
  }
  executeNext(e) {
    if (this.queues === null || this.tracks === null)
      return;
    const t = this.queues[e];
    if (t.length) {
      const s = t[0];
      try {
        s.execute();
      } catch (i) {
        var r;
        if (s.onError(i), this.queues === null || this.tracks === null)
          return;
        const o = (r = this.tracks[e]) == null ? void 0 : r.buffer;
        o != null && o.updating || this.shiftAndExecuteNext(e);
      }
    }
  }
  shiftAndExecuteNext(e) {
    this.queues !== null && (this.queues[e].shift(), this.executeNext(e));
  }
  current(e) {
    var t;
    return ((t = this.queues) == null ? void 0 : t[e][0]) || null;
  }
  toString() {
    const {
      queues: e,
      tracks: t
    } = this;
    return e === null || t === null ? "<destroyed>" : `
${this.list("video")}
${this.list("audio")}
${this.list("audiovideo")}}`;
  }
  list(e) {
    var t, r;
    return (t = this.queues) != null && t[e] || (r = this.tracks) != null && r[e] ? `${e}: (${this.listSbInfo(e)}) ${this.listOps(e)}` : "";
  }
  listSbInfo(e) {
    var t;
    const r = (t = this.tracks) == null ? void 0 : t[e], s = r == null ? void 0 : r.buffer;
    return s ? `SourceBuffer${s.updating ? " updating" : ""}${r.ended ? " ended" : ""}${r.ending ? " ending" : ""}` : "none";
  }
  listOps(e) {
    var t;
    return ((t = this.queues) == null ? void 0 : t[e].map((r) => r.label).join(", ")) || "";
  }
}
const Wh = /(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/, Vp = "HlsJsTrackRemovedError";
class b2 extends Error {
  constructor(e) {
    super(e), this.name = Vp;
  }
}
class T2 extends Cn {
  constructor(e, t) {
    super("buffer-controller", e.logger), this.hls = void 0, this.fragmentTracker = void 0, this.details = null, this._objectUrl = null, this.operationQueue = null, this.bufferCodecEventsTotal = 0, this.media = null, this.mediaSource = null, this.lastMpegAudioChunk = null, this.blockedAudioAppend = null, this.lastVideoAppendEnd = 0, this.appendSource = void 0, this.transferData = void 0, this.overrides = void 0, this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    }, this.tracks = {}, this.sourceBuffers = [[null, null], [null, null]], this._onEndStreaming = (r) => {
      var s;
      this.hls && ((s = this.mediaSource) == null ? void 0 : s.readyState) === "open" && this.hls.pauseBuffering();
    }, this._onStartStreaming = (r) => {
      this.hls && this.hls.resumeBuffering();
    }, this._onMediaSourceOpen = (r) => {
      const {
        media: s,
        mediaSource: i
      } = this;
      r && this.log("Media source opened"), !(!s || !i) && (i.removeEventListener("sourceopen", this._onMediaSourceOpen), s.removeEventListener("emptied", this._onMediaEmptied), this.updateDuration(), this.hls.trigger(T.MEDIA_ATTACHED, {
        media: s,
        mediaSource: i
      }), this.mediaSource !== null && this.checkPendingTracks());
    }, this._onMediaSourceClose = () => {
      this.log("Media source closed");
    }, this._onMediaSourceEnded = () => {
      this.log("Media source ended");
    }, this._onMediaEmptied = () => {
      const {
        mediaSrc: r,
        _objectUrl: s
      } = this;
      r !== s && this.error(`Media element src was set while attaching MediaSource (${s} > ${r})`);
    }, this.hls = e, this.fragmentTracker = t, this.appendSource = JS(Zn(e.config.preferManagedMediaSource)), this.initTracks(), this.registerListeners();
  }
  hasSourceTypes() {
    return Object.keys(this.tracks).length > 0;
  }
  destroy() {
    this.unregisterListeners(), this.details = null, this.lastMpegAudioChunk = this.blockedAudioAppend = null, this.transferData = this.overrides = void 0, this.operationQueue && (this.operationQueue.destroy(), this.operationQueue = null), this.hls = this.fragmentTracker = null, this._onMediaSourceOpen = this._onMediaSourceClose = null, this._onMediaSourceEnded = null, this._onStartStreaming = this._onEndStreaming = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.BUFFER_RESET, this.onBufferReset, this), e.on(T.BUFFER_APPENDING, this.onBufferAppending, this), e.on(T.BUFFER_CODECS, this.onBufferCodecs, this), e.on(T.BUFFER_EOS, this.onBufferEos, this), e.on(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(T.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(T.FRAG_PARSED, this.onFragParsed, this), e.on(T.FRAG_CHANGED, this.onFragChanged, this), e.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.BUFFER_RESET, this.onBufferReset, this), e.off(T.BUFFER_APPENDING, this.onBufferAppending, this), e.off(T.BUFFER_CODECS, this.onBufferCodecs, this), e.off(T.BUFFER_EOS, this.onBufferEos, this), e.off(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(T.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(T.FRAG_PARSED, this.onFragParsed, this), e.off(T.FRAG_CHANGED, this.onFragChanged, this), e.off(T.ERROR, this.onError, this);
  }
  transferMedia() {
    const {
      media: e,
      mediaSource: t
    } = this;
    if (!e)
      return null;
    const r = {};
    if (this.operationQueue) {
      const i = this.isUpdating();
      i || this.operationQueue.removeBlockers();
      const o = this.isQueued();
      (i || o) && this.warn(`Transfering MediaSource with${o ? " operations in queue" : ""}${i ? " updating SourceBuffer(s)" : ""} ${this.operationQueue}`), this.operationQueue.destroy();
    }
    const s = this.transferData;
    return !this.sourceBufferCount && s && s.mediaSource === t ? st(r, s.tracks) : this.sourceBuffers.forEach((i) => {
      const [o] = i;
      o && (r[o] = st({}, this.tracks[o]), this.removeBuffer(o)), i[0] = i[1] = null;
    }), {
      media: e,
      mediaSource: t,
      tracks: r
    };
  }
  initTracks() {
    const e = {};
    this.sourceBuffers = [[null, null], [null, null]], this.tracks = e, this.resetQueue(), this.resetAppendErrors(), this.lastMpegAudioChunk = this.blockedAudioAppend = null, this.lastVideoAppendEnd = 0;
  }
  onManifestLoading() {
    this.bufferCodecEventsTotal = 0, this.details = null;
  }
  onManifestParsed(e, t) {
    var r;
    let s = 2;
    (t.audio && !t.video || !t.altAudio) && (s = 1), this.bufferCodecEventsTotal = s, this.log(`${s} bufferCodec event(s) expected.`), (r = this.transferData) != null && r.mediaSource && this.sourceBufferCount && s && this.bufferCreated();
  }
  onMediaAttaching(e, t) {
    const r = this.media = t.media, s = Zn(this.appendSource);
    if (this.transferData = this.overrides = void 0, r && s) {
      const i = !!t.mediaSource;
      (i || t.overrides) && (this.transferData = t, this.overrides = t.overrides);
      const o = this.mediaSource = t.mediaSource || new s();
      if (this.assignMediaSource(o), i)
        this._objectUrl = r.src, this.attachTransferred();
      else {
        const a = this._objectUrl = self.URL.createObjectURL(o);
        if (this.appendSource)
          try {
            r.removeAttribute("src");
            const l = self.ManagedMediaSource;
            r.disableRemotePlayback = r.disableRemotePlayback || l && o instanceof l, qh(r), w2(r, a), r.load();
          } catch {
            r.src = a;
          }
        else
          r.src = a;
      }
      r.addEventListener("emptied", this._onMediaEmptied);
    }
  }
  assignMediaSource(e) {
    var t, r;
    this.log(`${((t = this.transferData) == null ? void 0 : t.mediaSource) === e ? "transferred" : "created"} media source: ${(r = e.constructor) == null ? void 0 : r.name}`), e.addEventListener("sourceopen", this._onMediaSourceOpen), e.addEventListener("sourceended", this._onMediaSourceEnded), e.addEventListener("sourceclose", this._onMediaSourceClose), this.appendSource && (e.addEventListener("startstreaming", this._onStartStreaming), e.addEventListener("endstreaming", this._onEndStreaming));
  }
  attachTransferred() {
    const e = this.media, t = this.transferData;
    if (!t || !e)
      return;
    const r = this.tracks, s = t.tracks, i = s ? Object.keys(s) : null, o = i ? i.length : 0, a = () => {
      this.media && this.mediaSourceOpenOrEnded && this._onMediaSourceOpen();
    };
    if (s && i && o) {
      if (!this.tracksReady) {
        this.hls.config.startFragPrefetch = !0, this.log("attachTransferred: waiting for SourceBuffer track info");
        return;
      }
      if (this.log(`attachTransferred: (bufferCodecEventsTotal ${this.bufferCodecEventsTotal})
required tracks: ${mt(r, (l, c) => l === "initSegment" ? void 0 : c)};
transfer tracks: ${mt(s, (l, c) => l === "initSegment" ? void 0 : c)}}`), !Vg(s, r)) {
        t.mediaSource = null, t.tracks = void 0;
        const l = e.currentTime, c = this.details, u = Math.max(l, (c == null ? void 0 : c.fragments[0].start) || 0);
        if (u - l > 1) {
          this.log(`attachTransferred: waiting for playback to reach new tracks start time ${l} -> ${u}`);
          return;
        }
        this.warn(`attachTransferred: resetting MediaSource for incompatible tracks ("${Object.keys(s)}"->"${Object.keys(r)}") start time: ${u} currentTime: ${l}`), this.onMediaDetaching(T.MEDIA_DETACHING, {}), this.onMediaAttaching(T.MEDIA_ATTACHING, t), e.currentTime = u;
        return;
      }
      this.transferData = void 0, i.forEach((l) => {
        const c = l, u = s[c];
        if (u) {
          const d = u.buffer;
          if (d) {
            const h = this.fragmentTracker, f = u.id;
            if (h.hasFragments(f) || h.hasParts(f)) {
              const m = Le.getBuffered(d);
              h.detectEvictedFragments(c, m, f, null, !0);
            }
            const p = Fl(c), y = [c, d];
            this.sourceBuffers[p] = y, d.updating && this.operationQueue && this.operationQueue.prependBlocker(c), this.trackSourceBuffer(c, u);
          }
        }
      }), a(), this.bufferCreated();
    } else
      this.log("attachTransferred: MediaSource w/o SourceBuffers"), a();
  }
  get mediaSourceOpenOrEnded() {
    var e;
    const t = (e = this.mediaSource) == null ? void 0 : e.readyState;
    return t === "open" || t === "ended";
  }
  onMediaDetaching(e, t) {
    const r = !!t.transferMedia;
    this.transferData = this.overrides = void 0;
    const {
      media: s,
      mediaSource: i,
      _objectUrl: o
    } = this;
    if (i) {
      if (this.log(`media source ${r ? "transferring" : "detaching"}`), r)
        this.sourceBuffers.forEach(([a]) => {
          a && this.removeBuffer(a);
        }), this.resetQueue();
      else {
        if (this.mediaSourceOpenOrEnded) {
          const a = i.readyState === "open";
          try {
            const l = i.sourceBuffers;
            for (let c = l.length; c--; )
              a && l[c].abort(), i.removeSourceBuffer(l[c]);
            a && i.endOfStream();
          } catch (l) {
            this.warn(`onMediaDetaching: ${l.message} while calling endOfStream`);
          }
        }
        this.sourceBufferCount && this.onBufferReset();
      }
      i.removeEventListener("sourceopen", this._onMediaSourceOpen), i.removeEventListener("sourceended", this._onMediaSourceEnded), i.removeEventListener("sourceclose", this._onMediaSourceClose), this.appendSource && (i.removeEventListener("startstreaming", this._onStartStreaming), i.removeEventListener("endstreaming", this._onEndStreaming)), this.mediaSource = null, this._objectUrl = null;
    }
    s && (s.removeEventListener("emptied", this._onMediaEmptied), r || (o && self.URL.revokeObjectURL(o), this.mediaSrc === o ? (s.removeAttribute("src"), this.appendSource && qh(s), s.load()) : this.warn("media|source.src was changed by a third party - skip cleanup")), this.media = null), this.hls.trigger(T.MEDIA_DETACHED, t);
  }
  onBufferReset() {
    this.sourceBuffers.forEach(([e]) => {
      e && this.resetBuffer(e);
    }), this.initTracks();
  }
  resetBuffer(e) {
    var t;
    const r = (t = this.tracks[e]) == null ? void 0 : t.buffer;
    if (this.removeBuffer(e), r)
      try {
        var s;
        (s = this.mediaSource) != null && s.sourceBuffers.length && this.mediaSource.removeSourceBuffer(r);
      } catch (i) {
        this.warn(`onBufferReset ${e}`, i);
      }
    delete this.tracks[e];
  }
  removeBuffer(e) {
    this.removeBufferListeners(e), this.sourceBuffers[Fl(e)] = [null, null];
    const t = this.tracks[e];
    t && (t.buffer = void 0);
  }
  resetQueue() {
    this.operationQueue && this.operationQueue.destroy(), this.operationQueue = new S2(this.tracks);
  }
  onBufferCodecs(e, t) {
    const r = this.tracks, s = Object.keys(t);
    this.log(`BUFFER_CODECS: "${s}" (current SB count ${this.sourceBufferCount})`);
    const i = "audiovideo" in t && (r.audio || r.video) || r.audiovideo && ("audio" in t || "video" in t), o = !i && this.sourceBufferCount && this.media && s.some((a) => !r[a]);
    if (i || o) {
      this.warn(`Unsupported transition between "${Object.keys(r)}" and "${s}" SourceBuffers`);
      return;
    }
    s.forEach((a) => {
      var l, c, u;
      const d = t[a], {
        id: h,
        codec: f,
        levelCodec: p,
        container: y,
        metadata: m,
        supplemental: b
      } = d;
      let C = r[a];
      const A = (l = this.transferData) == null || (c = l.tracks) == null ? void 0 : c[a], P = A != null && A.buffer ? A : C, I = (P == null ? void 0 : P.pendingCodec) || (P == null ? void 0 : P.codec), U = P == null ? void 0 : P.levelCodec;
      C || (C = r[a] = {
        buffer: void 0,
        listeners: [],
        codec: f,
        supplemental: b,
        container: y,
        levelCodec: p,
        metadata: m,
        id: h
      });
      const j = Ro(I, U), G = j == null ? void 0 : j.replace(Wh, "$1");
      let F = Ro(f, p);
      const B = (u = F) == null ? void 0 : u.replace(Wh, "$1");
      F && j && G !== B && (a.slice(0, 5) === "audio" && (F = pa(F, this.appendSource)), this.log(`switching codec ${I} to ${F}`), F !== (C.pendingCodec || C.codec) && (C.pendingCodec = F), C.container = y, this.appendChangeType(a, y, F));
    }), (this.tracksReady || this.sourceBufferCount) && (t.tracks = this.sourceBufferTracks), !this.sourceBufferCount && this.mediaSourceOpenOrEnded && this.checkPendingTracks();
  }
  get sourceBufferTracks() {
    return Object.keys(this.tracks).reduce((e, t) => {
      const r = this.tracks[t];
      return e[t] = {
        id: r.id,
        container: r.container,
        codec: r.codec,
        levelCodec: r.levelCodec
      }, e;
    }, {});
  }
  appendChangeType(e, t, r) {
    const s = `${t};codecs=${r}`, i = {
      label: `change-type=${s}`,
      execute: () => {
        const o = this.tracks[e];
        if (o) {
          const a = o.buffer;
          a != null && a.changeType && (this.log(`changing ${e} sourceBuffer type to ${s}`), a.changeType(s), o.codec = r, o.container = t);
        }
        this.shiftAndExecuteNext(e);
      },
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: (o) => {
        this.warn(`Failed to change ${e} SourceBuffer type`, o);
      }
    };
    this.append(i, e, this.isPending(this.tracks[e]));
  }
  blockAudio(e) {
    var t;
    const r = e.start, s = r + e.duration * 0.05;
    if (((t = this.fragmentTracker.getAppendedFrag(r, he.MAIN)) == null ? void 0 : t.gap) === !0)
      return;
    const o = {
      label: "block-audio",
      execute: () => {
        var a;
        const l = this.tracks.video;
        (this.lastVideoAppendEnd > s || l != null && l.buffer && Le.isBuffered(l.buffer, s) || ((a = this.fragmentTracker.getAppendedFrag(s, he.MAIN)) == null ? void 0 : a.gap) === !0) && (this.blockedAudioAppend = null, this.shiftAndExecuteNext("audio"));
      },
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: (a) => {
        this.warn("Error executing block-audio operation", a);
      }
    };
    this.blockedAudioAppend = {
      op: o,
      frag: e
    }, this.append(o, "audio", !0);
  }
  unblockAudio() {
    const {
      blockedAudioAppend: e,
      operationQueue: t
    } = this;
    e && t && (this.blockedAudioAppend = null, t.unblockAudio(e.op));
  }
  onBufferAppending(e, t) {
    const {
      tracks: r
    } = this, {
      data: s,
      type: i,
      parent: o,
      frag: a,
      part: l,
      chunkMeta: c
    } = t, u = c.buffering[i], d = a.sn, h = self.performance.now();
    u.start = h;
    const f = a.stats.buffering, p = l ? l.stats.buffering : null;
    f.start === 0 && (f.start = h), p && p.start === 0 && (p.start = h);
    const y = r.audio;
    let m = !1;
    i === "audio" && (y == null ? void 0 : y.container) === "audio/mpeg" && (m = !this.lastMpegAudioChunk || c.id === 1 || this.lastMpegAudioChunk.sn !== c.sn, this.lastMpegAudioChunk = c);
    const b = this.tracks.video, C = b == null ? void 0 : b.buffer;
    if (C && d !== "initSegment") {
      const I = l || a, U = this.blockedAudioAppend;
      if (i === "audio" && o !== "main" && !this.blockedAudioAppend) {
        const G = I.start + I.duration * 0.05, F = C.buffered, B = this.currentOp("video");
        !F.length && !B ? this.blockAudio(I) : !B && !Le.isBuffered(C, G) && this.lastVideoAppendEnd < G && this.blockAudio(I);
      } else if (i === "video") {
        const j = I.end;
        if (U) {
          const G = U.frag.start;
          (j > G || j < this.lastVideoAppendEnd || Le.isBuffered(C, G)) && this.unblockAudio();
        }
        this.lastVideoAppendEnd = j;
      }
    }
    const A = (l || a).start, P = {
      label: `append-${i}`,
      execute: () => {
        if (u.executeStart = self.performance.now(), m) {
          const I = this.tracks[i];
          if (I) {
            const U = I.buffer;
            if (U) {
              const j = A - U.timestampOffset;
              Math.abs(j) >= 0.1 && (this.log(`Updating audio SourceBuffer timestampOffset to ${A} (delta: ${j}) sn: ${d})`), U.timestampOffset = A);
            }
          }
        }
        this.appendExecutor(s, i);
      },
      onStart: () => {
      },
      onComplete: () => {
        const I = self.performance.now();
        u.executeEnd = u.end = I, f.first === 0 && (f.first = I), p && p.first === 0 && (p.first = I);
        const U = {};
        this.sourceBuffers.forEach(([j, G]) => {
          j && (U[j] = Le.getBuffered(G));
        }), this.appendErrors[i] = 0, i === "audio" || i === "video" ? this.appendErrors.audiovideo = 0 : (this.appendErrors.audio = 0, this.appendErrors.video = 0), this.hls.trigger(T.BUFFER_APPENDED, {
          type: i,
          frag: a,
          part: l,
          chunkMeta: c,
          parent: a.type,
          timeRanges: U
        });
      },
      onError: (I) => {
        var U;
        const j = {
          type: ge.MEDIA_ERROR,
          parent: a.type,
          details: Y.BUFFER_APPEND_ERROR,
          sourceBufferName: i,
          frag: a,
          part: l,
          chunkMeta: c,
          error: I,
          err: I,
          fatal: !1
        }, G = (U = this.media) == null ? void 0 : U.error;
        if (I.code === DOMException.QUOTA_EXCEEDED_ERR)
          j.details = Y.BUFFER_FULL_ERROR;
        else if (I.code === DOMException.INVALID_STATE_ERR && this.mediaSourceOpenOrEnded && !G)
          j.errorAction = Fi(!0);
        else if (I.name === Vp && this.sourceBufferCount === 0)
          j.errorAction = Fi(!0);
        else {
          const F = ++this.appendErrors[i];
          this.warn(`Failed ${F}/${this.hls.config.appendErrorMaxRetry} times to append segment in "${i}" sourceBuffer (${G || "no media error"})`), (F >= this.hls.config.appendErrorMaxRetry || G) && (j.fatal = !0);
        }
        this.hls.trigger(T.ERROR, j);
      }
    };
    this.append(P, i, this.isPending(this.tracks[i]));
  }
  getFlushOp(e, t, r) {
    return this.log(`queuing "${e}" remove ${t}-${r}`), {
      label: "remove",
      execute: () => {
        this.removeExecutor(e, t, r);
      },
      onStart: () => {
      },
      onComplete: () => {
        this.hls.trigger(T.BUFFER_FLUSHED, {
          type: e
        });
      },
      onError: (s) => {
        this.warn(`Failed to remove ${t}-${r} from "${e}" SourceBuffer`, s);
      }
    };
  }
  onBufferFlushing(e, t) {
    const {
      type: r,
      startOffset: s,
      endOffset: i
    } = t;
    r ? this.append(this.getFlushOp(r, s, i), r) : this.sourceBuffers.forEach(([o]) => {
      o && this.append(this.getFlushOp(o, s, i), o);
    });
  }
  onFragParsed(e, t) {
    const {
      frag: r,
      part: s
    } = t, i = [], o = s ? s.elementaryStreams : r.elementaryStreams;
    o[lt.AUDIOVIDEO] ? i.push("audiovideo") : (o[lt.AUDIO] && i.push("audio"), o[lt.VIDEO] && i.push("video"));
    const a = () => {
      const l = self.performance.now();
      r.stats.buffering.end = l, s && (s.stats.buffering.end = l);
      const c = s ? s.stats : r.stats;
      this.hls.trigger(T.FRAG_BUFFERED, {
        frag: r,
        part: s,
        stats: c,
        id: r.type
      });
    };
    i.length === 0 && this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${r.type} level: ${r.level} sn: ${r.sn}`), this.blockBuffers(a, i).catch((l) => {
      this.warn(`Fragment buffered callback ${l}`), this.stepOperationQueue(this.sourceBufferTypes);
    });
  }
  onFragChanged(e, t) {
    this.trimBuffers();
  }
  get bufferedToEnd() {
    return this.sourceBufferCount > 0 && !this.sourceBuffers.some(([e]) => {
      var t, r;
      return e && (!((t = this.tracks[e]) != null && t.ended) || ((r = this.tracks[e]) == null ? void 0 : r.ending));
    });
  }
  // on BUFFER_EOS mark matching sourcebuffer(s) as "ending" and "ended" and queue endOfStream after remaining operations(s)
  // an undefined data.type will mark all buffers as EOS.
  onBufferEos(e, t) {
    var r;
    this.sourceBuffers.forEach(([o]) => {
      if (o) {
        const a = this.tracks[o];
        (!t.type || t.type === o) && (a.ending = !0, a.ended || (a.ended = !0, this.log(`${o} buffer reached EOS`)));
      }
    });
    const s = ((r = this.overrides) == null ? void 0 : r.endOfStream) !== !1;
    this.sourceBufferCount > 0 && !this.sourceBuffers.some(([o]) => {
      var a;
      return o && !((a = this.tracks[o]) != null && a.ended);
    }) && (s ? (this.log("Queueing EOS"), this.blockUntilOpen(() => {
      this.tracksEnded();
      const {
        mediaSource: o
      } = this;
      if (!o || o.readyState !== "open") {
        o && this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${o.readyState}`);
        return;
      }
      this.log("Calling mediaSource.endOfStream()"), o.endOfStream(), this.hls.trigger(T.BUFFERED_TO_END, void 0);
    })) : (this.tracksEnded(), this.hls.trigger(T.BUFFERED_TO_END, void 0)));
  }
  tracksEnded() {
    this.sourceBuffers.forEach(([e]) => {
      if (e !== null) {
        const t = this.tracks[e];
        t && (t.ending = !1);
      }
    });
  }
  onLevelUpdated(e, {
    details: t
  }) {
    t.fragments.length && (this.details = t, this.updateDuration());
  }
  updateDuration() {
    const e = this.getDurationAndRange();
    e && this.blockUntilOpen(() => this.updateMediaSource(e));
  }
  onError(e, t) {
    if (t.details === Y.BUFFER_APPEND_ERROR && t.frag) {
      var r;
      const s = (r = t.errorAction) == null ? void 0 : r.nextAutoLevel;
      ae(s) && s !== t.frag.level && this.resetAppendErrors();
    }
  }
  resetAppendErrors() {
    this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    };
  }
  trimBuffers() {
    const {
      hls: e,
      details: t,
      media: r
    } = this;
    if (!r || t === null || !this.sourceBufferCount)
      return;
    const s = e.config, i = r.currentTime, o = t.levelTargetDuration, a = t.live && s.liveBackBufferLength !== null ? s.liveBackBufferLength : s.backBufferLength;
    if (ae(a) && a >= 0) {
      const l = Math.max(a, o), c = Math.floor(i / o) * o - l;
      this.flushBackBuffer(i, o, c);
    }
    if (ae(s.frontBufferFlushThreshold) && s.frontBufferFlushThreshold > 0) {
      const l = Math.max(s.maxBufferLength, s.frontBufferFlushThreshold), c = Math.max(l, o), u = Math.floor(i / o) * o + c;
      this.flushFrontBuffer(i, o, u);
    }
  }
  flushBackBuffer(e, t, r) {
    this.sourceBuffers.forEach(([s, i]) => {
      if (i) {
        const a = Le.getBuffered(i);
        if (a.length > 0 && r > a.start(0)) {
          var o;
          this.hls.trigger(T.BACK_BUFFER_REACHED, {
            bufferEnd: r
          });
          const l = this.tracks[s];
          if ((o = this.details) != null && o.live)
            this.hls.trigger(T.LIVE_BACK_BUFFER_REACHED, {
              bufferEnd: r
            });
          else if (l != null && l.ended) {
            this.log(`Cannot flush ${s} back buffer while SourceBuffer is in ended state`);
            return;
          }
          this.hls.trigger(T.BUFFER_FLUSHING, {
            startOffset: 0,
            endOffset: r,
            type: s
          });
        }
      }
    });
  }
  flushFrontBuffer(e, t, r) {
    this.sourceBuffers.forEach(([s, i]) => {
      if (i) {
        const o = Le.getBuffered(i), a = o.length;
        if (a < 2)
          return;
        const l = o.start(a - 1), c = o.end(a - 1);
        if (r > l || e >= l && e <= c)
          return;
        this.hls.trigger(T.BUFFER_FLUSHING, {
          startOffset: l,
          endOffset: 1 / 0,
          type: s
        });
      }
    });
  }
  /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */
  getDurationAndRange() {
    var e;
    const {
      details: t,
      mediaSource: r
    } = this;
    if (!t || !this.media || (r == null ? void 0 : r.readyState) !== "open")
      return null;
    const s = t.edge;
    if (t.live && this.hls.config.liveDurationInfinity) {
      if (t.fragments.length && t.live && r.setLiveSeekableRange) {
        const c = Math.max(0, t.fragmentStart), u = Math.max(c, s);
        return {
          duration: 1 / 0,
          start: c,
          end: u
        };
      }
      return {
        duration: 1 / 0
      };
    }
    const i = (e = this.overrides) == null ? void 0 : e.duration;
    if (i)
      return ae(i) ? {
        duration: i
      } : null;
    const o = this.media.duration, a = ae(r.duration) ? r.duration : 0;
    return s > a && s > o || !ae(o) ? {
      duration: s
    } : null;
  }
  updateMediaSource({
    duration: e,
    start: t,
    end: r
  }) {
    const s = this.mediaSource;
    !this.media || !s || s.readyState !== "open" || (s.duration !== e && (ae(e) && this.log(`Updating MediaSource duration to ${e.toFixed(3)}`), s.duration = e), t !== void 0 && r !== void 0 && (this.log(`MediaSource duration is set to ${s.duration}. Setting seekable range to ${t}-${r}.`), s.setLiveSeekableRange(t, r)));
  }
  get tracksReady() {
    const e = this.pendingTrackCount;
    return e > 0 && (e >= this.bufferCodecEventsTotal || this.isPending(this.tracks.audiovideo));
  }
  checkPendingTracks() {
    const {
      bufferCodecEventsTotal: e,
      pendingTrackCount: t,
      tracks: r
    } = this;
    if (this.log(`checkPendingTracks (pending: ${t} codec events expected: ${e}) ${mt(r)}`), this.tracksReady) {
      var s;
      const i = (s = this.transferData) == null ? void 0 : s.tracks;
      i && Object.keys(i).length ? this.attachTransferred() : this.createSourceBuffers();
    }
  }
  bufferCreated() {
    if (this.sourceBufferCount) {
      const e = {};
      this.sourceBuffers.forEach(([t, r]) => {
        if (t) {
          const s = this.tracks[t];
          e[t] = {
            buffer: r,
            container: s.container,
            codec: s.codec,
            supplemental: s.supplemental,
            levelCodec: s.levelCodec,
            id: s.id,
            metadata: s.metadata
          };
        }
      }), this.hls.trigger(T.BUFFER_CREATED, {
        tracks: e
      }), this.log(`SourceBuffers created. Running queue: ${this.operationQueue}`), this.sourceBuffers.forEach(([t]) => {
        this.executeNext(t);
      });
    } else {
      const e = new Error("could not create source buffer for media codec(s)");
      this.hls.trigger(T.ERROR, {
        type: ge.MEDIA_ERROR,
        details: Y.BUFFER_INCOMPATIBLE_CODECS_ERROR,
        fatal: !0,
        error: e,
        reason: e.message
      });
    }
  }
  createSourceBuffers() {
    const {
      tracks: e,
      sourceBuffers: t,
      mediaSource: r
    } = this;
    if (!r)
      throw new Error("createSourceBuffers called when mediaSource was null");
    for (const i in e) {
      const o = i, a = e[o];
      if (this.isPending(a)) {
        const l = this.getTrackCodec(a, o), c = `${a.container};codecs=${l}`;
        a.codec = l, this.log(`creating sourceBuffer(${c})${this.currentOp(o) ? " Queued" : ""} ${mt(a)}`);
        try {
          const u = r.addSourceBuffer(c), d = Fl(o), h = [o, u];
          t[d] = h, a.buffer = u;
        } catch (u) {
          var s;
          this.error(`error while trying to add sourceBuffer: ${u.message}`), this.shiftAndExecuteNext(o), (s = this.operationQueue) == null || s.removeBlockers(), delete this.tracks[o], this.hls.trigger(T.ERROR, {
            type: ge.MEDIA_ERROR,
            details: Y.BUFFER_ADD_CODEC_ERROR,
            fatal: !1,
            error: u,
            sourceBufferName: o,
            mimeType: c,
            parent: a.id
          });
          return;
        }
        this.trackSourceBuffer(o, a);
      }
    }
    this.bufferCreated();
  }
  getTrackCodec(e, t) {
    const r = e.supplemental;
    let s = e.codec;
    r && (t === "video" || t === "audiovideo") && Tc(r, "video") && (s = Eb(s, r));
    const i = Ro(s, e.levelCodec);
    return i ? t.slice(0, 5) === "audio" ? pa(i, this.appendSource) : i : "";
  }
  trackSourceBuffer(e, t) {
    const r = t.buffer;
    if (!r)
      return;
    const s = this.getTrackCodec(t, e);
    this.tracks[e] = {
      buffer: r,
      codec: s,
      container: t.container,
      levelCodec: t.levelCodec,
      supplemental: t.supplemental,
      metadata: t.metadata,
      id: t.id,
      listeners: []
    }, this.removeBufferListeners(e), this.addBufferListener(e, "updatestart", this.onSBUpdateStart), this.addBufferListener(e, "updateend", this.onSBUpdateEnd), this.addBufferListener(e, "error", this.onSBUpdateError), this.appendSource && this.addBufferListener(e, "bufferedchange", (i, o) => {
      const a = o.removedRanges;
      a != null && a.length && this.hls.trigger(T.BUFFER_FLUSHED, {
        type: i
      });
    });
  }
  get mediaSrc() {
    var e, t;
    const r = ((e = this.media) == null || (t = e.querySelector) == null ? void 0 : t.call(e, "source")) || this.media;
    return r == null ? void 0 : r.src;
  }
  onSBUpdateStart(e) {
    const t = this.currentOp(e);
    t && t.onStart();
  }
  onSBUpdateEnd(e) {
    var t;
    if (((t = this.mediaSource) == null ? void 0 : t.readyState) === "closed") {
      this.resetBuffer(e);
      return;
    }
    const r = this.currentOp(e);
    r && (r.onComplete(), this.shiftAndExecuteNext(e));
  }
  onSBUpdateError(e, t) {
    var r;
    const s = new Error(`${e} SourceBuffer error. MediaSource readyState: ${(r = this.mediaSource) == null ? void 0 : r.readyState}`);
    this.error(`${s}`, t), this.hls.trigger(T.ERROR, {
      type: ge.MEDIA_ERROR,
      details: Y.BUFFER_APPENDING_ERROR,
      sourceBufferName: e,
      error: s,
      fatal: !1
    });
    const i = this.currentOp(e);
    i && i.onError(s);
  }
  // This method must result in an updateend event; if remove is not called, onSBUpdateEnd must be called manually
  removeExecutor(e, t, r) {
    const {
      media: s,
      mediaSource: i
    } = this, o = this.tracks[e], a = o == null ? void 0 : o.buffer;
    if (!s || !i || !a) {
      this.warn(`Attempting to remove from the ${e} SourceBuffer, but it does not exist`), this.shiftAndExecuteNext(e);
      return;
    }
    const l = ae(s.duration) ? s.duration : 1 / 0, c = ae(i.duration) ? i.duration : 1 / 0, u = Math.max(0, t), d = Math.min(r, l, c);
    d > u && (!o.ending || o.ended) ? (o.ended = !1, this.log(`Removing [${u},${d}] from the ${e} SourceBuffer`), a.remove(u, d)) : this.shiftAndExecuteNext(e);
  }
  // This method must result in an updateend event; if append is not called, onSBUpdateEnd must be called manually
  appendExecutor(e, t) {
    const r = this.tracks[t], s = r == null ? void 0 : r.buffer;
    if (!s)
      throw new b2(`Attempting to append to the ${t} SourceBuffer, but it does not exist`);
    r.ending = !1, r.ended = !1, s.appendBuffer(e);
  }
  blockUntilOpen(e) {
    if (this.isUpdating() || this.isQueued())
      this.blockBuffers(e).catch((t) => {
        this.warn(`SourceBuffer blocked callback ${t}`), this.stepOperationQueue(this.sourceBufferTypes);
      });
    else
      try {
        e();
      } catch (t) {
        this.warn(`Callback run without blocking ${this.operationQueue} ${t}`);
      }
  }
  isUpdating() {
    return this.sourceBuffers.some(([e, t]) => e && t.updating);
  }
  isQueued() {
    return this.sourceBuffers.some(([e]) => e && !!this.currentOp(e));
  }
  isPending(e) {
    return !!e && !e.buffer;
  }
  // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
  // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
  // upon completion, since we already do it here
  blockBuffers(e, t = this.sourceBufferTypes) {
    if (!t.length)
      return this.log("Blocking operation requested, but no SourceBuffers exist"), Promise.resolve().then(e);
    const {
      operationQueue: r
    } = this, s = t.map((o) => this.appendBlocker(o));
    return t.length > 1 && !!this.blockedAudioAppend && this.unblockAudio(), Promise.all(s).then((o) => {
      r === this.operationQueue && (e(), this.stepOperationQueue(this.sourceBufferTypes));
    });
  }
  stepOperationQueue(e) {
    e.forEach((t) => {
      var r;
      const s = (r = this.tracks[t]) == null ? void 0 : r.buffer;
      !s || s.updating || this.shiftAndExecuteNext(t);
    });
  }
  append(e, t, r) {
    this.operationQueue && this.operationQueue.append(e, t, r);
  }
  appendBlocker(e) {
    if (this.operationQueue)
      return this.operationQueue.appendBlocker(e);
  }
  currentOp(e) {
    return this.operationQueue ? this.operationQueue.current(e) : null;
  }
  executeNext(e) {
    e && this.operationQueue && this.operationQueue.executeNext(e);
  }
  shiftAndExecuteNext(e) {
    this.operationQueue && this.operationQueue.shiftAndExecuteNext(e);
  }
  get pendingTrackCount() {
    return Object.keys(this.tracks).reduce((e, t) => e + (this.isPending(this.tracks[t]) ? 1 : 0), 0);
  }
  get sourceBufferCount() {
    return this.sourceBuffers.reduce((e, [t]) => e + (t ? 1 : 0), 0);
  }
  get sourceBufferTypes() {
    return this.sourceBuffers.map(([e]) => e).filter((e) => !!e);
  }
  addBufferListener(e, t, r) {
    const s = this.tracks[e];
    if (!s)
      return;
    const i = s.buffer;
    if (!i)
      return;
    const o = r.bind(this, e);
    s.listeners.push({
      event: t,
      listener: o
    }), i.addEventListener(t, o);
  }
  removeBufferListeners(e) {
    const t = this.tracks[e];
    if (!t)
      return;
    const r = t.buffer;
    r && (t.listeners.forEach((s) => {
      r.removeEventListener(s.event, s.listener);
    }), t.listeners.length = 0);
  }
}
function qh(n) {
  const e = n.querySelectorAll("source");
  [].slice.call(e).forEach((t) => {
    n.removeChild(t);
  });
}
function w2(n, e) {
  const t = self.document.createElement("source");
  t.type = "video/mp4", t.src = e, n.appendChild(t);
}
function Fl(n) {
  return n === "audio" ? 1 : 0;
}
class Zu {
  constructor(e) {
    this.hls = void 0, this.autoLevelCapping = void 0, this.firstLevel = void 0, this.media = void 0, this.restrictedLevels = void 0, this.timer = void 0, this.clientRect = void 0, this.streamController = void 0, this.hls = e, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.firstLevel = -1, this.media = null, this.restrictedLevels = [], this.timer = void 0, this.clientRect = null, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  destroy() {
    this.hls && this.unregisterListener(), this.timer && this.stopCapping(), this.media = null, this.clientRect = null, this.hls = this.streamController = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.on(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(T.BUFFER_CODECS, this.onBufferCodecs, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListener() {
    const {
      hls: e
    } = this;
    e.off(T.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.off(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(T.BUFFER_CODECS, this.onBufferCodecs, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  onFpsDropLevelCapping(e, t) {
    const r = this.hls.levels[t.droppedLevel];
    this.isLevelAllowed(r) && this.restrictedLevels.push({
      bitrate: r.bitrate,
      height: r.height,
      width: r.width
    });
  }
  onMediaAttaching(e, t) {
    this.media = t.media instanceof HTMLVideoElement ? t.media : null, this.clientRect = null, this.timer && this.hls.levels.length && this.detectPlayerSize();
  }
  onManifestParsed(e, t) {
    const r = this.hls;
    this.restrictedLevels = [], this.firstLevel = t.firstLevel, r.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  onLevelsUpdated(e, t) {
    this.timer && ae(this.autoLevelCapping) && this.detectPlayerSize();
  }
  // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
  // to the first level
  onBufferCodecs(e, t) {
    this.hls.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  onMediaDetaching() {
    this.stopCapping(), this.media = null;
  }
  detectPlayerSize() {
    if (this.media) {
      if (this.mediaHeight <= 0 || this.mediaWidth <= 0) {
        this.clientRect = null;
        return;
      }
      const e = this.hls.levels;
      if (e.length) {
        const t = this.hls, r = this.getMaxLevel(e.length - 1);
        r !== this.autoLevelCapping && t.logger.log(`Setting autoLevelCapping to ${r}: ${e[r].height}p@${e[r].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`), t.autoLevelCapping = r, t.autoLevelEnabled && t.autoLevelCapping > this.autoLevelCapping && this.streamController && this.streamController.nextLevelSwitch(), this.autoLevelCapping = t.autoLevelCapping;
      }
    }
  }
  /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */
  getMaxLevel(e) {
    const t = this.hls.levels;
    if (!t.length)
      return -1;
    const r = t.filter((s, i) => this.isLevelAllowed(s) && i <= e);
    return this.clientRect = null, Zu.getMaxLevelByMediaSize(r, this.mediaWidth, this.mediaHeight);
  }
  startCapping() {
    this.timer || (this.autoLevelCapping = Number.POSITIVE_INFINITY, self.clearInterval(this.timer), this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
  }
  stopCapping() {
    this.restrictedLevels = [], this.firstLevel = -1, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.timer && (self.clearInterval(this.timer), this.timer = void 0);
  }
  getDimensions() {
    if (this.clientRect)
      return this.clientRect;
    const e = this.media, t = {
      width: 0,
      height: 0
    };
    if (e) {
      const r = e.getBoundingClientRect();
      t.width = r.width, t.height = r.height, !t.width && !t.height && (t.width = r.right - r.left || e.width || 0, t.height = r.bottom - r.top || e.height || 0);
    }
    return this.clientRect = t, t;
  }
  get mediaWidth() {
    return this.getDimensions().width * this.contentScaleFactor;
  }
  get mediaHeight() {
    return this.getDimensions().height * this.contentScaleFactor;
  }
  get contentScaleFactor() {
    let e = 1;
    if (!this.hls.config.ignoreDevicePixelRatio)
      try {
        e = self.devicePixelRatio;
      } catch {
      }
    return Math.min(e, this.hls.config.maxDevicePixelRatio);
  }
  isLevelAllowed(e) {
    return !this.restrictedLevels.some((r) => e.bitrate === r.bitrate && e.width === r.width && e.height === r.height);
  }
  static getMaxLevelByMediaSize(e, t, r) {
    if (!(e != null && e.length))
      return -1;
    const s = (a, l) => l ? a.width !== l.width || a.height !== l.height : !0;
    let i = e.length - 1;
    const o = Math.max(t, r);
    for (let a = 0; a < e.length; a += 1) {
      const l = e[a];
      if ((l.width >= o || l.height >= o) && s(l, e[a + 1])) {
        i = a;
        break;
      }
    }
    return i;
  }
}
const A2 = {
  /**
   * text file, such as a manifest or playlist
   */
  MANIFEST: "m",
  /**
   * audio only
   */
  AUDIO: "a",
  /**
   * video only
   */
  VIDEO: "v",
  /**
   * muxed audio and video
   */
  MUXED: "av",
  /**
   * init segment
   */
  INIT: "i",
  /**
   * caption or subtitle
   */
  CAPTION: "c",
  /**
   * ISOBMFF timed text track
   */
  TIMED_TEXT: "tt",
  /**
   * cryptographic key, license or certificate.
   */
  KEY: "k",
  /**
   * other
   */
  OTHER: "o"
}, yr = A2, I2 = {
  /**
   * HTTP Live Streaming (HLS)
   */
  HLS: "h"
}, _2 = I2, L2 = "CMCD-Object", R2 = "CMCD-Request", C2 = "CMCD-Session", k2 = "CMCD-Status", hi = {
  /**
   * keys whose values vary with the object being requested.
   */
  OBJECT: L2,
  /**
   * keys whose values vary with each request.
   */
  REQUEST: R2,
  /**
   * keys whose values are expected to be invariant over the life of the session.
   */
  SESSION: C2,
  /**
   * keys whose values do not vary with every request or object.
   */
  STATUS: k2
}, D2 = {
  [hi.OBJECT]: ["br", "d", "ot", "tb"],
  [hi.REQUEST]: ["bl", "dl", "mtp", "nor", "nrr", "su"],
  [hi.SESSION]: ["cid", "pr", "sf", "sid", "st", "v"],
  [hi.STATUS]: ["bs", "rtp"]
};
class ti {
  constructor(e, t) {
    Array.isArray(e) && (e = e.map((r) => r instanceof ti ? r : new ti(r))), this.value = e, this.params = t;
  }
}
const P2 = "Dict";
function M2(n) {
  return Array.isArray(n) ? JSON.stringify(n) : n instanceof Map ? "Map{}" : n instanceof Set ? "Set{}" : typeof n == "object" ? JSON.stringify(n) : String(n);
}
function O2(n, e, t, r) {
  return new Error(`failed to ${n} "${M2(e)}" as ${t}`, {
    cause: r
  });
}
function un(n, e, t) {
  return O2("serialize", n, e, t);
}
class Kp {
  constructor(e) {
    this.description = e;
  }
}
const zh = "Bare Item", B2 = "Boolean";
function F2(n) {
  if (typeof n != "boolean")
    throw un(n, B2);
  return n ? "?1" : "?0";
}
function N2(n) {
  return btoa(String.fromCharCode(...n));
}
const U2 = "Byte Sequence";
function $2(n) {
  if (ArrayBuffer.isView(n) === !1)
    throw un(n, U2);
  return `:${N2(n)}:`;
}
const G2 = "Integer";
function j2(n) {
  return n < -999999999999999 || 999999999999999 < n;
}
function Hp(n) {
  if (j2(n))
    throw un(n, G2);
  return n.toString();
}
function V2(n) {
  return `@${Hp(n.getTime() / 1e3)}`;
}
function Wp(n, e) {
  if (n < 0)
    return -Wp(-n, e);
  const t = Math.pow(10, e);
  if (Math.abs(n * t % 1 - 0.5) < Number.EPSILON) {
    const s = Math.floor(n * t);
    return (s % 2 === 0 ? s : s + 1) / t;
  } else
    return Math.round(n * t) / t;
}
const K2 = "Decimal";
function H2(n) {
  const e = Wp(n, 3);
  if (Math.floor(Math.abs(e)).toString().length > 12)
    throw un(n, K2);
  const t = e.toString();
  return t.includes(".") ? t : `${t}.0`;
}
const W2 = "String", q2 = /[\x00-\x1f\x7f]+/;
function z2(n) {
  if (q2.test(n))
    throw un(n, W2);
  return `"${n.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}
function Y2(n) {
  return n.description || n.toString().slice(7, -1);
}
const Z2 = "Token";
function Yh(n) {
  const e = Y2(n);
  if (/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(e) === !1)
    throw un(e, Z2);
  return e;
}
function Dc(n) {
  switch (typeof n) {
    case "number":
      if (!ae(n))
        throw un(n, zh);
      return Number.isInteger(n) ? Hp(n) : H2(n);
    case "string":
      return z2(n);
    case "symbol":
      return Yh(n);
    case "boolean":
      return F2(n);
    case "object":
      if (n instanceof Date)
        return V2(n);
      if (n instanceof Uint8Array)
        return $2(n);
      if (n instanceof Kp)
        return Yh(n);
    default:
      throw un(n, zh);
  }
}
const X2 = "Key";
function Pc(n) {
  if (/^[a-z*][a-z0-9\-_.*]*$/.test(n) === !1)
    throw un(n, X2);
  return n;
}
function Xu(n) {
  return n == null ? "" : Object.entries(n).map(([e, t]) => t === !0 ? `;${Pc(e)}` : `;${Pc(e)}=${Dc(t)}`).join("");
}
function qp(n) {
  return n instanceof ti ? `${Dc(n.value)}${Xu(n.params)}` : Dc(n);
}
function J2(n) {
  return `(${n.value.map(qp).join(" ")})${Xu(n.params)}`;
}
function Q2(n, e = {
  whitespace: !0
}) {
  if (typeof n != "object")
    throw un(n, P2);
  const t = n instanceof Map ? n.entries() : Object.entries(n), r = e != null && e.whitespace ? " " : "";
  return Array.from(t).map(([s, i]) => {
    i instanceof ti || (i = new ti(i));
    let o = Pc(s);
    return i.value === !0 ? o += Xu(i.params) : (o += "=", Array.isArray(i.value) ? o += J2(i) : o += qp(i)), o;
  }).join(`,${r}`);
}
function ew(n, e) {
  return Q2(n, e);
}
function tw(n) {
  return n === "ot" || n === "sf" || n === "st";
}
function rw(n) {
  return typeof n == "number" ? ae(n) : n != null && n !== "" && n !== !1;
}
function nw(n, e) {
  const t = new URL(n), r = new URL(e);
  if (t.origin !== r.origin)
    return n;
  const s = t.pathname.split("/").slice(1), i = r.pathname.split("/").slice(1, -1);
  for (; s[0] === i[0]; )
    s.shift(), i.shift();
  for (; i.length; )
    i.shift(), s.unshift("..");
  return s.join("/");
}
const Mo = (n) => Math.round(n), sw = (n, e) => (e != null && e.baseUrl && (n = nw(n, e.baseUrl)), encodeURIComponent(n)), vo = (n) => Mo(n / 100) * 100, iw = {
  /**
   * Bitrate (kbps) rounded integer
   */
  br: Mo,
  /**
   * Duration (milliseconds) rounded integer
   */
  d: Mo,
  /**
   * Buffer Length (milliseconds) rounded nearest 100ms
   */
  bl: vo,
  /**
   * Deadline (milliseconds) rounded nearest 100ms
   */
  dl: vo,
  /**
   * Measured Throughput (kbps) rounded nearest 100kbps
   */
  mtp: vo,
  /**
   * Next Object Request URL encoded
   */
  nor: sw,
  /**
   * Requested maximum throughput (kbps) rounded nearest 100kbps
   */
  rtp: vo,
  /**
   * Top Bitrate (kbps) rounded integer
   */
  tb: Mo
};
function ow(n, e) {
  const t = {};
  if (n == null || typeof n != "object")
    return t;
  const r = Object.keys(n).sort(), s = st({}, iw, e == null ? void 0 : e.formatters), i = e == null ? void 0 : e.filter;
  return r.forEach((o) => {
    if (i != null && i(o))
      return;
    let a = n[o];
    const l = s[o];
    l && (a = l(a, e)), !(o === "v" && a === 1) && (o == "pr" && a === 1 || rw(a) && (tw(o) && typeof a == "string" && (a = new Kp(a)), t[o] = a));
  }), t;
}
function zp(n, e = {}) {
  return n ? ew(ow(n, e), st({
    whitespace: !1
  }, e)) : "";
}
function aw(n, e = {}) {
  const t = {};
  if (!n)
    return t;
  const r = Object.entries(n), s = Object.entries(D2).concat(Object.entries((e == null ? void 0 : e.customHeaderMap) || {})), i = r.reduce((o, a) => {
    var l, c;
    const [u, d] = a, h = ((l = s.find((f) => f[1].includes(u))) === null || l === void 0 ? void 0 : l[0]) || hi.REQUEST;
    return (c = o[h]) !== null && c !== void 0 || (o[h] = {}), o[h][u] = d, o;
  }, {});
  return Object.entries(i).reduce((o, [a, l]) => (o[a] = zp(l, e), o), t);
}
function lw(n, e, t) {
  return st(n, aw(e, t));
}
const cw = "CMCD";
function uw(n, e = {}) {
  if (!n)
    return "";
  const t = zp(n, e);
  return `${cw}=${encodeURIComponent(t)}`;
}
const Zh = /CMCD=[^&#]+/;
function dw(n, e, t) {
  const r = uw(e, t);
  if (!r)
    return n;
  if (Zh.test(n))
    return n.replace(Zh, r);
  const s = n.includes("?") ? "&" : "?";
  return `${n}${s}${r}`;
}
class hw {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = void 0, this.sid = void 0, this.cid = void 0, this.useHeaders = !1, this.includeKeys = void 0, this.initialized = !1, this.starved = !1, this.buffering = !0, this.audioBuffer = void 0, this.videoBuffer = void 0, this.onWaiting = () => {
      this.initialized && (this.starved = !0), this.buffering = !0;
    }, this.onPlaying = () => {
      this.initialized || (this.initialized = !0), this.buffering = !1;
    }, this.applyPlaylistData = (s) => {
      try {
        this.apply(s, {
          ot: yr.MANIFEST,
          su: !this.initialized
        });
      } catch (i) {
        this.hls.logger.warn("Could not generate manifest CMCD data.", i);
      }
    }, this.applyFragmentData = (s) => {
      try {
        const {
          frag: i,
          part: o
        } = s, a = this.hls.levels[i.level], l = this.getObjectType(i), c = {
          d: (o || i).duration * 1e3,
          ot: l
        };
        (l === yr.VIDEO || l === yr.AUDIO || l == yr.MUXED) && (c.br = a.bitrate / 1e3, c.tb = this.getTopBandwidth(l) / 1e3, c.bl = this.getBufferLength(l));
        const u = o ? this.getNextPart(o) : this.getNextFrag(i);
        u != null && u.url && u.url !== i.url && (c.nor = u.url), this.apply(s, c);
      } catch (i) {
        this.hls.logger.warn("Could not generate segment CMCD data.", i);
      }
    }, this.hls = e;
    const t = this.config = e.config, {
      cmcd: r
    } = t;
    r != null && (t.pLoader = this.createPlaylistLoader(), t.fLoader = this.createFragmentLoader(), this.sid = r.sessionId || e.sessionId, this.cid = r.contentId, this.useHeaders = r.useHeaders === !0, this.includeKeys = r.includeKeys, this.registerListeners());
  }
  registerListeners() {
    const e = this.hls;
    e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHED, this.onMediaDetached, this), e.on(T.BUFFER_CREATED, this.onBufferCreated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHED, this.onMediaDetached, this), e.off(T.BUFFER_CREATED, this.onBufferCreated, this);
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached(), this.hls = this.config = this.audioBuffer = this.videoBuffer = null, this.onWaiting = this.onPlaying = this.media = null;
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("waiting", this.onWaiting), this.media.addEventListener("playing", this.onPlaying);
  }
  onMediaDetached() {
    this.media && (this.media.removeEventListener("waiting", this.onWaiting), this.media.removeEventListener("playing", this.onPlaying), this.media = null);
  }
  onBufferCreated(e, t) {
    var r, s;
    this.audioBuffer = (r = t.tracks.audio) == null ? void 0 : r.buffer, this.videoBuffer = (s = t.tracks.video) == null ? void 0 : s.buffer;
  }
  /**
   * Create baseline CMCD data
   */
  createData() {
    var e;
    return {
      v: 1,
      sf: _2.HLS,
      sid: this.sid,
      cid: this.cid,
      pr: (e = this.media) == null ? void 0 : e.playbackRate,
      mtp: this.hls.bandwidthEstimate / 1e3
    };
  }
  /**
   * Apply CMCD data to a request.
   */
  apply(e, t = {}) {
    st(t, this.createData());
    const r = t.ot === yr.INIT || t.ot === yr.VIDEO || t.ot === yr.MUXED;
    this.starved && r && (t.bs = !0, t.su = !0, this.starved = !1), t.su == null && (t.su = this.buffering);
    const {
      includeKeys: s
    } = this;
    s && (t = Object.keys(t).reduce((o, a) => (s.includes(a) && (o[a] = t[a]), o), {}));
    const i = {
      baseUrl: e.url
    };
    this.useHeaders ? (e.headers || (e.headers = {}), lw(e.headers, t, i)) : e.url = dw(e.url, t, i);
  }
  getNextFrag(e) {
    var t;
    const r = (t = this.hls.levels[e.level]) == null ? void 0 : t.details;
    if (r) {
      const s = e.sn - r.startSN;
      return r.fragments[s + 1];
    }
  }
  getNextPart(e) {
    var t, r;
    const {
      index: s,
      fragment: i
    } = e, o = (t = this.hls.levels[i.level]) == null || (r = t.details) == null ? void 0 : r.partList;
    if (o) {
      const {
        sn: a
      } = i;
      for (let l = o.length - 1; l >= 0; l--) {
        const c = o[l];
        if (c.index === s && c.fragment.sn === a)
          return o[l + 1];
      }
    }
  }
  /**
   * The CMCD object type.
   */
  getObjectType(e) {
    const {
      type: t
    } = e;
    if (t === "subtitle")
      return yr.TIMED_TEXT;
    if (e.sn === "initSegment")
      return yr.INIT;
    if (t === "audio")
      return yr.AUDIO;
    if (t === "main")
      return this.hls.audioTracks.length ? yr.VIDEO : yr.MUXED;
  }
  /**
   * Get the highest bitrate.
   */
  getTopBandwidth(e) {
    let t = 0, r;
    const s = this.hls;
    if (e === yr.AUDIO)
      r = s.audioTracks;
    else {
      const i = s.maxAutoLevel, o = i > -1 ? i + 1 : s.levels.length;
      r = s.levels.slice(0, o);
    }
    return r.forEach((i) => {
      i.bitrate > t && (t = i.bitrate);
    }), t > 0 ? t : NaN;
  }
  /**
   * Get the buffer length for a media type in milliseconds
   */
  getBufferLength(e) {
    const t = this.media, r = e === yr.AUDIO ? this.audioBuffer : this.videoBuffer;
    return !r || !t ? NaN : Le.bufferInfo(r, t.currentTime, this.config.maxBufferHole).len * 1e3;
  }
  /**
   * Create a playlist loader
   */
  createPlaylistLoader() {
    const {
      pLoader: e
    } = this.config, t = this.applyPlaylistData, r = e || this.config.loader;
    return class {
      constructor(i) {
        this.loader = void 0, this.loader = new r(i);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(i, o, a) {
        t(i), this.loader.load(i, o, a);
      }
    };
  }
  /**
   * Create a playlist loader
   */
  createFragmentLoader() {
    const {
      fLoader: e
    } = this.config, t = this.applyFragmentData, r = e || this.config.loader;
    return class {
      constructor(i) {
        this.loader = void 0, this.loader = new r(i);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(i, o, a) {
        t(i), this.loader.load(i, o, a);
      }
    };
  }
}
const fw = 3e5;
class gw extends Cn {
  constructor(e) {
    super("content-steering", e.logger), this.hls = void 0, this.loader = null, this.uri = null, this.pathwayId = ".", this._pathwayPriority = null, this.timeToLoad = 300, this.reloadTimer = -1, this.updated = 0, this.started = !1, this.enabled = !0, this.levels = null, this.audioTracks = null, this.subtitleTracks = null, this.penalizedPathways = {}, this.hls = e, this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.ERROR, this.onError, this));
  }
  pathways() {
    return (this.levels || []).reduce((e, t) => (e.indexOf(t.pathwayId) === -1 && e.push(t.pathwayId), e), []);
  }
  get pathwayPriority() {
    return this._pathwayPriority;
  }
  set pathwayPriority(e) {
    this.updatePathwayPriority(e);
  }
  startLoad() {
    if (this.started = !0, this.clearTimeout(), this.enabled && this.uri) {
      if (this.updated) {
        const e = this.timeToLoad * 1e3 - (performance.now() - this.updated);
        if (e > 0) {
          this.scheduleRefresh(this.uri, e);
          return;
        }
      }
      this.loadSteeringManifest(this.uri);
    }
  }
  stopLoad() {
    this.started = !1, this.loader && (this.loader.destroy(), this.loader = null), this.clearTimeout();
  }
  clearTimeout() {
    this.reloadTimer !== -1 && (self.clearTimeout(this.reloadTimer), this.reloadTimer = -1);
  }
  destroy() {
    this.unregisterListeners(), this.stopLoad(), this.hls = null, this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  removeLevel(e) {
    const t = this.levels;
    t && (this.levels = t.filter((r) => r !== e));
  }
  onManifestLoading() {
    this.stopLoad(), this.enabled = !0, this.timeToLoad = 300, this.updated = 0, this.uri = null, this.pathwayId = ".", this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  onManifestLoaded(e, t) {
    const {
      contentSteering: r
    } = t;
    r !== null && (this.pathwayId = r.pathwayId, this.uri = r.uri, this.started && this.startLoad());
  }
  onManifestParsed(e, t) {
    this.audioTracks = t.audioTracks, this.subtitleTracks = t.subtitleTracks;
  }
  onError(e, t) {
    const {
      errorAction: r
    } = t;
    if ((r == null ? void 0 : r.action) === ar.SendAlternateToPenaltyBox && r.flags === Gr.MoveAllAlternatesMatchingHost) {
      const s = this.levels;
      let i = this._pathwayPriority, o = this.pathwayId;
      if (t.context) {
        const {
          groupId: a,
          pathwayId: l,
          type: c
        } = t.context;
        a && s ? o = this.getPathwayForGroupId(a, c, o) : l && (o = l);
      }
      o in this.penalizedPathways || (this.penalizedPathways[o] = performance.now()), !i && s && (i = this.pathways()), i && i.length > 1 && (this.updatePathwayPriority(i), r.resolved = this.pathwayId !== o), r.resolved || this.warn(`Could not resolve ${t.details} ("${t.error.message}") with content-steering for Pathway: ${o} levels: ${s && s.length} priorities: ${mt(i)} penalized: ${mt(this.penalizedPathways)}`);
    }
  }
  filterParsedLevels(e) {
    this.levels = e;
    let t = this.getLevelsForPathway(this.pathwayId);
    if (t.length === 0) {
      const r = e[0].pathwayId;
      this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${r}"`), t = this.getLevelsForPathway(r), this.pathwayId = r;
    }
    return t.length !== e.length && this.log(`Found ${t.length}/${e.length} levels in Pathway "${this.pathwayId}"`), t;
  }
  getLevelsForPathway(e) {
    return this.levels === null ? [] : this.levels.filter((t) => e === t.pathwayId);
  }
  updatePathwayPriority(e) {
    this._pathwayPriority = e;
    let t;
    const r = this.penalizedPathways, s = performance.now();
    Object.keys(r).forEach((i) => {
      s - r[i] > fw && delete r[i];
    });
    for (let i = 0; i < e.length; i++) {
      const o = e[i];
      if (o in r)
        continue;
      if (o === this.pathwayId)
        return;
      const a = this.hls.nextLoadLevel, l = this.hls.levels[a];
      if (t = this.getLevelsForPathway(o), t.length > 0) {
        this.log(`Setting Pathway to "${o}"`), this.pathwayId = o, xp(t), this.hls.trigger(T.LEVELS_UPDATED, {
          levels: t
        });
        const c = this.hls.levels[a];
        l && c && this.levels && (c.attrs["STABLE-VARIANT-ID"] !== l.attrs["STABLE-VARIANT-ID"] && c.bitrate !== l.bitrate && this.log(`Unstable Pathways change from bitrate ${l.bitrate} to ${c.bitrate}`), this.hls.nextLoadLevel = a);
        break;
      }
    }
  }
  getPathwayForGroupId(e, t, r) {
    const s = this.getLevelsForPathway(r).concat(this.levels || []);
    for (let i = 0; i < s.length; i++)
      if (t === Ke.AUDIO_TRACK && s[i].hasAudioGroup(e) || t === Ke.SUBTITLE_TRACK && s[i].hasSubtitleGroup(e))
        return s[i].pathwayId;
    return r;
  }
  clonePathways(e) {
    const t = this.levels;
    if (!t)
      return;
    const r = {}, s = {};
    e.forEach((i) => {
      const {
        ID: o,
        "BASE-ID": a,
        "URI-REPLACEMENT": l
      } = i;
      if (t.some((u) => u.pathwayId === o))
        return;
      const c = this.getLevelsForPathway(a).map((u) => {
        const d = new yt(u.attrs);
        d["PATHWAY-ID"] = o;
        const h = d.AUDIO && `${d.AUDIO}_clone_${o}`, f = d.SUBTITLES && `${d.SUBTITLES}_clone_${o}`;
        h && (r[d.AUDIO] = h, d.AUDIO = h), f && (s[d.SUBTITLES] = f, d.SUBTITLES = f);
        const p = Yp(u.uri, d["STABLE-VARIANT-ID"], "PER-VARIANT-URIS", l), y = new Bi({
          attrs: d,
          audioCodec: u.audioCodec,
          bitrate: u.bitrate,
          height: u.height,
          name: u.name,
          url: p,
          videoCodec: u.videoCodec,
          width: u.width
        });
        if (u.audioGroups)
          for (let m = 1; m < u.audioGroups.length; m++)
            y.addGroupId("audio", `${u.audioGroups[m]}_clone_${o}`);
        if (u.subtitleGroups)
          for (let m = 1; m < u.subtitleGroups.length; m++)
            y.addGroupId("text", `${u.subtitleGroups[m]}_clone_${o}`);
        return y;
      });
      t.push(...c), Xh(this.audioTracks, r, l, o), Xh(this.subtitleTracks, s, l, o);
    });
  }
  loadSteeringManifest(e) {
    const t = this.hls.config, r = t.loader;
    this.loader && this.loader.destroy(), this.loader = new r(t);
    let s;
    try {
      s = new self.URL(e);
    } catch {
      this.enabled = !1, this.log(`Failed to parse Steering Manifest URI: ${e}`);
      return;
    }
    if (s.protocol !== "data:") {
      const u = (this.hls.bandwidthEstimate || t.abrEwmaDefaultEstimate) | 0;
      s.searchParams.set("_HLS_pathway", this.pathwayId), s.searchParams.set("_HLS_throughput", "" + u);
    }
    const i = {
      responseType: "json",
      url: s.href
    }, o = t.steeringManifestLoadPolicy.default, a = o.errorRetry || o.timeoutRetry || {}, l = {
      loadPolicy: o,
      timeout: o.maxLoadTimeMs,
      maxRetry: a.maxNumRetry || 0,
      retryDelay: a.retryDelayMs || 0,
      maxRetryDelay: a.maxRetryDelayMs || 0
    }, c = {
      onSuccess: (u, d, h, f) => {
        this.log(`Loaded steering manifest: "${s}"`);
        const p = u.data;
        if ((p == null ? void 0 : p.VERSION) !== 1) {
          this.log(`Steering VERSION ${p.VERSION} not supported!`);
          return;
        }
        this.updated = performance.now(), this.timeToLoad = p.TTL;
        const {
          "RELOAD-URI": y,
          "PATHWAY-CLONES": m,
          "PATHWAY-PRIORITY": b
        } = p;
        if (y)
          try {
            this.uri = new self.URL(y, s).href;
          } catch {
            this.enabled = !1, this.log(`Failed to parse Steering Manifest RELOAD-URI: ${y}`);
            return;
          }
        this.scheduleRefresh(this.uri || h.url), m && this.clonePathways(m);
        const C = {
          steeringManifest: p,
          url: s.toString()
        };
        this.hls.trigger(T.STEERING_MANIFEST_LOADED, C), b && this.updatePathwayPriority(b);
      },
      onError: (u, d, h, f) => {
        if (this.log(`Error loading steering manifest: ${u.code} ${u.text} (${d.url})`), this.stopLoad(), u.code === 410) {
          this.enabled = !1, this.log(`Steering manifest ${d.url} no longer available`);
          return;
        }
        let p = this.timeToLoad * 1e3;
        if (u.code === 429) {
          const y = this.loader;
          if (typeof (y == null ? void 0 : y.getResponseHeader) == "function") {
            const m = y.getResponseHeader("Retry-After");
            m && (p = parseFloat(m) * 1e3);
          }
          this.log(`Steering manifest ${d.url} rate limited`);
          return;
        }
        this.scheduleRefresh(this.uri || d.url, p);
      },
      onTimeout: (u, d, h) => {
        this.log(`Timeout loading steering manifest (${d.url})`), this.scheduleRefresh(this.uri || d.url);
      }
    };
    this.log(`Requesting steering manifest: ${s}`), this.loader.load(i, l, c);
  }
  scheduleRefresh(e, t = this.timeToLoad * 1e3) {
    this.clearTimeout(), this.reloadTimer = self.setTimeout(() => {
      var r;
      const s = (r = this.hls) == null ? void 0 : r.media;
      if (s && !s.ended) {
        this.loadSteeringManifest(e);
        return;
      }
      this.scheduleRefresh(e, this.timeToLoad * 1e3);
    }, t);
  }
}
function Xh(n, e, t, r) {
  n && Object.keys(e).forEach((s) => {
    const i = n.filter((o) => o.groupId === s).map((o) => {
      const a = st({}, o);
      return a.details = void 0, a.attrs = new yt(a.attrs), a.url = a.attrs.URI = Yp(o.url, o.attrs["STABLE-RENDITION-ID"], "PER-RENDITION-URIS", t), a.groupId = a.attrs["GROUP-ID"] = e[s], a.attrs["PATHWAY-ID"] = r, a;
    });
    n.push(...i);
  });
}
function Yp(n, e, t, r) {
  const {
    HOST: s,
    PARAMS: i,
    [t]: o
  } = r;
  let a;
  e && (a = o == null ? void 0 : o[e], a && (n = a));
  const l = new self.URL(n);
  return s && !a && (l.host = s), i && Object.keys(i).sort().forEach((c) => {
    c && l.searchParams.set(c, i[c]);
  }), l.href;
}
function _r(n, e, t) {
  Or(n, e, t), n.addEventListener(e, t);
}
function Or(n, e, t) {
  n.removeEventListener(e, t);
}
class js extends Cn {
  constructor(e) {
    super("eme", e.logger), this.hls = void 0, this.config = void 0, this.media = null, this.keyFormatPromise = null, this.keySystemAccessPromises = {}, this._requestLicenseFailureCount = 0, this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, this.mediaKeys = null, this.setMediaKeysQueue = js.CDMCleanupPromise ? [js.CDMCleanupPromise] : [], this.onMediaEncrypted = (t) => {
      const {
        initDataType: r,
        initData: s
      } = t, i = `"${t.type}" event: init data type: "${r}"`;
      if (this.debug(i), s !== null) {
        if (!this.keyFormatPromise) {
          let o = Object.keys(this.keySystemAccessPromises);
          o.length || (o = di(this.config));
          const a = o.map(fo).filter((l) => !!l);
          this.keyFormatPromise = this.getKeyFormatPromise(a);
        }
        this.keyFormatPromise.then((o) => {
          const a = ko(o);
          let l, c;
          if (r === "sinf") {
            if (a !== nt.FAIRPLAY) {
              this.warn(`Ignoring unexpected "${t.type}" event with init data type: "${r}" for selected key-system ${a}`);
              return;
            }
            const p = Vt(new Uint8Array(s));
            try {
              const y = $u(JSON.parse(p).sinf), m = Zg(y);
              if (!m)
                throw new Error("'schm' box missing or not cbcs/cenc with schi > tenc");
              l = new Uint8Array(m.subarray(8, 24)), c = nt.FAIRPLAY;
            } catch (y) {
              this.warn(`${i} Failed to parse sinf: ${y}`);
              return;
            }
          } else {
            if (a !== nt.WIDEVINE && a !== nt.PLAYREADY) {
              this.warn(`Ignoring unexpected "${t.type}" event with init data type: "${r}" for selected key-system ${a}`);
              return;
            }
            const p = mb(s), y = p.filter((b) => !!b.systemId && Rl(b.systemId) === a);
            y.length > 1 && this.warn(`${i} Using first of ${y.length} pssh found for selected key-system ${a}`);
            const m = y[0];
            if (!m) {
              p.length === 0 || p.some((b) => !b.systemId) ? this.warn(`${i} contains incomplete or invalid pssh data`) : this.log(`ignoring ${i} for ${p.map((b) => Rl(b.systemId)).join(",")} pssh data in favor of playlist keys`);
              return;
            }
            if (c = Rl(m.systemId), m.version === 0 && m.data)
              if (c === nt.WIDEVINE) {
                const b = m.data.length - 22;
                l = new Uint8Array(m.data.subarray(b, b + 16));
              } else c === nt.PLAYREADY && (l = hp(m.data));
          }
          if (!c || !l)
            return;
          const u = Qr.hexDump(l), {
            keyIdToKeySessionPromise: d,
            mediaKeySessions: h
          } = this;
          let f = d[u];
          for (let p = 0; p < h.length; p++) {
            const y = h[p], m = y.decryptdata;
            if (!m.keyId)
              continue;
            const b = Qr.hexDump(m.keyId);
            if (u === b || m.uri.replace(/-/g, "").indexOf(u) !== -1) {
              if (f = d[b], m.pssh)
                break;
              delete d[b], m.pssh = new Uint8Array(s), m.keyId = l, f = d[u] = f.then(() => this.generateRequestWithPreferredKeySession(y, r, s, "encrypted-event-key-match")), f.catch((C) => this.handleError(C));
              break;
            }
          }
          if (!f) {
            if (c !== a) {
              this.log(`Ignoring "${t.type}" event with ${c} init data for selected key-system ${a}`);
              return;
            }
            f = d[u] = this.getKeySystemSelectionPromise([c]).then(({
              keySystem: p,
              mediaKeys: y
            }) => {
              var m;
              this.throwIfDestroyed();
              const b = new Ni("ISO-23001-7", u, (m = fo(p)) != null ? m : "");
              return b.pssh = new Uint8Array(s), b.keyId = l, this.attemptSetMediaKeys(p, y).then(() => {
                this.throwIfDestroyed();
                const C = this.createMediaKeySessionContext({
                  decryptdata: b,
                  keySystem: p,
                  mediaKeys: y
                });
                return this.generateRequestWithPreferredKeySession(C, r, s, "encrypted-event-no-match");
              });
            }), f.catch((p) => this.handleError(p));
          }
        });
      }
    }, this.onWaitingForKey = (t) => {
      this.log(`"${t.type}" event`);
    }, this.hls = e, this.config = e.config, this.registerListeners();
  }
  destroy() {
    this.onDestroying(), this.onMediaDetached();
    const e = this.config;
    e.requestMediaKeySystemAccessFunc = null, e.licenseXhrSetup = e.licenseResponseCallback = void 0, e.drmSystems = e.drmSystemOptions = {}, this.hls = this.config = this.keyIdToKeySessionPromise = null, this.onMediaEncrypted = this.onWaitingForKey = null;
  }
  registerListeners() {
    this.hls.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(T.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.on(T.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(T.MANIFEST_LOADED, this.onManifestLoaded, this), this.hls.on(T.DESTROYING, this.onDestroying, this);
  }
  unregisterListeners() {
    this.hls.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(T.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.off(T.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(T.MANIFEST_LOADED, this.onManifestLoaded, this), this.hls.off(T.DESTROYING, this.onDestroying, this);
  }
  getLicenseServerUrl(e) {
    const {
      drmSystems: t,
      widevineLicenseUrl: r
    } = this.config, s = t[e];
    if (s)
      return s.licenseUrl;
    if (e === nt.WIDEVINE && r)
      return r;
  }
  getLicenseServerUrlOrThrow(e) {
    const t = this.getLicenseServerUrl(e);
    if (t === void 0)
      throw new Error(`no license server URL configured for key-system "${e}"`);
    return t;
  }
  getServerCertificateUrl(e) {
    const {
      drmSystems: t
    } = this.config, r = t[e];
    if (r)
      return r.serverCertificateUrl;
    this.log(`No Server Certificate in config.drmSystems["${e}"]`);
  }
  attemptKeySystemAccess(e) {
    const t = this.hls.levels, r = (o, a, l) => !!o && l.indexOf(o) === a, s = t.map((o) => o.audioCodec).filter(r), i = t.map((o) => o.videoCodec).filter(r);
    return s.length + i.length === 0 && i.push("avc1.42e01e"), new Promise((o, a) => {
      const l = (c) => {
        const u = c.shift();
        this.getMediaKeysPromise(u, s, i).then((d) => o({
          keySystem: u,
          mediaKeys: d
        })).catch((d) => {
          c.length ? l(c) : d instanceof kr ? a(d) : a(new kr({
            type: ge.KEY_SYSTEM_ERROR,
            details: Y.KEY_SYSTEM_NO_ACCESS,
            error: d,
            fatal: !0
          }, d.message));
        });
      };
      l(e);
    });
  }
  requestMediaKeySystemAccess(e, t) {
    const {
      requestMediaKeySystemAccessFunc: r
    } = this.config;
    if (typeof r != "function") {
      let s = `Configured requestMediaKeySystemAccess is not a function ${r}`;
      return dp === null && self.location.protocol === "http:" && (s = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`), Promise.reject(new Error(s));
    }
    return r(e, t);
  }
  getMediaKeysPromise(e, t, r) {
    const s = oT(e, t, r, this.config.drmSystemOptions), i = this.keySystemAccessPromises[e];
    let o = i == null ? void 0 : i.keySystemAccess;
    if (!o) {
      this.log(`Requesting encrypted media "${e}" key-system access with config: ${mt(s)}`), o = this.requestMediaKeySystemAccess(e, s);
      const a = this.keySystemAccessPromises[e] = {
        keySystemAccess: o
      };
      return o.catch((l) => {
        this.log(`Failed to obtain access to key-system "${e}": ${l}`);
      }), o.then((l) => {
        this.log(`Access for key-system "${l.keySystem}" obtained`);
        const c = this.fetchServerCertificate(e);
        return this.log(`Create media-keys for "${e}"`), a.mediaKeys = l.createMediaKeys().then((u) => (this.log(`Media-keys created for "${e}"`), a.hasMediaKeys = !0, c.then((d) => d ? this.setMediaKeysServerCertificate(u, e, d) : u))), a.mediaKeys.catch((u) => {
          this.error(`Failed to create media-keys for "${e}"}: ${u}`);
        }), a.mediaKeys;
      });
    }
    return o.then(() => i.mediaKeys);
  }
  createMediaKeySessionContext({
    decryptdata: e,
    keySystem: t,
    mediaKeys: r
  }) {
    this.log(`Creating key-system session "${t}" keyId: ${Qr.hexDump(e.keyId || [])}`);
    const s = r.createSession(), i = {
      decryptdata: e,
      keySystem: t,
      mediaKeys: r,
      mediaKeysSession: s,
      keyStatus: "status-pending"
    };
    return this.mediaKeySessions.push(i), i;
  }
  renewKeySession(e) {
    const t = e.decryptdata;
    if (t.pssh) {
      const r = this.createMediaKeySessionContext(e), s = this.getKeyIdString(t), i = "cenc";
      this.keyIdToKeySessionPromise[s] = this.generateRequestWithPreferredKeySession(r, i, t.pssh.buffer, "expired");
    } else
      this.warn("Could not renew expired session. Missing pssh initData.");
    this.removeSession(e);
  }
  getKeyIdString(e) {
    if (!e)
      throw new Error("Could not read keyId of undefined decryptdata");
    if (e.keyId === null)
      throw new Error("keyId is null");
    return Qr.hexDump(e.keyId);
  }
  updateKeySession(e, t) {
    var r;
    const s = e.mediaKeysSession;
    return this.log(`Updating key-session "${s.sessionId}" for keyID ${Qr.hexDump(((r = e.decryptdata) == null ? void 0 : r.keyId) || [])}
      } (data length: ${t && t.byteLength})`), s.update(t);
  }
  getSelectedKeySystemFormats() {
    return Object.keys(this.keySystemAccessPromises).map((e) => ({
      keySystem: e,
      hasMediaKeys: this.keySystemAccessPromises[e].hasMediaKeys
    })).filter(({
      hasMediaKeys: e
    }) => !!e).map(({
      keySystem: e
    }) => fo(e)).filter((e) => !!e);
  }
  getKeySystemAccess(e) {
    return this.getKeySystemSelectionPromise(e).then(({
      keySystem: t,
      mediaKeys: r
    }) => this.attemptSetMediaKeys(t, r));
  }
  selectKeySystem(e) {
    return new Promise((t, r) => this.getKeySystemSelectionPromise(e).then(({
      keySystem: s
    }) => {
      const i = fo(s);
      i ? t(i) : r(new Error(`Unable to find format for key-system "${s}"`));
    }).catch(r));
  }
  selectKeySystemFormat(e) {
    const t = Object.keys(e.levelkeys || {});
    return this.keyFormatPromise || (this.log(`Selecting key-system from fragment (sn: ${e.sn} ${e.type}: ${e.level}) key formats ${t.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(t)), this.keyFormatPromise;
  }
  getKeyFormatPromise(e) {
    const t = di(this.config), r = e.map(ko).filter((s) => !!s && t.indexOf(s) !== -1);
    return this.selectKeySystem(r);
  }
  loadKey(e) {
    const t = e.keyInfo.decryptdata, r = this.getKeyIdString(t), s = `(keyId: ${r} format: "${t.keyFormat}" method: ${t.method} uri: ${t.uri})`;
    this.log(`Starting session for key ${s}`);
    let i = this.keyIdToKeySessionPromise[r];
    return i || (i = this.getKeySystemForKeyPromise(t).then(({
      keySystem: a,
      mediaKeys: l
    }) => (this.throwIfDestroyed(), this.log(`Handle encrypted media sn: ${e.frag.sn} ${e.frag.type}: ${e.frag.level} using key ${s}`), this.attemptSetMediaKeys(a, l).then(() => (this.throwIfDestroyed(), this.createMediaKeySessionContext({
      keySystem: a,
      mediaKeys: l,
      decryptdata: t
    }))))), (this.keyIdToKeySessionPromise[r] = i.then((a) => {
      const l = "cenc", c = t.pssh ? t.pssh.buffer : null;
      return this.generateRequestWithPreferredKeySession(a, l, c, "playlist-key");
    })).catch((a) => this.handleError(a))), i;
  }
  throwIfDestroyed(e = "Invalid state") {
    if (!this.hls)
      throw new Error("invalid state");
  }
  handleError(e) {
    this.hls && (this.error(e.message), e instanceof kr ? this.hls.trigger(T.ERROR, e.data) : this.hls.trigger(T.ERROR, {
      type: ge.KEY_SYSTEM_ERROR,
      details: Y.KEY_SYSTEM_NO_KEYS,
      error: e,
      fatal: !0
    }));
  }
  getKeySystemForKeyPromise(e) {
    const t = this.getKeyIdString(e), r = this.keyIdToKeySessionPromise[t];
    if (!r) {
      const s = ko(e.keyFormat), i = s ? [s] : di(this.config);
      return this.attemptKeySystemAccess(i);
    }
    return r;
  }
  getKeySystemSelectionPromise(e) {
    if (e.length || (e = di(this.config)), e.length === 0)
      throw new kr({
        type: ge.KEY_SYSTEM_ERROR,
        details: Y.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
        fatal: !0
      }, `Missing key-system license configuration options ${mt({
        drmSystems: this.config.drmSystems
      })}`);
    return this.attemptKeySystemAccess(e);
  }
  attemptSetMediaKeys(e, t) {
    if (this.mediaKeys === t)
      return Promise.resolve();
    const r = this.setMediaKeysQueue.slice();
    this.log(`Setting media-keys for "${e}"`);
    const s = Promise.all(r).then(() => {
      if (!this.media)
        throw this.mediaKeys = null, new Error("Attempted to set mediaKeys without media element attached");
      return this.media.setMediaKeys(t);
    });
    return this.mediaKeys = t, this.setMediaKeysQueue.push(s), s.then(() => {
      this.log(`Media-keys set for "${e}"`), r.push(s), this.setMediaKeysQueue = this.setMediaKeysQueue.filter((i) => r.indexOf(i) === -1);
    });
  }
  generateRequestWithPreferredKeySession(e, t, r, s) {
    var i, o;
    const a = (i = this.config.drmSystems) == null || (o = i[e.keySystem]) == null ? void 0 : o.generateRequest;
    if (a)
      try {
        const p = a.call(this.hls, t, r, e);
        if (!p)
          throw new Error("Invalid response from configured generateRequest filter");
        t = p.initDataType, r = p.initData ? p.initData : null, e.decryptdata.pssh = r ? new Uint8Array(r) : null;
      } catch (p) {
        var l;
        if (this.warn(p.message), (l = this.hls) != null && l.config.debug)
          throw p;
      }
    if (r === null)
      return this.log(`Skipping key-session request for "${s}" (no initData)`), Promise.resolve(e);
    const c = this.getKeyIdString(e.decryptdata);
    this.log(`Generating key-session request for "${s}": ${c} (init data type: ${t} length: ${r ? r.byteLength : null})`);
    const u = new ju(), d = e._onmessage = (p) => {
      const y = e.mediaKeysSession;
      if (!y) {
        u.emit("error", new Error("invalid state"));
        return;
      }
      const {
        messageType: m,
        message: b
      } = p;
      this.log(`"${m}" message event for session "${y.sessionId}" message size: ${b.byteLength}`), m === "license-request" || m === "license-renewal" ? this.renewLicense(e, b).catch((C) => {
        u.eventNames().length ? u.emit("error", C) : this.handleError(C);
      }) : m === "license-release" ? e.keySystem === nt.FAIRPLAY && (this.updateKeySession(e, Ic("acknowledged")), this.removeSession(e)) : this.warn(`unhandled media key message type "${m}"`);
    }, h = e._onkeystatuseschange = (p) => {
      if (!e.mediaKeysSession) {
        u.emit("error", new Error("invalid state"));
        return;
      }
      this.onKeyStatusChange(e);
      const m = e.keyStatus;
      u.emit("keyStatus", m), m === "expired" && (this.warn(`${e.keySystem} expired for key ${c}`), this.renewKeySession(e));
    };
    _r(e.mediaKeysSession, "message", d), _r(e.mediaKeysSession, "keystatuseschange", h);
    const f = new Promise((p, y) => {
      u.on("error", y), u.on("keyStatus", (m) => {
        m.startsWith("usable") ? p() : m === "output-restricted" ? y(new kr({
          type: ge.KEY_SYSTEM_ERROR,
          details: Y.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
          fatal: !1
        }, "HDCP level output restricted")) : m === "internal-error" ? y(new kr({
          type: ge.KEY_SYSTEM_ERROR,
          details: Y.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
          fatal: !0
        }, `key status changed to "${m}"`)) : m === "expired" ? y(new Error("key expired while generating request")) : this.warn(`unhandled key status change "${m}"`);
      });
    });
    return e.mediaKeysSession.generateRequest(t, r).then(() => {
      var p;
      this.log(`Request generated for key-session "${(p = e.mediaKeysSession) == null ? void 0 : p.sessionId}" keyId: ${c}`);
    }).catch((p) => {
      throw new kr({
        type: ge.KEY_SYSTEM_ERROR,
        details: Y.KEY_SYSTEM_NO_SESSION,
        error: p,
        fatal: !1
      }, `Error generating key-session request: ${p}`);
    }).then(() => f).catch((p) => {
      throw u.removeAllListeners(), this.removeSession(e), p;
    }).then(() => (u.removeAllListeners(), e));
  }
  onKeyStatusChange(e) {
    e.mediaKeysSession.keyStatuses.forEach((t, r) => {
      if (typeof r == "string" && typeof t == "object") {
        const s = r;
        r = t, t = s;
      }
      this.log(`key status change "${t}" for keyStatuses keyId: ${Qr.hexDump("buffer" in r ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength) : new Uint8Array(r))} session keyId: ${Qr.hexDump(new Uint8Array(e.decryptdata.keyId || []))} uri: ${e.decryptdata.uri}`), e.keyStatus = t;
    });
  }
  fetchServerCertificate(e) {
    const t = this.config, r = t.loader, s = new r(t), i = this.getServerCertificateUrl(e);
    return i ? (this.log(`Fetching server certificate for "${e}"`), new Promise((o, a) => {
      const l = {
        responseType: "arraybuffer",
        url: i
      }, c = t.certLoadPolicy.default, u = {
        loadPolicy: c,
        timeout: c.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, d = {
        onSuccess: (h, f, p, y) => {
          o(h.data);
        },
        onError: (h, f, p, y) => {
          a(new kr({
            type: ge.KEY_SYSTEM_ERROR,
            details: Y.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: p,
            response: rt({
              url: l.url,
              data: void 0
            }, h)
          }, `"${e}" certificate request failed (${i}). Status: ${h.code} (${h.text})`));
        },
        onTimeout: (h, f, p) => {
          a(new kr({
            type: ge.KEY_SYSTEM_ERROR,
            details: Y.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: p,
            response: {
              url: l.url,
              data: void 0
            }
          }, `"${e}" certificate request timed out (${i})`));
        },
        onAbort: (h, f, p) => {
          a(new Error("aborted"));
        }
      };
      s.load(l, u, d);
    })) : Promise.resolve();
  }
  setMediaKeysServerCertificate(e, t, r) {
    return new Promise((s, i) => {
      e.setServerCertificate(r).then((o) => {
        this.log(`setServerCertificate ${o ? "success" : "not supported by CDM"} (${r == null ? void 0 : r.byteLength}) on "${t}"`), s(e);
      }).catch((o) => {
        i(new kr({
          type: ge.KEY_SYSTEM_ERROR,
          details: Y.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
          error: o,
          fatal: !0
        }, o.message));
      });
    });
  }
  renewLicense(e, t) {
    return this.requestLicense(e, new Uint8Array(t)).then((r) => this.updateKeySession(e, new Uint8Array(r)).catch((s) => {
      throw new kr({
        type: ge.KEY_SYSTEM_ERROR,
        details: Y.KEY_SYSTEM_SESSION_UPDATE_FAILED,
        error: s,
        fatal: !0
      }, s.message);
    }));
  }
  unpackPlayReadyKeyMessage(e, t) {
    const r = String.fromCharCode.apply(null, new Uint16Array(t.buffer));
    if (!r.includes("PlayReadyKeyMessage"))
      return e.setRequestHeader("Content-Type", "text/xml; charset=utf-8"), t;
    const s = new DOMParser().parseFromString(r, "application/xml"), i = s.querySelectorAll("HttpHeader");
    if (i.length > 0) {
      let u;
      for (let d = 0, h = i.length; d < h; d++) {
        var o, a;
        u = i[d];
        const f = (o = u.querySelector("name")) == null ? void 0 : o.textContent, p = (a = u.querySelector("value")) == null ? void 0 : a.textContent;
        f && p && e.setRequestHeader(f, p);
      }
    }
    const l = s.querySelector("Challenge"), c = l == null ? void 0 : l.textContent;
    if (!c)
      throw new Error("Cannot find <Challenge> in key message");
    return Ic(atob(c));
  }
  setupLicenseXHR(e, t, r, s) {
    const i = this.config.licenseXhrSetup;
    return i ? Promise.resolve().then(() => {
      if (!r.decryptdata)
        throw new Error("Key removed");
      return i.call(this.hls, e, t, r, s);
    }).catch((o) => {
      if (!r.decryptdata)
        throw o;
      return e.open("POST", t, !0), i.call(this.hls, e, t, r, s);
    }).then((o) => (e.readyState || e.open("POST", t, !0), {
      xhr: e,
      licenseChallenge: o || s
    })) : (e.open("POST", t, !0), Promise.resolve({
      xhr: e,
      licenseChallenge: s
    }));
  }
  requestLicense(e, t) {
    const r = this.config.keyLoadPolicy.default;
    return new Promise((s, i) => {
      const o = this.getLicenseServerUrlOrThrow(e.keySystem);
      this.log(`Sending license request to URL: ${o}`);
      const a = new XMLHttpRequest();
      a.responseType = "arraybuffer", a.onreadystatechange = () => {
        if (!this.hls || !e.mediaKeysSession)
          return i(new Error("invalid state"));
        if (a.readyState === 4)
          if (a.status === 200) {
            this._requestLicenseFailureCount = 0;
            let l = a.response;
            this.log(`License received ${l instanceof ArrayBuffer ? l.byteLength : l}`);
            const c = this.config.licenseResponseCallback;
            if (c)
              try {
                l = c.call(this.hls, a, o, e);
              } catch (u) {
                this.error(u);
              }
            s(l);
          } else {
            const l = r.errorRetry, c = l ? l.maxNumRetry : 0;
            if (this._requestLicenseFailureCount++, this._requestLicenseFailureCount > c || a.status >= 400 && a.status < 500)
              i(new kr({
                type: ge.KEY_SYSTEM_ERROR,
                details: Y.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: !0,
                networkDetails: a,
                response: {
                  url: o,
                  data: void 0,
                  code: a.status,
                  text: a.statusText
                }
              }, `License Request XHR failed (${o}). Status: ${a.status} (${a.statusText})`));
            else {
              const u = c - this._requestLicenseFailureCount + 1;
              this.warn(`Retrying license request, ${u} attempts left`), this.requestLicense(e, t).then(s, i);
            }
          }
      }, e.licenseXhr && e.licenseXhr.readyState !== XMLHttpRequest.DONE && e.licenseXhr.abort(), e.licenseXhr = a, this.setupLicenseXHR(a, o, e, t).then(({
        xhr: l,
        licenseChallenge: c
      }) => {
        e.keySystem == nt.PLAYREADY && (c = this.unpackPlayReadyKeyMessage(l, c)), l.send(c);
      });
    });
  }
  onDestroying() {
    this.unregisterListeners(), this._clear();
  }
  onMediaAttached(e, t) {
    if (!this.config.emeEnabled)
      return;
    const r = t.media;
    this.media = r, _r(r, "encrypted", this.onMediaEncrypted), _r(r, "waitingforkey", this.onWaitingForKey);
  }
  onMediaDetached() {
    const e = this.media;
    e && (Or(e, "encrypted", this.onMediaEncrypted), Or(e, "waitingforkey", this.onWaitingForKey), this.media = null, this.mediaKeys = null);
  }
  _clear() {
    var e;
    if (this._requestLicenseFailureCount = 0, this.keyIdToKeySessionPromise = {}, !this.mediaKeys && !this.mediaKeySessions.length)
      return;
    const t = this.media, r = this.mediaKeySessions.slice();
    this.mediaKeySessions = [], this.mediaKeys = null, Ni.clearKeyUriToKeyIdMap();
    const s = r.length;
    js.CDMCleanupPromise = Promise.all(r.map((i) => this.removeSession(i)).concat(t == null || (e = t.setMediaKeys(null)) == null ? void 0 : e.catch((i) => {
      var o;
      this.log(`Could not clear media keys: ${i}`), (o = this.hls) == null || o.trigger(T.ERROR, {
        type: ge.OTHER_ERROR,
        details: Y.KEY_SYSTEM_DESTROY_MEDIA_KEYS_ERROR,
        fatal: !1,
        error: new Error(`Could not clear media keys: ${i}`)
      });
    }))).catch((i) => {
      var o;
      this.log(`Could not close sessions and clear media keys: ${i}`), (o = this.hls) == null || o.trigger(T.ERROR, {
        type: ge.OTHER_ERROR,
        details: Y.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR,
        fatal: !1,
        error: new Error(`Could not close sessions and clear media keys: ${i}`)
      });
    }).then(() => {
      s && this.log("finished closing key sessions and clearing media keys");
    });
  }
  onManifestLoading() {
    this.keyFormatPromise = null;
  }
  onManifestLoaded(e, {
    sessionKeys: t
  }) {
    if (!(!t || !this.config.emeEnabled) && !this.keyFormatPromise) {
      const r = t.reduce((s, i) => (s.indexOf(i.keyFormat) === -1 && s.push(i.keyFormat), s), []);
      this.log(`Selecting key-system from session-keys ${r.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(r);
    }
  }
  removeSession(e) {
    const {
      mediaKeysSession: t,
      licenseXhr: r
    } = e;
    if (t) {
      this.log(`Remove licenses and keys and close session ${t.sessionId}`), e._onmessage && (t.removeEventListener("message", e._onmessage), e._onmessage = void 0), e._onkeystatuseschange && (t.removeEventListener("keystatuseschange", e._onkeystatuseschange), e._onkeystatuseschange = void 0), r && r.readyState !== XMLHttpRequest.DONE && r.abort(), e.mediaKeysSession = e.decryptdata = e.licenseXhr = void 0;
      const s = this.mediaKeySessions.indexOf(e);
      s > -1 && this.mediaKeySessions.splice(s, 1);
      const {
        drmSystemOptions: i
      } = this.config;
      return (lT(i) ? new Promise((a, l) => {
        self.setTimeout(() => l(new Error("MediaKeySession.remove() timeout")), 8e3), t.remove().then(a);
      }) : Promise.resolve()).catch((a) => {
        var l;
        this.log(`Could not remove session: ${a}`), (l = this.hls) == null || l.trigger(T.ERROR, {
          type: ge.OTHER_ERROR,
          details: Y.KEY_SYSTEM_DESTROY_REMOVE_SESSION_ERROR,
          fatal: !1,
          error: new Error(`Could not remove session: ${a}`)
        });
      }).then(() => t.close()).catch((a) => {
        var l;
        this.log(`Could not close session: ${a}`), (l = this.hls) == null || l.trigger(T.ERROR, {
          type: ge.OTHER_ERROR,
          details: Y.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR,
          fatal: !1,
          error: new Error(`Could not close session: ${a}`)
        });
      });
    }
  }
}
js.CDMCleanupPromise = void 0;
class kr extends Error {
  constructor(e, t) {
    super(t), this.data = void 0, e.error || (e.error = new Error(t)), this.data = e, e.err = e.error;
  }
}
class pw {
  constructor(e) {
    this.hls = void 0, this.isVideoPlaybackQualityAvailable = !1, this.timer = void 0, this.media = null, this.lastTime = void 0, this.lastDroppedFrames = 0, this.lastDecodedFrames = 0, this.streamController = void 0, this.hls = e, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  registerListeners() {
    this.hls.on(T.MEDIA_ATTACHING, this.onMediaAttaching, this), this.hls.on(T.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListeners() {
    this.hls.off(T.MEDIA_ATTACHING, this.onMediaAttaching, this), this.hls.off(T.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  destroy() {
    this.timer && clearInterval(this.timer), this.unregisterListeners(), this.isVideoPlaybackQualityAvailable = !1, this.media = null;
  }
  onMediaAttaching(e, t) {
    const r = this.hls.config;
    if (r.capLevelOnFPSDrop) {
      const s = t.media instanceof self.HTMLVideoElement ? t.media : null;
      this.media = s, s && typeof s.getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), self.clearInterval(this.timer), this.timer = self.setInterval(this.checkFPSInterval.bind(this), r.fpsDroppedMonitoringPeriod);
    }
  }
  onMediaDetaching() {
    this.media = null;
  }
  checkFPS(e, t, r) {
    const s = performance.now();
    if (t) {
      if (this.lastTime) {
        const i = s - this.lastTime, o = r - this.lastDroppedFrames, a = t - this.lastDecodedFrames, l = 1e3 * o / i, c = this.hls;
        if (c.trigger(T.FPS_DROP, {
          currentDropped: o,
          currentDecoded: a,
          totalDroppedFrames: r
        }), l > 0 && o > c.config.fpsDroppedMonitoringThreshold * a) {
          let u = c.currentLevel;
          c.logger.warn("drop FPS ratio greater than max allowed value for currentLevel: " + u), u > 0 && (c.autoLevelCapping === -1 || c.autoLevelCapping >= u) && (u = u - 1, c.trigger(T.FPS_DROP_LEVEL_CAPPING, {
            level: u,
            droppedLevel: c.currentLevel
          }), c.autoLevelCapping = u, this.streamController.nextLevelSwitch());
        }
      }
      this.lastTime = s, this.lastDroppedFrames = r, this.lastDecodedFrames = t;
    }
  }
  checkFPSInterval() {
    const e = this.media;
    if (e)
      if (this.isVideoPlaybackQualityAvailable) {
        const t = e.getVideoPlaybackQuality();
        this.checkFPS(e, t.totalVideoFrames, t.droppedVideoFrames);
      } else
        this.checkFPS(e, e.webkitDecodedFrameCount, e.webkitDroppedFrameCount);
  }
}
function Zp(n, e) {
  let t;
  try {
    t = new Event("addtrack");
  } catch {
    t = document.createEvent("Event"), t.initEvent("addtrack", !1, !1);
  }
  t.track = n, e.dispatchEvent(t);
}
function Xp(n, e) {
  const t = n.mode;
  if (t === "disabled" && (n.mode = "hidden"), n.cues && !n.cues.getCueById(e.id))
    try {
      if (n.addCue(e), !n.cues.getCueById(e.id))
        throw new Error(`addCue is failed for: ${e}`);
    } catch (r) {
      Ze.debug(`[texttrack-utils]: ${r}`);
      try {
        const s = new self.TextTrackCue(e.startTime, e.endTime, e.text);
        s.id = e.id, n.addCue(s);
      } catch (s) {
        Ze.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${s}`);
      }
    }
  t === "disabled" && (n.mode = t);
}
function Ns(n, e) {
  const t = n.mode;
  if (t === "disabled" && (n.mode = "hidden"), n.cues)
    for (let r = n.cues.length; r--; )
      e && n.cues[r].removeEventListener("enter", e), n.removeCue(n.cues[r]);
  t === "disabled" && (n.mode = t);
}
function Mc(n, e, t, r) {
  const s = n.mode;
  if (s === "disabled" && (n.mode = "hidden"), n.cues && n.cues.length > 0) {
    const i = yw(n.cues, e, t);
    for (let o = 0; o < i.length; o++)
      (!r || r(i[o])) && n.removeCue(i[o]);
  }
  s === "disabled" && (n.mode = s);
}
function mw(n, e) {
  if (e <= n[0].startTime)
    return 0;
  const t = n.length - 1;
  if (e > n[t].endTime)
    return -1;
  let r = 0, s = t, i;
  for (; r <= s; )
    if (i = Math.floor((s + r) / 2), e < n[i].startTime)
      s = i - 1;
    else if (e > n[i].startTime && r < t)
      r = i + 1;
    else
      return i;
  return n[r].startTime - e < e - n[s].startTime ? r : s;
}
function yw(n, e, t) {
  const r = [], s = mw(n, e);
  if (s > -1)
    for (let i = s, o = n.length; i < o; i++) {
      const a = n[i];
      if (a.startTime >= e && a.endTime <= t)
        r.push(a);
      else if (a.startTime > t)
        return r;
    }
  return r;
}
function Oo(n) {
  const e = [];
  for (let t = 0; t < n.length; t++) {
    const r = n[t];
    (r.kind === "subtitles" || r.kind === "captions") && r.label && e.push(n[t]);
  }
  return e;
}
class vw extends Yu {
  constructor(e) {
    super(e, "subtitle-track-controller"), this.media = null, this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.queuedDefaultTrack = -1, this.useTextTrackPolling = !1, this.subtitlePollingInterval = -1, this._subtitleDisplay = !0, this.asyncPollTrackChange = () => this.pollTrackChange(0), this.onTextTracksChanged = () => {
      if (this.useTextTrackPolling || self.clearInterval(this.subtitlePollingInterval), !this.media || !this.hls.config.renderTextTracksNatively)
        return;
      let t = null;
      const r = Oo(this.media.textTracks);
      for (let i = 0; i < r.length; i++)
        if (r[i].mode === "hidden")
          t = r[i];
        else if (r[i].mode === "showing") {
          t = r[i];
          break;
        }
      const s = this.findTrackForTextTrack(t);
      this.subtitleTrack !== s && this.setSubtitleTrack(s);
    }, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, this.onTextTracksChanged = this.asyncPollTrackChange = null, super.destroy();
  }
  get subtitleDisplay() {
    return this._subtitleDisplay;
  }
  set subtitleDisplay(e) {
    this._subtitleDisplay = e, this.trackId > -1 && this.toggleTrackModes();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.LEVEL_LOADING, this.onLevelLoading, this), e.on(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(T.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(T.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.LEVEL_LOADING, this.onLevelLoading, this), e.off(T.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(T.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(T.ERROR, this.onError, this);
  }
  // Listen for subtitle track change, then extract the current track ID.
  onMediaAttached(e, t) {
    this.media = t.media, this.media && (this.queuedDefaultTrack > -1 && (this.subtitleTrack = this.queuedDefaultTrack, this.queuedDefaultTrack = -1), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.pollTrackChange(500) : this.media.textTracks.addEventListener("change", this.asyncPollTrackChange));
  }
  pollTrackChange(e) {
    self.clearInterval(this.subtitlePollingInterval), this.subtitlePollingInterval = self.setInterval(this.onTextTracksChanged, e);
  }
  onMediaDetaching(e, t) {
    const r = this.media;
    if (!r)
      return;
    const s = !!t.transferMedia;
    if (self.clearInterval(this.subtitlePollingInterval), this.useTextTrackPolling || r.textTracks.removeEventListener("change", this.asyncPollTrackChange), this.trackId > -1 && (this.queuedDefaultTrack = this.trackId), this.subtitleTrack = -1, this.media = null, s)
      return;
    Oo(r.textTracks).forEach((o) => {
      Ns(o);
    });
  }
  onManifestLoading() {
    this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0;
  }
  // Fired whenever a new manifest is loaded.
  onManifestParsed(e, t) {
    this.tracks = t.subtitleTracks;
  }
  onSubtitleTrackLoaded(e, t) {
    const {
      id: r,
      groupId: s,
      details: i
    } = t, o = this.tracksInGroup[r];
    if (!o || o.groupId !== s) {
      this.warn(`Subtitle track with id:${r} and group:${s} not found in active group ${o == null ? void 0 : o.groupId}`);
      return;
    }
    const a = o.details;
    o.details = t.details, this.log(`Subtitle track ${r} "${o.name}" lang:${o.lang} group:${s} loaded [${i.startSN}-${i.endSN}]`), r === this.trackId && this.playlistLoaded(r, t, a);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!t)
      return;
    const r = t.subtitleGroups || null, s = this.groupIds;
    let i = this.currentTrack;
    if (!r || (s == null ? void 0 : s.length) !== (r == null ? void 0 : r.length) || r != null && r.some((o) => (s == null ? void 0 : s.indexOf(o)) === -1)) {
      this.groupIds = r, this.trackId = -1, this.currentTrack = null;
      const o = this.tracks.filter((u) => !r || r.indexOf(u.groupId) !== -1);
      if (o.length)
        this.selectDefaultTrack && !o.some((u) => u.default) && (this.selectDefaultTrack = !1), o.forEach((u, d) => {
          u.id = d;
        });
      else if (!i && !this.tracksInGroup.length)
        return;
      this.tracksInGroup = o;
      const a = this.hls.config.subtitlePreference;
      if (!i && a) {
        this.selectDefaultTrack = !1;
        const u = sn(a, o);
        if (u > -1)
          i = o[u];
        else {
          const d = sn(a, this.tracks);
          i = this.tracks[d];
        }
      }
      let l = this.findTrackId(i);
      l === -1 && i && (l = this.findTrackId(null));
      const c = {
        subtitleTracks: o
      };
      this.log(`Updating subtitle tracks, ${o.length} track(s) found in "${r == null ? void 0 : r.join(",")}" group-id`), this.hls.trigger(T.SUBTITLE_TRACKS_UPDATED, c), l !== -1 && this.trackId === -1 && this.setSubtitleTrack(l);
    }
  }
  findTrackId(e) {
    const t = this.tracksInGroup, r = this.selectDefaultTrack;
    for (let s = 0; s < t.length; s++) {
      const i = t[s];
      if (!(r && !i.default || !r && !e) && (!e || ls(i, e)))
        return s;
    }
    if (e) {
      for (let s = 0; s < t.length; s++) {
        const i = t[s];
        if (ji(e.attrs, i.attrs, ["LANGUAGE", "ASSOC-LANGUAGE", "CHARACTERISTICS"]))
          return s;
      }
      for (let s = 0; s < t.length; s++) {
        const i = t[s];
        if (ji(e.attrs, i.attrs, ["LANGUAGE"]))
          return s;
      }
    }
    return -1;
  }
  findTrackForTextTrack(e) {
    if (e) {
      const t = this.tracksInGroup;
      for (let r = 0; r < t.length; r++) {
        const s = t[r];
        if (kc(s, e))
          return r;
      }
    }
    return -1;
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === Ke.SUBTITLE_TRACK && t.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(t.context.groupId) !== -1) && this.checkRetry(t);
  }
  get allSubtitleTracks() {
    return this.tracks;
  }
  /** get alternate subtitle tracks list from playlist **/
  get subtitleTracks() {
    return this.tracksInGroup;
  }
  /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
  get subtitleTrack() {
    return this.trackId;
  }
  set subtitleTrack(e) {
    this.selectDefaultTrack = !1, this.setSubtitleTrack(e);
  }
  setSubtitleOption(e) {
    if (this.hls.config.subtitlePreference = e, e) {
      if (e.id === -1)
        return this.setSubtitleTrack(-1), null;
      const t = this.allSubtitleTracks;
      if (this.selectDefaultTrack = !1, t.length) {
        const r = this.currentTrack;
        if (r && ls(e, r))
          return r;
        const s = sn(e, this.tracksInGroup);
        if (s > -1) {
          const i = this.tracksInGroup[s];
          return this.setSubtitleTrack(s), i;
        } else {
          if (r)
            return null;
          {
            const i = sn(e, t);
            if (i > -1)
              return t[i];
          }
        }
      }
    }
    return null;
  }
  loadPlaylist(e) {
    super.loadPlaylist(), this.shouldLoadPlaylist(this.currentTrack) && this.scheduleLoading(this.currentTrack, e);
  }
  loadingPlaylist(e, t) {
    super.loadingPlaylist(e, t);
    const r = e.id, s = e.groupId, i = this.getUrlWithDirectives(e.url, t), o = e.details, a = o == null ? void 0 : o.age;
    this.log(`Loading subtitle ${r} "${e.name}" lang:${e.lang} group:${s}${(t == null ? void 0 : t.msn) !== void 0 ? " at sn " + t.msn + " part " + t.part : ""}${a && o.live ? " age " + a.toFixed(1) + (o.type && " " + o.type || "") : ""} ${i}`), this.hls.trigger(T.SUBTITLE_TRACK_LOADING, {
      url: i,
      id: r,
      groupId: s,
      deliveryDirectives: t || null,
      track: e
    });
  }
  /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */
  toggleTrackModes() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = Oo(e.textTracks), r = this.currentTrack;
    let s;
    if (r && (s = t.filter((i) => kc(r, i))[0], s || this.warn(`Unable to find subtitle TextTrack with name "${r.name}" and language "${r.lang}"`)), [].slice.call(t).forEach((i) => {
      i.mode !== "disabled" && i !== s && (i.mode = "disabled");
    }), s) {
      const i = this.subtitleDisplay ? "showing" : "hidden";
      s.mode !== i && (s.mode = i);
    }
  }
  /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */
  setSubtitleTrack(e) {
    const t = this.tracksInGroup;
    if (!this.media) {
      this.queuedDefaultTrack = e;
      return;
    }
    if (e < -1 || e >= t.length || !ae(e)) {
      this.warn(`Invalid subtitle track id: ${e}`);
      return;
    }
    this.selectDefaultTrack = !1;
    const r = this.currentTrack, s = t[e] || null;
    if (this.trackId = e, this.currentTrack = s, this.toggleTrackModes(), !s) {
      this.hls.trigger(T.SUBTITLE_TRACK_SWITCH, {
        id: e
      });
      return;
    }
    const i = !!s.details && !s.details.live;
    if (e === this.trackId && s === r && i)
      return;
    this.log(`Switching to subtitle-track ${e}` + (s ? ` "${s.name}" lang:${s.lang} group:${s.groupId}` : ""));
    const {
      id: o,
      groupId: a = "",
      name: l,
      type: c,
      url: u
    } = s;
    this.hls.trigger(T.SUBTITLE_TRACK_SWITCH, {
      id: o,
      groupId: a,
      name: l,
      type: c,
      url: u
    });
    const d = this.switchParams(s.url, r == null ? void 0 : r.details, s.details);
    this.loadPlaylist(d);
  }
}
function xw() {
  try {
    return crypto.randomUUID();
  } catch {
    try {
      const e = URL.createObjectURL(new Blob()), t = e.toString();
      return URL.revokeObjectURL(e), t.slice(t.lastIndexOf("/") + 1);
    } catch {
      let t = (/* @__PURE__ */ new Date()).getTime();
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (s) => {
        const i = (t + Math.random() * 16) % 16 | 0;
        return t = Math.floor(t / 16), (s == "x" ? i : i & 3 | 8).toString(16);
      });
    }
  }
}
function vi(n) {
  let e = 5381, t = n.length;
  for (; t; )
    e = e * 33 ^ n.charCodeAt(--t);
  return (e >>> 0).toString();
}
const Vs = 0.025;
let Ta = /* @__PURE__ */ function(n) {
  return n[n.Point = 0] = "Point", n[n.Range = 1] = "Range", n;
}({});
function Ew(n, e, t) {
  return `${n.identifier}-${t + 1}-${vi(e)}`;
}
class Sw {
  constructor(e, t) {
    this.base = void 0, this._duration = null, this._timelineStart = null, this.appendInPlaceDisabled = void 0, this.appendInPlaceStarted = void 0, this.dateRange = void 0, this.hasPlayed = !1, this.cumulativeDuration = 0, this.resumeOffset = NaN, this.playoutLimit = NaN, this.restrictions = {
      skip: !1,
      jump: !1
    }, this.snapOptions = {
      out: !1,
      in: !1
    }, this.assetList = [], this.assetListLoader = void 0, this.assetListResponse = null, this.resumeAnchor = void 0, this.error = void 0, this.resetOnResume = void 0, this.base = t, this.dateRange = e, this.setDateRange(e);
  }
  setDateRange(e) {
    this.dateRange = e, this.resumeOffset = e.attr.optionalFloat("X-RESUME-OFFSET", this.resumeOffset), this.playoutLimit = e.attr.optionalFloat("X-PLAYOUT-LIMIT", this.playoutLimit), this.restrictions = e.attr.enumeratedStringList("X-RESTRICT", this.restrictions), this.snapOptions = e.attr.enumeratedStringList("X-SNAP", this.snapOptions);
  }
  reset() {
    var e;
    this.appendInPlaceStarted = !1, (e = this.assetListLoader) == null || e.destroy(), this.assetListLoader = void 0, this.supplementsPrimary || (this.assetListResponse = null, this.assetList = [], this._duration = null);
  }
  isAssetPastPlayoutLimit(e) {
    var t;
    if (e > 0 && e >= this.assetList.length)
      return !0;
    const r = this.playoutLimit;
    return e <= 0 || isNaN(r) ? !1 : r === 0 ? !0 : (((t = this.assetList[e]) == null ? void 0 : t.startOffset) || 0) > r;
  }
  findAssetIndex(e) {
    return this.assetList.indexOf(e);
  }
  get identifier() {
    return this.dateRange.id;
  }
  get startDate() {
    return this.dateRange.startDate;
  }
  get startTime() {
    const e = this.dateRange.startTime;
    if (this.snapOptions.out) {
      const t = this.dateRange.tagAnchor;
      if (t)
        return Nl(e, t);
    }
    return e;
  }
  get startOffset() {
    return this.cue.pre ? 0 : this.startTime;
  }
  get startIsAligned() {
    if (this.startTime === 0 || this.snapOptions.out)
      return !0;
    const e = this.dateRange.tagAnchor;
    if (e) {
      const t = this.dateRange.startTime, r = Nl(t, e);
      return t - r < 0.1;
    }
    return !1;
  }
  get resumptionOffset() {
    const e = this.resumeOffset, t = ae(e) ? e : this.duration;
    return this.cumulativeDuration + t;
  }
  get resumeTime() {
    const e = this.startOffset + this.resumptionOffset;
    if (this.snapOptions.in) {
      const t = this.resumeAnchor;
      if (t)
        return Nl(e, t);
    }
    return e;
  }
  get appendInPlace() {
    return this.appendInPlaceStarted ? !0 : this.appendInPlaceDisabled ? !1 : !!(!this.cue.once && !this.cue.pre && // preroll starts at startPosition before startPosition is known (live)
    this.startIsAligned && (isNaN(this.playoutLimit) && isNaN(this.resumeOffset) || this.resumeOffset && this.duration && Math.abs(this.resumeOffset - this.duration) < Vs));
  }
  set appendInPlace(e) {
    if (this.appendInPlaceStarted) {
      this.resetOnResume = !e;
      return;
    }
    this.appendInPlaceDisabled = !e;
  }
  // Extended timeline start time
  get timelineStart() {
    return this._timelineStart !== null ? this._timelineStart : this.startTime;
  }
  set timelineStart(e) {
    this._timelineStart = e;
  }
  get duration() {
    const e = this.playoutLimit;
    let t;
    return this._duration !== null ? t = this._duration : this.dateRange.duration ? t = this.dateRange.duration : t = this.dateRange.plannedDuration || 0, !isNaN(e) && e < t && (t = e), t;
  }
  set duration(e) {
    this._duration = e;
  }
  get cue() {
    return this.dateRange.cue;
  }
  get timelineOccupancy() {
    return this.dateRange.attr["X-TIMELINE-OCCUPIES"] === "RANGE" ? Ta.Range : Ta.Point;
  }
  get supplementsPrimary() {
    return this.dateRange.attr["X-TIMELINE-STYLE"] === "PRIMARY";
  }
  get contentMayVary() {
    return this.dateRange.attr["X-CONTENT-MAY-VARY"] !== "NO";
  }
  get assetUrl() {
    return this.dateRange.attr["X-ASSET-URI"];
  }
  get assetListUrl() {
    return this.dateRange.attr["X-ASSET-LIST"];
  }
  get baseUrl() {
    return this.base.url;
  }
  get assetListLoaded() {
    return this.assetList.length > 0 || this.assetListResponse !== null;
  }
  toString() {
    return bw(this);
  }
}
function Nl(n, e) {
  return n - e.start < e.duration / 2 && !(Math.abs(n - (e.start + e.duration)) < Vs) ? e.start : e.start + e.duration;
}
function Jp(n, e, t) {
  const r = new self.URL(n, t);
  return r.protocol !== "data:" && r.searchParams.set("_HLS_primary_id", e), r;
}
function Ul(n, e) {
  for (; (t = n.assetList[++e]) != null && t.error; )
    var t;
  return e;
}
function bw(n) {
  return `["${n.identifier}" ${n.cue.pre ? "<pre>" : n.cue.post ? "<post>" : ""}${n.timelineStart.toFixed(2)}-${n.resumeTime.toFixed(2)}]`;
}
function Os(n) {
  const e = n.timelineStart, t = n.duration || 0;
  return `["${n.identifier}" ${e.toFixed(2)}-${(e + t).toFixed(2)}]`;
}
class Tw {
  constructor(e, t, r, s) {
    this.hls = void 0, this.interstitial = void 0, this.assetItem = void 0, this.tracks = null, this.hasDetails = !1, this.mediaAttached = null, this._currentTime = void 0, this._bufferedEosTime = void 0, this.checkPlayout = () => {
      this.reachedPlayout(this.currentTime) && this.hls.trigger(T.PLAYOUT_LIMIT_REACHED, {});
    };
    const i = this.hls = new e(t);
    this.interstitial = r, this.assetItem = s;
    let o = s.uri;
    try {
      o = Jp(o, t.primarySessionId).href;
    } catch {
    }
    i.loadSource(o);
    const a = () => {
      this.hasDetails = !0;
    };
    i.once(T.LEVEL_LOADED, a), i.once(T.AUDIO_TRACK_LOADED, a), i.once(T.SUBTITLE_TRACK_LOADED, a), i.on(T.MEDIA_ATTACHING, (l, {
      media: c
    }) => {
      this.removeMediaListeners(), this.mediaAttached = c, this.interstitial.playoutLimit && (c.addEventListener("timeupdate", this.checkPlayout), this.appendInPlace && i.on(T.BUFFER_APPENDED, () => {
        const d = this.bufferedEnd;
        this.reachedPlayout(d) && (this._bufferedEosTime = d, i.trigger(T.BUFFERED_TO_END, void 0));
      }));
    });
  }
  get appendInPlace() {
    var e;
    return ((e = this.interstitial) == null ? void 0 : e.appendInPlace) || !1;
  }
  bufferedInPlaceToEnd(e) {
    var t;
    if (!this.appendInPlace)
      return !1;
    if ((t = this.hls) != null && t.bufferedToEnd)
      return !0;
    if (!e || !this._bufferedEosTime)
      return !1;
    const r = this.timelineOffset, s = Le.bufferInfo(e, r, 0);
    return this.getAssetTime(s.end) >= this._bufferedEosTime - 0.02;
  }
  reachedPlayout(e) {
    const r = this.interstitial.playoutLimit;
    return this.startOffset + e >= r;
  }
  get destroyed() {
    var e;
    return !((e = this.hls) != null && e.userConfig);
  }
  get assetId() {
    return this.assetItem.identifier;
  }
  get interstitialId() {
    return this.assetItem.parentIdentifier;
  }
  get media() {
    var e;
    return ((e = this.hls) == null ? void 0 : e.media) || null;
  }
  get bufferedEnd() {
    const e = this.media || this.mediaAttached;
    if (!e)
      return this._bufferedEosTime ? this._bufferedEosTime : this.currentTime;
    const t = Le.bufferInfo(e, e.currentTime, 1e-3);
    return this.getAssetTime(t.end);
  }
  get currentTime() {
    const e = this.media || this.mediaAttached;
    return e ? this.getAssetTime(e.currentTime) : this._currentTime || 0;
  }
  get duration() {
    const e = this.assetItem.duration;
    return e || 0;
  }
  get remaining() {
    const e = this.duration;
    return e ? Math.max(0, e - this.currentTime) : 0;
  }
  get startOffset() {
    return this.assetItem.startOffset;
  }
  get timelineOffset() {
    var e;
    return ((e = this.hls) == null ? void 0 : e.config.timelineOffset) || 0;
  }
  set timelineOffset(e) {
    const t = this.timelineOffset;
    if (e !== t) {
      const r = e - t;
      if (Math.abs(r) > 1 / 9e4) {
        if (this.hasDetails)
          throw new Error("Cannot set timelineOffset after playlists are loaded");
        this.hls.config.timelineOffset = e;
      }
    }
  }
  getAssetTime(e) {
    const t = this.timelineOffset, r = this.duration;
    return Math.min(Math.max(0, e - t), r);
  }
  removeMediaListeners() {
    const e = this.mediaAttached;
    e && (this._currentTime = e.currentTime, this.bufferSnapShot(), e.removeEventListener("timeupdate", this.checkPlayout));
  }
  bufferSnapShot() {
    if (this.mediaAttached) {
      var e;
      (e = this.hls) != null && e.bufferedToEnd && (this._bufferedEosTime = this.bufferedEnd);
    }
  }
  destroy() {
    this.removeMediaListeners(), this.hls.destroy(), this.hls = this.interstitial = null, this.tracks = this.mediaAttached = this.checkPlayout = null;
  }
  attachMedia(e) {
    this.hls.attachMedia(e);
  }
  detachMedia() {
    this.removeMediaListeners(), this.mediaAttached = null, this.hls.detachMedia();
  }
  resumeBuffering() {
    this.hls.resumeBuffering();
  }
  pauseBuffering() {
    this.hls.pauseBuffering();
  }
  transferMedia() {
    return this.bufferSnapShot(), this.hls.transferMedia();
  }
  resetDetails() {
    const e = this.hls;
    if (this.hasDetails) {
      e.stopLoad();
      const t = (r) => delete r.details;
      e.levels.forEach(t), e.allAudioTracks.forEach(t), e.allSubtitleTracks.forEach(t), this.hasDetails = !1;
    }
  }
  on(e, t, r) {
    this.hls.on(e, t);
  }
  once(e, t, r) {
    this.hls.once(e, t);
  }
  off(e, t, r) {
    this.hls.off(e, t);
  }
  toString() {
    var e;
    return `HlsAssetPlayer: ${Os(this.assetItem)} ${(e = this.hls) == null ? void 0 : e.sessionId} ${this.appendInPlace ? "append-in-place" : ""}`;
  }
}
const Jh = 0.033;
class ww extends Cn {
  constructor(e, t) {
    super("interstitials-sched", t), this.onScheduleUpdate = void 0, this.eventMap = {}, this.events = null, this.items = null, this.durations = {
      primary: 0,
      playout: 0,
      integrated: 0
    }, this.onScheduleUpdate = e;
  }
  destroy() {
    this.reset(), this.onScheduleUpdate = null;
  }
  reset() {
    this.eventMap = {}, this.setDurations(0, 0, 0), this.events && this.events.forEach((e) => e.reset()), this.events = this.items = null;
  }
  resetErrorsInRange(e, t) {
    return this.events ? this.events.reduce((r, s) => e <= s.startOffset && t > s.startOffset ? (delete s.error, r + 1) : r, 0) : 0;
  }
  get duration() {
    const e = this.items;
    return e ? e[e.length - 1].end : 0;
  }
  get length() {
    return this.items ? this.items.length : 0;
  }
  getEvent(e) {
    return e && this.eventMap[e] || null;
  }
  hasEvent(e) {
    return e in this.eventMap;
  }
  findItemIndex(e, t) {
    if (e.event)
      return this.findEventIndex(e.event.identifier);
    let r = -1;
    e.nextEvent ? r = this.findEventIndex(e.nextEvent.identifier) - 1 : e.previousEvent && (r = this.findEventIndex(e.previousEvent.identifier) + 1);
    const s = this.items;
    if (s)
      for (s[r] || (t === void 0 && (t = e.start), r = this.findItemIndexAtTime(t)); r >= 0 && (i = s[r]) != null && i.event; ) {
        var i;
        r--;
      }
    return r;
  }
  findItemIndexAtTime(e, t) {
    const r = this.items;
    if (r)
      for (let s = 0; s < r.length; s++) {
        let i = r[s];
        if (t && t !== "primary" && (i = i[t]), e === i.start || e > i.start && e < i.end)
          return s;
      }
    return -1;
  }
  findJumpRestrictedIndex(e, t) {
    const r = this.items;
    if (r)
      for (let s = e; s <= t && r[s]; s++) {
        const i = r[s].event;
        if (i != null && i.restrictions.jump && !i.appendInPlace)
          return s;
      }
    return -1;
  }
  findEventIndex(e) {
    const t = this.items;
    if (t)
      for (let s = t.length; s--; ) {
        var r;
        if (((r = t[s].event) == null ? void 0 : r.identifier) === e)
          return s;
      }
    return -1;
  }
  findAssetIndex(e, t) {
    const r = e.assetList, s = r.length;
    if (s > 1)
      for (let i = 0; i < s; i++) {
        const o = r[i];
        if (!o.error) {
          const a = o.timelineStart;
          if (t === a || t > a && t < a + (o.duration || 0))
            return i;
        }
      }
    return 0;
  }
  get assetIdAtEnd() {
    var e, t;
    const r = (e = this.items) == null || (t = e[this.length - 1]) == null ? void 0 : t.event;
    if (r) {
      const s = r.assetList, i = s[s.length - 1];
      if (i)
        return i.identifier;
    }
    return null;
  }
  parseInterstitialDateRanges(e, t) {
    const r = e.main.details, {
      dateRanges: s
    } = r, i = this.events, o = this.parseDateRanges(s, {
      url: r.url
    }, t), a = Object.keys(s), l = i ? i.filter((c) => !a.includes(c.identifier)) : [];
    o.length && o.sort((c, u) => {
      const d = c.cue.pre, h = c.cue.post, f = u.cue.pre, p = u.cue.post;
      if (d && !f)
        return -1;
      if (f && !d || h && !p)
        return 1;
      if (p && !h)
        return -1;
      if (!d && !f && !h && !p) {
        const y = c.startTime, m = u.startTime;
        if (y !== m)
          return y - m;
      }
      return c.dateRange.tagOrder - u.dateRange.tagOrder;
    }), this.events = o, l.forEach((c) => {
      this.removeEvent(c);
    }), this.updateSchedule(e, l);
  }
  updateSchedule(e, t = []) {
    const r = this.events || [];
    if (r.length || t.length || this.length < 2) {
      const s = this.items, i = this.parseSchedule(r, e);
      (t.length || (s == null ? void 0 : s.length) !== i.length || i.some((a, l) => Math.abs(a.playout.start - s[l].playout.start) > 5e-3 || Math.abs(a.playout.end - s[l].playout.end) > 5e-3)) && (this.items = i, this.onScheduleUpdate(t, s));
    }
  }
  parseDateRanges(e, t, r) {
    const s = [], i = Object.keys(e);
    for (let o = 0; o < i.length; o++) {
      const a = i[o], l = e[a];
      if (l.isInterstitial) {
        let c = this.eventMap[a];
        c ? c.setDateRange(l) : (c = new Sw(l, t), this.eventMap[a] = c, r === !1 && (c.appendInPlace = r)), s.push(c);
      }
    }
    return s;
  }
  parseSchedule(e, t) {
    const r = [], s = t.main.details, i = s.live ? 1 / 0 : s.edge;
    let o = 0;
    if (e = e.filter((l) => !l.error && !(l.cue.once && l.hasPlayed)), e.length) {
      this.resolveOffsets(e, t);
      let l = 0, c = 0;
      if (e.forEach((u, d) => {
        const h = u.cue.pre, f = u.cue.post, p = e[d - 1] || null, y = u.appendInPlace, m = f ? i : u.startOffset, b = u.duration, C = u.timelineOccupancy === Ta.Range ? b : 0, A = u.resumptionOffset, P = (p == null ? void 0 : p.startTime) === m, I = m + u.cumulativeDuration;
        let U = y ? I + b : m + A;
        if (h || !f && m <= 0) {
          const G = c;
          c += C, u.timelineStart = I;
          const F = o;
          o += b, r.push({
            event: u,
            start: I,
            end: U,
            playout: {
              start: F,
              end: o
            },
            integrated: {
              start: G,
              end: c
            }
          });
        } else if (m <= i) {
          if (!P) {
            const B = m - l;
            if (B > Jh) {
              const V = l, H = c;
              c += B;
              const L = o;
              o += B;
              const g = {
                previousEvent: e[d - 1] || null,
                nextEvent: u,
                start: V,
                end: V + B,
                playout: {
                  start: L,
                  end: o
                },
                integrated: {
                  start: H,
                  end: c
                }
              };
              r.push(g);
            } else B > 0 && p && (p.cumulativeDuration += B, r[r.length - 1].end = m);
          }
          f && (U = I), u.timelineStart = I;
          const G = c;
          c += C;
          const F = o;
          o += b, r.push({
            event: u,
            start: I,
            end: U,
            playout: {
              start: F,
              end: o
            },
            integrated: {
              start: G,
              end: c
            }
          });
        } else
          return;
        const j = u.resumeTime;
        f || j > i ? l = i : l = j;
      }), l < i) {
        var a;
        const u = l, d = c, h = i - l;
        c += h;
        const f = o;
        o += h, r.push({
          previousEvent: ((a = r[r.length - 1]) == null ? void 0 : a.event) || null,
          nextEvent: null,
          start: l,
          end: u + h,
          playout: {
            start: f,
            end: o
          },
          integrated: {
            start: d,
            end: c
          }
        });
      }
      this.setDurations(i, o, c);
    } else
      r.push({
        previousEvent: null,
        nextEvent: null,
        start: 0,
        end: i,
        playout: {
          start: 0,
          end: i
        },
        integrated: {
          start: 0,
          end: i
        }
      }), this.setDurations(i, i, i);
    return r;
  }
  setDurations(e, t, r) {
    this.durations = {
      primary: e,
      playout: t,
      integrated: r
    };
  }
  resolveOffsets(e, t) {
    const r = t.main.details, s = r.live ? 1 / 0 : r.edge;
    let i = 0, o = -1;
    e.forEach((a, l) => {
      const c = a.cue.pre, u = a.cue.post, d = c ? 0 : u ? s : a.startTime;
      this.updateAssetDurations(a), o === d ? a.cumulativeDuration = i : (i = 0, o = d), !u && a.snapOptions.in && (a.resumeAnchor = gs(null, r.fragments, a.startOffset + a.resumptionOffset, 0, 0) || void 0), a.appendInPlace && !a.appendInPlaceStarted && (this.primaryCanResumeInPlaceAt(a, t) || (a.appendInPlace = !1)), !a.appendInPlace && l + 1 < e.length && e[l + 1].startTime - e[l].resumeTime < Jh && (e[l + 1].appendInPlace = !1, e[l + 1].appendInPlace && this.warn(`Could not change append strategy for abutting event ${a}`));
      const f = ae(a.resumeOffset) ? a.resumeOffset : a.duration;
      i += f;
    });
  }
  primaryCanResumeInPlaceAt(e, t) {
    const r = e.resumeTime, s = e.startTime + e.resumptionOffset;
    return Math.abs(r - s) > Vs ? (this.log(`"${e.identifier}" resumption ${r} not aligned with estimated timeline end ${s}`), !1) : t ? !Object.keys(t).some((o) => {
      const a = t[o].details, l = a.edge;
      if (r >= l)
        return this.log(`"${e.identifier}" resumption ${r} past ${o} playlist end ${l}`), !1;
      const c = gs(null, a.fragments, r);
      if (!c)
        return this.log(`"${e.identifier}" resumption ${r} does not align with any fragments in ${o} playlist (${a.fragStart}-${a.fragmentEnd})`), !0;
      const u = o === "audio" ? 0.175 : 0;
      return Math.abs(c.start - r) < Vs + u || Math.abs(c.end - r) < Vs + u ? !1 : (this.log(`"${e.identifier}" resumption ${r} not aligned with ${o} fragment bounds (${c.start}-${c.end} sn: ${c.sn} cc: ${c.cc})`), !0);
    }) : (this.log(`"${e.identifier}" resumption ${r} can not be aligned with media (none selected)`), !1);
  }
  updateAssetDurations(e) {
    if (!e.assetListLoaded)
      return;
    const t = e.timelineStart;
    let r = 0, s = !1, i = !1;
    e.assetList.forEach((o, a) => {
      const l = t + r;
      o.startOffset = r, o.timelineStart = l, s || (s = o.duration === null), i || (i = !!o.error);
      const c = o.error ? 0 : o.duration || 0;
      r += c;
    }), s && !i ? e.duration = Math.max(r, e.duration) : e.duration = r;
  }
  removeEvent(e) {
    e.reset(), delete this.eventMap[e.identifier];
  }
}
function Fn(n) {
  return `[${n.event ? '"' + n.event.identifier + '"' : "primary"}: ${n.start.toFixed(2)}-${n.end.toFixed(2)}]`;
}
class Aw {
  constructor(e) {
    this.hls = void 0, this.hls = e;
  }
  destroy() {
    this.hls = null;
  }
  loadAssetList(e, t) {
    const r = e.assetListUrl;
    let s;
    try {
      s = Jp(r, this.hls.sessionId, e.baseUrl);
    } catch (h) {
      const f = this.assignAssetListError(e, Y.ASSET_LIST_LOAD_ERROR, h, r);
      this.hls.trigger(T.ERROR, f);
      return;
    }
    t && s.protocol !== "data:" && s.searchParams.set("_HLS_start_offset", "" + t);
    const i = this.hls.config, o = i.loader, a = new o(i), l = {
      responseType: "json",
      url: s.href
    }, c = i.interstitialAssetListLoadPolicy.default, u = {
      loadPolicy: c,
      timeout: c.maxLoadTimeMs,
      maxRetry: 0,
      retryDelay: 0,
      maxRetryDelay: 0
    }, d = {
      onSuccess: (h, f, p, y) => {
        const m = h.data, b = m == null ? void 0 : m.ASSETS;
        if (!Array.isArray(b)) {
          const C = this.assignAssetListError(e, Y.ASSET_LIST_PARSING_ERROR, new Error("Invalid interstitial asset list"), p.url, f, y);
          this.hls.trigger(T.ERROR, C);
          return;
        }
        e.assetListResponse = m, this.hls.trigger(T.ASSET_LIST_LOADED, {
          event: e,
          assetListResponse: m,
          networkDetails: y
        });
      },
      onError: (h, f, p, y) => {
        const m = this.assignAssetListError(e, Y.ASSET_LIST_LOAD_ERROR, new Error(`Error loading X-ASSET-LIST: HTTP status ${h.code} ${h.text} (${f.url})`), f.url, y, p);
        this.hls.trigger(T.ERROR, m);
      },
      onTimeout: (h, f, p) => {
        const y = this.assignAssetListError(e, Y.ASSET_LIST_LOAD_TIMEOUT, new Error(`Timeout loading X-ASSET-LIST (${f.url})`), f.url, h, p);
        this.hls.trigger(T.ERROR, y);
      }
    };
    return a.load(l, u, d), this.hls.trigger(T.ASSET_LIST_LOADING, {
      event: e
    }), a;
  }
  assignAssetListError(e, t, r, s, i, o) {
    return e.error = r, {
      type: ge.NETWORK_ERROR,
      details: t,
      fatal: !1,
      interstitial: e,
      url: s,
      error: r,
      networkDetails: o,
      stats: i
    };
  }
}
function Qh(n) {
  n == null || n.play().catch(() => {
  });
}
class Iw extends Cn {
  constructor(e, t) {
    super("interstitials", e.logger), this.HlsPlayerClass = void 0, this.hls = void 0, this.assetListLoader = void 0, this.mediaSelection = null, this.altSelection = null, this.media = null, this.detachedData = null, this.requiredTracks = null, this.manager = null, this.playerQueue = [], this.bufferedPos = -1, this.timelinePos = -1, this.schedule = void 0, this.playingItem = null, this.bufferingItem = null, this.waitingItem = null, this.endedItem = null, this.playingAsset = null, this.endedAsset = null, this.bufferingAsset = null, this.shouldPlay = !1, this.onPlay = () => {
      this.shouldPlay = !0;
    }, this.onPause = () => {
      this.shouldPlay = !1;
    }, this.onSeeking = () => {
      const r = this.currentTime;
      if (r === void 0 || this.playbackDisabled)
        return;
      const s = r - this.timelinePos;
      if (Math.abs(s) < 1 / 7056e5)
        return;
      const o = s <= -0.01;
      this.timelinePos = r, this.bufferedPos = r;
      const a = this.playingItem;
      if (!a) {
        this.checkBuffer();
        return;
      }
      if (o && this.schedule.resetErrorsInRange(r, r - s) && this.updateSchedule(), this.checkBuffer(), o && r < a.start || r >= a.end) {
        var l;
        const h = this.schedule.findItemIndexAtTime(this.timelinePos);
        if (!this.isInterstitial(a) && (l = this.media) != null && l.paused && (this.shouldPlay = !1), !o) {
          const f = this.findItemIndex(a);
          if (h > f) {
            const p = this.schedule.findJumpRestrictedIndex(f + 1, h);
            if (p > f) {
              this.setSchedulePosition(p);
              return;
            }
          }
        }
        this.setSchedulePosition(h);
        return;
      }
      const c = this.playingAsset;
      if (!c) {
        if (this.playingLastItem && this.isInterstitial(a)) {
          const h = a.event.assetList[0];
          h && (this.endedItem = this.playingItem, this.playingItem = null, this.setScheduleToAssetAtTime(r, h));
        }
        return;
      }
      const u = c.timelineStart, d = c.duration || 0;
      (o && r < u || r >= u + d) && this.setScheduleToAssetAtTime(r, c);
    }, this.onTimeupdate = () => {
      const r = this.currentTime;
      if (r === void 0 || this.playbackDisabled)
        return;
      if (r > this.timelinePos)
        this.timelinePos = r, r > this.bufferedPos && this.checkBuffer();
      else
        return;
      const s = this.playingItem;
      if (!s || this.playingLastItem)
        return;
      if (r >= s.end) {
        this.timelinePos = s.end;
        const a = this.findItemIndex(s);
        this.setSchedulePosition(a + 1);
      }
      const i = this.playingAsset;
      if (!i)
        return;
      const o = i.timelineStart + (i.duration || 0);
      r >= o && this.setScheduleToAssetAtTime(r, i);
    }, this.onScheduleUpdate = (r, s) => {
      const i = this.schedule, o = this.playingItem, a = i.events || [], l = i.items || [], c = i.durations, u = r.map((p) => p.identifier), d = !!(a.length || u.length);
      (d || s) && this.log(`INTERSTITIALS_UPDATED (${a.length}): ${a}
Schedule: ${l.map((p) => Fn(p))} pos: ${this.timelinePos}`), u.length && this.log(`Removed events ${u}`), this.playerQueue.forEach((p) => {
        if (p.interstitial.appendInPlace) {
          const y = p.assetItem.timelineStart, m = p.timelineOffset - y;
          if (m)
            try {
              p.timelineOffset = y;
            } catch (b) {
              Math.abs(m) > Vs && this.warn(`${b} ("${p.assetId}" ${p.timelineOffset}->${y})`);
            }
        }
      });
      let h = null;
      if (o) {
        const p = this.updateItem(o, this.timelinePos);
        this.itemsMatch(o, p) && (this.playingItem = p, this.waitingItem = this.endedItem = null, h = () => this.trimInPlace(p, o));
      } else
        this.waitingItem = this.updateItem(this.waitingItem), this.endedItem = this.updateItem(this.endedItem);
      const f = this.bufferingItem;
      if (f) {
        const p = this.updateItem(f, this.bufferedPos);
        this.itemsMatch(f, p) ? (this.bufferingItem = p, h || (h = () => this.trimInPlace(p, f))) : f.event && (this.bufferingItem = this.playingItem, this.clearInterstitial(f.event, null));
      }
      if (r.forEach((p) => {
        p.assetList.forEach((y) => {
          this.clearAssetPlayer(y.identifier, null);
        });
      }), d || s) {
        if (this.hls.trigger(T.INTERSTITIALS_UPDATED, {
          events: a.slice(0),
          schedule: l.slice(0),
          durations: c,
          removedIds: u
        }), this.isInterstitial(o) && u.includes(o.event.identifier)) {
          this.warn(`Interstitial "${o.event.identifier}" removed while playing`), this.primaryFallback(o.event);
          return;
        }
        h && h(), this.checkBuffer();
      }
    }, this.hls = e, this.HlsPlayerClass = t, this.assetListLoader = new Aw(e), this.schedule = new ww(this.onScheduleUpdate, e.logger), this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(T.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(T.AUDIO_TRACK_UPDATED, this.onAudioTrackUpdated, this), e.on(T.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.on(T.SUBTITLE_TRACK_UPDATED, this.onSubtitleTrackUpdated, this), e.on(T.EVENT_CUE_ENTER, this.onInterstitialCueEnter, this), e.on(T.ASSET_LIST_LOADED, this.onAssetListLoaded, this), e.on(T.BUFFER_APPENDED, this.onBufferAppended, this), e.on(T.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(T.BUFFERED_TO_END, this.onBufferedToEnd, this), e.on(T.MEDIA_ENDED, this.onMediaEnded, this), e.on(T.ERROR, this.onError, this), e.on(T.DESTROYING, this.onDestroying, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(T.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(T.AUDIO_TRACK_UPDATED, this.onAudioTrackUpdated, this), e.off(T.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.off(T.SUBTITLE_TRACK_UPDATED, this.onSubtitleTrackUpdated, this), e.off(T.EVENT_CUE_ENTER, this.onInterstitialCueEnter, this), e.off(T.ASSET_LIST_LOADED, this.onAssetListLoaded, this), e.off(T.BUFFER_CODECS, this.onBufferCodecs, this), e.off(T.BUFFER_APPENDED, this.onBufferAppended, this), e.off(T.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(T.BUFFERED_TO_END, this.onBufferedToEnd, this), e.off(T.MEDIA_ENDED, this.onMediaEnded, this), e.off(T.ERROR, this.onError, this), e.off(T.DESTROYING, this.onDestroying, this));
  }
  startLoad() {
    this.resumeBuffering();
  }
  stopLoad() {
    this.pauseBuffering();
  }
  resumeBuffering() {
    var e;
    (e = this.getBufferingPlayer()) == null || e.resumeBuffering();
  }
  pauseBuffering() {
    var e;
    (e = this.getBufferingPlayer()) == null || e.pauseBuffering();
  }
  destroy() {
    this.unregisterListeners(), this.stopLoad(), this.assetListLoader && this.assetListLoader.destroy(), this.emptyPlayerQueue(), this.clearScheduleState(), this.schedule && this.schedule.destroy(), this.media = this.detachedData = this.mediaSelection = this.requiredTracks = this.altSelection = this.manager = null, this.hls = this.HlsPlayerClass = this.schedule = this.log = null, this.assetListLoader = null, this.onPlay = this.onPause = this.onSeeking = this.onTimeupdate = null, this.onScheduleUpdate = null;
  }
  onDestroying() {
    const e = this.primaryMedia || this.media;
    e && this.removeMediaListeners(e);
  }
  removeMediaListeners(e) {
    Or(e, "play", this.onPlay), Or(e, "pause", this.onPause), Or(e, "seeking", this.onSeeking), Or(e, "timeupdate", this.onTimeupdate);
  }
  onMediaAttaching(e, t) {
    const r = this.media = t.media;
    _r(r, "seeking", this.onSeeking), _r(r, "timeupdate", this.onTimeupdate), _r(r, "play", this.onPlay), _r(r, "pause", this.onPause);
  }
  onMediaAttached(e, t) {
    const r = this.effectivePlayingItem, s = this.detachedData;
    if (this.detachedData = null, r === null)
      this.checkStart();
    else if (!s) {
      this.clearScheduleState();
      const i = this.findItemIndex(r);
      this.setSchedulePosition(i);
    }
  }
  clearScheduleState() {
    this.playingItem = this.bufferingItem = this.waitingItem = this.endedItem = this.playingAsset = this.endedAsset = this.bufferingAsset = null;
  }
  onMediaDetaching(e, t) {
    const r = !!t.transferMedia, s = this.media;
    if (this.media = null, !r && (s && this.removeMediaListeners(s), this.detachedData)) {
      const i = this.getBufferingPlayer();
      i && (this.playingAsset = this.endedAsset = this.bufferingAsset = this.bufferingItem = this.waitingItem = this.detachedData = null, i.detachMedia()), this.shouldPlay = !1;
    }
  }
  get interstitialsManager() {
    if (!this.manager) {
      if (!this.hls)
        return null;
      const e = this, t = () => e.bufferingItem || e.waitingItem, r = (d) => d && e.getAssetPlayer(d.identifier), s = (d, h, f, p, y) => {
        if (d) {
          let m = d[h].start;
          const b = d.event;
          if (b) {
            if (h === "playout" || b.timelineOccupancy !== Ta.Point) {
              const C = r(f);
              (C == null ? void 0 : C.interstitial) === b && (m += C.assetItem.startOffset + C[y]);
            }
          } else {
            const C = p === "bufferedPos" ? o() : e[p];
            m += C - d.start;
          }
          return m;
        }
        return 0;
      }, i = (d, h) => {
        if (d !== 0 && h !== "primary" && e.schedule.length) {
          var f;
          const p = e.schedule.findItemIndexAtTime(d), y = (f = e.schedule.items) == null ? void 0 : f[p];
          if (y) {
            const m = y[h].start - y.start;
            return d + m;
          }
        }
        return d;
      }, o = () => {
        const d = e.bufferedPos;
        return d === Number.MAX_VALUE ? a("primary") : Math.max(d, 0);
      }, a = (d) => {
        var h;
        return (h = e.primaryDetails) != null && h.live ? e.primaryDetails.edge : e.schedule.durations[d];
      }, l = (d, h) => {
        var f, p;
        const y = e.effectivePlayingItem;
        if (y != null && (f = y.event) != null && f.restrictions.skip)
          return;
        e.log(`seek to ${d} "${h}"`);
        const m = e.effectivePlayingItem, b = e.schedule.findItemIndexAtTime(d, h), C = (p = e.schedule.items) == null ? void 0 : p[b], A = e.getBufferingPlayer(), P = A == null ? void 0 : A.interstitial, I = P == null ? void 0 : P.appendInPlace, U = m && e.itemsMatch(m, C);
        if (m && (I || U)) {
          const G = r(e.playingAsset), F = (G == null ? void 0 : G.media) || e.primaryMedia;
          if (F) {
            const B = h === "primary" ? F.currentTime : s(m, h, e.playingAsset, "timelinePos", "currentTime"), V = d - B, H = (I ? B : F.currentTime) + V;
            if (H >= 0 && (!G || I || H <= G.duration)) {
              F.currentTime = H;
              return;
            }
          }
        }
        if (C) {
          let G = d;
          if (h !== "primary") {
            const B = C[h].start, V = d - B;
            G = C.start + V;
          }
          const F = !e.isInterstitial(C);
          if ((!e.isInterstitial(m) || m.event.appendInPlace) && (F || C.event.appendInPlace)) {
            const B = e.media || (I ? A == null ? void 0 : A.media : null);
            B && (B.currentTime = G);
          } else if (m) {
            const B = e.findItemIndex(m);
            if (b > B) {
              const H = e.schedule.findJumpRestrictedIndex(B + 1, b);
              if (H > B) {
                e.setSchedulePosition(H);
                return;
              }
            }
            let V = 0;
            if (F)
              e.timelinePos = G, e.checkBuffer();
            else {
              var j;
              const H = C == null || (j = C.event) == null ? void 0 : j.assetList;
              if (H) {
                const L = d - (C[h] || C).start;
                for (let g = H.length; g--; ) {
                  const x = H[g];
                  if (x.duration && L >= x.startOffset && L < x.startOffset + x.duration) {
                    V = g;
                    break;
                  }
                }
              }
            }
            e.setSchedulePosition(b, V);
          }
        }
      }, c = () => {
        const d = e.effectivePlayingItem;
        if (e.isInterstitial(d))
          return d;
        const h = t();
        return e.isInterstitial(h) ? h : null;
      }, u = {
        get currentTime() {
          const d = c(), h = e.effectivePlayingItem;
          return h && h === d ? s(h, "playout", e.effectivePlayingAsset, "timelinePos", "currentTime") - h.playout.start : 0;
        },
        set currentTime(d) {
          const h = c(), f = e.effectivePlayingItem;
          f && f === h && l(d + f.playout.start, "playout");
        },
        get duration() {
          const d = c();
          return d ? d.playout.end - d.playout.start : 0;
        },
        get assetPlayers() {
          var d;
          const h = (d = c()) == null ? void 0 : d.event.assetList;
          return h ? h.map((f) => e.getAssetPlayer(f.identifier)) : [];
        },
        get playingIndex() {
          var d;
          const h = (d = c()) == null ? void 0 : d.event;
          return h && e.effectivePlayingAsset ? h.findAssetIndex(e.effectivePlayingAsset) : -1;
        },
        get scheduleItem() {
          return c();
        }
      };
      this.manager = {
        get events() {
          var d, h;
          return ((d = e.schedule) == null || (h = d.events) == null ? void 0 : h.slice(0)) || [];
        },
        get schedule() {
          var d, h;
          return ((d = e.schedule) == null || (h = d.items) == null ? void 0 : h.slice(0)) || [];
        },
        get interstitialPlayer() {
          return c() ? u : null;
        },
        get playerQueue() {
          return e.playerQueue.slice(0);
        },
        get bufferingAsset() {
          return e.bufferingAsset;
        },
        get bufferingItem() {
          return t();
        },
        get bufferingIndex() {
          const d = t();
          return e.findItemIndex(d);
        },
        get playingAsset() {
          return e.effectivePlayingAsset;
        },
        get playingItem() {
          return e.effectivePlayingItem;
        },
        get playingIndex() {
          const d = e.effectivePlayingItem;
          return e.findItemIndex(d);
        },
        primary: {
          get bufferedEnd() {
            return o();
          },
          get currentTime() {
            const d = e.timelinePos;
            return d > 0 ? d : 0;
          },
          set currentTime(d) {
            l(d, "primary");
          },
          get duration() {
            return a("primary");
          },
          get seekableStart() {
            var d;
            return ((d = e.primaryDetails) == null ? void 0 : d.fragmentStart) || 0;
          }
        },
        integrated: {
          get bufferedEnd() {
            return s(t(), "integrated", e.bufferingAsset, "bufferedPos", "bufferedEnd");
          },
          get currentTime() {
            return s(e.effectivePlayingItem, "integrated", e.effectivePlayingAsset, "timelinePos", "currentTime");
          },
          set currentTime(d) {
            l(d, "integrated");
          },
          get duration() {
            return a("integrated");
          },
          get seekableStart() {
            var d;
            return i(((d = e.primaryDetails) == null ? void 0 : d.fragmentStart) || 0, "integrated");
          }
        },
        skip: () => {
          const d = e.effectivePlayingItem, h = d == null ? void 0 : d.event;
          if (h && !h.restrictions.skip) {
            const f = e.findItemIndex(d);
            if (h.appendInPlace) {
              const p = d.playout.start + d.event.duration;
              l(p + 1e-3, "playout");
            } else
              e.advanceAfterAssetEnded(h, f, 1 / 0);
          }
        }
      };
    }
    return this.manager;
  }
  // Schedule getters
  get effectivePlayingItem() {
    return this.waitingItem || this.playingItem || this.endedItem;
  }
  get effectivePlayingAsset() {
    return this.playingAsset || this.endedAsset;
  }
  get playingLastItem() {
    var e;
    const t = this.playingItem, r = (e = this.schedule) == null ? void 0 : e.items;
    return !this.playbackStarted || !t || !r ? !1 : this.findItemIndex(t) === r.length - 1;
  }
  get playbackStarted() {
    return this.effectivePlayingItem !== null;
  }
  // Media getters and event callbacks
  get currentTime() {
    var e, t, r;
    if (this.mediaSelection === null)
      return;
    const s = this.waitingItem || this.playingItem;
    if (this.isInterstitial(s) && !s.event.appendInPlace)
      return;
    let i = this.media;
    !i && (e = this.bufferingItem) != null && (t = e.event) != null && t.appendInPlace && (i = this.primaryMedia);
    const o = (r = i) == null ? void 0 : r.currentTime;
    if (!(o === void 0 || !ae(o)))
      return o;
  }
  get primaryMedia() {
    var e;
    return this.media || ((e = this.detachedData) == null ? void 0 : e.media) || null;
  }
  isInterstitial(e) {
    return !!(e != null && e.event);
  }
  retreiveMediaSource(e, t) {
    const r = this.getAssetPlayer(e);
    r && this.transferMediaFromPlayer(r, t);
  }
  transferMediaFromPlayer(e, t) {
    const r = e.interstitial.appendInPlace, s = e.media;
    if (r && s === this.primaryMedia) {
      if (this.bufferingAsset = null, (!t || this.isInterstitial(t) && !t.event.appendInPlace) && t && s) {
        this.detachedData = {
          media: s
        };
        return;
      }
      const i = e.transferMedia();
      this.log(`transfer MediaSource from ${e} ${mt(i)}`), this.detachedData = i;
    } else t && s && (this.shouldPlay || (this.shouldPlay = !s.paused));
  }
  transferMediaTo(e, t) {
    var r, s;
    if (e.media === t)
      return;
    let i = null;
    const o = this.hls, a = e !== o, l = a && e.interstitial.appendInPlace, c = (r = this.detachedData) == null ? void 0 : r.mediaSource;
    let u;
    if (o.media)
      l && (i = o.transferMedia(), this.detachedData = i), u = "Primary";
    else if (c) {
      const f = this.getBufferingPlayer();
      f ? (i = f.transferMedia(), u = `${f}`) : u = "detached MediaSource";
    } else
      u = "detached media";
    if (!i) {
      if (c)
        i = this.detachedData, this.log(`using detachedData: MediaSource ${mt(i)}`);
      else if (!this.detachedData || o.media === t) {
        const f = this.playerQueue;
        f.length > 1 && f.forEach((p) => {
          if (a && p.interstitial.appendInPlace !== l) {
            const y = p.interstitial;
            this.clearInterstitial(p.interstitial, null), y.appendInPlace = !1, y.appendInPlace && this.warn(`Could not change append strategy for queued assets ${y}`);
          }
        }), this.hls.detachMedia(), this.detachedData = {
          media: t
        };
      }
    }
    const d = i && "mediaSource" in i && ((s = i.mediaSource) == null ? void 0 : s.readyState) !== "closed", h = d && i ? i : t;
    if (this.log(`${d ? "transfering MediaSource" : "attaching media"} to ${a ? e : "Primary"} from ${u}`), h === i) {
      const f = a && e.assetId === this.schedule.assetIdAtEnd;
      h.overrides = {
        duration: this.schedule.duration,
        endOfStream: !a || f,
        cueRemoval: !a
      };
    }
    e.attachMedia(h);
  }
  onInterstitialCueEnter() {
    this.onTimeupdate();
  }
  // Scheduling methods
  checkStart() {
    const e = this.schedule, t = e.events;
    if (!t || this.playbackDisabled || !this.media)
      return;
    this.bufferedPos === -1 && (this.bufferedPos = 0);
    const r = this.timelinePos, s = this.effectivePlayingItem;
    if (r === -1) {
      const i = this.hls.startPosition;
      if (this.timelinePos = i, t.length && t[0].cue.pre) {
        const o = e.findEventIndex(t[0].identifier);
        this.setSchedulePosition(o);
      } else if (i >= 0 || !this.primaryLive) {
        const o = this.timelinePos = i > 0 ? i : 0, a = e.findItemIndexAtTime(o);
        this.setSchedulePosition(a);
      }
    } else if (s && !this.playingItem) {
      const i = e.findItemIndex(s);
      this.setSchedulePosition(i);
    }
  }
  advanceAfterAssetEnded(e, t, r) {
    const s = Ul(e, r);
    if (!e.isAssetPastPlayoutLimit(s))
      this.setSchedulePosition(t, s);
    else {
      const i = this.schedule.items;
      if (i) {
        const o = t + 1, a = i.length;
        if (o >= a) {
          this.setSchedulePosition(-1);
          return;
        }
        const l = e.resumeTime;
        this.timelinePos < l && (this.timelinePos = l, this.checkBuffer()), this.setSchedulePosition(o);
      }
    }
  }
  setScheduleToAssetAtTime(e, t) {
    const r = this.schedule, s = t.parentIdentifier, i = r.getEvent(s);
    if (i) {
      const o = r.findEventIndex(s), a = r.findAssetIndex(i, e);
      this.advanceAfterAssetEnded(i, o, a - 1);
    }
  }
  setSchedulePosition(e, t) {
    const r = this.schedule.items;
    if (!r || this.playbackDisabled)
      return;
    this.log(`setSchedulePosition ${e}, ${t}`);
    const s = e >= 0 ? r[e] : null, i = this.playingItem, o = this.playingLastItem;
    if (this.isInterstitial(i)) {
      var a;
      const c = i.event, u = this.playingAsset, d = u == null ? void 0 : u.identifier, h = d ? this.getAssetPlayer(d) : null;
      if (h && d && (!this.eventItemsMatch(i, s) || t !== void 0 && d !== ((a = c.assetList) == null ? void 0 : a[t].identifier))) {
        var l;
        const f = c.findAssetIndex(u);
        this.log(`INTERSTITIAL_ASSET_ENDED ${f + 1}/${c.assetList.length} ${Os(u)}`), this.endedAsset = u, this.playingAsset = null, this.hls.trigger(T.INTERSTITIAL_ASSET_ENDED, {
          asset: u,
          assetListIndex: f,
          event: c,
          schedule: r.slice(0),
          scheduleIndex: e,
          player: h
        }), this.retreiveMediaSource(d, s), h.media && !((l = this.detachedData) != null && l.mediaSource) && h.detachMedia();
      }
      if (!this.eventItemsMatch(i, s) && (this.endedItem = i, this.playingItem = null, this.log(`INTERSTITIAL_ENDED ${c} ${Fn(i)}`), c.hasPlayed = !0, this.hls.trigger(T.INTERSTITIAL_ENDED, {
        event: c,
        schedule: r.slice(0),
        scheduleIndex: e
      }), c.cue.once)) {
        this.updateSchedule();
        const f = this.schedule.items;
        if (s && f) {
          const p = this.schedule.findItemIndex(s);
          this.advanceSchedule(p, f, t, i, o);
        }
        return;
      }
    }
    this.advanceSchedule(e, r, t, i, o);
  }
  advanceSchedule(e, t, r, s, i) {
    const o = e >= 0 ? t[e] : null, a = this.primaryMedia, l = this.playerQueue;
    if (l.length && l.forEach((c) => {
      const u = c.interstitial, d = this.schedule.findEventIndex(u.identifier);
      (d < e || d > e + 1) && this.clearInterstitial(u, o);
    }), this.isInterstitial(o)) {
      this.timelinePos = Math.min(Math.max(this.timelinePos, o.start), o.end);
      const c = o.event;
      if (r === void 0) {
        r = this.schedule.findAssetIndex(c, this.timelinePos);
        const f = Ul(c, r - 1);
        if (c.isAssetPastPlayoutLimit(f)) {
          this.advanceAfterAssetEnded(c, e, r);
          return;
        }
        r = f;
      }
      const u = this.waitingItem;
      this.assetsBuffered(o, a) || this.setBufferingItem(o);
      let d = this.preloadAssets(c, r);
      if (this.eventItemsMatch(o, u || s) || (this.waitingItem = o, this.log(`INTERSTITIAL_STARTED ${Fn(o)} ${c.appendInPlace ? "append in place" : ""}`), this.hls.trigger(T.INTERSTITIAL_STARTED, {
        event: c,
        schedule: t.slice(0),
        scheduleIndex: e
      })), !c.assetListLoaded) {
        this.log(`Waiting for ASSET-LIST to complete loading ${c}`);
        return;
      }
      if (c.assetListLoader && (c.assetListLoader.destroy(), c.assetListLoader = void 0), !a) {
        this.log(`Waiting for attachMedia to start Interstitial ${c}`);
        return;
      }
      this.waitingItem = this.endedItem = null, this.playingItem = o;
      const h = c.assetList[r];
      if (!h) {
        const f = t[e + 1], p = this.media;
        f && p && !this.isInterstitial(f) && p.currentTime < f.start && (p.currentTime = this.timelinePos = f.start), this.advanceAfterAssetEnded(c, e, r || 0);
        return;
      }
      if (d || (d = this.getAssetPlayer(h.identifier)), d === null || d.destroyed) {
        const f = c.assetList.length;
        this.warn(`asset ${r + 1}/${f} player destroyed ${c}`), d = this.createAssetPlayer(c, h, r);
      }
      if (!this.eventItemsMatch(o, this.bufferingItem) && c.appendInPlace && this.isAssetBuffered(h))
        return;
      this.startAssetPlayer(d, r, t, e, a), this.shouldPlay && Qh(d.media);
    } else o !== null ? (this.resumePrimary(o, e, s), this.shouldPlay && Qh(this.hls.media)) : i && this.isInterstitial(s) && (this.endedItem = null, this.playingItem = s, s.event.appendInPlace || this.attachPrimary(this.schedule.durations.primary, null));
  }
  get playbackDisabled() {
    return this.hls.config.enableInterstitialPlayback === !1;
  }
  get primaryDetails() {
    var e, t;
    return (e = this.mediaSelection) == null || (t = e.main) == null ? void 0 : t.details;
  }
  get primaryLive() {
    var e;
    return !!((e = this.primaryDetails) != null && e.live);
  }
  resumePrimary(e, t, r) {
    var s;
    if (this.playingItem = e, this.playingAsset = this.endedAsset = null, this.waitingItem = this.endedItem = null, this.bufferedToItem(e), this.log(`resuming ${Fn(e)}`), !((s = this.detachedData) != null && s.mediaSource)) {
      let o = this.timelinePos;
      (o < e.start || o >= e.end) && (o = this.getPrimaryResumption(e, t), this.timelinePos = o), this.attachPrimary(o, e);
    }
    if (!r)
      return;
    const i = this.schedule.items;
    i && (this.log(`INTERSTITIALS_PRIMARY_RESUMED ${Fn(e)}`), this.hls.trigger(T.INTERSTITIALS_PRIMARY_RESUMED, {
      schedule: i.slice(0),
      scheduleIndex: t
    }), this.checkBuffer());
  }
  getPrimaryResumption(e, t) {
    const r = e.start;
    if (this.primaryLive) {
      const s = this.primaryDetails;
      if (t === 0)
        return this.hls.startPosition;
      if (s && (r < s.fragmentStart || r > s.edge))
        return this.hls.liveSyncPosition || -1;
    }
    return r;
  }
  isAssetBuffered(e) {
    const t = this.getAssetPlayer(e.identifier);
    return t != null && t.hls ? t.hls.bufferedToEnd : Le.bufferInfo(this.primaryMedia, this.timelinePos, 0).end + 1 >= e.timelineStart + (e.duration || 0);
  }
  attachPrimary(e, t, r) {
    t ? this.setBufferingItem(t) : this.bufferingItem = this.playingItem, this.bufferingAsset = null;
    const s = this.primaryMedia;
    if (!s)
      return;
    const i = this.hls;
    i.media ? this.checkBuffer() : (this.transferMediaTo(i, s), r && this.startLoadingPrimaryAt(e, r)), r || (this.timelinePos = e, this.startLoadingPrimaryAt(e, r));
  }
  startLoadingPrimaryAt(e, t) {
    var r;
    const s = this.hls;
    !s.loadingEnabled || !s.media || Math.abs((((r = s.mainForwardBufferInfo) == null ? void 0 : r.start) || s.media.currentTime) - e) > 0.5 ? s.startLoad(e, t) : s.bufferingEnabled || s.resumeBuffering();
  }
  // HLS.js event callbacks
  onManifestLoading() {
    this.stopLoad(), this.schedule.reset(), this.emptyPlayerQueue(), this.clearScheduleState(), this.shouldPlay = !1, this.bufferedPos = this.timelinePos = -1, this.mediaSelection = this.altSelection = this.manager = this.requiredTracks = null, this.hls.off(T.BUFFER_CODECS, this.onBufferCodecs, this), this.hls.on(T.BUFFER_CODECS, this.onBufferCodecs, this);
  }
  onLevelUpdated(e, t) {
    if (t.level === -1)
      return;
    const r = this.hls.levels[t.level], s = rt(rt({}, this.mediaSelection || this.altSelection), {}, {
      main: r
    });
    this.mediaSelection = s, this.schedule.parseInterstitialDateRanges(s, this.hls.config.interstitialAppendInPlace), !this.effectivePlayingItem && this.schedule.items && this.checkStart();
  }
  onAudioTrackUpdated(e, t) {
    const r = this.hls.audioTracks[t.id], s = this.mediaSelection;
    if (!s) {
      this.altSelection = rt(rt({}, this.altSelection), {}, {
        audio: r
      });
      return;
    }
    const i = rt(rt({}, s), {}, {
      audio: r
    });
    this.mediaSelection = i;
  }
  onSubtitleTrackUpdated(e, t) {
    const r = this.hls.subtitleTracks[t.id], s = this.mediaSelection;
    if (!s) {
      this.altSelection = rt(rt({}, this.altSelection), {}, {
        subtitles: r
      });
      return;
    }
    const i = rt(rt({}, s), {}, {
      subtitles: r
    });
    this.mediaSelection = i;
  }
  onAudioTrackSwitching(e, t) {
    const r = dh(t);
    this.playerQueue.forEach((s) => s.hls.setAudioOption(t) || s.hls.setAudioOption(r));
  }
  onSubtitleTrackSwitch(e, t) {
    const r = dh(t);
    this.playerQueue.forEach((s) => s.hls.setSubtitleOption(t) || t.id !== -1 && s.hls.setSubtitleOption(r));
  }
  onBufferCodecs(e, t) {
    const r = t.tracks;
    r && (this.requiredTracks = r);
  }
  onBufferAppended(e, t) {
    this.checkBuffer();
  }
  onBufferFlushed(e, t) {
    const r = this.playingItem;
    if (r && !this.itemsMatch(r, this.bufferingItem) && !this.isInterstitial(r)) {
      const s = this.timelinePos;
      this.bufferedPos = s, this.checkBuffer();
    }
  }
  onBufferedToEnd(e) {
    const t = this.schedule.events;
    if (this.bufferedPos < Number.MAX_VALUE && t) {
      for (let s = 0; s < t.length; s++) {
        const i = t[s];
        if (i.cue.post) {
          var r;
          const o = this.schedule.findEventIndex(i.identifier), a = (r = this.schedule.items) == null ? void 0 : r[o];
          this.isInterstitial(a) && this.eventItemsMatch(a, this.bufferingItem) && this.bufferedToItem(a, 0);
          break;
        }
      }
      this.bufferedPos = Number.MAX_VALUE;
    }
  }
  onMediaEnded(e) {
    const t = this.playingItem;
    if (!this.playingLastItem && t) {
      const r = this.findItemIndex(t);
      this.setSchedulePosition(r + 1);
    } else
      this.shouldPlay = !1;
  }
  updateItem(e, t) {
    const r = this.schedule.items;
    if (e && r) {
      const s = this.findItemIndex(e, t);
      return r[s] || null;
    }
    return null;
  }
  trimInPlace(e, t) {
    if (this.isInterstitial(e) && e.event.appendInPlace && t.end - e.end > 0.25) {
      e.event.assetList.forEach((i, o) => {
        e.event.isAssetPastPlayoutLimit(o) && this.clearAssetPlayer(i.identifier, null);
      });
      const r = e.end + 0.25, s = Le.bufferInfo(this.primaryMedia, r, 0);
      (s.end > r || (s.nextStart || 0) > r) && (this.attachPrimary(r, null), this.flushFrontBuffer(r));
    }
  }
  itemsMatch(e, t) {
    return !!t && (e === t || e.event && t.event && this.eventItemsMatch(e, t) || !e.event && !t.event && this.findItemIndex(e) === this.findItemIndex(t));
  }
  eventItemsMatch(e, t) {
    var r;
    return !!t && (e === t || e.event.identifier === ((r = t.event) == null ? void 0 : r.identifier));
  }
  findItemIndex(e, t) {
    return e ? this.schedule.findItemIndex(e, t) : -1;
  }
  updateSchedule() {
    const e = this.mediaSelection;
    e && this.schedule.updateSchedule(e, []);
  }
  // Schedule buffer control
  checkBuffer(e) {
    const t = this.schedule.items;
    if (!t)
      return;
    const r = Le.bufferInfo(this.primaryMedia, this.timelinePos, 0);
    e && (this.bufferedPos = this.timelinePos), e || (e = r.len < 1), this.updateBufferedPos(r.end, t, e);
  }
  updateBufferedPos(e, t, r) {
    const s = this.schedule, i = this.bufferingItem;
    if (this.bufferedPos > e)
      return;
    if (t.length === 1 && this.itemsMatch(t[0], i)) {
      this.bufferedPos = e;
      return;
    }
    const o = this.playingItem, a = this.findItemIndex(o);
    let l = s.findItemIndexAtTime(e);
    if (this.bufferedPos < e) {
      var c, u;
      const d = this.findItemIndex(i), h = Math.min(d + 1, t.length - 1), f = t[h];
      if ((l === -1 && i && e >= i.end || (c = f.event) != null && c.appendInPlace && e + 0.01 >= f.start) && (l = h), h - a > 1 && (i == null || (u = i.event) == null ? void 0 : u.appendInPlace) === !1)
        return;
      if (this.bufferedPos = e, l > d && l > a)
        this.bufferedToItem(f);
      else {
        const p = this.primaryDetails;
        this.primaryLive && p && e > p.edge - p.targetduration && f.start < p.edge + this.hls.config.interstitialLiveLookAhead && this.isInterstitial(f) && this.preloadAssets(f.event, 0);
      }
    } else r && o && !this.itemsMatch(o, i) && (l === a ? this.bufferedToItem(o) : l === a + 1 && this.bufferedToItem(t[l]));
  }
  assetsBuffered(e, t) {
    return e.event.assetList.length === 0 ? !1 : !e.event.assetList.some((s) => {
      const i = this.getAssetPlayer(s.identifier);
      return !(i != null && i.bufferedInPlaceToEnd(t));
    });
  }
  setBufferingItem(e) {
    const t = this.bufferingItem, r = this.schedule;
    if (this.itemsMatch(e, t))
      this.bufferingItem !== e && (this.bufferingItem = e);
    else {
      const {
        items: s,
        events: i
      } = r;
      if (!s || !i)
        return t;
      const o = this.isInterstitial(e), a = this.getBufferingPlayer();
      this.bufferingItem = e, this.bufferedPos = Math.max(e.start, Math.min(e.end, this.timelinePos));
      const l = a ? a.remaining : t ? t.end - this.timelinePos : 0;
      this.log(`INTERSTITIALS_BUFFERED_TO_BOUNDARY ${Fn(e)}` + (t ? ` (${l.toFixed(2)} remaining)` : "")), this.playbackDisabled || (o ? e.event.assetList.forEach((c) => {
        const u = this.getAssetPlayer(c.identifier);
        u && u.resumeBuffering();
      }) : (this.hls.resumeBuffering(), this.playerQueue.forEach((c) => c.pauseBuffering()))), this.hls.trigger(T.INTERSTITIALS_BUFFERED_TO_BOUNDARY, {
        events: i.slice(0),
        schedule: s.slice(0),
        bufferingIndex: this.findItemIndex(e),
        playingIndex: this.findItemIndex(this.playingItem)
      });
    }
    return t;
  }
  bufferedToItem(e, t = 0) {
    const r = this.setBufferingItem(e);
    if (!this.playbackDisabled) {
      if (this.isInterstitial(e))
        this.bufferedToEvent(e, t);
      else if (r !== null) {
        this.bufferingAsset = null;
        const s = this.detachedData;
        s ? s.mediaSource ? this.attachPrimary(e.start, e, !0) : this.preloadPrimary(e) : this.preloadPrimary(e);
      }
    }
  }
  preloadPrimary(e) {
    const t = this.findItemIndex(e), r = this.getPrimaryResumption(e, t);
    this.startLoadingPrimaryAt(r);
  }
  bufferedToEvent(e, t) {
    const r = e.event, s = r.assetList.length === 0 && !r.assetListLoader, i = r.cue.once;
    if (s || !i) {
      const o = this.preloadAssets(r, t);
      if (o != null && o.interstitial.appendInPlace) {
        const a = r.assetList[t], l = this.primaryMedia;
        a && l && this.bufferAssetPlayer(o, l);
      }
    }
  }
  preloadAssets(e, t) {
    const r = e.assetUrl, s = e.assetList.length, i = s === 0 && !e.assetListLoader, o = e.cue.once;
    if (i) {
      const l = e.timelineStart;
      if (e.appendInPlace) {
        var a;
        const h = this.playingItem;
        !this.isInterstitial(h) && (h == null || (a = h.nextEvent) == null ? void 0 : a.identifier) === e.identifier && this.flushFrontBuffer(l + 0.25);
      }
      let c, u = 0;
      if (!this.playingItem && this.primaryLive && (u = this.hls.startPosition, u === -1 && (u = this.hls.liveSyncPosition || 0)), u && !(e.cue.pre || e.cue.post)) {
        const h = u - l;
        h > 0 && (c = Math.round(h * 1e3) / 1e3);
      }
      if (this.log(`Load interstitial asset ${t + 1}/${r ? 1 : s} ${e}${c ? ` live-start: ${u} start-offset: ${c}` : ""}`), r)
        return this.createAsset(e, 0, 0, l, e.duration, r);
      const d = this.assetListLoader.loadAssetList(e, c);
      d && (e.assetListLoader = d);
    } else if (!o && s) {
      for (let l = t; l < s; l++) {
        const c = e.assetList[l], u = this.getAssetPlayerQueueIndex(c.identifier);
        (u === -1 || this.playerQueue[u].destroyed) && !c.error && this.createAssetPlayer(e, c, l);
      }
      return this.getAssetPlayer(e.assetList[t].identifier);
    }
    return null;
  }
  flushFrontBuffer(e) {
    const t = this.requiredTracks;
    if (!t)
      return;
    this.log(`Removing front buffer starting at ${e}`), Object.keys(t).forEach((s) => {
      this.hls.trigger(T.BUFFER_FLUSHING, {
        startOffset: e,
        endOffset: 1 / 0,
        type: s
      });
    });
  }
  // Interstitial Asset Player control
  getAssetPlayerQueueIndex(e) {
    const t = this.playerQueue;
    for (let r = 0; r < t.length; r++)
      if (e === t[r].assetId)
        return r;
    return -1;
  }
  getAssetPlayer(e) {
    const t = this.getAssetPlayerQueueIndex(e);
    return this.playerQueue[t] || null;
  }
  getBufferingPlayer() {
    const {
      playerQueue: e,
      primaryMedia: t
    } = this;
    if (t) {
      for (let r = 0; r < e.length; r++)
        if (e[r].media === t)
          return e[r];
    }
    return null;
  }
  createAsset(e, t, r, s, i, o) {
    const a = {
      parentIdentifier: e.identifier,
      identifier: Ew(e, o, t),
      duration: i,
      startOffset: r,
      timelineStart: s,
      uri: o
    };
    return this.createAssetPlayer(e, a, t);
  }
  createAssetPlayer(e, t, r) {
    const s = this.hls, i = s.userConfig;
    let o = i.videoPreference;
    const a = s.loadLevelObj || s.levels[s.currentLevel];
    (o || a) && (o = st({}, o), a.videoCodec && (o.videoCodec = a.videoCodec), a.videoRange && (o.allowedVideoRanges = [a.videoRange]));
    const l = s.audioTracks[s.audioTrack], c = s.subtitleTracks[s.subtitleTrack];
    let u = 0;
    if (this.primaryLive || e.appendInPlace) {
      const A = this.timelinePos - t.timelineStart;
      if (A > 1) {
        const P = t.duration;
        P && A < P && (u = A);
      }
    }
    const d = t.identifier, h = rt(rt({}, i), {}, {
      autoStartLoad: !0,
      startFragPrefetch: !0,
      primarySessionId: s.sessionId,
      assetPlayerId: d,
      abrEwmaDefaultEstimate: s.bandwidthEstimate,
      interstitialsController: void 0,
      startPosition: u,
      liveDurationInfinity: !1,
      testBandwidth: !1,
      videoPreference: o,
      audioPreference: l || i.audioPreference,
      subtitlePreference: c || i.subtitlePreference
    });
    e.appendInPlace && (e.appendInPlaceStarted = !0, t.timelineStart && (h.timelineOffset = t.timelineStart));
    const f = h.cmcd;
    f != null && f.sessionId && f.contentId && (h.cmcd = st({}, f, {
      contentId: vi(t.uri)
    })), this.getAssetPlayer(d) && this.warn(`Duplicate date range identifier ${e} and asset ${d}`);
    const p = new Tw(this.HlsPlayerClass, h, e, t);
    this.playerQueue.push(p), e.assetList[r] = t;
    const y = (A) => {
      if (A.live) {
        const U = new Error(`Interstitials MUST be VOD assets ${e}`), j = {
          fatal: !0,
          type: ge.OTHER_ERROR,
          details: Y.INTERSTITIAL_ASSET_ITEM_ERROR,
          error: U
        };
        this.handleAssetItemError(j, e, this.schedule.findEventIndex(e.identifier), r, U.message);
        return;
      }
      const P = A.edge - A.fragmentStart, I = t.duration;
      (I === null || P > I) && (this.log(`Interstitial asset "${d}" duration change ${I} > ${P}`), t.duration = P, this.updateSchedule());
    };
    p.on(T.LEVEL_UPDATED, (A, {
      details: P
    }) => y(P)), p.on(T.LEVEL_PTS_UPDATED, (A, {
      details: P
    }) => y(P));
    const m = (A, P) => {
      const I = this.getAssetPlayer(d);
      if (I && P.tracks) {
        I.off(T.BUFFER_CODECS, m), I.tracks = P.tracks;
        const U = this.primaryMedia;
        this.bufferingAsset === I.assetItem && U && !I.media && this.bufferAssetPlayer(I, U);
      }
    };
    p.on(T.BUFFER_CODECS, m);
    const b = () => {
      var A;
      const P = this.getAssetPlayer(d);
      if (this.log(`buffered to end of asset ${P}`), !P)
        return;
      const I = this.schedule.findEventIndex(e.identifier), U = (A = this.schedule.items) == null ? void 0 : A[I];
      if (this.isInterstitial(U)) {
        const G = e.findAssetIndex(t), F = Ul(e, G);
        if (!e.isAssetPastPlayoutLimit(F))
          this.bufferedToItem(U, F);
        else {
          var j;
          const B = (j = this.schedule.items) == null ? void 0 : j[I + 1];
          B && this.bufferedToItem(B);
        }
      }
    };
    p.on(T.BUFFERED_TO_END, b);
    const C = (A) => () => {
      if (!this.getAssetPlayer(d))
        return;
      this.shouldPlay = !0;
      const I = this.schedule.findEventIndex(e.identifier);
      this.advanceAfterAssetEnded(e, I, A);
    };
    return p.once(T.MEDIA_ENDED, C(r)), p.once(T.PLAYOUT_LIMIT_REACHED, C(1 / 0)), p.on(T.ERROR, (A, P) => {
      const I = this.getAssetPlayer(d);
      if (P.details === Y.BUFFER_STALLED_ERROR) {
        if (I != null && I.media) {
          const U = I.currentTime, j = I.duration - U;
          U && e.appendInPlace && j / I.media.playbackRate < 0.5 ? (this.log(`Advancing buffer past end of asset ${d} ${e} at ${I.media.currentTime}`), b()) : (this.warn(`Stalled at ${U} of ${U + j} in asset ${d} ${e}`), this.onTimeupdate(), this.checkBuffer(!0));
        }
        return;
      }
      this.handleAssetItemError(P, e, this.schedule.findEventIndex(e.identifier), r, `Asset player error ${P.error} ${e}`);
    }), p.on(T.DESTROYING, () => {
      if (!this.getAssetPlayer(d))
        return;
      const P = new Error(`Asset player destroyed unexpectedly ${d}`), I = {
        fatal: !0,
        type: ge.OTHER_ERROR,
        details: Y.INTERSTITIAL_ASSET_ITEM_ERROR,
        error: P
      };
      this.handleAssetItemError(I, e, this.schedule.findEventIndex(e.identifier), r, P.message);
    }), this.log(`INTERSTITIAL_ASSET_PLAYER_CREATED ${Os(t)}`), this.hls.trigger(T.INTERSTITIAL_ASSET_PLAYER_CREATED, {
      asset: t,
      assetListIndex: r,
      event: e,
      player: p
    }), p;
  }
  clearInterstitial(e, t) {
    e.assetList.forEach((r) => {
      this.clearAssetPlayer(r.identifier, t);
    }), e.reset();
  }
  resetAssetPlayer(e) {
    const t = this.getAssetPlayerQueueIndex(e);
    if (t !== -1) {
      this.log(`reset asset player "${e}" after error`);
      const r = this.playerQueue[t];
      this.transferMediaFromPlayer(r, null), r.resetDetails();
    }
  }
  clearAssetPlayer(e, t) {
    const r = this.getAssetPlayerQueueIndex(e);
    if (r !== -1) {
      this.log(`clear asset player "${e}" toSegment: ${t && Fn(t)}`);
      const s = this.playerQueue[r];
      this.transferMediaFromPlayer(s, t), this.playerQueue.splice(r, 1), s.destroy();
    }
  }
  emptyPlayerQueue() {
    let e;
    for (; e = this.playerQueue.pop(); )
      e.destroy();
    this.playerQueue = [];
  }
  startAssetPlayer(e, t, r, s, i) {
    const {
      interstitial: o,
      assetItem: a,
      assetId: l
    } = e, c = o.assetList.length, u = this.playingAsset;
    this.endedAsset = null, this.playingAsset = a, (!u || u.identifier !== l) && (u && (this.clearAssetPlayer(u.identifier, r[s]), delete u.error), this.log(`INTERSTITIAL_ASSET_STARTED ${t + 1}/${c} ${Os(a)}`), this.hls.trigger(T.INTERSTITIAL_ASSET_STARTED, {
      asset: a,
      assetListIndex: t,
      event: o,
      schedule: r.slice(0),
      scheduleIndex: s,
      player: e
    })), this.bufferAssetPlayer(e, i);
  }
  bufferAssetPlayer(e, t) {
    var r, s;
    const {
      interstitial: i,
      assetItem: o
    } = e, a = this.schedule.findEventIndex(i.identifier), l = (r = this.schedule.items) == null ? void 0 : r[a];
    if (!l)
      return;
    this.setBufferingItem(l), this.bufferingAsset = o;
    const c = this.getBufferingPlayer();
    if (c === e)
      return;
    const u = i.appendInPlace;
    if (u && (c == null ? void 0 : c.interstitial.appendInPlace) === !1)
      return;
    const d = (c == null ? void 0 : c.tracks) || ((s = this.detachedData) == null ? void 0 : s.tracks) || this.requiredTracks;
    if (u && o !== this.playingAsset) {
      if (!e.tracks)
        return;
      if (d && !Vg(d, e.tracks)) {
        const h = new Error(`Asset ${Os(o)} SourceBuffer tracks ('${Object.keys(e.tracks)}') are not compatible with primary content tracks ('${Object.keys(d)}')`), f = {
          fatal: !0,
          type: ge.OTHER_ERROR,
          details: Y.INTERSTITIAL_ASSET_ITEM_ERROR,
          error: h
        }, p = i.findAssetIndex(o);
        this.handleAssetItemError(f, i, a, p, h.message);
        return;
      }
    }
    this.transferMediaTo(e, t);
  }
  handleAssetItemError(e, t, r, s, i) {
    if (e.details === Y.BUFFER_STALLED_ERROR)
      return;
    const o = t.assetList[s];
    this.warn(`INTERSTITIAL_ASSET_ERROR ${o && Os(o)} ${e.error}`);
    const a = o == null ? void 0 : o.identifier, l = this.getAssetPlayerQueueIndex(a), c = this.playerQueue[l] || null, u = this.schedule.items, d = st({}, e, {
      fatal: !1,
      errorAction: Fi(!0),
      asset: o,
      assetListIndex: s,
      event: t,
      schedule: u,
      scheduleIndex: r,
      player: c
    });
    if (this.hls.trigger(T.INTERSTITIAL_ASSET_ERROR, d), !e.fatal)
      return;
    const h = this.playingAsset, f = new Error(i);
    if (o && (this.clearAssetPlayer(a, null), o.error = f), !t.assetList.some((p) => !p.error))
      t.error = f;
    else if (t.appendInPlace) {
      for (let p = s; p < t.assetList.length; p++)
        this.resetAssetPlayer(t.assetList[p].identifier);
      this.updateSchedule();
    }
    t.error ? this.primaryFallback(t) : h && h.identifier === a && this.advanceAfterAssetEnded(t, r, s);
  }
  primaryFallback(e) {
    const t = e.timelineStart, r = this.effectivePlayingItem;
    if (this.updateSchedule(), r) {
      this.log(`Fallback to primary from event "${e.identifier}" start: ${t} pos: ${this.timelinePos} playing: ${r ? Fn(r) : "<none>"} error: ${e.error}`);
      let s = this.timelinePos;
      s === -1 && (s = this.hls.startPosition);
      const i = this.updateItem(r, s);
      this.itemsMatch(r, i) && this.clearInterstitial(e, null), e.appendInPlace && (this.attachPrimary(t, null), this.flushFrontBuffer(t));
      const o = this.schedule.findItemIndexAtTime(s);
      this.setSchedulePosition(o);
    } else
      this.checkStart();
  }
  // Asset List loading
  onAssetListLoaded(e, t) {
    var r;
    const s = t.event, i = s.identifier, o = t.assetListResponse.ASSETS;
    if (!this.schedule.hasEvent(i))
      return;
    const a = s.timelineStart, l = s.duration;
    let c = 0;
    o.forEach((p, y) => {
      const m = parseFloat(p.DURATION);
      this.createAsset(s, y, c, a + c, m, p.URI), c += m;
    }), s.duration = c, this.log(`Loaded asset-list with duration: ${c} (was: ${l}) ${s}`);
    const u = this.waitingItem, d = (u == null ? void 0 : u.event.identifier) === i;
    this.updateSchedule();
    const h = (r = this.bufferingItem) == null ? void 0 : r.event;
    if (d) {
      var f;
      const p = this.schedule.findEventIndex(i), y = (f = this.schedule.items) == null ? void 0 : f[p];
      if (y) {
        if (!this.playingItem && this.timelinePos > y.end && this.schedule.findItemIndexAtTime(this.timelinePos) !== p) {
          s.error = new Error(`Interstitial no longer within playback range ${this.timelinePos} ${s}`), this.primaryFallback(s);
          return;
        }
        this.setBufferingItem(y);
      }
      this.setSchedulePosition(p);
    } else if ((h == null ? void 0 : h.identifier) === i && h.appendInPlace) {
      const p = s.assetList[0], y = this.getAssetPlayer(p.identifier), m = this.primaryMedia;
      p && y && m && this.bufferAssetPlayer(y, m);
    }
  }
  onError(e, t) {
    switch (t.details) {
      case Y.ASSET_LIST_PARSING_ERROR:
      case Y.ASSET_LIST_LOAD_ERROR:
      case Y.ASSET_LIST_LOAD_TIMEOUT: {
        const r = t.interstitial;
        r && this.primaryFallback(r);
        break;
      }
      case Y.BUFFER_STALLED_ERROR: {
        this.onTimeupdate(), this.checkBuffer(!0);
        break;
      }
    }
  }
}
const ef = 500;
class _w extends Gu {
  constructor(e, t, r) {
    super(e, t, r, "subtitle-stream-controller", he.SUBTITLE), this.currentTrackId = -1, this.tracksBuffered = [], this.mainDetails = null, this.registerListeners();
  }
  onHandlerDestroying() {
    this.unregisterListeners(), super.onHandlerDestroying(), this.mainDetails = null;
  }
  registerListeners() {
    super.registerListeners();
    const {
      hls: e
    } = this;
    e.on(T.LEVEL_LOADED, this.onLevelLoaded, this), e.on(T.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(T.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.on(T.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(T.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.on(T.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  unregisterListeners() {
    super.unregisterListeners();
    const {
      hls: e
    } = this;
    e.off(T.LEVEL_LOADED, this.onLevelLoaded, this), e.off(T.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(T.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.off(T.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(T.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.off(T.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  startLoad(e, t) {
    this.stopLoad(), this.state = Q.IDLE, this.setInterval(ef), this.nextLoadPosition = this.lastCurrentTime = e + this.timelineOffset, this.startPosition = t ? -1 : e, this.tick();
  }
  onManifestLoading() {
    super.onManifestLoading(), this.mainDetails = null;
  }
  onMediaDetaching(e, t) {
    this.tracksBuffered = [], super.onMediaDetaching(e, t);
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details;
  }
  onSubtitleFragProcessed(e, t) {
    const {
      frag: r,
      success: s
    } = t;
    if (Yt(r) && (this.fragPrevious = r), this.state = Q.IDLE, !s)
      return;
    const i = this.tracksBuffered[this.currentTrackId];
    if (!i)
      return;
    let o;
    const a = r.start;
    for (let c = 0; c < i.length; c++)
      if (a >= i[c].start && a <= i[c].end) {
        o = i[c];
        break;
      }
    const l = r.start + r.duration;
    o ? o.end = l : (o = {
      start: a,
      end: l
    }, i.push(o)), this.fragmentTracker.fragBuffered(r), this.fragBufferedComplete(r, null), this.media && this.tick();
  }
  onBufferFlushing(e, t) {
    const {
      startOffset: r,
      endOffset: s
    } = t;
    if (r === 0 && s !== Number.POSITIVE_INFINITY) {
      const i = s - 1;
      if (i <= 0)
        return;
      t.endOffsetSubtitles = Math.max(0, i), this.tracksBuffered.forEach((o) => {
        for (let a = 0; a < o.length; ) {
          if (o[a].end <= i) {
            o.shift();
            continue;
          } else if (o[a].start < i)
            o[a].start = i;
          else
            break;
          a++;
        }
      }), this.fragmentTracker.removeFragmentsInRange(r, i, he.SUBTITLE);
    }
  }
  // If something goes wrong, proceed to next frag, if we were processing one.
  onError(e, t) {
    const r = t.frag;
    (r == null ? void 0 : r.type) === he.SUBTITLE && (t.details === Y.FRAG_GAP && this.fragmentTracker.fragBuffered(r, !0), this.fragCurrent && this.fragCurrent.abortRequests(), this.state !== Q.STOPPED && (this.state = Q.IDLE));
  }
  // Got all new subtitle levels.
  onSubtitleTracksUpdated(e, {
    subtitleTracks: t
  }) {
    if (this.levels && jp(this.levels, t)) {
      this.levels = t.map((r) => new Bi(r));
      return;
    }
    this.tracksBuffered = [], this.levels = t.map((r) => {
      const s = new Bi(r);
      return this.tracksBuffered[s.id] = [], s;
    }), this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, he.SUBTITLE), this.fragPrevious = null, this.mediaBuffer = null;
  }
  onSubtitleTrackSwitch(e, t) {
    var r;
    if (this.currentTrackId = t.id, !((r = this.levels) != null && r.length) || this.currentTrackId === -1) {
      this.clearInterval();
      return;
    }
    const s = this.levels[this.currentTrackId];
    s != null && s.details ? this.mediaBuffer = this.mediaBufferTimeRanges : this.mediaBuffer = null, s && this.state !== Q.STOPPED && this.setInterval(ef);
  }
  // Got a new set of subtitle fragments.
  onSubtitleTrackLoaded(e, t) {
    var r;
    const {
      currentTrackId: s,
      levels: i
    } = this, {
      details: o,
      id: a
    } = t;
    if (!i) {
      this.warn(`Subtitle tracks were reset while loading level ${a}`);
      return;
    }
    const l = i[a];
    if (a >= i.length || !l)
      return;
    this.log(`Subtitle track ${a} loaded [${o.startSN},${o.endSN}]${o.lastPartSn ? `[part-${o.lastPartSn}-${o.lastPartIndex}]` : ""},duration:${o.totalduration}`), this.mediaBuffer = this.mediaBufferTimeRanges;
    let c = 0;
    if (o.live || (r = l.details) != null && r.live) {
      const d = this.mainDetails;
      if (o.deltaUpdateFailed || !d)
        return;
      const h = d.fragments[0];
      if (!l.details)
        o.hasProgramDateTime && d.hasProgramDateTime ? (Sa(o, d), c = o.fragmentStart) : h && (c = h.start, Lc(o, c));
      else {
        var u;
        c = this.alignPlaylists(o, l.details, (u = this.levelLastLoaded) == null ? void 0 : u.details), c === 0 && h && (c = h.start, Lc(o, c));
      }
    }
    l.details = o, this.levelLastLoaded = l, a === s && (this.hls.trigger(T.SUBTITLE_TRACK_UPDATED, {
      details: o,
      id: a,
      groupId: t.groupId
    }), this.tick(), o.live && !this.fragCurrent && this.media && this.state === Q.IDLE && (gs(null, o.fragments, this.media.currentTime, 0) || (this.warn("Subtitle playlist not aligned with playback"), l.details = void 0)));
  }
  _handleFragmentLoadComplete(e) {
    const {
      frag: t,
      payload: r
    } = e, s = t.decryptdata, i = this.hls;
    if (!this.fragContextChanged(t) && r && r.byteLength > 0 && s != null && s.key && s.iv && Gs(s.method)) {
      const o = performance.now();
      this.decrypter.decrypt(new Uint8Array(r), s.key.buffer, s.iv.buffer, Uu(s.method)).catch((a) => {
        throw i.trigger(T.ERROR, {
          type: ge.MEDIA_ERROR,
          details: Y.FRAG_DECRYPT_ERROR,
          fatal: !1,
          error: a,
          reason: a.message,
          frag: t
        }), a;
      }).then((a) => {
        const l = performance.now();
        i.trigger(T.FRAG_DECRYPTED, {
          frag: t,
          payload: a,
          stats: {
            tstart: o,
            tdecrypt: l
          }
        });
      }).catch((a) => {
        this.warn(`${a.name}: ${a.message}`), this.state = Q.IDLE;
      });
    }
  }
  doTick() {
    if (!this.media) {
      this.state = Q.IDLE;
      return;
    }
    if (this.state === Q.IDLE) {
      const {
        currentTrackId: e,
        levels: t
      } = this, r = t == null ? void 0 : t[e];
      if (!r || !t.length || !r.details || this.waitForLive(r))
        return;
      const {
        config: s
      } = this, i = this.getLoadPosition(), o = Le.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], i, s.maxBufferHole), {
        end: a,
        len: l
      } = o, c = r.details, u = this.hls.maxBufferLength + c.levelTargetDuration;
      if (l > u)
        return;
      const d = c.fragments, h = d.length, f = c.edge;
      let p = null;
      const y = this.fragPrevious;
      if (a < f) {
        const C = s.maxFragLookUpTolerance, A = a > f - C ? 0 : C;
        p = gs(y, d, Math.max(d[0].start, a), A), !p && y && y.start < d[0].start && (p = d[0]);
      } else
        p = d[h - 1];
      if (p = this.filterReplacedPrimary(p, r.details), !p)
        return;
      const m = p.sn - c.startSN, b = d[m - 1];
      if (b && b.cc === p.cc && this.fragmentTracker.getState(b) === Ht.NOT_LOADED && (p = b), this.fragmentTracker.getState(p) === Ht.NOT_LOADED) {
        const C = this.mapToInitFragWhenRequired(p);
        C && this.loadFragment(C, r, a);
      }
    }
  }
  loadFragment(e, t, r) {
    Yt(e) ? super.loadFragment(e, t, r) : this._loadInitSegment(e, t);
  }
  get mediaBufferTimeRanges() {
    return new Lw(this.tracksBuffered[this.currentTrackId] || []);
  }
}
class Lw {
  constructor(e) {
    this.buffered = void 0;
    const t = (r, s, i) => {
      if (s = s >>> 0, s > i - 1)
        throw new DOMException(`Failed to execute '${r}' on 'TimeRanges': The index provided (${s}) is greater than the maximum bound (${i})`);
      return e[s][r];
    };
    this.buffered = {
      get length() {
        return e.length;
      },
      end(r) {
        return t("end", r, e.length);
      },
      start(r) {
        return t("start", r, e.length);
      }
    };
  }
}
const Rw = {
  42: 225,
  // lowercase a, acute accent
  92: 233,
  // lowercase e, acute accent
  94: 237,
  // lowercase i, acute accent
  95: 243,
  // lowercase o, acute accent
  96: 250,
  // lowercase u, acute accent
  123: 231,
  // lowercase c with cedilla
  124: 247,
  // division symbol
  125: 209,
  // uppercase N tilde
  126: 241,
  // lowercase n tilde
  127: 9608,
  // Full block
  // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
  // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
  128: 174,
  // Registered symbol (R)
  129: 176,
  // degree sign
  130: 189,
  // 1/2 symbol
  131: 191,
  // Inverted (open) question mark
  132: 8482,
  // Trademark symbol (TM)
  133: 162,
  // Cents symbol
  134: 163,
  // Pounds sterling
  135: 9834,
  // Music 8'th note
  136: 224,
  // lowercase a, grave accent
  137: 32,
  // transparent space (regular)
  138: 232,
  // lowercase e, grave accent
  139: 226,
  // lowercase a, circumflex accent
  140: 234,
  // lowercase e, circumflex accent
  141: 238,
  // lowercase i, circumflex accent
  142: 244,
  // lowercase o, circumflex accent
  143: 251,
  // lowercase u, circumflex accent
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
  144: 193,
  // capital letter A with acute
  145: 201,
  // capital letter E with acute
  146: 211,
  // capital letter O with acute
  147: 218,
  // capital letter U with acute
  148: 220,
  // capital letter U with diaresis
  149: 252,
  // lowercase letter U with diaeresis
  150: 8216,
  // opening single quote
  151: 161,
  // inverted exclamation mark
  152: 42,
  // asterisk
  153: 8217,
  // closing single quote
  154: 9473,
  // box drawings heavy horizontal
  155: 169,
  // copyright sign
  156: 8480,
  // Service mark
  157: 8226,
  // (round) bullet
  158: 8220,
  // Left double quotation mark
  159: 8221,
  // Right double quotation mark
  160: 192,
  // uppercase A, grave accent
  161: 194,
  // uppercase A, circumflex
  162: 199,
  // uppercase C with cedilla
  163: 200,
  // uppercase E, grave accent
  164: 202,
  // uppercase E, circumflex
  165: 203,
  // capital letter E with diaresis
  166: 235,
  // lowercase letter e with diaresis
  167: 206,
  // uppercase I, circumflex
  168: 207,
  // uppercase I, with diaresis
  169: 239,
  // lowercase i, with diaresis
  170: 212,
  // uppercase O, circumflex
  171: 217,
  // uppercase U, grave accent
  172: 249,
  // lowercase u, grave accent
  173: 219,
  // uppercase U, circumflex
  174: 171,
  // left-pointing double angle quotation mark
  175: 187,
  // right-pointing double angle quotation mark
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
  176: 195,
  // Uppercase A, tilde
  177: 227,
  // Lowercase a, tilde
  178: 205,
  // Uppercase I, acute accent
  179: 204,
  // Uppercase I, grave accent
  180: 236,
  // Lowercase i, grave accent
  181: 210,
  // Uppercase O, grave accent
  182: 242,
  // Lowercase o, grave accent
  183: 213,
  // Uppercase O, tilde
  184: 245,
  // Lowercase o, tilde
  185: 123,
  // Open curly brace
  186: 125,
  // Closing curly brace
  187: 92,
  // Backslash
  188: 94,
  // Caret
  189: 95,
  // Underscore
  190: 124,
  // Pipe (vertical line)
  191: 8764,
  // Tilde operator
  192: 196,
  // Uppercase A, umlaut
  193: 228,
  // Lowercase A, umlaut
  194: 214,
  // Uppercase O, umlaut
  195: 246,
  // Lowercase o, umlaut
  196: 223,
  // Esszett (sharp S)
  197: 165,
  // Yen symbol
  198: 164,
  // Generic currency sign
  199: 9475,
  // Box drawings heavy vertical
  200: 197,
  // Uppercase A, ring
  201: 229,
  // Lowercase A, ring
  202: 216,
  // Uppercase O, stroke
  203: 248,
  // Lowercase o, strok
  204: 9487,
  // Box drawings heavy down and right
  205: 9491,
  // Box drawings heavy down and left
  206: 9495,
  // Box drawings heavy up and right
  207: 9499
  // Box drawings heavy up and left
}, Qp = (n) => String.fromCharCode(Rw[n] || n), $r = 15, vn = 100, Cw = {
  17: 1,
  18: 3,
  21: 5,
  22: 7,
  23: 9,
  16: 11,
  19: 12,
  20: 14
}, kw = {
  17: 2,
  18: 4,
  21: 6,
  22: 8,
  23: 10,
  19: 13,
  20: 15
}, Dw = {
  25: 1,
  26: 3,
  29: 5,
  30: 7,
  31: 9,
  24: 11,
  27: 12,
  28: 14
}, Pw = {
  25: 2,
  26: 4,
  29: 6,
  30: 8,
  31: 10,
  27: 13,
  28: 15
}, Mw = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"];
class Ow {
  constructor() {
    this.time = null, this.verboseLevel = 0;
  }
  log(e, t) {
    if (this.verboseLevel >= e) {
      const r = typeof t == "function" ? t() : t;
      Ze.log(`${this.time} [${e}] ${r}`);
    }
  }
}
const Qn = function(e) {
  const t = [];
  for (let r = 0; r < e.length; r++)
    t.push(e[r].toString(16));
  return t;
};
class em {
  constructor() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  reset() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  setStyles(e) {
    const t = ["foreground", "underline", "italics", "background", "flash"];
    for (let r = 0; r < t.length; r++) {
      const s = t[r];
      e.hasOwnProperty(s) && (this[s] = e[s]);
    }
  }
  isDefault() {
    return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
  }
  equals(e) {
    return this.foreground === e.foreground && this.underline === e.underline && this.italics === e.italics && this.background === e.background && this.flash === e.flash;
  }
  copy(e) {
    this.foreground = e.foreground, this.underline = e.underline, this.italics = e.italics, this.background = e.background, this.flash = e.flash;
  }
  toString() {
    return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
  }
}
class Bw {
  constructor() {
    this.uchar = " ", this.penState = new em();
  }
  reset() {
    this.uchar = " ", this.penState.reset();
  }
  setChar(e, t) {
    this.uchar = e, this.penState.copy(t);
  }
  setPenState(e) {
    this.penState.copy(e);
  }
  equals(e) {
    return this.uchar === e.uchar && this.penState.equals(e.penState);
  }
  copy(e) {
    this.uchar = e.uchar, this.penState.copy(e.penState);
  }
  isEmpty() {
    return this.uchar === " " && this.penState.isDefault();
  }
}
class Fw {
  constructor(e) {
    this.chars = [], this.pos = 0, this.currPenState = new em(), this.cueStartTime = null, this.logger = void 0;
    for (let t = 0; t < vn; t++)
      this.chars.push(new Bw());
    this.logger = e;
  }
  equals(e) {
    for (let t = 0; t < vn; t++)
      if (!this.chars[t].equals(e.chars[t]))
        return !1;
    return !0;
  }
  copy(e) {
    for (let t = 0; t < vn; t++)
      this.chars[t].copy(e.chars[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < vn; t++)
      if (!this.chars[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  /**
   *  Set the cursor to a valid column.
   */
  setCursor(e) {
    this.pos !== e && (this.pos = e), this.pos < 0 ? (this.logger.log(3, "Negative cursor position " + this.pos), this.pos = 0) : this.pos > vn && (this.logger.log(3, "Too large cursor position " + this.pos), this.pos = vn);
  }
  /**
   * Move the cursor relative to current position.
   */
  moveCursor(e) {
    const t = this.pos + e;
    if (e > 1)
      for (let r = this.pos + 1; r < t + 1; r++)
        this.chars[r].setPenState(this.currPenState);
    this.setCursor(t);
  }
  /**
   * Backspace, move one step back and clear character.
   */
  backSpace() {
    this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
  }
  insertChar(e) {
    e >= 144 && this.backSpace();
    const t = Qp(e);
    if (this.pos >= vn) {
      this.logger.log(0, () => "Cannot insert " + e.toString(16) + " (" + t + ") at position " + this.pos + ". Skipping it!");
      return;
    }
    this.chars[this.pos].setChar(t, this.currPenState), this.moveCursor(1);
  }
  clearFromPos(e) {
    let t;
    for (t = e; t < vn; t++)
      this.chars[t].reset();
  }
  clear() {
    this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
  }
  clearToEndOfRow() {
    this.clearFromPos(this.pos);
  }
  getTextString() {
    const e = [];
    let t = !0;
    for (let r = 0; r < vn; r++) {
      const s = this.chars[r].uchar;
      s !== " " && (t = !1), e.push(s);
    }
    return t ? "" : e.join("");
  }
  setPenStyles(e) {
    this.currPenState.setStyles(e), this.chars[this.pos].setPenState(this.currPenState);
  }
}
class $l {
  constructor(e) {
    this.rows = [], this.currRow = $r - 1, this.nrRollUpRows = null, this.lastOutputScreen = null, this.logger = void 0;
    for (let t = 0; t < $r; t++)
      this.rows.push(new Fw(e));
    this.logger = e;
  }
  reset() {
    for (let e = 0; e < $r; e++)
      this.rows[e].clear();
    this.currRow = $r - 1;
  }
  equals(e) {
    let t = !0;
    for (let r = 0; r < $r; r++)
      if (!this.rows[r].equals(e.rows[r])) {
        t = !1;
        break;
      }
    return t;
  }
  copy(e) {
    for (let t = 0; t < $r; t++)
      this.rows[t].copy(e.rows[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < $r; t++)
      if (!this.rows[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  backSpace() {
    this.rows[this.currRow].backSpace();
  }
  clearToEndOfRow() {
    this.rows[this.currRow].clearToEndOfRow();
  }
  /**
   * Insert a character (without styling) in the current row.
   */
  insertChar(e) {
    this.rows[this.currRow].insertChar(e);
  }
  setPen(e) {
    this.rows[this.currRow].setPenStyles(e);
  }
  moveCursor(e) {
    this.rows[this.currRow].moveCursor(e);
  }
  setCursor(e) {
    this.logger.log(2, "setCursor: " + e), this.rows[this.currRow].setCursor(e);
  }
  setPAC(e) {
    this.logger.log(2, () => "pacData = " + mt(e));
    let t = e.row - 1;
    if (this.nrRollUpRows && t < this.nrRollUpRows - 1 && (t = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== t) {
      for (let a = 0; a < $r; a++)
        this.rows[a].clear();
      const i = this.currRow + 1 - this.nrRollUpRows, o = this.lastOutputScreen;
      if (o) {
        const a = o.rows[i].cueStartTime, l = this.logger.time;
        if (a !== null && l !== null && a < l)
          for (let c = 0; c < this.nrRollUpRows; c++)
            this.rows[t - this.nrRollUpRows + c + 1].copy(o.rows[i + c]);
      }
    }
    this.currRow = t;
    const r = this.rows[this.currRow];
    if (e.indent !== null) {
      const i = e.indent, o = Math.max(i - 1, 0);
      r.setCursor(e.indent), e.color = r.chars[o].penState.foreground;
    }
    const s = {
      foreground: e.color,
      underline: e.underline,
      italics: e.italics,
      background: "black",
      flash: !1
    };
    this.setPen(s);
  }
  /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */
  setBkgData(e) {
    this.logger.log(2, () => "bkgData = " + mt(e)), this.backSpace(), this.setPen(e), this.insertChar(32);
  }
  setRollUpRows(e) {
    this.nrRollUpRows = e;
  }
  rollUp() {
    if (this.nrRollUpRows === null) {
      this.logger.log(3, "roll_up but nrRollUpRows not set yet");
      return;
    }
    this.logger.log(1, () => this.getDisplayText());
    const e = this.currRow + 1 - this.nrRollUpRows, t = this.rows.splice(e, 1)[0];
    t.clear(), this.rows.splice(this.currRow, 0, t), this.logger.log(2, "Rolling up");
  }
  /**
   * Get all non-empty rows with as unicode text.
   */
  getDisplayText(e) {
    e = e || !1;
    const t = [];
    let r = "", s = -1;
    for (let i = 0; i < $r; i++) {
      const o = this.rows[i].getTextString();
      o && (s = i + 1, e ? t.push("Row " + s + ": '" + o + "'") : t.push(o.trim()));
    }
    return t.length > 0 && (e ? r = "[" + t.join(" | ") + "]" : r = t.join(`
`)), r;
  }
  getTextAndFormat() {
    return this.rows;
  }
}
class tf {
  constructor(e, t, r) {
    this.chNr = void 0, this.outputFilter = void 0, this.mode = void 0, this.verbose = void 0, this.displayedMemory = void 0, this.nonDisplayedMemory = void 0, this.lastOutputScreen = void 0, this.currRollUpRow = void 0, this.writeScreen = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chNr = e, this.outputFilter = t, this.mode = null, this.verbose = 0, this.displayedMemory = new $l(r), this.nonDisplayedMemory = new $l(r), this.lastOutputScreen = new $l(r), this.currRollUpRow = this.displayedMemory.rows[$r - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.logger = r;
  }
  reset() {
    this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.outputFilter.reset(), this.currRollUpRow = this.displayedMemory.rows[$r - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
  }
  getHandler() {
    return this.outputFilter;
  }
  setHandler(e) {
    this.outputFilter = e;
  }
  setPAC(e) {
    this.writeScreen.setPAC(e);
  }
  setBkgData(e) {
    this.writeScreen.setBkgData(e);
  }
  setMode(e) {
    e !== this.mode && (this.mode = e, this.logger.log(2, () => "MODE=" + e), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = e);
  }
  insertChars(e) {
    for (let r = 0; r < e.length; r++)
      this.writeScreen.insertChar(e[r]);
    const t = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
    this.logger.log(2, () => t + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (this.logger.log(1, () => "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
  }
  ccRCL() {
    this.logger.log(2, "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
  }
  ccBS() {
    this.logger.log(2, "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
  }
  ccAOF() {
  }
  ccAON() {
  }
  ccDER() {
    this.logger.log(2, "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
  }
  ccRU(e) {
    this.logger.log(2, "RU(" + e + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(e);
  }
  ccFON() {
    this.logger.log(2, "FON - Flash On"), this.writeScreen.setPen({
      flash: !0
    });
  }
  ccRDC() {
    this.logger.log(2, "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
  }
  ccTR() {
    this.logger.log(2, "TR"), this.setMode("MODE_TEXT");
  }
  ccRTD() {
    this.logger.log(2, "RTD"), this.setMode("MODE_TEXT");
  }
  ccEDM() {
    this.logger.log(2, "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
  }
  ccCR() {
    this.logger.log(2, "CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
  }
  ccENM() {
    this.logger.log(2, "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
  }
  ccEOC() {
    if (this.logger.log(2, "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
      const e = this.displayedMemory;
      this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = e, this.writeScreen = this.nonDisplayedMemory, this.logger.log(1, () => "DISP: " + this.displayedMemory.getDisplayText());
    }
    this.outputDataUpdate(!0);
  }
  ccTO(e) {
    this.logger.log(2, "TO(" + e + ") - Tab Offset"), this.writeScreen.moveCursor(e);
  }
  ccMIDROW(e) {
    const t = {
      flash: !1
    };
    if (t.underline = e % 2 === 1, t.italics = e >= 46, t.italics)
      t.foreground = "white";
    else {
      const r = Math.floor(e / 2) - 16, s = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
      t.foreground = s[r];
    }
    this.logger.log(2, "MIDROW: " + mt(t)), this.writeScreen.setPen(t);
  }
  outputDataUpdate(e = !1) {
    const t = this.logger.time;
    t !== null && this.outputFilter && (this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = t : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen), e && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(), this.cueStartTime = this.displayedMemory.isEmpty() ? null : t), this.lastOutputScreen.copy(this.displayedMemory));
  }
  cueSplitAtTime(e) {
    this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, e, this.displayedMemory), this.cueStartTime = e));
  }
}
class rf {
  constructor(e, t, r) {
    this.channels = void 0, this.currentChannel = 0, this.cmdHistory = Uw(), this.logger = void 0;
    const s = this.logger = new Ow();
    this.channels = [null, new tf(e, t, s), new tf(e + 1, r, s)];
  }
  getHandler(e) {
    return this.channels[e].getHandler();
  }
  setHandler(e, t) {
    this.channels[e].setHandler(t);
  }
  /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */
  addData(e, t) {
    this.logger.time = e;
    for (let r = 0; r < t.length; r += 2) {
      const s = t[r] & 127, i = t[r + 1] & 127;
      let o = !1, a = null;
      if (s === 0 && i === 0)
        continue;
      this.logger.log(3, () => "[" + Qn([t[r], t[r + 1]]) + "] -> (" + Qn([s, i]) + ")");
      const l = this.cmdHistory;
      if (s >= 16 && s <= 31) {
        if (Nw(s, i, l)) {
          xo(null, null, l), this.logger.log(3, () => "Repeated command (" + Qn([s, i]) + ") is dropped");
          continue;
        }
        xo(s, i, this.cmdHistory), o = this.parseCmd(s, i), o || (o = this.parseMidrow(s, i)), o || (o = this.parsePAC(s, i)), o || (o = this.parseBackgroundAttributes(s, i));
      } else
        xo(null, null, l);
      if (!o && (a = this.parseChars(s, i), a)) {
        const u = this.currentChannel;
        u && u > 0 ? this.channels[u].insertChars(a) : this.logger.log(2, "No channel found yet. TEXT-MODE?");
      }
      !o && !a && this.logger.log(2, () => "Couldn't parse cleaned data " + Qn([s, i]) + " orig: " + Qn([t[r], t[r + 1]]));
    }
  }
  /**
   * Parse Command.
   * @returns True if a command was found
   */
  parseCmd(e, t) {
    const r = (e === 20 || e === 28 || e === 21 || e === 29) && t >= 32 && t <= 47, s = (e === 23 || e === 31) && t >= 33 && t <= 35;
    if (!(r || s))
      return !1;
    const i = e === 20 || e === 21 || e === 23 ? 1 : 2, o = this.channels[i];
    return e === 20 || e === 21 || e === 28 || e === 29 ? t === 32 ? o.ccRCL() : t === 33 ? o.ccBS() : t === 34 ? o.ccAOF() : t === 35 ? o.ccAON() : t === 36 ? o.ccDER() : t === 37 ? o.ccRU(2) : t === 38 ? o.ccRU(3) : t === 39 ? o.ccRU(4) : t === 40 ? o.ccFON() : t === 41 ? o.ccRDC() : t === 42 ? o.ccTR() : t === 43 ? o.ccRTD() : t === 44 ? o.ccEDM() : t === 45 ? o.ccCR() : t === 46 ? o.ccENM() : t === 47 && o.ccEOC() : o.ccTO(t - 32), this.currentChannel = i, !0;
  }
  /**
   * Parse midrow styling command
   */
  parseMidrow(e, t) {
    let r = 0;
    if ((e === 17 || e === 25) && t >= 32 && t <= 47) {
      if (e === 17 ? r = 1 : r = 2, r !== this.currentChannel)
        return this.logger.log(0, "Mismatch channel in midrow parsing"), !1;
      const s = this.channels[r];
      return s ? (s.ccMIDROW(t), this.logger.log(3, () => "MIDROW (" + Qn([e, t]) + ")"), !0) : !1;
    }
    return !1;
  }
  /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */
  parsePAC(e, t) {
    let r;
    const s = (e >= 17 && e <= 23 || e >= 25 && e <= 31) && t >= 64 && t <= 127, i = (e === 16 || e === 24) && t >= 64 && t <= 95;
    if (!(s || i))
      return !1;
    const o = e <= 23 ? 1 : 2;
    t >= 64 && t <= 95 ? r = o === 1 ? Cw[e] : Dw[e] : r = o === 1 ? kw[e] : Pw[e];
    const a = this.channels[o];
    return a ? (a.setPAC(this.interpretPAC(r, t)), this.currentChannel = o, !0) : !1;
  }
  /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */
  interpretPAC(e, t) {
    let r;
    const s = {
      color: null,
      italics: !1,
      indent: null,
      underline: !1,
      row: e
    };
    return t > 95 ? r = t - 96 : r = t - 64, s.underline = (r & 1) === 1, r <= 13 ? s.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(r / 2)] : r <= 15 ? (s.italics = !0, s.color = "white") : s.indent = Math.floor((r - 16) / 2) * 4, s;
  }
  /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */
  parseChars(e, t) {
    let r, s = null, i = null;
    if (e >= 25 ? (r = 2, i = e - 8) : (r = 1, i = e), i >= 17 && i <= 19) {
      let o;
      i === 17 ? o = t + 80 : i === 18 ? o = t + 112 : o = t + 144, this.logger.log(2, () => "Special char '" + Qp(o) + "' in channel " + r), s = [o];
    } else e >= 32 && e <= 127 && (s = t === 0 ? [e] : [e, t]);
    return s && this.logger.log(3, () => "Char codes =  " + Qn(s).join(",")), s;
  }
  /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */
  parseBackgroundAttributes(e, t) {
    const r = (e === 16 || e === 24) && t >= 32 && t <= 47, s = (e === 23 || e === 31) && t >= 45 && t <= 47;
    if (!(r || s))
      return !1;
    let i;
    const o = {};
    e === 16 || e === 24 ? (i = Math.floor((t - 32) / 2), o.background = Mw[i], t % 2 === 1 && (o.background = o.background + "_semi")) : t === 45 ? o.background = "transparent" : (o.foreground = "black", t === 47 && (o.underline = !0));
    const a = e <= 23 ? 1 : 2;
    return this.channels[a].setBkgData(o), !0;
  }
  /**
   * Reset state of parser and its channels.
   */
  reset() {
    for (let e = 0; e < Object.keys(this.channels).length; e++) {
      const t = this.channels[e];
      t && t.reset();
    }
    xo(null, null, this.cmdHistory);
  }
  /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */
  cueSplitAtTime(e) {
    for (let t = 0; t < this.channels.length; t++) {
      const r = this.channels[t];
      r && r.cueSplitAtTime(e);
    }
  }
}
function xo(n, e, t) {
  t.a = n, t.b = e;
}
function Nw(n, e, t) {
  return t.a === n && t.b === e;
}
function Uw() {
  return {
    a: null,
    b: null
  };
}
var Ju = function() {
  if (Ea != null && Ea.VTTCue)
    return self.VTTCue;
  const n = ["", "lr", "rl"], e = ["start", "middle", "end", "left", "right"];
  function t(a, l) {
    if (typeof l != "string" || !Array.isArray(a))
      return !1;
    const c = l.toLowerCase();
    return ~a.indexOf(c) ? c : !1;
  }
  function r(a) {
    return t(n, a);
  }
  function s(a) {
    return t(e, a);
  }
  function i(a, ...l) {
    let c = 1;
    for (; c < arguments.length; c++) {
      const u = arguments[c];
      for (const d in u)
        a[d] = u[d];
    }
    return a;
  }
  function o(a, l, c) {
    const u = this, d = {
      enumerable: !0
    };
    u.hasBeenReset = !1;
    let h = "", f = !1, p = a, y = l, m = c, b = null, C = "", A = !0, P = "auto", I = "start", U = 50, j = "middle", G = 50, F = "middle";
    Object.defineProperty(u, "id", i({}, d, {
      get: function() {
        return h;
      },
      set: function(B) {
        h = "" + B;
      }
    })), Object.defineProperty(u, "pauseOnExit", i({}, d, {
      get: function() {
        return f;
      },
      set: function(B) {
        f = !!B;
      }
    })), Object.defineProperty(u, "startTime", i({}, d, {
      get: function() {
        return p;
      },
      set: function(B) {
        if (typeof B != "number")
          throw new TypeError("Start time must be set to a number.");
        p = B, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "endTime", i({}, d, {
      get: function() {
        return y;
      },
      set: function(B) {
        if (typeof B != "number")
          throw new TypeError("End time must be set to a number.");
        y = B, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "text", i({}, d, {
      get: function() {
        return m;
      },
      set: function(B) {
        m = "" + B, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "region", i({}, d, {
      get: function() {
        return b;
      },
      set: function(B) {
        b = B, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "vertical", i({}, d, {
      get: function() {
        return C;
      },
      set: function(B) {
        const V = r(B);
        if (V === !1)
          throw new SyntaxError("An invalid or illegal string was specified.");
        C = V, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "snapToLines", i({}, d, {
      get: function() {
        return A;
      },
      set: function(B) {
        A = !!B, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "line", i({}, d, {
      get: function() {
        return P;
      },
      set: function(B) {
        if (typeof B != "number" && B !== "auto")
          throw new SyntaxError("An invalid number or illegal string was specified.");
        P = B, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "lineAlign", i({}, d, {
      get: function() {
        return I;
      },
      set: function(B) {
        const V = s(B);
        if (!V)
          throw new SyntaxError("An invalid or illegal string was specified.");
        I = V, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "position", i({}, d, {
      get: function() {
        return U;
      },
      set: function(B) {
        if (B < 0 || B > 100)
          throw new Error("Position must be between 0 and 100.");
        U = B, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "positionAlign", i({}, d, {
      get: function() {
        return j;
      },
      set: function(B) {
        const V = s(B);
        if (!V)
          throw new SyntaxError("An invalid or illegal string was specified.");
        j = V, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "size", i({}, d, {
      get: function() {
        return G;
      },
      set: function(B) {
        if (B < 0 || B > 100)
          throw new Error("Size must be between 0 and 100.");
        G = B, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "align", i({}, d, {
      get: function() {
        return F;
      },
      set: function(B) {
        const V = s(B);
        if (!V)
          throw new SyntaxError("An invalid or illegal string was specified.");
        F = V, this.hasBeenReset = !0;
      }
    })), u.displayState = void 0;
  }
  return o.prototype.getCueAsHTML = function() {
    return self.WebVTT.convertCueToDOMTree(self, this.text);
  }, o;
}();
class $w {
  decode(e, t) {
    if (!e)
      return "";
    if (typeof e != "string")
      throw new Error("Error - expected string data.");
    return decodeURIComponent(encodeURIComponent(e));
  }
}
function tm(n) {
  function e(r, s, i, o) {
    return (r | 0) * 3600 + (s | 0) * 60 + (i | 0) + parseFloat(o || 0);
  }
  const t = n.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
  return t ? parseFloat(t[2]) > 59 ? e(t[2], t[3], 0, t[4]) : e(t[1], t[2], t[3], t[4]) : null;
}
class Gw {
  constructor() {
    this.values = /* @__PURE__ */ Object.create(null);
  }
  // Only accept the first assignment to any key.
  set(e, t) {
    !this.get(e) && t !== "" && (this.values[e] = t);
  }
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get(e, t, r) {
    return r ? this.has(e) ? this.values[e] : t[r] : this.has(e) ? this.values[e] : t;
  }
  // Check whether we have a value for a key.
  has(e) {
    return e in this.values;
  }
  // Accept a setting if its one of the given alternatives.
  alt(e, t, r) {
    for (let s = 0; s < r.length; ++s)
      if (t === r[s]) {
        this.set(e, t);
        break;
      }
  }
  // Accept a setting if its a valid (signed) integer.
  integer(e, t) {
    /^-?\d+$/.test(t) && this.set(e, parseInt(t, 10));
  }
  // Accept a setting if its a valid percentage.
  percent(e, t) {
    if (/^([\d]{1,3})(\.[\d]*)?%$/.test(t)) {
      const r = parseFloat(t);
      if (r >= 0 && r <= 100)
        return this.set(e, r), !0;
    }
    return !1;
  }
}
function rm(n, e, t, r) {
  const s = r ? n.split(r) : [n];
  for (const i in s) {
    if (typeof s[i] != "string")
      continue;
    const o = s[i].split(t);
    if (o.length !== 2)
      continue;
    const a = o[0], l = o[1];
    e(a, l);
  }
}
const Oc = new Ju(0, 0, ""), Eo = Oc.align === "middle" ? "middle" : "center";
function jw(n, e, t) {
  const r = n;
  function s() {
    const a = tm(n);
    if (a === null)
      throw new Error("Malformed timestamp: " + r);
    return n = n.replace(/^[^\sa-zA-Z-]+/, ""), a;
  }
  function i(a, l) {
    const c = new Gw();
    rm(a, function(h, f) {
      let p;
      switch (h) {
        case "region":
          for (let y = t.length - 1; y >= 0; y--)
            if (t[y].id === f) {
              c.set(h, t[y].region);
              break;
            }
          break;
        case "vertical":
          c.alt(h, f, ["rl", "lr"]);
          break;
        case "line":
          p = f.split(","), c.integer(h, p[0]), c.percent(h, p[0]) && c.set("snapToLines", !1), c.alt(h, p[0], ["auto"]), p.length === 2 && c.alt("lineAlign", p[1], ["start", Eo, "end"]);
          break;
        case "position":
          p = f.split(","), c.percent(h, p[0]), p.length === 2 && c.alt("positionAlign", p[1], ["start", Eo, "end", "line-left", "line-right", "auto"]);
          break;
        case "size":
          c.percent(h, f);
          break;
        case "align":
          c.alt(h, f, ["start", Eo, "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), l.region = c.get("region", null), l.vertical = c.get("vertical", "");
    let u = c.get("line", "auto");
    u === "auto" && Oc.line === -1 && (u = -1), l.line = u, l.lineAlign = c.get("lineAlign", "start"), l.snapToLines = c.get("snapToLines", !0), l.size = c.get("size", 100), l.align = c.get("align", Eo);
    let d = c.get("position", "auto");
    d === "auto" && Oc.position === 50 && (d = l.align === "start" || l.align === "left" ? 0 : l.align === "end" || l.align === "right" ? 100 : 50), l.position = d;
  }
  function o() {
    n = n.replace(/^\s+/, "");
  }
  if (o(), e.startTime = s(), o(), n.slice(0, 3) !== "-->")
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + r);
  n = n.slice(3), o(), e.endTime = s(), o(), i(n, e);
}
function nm(n) {
  return n.replace(/<br(?: \/)?>/gi, `
`);
}
class Vw {
  constructor() {
    this.state = "INITIAL", this.buffer = "", this.decoder = new $w(), this.regionList = [], this.cue = null, this.oncue = void 0, this.onparsingerror = void 0, this.onflush = void 0;
  }
  parse(e) {
    const t = this;
    e && (t.buffer += t.decoder.decode(e, {
      stream: !0
    }));
    function r() {
      let i = t.buffer, o = 0;
      for (i = nm(i); o < i.length && i[o] !== "\r" && i[o] !== `
`; )
        ++o;
      const a = i.slice(0, o);
      return i[o] === "\r" && ++o, i[o] === `
` && ++o, t.buffer = i.slice(o), a;
    }
    function s(i) {
      rm(i, function(o, a) {
      }, /:/);
    }
    try {
      let i = "";
      if (t.state === "INITIAL") {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        i = r();
        const a = i.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
        if (!(a != null && a[0]))
          throw new Error("Malformed WebVTT signature.");
        t.state = "HEADER";
      }
      let o = !1;
      for (; t.buffer; ) {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        switch (o ? o = !1 : i = r(), t.state) {
          case "HEADER":
            /:/.test(i) ? s(i) : i || (t.state = "ID");
            continue;
          case "NOTE":
            i || (t.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(i)) {
              t.state = "NOTE";
              break;
            }
            if (!i)
              continue;
            if (t.cue = new Ju(0, 0, ""), t.state = "CUE", i.indexOf("-->") === -1) {
              t.cue.id = i;
              continue;
            }
          case "CUE":
            if (!t.cue) {
              t.state = "BADCUE";
              continue;
            }
            try {
              jw(i, t.cue, t.regionList);
            } catch {
              t.cue = null, t.state = "BADCUE";
              continue;
            }
            t.state = "CUETEXT";
            continue;
          case "CUETEXT":
            {
              const a = i.indexOf("-->") !== -1;
              if (!i || a && (o = !0)) {
                t.oncue && t.cue && t.oncue(t.cue), t.cue = null, t.state = "ID";
                continue;
              }
              if (t.cue === null)
                continue;
              t.cue.text && (t.cue.text += `
`), t.cue.text += i;
            }
            continue;
          case "BADCUE":
            i || (t.state = "ID");
        }
      }
    } catch {
      t.state === "CUETEXT" && t.cue && t.oncue && t.oncue(t.cue), t.cue = null, t.state = t.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  }
  flush() {
    const e = this;
    try {
      if ((e.cue || e.state === "HEADER") && (e.buffer += `

`, e.parse()), e.state === "INITIAL" || e.state === "BADWEBVTT")
        throw new Error("Malformed WebVTT signature.");
    } catch (t) {
      e.onparsingerror && e.onparsingerror(t);
    }
    return e.onflush && e.onflush(), this;
  }
}
const Kw = /\r\n|\n\r|\n|\r/g, Gl = function(e, t, r = 0) {
  return e.slice(r, r + t.length) === t;
}, Hw = function(e) {
  let t = parseInt(e.slice(-3));
  const r = parseInt(e.slice(-6, -4)), s = parseInt(e.slice(-9, -7)), i = e.length > 9 ? parseInt(e.substring(0, e.indexOf(":"))) : 0;
  if (!ae(t) || !ae(r) || !ae(s) || !ae(i))
    throw Error(`Malformed X-TIMESTAMP-MAP: Local:${e}`);
  return t += 1e3 * r, t += 60 * 1e3 * s, t += 60 * 60 * 1e3 * i, t;
};
function Qu(n, e, t) {
  return vi(n.toString()) + vi(e.toString()) + vi(t);
}
const Ww = function(e, t, r) {
  let s = e[t], i = e[s.prevCC];
  if (!i || !i.new && s.new) {
    e.ccOffset = e.presentationOffset = s.start, s.new = !1;
    return;
  }
  for (; (o = i) != null && o.new; ) {
    var o;
    e.ccOffset += s.start - i.start, s.new = !1, s = i, i = e[s.prevCC];
  }
  e.presentationOffset = r;
};
function qw(n, e, t, r, s, i, o) {
  const a = new Vw(), l = Lr(new Uint8Array(n)).trim().replace(Kw, `
`).split(`
`), c = [], u = e ? l2(e.baseTime, e.timescale) : 0;
  let d = "00:00.000", h = 0, f = 0, p, y = !0;
  a.oncue = function(m) {
    const b = t[r];
    let C = t.ccOffset;
    const A = (h - u) / 9e4;
    if (b != null && b.new && (f !== void 0 ? C = t.ccOffset = b.start : Ww(t, r, A)), A) {
      if (!e) {
        p = new Error("Missing initPTS for VTT MPEGTS");
        return;
      }
      C = A - t.presentationOffset;
    }
    const P = m.endTime - m.startTime, I = Pr((m.startTime + C - f) * 9e4, s * 9e4) / 9e4;
    m.startTime = Math.max(I, 0), m.endTime = Math.max(I + P, 0);
    const U = m.text.trim();
    m.text = decodeURIComponent(encodeURIComponent(U)), m.id || (m.id = Qu(m.startTime, m.endTime, U)), m.endTime > 0 && c.push(m);
  }, a.onparsingerror = function(m) {
    p = m;
  }, a.onflush = function() {
    if (p) {
      o(p);
      return;
    }
    i(c);
  }, l.forEach((m) => {
    if (y)
      if (Gl(m, "X-TIMESTAMP-MAP=")) {
        y = !1, m.slice(16).split(",").forEach((b) => {
          Gl(b, "LOCAL:") ? d = b.slice(6) : Gl(b, "MPEGTS:") && (h = parseInt(b.slice(7)));
        });
        try {
          f = Hw(d) / 1e3;
        } catch (b) {
          p = b;
        }
        return;
      } else m === "" && (y = !1);
    a.parse(m + `
`);
  }), a.flush();
}
const jl = "stpp.ttml.im1t", sm = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, im = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/, zw = {
  left: "start",
  center: "center",
  right: "end",
  start: "start",
  end: "end"
};
function nf(n, e, t, r) {
  const s = Oe(new Uint8Array(n), ["mdat"]);
  if (s.length === 0) {
    r(new Error("Could not parse IMSC1 mdat"));
    return;
  }
  const i = s.map((a) => Lr(a)), o = a2(e.baseTime, 1, e.timescale);
  try {
    i.forEach((a) => t(Yw(a, o)));
  } catch (a) {
    r(a);
  }
}
function Yw(n, e) {
  const s = new DOMParser().parseFromString(n, "text/xml").getElementsByTagName("tt")[0];
  if (!s)
    throw new Error("Invalid ttml");
  const i = {
    frameRate: 30,
    subFrameRate: 1,
    frameRateMultiplier: 0,
    tickRate: 0
  }, o = Object.keys(i).reduce((d, h) => (d[h] = s.getAttribute(`ttp:${h}`) || i[h], d), {}), a = s.getAttribute("xml:space") !== "preserve", l = sf(Vl(s, "styling", "style")), c = sf(Vl(s, "layout", "region")), u = Vl(s, "body", "[begin]");
  return [].map.call(u, (d) => {
    const h = om(d, a);
    if (!h || !d.hasAttribute("begin"))
      return null;
    const f = Hl(d.getAttribute("begin"), o), p = Hl(d.getAttribute("dur"), o);
    let y = Hl(d.getAttribute("end"), o);
    if (f === null)
      throw of(d);
    if (y === null) {
      if (p === null)
        throw of(d);
      y = f + p;
    }
    const m = new Ju(f - e, y - e, h);
    m.id = Qu(m.startTime, m.endTime, m.text);
    const b = c[d.getAttribute("region")], C = l[d.getAttribute("style")], A = Zw(b, C, l), {
      textAlign: P
    } = A;
    if (P) {
      const I = zw[P];
      I && (m.lineAlign = I), m.align = P;
    }
    return st(m, A), m;
  }).filter((d) => d !== null);
}
function Vl(n, e, t) {
  const r = n.getElementsByTagName(e)[0];
  return r ? [].slice.call(r.querySelectorAll(t)) : [];
}
function sf(n) {
  return n.reduce((e, t) => {
    const r = t.getAttribute("xml:id");
    return r && (e[r] = t), e;
  }, {});
}
function om(n, e) {
  return [].slice.call(n.childNodes).reduce((t, r, s) => {
    var i;
    return r.nodeName === "br" && s ? t + `
` : (i = r.childNodes) != null && i.length ? om(r, e) : e ? t + r.textContent.trim().replace(/\s+/g, " ") : t + r.textContent;
  }, "");
}
function Zw(n, e, t) {
  const r = "http://www.w3.org/ns/ttml#styling";
  let s = null;
  const i = [
    "displayAlign",
    "textAlign",
    "color",
    "backgroundColor",
    "fontSize",
    "fontFamily"
    // 'fontWeight',
    // 'lineHeight',
    // 'wrapOption',
    // 'fontStyle',
    // 'direction',
    // 'writingMode'
  ], o = n != null && n.hasAttribute("style") ? n.getAttribute("style") : null;
  return o && t.hasOwnProperty(o) && (s = t[o]), i.reduce((a, l) => {
    const c = Kl(e, r, l) || Kl(n, r, l) || Kl(s, r, l);
    return c && (a[l] = c), a;
  }, {});
}
function Kl(n, e, t) {
  return n && n.hasAttributeNS(e, t) ? n.getAttributeNS(e, t) : null;
}
function of(n) {
  return new Error(`Could not parse ttml timestamp ${n}`);
}
function Hl(n, e) {
  if (!n)
    return null;
  let t = tm(n);
  return t === null && (sm.test(n) ? t = Xw(n, e) : im.test(n) && (t = Jw(n, e))), t;
}
function Xw(n, e) {
  const t = sm.exec(n), r = (t[4] | 0) + (t[5] | 0) / e.subFrameRate;
  return (t[1] | 0) * 3600 + (t[2] | 0) * 60 + (t[3] | 0) + r / e.frameRate;
}
function Jw(n, e) {
  const t = im.exec(n), r = Number(t[1]);
  switch (t[2]) {
    case "h":
      return r * 3600;
    case "m":
      return r * 60;
    case "ms":
      return r * 1e3;
    case "f":
      return r / e.frameRate;
    case "t":
      return r / e.tickRate;
  }
  return r;
}
class So {
  constructor(e, t) {
    this.timelineController = void 0, this.cueRanges = [], this.trackName = void 0, this.startTime = null, this.endTime = null, this.screen = null, this.timelineController = e, this.trackName = t;
  }
  dispatchCue() {
    this.startTime !== null && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges), this.startTime = null);
  }
  newCue(e, t, r) {
    (this.startTime === null || this.startTime > e) && (this.startTime = e), this.endTime = t, this.screen = r, this.timelineController.createCaptionsTrack(this.trackName);
  }
  reset() {
    this.cueRanges = [], this.startTime = null;
  }
}
class Qw {
  constructor(e) {
    this.hls = void 0, this.media = null, this.config = void 0, this.enabled = !0, this.Cues = void 0, this.textTracks = [], this.tracks = [], this.initPTS = [], this.unparsedVttFrags = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.cea608Parser1 = void 0, this.cea608Parser2 = void 0, this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = lf(), this.captionsProperties = void 0, this.hls = e, this.config = e.config, this.Cues = e.config.cueHandler, this.captionsProperties = {
      textTrack1: {
        label: this.config.captionsTextTrack1Label,
        languageCode: this.config.captionsTextTrack1LanguageCode
      },
      textTrack2: {
        label: this.config.captionsTextTrack2Label,
        languageCode: this.config.captionsTextTrack2LanguageCode
      },
      textTrack3: {
        label: this.config.captionsTextTrack3Label,
        languageCode: this.config.captionsTextTrack3LanguageCode
      },
      textTrack4: {
        label: this.config.captionsTextTrack4Label,
        languageCode: this.config.captionsTextTrack4LanguageCode
      }
    }, e.on(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(T.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(T.FRAG_LOADING, this.onFragLoading, this), e.on(T.FRAG_LOADED, this.onFragLoaded, this), e.on(T.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.on(T.FRAG_DECRYPTED, this.onFragDecrypted, this), e.on(T.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(T.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.on(T.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  destroy() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(T.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(T.FRAG_LOADING, this.onFragLoading, this), e.off(T.FRAG_LOADED, this.onFragLoaded, this), e.off(T.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.off(T.FRAG_DECRYPTED, this.onFragDecrypted, this), e.off(T.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(T.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.off(T.BUFFER_FLUSHING, this.onBufferFlushing, this), this.hls = this.config = this.media = null, this.cea608Parser1 = this.cea608Parser2 = void 0;
  }
  initCea608Parsers() {
    const e = new So(this, "textTrack1"), t = new So(this, "textTrack2"), r = new So(this, "textTrack3"), s = new So(this, "textTrack4");
    this.cea608Parser1 = new rf(1, e, t), this.cea608Parser2 = new rf(3, r, s);
  }
  addCues(e, t, r, s, i) {
    let o = !1;
    for (let a = i.length; a--; ) {
      const l = i[a], c = eA(l[0], l[1], t, r);
      if (c >= 0 && (l[0] = Math.min(l[0], t), l[1] = Math.max(l[1], r), o = !0, c / (r - t) > 0.5))
        return;
    }
    if (o || i.push([t, r]), this.config.renderTextTracksNatively) {
      const a = this.captionsTracks[e];
      this.Cues.newCue(a, t, r, s);
    } else {
      const a = this.Cues.newCue(null, t, r, s);
      this.hls.trigger(T.CUES_PARSED, {
        type: "captions",
        cues: a,
        track: e
      });
    }
  }
  // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
  onInitPtsFound(e, {
    frag: t,
    id: r,
    initPTS: s,
    timescale: i
  }) {
    const {
      unparsedVttFrags: o
    } = this;
    r === he.MAIN && (this.initPTS[t.cc] = {
      baseTime: s,
      timescale: i
    }), o.length && (this.unparsedVttFrags = [], o.forEach((a) => {
      this.onFragLoaded(T.FRAG_LOADED, a);
    }));
  }
  getExistingTrack(e, t) {
    const {
      media: r
    } = this;
    if (r)
      for (let s = 0; s < r.textTracks.length; s++) {
        const i = r.textTracks[s];
        if (af(i, {
          name: e,
          lang: t,
          characteristics: "transcribes-spoken-dialog,describes-music-and-sound"
        }))
          return i;
      }
    return null;
  }
  createCaptionsTrack(e) {
    this.config.renderTextTracksNatively ? this.createNativeTrack(e) : this.createNonNativeTrack(e);
  }
  createNativeTrack(e) {
    if (this.captionsTracks[e])
      return;
    const {
      captionsProperties: t,
      captionsTracks: r,
      media: s
    } = this, {
      label: i,
      languageCode: o
    } = t[e], a = this.getExistingTrack(i, o);
    if (a)
      r[e] = a, Ns(r[e]), Zp(r[e], s);
    else {
      const l = this.createTextTrack("captions", i, o);
      l && (l[e] = !0, r[e] = l);
    }
  }
  createNonNativeTrack(e) {
    if (this.nonNativeCaptionsTracks[e])
      return;
    const t = this.captionsProperties[e];
    if (!t)
      return;
    const r = t.label, s = {
      _id: e,
      label: r,
      kind: "captions",
      default: t.media ? !!t.media.default : !1,
      closedCaptions: t.media
    };
    this.nonNativeCaptionsTracks[e] = s, this.hls.trigger(T.NON_NATIVE_TEXT_TRACKS_FOUND, {
      tracks: [s]
    });
  }
  createTextTrack(e, t, r) {
    const s = this.media;
    if (s)
      return s.addTextTrack(e, t, r);
  }
  onMediaAttaching(e, t) {
    this.media = t.media, t.mediaSource || this._cleanTracks();
  }
  onMediaDetaching(e, t) {
    const r = !!t.transferMedia;
    if (this.media = null, r)
      return;
    const {
      captionsTracks: s
    } = this;
    Object.keys(s).forEach((i) => {
      Ns(s[i]), delete s[i];
    }), this.nonNativeCaptionsTracks = {};
  }
  onManifestLoading() {
    this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = lf(), this._cleanTracks(), this.tracks = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.textTracks = [], this.unparsedVttFrags = [], this.initPTS = [], this.cea608Parser1 && this.cea608Parser2 && (this.cea608Parser1.reset(), this.cea608Parser2.reset());
  }
  _cleanTracks() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.textTracks;
    if (t)
      for (let r = 0; r < t.length; r++)
        Ns(t[r]);
  }
  onSubtitleTracksUpdated(e, t) {
    const r = t.subtitleTracks || [], s = r.some((i) => i.textCodec === jl);
    if (this.config.enableWebVTT || s && this.config.enableIMSC1) {
      if (jp(this.tracks, r)) {
        this.tracks = r;
        return;
      }
      if (this.textTracks = [], this.tracks = r, this.config.renderTextTracksNatively) {
        const o = this.media, a = o ? Oo(o.textTracks) : null;
        if (this.tracks.forEach((l, c) => {
          let u;
          if (a) {
            let d = null;
            for (let h = 0; h < a.length; h++)
              if (a[h] && af(a[h], l)) {
                d = a[h], a[h] = null;
                break;
              }
            d && (u = d);
          }
          if (u)
            Ns(u);
          else {
            const d = am(l);
            u = this.createTextTrack(d, l.name, l.lang), u && (u.mode = "disabled");
          }
          u && this.textTracks.push(u);
        }), a != null && a.length) {
          const l = a.filter((c) => c !== null).map((c) => c.label);
          l.length && this.hls.logger.warn(`Media element contains unused subtitle tracks: ${l.join(", ")}. Replace media element for each source to clear TextTracks and captions menu.`);
        }
      } else if (this.tracks.length) {
        const o = this.tracks.map((a) => ({
          label: a.name,
          kind: a.type.toLowerCase(),
          default: a.default,
          subtitleTrack: a
        }));
        this.hls.trigger(T.NON_NATIVE_TEXT_TRACKS_FOUND, {
          tracks: o
        });
      }
    }
  }
  onManifestLoaded(e, t) {
    this.config.enableCEA708Captions && t.captions && t.captions.forEach((r) => {
      const s = /(?:CC|SERVICE)([1-4])/.exec(r.instreamId);
      if (!s)
        return;
      const i = `textTrack${s[1]}`, o = this.captionsProperties[i];
      o && (o.label = r.name, r.lang && (o.languageCode = r.lang), o.media = r);
    });
  }
  closedCaptionsForLevel(e) {
    const t = this.hls.levels[e.level];
    return t == null ? void 0 : t.attrs["CLOSED-CAPTIONS"];
  }
  onFragLoading(e, t) {
    if (this.enabled && t.frag.type === he.MAIN) {
      var r, s;
      const {
        cea608Parser1: i,
        cea608Parser2: o,
        lastSn: a
      } = this, {
        cc: l,
        sn: c
      } = t.frag, u = (r = (s = t.part) == null ? void 0 : s.index) != null ? r : -1;
      i && o && (c !== a + 1 || c === a && u !== this.lastPartIndex + 1 || l !== this.lastCc) && (i.reset(), o.reset()), this.lastCc = l, this.lastSn = c, this.lastPartIndex = u;
    }
  }
  onFragLoaded(e, t) {
    const {
      frag: r,
      payload: s
    } = t;
    if (r.type === he.SUBTITLE)
      if (s.byteLength) {
        const i = r.decryptdata, o = "stats" in t;
        if (i == null || !i.encrypted || o) {
          const a = this.tracks[r.level], l = this.vttCCs;
          l[r.cc] || (l[r.cc] = {
            start: r.start,
            prevCC: this.prevCC,
            new: !0
          }, this.prevCC = r.cc), a && a.textCodec === jl ? this._parseIMSC1(r, s) : this._parseVTTs(t);
        }
      } else
        this.hls.trigger(T.SUBTITLE_FRAG_PROCESSED, {
          success: !1,
          frag: r,
          error: new Error("Empty subtitle payload")
        });
  }
  _parseIMSC1(e, t) {
    const r = this.hls;
    nf(t, this.initPTS[e.cc], (s) => {
      this._appendCues(s, e.level), r.trigger(T.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: e
      });
    }, (s) => {
      r.logger.log(`Failed to parse IMSC1: ${s}`), r.trigger(T.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: e,
        error: s
      });
    });
  }
  _parseVTTs(e) {
    var t;
    const {
      frag: r,
      payload: s
    } = e, {
      initPTS: i,
      unparsedVttFrags: o
    } = this, a = i.length - 1;
    if (!i[r.cc] && a === -1) {
      o.push(e);
      return;
    }
    const l = this.hls, c = (t = r.initSegment) != null && t.data ? Nr(r.initSegment.data, new Uint8Array(s)).buffer : s;
    qw(c, this.initPTS[r.cc], this.vttCCs, r.cc, r.start, (u) => {
      this._appendCues(u, r.level), l.trigger(T.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: r
      });
    }, (u) => {
      const d = u.message === "Missing initPTS for VTT MPEGTS";
      d ? o.push(e) : this._fallbackToIMSC1(r, s), l.logger.log(`Failed to parse VTT cue: ${u}`), !(d && a > r.cc) && l.trigger(T.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: r,
        error: u
      });
    });
  }
  _fallbackToIMSC1(e, t) {
    const r = this.tracks[e.level];
    r.textCodec || nf(t, this.initPTS[e.cc], () => {
      r.textCodec = jl, this._parseIMSC1(e, t);
    }, () => {
      r.textCodec = "wvtt";
    });
  }
  _appendCues(e, t) {
    const r = this.hls;
    if (this.config.renderTextTracksNatively) {
      const s = this.textTracks[t];
      if (!s || s.mode === "disabled")
        return;
      e.forEach((i) => Xp(s, i));
    } else {
      const s = this.tracks[t];
      if (!s)
        return;
      const i = s.default ? "default" : "subtitles" + t;
      r.trigger(T.CUES_PARSED, {
        type: "subtitles",
        cues: e,
        track: i
      });
    }
  }
  onFragDecrypted(e, t) {
    const {
      frag: r
    } = t;
    r.type === he.SUBTITLE && this.onFragLoaded(T.FRAG_LOADED, t);
  }
  onSubtitleTracksCleared() {
    this.tracks = [], this.captionsTracks = {};
  }
  onFragParsingUserdata(e, t) {
    if (!this.enabled || !this.config.enableCEA708Captions)
      return;
    const {
      frag: r,
      samples: s
    } = t;
    if (!(r.type === he.MAIN && this.closedCaptionsForLevel(r) === "NONE"))
      for (let i = 0; i < s.length; i++) {
        const o = s[i].bytes;
        if (o) {
          this.cea608Parser1 || this.initCea608Parsers();
          const a = this.extractCea608Data(o);
          this.cea608Parser1.addData(s[i].pts, a[0]), this.cea608Parser2.addData(s[i].pts, a[1]);
        }
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: r,
    endOffsetSubtitles: s,
    type: i
  }) {
    const {
      media: o
    } = this;
    if (!(!o || o.currentTime < r)) {
      if (!i || i === "video") {
        const {
          captionsTracks: a
        } = this;
        Object.keys(a).forEach((l) => Mc(a[l], t, r));
      }
      if (this.config.renderTextTracksNatively && t === 0 && s !== void 0) {
        const {
          textTracks: a
        } = this;
        Object.keys(a).forEach((l) => Mc(a[l], t, s));
      }
    }
  }
  extractCea608Data(e) {
    const t = [[], []], r = e[0] & 31;
    let s = 2;
    for (let i = 0; i < r; i++) {
      const o = e[s++], a = 127 & e[s++], l = 127 & e[s++];
      if (a === 0 && l === 0)
        continue;
      if ((4 & o) !== 0) {
        const u = 3 & o;
        (u === 0 || u === 1) && (t[u].push(a), t[u].push(l));
      }
    }
    return t;
  }
}
function am(n) {
  return n.characteristics && /transcribes-spoken-dialog/gi.test(n.characteristics) && /describes-music-and-sound/gi.test(n.characteristics) ? "captions" : "subtitles";
}
function af(n, e) {
  return !!n && n.kind === am(e) && kc(e, n);
}
function eA(n, e, t, r) {
  return Math.min(e, r) - Math.max(n, t);
}
function lf() {
  return {
    ccOffset: 0,
    presentationOffset: 0,
    0: {
      start: 0,
      prevCC: -1,
      new: !0
    }
  };
}
const tA = /\s/, rA = {
  newCue(n, e, t, r) {
    const s = [];
    let i, o, a, l, c;
    const u = self.VTTCue || self.TextTrackCue;
    for (let h = 0; h < r.rows.length; h++)
      if (i = r.rows[h], a = !0, l = 0, c = "", !i.isEmpty()) {
        var d;
        for (let y = 0; y < i.chars.length; y++)
          tA.test(i.chars[y].uchar) && a ? l++ : (c += i.chars[y].uchar, a = !1);
        i.cueStartTime = e, e === t && (t += 1e-4), l >= 16 ? l-- : l++;
        const f = nm(c.trim()), p = Qu(e, t, f);
        n != null && (d = n.cues) != null && d.getCueById(p) || (o = new u(e, t, f), o.id = p, o.line = h + 1, o.align = "left", o.position = 10 + Math.min(80, Math.floor(l * 8 / 32) * 10), s.push(o));
      }
    return n && s.length && (s.sort((h, f) => h.line === "auto" || f.line === "auto" ? 0 : h.line > 8 && f.line > 8 ? f.line - h.line : h.line - f.line), s.forEach((h) => Xp(n, h))), s;
  }
};
function nA() {
  if (
    // @ts-ignore
    self.fetch && self.AbortController && self.ReadableStream && self.Request
  )
    try {
      return new self.ReadableStream({}), !0;
    } catch {
    }
  return !1;
}
const sA = /(\d+)-(\d+)\/(\d+)/;
class cf {
  constructor(e) {
    this.fetchSetup = void 0, this.requestTimeout = void 0, this.request = null, this.response = null, this.controller = void 0, this.context = null, this.config = null, this.callbacks = null, this.stats = void 0, this.loader = null, this.fetchSetup = e.fetchSetup || lA, this.controller = new self.AbortController(), this.stats = new Mu();
  }
  destroy() {
    this.loader = this.callbacks = this.context = this.config = this.request = null, this.abortInternal(), this.response = null, this.fetchSetup = this.controller = this.stats = null;
  }
  abortInternal() {
    this.controller && !this.stats.loading.end && (this.stats.aborted = !0, this.controller.abort());
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.response);
  }
  load(e, t, r) {
    const s = this.stats;
    if (s.loading.start)
      throw new Error("Loader can only be used once.");
    s.loading.start = self.performance.now();
    const i = iA(e, this.controller.signal), o = e.responseType === "arraybuffer", a = o ? "byteLength" : "length", {
      maxTimeToFirstByteMs: l,
      maxLoadTimeMs: c
    } = t.loadPolicy;
    this.context = e, this.config = t, this.callbacks = r, this.request = this.fetchSetup(e, i), self.clearTimeout(this.requestTimeout), t.timeout = l && ae(l) ? l : c, this.requestTimeout = self.setTimeout(() => {
      this.callbacks && (this.abortInternal(), this.callbacks.onTimeout(s, e, this.response));
    }, t.timeout), (Gi(this.request) ? this.request.then(self.fetch) : self.fetch(this.request)).then((d) => {
      var h;
      this.response = this.loader = d;
      const f = Math.max(self.performance.now(), s.loading.start);
      if (self.clearTimeout(this.requestTimeout), t.timeout = c, this.requestTimeout = self.setTimeout(() => {
        this.callbacks && (this.abortInternal(), this.callbacks.onTimeout(s, e, this.response));
      }, c - (f - s.loading.start)), !d.ok) {
        const {
          status: y,
          statusText: m
        } = d;
        throw new cA(m || "fetch, bad network response", y, d);
      }
      s.loading.first = f, s.total = aA(d.headers) || s.total;
      const p = (h = this.callbacks) == null ? void 0 : h.onProgress;
      return p && ae(t.highWaterMark) ? this.loadProgressively(d, s, e, t.highWaterMark, p) : o ? d.arrayBuffer() : e.responseType === "json" ? d.json() : d.text();
    }).then((d) => {
      var h, f;
      const p = this.response;
      if (!p)
        throw new Error("loader destroyed");
      self.clearTimeout(this.requestTimeout), s.loading.end = Math.max(self.performance.now(), s.loading.first);
      const y = d[a];
      y && (s.loaded = s.total = y);
      const m = {
        url: p.url,
        data: d,
        code: p.status
      }, b = (h = this.callbacks) == null ? void 0 : h.onProgress;
      b && !ae(t.highWaterMark) && b(s, e, d, p), (f = this.callbacks) == null || f.onSuccess(m, s, e, p);
    }).catch((d) => {
      var h;
      if (self.clearTimeout(this.requestTimeout), s.aborted)
        return;
      const f = d && d.code || 0, p = d ? d.message : null;
      (h = this.callbacks) == null || h.onError({
        code: f,
        text: p
      }, e, d ? d.details : null, s);
    });
  }
  getCacheAge() {
    let e = null;
    if (this.response) {
      const t = this.response.headers.get("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.response ? this.response.headers.get(e) : null;
  }
  loadProgressively(e, t, r, s = 0, i) {
    const o = new bp(), a = e.body.getReader(), l = () => a.read().then((c) => {
      if (c.done)
        return o.dataLength && i(t, r, o.flush().buffer, e), Promise.resolve(new ArrayBuffer(0));
      const u = c.value, d = u.length;
      return t.loaded += d, d < s || o.dataLength ? (o.push(u), o.dataLength >= s && i(t, r, o.flush().buffer, e)) : i(t, r, u.buffer, e), l();
    }).catch(() => Promise.reject());
    return l();
  }
}
function iA(n, e) {
  const t = {
    method: "GET",
    mode: "cors",
    credentials: "same-origin",
    signal: e,
    headers: new self.Headers(st({}, n.headers))
  };
  return n.rangeEnd && t.headers.set("Range", "bytes=" + n.rangeStart + "-" + String(n.rangeEnd - 1)), t;
}
function oA(n) {
  const e = sA.exec(n);
  if (e)
    return parseInt(e[2]) - parseInt(e[1]) + 1;
}
function aA(n) {
  const e = n.get("Content-Range");
  if (e) {
    const r = oA(e);
    if (ae(r))
      return r;
  }
  const t = n.get("Content-Length");
  if (t)
    return parseInt(t);
}
function lA(n, e) {
  return new self.Request(n.url, e);
}
class cA extends Error {
  constructor(e, t, r) {
    super(e), this.code = void 0, this.details = void 0, this.code = t, this.details = r;
  }
}
const uA = /^age:\s*[\d.]+\s*$/im;
class lm {
  constructor(e) {
    this.xhrSetup = void 0, this.requestTimeout = void 0, this.retryTimeout = void 0, this.retryDelay = void 0, this.config = null, this.callbacks = null, this.context = null, this.loader = null, this.stats = void 0, this.xhrSetup = e && e.xhrSetup || null, this.stats = new Mu(), this.retryDelay = 0;
  }
  destroy() {
    this.callbacks = null, this.abortInternal(), this.loader = null, this.config = null, this.context = null, this.xhrSetup = null;
  }
  abortInternal() {
    const e = this.loader;
    self.clearTimeout(this.requestTimeout), self.clearTimeout(this.retryTimeout), e && (e.onreadystatechange = null, e.onprogress = null, e.readyState !== 4 && (this.stats.aborted = !0, e.abort()));
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.loader);
  }
  load(e, t, r) {
    if (this.stats.loading.start)
      throw new Error("Loader can only be used once.");
    this.stats.loading.start = self.performance.now(), this.context = e, this.config = t, this.callbacks = r, this.loadInternal();
  }
  loadInternal() {
    const {
      config: e,
      context: t
    } = this;
    if (!e || !t)
      return;
    const r = this.loader = new self.XMLHttpRequest(), s = this.stats;
    s.loading.first = 0, s.loaded = 0, s.aborted = !1;
    const i = this.xhrSetup;
    i ? Promise.resolve().then(() => {
      if (!(this.loader !== r || this.stats.aborted))
        return i(r, t.url);
    }).catch((o) => {
      if (!(this.loader !== r || this.stats.aborted))
        return r.open("GET", t.url, !0), i(r, t.url);
    }).then(() => {
      this.loader !== r || this.stats.aborted || this.openAndSendXhr(r, t, e);
    }).catch((o) => {
      var a;
      (a = this.callbacks) == null || a.onError({
        code: r.status,
        text: o.message
      }, t, r, s);
    }) : this.openAndSendXhr(r, t, e);
  }
  openAndSendXhr(e, t, r) {
    e.readyState || e.open("GET", t.url, !0);
    const s = t.headers, {
      maxTimeToFirstByteMs: i,
      maxLoadTimeMs: o
    } = r.loadPolicy;
    if (s)
      for (const a in s)
        e.setRequestHeader(a, s[a]);
    t.rangeEnd && e.setRequestHeader("Range", "bytes=" + t.rangeStart + "-" + (t.rangeEnd - 1)), e.onreadystatechange = this.readystatechange.bind(this), e.onprogress = this.loadprogress.bind(this), e.responseType = t.responseType, self.clearTimeout(this.requestTimeout), r.timeout = i && ae(i) ? i : o, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), r.timeout), e.send();
  }
  readystatechange() {
    const {
      context: e,
      loader: t,
      stats: r
    } = this;
    if (!e || !t)
      return;
    const s = t.readyState, i = this.config;
    if (!r.aborted && s >= 2 && (r.loading.first === 0 && (r.loading.first = Math.max(self.performance.now(), r.loading.start), i.timeout !== i.loadPolicy.maxLoadTimeMs && (self.clearTimeout(this.requestTimeout), i.timeout = i.loadPolicy.maxLoadTimeMs, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), i.loadPolicy.maxLoadTimeMs - (r.loading.first - r.loading.start)))), s === 4)) {
      self.clearTimeout(this.requestTimeout), t.onreadystatechange = null, t.onprogress = null;
      const c = t.status, u = t.responseType === "text" ? t.responseText : null;
      if (c >= 200 && c < 300) {
        const p = u ?? t.response;
        if (p != null) {
          var o, a;
          r.loading.end = Math.max(self.performance.now(), r.loading.first);
          const y = t.responseType === "arraybuffer" ? p.byteLength : p.length;
          r.loaded = r.total = y, r.bwEstimate = r.total * 8e3 / (r.loading.end - r.loading.first);
          const m = (o = this.callbacks) == null ? void 0 : o.onProgress;
          m && m(r, e, p, t);
          const b = {
            url: t.responseURL,
            data: p,
            code: c
          };
          (a = this.callbacks) == null || a.onSuccess(b, r, e, t);
          return;
        }
      }
      const d = i.loadPolicy.errorRetry, h = r.retry, f = {
        url: e.url,
        data: void 0,
        code: c
      };
      if (xa(d, h, !1, f))
        this.retry(d);
      else {
        var l;
        Ze.error(`${c} while loading ${e.url}`), (l = this.callbacks) == null || l.onError({
          code: c,
          text: t.statusText
        }, e, t, r);
      }
    }
  }
  loadtimeout() {
    if (!this.config) return;
    const e = this.config.loadPolicy.timeoutRetry, t = this.stats.retry;
    if (xa(e, t, !0))
      this.retry(e);
    else {
      var r;
      Ze.warn(`timeout while loading ${(r = this.context) == null ? void 0 : r.url}`);
      const s = this.callbacks;
      s && (this.abortInternal(), s.onTimeout(this.stats, this.context, this.loader));
    }
  }
  retry(e) {
    const {
      context: t,
      stats: r
    } = this;
    this.retryDelay = Bu(e, r.retry), r.retry++, Ze.warn(`${status ? "HTTP Status " + status : "Timeout"} while loading ${t == null ? void 0 : t.url}, retrying ${r.retry}/${e.maxNumRetry} in ${this.retryDelay}ms`), this.abortInternal(), this.loader = null, self.clearTimeout(this.retryTimeout), this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
  }
  loadprogress(e) {
    const t = this.stats;
    t.loaded = e.loaded, e.lengthComputable && (t.total = e.total);
  }
  getCacheAge() {
    let e = null;
    if (this.loader && uA.test(this.loader.getAllResponseHeaders())) {
      const t = this.loader.getResponseHeader("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.loader && new RegExp(`^${e}:\\s*[\\d.]+\\s*$`, "im").test(this.loader.getAllResponseHeaders()) ? this.loader.getResponseHeader(e) : null;
  }
}
const dA = {
  maxTimeToFirstByteMs: 8e3,
  maxLoadTimeMs: 2e4,
  timeoutRetry: null,
  errorRetry: null
}, hA = rt(rt({
  autoStartLoad: !0,
  // used by stream-controller
  startPosition: -1,
  // used by stream-controller
  defaultAudioCodec: void 0,
  // used by stream-controller
  debug: !1,
  // used by logger
  capLevelOnFPSDrop: !1,
  // used by fps-controller
  capLevelToPlayerSize: !1,
  // used by cap-level-controller
  ignoreDevicePixelRatio: !1,
  // used by cap-level-controller
  maxDevicePixelRatio: Number.POSITIVE_INFINITY,
  // used by cap-level-controller
  preferManagedMediaSource: !0,
  initialLiveManifestSize: 1,
  // used by stream-controller
  maxBufferLength: 30,
  // used by stream-controller
  backBufferLength: 1 / 0,
  // used by buffer-controller
  frontBufferFlushThreshold: 1 / 0,
  startOnSegmentBoundary: !1,
  // used by stream-controller
  maxBufferSize: 60 * 1e3 * 1e3,
  // used by stream-controller
  maxFragLookUpTolerance: 0.25,
  // used by stream-controller
  maxBufferHole: 0.1,
  // used by stream-controller and gap-controller
  detectStallWithCurrentTimeMs: 1250,
  // used by gap-controller
  highBufferWatchdogPeriod: 2,
  // used by gap-controller
  nudgeOffset: 0.1,
  // used by gap-controller
  nudgeMaxRetry: 3,
  // used by gap-controller
  nudgeOnVideoHole: !0,
  // used by gap-controller
  liveSyncMode: "edge",
  // used by stream-controller
  liveSyncDurationCount: 3,
  // used by latency-controller
  liveSyncOnStallIncrease: 1,
  // used by latency-controller
  liveMaxLatencyDurationCount: 1 / 0,
  // used by latency-controller
  liveSyncDuration: void 0,
  // used by latency-controller
  liveMaxLatencyDuration: void 0,
  // used by latency-controller
  maxLiveSyncPlaybackRate: 1,
  // used by latency-controller
  liveDurationInfinity: !1,
  // used by buffer-controller
  /**
   * @deprecated use backBufferLength
   */
  liveBackBufferLength: null,
  // used by buffer-controller
  maxMaxBufferLength: 600,
  // used by stream-controller
  enableWorker: !0,
  // used by transmuxer
  workerPath: null,
  // used by transmuxer
  enableSoftwareAES: !0,
  // used by decrypter
  startLevel: void 0,
  // used by level-controller
  startFragPrefetch: !1,
  // used by stream-controller
  fpsDroppedMonitoringPeriod: 5e3,
  // used by fps-controller
  fpsDroppedMonitoringThreshold: 0.2,
  // used by fps-controller
  appendErrorMaxRetry: 3,
  // used by buffer-controller
  ignorePlaylistParsingErrors: !1,
  loader: lm,
  // loader: FetchLoader,
  fLoader: void 0,
  // used by fragment-loader
  pLoader: void 0,
  // used by playlist-loader
  xhrSetup: void 0,
  // used by xhr-loader
  licenseXhrSetup: void 0,
  // used by eme-controller
  licenseResponseCallback: void 0,
  // used by eme-controller
  abrController: Ob,
  bufferController: T2,
  capLevelController: Zu,
  errorController: $b,
  fpsController: pw,
  stretchShortVideoTrack: !1,
  // used by mp4-remuxer
  maxAudioFramesDrift: 1,
  // used by mp4-remuxer
  forceKeyFrameOnDiscontinuity: !0,
  // used by ts-demuxer
  abrEwmaFastLive: 3,
  // used by abr-controller
  abrEwmaSlowLive: 9,
  // used by abr-controller
  abrEwmaFastVoD: 3,
  // used by abr-controller
  abrEwmaSlowVoD: 9,
  // used by abr-controller
  abrEwmaDefaultEstimate: 5e5,
  // 500 kbps  // used by abr-controller
  abrEwmaDefaultEstimateMax: 5e6,
  // 5 mbps
  abrBandWidthFactor: 0.95,
  // used by abr-controller
  abrBandWidthUpFactor: 0.7,
  // used by abr-controller
  abrMaxWithRealBitrate: !1,
  // used by abr-controller
  maxStarvationDelay: 4,
  // used by abr-controller
  maxLoadingDelay: 4,
  // used by abr-controller
  minAutoBitrate: 0,
  // used by hls
  emeEnabled: !1,
  // used by eme-controller
  widevineLicenseUrl: void 0,
  // used by eme-controller
  drmSystems: {},
  // used by eme-controller
  drmSystemOptions: {},
  // used by eme-controller
  requestMediaKeySystemAccessFunc: dp,
  // used by eme-controller
  requireKeySystemAccessOnStart: !1,
  // used by eme-controller
  testBandwidth: !0,
  progressive: !1,
  lowLatencyMode: !0,
  cmcd: void 0,
  enableDateRangeMetadataCues: !0,
  enableEmsgMetadataCues: !0,
  enableEmsgKLVMetadata: !1,
  enableID3MetadataCues: !0,
  enableInterstitialPlayback: !0,
  interstitialAppendInPlace: !0,
  interstitialLiveLookAhead: 10,
  useMediaCapabilities: !0,
  preserveManualLevelOnError: !1,
  certLoadPolicy: {
    default: dA
  },
  keyLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 8e3,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      },
      errorRetry: {
        maxNumRetry: 8,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      }
    }
  },
  manifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1 / 0,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  playlistLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 2,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  fragLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 12e4,
      timeoutRetry: {
        maxNumRetry: 4,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 6,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  steeringManifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  interstitialAssetListLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 3e4,
      timeoutRetry: {
        maxNumRetry: 0,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 0,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  // These default settings are deprecated in favor of the above policies
  // and are maintained for backwards compatibility
  manifestLoadingTimeOut: 1e4,
  manifestLoadingMaxRetry: 1,
  manifestLoadingRetryDelay: 1e3,
  manifestLoadingMaxRetryTimeout: 64e3,
  levelLoadingTimeOut: 1e4,
  levelLoadingMaxRetry: 4,
  levelLoadingRetryDelay: 1e3,
  levelLoadingMaxRetryTimeout: 64e3,
  fragLoadingTimeOut: 2e4,
  fragLoadingMaxRetry: 6,
  fragLoadingRetryDelay: 1e3,
  fragLoadingMaxRetryTimeout: 64e3
}, fA()), {}, {
  subtitleStreamController: _w,
  subtitleTrackController: vw,
  timelineController: Qw,
  audioStreamController: x2,
  audioTrackController: E2,
  emeController: js,
  cmcdController: hw,
  contentSteeringController: gw,
  interstitialsController: Iw
});
function fA() {
  return {
    cueHandler: rA,
    // used by timeline-controller
    enableWebVTT: !0,
    // used by timeline-controller
    enableIMSC1: !0,
    // used by timeline-controller
    enableCEA708Captions: !0,
    // used by timeline-controller
    captionsTextTrack1Label: "English",
    // used by timeline-controller
    captionsTextTrack1LanguageCode: "en",
    // used by timeline-controller
    captionsTextTrack2Label: "Spanish",
    // used by timeline-controller
    captionsTextTrack2LanguageCode: "es",
    // used by timeline-controller
    captionsTextTrack3Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack3LanguageCode: "",
    // used by timeline-controller
    captionsTextTrack4Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack4LanguageCode: "",
    // used by timeline-controller
    renderTextTracksNatively: !0
  };
}
function gA(n, e, t) {
  if ((e.liveSyncDurationCount || e.liveMaxLatencyDurationCount) && (e.liveSyncDuration || e.liveMaxLatencyDuration))
    throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
  if (e.liveMaxLatencyDurationCount !== void 0 && (e.liveSyncDurationCount === void 0 || e.liveMaxLatencyDurationCount <= e.liveSyncDurationCount))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
  if (e.liveMaxLatencyDuration !== void 0 && (e.liveSyncDuration === void 0 || e.liveMaxLatencyDuration <= e.liveSyncDuration))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
  const r = Bc(n), s = ["manifest", "level", "frag"], i = ["TimeOut", "MaxRetry", "RetryDelay", "MaxRetryTimeout"];
  return s.forEach((o) => {
    const a = `${o === "level" ? "playlist" : o}LoadPolicy`, l = e[a] === void 0, c = [];
    i.forEach((u) => {
      const d = `${o}Loading${u}`, h = e[d];
      if (h !== void 0 && l) {
        c.push(d);
        const f = r[a].default;
        switch (e[a] = {
          default: f
        }, u) {
          case "TimeOut":
            f.maxLoadTimeMs = h, f.maxTimeToFirstByteMs = h;
            break;
          case "MaxRetry":
            f.errorRetry.maxNumRetry = h, f.timeoutRetry.maxNumRetry = h;
            break;
          case "RetryDelay":
            f.errorRetry.retryDelayMs = h, f.timeoutRetry.retryDelayMs = h;
            break;
          case "MaxRetryTimeout":
            f.errorRetry.maxRetryDelayMs = h, f.timeoutRetry.maxRetryDelayMs = h;
            break;
        }
      }
    }), c.length && t.warn(`hls.js config: "${c.join('", "')}" setting(s) are deprecated, use "${a}": ${mt(e[a])}`);
  }), rt(rt({}, r), e);
}
function Bc(n) {
  return n && typeof n == "object" ? Array.isArray(n) ? n.map(Bc) : Object.keys(n).reduce((e, t) => (e[t] = Bc(n[t]), e), {}) : n;
}
function pA(n, e) {
  const t = n.loader;
  t !== cf && t !== lm ? (e.log("[config]: Custom loader detected, cannot enable progressive streaming"), n.progressive = !1) : nA() && (n.loader = cf, n.progressive = !0, n.enableSoftwareAES = !0, e.log("[config]: Progressive streaming enabled, using FetchLoader"));
}
const Bo = 2, mA = 0.1, yA = 0.05, vA = 100;
class xA extends lp {
  constructor(e, t) {
    super("gap-controller", e.logger), this.hls = null, this.fragmentTracker = null, this.media = null, this.mediaSource = void 0, this.nudgeRetry = 0, this.stallReported = !1, this.stalled = null, this.moved = !1, this.seeking = !1, this.buffered = {}, this.lastCurrentTime = 0, this.ended = 0, this.waiting = 0, this.onMediaPlaying = () => {
      this.ended = 0, this.waiting = 0;
    }, this.onMediaWaiting = () => {
      var r;
      (r = this.media) != null && r.seeking || (this.waiting = self.performance.now(), this.tick());
    }, this.onMediaEnded = () => {
      if (this.hls) {
        var r;
        this.ended = ((r = this.media) == null ? void 0 : r.currentTime) || 1, this.hls.trigger(T.MEDIA_ENDED, {
          stalled: !1
        });
      }
    }, this.hls = e, this.fragmentTracker = t, this.registerListeners();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e && (e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.BUFFER_APPENDED, this.onBufferAppended, this));
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.BUFFER_APPENDED, this.onBufferAppended, this));
  }
  destroy() {
    super.destroy(), this.unregisterListeners(), this.media = this.hls = this.fragmentTracker = null, this.mediaSource = void 0;
  }
  onMediaAttached(e, t) {
    this.setInterval(vA), this.mediaSource = t.mediaSource;
    const r = this.media = t.media;
    _r(r, "playing", this.onMediaPlaying), _r(r, "waiting", this.onMediaWaiting), _r(r, "ended", this.onMediaEnded);
  }
  onMediaDetaching(e, t) {
    this.clearInterval();
    const {
      media: r
    } = this;
    r && (Or(r, "playing", this.onMediaPlaying), Or(r, "waiting", this.onMediaWaiting), Or(r, "ended", this.onMediaEnded), this.media = null), this.mediaSource = void 0;
  }
  onBufferAppended(e, t) {
    this.buffered = t.timeRanges;
  }
  get hasBuffered() {
    return Object.keys(this.buffered).length > 0;
  }
  tick() {
    var e;
    if (!((e = this.media) != null && e.readyState) || !this.hasBuffered)
      return;
    const t = this.media.currentTime;
    this.poll(t, this.lastCurrentTime), this.lastCurrentTime = t;
  }
  /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */
  poll(e, t) {
    var r, s;
    const i = (r = this.hls) == null ? void 0 : r.config;
    if (!i)
      return;
    const o = this.media;
    if (!o)
      return;
    const {
      seeking: a
    } = o, l = this.seeking && !a, c = !this.seeking && a, u = o.paused && !a || o.ended || o.playbackRate === 0;
    if (this.seeking = a, e !== t) {
      t && (this.ended = 0), this.moved = !0, a || (this.nudgeRetry = 0, i.nudgeOnVideoHole && !u && e > t && this.nudgeOnVideoHole(e, t)), this.waiting === 0 && this.stallResolved(e);
      return;
    }
    if (c || l) {
      l && this.stallResolved(e);
      return;
    }
    if (u) {
      this.nudgeRetry = 0, this.stallResolved(e), !this.ended && o.ended && this.hls && (this.ended = e || 1, this.hls.trigger(T.MEDIA_ENDED, {
        stalled: !1
      }));
      return;
    }
    if (!Le.getBuffered(o).length) {
      this.nudgeRetry = 0;
      return;
    }
    const d = Le.bufferInfo(o, e, 0), h = d.nextStart || 0, f = this.fragmentTracker;
    if (a && f && this.hls) {
      const U = uf(this.hls.inFlightFragments, e), j = d.len > Bo, G = !h || U || h - e > Bo && !f.getPartialFragment(e);
      if (j || G)
        return;
      this.moved = !1;
    }
    const p = (s = this.hls) == null ? void 0 : s.latestLevelDetails;
    if (!this.moved && this.stalled !== null && f) {
      if (!(d.len > 0) && !h)
        return;
      const j = Math.max(h, d.start || 0) - e, F = !!(p != null && p.live) ? p.targetduration * 2 : Bo, B = f.getPartialFragment(e);
      if (j > 0 && (j <= F || B)) {
        o.paused || this._trySkipBufferHole(B);
        return;
      }
    }
    const y = i.detectStallWithCurrentTimeMs, m = self.performance.now(), b = this.waiting;
    let C = this.stalled;
    if (C === null)
      if (b > 0 && m - b < y)
        C = this.stalled = b;
      else {
        this.stalled = m;
        return;
      }
    const A = m - C;
    if (!a && (A >= y || b) && this.hls) {
      var P;
      if (((P = this.mediaSource) == null ? void 0 : P.readyState) === "ended" && !(p != null && p.live) && Math.abs(e - ((p == null ? void 0 : p.edge) || 0)) < 1) {
        if (this.ended)
          return;
        this.ended = e || 1, this.hls.trigger(T.MEDIA_ENDED, {
          stalled: !0
        });
        return;
      }
      if (this._reportStall(d), !this.media || !this.hls)
        return;
    }
    const I = Le.bufferInfo(o, e, i.maxBufferHole);
    this._tryFixBufferStall(I, A, e);
  }
  stallResolved(e) {
    const t = this.stalled;
    if (t && this.hls && (this.stalled = null, this.stallReported)) {
      const r = self.performance.now() - t;
      this.log(`playback not stuck anymore @${e}, after ${Math.round(r)}ms`), this.stallReported = !1, this.waiting = 0, this.hls.trigger(T.STALL_RESOLVED, {});
    }
  }
  nudgeOnVideoHole(e, t) {
    var r;
    const s = this.buffered.video;
    if (this.hls && this.media && this.fragmentTracker && (r = this.buffered.audio) != null && r.length && s && s.length > 1 && e > s.end(0)) {
      const i = Le.bufferedInfo(Le.timeRangesToArray(this.buffered.audio), e, 0);
      if (i.len > 1 && t >= i.start) {
        const o = Le.timeRangesToArray(s), a = Le.bufferedInfo(o, t, 0).bufferedIndex;
        if (a > -1 && a < o.length - 1) {
          const l = Le.bufferedInfo(o, e, 0).bufferedIndex, c = o[a].end, u = o[a + 1].start;
          if ((l === -1 || l > a) && u - c < 1 && // `maxBufferHole` may be too small and setting it to 0 should not disable this feature
          e - c < 2) {
            const d = new Error(`nudging playhead to flush pipeline after video hole. currentTime: ${e} hole: ${c} -> ${u} buffered index: ${l}`);
            this.warn(d.message), this.media.currentTime += 1e-6;
            const h = this.fragmentTracker.getPartialFragment(e) || void 0, f = Le.bufferInfo(this.media, e, 0);
            this.hls.trigger(T.ERROR, {
              type: ge.MEDIA_ERROR,
              details: Y.BUFFER_SEEK_OVER_HOLE,
              fatal: !1,
              error: d,
              reason: d.message,
              frag: h,
              buffer: f.len,
              bufferInfo: f
            });
          }
        }
      }
    }
  }
  /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */
  _tryFixBufferStall(e, t, r) {
    var s, i;
    const {
      fragmentTracker: o,
      media: a
    } = this, l = (s = this.hls) == null ? void 0 : s.config;
    if (!a || !o || !l)
      return;
    const c = (i = this.hls) == null ? void 0 : i.latestLevelDetails, u = o.getPartialFragment(r);
    if ((u || c != null && c.live && r < c.fragmentStart) && (this._trySkipBufferHole(u) || !this.media))
      return;
    const d = e.buffered, h = this.adjacentTraversal(e, r);
    (d && d.length > 1 && e.len > l.maxBufferHole || e.nextStart && (e.nextStart - r < l.maxBufferHole || h)) && (t > l.highBufferWatchdogPeriod * 1e3 || this.waiting) && (this.warn("Trying to nudge playhead over buffer-hole"), this._tryNudgeBuffer(e));
  }
  adjacentTraversal(e, t) {
    const r = this.fragmentTracker, s = e.nextStart;
    if (r && s) {
      const i = r.getFragAtPos(t, he.MAIN), o = r.getFragAtPos(s, he.MAIN);
      if (i && o)
        return o.sn - i.sn < 2;
    }
    return !1;
  }
  /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */
  _reportStall(e) {
    const {
      hls: t,
      media: r,
      stallReported: s,
      stalled: i
    } = this;
    if (!s && i !== null && r && t) {
      this.stallReported = !0;
      const o = new Error(`Playback stalling at @${r.currentTime} due to low buffer (${mt(e)})`);
      this.warn(o.message), t.trigger(T.ERROR, {
        type: ge.MEDIA_ERROR,
        details: Y.BUFFER_STALLED_ERROR,
        fatal: !1,
        error: o,
        buffer: e.len,
        bufferInfo: e,
        stalled: {
          start: i
        }
      });
    }
  }
  /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */
  _trySkipBufferHole(e) {
    var t;
    const {
      fragmentTracker: r,
      media: s
    } = this, i = (t = this.hls) == null ? void 0 : t.config;
    if (!s || !r || !i)
      return 0;
    const o = s.currentTime, a = Le.bufferInfo(s, o, 0), l = o < a.start ? a.start : a.nextStart;
    if (l && this.hls) {
      const u = a.len <= i.maxBufferHole, d = a.len > 0 && a.len < 1 && s.readyState < 3, h = l - o;
      if (h > 0 && (u || d)) {
        if (h > i.maxBufferHole) {
          let p = !1;
          if (o === 0) {
            const y = r.getAppendedFrag(0, he.MAIN);
            y && l < y.end && (p = !0);
          }
          if (!p) {
            const y = e || r.getAppendedFrag(o, he.MAIN);
            if (y) {
              var c;
              if (!((c = this.hls.loadLevelObj) != null && c.details) || uf(this.hls.inFlightFragments, l))
                return 0;
              let b = !1, C = y.end;
              for (; C < l; ) {
                const A = r.getPartialFragment(C);
                if (A)
                  C += A.duration;
                else {
                  b = !0;
                  break;
                }
              }
              if (b)
                return 0;
            }
          }
        }
        const f = Math.max(l + yA, o + mA);
        if (this.warn(`skipping hole, adjusting currentTime from ${o} to ${f}`), this.moved = !0, s.currentTime = f, !(e != null && e.gap)) {
          const p = new Error(`fragment loaded with buffer holes, seeking from ${o} to ${f}`);
          this.hls.trigger(T.ERROR, {
            type: ge.MEDIA_ERROR,
            details: Y.BUFFER_SEEK_OVER_HOLE,
            fatal: !1,
            error: p,
            reason: p.message,
            frag: e || void 0,
            buffer: a.len,
            bufferInfo: a
          });
        }
        return f;
      }
    }
    return 0;
  }
  /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */
  _tryNudgeBuffer(e) {
    const {
      hls: t,
      media: r,
      nudgeRetry: s
    } = this, i = t == null ? void 0 : t.config;
    if (!r || !i)
      return 0;
    const o = r.currentTime;
    if (this.nudgeRetry++, s < i.nudgeMaxRetry) {
      const a = o + (s + 1) * i.nudgeOffset, l = new Error(`Nudging 'currentTime' from ${o} to ${a}`);
      this.warn(l.message), r.currentTime = a, t.trigger(T.ERROR, {
        type: ge.MEDIA_ERROR,
        details: Y.BUFFER_NUDGE_ON_STALL,
        error: l,
        fatal: !1,
        buffer: e.len,
        bufferInfo: e
      });
    } else {
      const a = new Error(`Playhead still not moving while enough data buffered @${o} after ${i.nudgeMaxRetry} nudges`);
      this.error(a.message), t.trigger(T.ERROR, {
        type: ge.MEDIA_ERROR,
        details: Y.BUFFER_STALLED_ERROR,
        error: a,
        fatal: !0,
        buffer: e.len,
        bufferInfo: e
      });
    }
  }
}
function uf(n, e) {
  const t = df(n.main);
  if (t && t.start <= e)
    return t;
  const r = df(n.audio);
  return r && r.start <= e ? r : null;
}
function df(n) {
  if (!n)
    return null;
  switch (n.state) {
    case Q.IDLE:
    case Q.STOPPED:
    case Q.ENDED:
    case Q.ERROR:
      return null;
  }
  return n.frag;
}
const EA = 0.25;
function Fc() {
  if (!(typeof self > "u"))
    return self.VTTCue || self.TextTrackCue;
}
function hf(n, e, t, r, s) {
  let i = new n(e, t, "");
  try {
    i.value = r, s && (i.type = s);
  } catch {
    i = new n(e, t, mt(s ? rt({
      type: s
    }, r) : r));
  }
  return i;
}
const bo = (() => {
  const n = Fc();
  try {
    n && new n(0, Number.POSITIVE_INFINITY, "");
  } catch {
    return Number.MAX_VALUE;
  }
  return Number.POSITIVE_INFINITY;
})();
function SA(n) {
  return Uint8Array.from(n.replace(/^0x/, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")).buffer;
}
class bA {
  constructor(e) {
    this.hls = void 0, this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.removeCues = !0, this.onEventCueEnter = () => {
      this.hls && this.hls.trigger(T.EVENT_CUE_ENTER, {});
    }, this.hls = e, this._registerListeners();
  }
  destroy() {
    this._unregisterListeners(), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = this.onEventCueEnter = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.on(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(T.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(T.LEVEL_PTS_UPDATED, this.onLevelPtsUpdated, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.off(T.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(T.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(T.LEVEL_PTS_UPDATED, this.onLevelPtsUpdated, this);
  }
  // Add ID3 metatadata text track.
  onMediaAttaching(e, t) {
    var r;
    this.media = t.media, ((r = t.overrides) == null ? void 0 : r.cueRemoval) === !1 && (this.removeCues = !1);
  }
  onMediaAttached() {
    const e = this.hls.latestLevelDetails;
    e && this.updateDateRangeCues(e);
  }
  onMediaDetaching(e, t) {
    this.media = null, !t.transferMedia && (this.id3Track && (this.removeCues && Ns(this.id3Track, this.onEventCueEnter), this.id3Track = null), this.dateRangeCuesAppended = {});
  }
  onManifestLoading() {
    this.dateRangeCuesAppended = {};
  }
  createTrack(e) {
    const t = this.getID3Track(e.textTracks);
    return t.mode = "hidden", t;
  }
  getID3Track(e) {
    if (this.media) {
      for (let t = 0; t < e.length; t++) {
        const r = e[t];
        if (r.kind === "metadata" && r.label === "id3")
          return Zp(r, this.media), r;
      }
      return this.media.addTextTrack("metadata", "id3");
    }
  }
  onFragParsingMetadata(e, t) {
    if (!this.media)
      return;
    const {
      hls: {
        config: {
          enableEmsgMetadataCues: r,
          enableID3MetadataCues: s
        }
      }
    } = this;
    if (!r && !s)
      return;
    const {
      samples: i
    } = t;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const o = Fc();
    if (o)
      for (let a = 0; a < i.length; a++) {
        const l = i[a].type;
        if (l === Ir.emsg && !r || !s)
          continue;
        const c = Rp(i[a].data);
        if (c) {
          const u = i[a].pts;
          let d = u + i[a].duration;
          d > bo && (d = bo), d - u <= 0 && (d = u + EA);
          for (let f = 0; f < c.length; f++) {
            const p = c[f];
            if (!Cp(p)) {
              this.updateId3CueEnds(u, l);
              const y = hf(o, u, d, p, l);
              y && this.id3Track.addCue(y);
            }
          }
        }
      }
  }
  updateId3CueEnds(e, t) {
    var r;
    const s = (r = this.id3Track) == null ? void 0 : r.cues;
    if (s)
      for (let i = s.length; i--; ) {
        const o = s[i];
        o.type === t && o.startTime < e && o.endTime === bo && (o.endTime = e);
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: r,
    type: s
  }) {
    const {
      id3Track: i,
      hls: o
    } = this;
    if (!o)
      return;
    const {
      config: {
        enableEmsgMetadataCues: a,
        enableID3MetadataCues: l
      }
    } = o;
    if (i && (a || l)) {
      let c;
      s === "audio" ? c = (u) => u.type === Ir.audioId3 && l : s === "video" ? c = (u) => u.type === Ir.emsg && a : c = (u) => u.type === Ir.audioId3 && l || u.type === Ir.emsg && a, Mc(i, t, r, c);
    }
  }
  onLevelUpdated(e, {
    details: t
  }) {
    this.updateDateRangeCues(t, !0);
  }
  onLevelPtsUpdated(e, t) {
    Math.abs(t.drift) > 0.01 && this.updateDateRangeCues(t.details);
  }
  updateDateRangeCues(e, t) {
    if (!this.media || !e.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues)
      return;
    const {
      id3Track: r
    } = this, {
      dateRanges: s
    } = e, i = Object.keys(s);
    let o = this.dateRangeCuesAppended;
    if (r && t) {
      var a;
      if ((a = r.cues) != null && a.length) {
        const u = Object.keys(o).filter((d) => !i.includes(d));
        for (let d = u.length; d--; ) {
          const h = u[d], f = o[h].cues;
          delete o[h], Object.keys(f).forEach((p) => {
            try {
              const y = f[p];
              y.removeEventListener("enter", this.onEventCueEnter), r.removeCue(y);
            } catch {
            }
          });
        }
      } else
        o = this.dateRangeCuesAppended = {};
    }
    const l = e.fragments[e.fragments.length - 1];
    if (i.length === 0 || !ae(l == null ? void 0 : l.programDateTime))
      return;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const c = Fc();
    for (let u = 0; u < i.length; u++) {
      const d = i[u], h = s[d], f = h.startTime, p = o[d], y = (p == null ? void 0 : p.cues) || {};
      let m = (p == null ? void 0 : p.durationKnown) || !1, b = bo;
      const {
        duration: C,
        endDate: A
      } = h;
      if (A && C !== null)
        b = f + C, m = !0;
      else if (h.endOnNext && !m) {
        const I = i.reduce((U, j) => {
          if (j !== h.id) {
            const G = s[j];
            if (G.class === h.class && G.startDate > h.startDate && (!U || h.startDate < U.startDate))
              return G;
          }
          return U;
        }, null);
        I && (b = I.startTime, m = !0);
      }
      const P = Object.keys(h.attr);
      for (let I = 0; I < P.length; I++) {
        const U = P[I];
        if (!Qb(U))
          continue;
        const j = y[U];
        if (j)
          m && !p.durationKnown ? j.endTime = b : Math.abs(j.startTime - f) > 0.01 && (j.startTime = f, j.endTime = b);
        else if (c) {
          let G = h.attr[U];
          eT(U) && (G = SA(G));
          const B = hf(c, f, b, {
            key: U,
            data: G
          }, Ir.dateRange);
          B && (B.id = d, this.id3Track.addCue(B), y[U] = B, this.hls.config.interstitialsController && (U === "X-ASSET-LIST" || U === "X-ASSET-URL") && B.addEventListener("enter", this.onEventCueEnter));
        }
      }
      o[d] = {
        cues: y,
        dateRange: h,
        durationKnown: m
      };
    }
  }
}
class TA {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = null, this.currentTime = 0, this.stallCount = 0, this._latency = null, this._targetLatencyUpdated = !1, this.onTimeupdate = () => {
      const {
        media: t
      } = this, r = this.levelDetails;
      if (!t || !r)
        return;
      this.currentTime = t.currentTime;
      const s = this.computeLatency();
      if (s === null)
        return;
      this._latency = s;
      const {
        lowLatencyMode: i,
        maxLiveSyncPlaybackRate: o
      } = this.config;
      if (!i || o === 1 || !r.live)
        return;
      const a = this.targetLatency;
      if (a === null)
        return;
      const l = s - a, c = Math.min(this.maxLatency, a + r.targetduration);
      if (l < c && l > 0.05 && this.forwardBufferLength > 1) {
        const d = Math.min(2, Math.max(1, o)), h = Math.round(2 / (1 + Math.exp(-0.75 * l - this.edgeStalled)) * 20) / 20, f = Math.min(d, Math.max(1, h));
        this.changeMediaPlaybackRate(t, f);
      } else t.playbackRate !== 1 && t.playbackRate !== 0 && this.changeMediaPlaybackRate(t, 1);
    }, this.hls = e, this.config = e.config, this.registerListeners();
  }
  get levelDetails() {
    var e;
    return ((e = this.hls) == null ? void 0 : e.latestLevelDetails) || null;
  }
  get latency() {
    return this._latency || 0;
  }
  get maxLatency() {
    const {
      config: e
    } = this;
    if (e.liveMaxLatencyDuration !== void 0)
      return e.liveMaxLatencyDuration;
    const t = this.levelDetails;
    return t ? e.liveMaxLatencyDurationCount * t.targetduration : 0;
  }
  get targetLatency() {
    const e = this.levelDetails;
    if (e === null || this.hls === null)
      return null;
    const {
      holdBack: t,
      partHoldBack: r,
      targetduration: s
    } = e, {
      liveSyncDuration: i,
      liveSyncDurationCount: o,
      lowLatencyMode: a
    } = this.config, l = this.hls.userConfig;
    let c = a && r || t;
    (this._targetLatencyUpdated || l.liveSyncDuration || l.liveSyncDurationCount || c === 0) && (c = i !== void 0 ? i : o * s);
    const u = s;
    return c + Math.min(this.stallCount * this.config.liveSyncOnStallIncrease, u);
  }
  set targetLatency(e) {
    this.stallCount = 0, this.config.liveSyncDuration = e, this._targetLatencyUpdated = !0;
  }
  get liveSyncPosition() {
    const e = this.estimateLiveEdge(), t = this.targetLatency;
    if (e === null || t === null)
      return null;
    const r = this.levelDetails;
    if (r === null)
      return null;
    const s = r.edge, i = e - t - this.edgeStalled, o = s - r.totalduration, a = s - (this.config.lowLatencyMode && r.partTarget || r.targetduration);
    return Math.min(Math.max(o, i), a);
  }
  get drift() {
    const e = this.levelDetails;
    return e === null ? 1 : e.drift;
  }
  get edgeStalled() {
    const e = this.levelDetails;
    if (e === null)
      return 0;
    const t = (this.config.lowLatencyMode && e.partTarget || e.targetduration) * 3;
    return Math.max(e.age - t, 0);
  }
  get forwardBufferLength() {
    const {
      media: e
    } = this, t = this.levelDetails;
    if (!e || !t)
      return 0;
    const r = e.buffered.length;
    return (r ? e.buffered.end(r - 1) : t.edge) - this.currentTime;
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetaching(), this.hls = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e && (e.on(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(T.ERROR, this.onError, this));
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(T.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(T.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(T.ERROR, this.onError, this));
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("timeupdate", this.onTimeupdate);
  }
  onMediaDetaching() {
    this.media && (this.media.removeEventListener("timeupdate", this.onTimeupdate), this.media = null);
  }
  onManifestLoading() {
    this._latency = null, this.stallCount = 0;
  }
  onLevelUpdated(e, {
    details: t
  }) {
    t.advanced && this.onTimeupdate(), !t.live && this.media && this.media.removeEventListener("timeupdate", this.onTimeupdate);
  }
  onError(e, t) {
    var r;
    t.details === Y.BUFFER_STALLED_ERROR && (this.stallCount++, this.hls && (r = this.levelDetails) != null && r.live && this.hls.logger.warn("[latency-controller]: Stall detected, adjusting target latency"));
  }
  changeMediaPlaybackRate(e, t) {
    var r, s;
    e.playbackRate !== t && ((r = this.hls) == null || r.logger.debug(`[latency-controller]: latency=${this.latency.toFixed(3)}, targetLatency=${(s = this.targetLatency) == null ? void 0 : s.toFixed(3)}, forwardBufferLength=${this.forwardBufferLength.toFixed(3)}: adjusting playback rate from ${e.playbackRate} to ${t}`), e.playbackRate = t);
  }
  estimateLiveEdge() {
    const e = this.levelDetails;
    return e === null ? null : e.edge + e.age;
  }
  computeLatency() {
    const e = this.estimateLiveEdge();
    return e === null ? null : e - this.currentTime;
  }
}
class wA extends Yu {
  constructor(e, t) {
    super(e, "level-controller"), this._levels = [], this._firstLevel = -1, this._maxAutoLevel = -1, this._startLevel = void 0, this.currentLevel = null, this.currentLevelIndex = -1, this.manualLevelIndex = -1, this.steering = void 0, this.onParsedComplete = void 0, this.steering = t, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(T.LEVEL_LOADED, this.onLevelLoaded, this), e.on(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this), e.on(T.ERROR, this.onError, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(T.LEVEL_LOADED, this.onLevelLoaded, this), e.off(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this), e.off(T.ERROR, this.onError, this);
  }
  destroy() {
    this._unregisterListeners(), this.steering = null, this.resetLevels(), super.destroy();
  }
  stopLoad() {
    this._levels.forEach((t) => {
      t.loadError = 0, t.fragmentError = 0;
    }), super.stopLoad();
  }
  resetLevels() {
    this._startLevel = void 0, this.manualLevelIndex = -1, this.currentLevelIndex = -1, this.currentLevel = null, this._levels = [], this._maxAutoLevel = -1;
  }
  onManifestLoading(e, t) {
    this.resetLevels();
  }
  onManifestLoaded(e, t) {
    const r = this.hls.config.preferManagedMediaSource, s = [], i = {}, o = {};
    let a = !1, l = !1, c = !1;
    t.levels.forEach((u) => {
      const d = u.attrs;
      let {
        audioCodec: h,
        videoCodec: f
      } = u;
      h && (u.audioCodec = h = pa(h, r) || void 0), f && (f = u.videoCodec = Sb(f));
      const {
        width: p,
        height: y,
        unknownCodecs: m
      } = u;
      let b = m ? m.length : 0;
      if (m)
        for (let B = b; B--; ) {
          const V = m[B];
          this.isAudioSupported(V) ? (u.audioCodec = h = h ? `${h},${V}` : V, b--, Qs.audio[h.substring(0, 4)] = 2) : this.isVideoSupported(V) && (u.videoCodec = f = f ? `${f},${V}` : V, b--, Qs.video[f.substring(0, 4)] = 2);
        }
      if (a || (a = !!(p && y)), l || (l = !!f), c || (c = !!h), b || h && !this.isAudioSupported(h) || f && !this.isVideoSupported(f)) {
        this.log(`Some or all CODECS not supported "${d.CODECS}"`);
        return;
      }
      const {
        CODECS: C,
        "FRAME-RATE": A,
        "HDCP-LEVEL": P,
        "PATHWAY-ID": I,
        RESOLUTION: U,
        "VIDEO-RANGE": j
      } = d, F = `${`${I || "."}-`}${u.bitrate}-${U}-${A}-${C}-${j}-${P}`;
      if (i[F])
        if (i[F].uri !== u.url && !u.attrs["PATHWAY-ID"]) {
          const B = o[F] += 1;
          u.attrs["PATHWAY-ID"] = new Array(B + 1).join(".");
          const V = this.createLevel(u);
          i[F] = V, s.push(V);
        } else
          i[F].addGroupId("audio", d.AUDIO), i[F].addGroupId("text", d.SUBTITLES);
      else {
        const B = this.createLevel(u);
        i[F] = B, o[F] = 1, s.push(B);
      }
    }), this.filterAndSortMediaOptions(s, t, a, l, c);
  }
  createLevel(e) {
    const t = new Bi(e), r = e.supplemental;
    if (r != null && r.videoCodec && !this.isVideoSupported(r.videoCodec)) {
      const s = new Error(`SUPPLEMENTAL-CODECS not supported "${r.videoCodec}"`);
      this.log(s.message), t.supportedResult = np(s, []);
    }
    return t;
  }
  isAudioSupported(e) {
    return Tc(e, "audio", this.hls.config.preferManagedMediaSource);
  }
  isVideoSupported(e) {
    return Tc(e, "video", this.hls.config.preferManagedMediaSource);
  }
  filterAndSortMediaOptions(e, t, r, s, i) {
    let o = [], a = [], l = e;
    if ((r || s) && i && (l = l.filter(({
      videoCodec: m,
      videoRange: b,
      width: C,
      height: A
    }) => (!!m || !!(C && A)) && Ib(b))), l.length === 0) {
      Promise.resolve().then(() => {
        if (this.hls) {
          let m = "no level with compatible codecs found in manifest", b = m;
          t.levels.length && (b = `one or more CODECS in variant not supported: ${mt(t.levels.map((A) => A.attrs.CODECS).filter((A, P, I) => I.indexOf(A) === P))}`, this.warn(b), m += ` (${b})`);
          const C = new Error(m);
          this.hls.trigger(T.ERROR, {
            type: ge.MEDIA_ERROR,
            details: Y.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
            fatal: !0,
            url: t.url,
            error: C,
            reason: b
          });
        }
      });
      return;
    }
    t.audioTracks && (o = t.audioTracks.filter((m) => !m.audioCodec || this.isAudioSupported(m.audioCodec)), ff(o)), t.subtitles && (a = t.subtitles, ff(a));
    const c = l.slice(0);
    l.sort((m, b) => {
      if (m.attrs["HDCP-LEVEL"] !== b.attrs["HDCP-LEVEL"])
        return (m.attrs["HDCP-LEVEL"] || "") > (b.attrs["HDCP-LEVEL"] || "") ? 1 : -1;
      if (r && m.height !== b.height)
        return m.height - b.height;
      if (m.frameRate !== b.frameRate)
        return m.frameRate - b.frameRate;
      if (m.videoRange !== b.videoRange)
        return ma.indexOf(m.videoRange) - ma.indexOf(b.videoRange);
      if (m.videoCodec !== b.videoCodec) {
        const C = ih(m.videoCodec), A = ih(b.videoCodec);
        if (C !== A)
          return A - C;
      }
      if (m.uri === b.uri && m.codecSet !== b.codecSet) {
        const C = ga(m.codecSet), A = ga(b.codecSet);
        if (C !== A)
          return A - C;
      }
      return m.averageBitrate !== b.averageBitrate ? m.averageBitrate - b.averageBitrate : 0;
    });
    let u = c[0];
    if (this.steering && (l = this.steering.filterParsedLevels(l), l.length !== c.length)) {
      for (let m = 0; m < c.length; m++)
        if (c[m].pathwayId === l[0].pathwayId) {
          u = c[m];
          break;
        }
    }
    this._levels = l;
    for (let m = 0; m < l.length; m++)
      if (l[m] === u) {
        var d;
        this._firstLevel = m;
        const b = u.bitrate, C = this.hls.bandwidthEstimate;
        if (this.log(`manifest loaded, ${l.length} level(s) found, first bitrate: ${b}`), ((d = this.hls.userConfig) == null ? void 0 : d.abrEwmaDefaultEstimate) === void 0) {
          const A = Math.min(b, this.hls.config.abrEwmaDefaultEstimateMax);
          A > C && C === this.hls.abrEwmaDefaultEstimate && (this.hls.bandwidthEstimate = A);
        }
        break;
      }
    const h = i && !s, f = this.hls.config, p = !!(f.audioStreamController && f.audioTrackController), y = {
      levels: l,
      audioTracks: o,
      subtitleTracks: a,
      sessionData: t.sessionData,
      sessionKeys: t.sessionKeys,
      firstLevel: this._firstLevel,
      stats: t.stats,
      audio: i,
      video: s,
      altAudio: p && !h && o.some((m) => !!m.url)
    };
    this.hls.trigger(T.MANIFEST_PARSED, y);
  }
  get levels() {
    return this._levels.length === 0 ? null : this._levels;
  }
  get loadLevelObj() {
    return this.currentLevel;
  }
  get level() {
    return this.currentLevelIndex;
  }
  set level(e) {
    const t = this._levels;
    if (t.length === 0)
      return;
    if (e < 0 || e >= t.length) {
      const u = new Error("invalid level idx"), d = e < 0;
      if (this.hls.trigger(T.ERROR, {
        type: ge.OTHER_ERROR,
        details: Y.LEVEL_SWITCH_ERROR,
        level: e,
        fatal: d,
        error: u,
        reason: u.message
      }), d)
        return;
      e = Math.min(e, t.length - 1);
    }
    const r = this.currentLevelIndex, s = this.currentLevel, i = s ? s.attrs["PATHWAY-ID"] : void 0, o = t[e], a = o.attrs["PATHWAY-ID"];
    if (this.currentLevelIndex = e, this.currentLevel = o, r === e && s && i === a)
      return;
    this.log(`Switching to level ${e} (${o.height ? o.height + "p " : ""}${o.videoRange ? o.videoRange + " " : ""}${o.codecSet ? o.codecSet + " " : ""}@${o.bitrate})${a ? " with Pathway " + a : ""} from level ${r}${i ? " with Pathway " + i : ""}`);
    const l = {
      level: e,
      attrs: o.attrs,
      details: o.details,
      bitrate: o.bitrate,
      averageBitrate: o.averageBitrate,
      maxBitrate: o.maxBitrate,
      realBitrate: o.realBitrate,
      width: o.width,
      height: o.height,
      codecSet: o.codecSet,
      audioCodec: o.audioCodec,
      videoCodec: o.videoCodec,
      audioGroups: o.audioGroups,
      subtitleGroups: o.subtitleGroups,
      loaded: o.loaded,
      loadError: o.loadError,
      fragmentError: o.fragmentError,
      name: o.name,
      id: o.id,
      uri: o.uri,
      url: o.url,
      urlId: 0,
      audioGroupIds: o.audioGroupIds,
      textGroupIds: o.textGroupIds
    };
    this.hls.trigger(T.LEVEL_SWITCHING, l);
    const c = o.details;
    if (!c || c.live) {
      const u = this.switchParams(o.uri, s == null ? void 0 : s.details, c);
      this.loadPlaylist(u);
    }
  }
  get manualLevel() {
    return this.manualLevelIndex;
  }
  set manualLevel(e) {
    this.manualLevelIndex = e, this._startLevel === void 0 && (this._startLevel = e), e !== -1 && (this.level = e);
  }
  get firstLevel() {
    return this._firstLevel;
  }
  set firstLevel(e) {
    this._firstLevel = e;
  }
  get startLevel() {
    if (this._startLevel === void 0) {
      const e = this.hls.config.startLevel;
      return e !== void 0 ? e : this.hls.firstAutoLevel;
    }
    return this._startLevel;
  }
  set startLevel(e) {
    this._startLevel = e;
  }
  get pathways() {
    return this.steering ? this.steering.pathways() : [];
  }
  get pathwayPriority() {
    return this.steering ? this.steering.pathwayPriority : null;
  }
  set pathwayPriority(e) {
    if (this.steering) {
      const t = this.steering.pathways(), r = e.filter((s) => t.indexOf(s) !== -1);
      if (e.length < 1) {
        this.warn(`pathwayPriority ${e} should contain at least one pathway from list: ${t}`);
        return;
      }
      this.steering.pathwayPriority = r;
    }
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === Ke.LEVEL && t.context.level === this.level && this.checkRetry(t);
  }
  // reset errors on the successful load of a fragment
  onFragBuffered(e, {
    frag: t
  }) {
    if (t !== void 0 && t.type === he.MAIN) {
      const r = t.elementaryStreams;
      if (!Object.keys(r).some((i) => !!r[i]))
        return;
      const s = this._levels[t.level];
      s != null && s.loadError && (this.log(`Resetting level error count of ${s.loadError} on frag buffered`), s.loadError = 0);
    }
  }
  onLevelLoaded(e, t) {
    var r;
    const {
      level: s,
      details: i
    } = t, o = t.levelInfo;
    if (!o) {
      var a;
      this.warn(`Invalid level index ${s}`), (a = t.deliveryDirectives) != null && a.skip && (i.deltaUpdateFailed = !0);
      return;
    }
    if (o === this.currentLevel || t.withoutMultiVariant) {
      o.fragmentError === 0 && (o.loadError = 0);
      let l = o.details;
      l === t.details && l.advanced && (l = void 0), this.playlistLoaded(s, t, l);
    } else (r = t.deliveryDirectives) != null && r.skip && (i.deltaUpdateFailed = !0);
  }
  loadPlaylist(e) {
    super.loadPlaylist(), this.shouldLoadPlaylist(this.currentLevel) && this.scheduleLoading(this.currentLevel, e);
  }
  loadingPlaylist(e, t) {
    super.loadingPlaylist(e, t);
    const r = this.getUrlWithDirectives(e.uri, t), s = this.currentLevelIndex, i = e.attrs["PATHWAY-ID"], o = e.details, a = o == null ? void 0 : o.age;
    this.log(`Loading level index ${s}${(t == null ? void 0 : t.msn) !== void 0 ? " at sn " + t.msn + " part " + t.part : ""}${i ? " Pathway " + i : ""}${a && o.live ? " age " + a.toFixed(1) + (o.type && " " + o.type || "") : ""} ${r}`), this.hls.trigger(T.LEVEL_LOADING, {
      url: r,
      level: s,
      levelInfo: e,
      pathwayId: e.attrs["PATHWAY-ID"],
      id: 0,
      // Deprecated Level urlId
      deliveryDirectives: t || null
    });
  }
  get nextLoadLevel() {
    return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
  }
  set nextLoadLevel(e) {
    this.level = e, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = e);
  }
  removeLevel(e) {
    var t;
    if (this._levels.length === 1)
      return;
    const r = this._levels.filter((i, o) => o !== e ? !0 : (this.steering && this.steering.removeLevel(i), i === this.currentLevel && (this.currentLevel = null, this.currentLevelIndex = -1, i.details && i.details.fragments.forEach((a) => a.level = -1)), !1));
    xp(r), this._levels = r, this.currentLevelIndex > -1 && (t = this.currentLevel) != null && t.details && (this.currentLevelIndex = this.currentLevel.details.fragments[0].level), this.manualLevelIndex > -1 && (this.manualLevelIndex = this.currentLevelIndex);
    const s = r.length - 1;
    this._firstLevel = Math.min(this._firstLevel, s), this._startLevel && (this._startLevel = Math.min(this._startLevel, s)), this.hls.trigger(T.LEVELS_UPDATED, {
      levels: r
    });
  }
  onLevelsUpdated(e, {
    levels: t
  }) {
    this._levels = t;
  }
  checkMaxAutoUpdated() {
    const {
      autoLevelCapping: e,
      maxAutoLevel: t,
      maxHdcpLevel: r
    } = this.hls;
    this._maxAutoLevel !== t && (this._maxAutoLevel = t, this.hls.trigger(T.MAX_AUTO_LEVEL_UPDATED, {
      autoLevelCapping: e,
      levels: this.levels,
      maxAutoLevel: t,
      minAutoLevel: this.hls.minAutoLevel,
      maxHdcpLevel: r
    }));
  }
}
function ff(n) {
  const e = {};
  n.forEach((t) => {
    const r = t.groupId || "";
    t.id = e[r] = e[r] || 0, e[r]++;
  });
}
function cm() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}
function um() {
  if (!Zn())
    return !1;
  const e = cm();
  return !e || e.prototype && typeof e.prototype.appendBuffer == "function" && typeof e.prototype.remove == "function";
}
function AA() {
  if (!um())
    return !1;
  const n = Zn();
  return typeof (n == null ? void 0 : n.isTypeSupported) == "function" && (["avc1.42E01E,mp4a.40.2", "av01.0.01M.08", "vp09.00.50.08"].some((e) => n.isTypeSupported(Oi(e, "video"))) || ["mp4a.40.2", "fLaC"].some((e) => n.isTypeSupported(Oi(e, "audio"))));
}
function IA() {
  var n;
  const e = cm();
  return typeof (e == null || (n = e.prototype) == null ? void 0 : n.changeType) == "function";
}
const _A = 100;
class LA extends Gu {
  constructor(e, t, r) {
    super(e, t, r, "stream-controller", he.MAIN), this.audioCodecSwap = !1, this.level = -1, this._forceStartLoad = !1, this._hasEnoughToStart = !1, this.altAudio = 0, this.audioOnly = !1, this.fragPlaying = null, this.fragLastKbps = 0, this.couldBacktrack = !1, this.backtrackFragment = null, this.audioCodecSwitch = !1, this.videoBuffer = null, this.onMediaPlaying = () => {
      this.tick();
    }, this.onMediaSeeked = () => {
      const s = this.media, i = s ? s.currentTime : null;
      if (i === null || !ae(i) || (this.log(`Media seeked to ${i.toFixed(3)}`), !this.getBufferedFrag(i)))
        return;
      const o = this.getFwdBufferInfoAtPos(s, i, he.MAIN, 0);
      if (o === null || o.len === 0) {
        this.warn(`Main forward buffer length at ${i} on "seeked" event ${o ? o.len : "empty"})`);
        return;
      }
      this.tick();
    }, this.registerListeners();
  }
  registerListeners() {
    super.registerListeners();
    const {
      hls: e
    } = this;
    e.on(T.MANIFEST_PARSED, this.onManifestParsed, this), e.on(T.LEVEL_LOADING, this.onLevelLoading, this), e.on(T.LEVEL_LOADED, this.onLevelLoaded, this), e.on(T.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.on(T.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(T.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.on(T.BUFFER_CREATED, this.onBufferCreated, this), e.on(T.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(T.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  unregisterListeners() {
    super.unregisterListeners();
    const {
      hls: e
    } = this;
    e.off(T.MANIFEST_PARSED, this.onManifestParsed, this), e.off(T.LEVEL_LOADED, this.onLevelLoaded, this), e.off(T.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.off(T.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(T.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.off(T.BUFFER_CREATED, this.onBufferCreated, this), e.off(T.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(T.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(T.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  onHandlerDestroying() {
    this.onMediaPlaying = this.onMediaSeeked = null, this.unregisterListeners(), super.onHandlerDestroying();
  }
  startLoad(e, t) {
    if (this.levels) {
      const {
        lastCurrentTime: r,
        hls: s
      } = this;
      if (this.stopLoad(), this.setInterval(_A), this.level = -1, !this.startFragRequested) {
        let i = s.startLevel;
        i === -1 && (s.config.testBandwidth && this.levels.length > 1 ? (i = 0, this.bitrateTest = !0) : i = s.firstAutoLevel), s.nextLoadLevel = i, this.level = s.loadLevel, this._hasEnoughToStart = !!t;
      }
      r > 0 && e === -1 && !t && (this.log(`Override startPosition with lastCurrentTime @${r.toFixed(3)}`), e = r), this.state = Q.IDLE, this.nextLoadPosition = this.lastCurrentTime = e + this.timelineOffset, this.startPosition = t ? -1 : e, this.tick();
    } else
      this._forceStartLoad = !0, this.state = Q.STOPPED;
  }
  stopLoad() {
    this._forceStartLoad = !1, super.stopLoad();
  }
  doTick() {
    switch (this.state) {
      case Q.WAITING_LEVEL: {
        const {
          levels: t,
          level: r
        } = this, s = t == null ? void 0 : t[r], i = s == null ? void 0 : s.details;
        if (i && (!i.live || this.levelLastLoaded === s && !this.waitForLive(s))) {
          if (this.waitForCdnTuneIn(i))
            break;
          this.state = Q.IDLE;
          break;
        } else if (this.hls.nextLoadLevel !== this.level) {
          this.state = Q.IDLE;
          break;
        }
        break;
      }
      case Q.FRAG_LOADING_WAITING_RETRY:
        {
          var e;
          const t = self.performance.now(), r = this.retryDate;
          if (!r || t >= r || (e = this.media) != null && e.seeking) {
            const {
              levels: s,
              level: i
            } = this, o = s == null ? void 0 : s[i];
            this.resetStartWhenNotLoaded(o || null), this.state = Q.IDLE;
          }
        }
        break;
    }
    this.state === Q.IDLE && this.doTickIdle(), this.onTickEnd();
  }
  onTickEnd() {
    var e;
    super.onTickEnd(), (e = this.media) != null && e.readyState && this.media.seeking === !1 && (this.lastCurrentTime = this.media.currentTime), this.checkFragmentChanged();
  }
  doTickIdle() {
    const {
      hls: e,
      levelLastLoaded: t,
      levels: r,
      media: s
    } = this;
    if (t === null || !s && !this.primaryPrefetch && (this.startFragRequested || !e.config.startFragPrefetch) || this.altAudio && this.audioOnly)
      return;
    const i = this.buffering ? e.nextLoadLevel : e.loadLevel;
    if (!(r != null && r[i]))
      return;
    const o = r[i], a = this.getMainFwdBufferInfo();
    if (a === null)
      return;
    const l = this.getLevelDetails();
    if (l && this._streamEnded(a, l)) {
      const y = {};
      this.altAudio === 2 && (y.type = "video"), this.hls.trigger(T.BUFFER_EOS, y), this.state = Q.ENDED;
      return;
    }
    if (!this.buffering)
      return;
    e.loadLevel !== i && e.manualLevel === -1 && this.log(`Adapting to level ${i} from level ${this.level}`), this.level = e.nextLoadLevel = i;
    const c = o.details;
    if (!c || this.state === Q.WAITING_LEVEL || this.waitForLive(o)) {
      this.level = i, this.state = Q.WAITING_LEVEL, this.startFragRequested = !1;
      return;
    }
    const u = a.len, d = this.getMaxBufferLength(o.maxBitrate);
    if (u >= d)
      return;
    this.backtrackFragment && this.backtrackFragment.start > a.end && (this.backtrackFragment = null);
    const h = this.backtrackFragment ? this.backtrackFragment.start : a.end;
    let f = this.getNextFragment(h, c);
    if (this.couldBacktrack && !this.fragPrevious && f && Yt(f) && this.fragmentTracker.getState(f) !== Ht.OK) {
      var p;
      const m = ((p = this.backtrackFragment) != null ? p : f).sn - c.startSN, b = c.fragments[m - 1];
      b && f.cc === b.cc && (f = b, this.fragmentTracker.removeFragment(b));
    } else this.backtrackFragment && a.len && (this.backtrackFragment = null);
    if (f && this.isLoopLoading(f, h)) {
      if (!f.gap) {
        const m = this.audioOnly && !this.altAudio ? lt.AUDIO : lt.VIDEO, b = (m === lt.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
        b && this.afterBufferFlushed(b, m, he.MAIN);
      }
      f = this.getNextFragmentLoopLoading(f, c, a, he.MAIN, d);
    }
    f && (f.initSegment && !f.initSegment.data && !this.bitrateTest && (f = f.initSegment), this.loadFragment(f, o, h));
  }
  loadFragment(e, t, r) {
    const s = this.fragmentTracker.getState(e);
    s === Ht.NOT_LOADED || s === Ht.PARTIAL ? Yt(e) ? this.bitrateTest ? (this.log(`Fragment ${e.sn} of level ${e.level} is being downloaded to test bitrate and will not be buffered`), this._loadBitrateTestFrag(e, t)) : super.loadFragment(e, t, r) : this._loadInitSegment(e, t) : this.clearTrackerIfNeeded(e);
  }
  getBufferedFrag(e) {
    return this.fragmentTracker.getBufferedFrag(e, he.MAIN);
  }
  followingBufferedFrag(e) {
    return e ? this.getBufferedFrag(e.end + 0.5) : null;
  }
  /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */
  immediateLevelSwitch() {
    this.abortCurrentFrag(), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
  }
  /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */
  nextLevelSwitch() {
    const {
      levels: e,
      media: t
    } = this;
    if (t != null && t.readyState) {
      let r;
      const s = this.getAppendedFrag(t.currentTime);
      s && s.start > 1 && this.flushMainBuffer(0, s.start - 1);
      const i = this.getLevelDetails();
      if (i != null && i.live) {
        const a = this.getMainFwdBufferInfo();
        if (!a || a.len < i.targetduration * 2)
          return;
      }
      if (!t.paused && e) {
        const a = this.hls.nextLoadLevel, l = e[a], c = this.fragLastKbps;
        c && this.fragCurrent ? r = this.fragCurrent.duration * l.maxBitrate / (1e3 * c) + 1 : r = 0;
      } else
        r = 0;
      const o = this.getBufferedFrag(t.currentTime + r);
      if (o) {
        const a = this.followingBufferedFrag(o);
        if (a) {
          this.abortCurrentFrag();
          const l = a.maxStartPTS ? a.maxStartPTS : a.start, c = a.duration, u = Math.max(o.end, l + Math.min(Math.max(c - this.config.maxFragLookUpTolerance, c * (this.couldBacktrack ? 0.5 : 0.125)), c * (this.couldBacktrack ? 0.75 : 0.25)));
          this.flushMainBuffer(u, Number.POSITIVE_INFINITY);
        }
      }
    }
  }
  abortCurrentFrag() {
    const e = this.fragCurrent;
    switch (this.fragCurrent = null, this.backtrackFragment = null, e && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.state) {
      case Q.KEY_LOADING:
      case Q.FRAG_LOADING:
      case Q.FRAG_LOADING_WAITING_RETRY:
      case Q.PARSING:
      case Q.PARSED:
        this.state = Q.IDLE;
        break;
    }
    this.nextLoadPosition = this.getLoadPosition();
  }
  flushMainBuffer(e, t) {
    super.flushMainBuffer(e, t, this.altAudio === 2 ? "video" : null);
  }
  onMediaAttached(e, t) {
    super.onMediaAttached(e, t);
    const r = t.media;
    _r(r, "playing", this.onMediaPlaying), _r(r, "seeked", this.onMediaSeeked);
  }
  onMediaDetaching(e, t) {
    const {
      media: r
    } = this;
    r && (Or(r, "playing", this.onMediaPlaying), Or(r, "seeked", this.onMediaSeeked)), this.videoBuffer = null, this.fragPlaying = null, super.onMediaDetaching(e, t), !t.transferMedia && (this._hasEnoughToStart = !1);
  }
  onManifestLoading() {
    super.onManifestLoading(), this.log("Trigger BUFFER_RESET"), this.hls.trigger(T.BUFFER_RESET, void 0), this.couldBacktrack = !1, this.fragLastKbps = 0, this.fragPlaying = this.backtrackFragment = null, this.altAudio = 0, this.audioOnly = !1;
  }
  onManifestParsed(e, t) {
    let r = !1, s = !1;
    t.levels.forEach((i) => {
      const o = i.audioCodec;
      o && (r = r || o.indexOf("mp4a.40.2") !== -1, s = s || o.indexOf("mp4a.40.5") !== -1);
    }), this.audioCodecSwitch = r && s && !IA(), this.audioCodecSwitch && this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = t.levels, this.startFragRequested = !1;
  }
  onLevelLoading(e, t) {
    const {
      levels: r
    } = this;
    if (!r || this.state !== Q.IDLE)
      return;
    const s = t.levelInfo;
    (!s.details || s.details.live && (this.levelLastLoaded !== s || s.details.expired) || this.waitForCdnTuneIn(s.details)) && (this.state = Q.WAITING_LEVEL);
  }
  onLevelLoaded(e, t) {
    var r;
    const {
      levels: s,
      startFragRequested: i
    } = this, o = t.level, a = t.details, l = a.totalduration;
    if (!s) {
      this.warn(`Levels were reset while loading level ${o}`);
      return;
    }
    this.log(`Level ${o} loaded [${a.startSN},${a.endSN}]${a.lastPartSn ? `[part-${a.lastPartSn}-${a.lastPartIndex}]` : ""}, cc [${a.startCC}, ${a.endCC}] duration:${l}`);
    const c = t.levelInfo, u = this.fragCurrent;
    u && (this.state === Q.FRAG_LOADING || this.state === Q.FRAG_LOADING_WAITING_RETRY) && u.level !== t.level && u.loader && this.abortCurrentFrag();
    let d = 0;
    if (a.live || (r = c.details) != null && r.live) {
      var h;
      if (this.checkLiveUpdate(a), a.deltaUpdateFailed)
        return;
      d = this.alignPlaylists(a, c.details, (h = this.levelLastLoaded) == null ? void 0 : h.details);
    }
    if (c.details = a, this.levelLastLoaded = c, i || this.setStartPosition(a, d), this.hls.trigger(T.LEVEL_UPDATED, {
      details: a,
      level: o
    }), this.state === Q.WAITING_LEVEL) {
      if (this.waitForCdnTuneIn(a))
        return;
      this.state = Q.IDLE;
    }
    i && a.live && this.synchronizeToLiveEdge(a), this.tick();
  }
  synchronizeToLiveEdge(e) {
    const {
      config: t,
      media: r
    } = this;
    if (!r)
      return;
    const s = this.hls.liveSyncPosition, i = this.getLoadPosition(), o = e.fragmentStart, a = e.edge, l = i >= o - t.maxFragLookUpTolerance && i <= a;
    if (s !== null && r.duration > s && (i < s || !l)) {
      const u = t.liveMaxLatencyDuration !== void 0 ? t.liveMaxLatencyDuration : t.liveMaxLatencyDurationCount * e.targetduration;
      if ((!l && r.readyState < 4 || i < a - u) && (this._hasEnoughToStart || (this.nextLoadPosition = s), r.readyState))
        if (this.warn(`Playback: ${i.toFixed(3)} is located too far from the end of live sliding playlist: ${a}, reset currentTime to : ${s.toFixed(3)}`), this.config.liveSyncMode === "buffered") {
          var c;
          const d = Le.bufferInfo(r, s, 0);
          if (!(d != null && (c = d.buffered) != null && c.length)) {
            r.currentTime = s;
            return;
          }
          if (d.start <= i) {
            r.currentTime = s;
            return;
          }
          const {
            nextStart: f
          } = Le.bufferedInfo(d.buffered, i, 0);
          f && (r.currentTime = f);
        } else
          r.currentTime = s;
    }
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const r = e.frag, {
      part: s,
      payload: i
    } = e, {
      levels: o
    } = this;
    if (!o) {
      this.warn(`Levels were reset while fragment load was in progress. Fragment ${r.sn} of level ${r.level} will not be buffered`);
      return;
    }
    const a = o[r.level];
    if (!a) {
      this.warn(`Level ${r.level} not found on progress`);
      return;
    }
    const l = a.details;
    if (!l) {
      this.warn(`Dropping fragment ${r.sn} of level ${r.level} after level details were reset`), this.fragmentTracker.removeFragment(r);
      return;
    }
    const c = a.videoCodec, u = l.PTSKnown || !l.live, d = (t = r.initSegment) == null ? void 0 : t.data, h = this._getAudioCodec(a), f = this.transmuxer = this.transmuxer || new Gp(this.hls, he.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)), p = s ? s.index : -1, y = p !== -1, m = new Nu(r.level, r.sn, r.stats.chunkCount, i.byteLength, p, y), b = this.initPTS[r.cc];
    f.push(i, d, h, c, r, s, l.totalduration, u, m, b);
  }
  onAudioTrackSwitching(e, t) {
    const r = this.hls, s = this.altAudio === 2;
    if (ya(t.url, r))
      this.altAudio = 1;
    else {
      if (this.mediaBuffer !== this.media) {
        this.log("Switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
        const o = this.fragCurrent;
        o && (this.log("Switching to main audio track, cancel main fragment load"), o.abortRequests(), this.fragmentTracker.removeFragment(o)), this.resetTransmuxer(), this.resetLoadingState();
      } else this.audioOnly && this.resetTransmuxer();
      if (s) {
        this.fragmentTracker.removeAllFragments(), r.once(T.BUFFER_FLUSHED, () => {
          var o;
          (o = this.hls) == null || o.trigger(T.AUDIO_TRACK_SWITCHED, t);
        }), r.trigger(T.BUFFER_FLUSHING, {
          startOffset: 0,
          endOffset: Number.POSITIVE_INFINITY,
          type: null
        });
        return;
      }
      r.trigger(T.AUDIO_TRACK_SWITCHED, t);
    }
  }
  onAudioTrackSwitched(e, t) {
    const r = ya(t.url, this.hls);
    if (r) {
      const s = this.videoBuffer;
      s && this.mediaBuffer !== s && (this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = s);
    }
    this.altAudio = r ? 2 : 0, this.tick();
  }
  onBufferCreated(e, t) {
    const r = t.tracks;
    let s, i, o = !1;
    for (const a in r) {
      const l = r[a];
      if (l.id === "main") {
        if (i = a, s = l, a === "video") {
          const c = r[a];
          c && (this.videoBuffer = c.buffer);
        }
      } else
        o = !0;
    }
    o && s ? (this.log(`Alternate track found, use ${i}.buffered to schedule main fragment loading`), this.mediaBuffer = s.buffer) : this.mediaBuffer = this.media;
  }
  onFragBuffered(e, t) {
    const {
      frag: r,
      part: s
    } = t, i = r.type === he.MAIN;
    if (i) {
      if (this.fragContextChanged(r)) {
        this.warn(`Fragment ${r.sn}${s ? " p: " + s.index : ""} of level ${r.level} finished buffering, but was aborted. state: ${this.state}`), this.state === Q.PARSED && (this.state = Q.IDLE);
        return;
      }
      const a = s ? s.stats : r.stats;
      this.fragLastKbps = Math.round(8 * a.total / (a.buffering.end - a.loading.first)), Yt(r) && (this.fragPrevious = r), this.fragBufferedComplete(r, s);
    }
    const o = this.media;
    o && (!this._hasEnoughToStart && Le.getBuffered(o).length && (this._hasEnoughToStart = !0, this.seekToStartPos()), i && this.tick());
  }
  get hasEnoughToStart() {
    return this._hasEnoughToStart;
  }
  onError(e, t) {
    var r;
    if (t.fatal) {
      this.state = Q.ERROR;
      return;
    }
    switch (t.details) {
      case Y.FRAG_GAP:
      case Y.FRAG_PARSING_ERROR:
      case Y.FRAG_DECRYPT_ERROR:
      case Y.FRAG_LOAD_ERROR:
      case Y.FRAG_LOAD_TIMEOUT:
      case Y.KEY_LOAD_ERROR:
      case Y.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(he.MAIN, t);
        break;
      case Y.LEVEL_LOAD_ERROR:
      case Y.LEVEL_LOAD_TIMEOUT:
      case Y.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === Q.WAITING_LEVEL && ((r = t.context) == null ? void 0 : r.type) === Ke.LEVEL && (this.state = Q.IDLE);
        break;
      case Y.BUFFER_ADD_CODEC_ERROR:
      case Y.BUFFER_APPEND_ERROR:
        if (t.parent !== "main")
          return;
        this.resetLoadingState();
        break;
      case Y.BUFFER_FULL_ERROR:
        if (t.parent !== "main")
          return;
        this.reduceLengthAndFlushBuffer(t) && this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
        break;
      case Y.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  onFragLoadEmergencyAborted() {
    this.state = Q.IDLE, this._hasEnoughToStart || (this.startFragRequested = !1, this.nextLoadPosition = this.lastCurrentTime), this.tickImmediate();
  }
  onBufferFlushed(e, {
    type: t
  }) {
    if (t !== lt.AUDIO || !this.altAudio) {
      const r = (t === lt.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
      r && (this.afterBufferFlushed(r, t, he.MAIN), this.tick());
    }
  }
  onLevelsUpdated(e, t) {
    this.level > -1 && this.fragCurrent && (this.level = this.fragCurrent.level, this.level === -1 && this.resetWhenMissingContext(this.fragCurrent)), this.levels = t.levels;
  }
  swapAudioCodec() {
    this.audioCodecSwap = !this.audioCodecSwap;
  }
  /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */
  seekToStartPos() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.currentTime;
    let r = this.startPosition;
    if (r >= 0 && t < r) {
      if (e.seeking) {
        this.log(`could not seek to ${r}, already seeking at ${t}`);
        return;
      }
      const s = this.timelineOffset;
      s && r && (r += s);
      const i = this.getLevelDetails(), o = Le.getBuffered(e), a = o.length ? o.start(0) : 0, l = a - r, c = Math.max(this.config.maxBufferHole, this.config.maxFragLookUpTolerance);
      (this.config.startOnSegmentBoundary || l > 0 && (l < c || this.loadingParts && l < 2 * ((i == null ? void 0 : i.partTarget) || 0))) && (this.log(`adjusting start position by ${l} to match buffer start`), r += l, this.startPosition = r), t < r && (this.log(`seek to target start position ${r} from current time ${t} buffer start ${a}`), e.currentTime = r);
    }
  }
  _getAudioCodec(e) {
    let t = this.config.defaultAudioCodec || e.audioCodec;
    return this.audioCodecSwap && t && (this.log("Swapping audio codec"), t.indexOf("mp4a.40.5") !== -1 ? t = "mp4a.40.2" : t = "mp4a.40.5"), t;
  }
  _loadBitrateTestFrag(e, t) {
    e.bitrateTest = !0, this._doFragLoad(e, t).then((r) => {
      const {
        hls: s
      } = this, i = r == null ? void 0 : r.frag;
      if (!i || this.fragContextChanged(i))
        return;
      t.fragmentError = 0, this.state = Q.IDLE, this.startFragRequested = !1, this.bitrateTest = !1;
      const o = i.stats;
      o.parsing.start = o.parsing.end = o.buffering.start = o.buffering.end = self.performance.now(), s.trigger(T.FRAG_LOADED, r), i.bitrateTest = !1;
    });
  }
  _handleTransmuxComplete(e) {
    var t;
    const r = this.playlistType, {
      hls: s
    } = this, {
      remuxResult: i,
      chunkMeta: o
    } = e, a = this.getCurrentContext(o);
    if (!a) {
      this.resetWhenMissingContext(o);
      return;
    }
    const {
      frag: l,
      part: c,
      level: u
    } = a, {
      video: d,
      text: h,
      id3: f,
      initSegment: p
    } = i, {
      details: y
    } = u, m = this.altAudio ? void 0 : i.audio;
    if (this.fragContextChanged(l)) {
      this.fragmentTracker.removeFragment(l);
      return;
    }
    if (this.state = Q.PARSING, p) {
      if (p != null && p.tracks) {
        const A = l.initSegment || l;
        this._bufferInitSegment(u, p.tracks, A, o), s.trigger(T.FRAG_PARSING_INIT_SEGMENT, {
          frag: A,
          id: r,
          tracks: p.tracks
        });
      }
      const b = p.initPTS, C = p.timescale;
      ae(b) && (this.initPTS[l.cc] = {
        baseTime: b,
        timescale: C
      }, s.trigger(T.INIT_PTS_FOUND, {
        frag: l,
        id: r,
        initPTS: b,
        timescale: C
      }));
    }
    if (d && y) {
      m && d.type === "audiovideo" && this.logMuxedErr(l);
      const b = y.fragments[l.sn - 1 - y.startSN], C = l.sn === y.startSN, A = !b || l.cc > b.cc;
      if (i.independent !== !1) {
        const {
          startPTS: P,
          endPTS: I,
          startDTS: U,
          endDTS: j
        } = d;
        if (c)
          c.elementaryStreams[d.type] = {
            startPTS: P,
            endPTS: I,
            startDTS: U,
            endDTS: j
          };
        else if (d.firstKeyFrame && d.independent && o.id === 1 && !A && (this.couldBacktrack = !0), d.dropped && d.independent) {
          const G = this.getMainFwdBufferInfo(), F = (G ? G.end : this.getLoadPosition()) + this.config.maxBufferHole, B = d.firstKeyFramePTS ? d.firstKeyFramePTS : P;
          if (!C && F < B - this.config.maxBufferHole && !A) {
            this.backtrack(l);
            return;
          } else A && (l.gap = !0);
          l.setElementaryStreamInfo(d.type, l.start, I, l.start, j, !0);
        } else C && P - (y.appliedTimelineOffset || 0) > Bo && (l.gap = !0);
        l.setElementaryStreamInfo(d.type, P, I, U, j), this.backtrackFragment && (this.backtrackFragment = l), this.bufferFragmentData(d, l, c, o, C || A);
      } else if (C || A)
        l.gap = !0;
      else {
        this.backtrack(l);
        return;
      }
    }
    if (m) {
      const {
        startPTS: b,
        endPTS: C,
        startDTS: A,
        endDTS: P
      } = m;
      c && (c.elementaryStreams[lt.AUDIO] = {
        startPTS: b,
        endPTS: C,
        startDTS: A,
        endDTS: P
      }), l.setElementaryStreamInfo(lt.AUDIO, b, C, A, P), this.bufferFragmentData(m, l, c, o);
    }
    if (y && f != null && (t = f.samples) != null && t.length) {
      const b = {
        id: r,
        frag: l,
        details: y,
        samples: f.samples
      };
      s.trigger(T.FRAG_PARSING_METADATA, b);
    }
    if (y && h) {
      const b = {
        id: r,
        frag: l,
        details: y,
        samples: h.samples
      };
      s.trigger(T.FRAG_PARSING_USERDATA, b);
    }
  }
  logMuxedErr(e) {
    this.warn(`${Yt(e) ? "Media" : "Init"} segment with muxed audiovideo where only video expected: ${e.url}`);
  }
  _bufferInitSegment(e, t, r, s) {
    if (this.state !== Q.PARSING)
      return;
    this.audioOnly = !!t.audio && !t.video, this.altAudio && !this.audioOnly && (delete t.audio, t.audiovideo && this.logMuxedErr(r));
    const {
      audio: i,
      video: o,
      audiovideo: a
    } = t;
    if (i) {
      let c = Ro(i.codec, e.audioCodec);
      c === "mp4a" && (c = "mp4a.40.5");
      const u = navigator.userAgent.toLowerCase();
      if (this.audioCodecSwitch) {
        c && (c.indexOf("mp4a.40.5") !== -1 ? c = "mp4a.40.2" : c = "mp4a.40.5");
        const d = i.metadata;
        d && "channelCount" in d && (d.channelCount || 1) !== 1 && u.indexOf("firefox") === -1 && (c = "mp4a.40.5");
      }
      c && c.indexOf("mp4a.40.5") !== -1 && u.indexOf("android") !== -1 && i.container !== "audio/mpeg" && (c = "mp4a.40.2", this.log(`Android: force audio codec to ${c}`)), e.audioCodec && e.audioCodec !== c && this.log(`Swapping manifest audio codec "${e.audioCodec}" for "${c}"`), i.levelCodec = c, i.id = he.MAIN, this.log(`Init audio buffer, container:${i.container}, codecs[selected/level/parsed]=[${c || ""}/${e.audioCodec || ""}/${i.codec}]`), delete t.audiovideo;
    }
    if (o) {
      o.levelCodec = e.videoCodec, o.id = he.MAIN;
      const c = o.codec;
      if ((c == null ? void 0 : c.length) === 4)
        switch (c) {
          case "hvc1":
          case "hev1":
            o.codec = "hvc1.1.6.L120.90";
            break;
          case "av01":
            o.codec = "av01.0.04M.08";
            break;
          case "avc1":
            o.codec = "avc1.42e01e";
            break;
        }
      this.log(`Init video buffer, container:${o.container}, codecs[level/parsed]=[${e.videoCodec || ""}/${c}]${o.codec !== c ? " parsed-corrected=" + o.codec : ""}${o.supplemental ? " supplemental=" + o.supplemental : ""}`), delete t.audiovideo;
    }
    a && (this.log(`Init audiovideo buffer, container:${a.container}, codecs[level/parsed]=[${e.codecs}/${a.codec}]`), delete t.video, delete t.audio);
    const l = Object.keys(t);
    if (l.length) {
      if (this.hls.trigger(T.BUFFER_CODECS, t), !this.hls)
        return;
      l.forEach((c) => {
        const d = t[c].initSegment;
        d != null && d.byteLength && this.hls.trigger(T.BUFFER_APPENDING, {
          type: c,
          data: d,
          frag: r,
          part: null,
          chunkMeta: s,
          parent: r.type
        });
      });
    }
    this.tickImmediate();
  }
  getMainFwdBufferInfo() {
    const e = this.mediaBuffer && this.altAudio === 2 ? this.mediaBuffer : this.media;
    return this.getFwdBufferInfo(e, he.MAIN);
  }
  get maxBufferLength() {
    const {
      levels: e,
      level: t
    } = this, r = e == null ? void 0 : e[t];
    return r ? this.getMaxBufferLength(r.maxBitrate) : this.config.maxBufferLength;
  }
  backtrack(e) {
    this.couldBacktrack = !0, this.backtrackFragment = e, this.resetTransmuxer(), this.flushBufferGap(e), this.fragmentTracker.removeFragment(e), this.fragPrevious = null, this.nextLoadPosition = e.start, this.state = Q.IDLE;
  }
  checkFragmentChanged() {
    const e = this.media;
    let t = null;
    if (e && e.readyState > 1 && e.seeking === !1) {
      const r = e.currentTime;
      if (Le.isBuffered(e, r) ? t = this.getAppendedFrag(r) : Le.isBuffered(e, r + 0.1) && (t = this.getAppendedFrag(r + 0.1)), t) {
        this.backtrackFragment = null;
        const s = this.fragPlaying, i = t.level;
        (!s || t.sn !== s.sn || s.level !== i) && (this.fragPlaying = t, this.hls.trigger(T.FRAG_CHANGED, {
          frag: t
        }), (!s || s.level !== i) && this.hls.trigger(T.LEVEL_SWITCHED, {
          level: i
        }));
      }
    }
  }
  get nextLevel() {
    const e = this.nextBufferedFrag;
    return e ? e.level : -1;
  }
  get currentFrag() {
    var e;
    if (this.fragPlaying)
      return this.fragPlaying;
    const t = ((e = this.media) == null ? void 0 : e.currentTime) || this.lastCurrentTime;
    return ae(t) ? this.getAppendedFrag(t) : null;
  }
  get currentProgramDateTime() {
    var e;
    const t = ((e = this.media) == null ? void 0 : e.currentTime) || this.lastCurrentTime;
    if (ae(t)) {
      const r = this.getLevelDetails(), s = this.currentFrag || (r ? gs(null, r.fragments, t) : null);
      if (s) {
        const i = s.programDateTime;
        if (i !== null) {
          const o = i + (t - s.start) * 1e3;
          return new Date(o);
        }
      }
    }
    return null;
  }
  get currentLevel() {
    const e = this.currentFrag;
    return e ? e.level : -1;
  }
  get nextBufferedFrag() {
    const e = this.currentFrag;
    return e ? this.followingBufferedFrag(e) : null;
  }
  get forceStartLoad() {
    return this._forceStartLoad;
  }
}
class RA {
  constructor(e) {
    this.config = void 0, this.keyUriToKeyInfo = {}, this.emeController = null, this.config = e;
  }
  abort(e) {
    for (const r in this.keyUriToKeyInfo) {
      const s = this.keyUriToKeyInfo[r].loader;
      if (s) {
        var t;
        if (e && e !== ((t = s.context) == null ? void 0 : t.frag.type))
          return;
        s.abort();
      }
    }
  }
  detach() {
    for (const e in this.keyUriToKeyInfo) {
      const t = this.keyUriToKeyInfo[e];
      (t.mediaKeySessionContext || t.decryptdata.isCommonEncryption) && delete this.keyUriToKeyInfo[e];
    }
  }
  destroy() {
    this.detach();
    for (const e in this.keyUriToKeyInfo) {
      const t = this.keyUriToKeyInfo[e].loader;
      t && t.destroy();
    }
    this.keyUriToKeyInfo = {};
  }
  createKeyLoadError(e, t = Y.KEY_LOAD_ERROR, r, s, i) {
    return new En({
      type: ge.NETWORK_ERROR,
      details: t,
      fatal: !1,
      frag: e,
      response: i,
      error: r,
      networkDetails: s
    });
  }
  loadClear(e, t) {
    if (this.emeController && this.config.emeEnabled && !this.emeController.getSelectedKeySystemFormats().length) {
      if (t.length) {
        const {
          sn: r,
          cc: s
        } = e;
        for (let i = 0; i < t.length; i++) {
          const o = t[i];
          if (s <= o.cc && (r === "initSegment" || o.sn === "initSegment" || r < o.sn))
            return this.emeController.selectKeySystemFormat(o).then((a) => {
              if (o.setKeyFormat(a), this.emeController && this.config.requireKeySystemAccessOnStart) {
                const l = ko(a);
                if (l)
                  return this.emeController.getKeySystemAccess([l]);
              }
            });
        }
      } else if (this.config.requireKeySystemAccessOnStart) {
        const r = di(this.config);
        if (r.length)
          return this.emeController.getKeySystemAccess(r);
      }
    }
    return null;
  }
  load(e) {
    return !e.decryptdata && e.encrypted && this.emeController && this.config.emeEnabled ? this.emeController.selectKeySystemFormat(e).then((t) => this.loadInternal(e, t)) : this.loadInternal(e);
  }
  loadInternal(e, t) {
    var r, s;
    t && e.setKeyFormat(t);
    const i = e.decryptdata;
    if (!i) {
      const c = new Error(t ? `Expected frag.decryptdata to be defined after setting format ${t}` : "Missing decryption data on fragment in onKeyLoading");
      return Promise.reject(this.createKeyLoadError(e, Y.KEY_LOAD_ERROR, c));
    }
    const o = i.uri;
    if (!o)
      return Promise.reject(this.createKeyLoadError(e, Y.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${o}"`)));
    let a = this.keyUriToKeyInfo[o];
    if ((r = a) != null && r.decryptdata.key)
      return i.key = a.decryptdata.key, Promise.resolve({
        frag: e,
        keyInfo: a
      });
    if ((s = a) != null && s.keyLoadPromise) {
      var l;
      switch ((l = a.mediaKeySessionContext) == null ? void 0 : l.keyStatus) {
        case void 0:
        case "status-pending":
        case "usable":
        case "usable-in-future":
          return a.keyLoadPromise.then((c) => (i.key = c.keyInfo.decryptdata.key, {
            frag: e,
            keyInfo: a
          }));
      }
    }
    switch (a = this.keyUriToKeyInfo[o] = {
      decryptdata: i,
      keyLoadPromise: null,
      loader: null,
      mediaKeySessionContext: null
    }, i.method) {
      case "ISO-23001-7":
      case "SAMPLE-AES":
      case "SAMPLE-AES-CENC":
      case "SAMPLE-AES-CTR":
        return i.keyFormat === "identity" ? this.loadKeyHTTP(a, e) : this.loadKeyEME(a, e);
      case "AES-128":
      case "AES-256":
      case "AES-256-CTR":
        return this.loadKeyHTTP(a, e);
      default:
        return Promise.reject(this.createKeyLoadError(e, Y.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${i.method}"`)));
    }
  }
  loadKeyEME(e, t) {
    const r = {
      frag: t,
      keyInfo: e
    };
    if (this.emeController && this.config.emeEnabled) {
      const s = this.emeController.loadKey(r);
      if (s)
        return (e.keyLoadPromise = s.then((i) => (e.mediaKeySessionContext = i, r))).catch((i) => {
          throw e.keyLoadPromise = null, i;
        });
    }
    return Promise.resolve(r);
  }
  loadKeyHTTP(e, t) {
    const r = this.config, s = r.loader, i = new s(r);
    return t.keyLoader = e.loader = i, e.keyLoadPromise = new Promise((o, a) => {
      const l = {
        keyInfo: e,
        frag: t,
        responseType: "arraybuffer",
        url: e.decryptdata.uri
      }, c = r.keyLoadPolicy.default, u = {
        loadPolicy: c,
        timeout: c.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, d = {
        onSuccess: (h, f, p, y) => {
          const {
            frag: m,
            keyInfo: b,
            url: C
          } = p;
          if (!m.decryptdata || b !== this.keyUriToKeyInfo[C])
            return a(this.createKeyLoadError(m, Y.KEY_LOAD_ERROR, new Error("after key load, decryptdata unset or changed"), y));
          b.decryptdata.key = m.decryptdata.key = new Uint8Array(h.data), m.keyLoader = null, b.loader = null, o({
            frag: m,
            keyInfo: b
          });
        },
        onError: (h, f, p, y) => {
          this.resetLoader(f), a(this.createKeyLoadError(t, Y.KEY_LOAD_ERROR, new Error(`HTTP Error ${h.code} loading key ${h.text}`), p, rt({
            url: l.url,
            data: void 0
          }, h)));
        },
        onTimeout: (h, f, p) => {
          this.resetLoader(f), a(this.createKeyLoadError(t, Y.KEY_LOAD_TIMEOUT, new Error("key loading timed out"), p));
        },
        onAbort: (h, f, p) => {
          this.resetLoader(f), a(this.createKeyLoadError(t, Y.INTERNAL_ABORTED, new Error("key loading aborted"), p));
        }
      };
      i.load(l, u, d);
    });
  }
  resetLoader(e) {
    const {
      frag: t,
      keyInfo: r,
      url: s
    } = e, i = r.loader;
    t.keyLoader === i && (t.keyLoader = null, r.loader = null), delete this.keyUriToKeyInfo[s], i && i.destroy();
  }
}
function gf(n) {
  const {
    type: e
  } = n;
  switch (e) {
    case Ke.AUDIO_TRACK:
      return he.AUDIO;
    case Ke.SUBTITLE_TRACK:
      return he.SUBTITLE;
    default:
      return he.MAIN;
  }
}
function Wl(n, e) {
  let t = n.url;
  return (t === void 0 || t.indexOf("data:") === 0) && (t = e.url), t;
}
class CA {
  constructor(e) {
    this.hls = void 0, this.loaders = /* @__PURE__ */ Object.create(null), this.variableList = null, this.onManifestLoaded = this.checkAutostartLoad, this.hls = e, this.registerListeners();
  }
  startLoad(e) {
  }
  stopLoad() {
    this.destroyInternalLoaders();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(T.MANIFEST_LOADING, this.onManifestLoading, this), e.on(T.LEVEL_LOADING, this.onLevelLoading, this), e.on(T.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.on(T.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this), e.on(T.LEVELS_UPDATED, this.onLevelsUpdated, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(T.MANIFEST_LOADING, this.onManifestLoading, this), e.off(T.LEVEL_LOADING, this.onLevelLoading, this), e.off(T.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.off(T.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this), e.off(T.LEVELS_UPDATED, this.onLevelsUpdated, this);
  }
  /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */
  createInternalLoader(e) {
    const t = this.hls.config, r = t.pLoader, s = t.loader, i = r || s, o = new i(t);
    return this.loaders[e.type] = o, o;
  }
  getInternalLoader(e) {
    return this.loaders[e.type];
  }
  resetInternalLoader(e) {
    this.loaders[e] && delete this.loaders[e];
  }
  /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */
  destroyInternalLoaders() {
    for (const e in this.loaders) {
      const t = this.loaders[e];
      t && t.destroy(), this.resetInternalLoader(e);
    }
  }
  destroy() {
    this.variableList = null, this.unregisterListeners(), this.destroyInternalLoaders();
  }
  onManifestLoading(e, t) {
    const {
      url: r
    } = t;
    this.variableList = null, this.load({
      id: null,
      level: 0,
      responseType: "text",
      type: Ke.MANIFEST,
      url: r,
      deliveryDirectives: null,
      levelOrTrack: null
    });
  }
  onLevelLoading(e, t) {
    const {
      id: r,
      level: s,
      pathwayId: i,
      url: o,
      deliveryDirectives: a,
      levelInfo: l
    } = t;
    this.load({
      id: r,
      level: s,
      pathwayId: i,
      responseType: "text",
      type: Ke.LEVEL,
      url: o,
      deliveryDirectives: a,
      levelOrTrack: l
    });
  }
  onAudioTrackLoading(e, t) {
    const {
      id: r,
      groupId: s,
      url: i,
      deliveryDirectives: o,
      track: a
    } = t;
    this.load({
      id: r,
      groupId: s,
      level: null,
      responseType: "text",
      type: Ke.AUDIO_TRACK,
      url: i,
      deliveryDirectives: o,
      levelOrTrack: a
    });
  }
  onSubtitleTrackLoading(e, t) {
    const {
      id: r,
      groupId: s,
      url: i,
      deliveryDirectives: o,
      track: a
    } = t;
    this.load({
      id: r,
      groupId: s,
      level: null,
      responseType: "text",
      type: Ke.SUBTITLE_TRACK,
      url: i,
      deliveryDirectives: o,
      levelOrTrack: a
    });
  }
  onLevelsUpdated(e, t) {
    const r = this.loaders[Ke.LEVEL];
    if (r) {
      const s = r.context;
      s && !t.levels.some((i) => i === s.levelOrTrack) && (r.abort(), delete this.loaders[Ke.LEVEL]);
    }
  }
  load(e) {
    var t;
    const r = this.hls.config;
    let s = this.getInternalLoader(e);
    if (s) {
      const c = this.hls.logger, u = s.context;
      if (u && u.levelOrTrack === e.levelOrTrack && (u.url === e.url || u.deliveryDirectives && !e.deliveryDirectives)) {
        u.url === e.url ? c.log(`[playlist-loader]: ignore ${e.url} ongoing request`) : c.log(`[playlist-loader]: ignore ${e.url} in favor of ${u.url}`);
        return;
      }
      c.log(`[playlist-loader]: aborting previous loader for type: ${e.type}`), s.abort();
    }
    let i;
    if (e.type === Ke.MANIFEST ? i = r.manifestLoadPolicy.default : i = st({}, r.playlistLoadPolicy.default, {
      timeoutRetry: null,
      errorRetry: null
    }), s = this.createInternalLoader(e), ae((t = e.deliveryDirectives) == null ? void 0 : t.part)) {
      let c;
      if (e.type === Ke.LEVEL && e.level !== null ? c = this.hls.levels[e.level].details : e.type === Ke.AUDIO_TRACK && e.id !== null ? c = this.hls.audioTracks[e.id].details : e.type === Ke.SUBTITLE_TRACK && e.id !== null && (c = this.hls.subtitleTracks[e.id].details), c) {
        const u = c.partTarget, d = c.targetduration;
        if (u && d) {
          const h = Math.max(u * 3, d * 0.8) * 1e3;
          i = st({}, i, {
            maxTimeToFirstByteMs: Math.min(h, i.maxTimeToFirstByteMs),
            maxLoadTimeMs: Math.min(h, i.maxTimeToFirstByteMs)
          });
        }
      }
    }
    const o = i.errorRetry || i.timeoutRetry || {}, a = {
      loadPolicy: i,
      timeout: i.maxLoadTimeMs,
      maxRetry: o.maxNumRetry || 0,
      retryDelay: o.retryDelayMs || 0,
      maxRetryDelay: o.maxRetryDelayMs || 0
    }, l = {
      onSuccess: (c, u, d, h) => {
        const f = this.getInternalLoader(d);
        this.resetInternalLoader(d.type);
        const p = c.data;
        if (p.indexOf("#EXTM3U") !== 0) {
          this.handleManifestParsingError(c, d, new Error("no EXTM3U delimiter"), h || null, u);
          return;
        }
        u.parsing.start = performance.now(), on.isMediaPlaylist(p) || d.type !== Ke.MANIFEST ? this.handleTrackOrLevelPlaylist(c, u, d, h || null, f) : this.handleMasterPlaylist(c, u, d, h);
      },
      onError: (c, u, d, h) => {
        this.handleNetworkError(u, d, !1, c, h);
      },
      onTimeout: (c, u, d) => {
        this.handleNetworkError(u, d, !0, void 0, c);
      }
    };
    s.load(e, a, l);
  }
  checkAutostartLoad() {
    if (!this.hls)
      return;
    const {
      config: {
        autoStartLoad: e,
        startPosition: t
      },
      forceStartLoad: r
    } = this.hls;
    (e || r) && (this.hls.logger.log(`${e ? "auto" : "force"} startLoad with configured startPosition ${t}`), this.hls.startLoad(t));
  }
  handleMasterPlaylist(e, t, r, s) {
    const i = this.hls, o = e.data, a = Wl(e, r), l = on.parseMasterPlaylist(o, a);
    if (l.playlistParsingError) {
      this.handleManifestParsingError(e, r, l.playlistParsingError, s, t);
      return;
    }
    const {
      contentSteering: c,
      levels: u,
      sessionData: d,
      sessionKeys: h,
      startTimeOffset: f,
      variableList: p
    } = l;
    this.variableList = p;
    const {
      AUDIO: y = [],
      SUBTITLES: m,
      "CLOSED-CAPTIONS": b
    } = on.parseMasterPlaylistMedia(o, a, l);
    y.length && !y.some((A) => !A.url) && u[0].audioCodec && !u[0].attrs.AUDIO && (this.hls.logger.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"), y.unshift({
      type: "main",
      name: "main",
      groupId: "main",
      default: !1,
      autoselect: !1,
      forced: !1,
      id: -1,
      attrs: new yt({}),
      bitrate: 0,
      url: ""
    })), i.trigger(T.MANIFEST_LOADED, {
      levels: u,
      audioTracks: y,
      subtitles: m,
      captions: b,
      contentSteering: c,
      url: a,
      stats: t,
      networkDetails: s,
      sessionData: d,
      sessionKeys: h,
      startTimeOffset: f,
      variableList: p
    });
  }
  handleTrackOrLevelPlaylist(e, t, r, s, i) {
    const o = this.hls, {
      id: a,
      level: l,
      type: c
    } = r, u = Wl(e, r), d = ae(l) ? l : ae(a) ? a : 0, h = gf(r), f = on.parseLevelPlaylist(e.data, u, d, h, 0, this.variableList);
    if (c === Ke.MANIFEST) {
      const p = {
        attrs: new yt({}),
        bitrate: 0,
        details: f,
        name: "",
        url: u
      };
      f.requestScheduled = t.loading.start + mp(f, 0), o.trigger(T.MANIFEST_LOADED, {
        levels: [p],
        audioTracks: [],
        url: u,
        stats: t,
        networkDetails: s,
        sessionData: null,
        sessionKeys: null,
        contentSteering: null,
        startTimeOffset: null,
        variableList: null
      });
    }
    t.parsing.end = performance.now(), r.levelDetails = f, this.handlePlaylistLoaded(f, e, t, r, s, i);
  }
  handleManifestParsingError(e, t, r, s, i) {
    this.hls.trigger(T.ERROR, {
      type: ge.NETWORK_ERROR,
      details: Y.MANIFEST_PARSING_ERROR,
      fatal: t.type === Ke.MANIFEST,
      url: e.url,
      err: r,
      error: r,
      reason: r.message,
      response: e,
      context: t,
      networkDetails: s,
      stats: i
    });
  }
  handleNetworkError(e, t, r = !1, s, i) {
    let o = `A network ${r ? "timeout" : "error" + (s ? " (status " + s.code + ")" : "")} occurred while loading ${e.type}`;
    e.type === Ke.LEVEL ? o += `: ${e.level} id: ${e.id}` : (e.type === Ke.AUDIO_TRACK || e.type === Ke.SUBTITLE_TRACK) && (o += ` id: ${e.id} group-id: "${e.groupId}"`);
    const a = new Error(o);
    this.hls.logger.warn(`[playlist-loader]: ${o}`);
    let l = Y.UNKNOWN, c = !1;
    const u = this.getInternalLoader(e);
    switch (e.type) {
      case Ke.MANIFEST:
        l = r ? Y.MANIFEST_LOAD_TIMEOUT : Y.MANIFEST_LOAD_ERROR, c = !0;
        break;
      case Ke.LEVEL:
        l = r ? Y.LEVEL_LOAD_TIMEOUT : Y.LEVEL_LOAD_ERROR, c = !1;
        break;
      case Ke.AUDIO_TRACK:
        l = r ? Y.AUDIO_TRACK_LOAD_TIMEOUT : Y.AUDIO_TRACK_LOAD_ERROR, c = !1;
        break;
      case Ke.SUBTITLE_TRACK:
        l = r ? Y.SUBTITLE_TRACK_LOAD_TIMEOUT : Y.SUBTITLE_LOAD_ERROR, c = !1;
        break;
    }
    u && this.resetInternalLoader(e.type);
    const d = {
      type: ge.NETWORK_ERROR,
      details: l,
      fatal: c,
      url: e.url,
      loader: u,
      context: e,
      error: a,
      networkDetails: t,
      stats: i
    };
    if (s) {
      const h = (t == null ? void 0 : t.url) || e.url;
      d.response = rt({
        url: h,
        data: void 0
      }, s);
    }
    this.hls.trigger(T.ERROR, d);
  }
  handlePlaylistLoaded(e, t, r, s, i, o) {
    const a = this.hls, {
      type: l,
      level: c,
      id: u,
      groupId: d,
      deliveryDirectives: h
    } = s, f = Wl(t, s), p = gf(s), y = typeof s.level == "number" && p === he.MAIN ? c : void 0;
    if (!e.fragments.length) {
      const b = e.playlistParsingError = new Error("No Segments found in Playlist");
      a.trigger(T.ERROR, {
        type: ge.NETWORK_ERROR,
        details: Y.LEVEL_EMPTY_ERROR,
        fatal: !1,
        url: f,
        error: b,
        reason: b.message,
        response: t,
        context: s,
        level: y,
        parent: p,
        networkDetails: i,
        stats: r
      });
      return;
    }
    e.targetduration || (e.playlistParsingError = new Error("Missing Target Duration"));
    const m = e.playlistParsingError;
    if (m) {
      if (this.hls.logger.warn(m), !a.config.ignorePlaylistParsingErrors) {
        a.trigger(T.ERROR, {
          type: ge.NETWORK_ERROR,
          details: Y.LEVEL_PARSING_ERROR,
          fatal: !1,
          url: f,
          error: m,
          reason: m.message,
          response: t,
          context: s,
          level: y,
          parent: p,
          networkDetails: i,
          stats: r
        });
        return;
      }
      e.playlistParsingError = null;
    }
    switch (e.live && o && (o.getCacheAge && (e.ageHeader = o.getCacheAge() || 0), (!o.getCacheAge || isNaN(e.ageHeader)) && (e.ageHeader = 0)), l) {
      case Ke.MANIFEST:
      case Ke.LEVEL:
        a.trigger(T.LEVEL_LOADED, {
          details: e,
          levelInfo: s.levelOrTrack || a.levels[0],
          level: y || 0,
          id: u || 0,
          stats: r,
          networkDetails: i,
          deliveryDirectives: h,
          withoutMultiVariant: l === Ke.MANIFEST
        });
        break;
      case Ke.AUDIO_TRACK:
        a.trigger(T.AUDIO_TRACK_LOADED, {
          details: e,
          track: s.levelOrTrack,
          id: u || 0,
          groupId: d || "",
          stats: r,
          networkDetails: i,
          deliveryDirectives: h
        });
        break;
      case Ke.SUBTITLE_TRACK:
        a.trigger(T.SUBTITLE_TRACK_LOADED, {
          details: e,
          track: s.levelOrTrack,
          id: u || 0,
          groupId: d || "",
          stats: r,
          networkDetails: i,
          deliveryDirectives: h
        });
        break;
    }
  }
}
class rn {
  /**
   * Get the video-dev/hls.js package version.
   */
  static get version() {
    return Ui;
  }
  /**
   * Check if the required MediaSource Extensions are available.
   */
  static isMSESupported() {
    return um();
  }
  /**
   * Check if MediaSource Extensions are available and isTypeSupported checks pass for any baseline codecs.
   */
  static isSupported() {
    return AA();
  }
  /**
   * Get the MediaSource global used for MSE playback (ManagedMediaSource, MediaSource, or WebKitMediaSource).
   */
  static getMediaSource() {
    return Zn();
  }
  static get Events() {
    return T;
  }
  static get MetadataSchema() {
    return Ir;
  }
  static get ErrorTypes() {
    return ge;
  }
  static get ErrorDetails() {
    return Y;
  }
  /**
   * Get the default configuration applied to new instances.
   */
  static get DefaultConfig() {
    return rn.defaultConfig ? rn.defaultConfig : hA;
  }
  /**
   * Replace the default configuration applied to new instances.
   */
  static set DefaultConfig(e) {
    rn.defaultConfig = e;
  }
  /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */
  constructor(e = {}) {
    this.config = void 0, this.userConfig = void 0, this.logger = void 0, this.coreComponents = void 0, this.networkControllers = void 0, this._emitter = new ju(), this._autoLevelCapping = -1, this._maxHdcpLevel = null, this.abrController = void 0, this.bufferController = void 0, this.capLevelController = void 0, this.latencyController = void 0, this.levelController = void 0, this.streamController = void 0, this.audioStreamController = void 0, this.subtititleStreamController = void 0, this.audioTrackController = void 0, this.subtitleTrackController = void 0, this.interstitialsController = void 0, this.gapController = void 0, this.emeController = void 0, this.cmcdController = void 0, this._media = null, this._url = null, this._sessionId = void 0, this.triggeringException = void 0, this.started = !1;
    const t = this.logger = XS(e.debug || !1, "Hls instance", e.assetPlayerId), r = this.config = gA(rn.DefaultConfig, e, t);
    this.userConfig = e, r.progressive && pA(r, t);
    const {
      abrController: s,
      bufferController: i,
      capLevelController: o,
      errorController: a,
      fpsController: l
    } = r, c = new a(this), u = this.abrController = new s(this), d = new Gb(this), h = r.interstitialsController, f = h ? this.interstitialsController = new h(this, rn) : null, p = this.bufferController = new i(this, d), y = this.capLevelController = new o(this), m = new l(this), b = new CA(this), C = r.contentSteeringController, A = C ? new C(this) : null, P = this.levelController = new wA(this, A), I = new bA(this), U = new RA(this.config), j = this.streamController = new LA(this, d, U), G = this.gapController = new xA(this, d);
    y.setStreamController(j), m.setStreamController(j);
    const F = [b, P, j];
    f && F.splice(1, 0, f), A && F.splice(1, 0, A), this.networkControllers = F;
    const B = [u, p, G, y, m, I, d];
    this.audioTrackController = this.createController(r.audioTrackController, F);
    const V = r.audioStreamController;
    V && F.push(this.audioStreamController = new V(this, d, U)), this.subtitleTrackController = this.createController(r.subtitleTrackController, F);
    const H = r.subtitleStreamController;
    H && F.push(this.subtititleStreamController = new H(this, d, U)), this.createController(r.timelineController, B), U.emeController = this.emeController = this.createController(r.emeController, B), this.cmcdController = this.createController(r.cmcdController, B), this.latencyController = this.createController(TA, B), this.coreComponents = B, F.push(c);
    const L = c.onErrorOut;
    typeof L == "function" && this.on(T.ERROR, L, c), this.on(T.MANIFEST_LOADED, b.onManifestLoaded, b);
  }
  createController(e, t) {
    if (e) {
      const r = new e(this);
      return t && t.push(r), r;
    }
    return null;
  }
  // Delegate the EventEmitter through the public API of Hls.js
  on(e, t, r = this) {
    this._emitter.on(e, t, r);
  }
  once(e, t, r = this) {
    this._emitter.once(e, t, r);
  }
  removeAllListeners(e) {
    this._emitter.removeAllListeners(e);
  }
  off(e, t, r = this, s) {
    this._emitter.off(e, t, r, s);
  }
  listeners(e) {
    return this._emitter.listeners(e);
  }
  emit(e, t, r) {
    return this._emitter.emit(e, t, r);
  }
  trigger(e, t) {
    if (this.config.debug)
      return this.emit(e, e, t);
    try {
      return this.emit(e, e, t);
    } catch (r) {
      if (this.logger.error("An internal error happened while handling event " + e + '. Error message: "' + r.message + '". Here is a stacktrace:', r), !this.triggeringException) {
        this.triggeringException = !0;
        const s = e === T.ERROR;
        this.trigger(T.ERROR, {
          type: ge.OTHER_ERROR,
          details: Y.INTERNAL_EXCEPTION,
          fatal: s,
          event: e,
          error: r
        }), this.triggeringException = !1;
      }
    }
    return !1;
  }
  listenerCount(e) {
    return this._emitter.listenerCount(e);
  }
  /**
   * Dispose of the instance
   */
  destroy() {
    this.logger.log("destroy"), this.trigger(T.DESTROYING, void 0), this.detachMedia(), this.removeAllListeners(), this._autoLevelCapping = -1, this._url = null, this.networkControllers.forEach((t) => t.destroy()), this.networkControllers.length = 0, this.coreComponents.forEach((t) => t.destroy()), this.coreComponents.length = 0;
    const e = this.config;
    e.xhrSetup = e.fetchSetup = void 0, this.userConfig = null;
  }
  /**
   * Attaches Hls.js to a media element
   */
  attachMedia(e) {
    if (!e || "media" in e && !e.media) {
      const i = new Error(`attachMedia failed: invalid argument (${e})`);
      this.trigger(T.ERROR, {
        type: ge.OTHER_ERROR,
        details: Y.ATTACH_MEDIA_ERROR,
        fatal: !0,
        error: i
      });
      return;
    }
    this.logger.log("attachMedia"), this._media && (this.logger.warn("media must be detached before attaching"), this.detachMedia());
    const t = "media" in e, r = t ? e.media : e, s = t ? e : {
      media: r
    };
    this._media = r, this.trigger(T.MEDIA_ATTACHING, s);
  }
  /**
   * Detach Hls.js from the media
   */
  detachMedia() {
    this.logger.log("detachMedia"), this.trigger(T.MEDIA_DETACHING, {}), this._media = null;
  }
  /**
   * Detach HTMLMediaElement, MediaSource, and SourceBuffers without reset, for attaching to another instance
   */
  transferMedia() {
    this._media = null;
    const e = this.bufferController.transferMedia();
    return this.trigger(T.MEDIA_DETACHING, {
      transferMedia: e
    }), e;
  }
  /**
   * Set the source URL. Can be relative or absolute.
   */
  loadSource(e) {
    this.stopLoad();
    const t = this.media, r = this._url, s = this._url = Pu.buildAbsoluteURL(self.location.href, e, {
      alwaysNormalize: !0
    });
    this._autoLevelCapping = -1, this._maxHdcpLevel = null, this.logger.log(`loadSource:${s}`), t && r && (r !== s || this.bufferController.hasSourceTypes()) && (this.detachMedia(), this.attachMedia(t)), this.trigger(T.MANIFEST_LOADING, {
      url: e
    });
  }
  /**
   * Gets the currently loaded URL
   */
  get url() {
    return this._url;
  }
  /**
   * Whether or not enough has been buffered to seek to start position or use `media.currentTime` to determine next load position
   */
  get hasEnoughToStart() {
    return this.streamController.hasEnoughToStart;
  }
  /**
   * Get the startPosition set on startLoad(position) or on autostart with config.startPosition
   */
  get startPosition() {
    return this.streamController.startPositionValue;
  }
  /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */
  startLoad(e = -1, t) {
    this.logger.log(`startLoad(${e + (t ? ", <skip seek to start>" : "")})`), this.started = !0, this.resumeBuffering();
    for (let r = 0; r < this.networkControllers.length && (this.networkControllers[r].startLoad(e, t), !(!this.started || !this.networkControllers)); r++)
      ;
  }
  /**
   * Stop loading of any stream data.
   */
  stopLoad() {
    this.logger.log("stopLoad"), this.started = !1;
    for (let e = 0; e < this.networkControllers.length && (this.networkControllers[e].stopLoad(), !(this.started || !this.networkControllers)); e++)
      ;
  }
  /**
   * Returns whether loading, toggled with `startLoad()` and `stopLoad()`, is active or not`.
   */
  get loadingEnabled() {
    return this.started;
  }
  /**
   * Returns state of fragment loading toggled by calling `pauseBuffering()` and `resumeBuffering()`.
   */
  get bufferingEnabled() {
    return this.streamController.bufferingEnabled;
  }
  /**
   * Resumes stream controller segment loading after `pauseBuffering` has been called.
   */
  resumeBuffering() {
    this.bufferingEnabled || (this.logger.log("resume buffering"), this.networkControllers.forEach((e) => {
      e.resumeBuffering && e.resumeBuffering();
    }));
  }
  /**
   * Prevents stream controller from loading new segments until `resumeBuffering` is called.
   * This allows for media buffering to be paused without interupting playlist loading.
   */
  pauseBuffering() {
    this.bufferingEnabled && (this.logger.log("pause buffering"), this.networkControllers.forEach((e) => {
      e.pauseBuffering && e.pauseBuffering();
    }));
  }
  get inFlightFragments() {
    const e = {
      [he.MAIN]: this.streamController.inFlightFrag
    };
    return this.audioStreamController && (e[he.AUDIO] = this.audioStreamController.inFlightFrag), this.subtititleStreamController && (e[he.SUBTITLE] = this.subtititleStreamController.inFlightFrag), e;
  }
  /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */
  swapAudioCodec() {
    this.logger.log("swapAudioCodec"), this.streamController.swapAudioCodec();
  }
  /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */
  recoverMediaError() {
    this.logger.log("recoverMediaError");
    const e = this._media, t = e == null ? void 0 : e.currentTime;
    this.detachMedia(), e && (this.attachMedia(e), t && this.startLoad(t));
  }
  removeLevel(e) {
    this.levelController.removeLevel(e);
  }
  /**
   * @returns a UUID for this player instance
   */
  get sessionId() {
    let e = this._sessionId;
    return e || (e = this._sessionId = xw()), e;
  }
  /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
   */
  get levels() {
    const e = this.levelController.levels;
    return e || [];
  }
  /**
   * @returns LevelDetails of last loaded level (variant) or `null` prior to loading a media playlist.
   */
  get latestLevelDetails() {
    return this.streamController.getLevelDetails() || null;
  }
  /**
   * @returns Level object of selected level (variant) or `null` prior to selecting a level or once the level is removed.
   */
  get loadLevelObj() {
    return this.levelController.loadLevelObj;
  }
  /**
   * Index of quality level (variant) currently played
   */
  get currentLevel() {
    return this.streamController.currentLevel;
  }
  /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */
  set currentLevel(e) {
    this.logger.log(`set currentLevel:${e}`), this.levelController.manualLevel = e, this.streamController.immediateLevelSwitch();
  }
  /**
   * Index of next quality level loaded as scheduled by stream controller.
   */
  get nextLevel() {
    return this.streamController.nextLevel;
  }
  /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */
  set nextLevel(e) {
    this.logger.log(`set nextLevel:${e}`), this.levelController.manualLevel = e, this.streamController.nextLevelSwitch();
  }
  /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */
  get loadLevel() {
    return this.levelController.level;
  }
  /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */
  set loadLevel(e) {
    this.logger.log(`set loadLevel:${e}`), this.levelController.manualLevel = e;
  }
  /**
   * get next quality level loaded
   */
  get nextLoadLevel() {
    return this.levelController.nextLoadLevel;
  }
  /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */
  set nextLoadLevel(e) {
    this.levelController.nextLoadLevel = e;
  }
  /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */
  get firstLevel() {
    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
  }
  /**
   * Sets "first-level", see getter.
   */
  set firstLevel(e) {
    this.logger.log(`set firstLevel:${e}`), this.levelController.firstLevel = e;
  }
  /**
   * Return the desired start level for the first fragment that will be loaded.
   * The default value of -1 indicates automatic start level selection.
   * Setting hls.nextAutoLevel without setting a startLevel will result in
   * the nextAutoLevel value being used for one fragment load.
   */
  get startLevel() {
    const e = this.levelController.startLevel;
    return e === -1 && this.abrController.forcedAutoLevel > -1 ? this.abrController.forcedAutoLevel : e;
  }
  /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  set startLevel(e) {
    this.logger.log(`set startLevel:${e}`), e !== -1 && (e = Math.max(e, this.minAutoLevel)), this.levelController.startLevel = e;
  }
  /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */
  get capLevelToPlayerSize() {
    return this.config.capLevelToPlayerSize;
  }
  /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */
  set capLevelToPlayerSize(e) {
    const t = !!e;
    t !== this.config.capLevelToPlayerSize && (t ? this.capLevelController.startCapping() : (this.capLevelController.stopCapping(), this.autoLevelCapping = -1, this.streamController.nextLevelSwitch()), this.config.capLevelToPlayerSize = t);
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  get autoLevelCapping() {
    return this._autoLevelCapping;
  }
  /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */
  get bandwidthEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimate() : NaN;
  }
  set bandwidthEstimate(e) {
    this.abrController.resetEstimator(e);
  }
  get abrEwmaDefaultEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.defaultEstimate : NaN;
  }
  /**
   * get time to first byte estimate
   * @type {number}
   */
  get ttfbEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimateTTFB() : NaN;
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  set autoLevelCapping(e) {
    this._autoLevelCapping !== e && (this.logger.log(`set autoLevelCapping:${e}`), this._autoLevelCapping = e, this.levelController.checkMaxAutoUpdated());
  }
  get maxHdcpLevel() {
    return this._maxHdcpLevel;
  }
  set maxHdcpLevel(e) {
    Ab(e) && this._maxHdcpLevel !== e && (this._maxHdcpLevel = e, this.levelController.checkMaxAutoUpdated());
  }
  /**
   * True when automatic level selection enabled
   */
  get autoLevelEnabled() {
    return this.levelController.manualLevel === -1;
  }
  /**
   * Level set manually (if any)
   */
  get manualLevel() {
    return this.levelController.manualLevel;
  }
  /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */
  get minAutoLevel() {
    const {
      levels: e,
      config: {
        minAutoBitrate: t
      }
    } = this;
    if (!e) return 0;
    const r = e.length;
    for (let s = 0; s < r; s++)
      if (e[s].maxBitrate >= t)
        return s;
    return 0;
  }
  /**
   * max level selectable in auto mode according to autoLevelCapping
   */
  get maxAutoLevel() {
    const {
      levels: e,
      autoLevelCapping: t,
      maxHdcpLevel: r
    } = this;
    let s;
    if (t === -1 && e != null && e.length ? s = e.length - 1 : s = t, r)
      for (let i = s; i--; ) {
        const o = e[i].attrs["HDCP-LEVEL"];
        if (o && o <= r)
          return i;
      }
    return s;
  }
  get firstAutoLevel() {
    return this.abrController.firstAutoLevel;
  }
  /**
   * next automatically selected quality level
   */
  get nextAutoLevel() {
    return this.abrController.nextAutoLevel;
  }
  /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */
  set nextAutoLevel(e) {
    this.abrController.nextAutoLevel = e;
  }
  /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */
  get playingDate() {
    return this.streamController.currentProgramDateTime;
  }
  get mainForwardBufferInfo() {
    return this.streamController.getMainFwdBufferInfo();
  }
  get maxBufferLength() {
    return this.streamController.maxBufferLength;
  }
  /**
   * Find and select the best matching audio track, making a level switch when a Group change is necessary.
   * Updates `hls.config.audioPreference`. Returns the selected track, or null when no matching track is found.
   */
  setAudioOption(e) {
    var t;
    return ((t = this.audioTrackController) == null ? void 0 : t.setAudioOption(e)) || null;
  }
  /**
   * Find and select the best matching subtitle track, making a level switch when a Group change is necessary.
   * Updates `hls.config.subtitlePreference`. Returns the selected track, or null when no matching track is found.
   */
  setSubtitleOption(e) {
    var t;
    return ((t = this.subtitleTrackController) == null ? void 0 : t.setSubtitleOption(e)) || null;
  }
  /**
   * Get the complete list of audio tracks across all media groups
   */
  get allAudioTracks() {
    const e = this.audioTrackController;
    return e ? e.allAudioTracks : [];
  }
  /**
   * Get the list of selectable audio tracks
   */
  get audioTracks() {
    const e = this.audioTrackController;
    return e ? e.audioTracks : [];
  }
  /**
   * index of the selected audio track (index in audio track lists)
   */
  get audioTrack() {
    const e = this.audioTrackController;
    return e ? e.audioTrack : -1;
  }
  /**
   * selects an audio track, based on its index in audio track lists
   */
  set audioTrack(e) {
    const t = this.audioTrackController;
    t && (t.audioTrack = e);
  }
  /**
   * get the complete list of subtitle tracks across all media groups
   */
  get allSubtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.allSubtitleTracks : [];
  }
  /**
   * get alternate subtitle tracks list from playlist
   */
  get subtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTracks : [];
  }
  /**
   * index of the selected subtitle track (index in subtitle track lists)
   */
  get subtitleTrack() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTrack : -1;
  }
  get media() {
    return this._media;
  }
  /**
   * select an subtitle track, based on its index in subtitle track lists
   */
  set subtitleTrack(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleTrack = e);
  }
  /**
   * Whether subtitle display is enabled or not
   */
  get subtitleDisplay() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleDisplay : !1;
  }
  /**
   * Enable/disable subtitle display rendering
   */
  set subtitleDisplay(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleDisplay = e);
  }
  /**
   * get mode for Low-Latency HLS loading
   */
  get lowLatencyMode() {
    return this.config.lowLatencyMode;
  }
  /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */
  set lowLatencyMode(e) {
    this.config.lowLatencyMode = e;
  }
  /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */
  get liveSyncPosition() {
    return this.latencyController.liveSyncPosition;
  }
  /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */
  get latency() {
    return this.latencyController.latency;
  }
  /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */
  get maxLatency() {
    return this.latencyController.maxLatency;
  }
  /**
   * target distance from the edge as calculated by the latency controller
   */
  get targetLatency() {
    return this.latencyController.targetLatency;
  }
  set targetLatency(e) {
    this.latencyController.targetLatency = e;
  }
  /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */
  get drift() {
    return this.latencyController.drift;
  }
  /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */
  get forceStartLoad() {
    return this.streamController.forceStartLoad;
  }
  /**
   * ContentSteering pathways getter
   */
  get pathways() {
    return this.levelController.pathways;
  }
  /**
   * ContentSteering pathwayPriority getter/setter
   */
  get pathwayPriority() {
    return this.levelController.pathwayPriority;
  }
  set pathwayPriority(e) {
    this.levelController.pathwayPriority = e;
  }
  /**
   * returns true when all SourceBuffers are buffered to the end
   */
  get bufferedToEnd() {
    var e;
    return !!((e = this.bufferController) != null && e.bufferedToEnd);
  }
  /**
   * returns Interstitials Program Manager
   */
  get interstitialsManager() {
    var e;
    return ((e = this.interstitialsController) == null ? void 0 : e.interstitialsManager) || null;
  }
  /**
   * returns mediaCapabilities.decodingInfo for a variant/rendition
   */
  getMediaDecodingInfo(e, t = this.allAudioTracks) {
    const r = ip(t);
    return sp(e, r, navigator.mediaCapabilities);
  }
}
rn.defaultConfig = void 0;
const Es = "https://sdk-api.neynar.com", kA = "https://api.allorigins.win/get", Vi = "https://i.imgur.com/gxH8azy.png";
var DA = {
  SDK_VERSION: '"1.2.7"'
};
const PA = DA.SDK_VERSION, Ss = async (n, e = {}) => (e.headers = {
  ...e.headers,
  "x-sdk": "react",
  "x-sdk-version": PA
}, fetch(n, e));
async function MA({
  type: n,
  identifier: e,
  viewerFid: t,
  client_id: r
}) {
  try {
    let s = `${Es}/v2/farcaster/cast?type=${n}&identifier=${e}${t ? `&viewer_fid=${t}` : ""}&client_id=${r}`;
    const o = await (await Ss(s)).json();
    return (o == null ? void 0 : o.cast) || null;
  } catch (s) {
    return console.error("Error fetching cast by identifier", s), null;
  }
}
const OA = ({
  type: n,
  identifier: e,
  viewerFid: t,
  allowReactions: r = !1,
  renderEmbeds: s = !0,
  renderFrames: i = !1,
  onLikeBtnPress: o,
  onRecastBtnPress: a,
  onCommentBtnPress: l,
  onFrameBtnPress: c,
  containerStyles: u,
  textStyles: d
}) => {
  var P;
  const {
    client_id: h
  } = gn(), [f, p] = ot.useState(null), [y, m] = ot.useState(!0), [b, C] = ot.useState(null), A = (f == null ? void 0 : f.author.fid) === t;
  return ot.useEffect(() => {
    n && e && (m(!0), C(null), MA({
      type: n,
      identifier: e,
      viewerFid: t,
      client_id: h
    }).then((I) => {
      p(I);
    }).catch((I) => {
      C(I);
    }).finally(() => {
      m(!1);
    }));
  }, [n, e, t, h]), y ? /* @__PURE__ */ K.jsx("div", {
    style: {
      padding: "20px"
    },
    children: "Loading..."
  }) : !f || b ? /* @__PURE__ */ K.jsx("div", {
    children: "Error: could not fetch cast data"
  }) : i && !c ? /* @__PURE__ */ K.jsx("div", {
    children: "Error: onFrameBtnPress must be provided when renderEmbeds is true."
  }) : /* @__PURE__ */ K.jsx(wa, {
    username: f.author.username,
    displayName: f.author.display_name,
    avatarImgUrl: f.author.pfp_url,
    text: f.text,
    hash: f.hash,
    reactions: f.reactions,
    replies: f.replies.count,
    embeds: f.embeds ?? [],
    frames: f.frames ?? [],
    renderEmbeds: s,
    renderFrames: i,
    channel: f.channel ? {
      id: f.channel.id,
      name: f.channel.name,
      url: f.parent_url
    } : void 0,
    viewerFid: t,
    allowReactions: r,
    hasPowerBadge: f.author.power_badge,
    appAvatarImgUrl: ((P = f.app) == null ? void 0 : P.pfp_url) || null,
    isOwnProfile: A,
    containerStyles: u,
    textStyles: d,
    onLikeBtnPress: o,
    onRecastBtnPress: a,
    onCommentBtnPress: l,
    onFrameBtnPress: c,
    timestamp: f.timestamp
  });
}, BA = /* @__PURE__ */ oe("a")({
  classes: ["s1uo4lx4"]
}), ql = /* @__PURE__ */ new Map(), To = /* @__PURE__ */ new Map(), pf = /* @__PURE__ */ new Map(), mf = (n) => new Promise((e) => setTimeout(e, n)), dm = async (n, e = 0) => {
  const t = new URL(n).hostname;
  if (pf.get(t))
    return {
      ogImage: "",
      ogTitle: "",
      ogDescription: ""
    };
  if (ql.has(n))
    return ql.get(n);
  if (To.has(n))
    return To.get(n);
  const r = (async () => {
    try {
      await mf(100);
      const s = await fetch(`${kA}?url=${encodeURIComponent(n)}`, {
        method: "GET"
      });
      if (!s.ok) {
        if (s.status === 429 && e < 5) {
          const m = Math.pow(2, e) * 1e3;
          return await mf(m), dm(n, e + 1);
        }
        throw pf.set(t, !0), new Error(`Failed to fetch Open Graph data: ${s.statusText}`);
      }
      const i = await s.json(), a = new DOMParser().parseFromString(i.contents, "text/html"), l = a.querySelector('meta[property="og:image"]'), c = a.querySelector('meta[property="og:title"]'), u = a.querySelector('meta[property="og:description"]'), d = a.querySelector("title"), h = l && l.getAttribute("content") || "", f = c ? c.getAttribute("content") || "" : d ? d.innerText : "", p = u && u.getAttribute("content") || "", y = {
        ogImage: h,
        ogTitle: f,
        ogDescription: p
      };
      return ql.set(n, y), y;
    } catch (s) {
      return console.error("Error fetching Open Graph data", s), {
        ogImage: "",
        ogTitle: "",
        ogDescription: ""
      };
    } finally {
      To.delete(n);
    }
  })();
  return To.set(n, r), r;
}, Nc = [];
let zl = 0;
const FA = 5, NA = (n) => {
  Nc.push(n), hm();
}, hm = async () => {
  if (zl >= FA || Nc.length === 0)
    return;
  zl++;
  const n = Nc.shift();
  n && await n(), zl--, hm();
}, UA = ({
  src: n,
  alt: e,
  style: t
}) => /* @__PURE__ */ K.jsx("img", {
  src: n,
  alt: e,
  style: {
    display: "block",
    height: "auto",
    maxHeight: "150px",
    width: "auto",
    maxWidth: "100%",
    objectFit: "cover",
    border: "1px solid grey",
    borderRadius: "10px",
    margin: "4px 0",
    ...t
  }
}), $A = ({
  url: n
}) => {
  const e = ot.useRef(null);
  return ot.useEffect(() => {
    if (e.current)
      if (rn.isSupported() && n.endsWith(".m3u8")) {
        const t = new rn();
        t.loadSource(n), t.attachMedia(e.current), t.on(rn.Events.MANIFEST_PARSED, () => {
          e.current.play();
        });
      } else
        e.current.src = n, e.current.addEventListener("loadedmetadata", () => {
          e.current.play();
        });
  }, [n]), /* @__PURE__ */ K.jsx("video", {
    ref: e,
    controls: !0,
    muted: !0,
    style: {
      width: "auto",
      maxWidth: "100%",
      maxHeight: "400px",
      borderRadius: "10px",
      margin: "10px 0",
      objectFit: "contain"
    }
  });
}, GA = (n) => /\.(jpeg|jpg|gif|png|webp|bmp|svg)$/.test(n) || n.startsWith("https://imagedelivery.net"), jA = (n, e, t) => {
  const [r, s] = ot.useState([]), i = ot.useCallback(async (o) => (await Promise.all(o.map(async (l) => {
    if (l.url) {
      const c = l.url;
      return GA(c) ? /* @__PURE__ */ K.jsx(UA, {
        src: c,
        alt: "Embedded image"
      }, c) : c.endsWith(".m3u8") || c.endsWith(".mp4") ? /* @__PURE__ */ K.jsx($A, {
        url: c
      }, c) : new Promise((u) => {
        NA(async () => {
          const {
            ogImage: d,
            ogTitle: h
          } = await dm(c), f = new URL(c).hostname.replace("www.", "");
          u(/* @__PURE__ */ K.jsxs(BA, {
            href: c,
            target: "_blank",
            rel: "noreferrer",
            children: [d && /* @__PURE__ */ K.jsx("img", {
              src: d,
              alt: h,
              style: {
                width: "50px",
                height: "50px",
                objectFit: "cover",
                borderRadius: "5px"
              }
            }), /* @__PURE__ */ K.jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column"
              },
              children: [/* @__PURE__ */ K.jsx("p", {
                style: {
                  margin: 0
                },
                children: h || c
              }), /* @__PURE__ */ K.jsx("p", {
                style: {
                  margin: 0,
                  color: "grey",
                  fontSize: "12px"
                },
                children: f
              })]
            })]
          }, c));
        });
      });
    } else if (l.cast_id)
      return /* @__PURE__ */ K.jsx("div", {
        style: {
          maxWidth: "85%"
        },
        children: /* @__PURE__ */ K.jsx(OA, {
          type: "hash",
          identifier: l.cast_id.hash,
          viewerFid: t,
          allowReactions: e,
          renderEmbeds: !1
        }, l.cast_id.fid)
      }, `cast-${l.cast_id.hash}`);
    return null;
  }))).filter((l) => l !== null), [e, t]);
  return ot.useEffect(() => {
    i(n).then(s);
  }, [n, i]), r;
}, fm = ({
  onClick: n
}) => /* @__PURE__ */ K.jsx("svg", {
  width: "18",
  height: "17",
  viewBox: "0 0 18 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  onClick: (e) => n ? n(e) : void 0,
  style: {
    cursor: "pointer"
  },
  children: /* @__PURE__ */ K.jsx("path", {
    d: "M6.22857 12.6828H7.01285C7.01285 12.2496 6.66172 11.8985 6.22857 11.8985V12.6828ZM6.22857 15.8199H5.4443C5.4443 16.1137 5.60848 16.3828 5.8697 16.5172C6.13092 16.6517 6.44537 16.6288 6.68443 16.4581L6.22857 15.8199ZM10.6205 12.6828V11.8985C10.4571 11.8985 10.2977 11.9496 10.1647 12.0446L10.6205 12.6828ZM1.78428 3.27146C1.78428 2.54955 2.3695 1.96433 3.09141 1.96433V0.395777C1.50321 0.395777 0.215723 1.68327 0.215723 3.27146H1.78428ZM1.78428 10.5914V3.27146H0.215723V10.5914H1.78428ZM3.0914 11.8985C2.3695 11.8985 1.78428 11.3133 1.78428 10.5914H0.215723C0.215723 12.1796 1.50321 13.4671 3.0914 13.4671V11.8985ZM6.22857 11.8985H3.0914V13.4671H6.22857V11.8985ZM7.01285 15.8199V12.6828H5.4443V15.8199H7.01285ZM10.1647 12.0446L5.77272 15.1817L6.68443 16.4581L11.0764 13.321L10.1647 12.0446ZM14.5941 11.8985H10.6205V13.4671H14.5941V11.8985ZM15.9013 10.5914C15.9013 11.3133 15.316 11.8985 14.5941 11.8985V13.4671C16.1823 13.4671 17.4698 12.1796 17.4698 10.5914H15.9013ZM15.9013 3.27146V10.5914H17.4698V3.27146H15.9013ZM14.5941 1.96433C15.316 1.96433 15.9013 2.54955 15.9013 3.27146H17.4698C17.4698 1.68326 16.1823 0.395777 14.5941 0.395777V1.96433ZM3.09141 1.96433H14.5941V0.395777H3.09141V1.96433Z",
    fill: "#A0A3AD"
  })
}), VA = ({
  fill: n,
  onClick: e
}) => /* @__PURE__ */ K.jsxs("svg", {
  width: "16",
  height: "15",
  viewBox: "0 0 16 15",
  fill: n || "none",
  xmlns: "http://www.w3.org/2000/svg",
  onClick: (t) => e ? e(t) : void 0,
  style: {
    cursor: "pointer"
  },
  children: [/* @__PURE__ */ K.jsx("path", {
    d: "M14.9245 14.2506C14.7258 14.2506 14.5352 14.1716 14.3946 14.0311C14.2541 13.8905 14.1751 13.6999 14.1751 13.5011V10.5034H11.1774C10.9787 10.5034 10.7881 10.4245 10.6475 10.2839C10.507 10.1434 10.428 9.95279 10.428 9.75403C10.428 9.55527 10.507 9.36465 10.6475 9.22411C10.7881 9.08357 10.9787 9.00461 11.1774 9.00461H14.9245C15.1233 9.00461 15.3139 9.08357 15.4545 9.22411C15.595 9.36465 15.674 9.55527 15.674 9.75403V13.5011C15.674 13.6999 15.595 13.8905 15.4545 14.0311C15.3139 14.1716 15.1233 14.2506 14.9245 14.2506ZM5.18207 6.00693H1.43497C1.23621 6.00693 1.04559 5.92797 0.905047 5.78743C0.764503 5.64688 0.685547 5.45627 0.685547 5.25751V1.51041C0.685547 1.31165 0.764503 1.12103 0.905047 0.980486C1.04559 0.839943 1.23621 0.760986 1.43497 0.760986C1.63373 0.760986 1.82434 0.839943 1.96489 0.980486C2.10543 1.12103 2.18439 1.31165 2.18439 1.51041V4.50809H5.18207C5.38083 4.50809 5.57145 4.58704 5.71199 4.72759C5.85253 4.86813 5.93149 5.05875 5.93149 5.25751C5.93149 5.45627 5.85253 5.64688 5.71199 5.78743C5.57145 5.92797 5.38083 6.00693 5.18207 6.00693Z",
    fill: n || "#A0A3AD"
  }), /* @__PURE__ */ K.jsx("path", {
    d: "M8.17934 15C6.33556 15.0003 4.55637 14.3209 3.18205 13.0918C1.80774 11.8627 0.934766 10.17 0.730106 8.33765C0.719281 8.23923 0.727945 8.13965 0.755606 8.04458C0.783266 7.94951 0.82938 7.86083 0.891315 7.78358C1.0164 7.62758 1.19833 7.52765 1.39709 7.50579C1.59585 7.48393 1.79515 7.54191 1.95116 7.667C2.10716 7.79208 2.20708 7.97401 2.22895 8.17277C2.37708 9.52376 2.97983 10.7843 3.93838 11.7478C4.89692 12.7113 6.15438 13.3205 7.50459 13.4755C8.85479 13.6306 10.2176 13.3223 11.3696 12.6012C12.5216 11.8801 13.3944 10.789 13.845 9.50674C13.8731 9.40817 13.9211 9.31642 13.986 9.23714C14.051 9.15787 14.1316 9.09277 14.2227 9.04586C14.3138 8.99895 14.4136 8.97123 14.5159 8.96442C14.6181 8.95761 14.7207 8.97185 14.8173 9.00625C14.9138 9.04066 15.0023 9.09451 15.0772 9.16446C15.1521 9.23442 15.2118 9.31899 15.2528 9.41296C15.2937 9.50693 15.3149 9.6083 15.3151 9.71079C15.3153 9.81329 15.2944 9.91473 15.2539 10.0089C14.7359 11.4705 13.7774 12.7355 12.5103 13.6294C11.2432 14.5233 9.73002 15.0022 8.17934 15ZM14.8792 7.50579C14.6939 7.50691 14.5148 7.43937 14.3764 7.3162C14.238 7.19302 14.1501 7.02295 14.1297 6.8388C13.975 5.49429 13.3699 4.24169 12.4128 3.28476C11.4558 2.32782 10.2031 1.72285 8.85858 1.56824C7.51405 1.41364 6.15676 1.7185 5.0075 2.43324C3.85823 3.14798 2.9846 4.23054 2.52872 5.50484C2.50062 5.6034 2.4526 5.69516 2.38763 5.77443C2.32266 5.85371 2.24212 5.91881 2.15099 5.96572C2.05987 6.01263 1.96008 6.04035 1.85781 6.04716C1.75555 6.05397 1.65297 6.03973 1.55642 6.00532C1.45988 5.97092 1.37141 5.91707 1.29651 5.84712C1.2216 5.77716 1.16183 5.69258 1.12091 5.59861C1.07999 5.50464 1.05878 5.40328 1.05859 5.30078C1.0584 5.19829 1.07923 5.09685 1.1198 5.00273C1.68406 3.40202 2.77497 2.04025 4.21397 1.14029C5.65297 0.240337 7.35485 -0.144505 9.04106 0.0487522C10.7273 0.242009 12.2979 1.00192 13.496 2.20411C14.6941 3.4063 15.4486 4.97958 15.6361 6.66644C15.6571 6.86306 15.5997 7.06004 15.4761 7.21445C15.3526 7.36887 15.173 7.4682 14.9766 7.4908L14.8792 7.50579Z",
    fill: n || "#A0A3AD"
  })]
}), gm = ({
  fill: n,
  onClick: e
}) => /* @__PURE__ */ K.jsxs("svg", {
  width: "17",
  height: "15",
  viewBox: "0 0 17 15",
  fill: n ? "red" : "none",
  xmlns: "http://www.w3.org/2000/svg",
  onClick: (t) => e ? e(t) : void 0,
  style: {
    cursor: "pointer"
  },
  children: [/* @__PURE__ */ K.jsx("path", {
    d: "M13.8719 2.25042L14.2947 1.58984L13.8719 2.25042C15.2467 3.13022 15.7676 5.22206 14.8856 7.61317C14.0436 9.89583 11.9555 12.2374 8.51573 13.3648C5.07606 12.2374 2.98799 9.89584 2.14596 7.61316C1.26392 5.22203 1.7848 3.13022 3.15951 2.25042L3.15951 2.25042C4.58542 1.33783 5.64997 1.52983 6.39945 1.92503C7.21272 2.35388 7.73108 3.07114 7.86143 3.26838L8.51573 4.25838L9.17002 3.26838C9.30038 3.07113 9.81873 2.35388 10.632 1.92503C11.3815 1.52983 12.446 1.33783 13.8719 2.25042Z",
    stroke: n || "#A0A3AD",
    strokeWidth: "1.56855"
  }), /* @__PURE__ */ K.jsx("mask", {
    id: "path-2-inside-1_187_1051",
    fill: "white",
    children: /* @__PURE__ */ K.jsx("path", {
      d: "M8.58444 13.9397C7.76139 13.6864 7.05334 13.3937 6.29976 12.9825C5.95633 12.7951 5.62285 12.5895 5.3003 12.3681C5.14416 12.2609 4.99108 12.1493 4.84063 12.0343C4.78132 11.9889 4.88038 12.0652 4.82156 12.0195C4.80388 12.0058 4.7863 11.9919 4.76869 11.9781C4.73364 11.9505 4.69884 11.9225 4.66413 11.8945C4.58948 11.8342 4.51582 11.7727 4.4428 11.7105C3.90499 11.252 3.41381 10.7389 2.98016 10.1809C3.01856 10.2303 2.97651 10.176 2.97064 10.1683C2.9583 10.1522 2.94604 10.1359 2.9338 10.1197C2.90939 10.0874 2.88527 10.0548 2.86126 10.0221C2.80961 9.95189 2.75908 9.8808 2.70932 9.8092C2.61492 9.67345 2.52441 9.535 2.4371 9.39457C2.2673 9.12145 2.11213 8.83926 1.97147 8.55006C1.93849 8.48228 1.90657 8.41396 1.87531 8.34537C1.85978 8.3113 1.84459 8.27709 1.82948 8.24284C1.82195 8.22575 1.81456 8.20864 1.80714 8.19152C1.80167 8.17889 1.76856 8.10061 1.79664 8.16736C1.73728 8.0262 1.68205 7.88329 1.63029 7.73916C1.52982 7.45942 1.44498 7.17407 1.37575 6.88502C1.34218 6.74492 1.31301 6.60379 1.28746 6.46202C1.2754 6.39502 1.2645 6.32782 1.2543 6.26052C1.24925 6.22713 1.24453 6.19369 1.23994 6.16023C1.25136 6.24358 1.23495 6.11772 1.23231 6.09532C1.20042 5.82444 1.18535 5.55158 1.18721 5.27885C1.18811 5.14691 1.19374 5.01501 1.20334 4.88343C1.20788 4.82128 1.21368 4.75922 1.22023 4.69726C1.2235 4.66651 1.22713 4.6358 1.23089 4.60511C1.23278 4.58982 1.23477 4.57457 1.23678 4.5593C1.22562 4.64425 1.23563 4.56956 1.23823 4.55163C1.27428 4.30419 1.32861 4.05943 1.40097 3.82006C1.43614 3.70375 1.47635 3.58899 1.52072 3.47587C1.53125 3.449 1.54219 3.42229 1.55326 3.39564C1.51941 3.47716 1.55889 3.38334 1.56717 3.36464C1.59226 3.30803 1.61886 3.25209 1.64643 3.19664C1.75101 2.98624 1.87476 2.78549 2.01534 2.59724C2.02371 2.58603 2.03221 2.57492 2.04071 2.5638C1.99275 2.62656 2.02446 2.58496 2.03493 2.57169C2.05223 2.54974 2.06993 2.52808 2.08773 2.50653C2.12631 2.45984 2.16629 2.41434 2.20713 2.36962C2.28587 2.28341 2.36926 2.20151 2.456 2.12339C2.49787 2.08568 2.54084 2.0492 2.58443 2.01352C2.60631 1.99561 2.62852 1.97808 2.65084 1.9607C2.58164 2.01466 2.67191 1.94557 2.68962 1.93265C2.83338 1.8277 2.98587 1.7348 3.14013 1.6463C3.54393 1.41459 3.92437 1.25567 4.3831 1.15072C4.47716 1.12921 4.57219 1.11204 4.6676 1.09771C4.74483 1.08611 4.61527 1.10399 4.69217 1.09444C4.71513 1.0916 4.73817 1.08917 4.76119 1.08677C4.81403 1.08124 4.86704 1.07739 4.92007 1.07423C5.10084 1.06348 5.28237 1.06851 5.46252 1.0864C5.48336 1.08846 5.50417 1.09092 5.52495 1.09338C5.59508 1.10167 5.46943 1.08526 5.53899 1.09521C5.57965 1.10103 5.62016 1.10795 5.66059 1.11524C5.74647 1.13073 5.83159 1.1503 5.91604 1.17227C6.0728 1.21311 6.22621 1.26621 6.37595 1.32786C6.31111 1.30115 6.41877 1.34702 6.43584 1.35477C6.46987 1.3702 6.50356 1.38639 6.53714 1.4028C6.60865 1.43779 6.67886 1.47543 6.74817 1.51462C6.87662 1.58723 7.00062 1.66753 7.12092 1.7529C7.14882 1.77271 7.17637 1.79297 7.20383 1.81338C7.21739 1.82348 7.23087 1.8337 7.24432 1.84396C7.29158 1.87992 7.1988 1.80839 7.24529 1.84482C7.30109 1.88853 7.35568 1.93375 7.40949 1.97982C7.50652 2.06288 7.59994 2.15008 7.69053 2.24011C7.84008 2.38879 7.98044 2.54677 8.11149 2.71194C8.12572 2.72987 8.17533 2.79414 8.11485 2.7157C8.12636 2.73065 8.13776 2.74568 8.1491 2.76075C8.1694 2.78769 8.18934 2.81491 8.20905 2.8423C8.23825 2.88286 8.2667 2.92398 8.29429 2.96566C8.40374 3.131 8.6286 3.131 8.73805 2.96566C8.76707 2.92181 8.79712 2.87866 8.82785 2.83598C8.84783 2.80823 8.86819 2.78075 8.88875 2.75344C8.90242 2.73529 8.94928 2.67474 8.88935 2.75214C8.90409 2.73312 8.919 2.71424 8.93399 2.69542C9.0671 2.52834 9.21071 2.36968 9.36261 2.21954C9.45411 2.12907 9.5493 2.04234 9.64732 1.95897C9.69737 1.91641 9.74847 1.87507 9.80017 1.83456C9.7388 1.88263 9.82694 1.81457 9.84213 1.80327C9.87427 1.77937 9.90683 1.75606 9.9396 1.73301C10.0608 1.64773 10.1866 1.56915 10.3159 1.49682C10.3802 1.46084 10.4457 1.42703 10.5119 1.39467C10.5455 1.37823 10.5795 1.36251 10.6136 1.34704C10.6308 1.33926 10.6481 1.33171 10.6654 1.32417C10.6915 1.31296 10.6885 1.3142 10.6564 1.3279C10.6681 1.32303 10.6798 1.31822 10.6916 1.31349C10.8423 1.25235 10.9973 1.20246 11.1548 1.16239C11.2332 1.14248 11.3123 1.12599 11.3918 1.11166C11.4323 1.10435 11.473 1.09815 11.5138 1.09231C11.4471 1.10186 11.5171 1.09226 11.5281 1.09095C11.5559 1.08767 11.5838 1.08499 11.6117 1.0824C11.793 1.06553 11.9757 1.06513 12.1573 1.0771C12.203 1.08011 12.2485 1.08444 12.294 1.08921C12.3172 1.09163 12.3402 1.0945 12.3633 1.09734C12.3036 1.08994 12.3813 1.10022 12.3881 1.10123C12.4921 1.11685 12.5952 1.13785 12.6975 1.16193C13.1586 1.27048 13.5378 1.44037 13.9464 1.67761C14.0904 1.76129 14.2314 1.8507 14.3656 1.9495C14.377 1.95791 14.3884 1.96648 14.3997 1.97503C14.4419 2.00688 14.351 1.93696 14.3926 1.96945C14.4149 1.98683 14.4369 2.00462 14.4588 2.02252C14.5059 2.06115 14.5519 2.1013 14.5971 2.14228C14.6835 2.22073 14.7656 2.30388 14.8439 2.39035C14.8815 2.43176 14.9178 2.47427 14.9534 2.51736C14.9712 2.53891 14.9887 2.56077 15.006 2.58274C15.0384 2.62388 14.9682 2.53335 15 2.575C15.0114 2.58983 15.0225 2.60479 15.0336 2.61978C15.1736 2.80871 15.2946 3.01142 15.3985 3.22224C15.4238 3.27356 15.4477 3.32553 15.4709 3.37782C15.4767 3.39096 15.4824 3.40414 15.4881 3.41734C15.5093 3.46656 15.464 3.35945 15.4845 3.40902C15.4975 3.44013 15.5099 3.47148 15.5221 3.50289C15.5661 3.61632 15.6049 3.73175 15.6398 3.84833C15.7115 4.08832 15.763 4.33416 15.7984 4.58204C15.8064 4.63806 15.7901 4.51842 15.7975 4.57463C15.7995 4.58992 15.8014 4.60521 15.8033 4.6205C15.807 4.6512 15.8104 4.68197 15.8137 4.71273C15.8208 4.77994 15.8264 4.84732 15.8312 4.91474C15.8404 5.04658 15.8447 5.17876 15.8453 5.31093C15.8464 5.58418 15.8287 5.85737 15.7961 6.12862C15.7941 6.14529 15.7919 6.16192 15.7898 6.17856C15.7822 6.23827 15.7983 6.11722 15.7901 6.17697C15.7855 6.21044 15.7806 6.24389 15.7755 6.27731C15.7644 6.35031 15.752 6.4231 15.7388 6.49573C15.7129 6.63769 15.6823 6.7788 15.6484 6.91905C15.5784 7.20843 15.4909 7.49348 15.3897 7.77343C15.3648 7.84232 15.3388 7.9108 15.3121 7.97902C15.2987 8.01338 15.2849 8.0476 15.2711 8.08179C15.2641 8.09896 15.257 8.11604 15.25 8.13315C15.2452 8.14458 15.2405 8.15598 15.2357 8.16738C15.2496 8.13453 15.251 8.13117 15.2399 8.15734C15.1786 8.30137 15.1131 8.44355 15.0443 8.58416C14.9028 8.87351 14.7451 9.15483 14.5745 9.42799C14.4868 9.56844 14.395 9.70634 14.3002 9.84213C14.254 9.90821 14.2069 9.97355 14.1592 10.0385C14.1351 10.0711 14.1108 10.1036 14.0864 10.136C14.0741 10.1522 14.0617 10.1684 14.0494 10.1845C14.0319 10.2073 14.0329 10.2061 14.0522 10.181C14.0439 10.1918 14.0355 10.2025 14.0271 10.2132C13.8135 10.4869 13.5849 10.7488 13.3445 10.9992C13.0948 11.2594 12.8309 11.5058 12.556 11.7391C12.4884 11.7965 12.4199 11.8528 12.3509 11.9086C12.3162 11.9366 12.2812 11.9643 12.2461 11.992C12.2285 12.0058 12.2108 12.0196 12.1931 12.0333C12.2377 11.9987 12.1636 12.0558 12.156 12.0616C12.005 12.1765 11.8508 12.2871 11.6942 12.3941C11.3706 12.6153 11.0348 12.8185 10.6904 13.0055C10.5122 13.1023 10.3313 13.1939 10.1484 13.2815C10.059 13.3243 9.96904 13.3658 9.87868 13.4064C9.8331 13.4269 9.78733 13.4469 9.74151 13.4669C9.7185 13.4769 9.69541 13.4868 9.67233 13.4966C9.6442 13.5086 9.64146 13.5098 9.66417 13.5002C9.64864 13.5067 9.63313 13.5132 9.61758 13.5196C9.2349 13.6788 8.84398 13.8179 8.44786 13.9398C8.31409 13.9809 8.2304 14.1178 8.26839 14.2559C8.3047 14.3878 8.45064 14.4765 8.5845 14.4353C10.1534 13.9525 11.626 13.1871 12.8857 12.131C13.9425 11.245 14.8349 10.1456 15.4543 8.91165C15.9942 7.83608 16.3357 6.64744 16.3583 5.43967C16.3774 4.41628 16.149 3.35704 15.5742 2.49789C15.2929 2.07732 14.9371 1.71816 14.5205 1.43134C13.7956 0.932295 12.9294 0.592822 12.045 0.557214C10.7717 0.505949 9.60126 1.17157 8.7697 2.09685C8.59779 2.28813 8.43634 2.49172 8.29431 2.70629C8.44223 2.70629 8.59015 2.70629 8.73807 2.70629C8.22434 1.93023 7.48255 1.25338 6.6264 0.880424C5.9305 0.577258 5.18555 0.490164 4.43721 0.617179C3.98766 0.69348 3.55546 0.856508 3.14849 1.05915C2.81945 1.22296 2.50653 1.41842 2.22115 1.65017C1.44904 2.27713 0.973026 3.20995 0.783732 4.17519C0.56509 5.29004 0.68737 6.45381 1.02051 7.53339C1.41084 8.79827 2.09407 9.95916 2.95641 10.9589C3.94757 12.1081 5.19614 13.0306 6.5582 13.6933C7.16712 13.9896 7.8008 14.2362 8.44788 14.4353C8.58174 14.4765 8.72768 14.3878 8.76399 14.2559C8.80189 14.1177 8.71821 13.9809 8.58444 13.9397Z"
    })
  }), /* @__PURE__ */ K.jsx("path", {
    d: "M8.58444 13.9397C7.76139 13.6864 7.05334 13.3937 6.29976 12.9825C5.95633 12.7951 5.62285 12.5895 5.3003 12.3681C5.14416 12.2609 4.99108 12.1493 4.84063 12.0343C4.78132 11.9889 4.88038 12.0652 4.82156 12.0195C4.80388 12.0058 4.7863 11.9919 4.76869 11.9781C4.73364 11.9505 4.69884 11.9225 4.66413 11.8945C4.58948 11.8342 4.51582 11.7727 4.4428 11.7105C3.90499 11.252 3.41381 10.7389 2.98016 10.1809C3.01856 10.2303 2.97651 10.176 2.97064 10.1683C2.9583 10.1522 2.94604 10.1359 2.9338 10.1197C2.90939 10.0874 2.88527 10.0548 2.86126 10.0221C2.80961 9.95189 2.75908 9.8808 2.70932 9.8092C2.61492 9.67345 2.52441 9.535 2.4371 9.39457C2.2673 9.12145 2.11213 8.83926 1.97147 8.55006C1.93849 8.48228 1.90657 8.41396 1.87531 8.34537C1.85978 8.3113 1.84459 8.27709 1.82948 8.24284C1.82195 8.22575 1.81456 8.20864 1.80714 8.19152C1.80167 8.17889 1.76856 8.10061 1.79664 8.16736C1.73728 8.0262 1.68205 7.88329 1.63029 7.73916C1.52982 7.45942 1.44498 7.17407 1.37575 6.88502C1.34218 6.74492 1.31301 6.60379 1.28746 6.46202C1.2754 6.39502 1.2645 6.32782 1.2543 6.26052C1.24925 6.22713 1.24453 6.19369 1.23994 6.16023C1.25136 6.24358 1.23495 6.11772 1.23231 6.09532C1.20042 5.82444 1.18535 5.55158 1.18721 5.27885C1.18811 5.14691 1.19374 5.01501 1.20334 4.88343C1.20788 4.82128 1.21368 4.75922 1.22023 4.69726C1.2235 4.66651 1.22713 4.6358 1.23089 4.60511C1.23278 4.58982 1.23477 4.57457 1.23678 4.5593C1.22562 4.64425 1.23563 4.56956 1.23823 4.55163C1.27428 4.30419 1.32861 4.05943 1.40097 3.82006C1.43614 3.70375 1.47635 3.58899 1.52072 3.47587C1.53125 3.449 1.54219 3.42229 1.55326 3.39564C1.51941 3.47716 1.55889 3.38334 1.56717 3.36464C1.59226 3.30803 1.61886 3.25209 1.64643 3.19664C1.75101 2.98624 1.87476 2.78549 2.01534 2.59724C2.02371 2.58603 2.03221 2.57492 2.04071 2.5638C1.99275 2.62656 2.02446 2.58496 2.03493 2.57169C2.05223 2.54974 2.06993 2.52808 2.08773 2.50653C2.12631 2.45984 2.16629 2.41434 2.20713 2.36962C2.28587 2.28341 2.36926 2.20151 2.456 2.12339C2.49787 2.08568 2.54084 2.0492 2.58443 2.01352C2.60631 1.99561 2.62852 1.97808 2.65084 1.9607C2.58164 2.01466 2.67191 1.94557 2.68962 1.93265C2.83338 1.8277 2.98587 1.7348 3.14013 1.6463C3.54393 1.41459 3.92437 1.25567 4.3831 1.15072C4.47716 1.12921 4.57219 1.11204 4.6676 1.09771C4.74483 1.08611 4.61527 1.10399 4.69217 1.09444C4.71513 1.0916 4.73817 1.08917 4.76119 1.08677C4.81403 1.08124 4.86704 1.07739 4.92007 1.07423C5.10084 1.06348 5.28237 1.06851 5.46252 1.0864C5.48336 1.08846 5.50417 1.09092 5.52495 1.09338C5.59508 1.10167 5.46943 1.08526 5.53899 1.09521C5.57965 1.10103 5.62016 1.10795 5.66059 1.11524C5.74647 1.13073 5.83159 1.1503 5.91604 1.17227C6.0728 1.21311 6.22621 1.26621 6.37595 1.32786C6.31111 1.30115 6.41877 1.34702 6.43584 1.35477C6.46987 1.3702 6.50356 1.38639 6.53714 1.4028C6.60865 1.43779 6.67886 1.47543 6.74817 1.51462C6.87662 1.58723 7.00062 1.66753 7.12092 1.7529C7.14882 1.77271 7.17637 1.79297 7.20383 1.81338C7.21739 1.82348 7.23087 1.8337 7.24432 1.84396C7.29158 1.87992 7.1988 1.80839 7.24529 1.84482C7.30109 1.88853 7.35568 1.93375 7.40949 1.97982C7.50652 2.06288 7.59994 2.15008 7.69053 2.24011C7.84008 2.38879 7.98044 2.54677 8.11149 2.71194C8.12572 2.72987 8.17533 2.79414 8.11485 2.7157C8.12636 2.73065 8.13776 2.74568 8.1491 2.76075C8.1694 2.78769 8.18934 2.81491 8.20905 2.8423C8.23825 2.88286 8.2667 2.92398 8.29429 2.96566C8.40374 3.131 8.6286 3.131 8.73805 2.96566C8.76707 2.92181 8.79712 2.87866 8.82785 2.83598C8.84783 2.80823 8.86819 2.78075 8.88875 2.75344C8.90242 2.73529 8.94928 2.67474 8.88935 2.75214C8.90409 2.73312 8.919 2.71424 8.93399 2.69542C9.0671 2.52834 9.21071 2.36968 9.36261 2.21954C9.45411 2.12907 9.5493 2.04234 9.64732 1.95897C9.69737 1.91641 9.74847 1.87507 9.80017 1.83456C9.7388 1.88263 9.82694 1.81457 9.84213 1.80327C9.87427 1.77937 9.90683 1.75606 9.9396 1.73301C10.0608 1.64773 10.1866 1.56915 10.3159 1.49682C10.3802 1.46084 10.4457 1.42703 10.5119 1.39467C10.5455 1.37823 10.5795 1.36251 10.6136 1.34704C10.6308 1.33926 10.6481 1.33171 10.6654 1.32417C10.6915 1.31296 10.6885 1.3142 10.6564 1.3279C10.6681 1.32303 10.6798 1.31822 10.6916 1.31349C10.8423 1.25235 10.9973 1.20246 11.1548 1.16239C11.2332 1.14248 11.3123 1.12599 11.3918 1.11166C11.4323 1.10435 11.473 1.09815 11.5138 1.09231C11.4471 1.10186 11.5171 1.09226 11.5281 1.09095C11.5559 1.08767 11.5838 1.08499 11.6117 1.0824C11.793 1.06553 11.9757 1.06513 12.1573 1.0771C12.203 1.08011 12.2485 1.08444 12.294 1.08921C12.3172 1.09163 12.3402 1.0945 12.3633 1.09734C12.3036 1.08994 12.3813 1.10022 12.3881 1.10123C12.4921 1.11685 12.5952 1.13785 12.6975 1.16193C13.1586 1.27048 13.5378 1.44037 13.9464 1.67761C14.0904 1.76129 14.2314 1.8507 14.3656 1.9495C14.377 1.95791 14.3884 1.96648 14.3997 1.97503C14.4419 2.00688 14.351 1.93696 14.3926 1.96945C14.4149 1.98683 14.4369 2.00462 14.4588 2.02252C14.5059 2.06115 14.5519 2.1013 14.5971 2.14228C14.6835 2.22073 14.7656 2.30388 14.8439 2.39035C14.8815 2.43176 14.9178 2.47427 14.9534 2.51736C14.9712 2.53891 14.9887 2.56077 15.006 2.58274C15.0384 2.62388 14.9682 2.53335 15 2.575C15.0114 2.58983 15.0225 2.60479 15.0336 2.61978C15.1736 2.80871 15.2946 3.01142 15.3985 3.22224C15.4238 3.27356 15.4477 3.32553 15.4709 3.37782C15.4767 3.39096 15.4824 3.40414 15.4881 3.41734C15.5093 3.46656 15.464 3.35945 15.4845 3.40902C15.4975 3.44013 15.5099 3.47148 15.5221 3.50289C15.5661 3.61632 15.6049 3.73175 15.6398 3.84833C15.7115 4.08832 15.763 4.33416 15.7984 4.58204C15.8064 4.63806 15.7901 4.51842 15.7975 4.57463C15.7995 4.58992 15.8014 4.60521 15.8033 4.6205C15.807 4.6512 15.8104 4.68197 15.8137 4.71273C15.8208 4.77994 15.8264 4.84732 15.8312 4.91474C15.8404 5.04658 15.8447 5.17876 15.8453 5.31093C15.8464 5.58418 15.8287 5.85737 15.7961 6.12862C15.7941 6.14529 15.7919 6.16192 15.7898 6.17856C15.7822 6.23827 15.7983 6.11722 15.7901 6.17697C15.7855 6.21044 15.7806 6.24389 15.7755 6.27731C15.7644 6.35031 15.752 6.4231 15.7388 6.49573C15.7129 6.63769 15.6823 6.7788 15.6484 6.91905C15.5784 7.20843 15.4909 7.49348 15.3897 7.77343C15.3648 7.84232 15.3388 7.9108 15.3121 7.97902C15.2987 8.01338 15.2849 8.0476 15.2711 8.08179C15.2641 8.09896 15.257 8.11604 15.25 8.13315C15.2452 8.14458 15.2405 8.15598 15.2357 8.16738C15.2496 8.13453 15.251 8.13117 15.2399 8.15734C15.1786 8.30137 15.1131 8.44355 15.0443 8.58416C14.9028 8.87351 14.7451 9.15483 14.5745 9.42799C14.4868 9.56844 14.395 9.70634 14.3002 9.84213C14.254 9.90821 14.2069 9.97355 14.1592 10.0385C14.1351 10.0711 14.1108 10.1036 14.0864 10.136C14.0741 10.1522 14.0617 10.1684 14.0494 10.1845C14.0319 10.2073 14.0329 10.2061 14.0522 10.181C14.0439 10.1918 14.0355 10.2025 14.0271 10.2132C13.8135 10.4869 13.5849 10.7488 13.3445 10.9992C13.0948 11.2594 12.8309 11.5058 12.556 11.7391C12.4884 11.7965 12.4199 11.8528 12.3509 11.9086C12.3162 11.9366 12.2812 11.9643 12.2461 11.992C12.2285 12.0058 12.2108 12.0196 12.1931 12.0333C12.2377 11.9987 12.1636 12.0558 12.156 12.0616C12.005 12.1765 11.8508 12.2871 11.6942 12.3941C11.3706 12.6153 11.0348 12.8185 10.6904 13.0055C10.5122 13.1023 10.3313 13.1939 10.1484 13.2815C10.059 13.3243 9.96904 13.3658 9.87868 13.4064C9.8331 13.4269 9.78733 13.4469 9.74151 13.4669C9.7185 13.4769 9.69541 13.4868 9.67233 13.4966C9.6442 13.5086 9.64146 13.5098 9.66417 13.5002C9.64864 13.5067 9.63313 13.5132 9.61758 13.5196C9.2349 13.6788 8.84398 13.8179 8.44786 13.9398C8.31409 13.9809 8.2304 14.1178 8.26839 14.2559C8.3047 14.3878 8.45064 14.4765 8.5845 14.4353C10.1534 13.9525 11.626 13.1871 12.8857 12.131C13.9425 11.245 14.8349 10.1456 15.4543 8.91165C15.9942 7.83608 16.3357 6.64744 16.3583 5.43967C16.3774 4.41628 16.149 3.35704 15.5742 2.49789C15.2929 2.07732 14.9371 1.71816 14.5205 1.43134C13.7956 0.932295 12.9294 0.592822 12.045 0.557214C10.7717 0.505949 9.60126 1.17157 8.7697 2.09685C8.59779 2.28813 8.43634 2.49172 8.29431 2.70629C8.44223 2.70629 8.59015 2.70629 8.73807 2.70629C8.22434 1.93023 7.48255 1.25338 6.6264 0.880424C5.9305 0.577258 5.18555 0.490164 4.43721 0.617179C3.98766 0.69348 3.55546 0.856508 3.14849 1.05915C2.81945 1.22296 2.50653 1.41842 2.22115 1.65017C1.44904 2.27713 0.973026 3.20995 0.783732 4.17519C0.56509 5.29004 0.68737 6.45381 1.02051 7.53339C1.41084 8.79827 2.09407 9.95916 2.95641 10.9589C3.94757 12.1081 5.19614 13.0306 6.5582 13.6933C7.16712 13.9896 7.8008 14.2362 8.44788 14.4353C8.58174 14.4765 8.72768 14.3878 8.76399 14.2559C8.80189 14.1177 8.71821 13.9809 8.58444 13.9397Z",
    stroke: n || "#A0A3AD",
    strokeWidth: "3.13711",
    mask: "url(#path-2-inside-1_187_1051)"
  })]
});
function pm({
  onClick: n,
  size: e = 24
}) {
  return /* @__PURE__ */ K.jsx("svg", {
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    viewBox: "0 0 16 16",
    width: e,
    height: e,
    fill: "#4A4A4A",
    style: {
      display: "inline-block",
      userSelect: "none",
      verticalAlign: "text-bottom",
      overflow: "visible",
      cursor: "pointer",
      padding: "4px"
    },
    onClick: n,
    children: /* @__PURE__ */ K.jsx("path", {
      d: "M3.72 3.72a.75.75 0 0 1 1.06 0L8 6.94l3.22-3.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 8l3.22 3.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 9.06l-3.22 3.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L6.94 8 3.72 4.78a.75.75 0 0 1 0-1.06Z"
    })
  });
}
const KA = () => Fr, HA = /* @__PURE__ */ oe(KA())({
  classes: ["rect7e5"]
}), WA = () => Fr, qA = /* @__PURE__ */ oe(WA())({
  classes: ["p13mqntt"]
}), zA = () => Fr, YA = /* @__PURE__ */ oe(zA())({
  classes: ["p1r47dz2"]
}), ZA = () => Fr, XA = /* @__PURE__ */ oe(ZA())({
  classes: ["cnojpqv"]
}), JA = ({
  hash: n,
  reactions: e,
  onComment: t,
  onRecast: r,
  onLike: s,
  isLiked: i
}) => {
  const {
    client_id: o,
    user: a,
    isAuthenticated: l
  } = gn(), [c, u] = ot.useState(!1), [d, h] = ot.useState({
    top: 0,
    left: 0
  }), [f, p] = ot.useState(null), [y, m] = ot.useState(i), [b, C] = ot.useState(!1), A = ot.useRef(null), P = ot.useRef({
    comment: null,
    recast: null,
    like: null
  });
  Et(() => {
    m(e.likes.some((U) => U.fid === (a == null ? void 0 : a.fid))), C(e.recasts.some((U) => U.fid === (a == null ? void 0 : a.fid)));
  }, [e, a]), Et(() => {
    const U = localStorage.getItem(ai.NEYNAR_AUTHENTICATED_USER);
    if (U)
      try {
        p(JSON.parse(U).signer_uuid);
      } catch (j) {
        console.error("Error parsing JSON from local storage:", j), p(null);
      }
    else
      console.warn("No NEYNAR_AUTHENTICATED_USER found in local storage.");
  }, [l]), Et(() => {
    (f || l) && c && u(!1);
  }, [f, l, c]);
  const I = async (U, j) => {
    if (f)
      switch (j) {
        case "comment":
          if (t)
            t();
          else
            throw new Error("No comment handler function provided");
          break;
        case "recast":
          if (r)
            C(r());
          else
            throw new Error("No recast handler function provided");
          break;
        case "like":
          if (s)
            m(s());
          else
            throw new Error("No like handler function provided");
          break;
      }
    const G = P.current[j];
    if (G) {
      const F = G.getBoundingClientRect(), B = A.current;
      if (B) {
        const V = B.getBoundingClientRect();
        h({
          top: F.top - V.height - 10,
          left: F.left + F.width / 2 - V.width / 2
        });
      }
    }
  };
  return /* @__PURE__ */ K.jsxs(HA, {
    children: [c && /* @__PURE__ */ K.jsxs(qA, {
      ref: A,
      style: {
        top: d.top,
        left: d.left
      },
      children: [/* @__PURE__ */ K.jsx(YA, {
        children: /* @__PURE__ */ K.jsx(FS, {
          variant: _n.NEYNAR
        })
      }), /* @__PURE__ */ K.jsx(XA, {
        children: /* @__PURE__ */ K.jsx(pm, {
          onClick: () => u(!1),
          size: 16
        })
      })]
    }), /* @__PURE__ */ K.jsx(Fr, {
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      },
      children: /* @__PURE__ */ K.jsxs(Fr, {
        spacingVertical: "15px",
        style: {
          display: "flex",
          gap: "42px"
        },
        children: [/* @__PURE__ */ K.jsx("div", {
          ref: (U) => P.current.comment = U,
          children: /* @__PURE__ */ K.jsx(fm, {
            onClick: (U) => I(U, "comment")
          })
        }), /* @__PURE__ */ K.jsx("div", {
          ref: (U) => P.current.recast = U,
          children: /* @__PURE__ */ K.jsx(VA, {
            fill: b ? "green" : void 0,
            onClick: (U) => I(U, "recast")
          })
        }), /* @__PURE__ */ K.jsx("div", {
          ref: (U) => P.current.like = U,
          children: /* @__PURE__ */ K.jsx(gm, {
            fill: y ? "red" : void 0,
            onClick: (U) => I(U, "like")
          })
        })]
      })
    })]
  });
};
function QA({
  onClick: n
}) {
  return /* @__PURE__ */ K.jsx("svg", {
    style: {
      cursor: "pointer"
    },
    width: "16",
    height: "15",
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: (e) => n ? n(e) : void 0,
    children: /* @__PURE__ */ K.jsx("path", {
      d: "M15.2003 7.49063C14.7504 7.49063 14.4504 7.79057 14.4504 8.24048V12.7396C14.4504 13.1895 14.1505 13.4894 13.7006 13.4894H3.20268C2.75277 13.4894 2.45283 13.1895 2.45283 12.7396V8.24048C2.45283 7.79057 2.15289 7.49063 1.70298 7.49063C1.25307 7.49063 0.953125 7.79057 0.953125 8.24048V12.7396C0.953125 14.0143 1.92793 14.9891 3.20268 14.9891H13.7006C14.9753 14.9891 15.9501 14.0143 15.9501 12.7396V8.24048C15.9501 7.79057 15.6502 7.49063 15.2003 7.49063ZM5.97713 4.26627L7.70178 2.54161V9.74018C7.70178 10.1901 8.00172 10.49 8.45163 10.49C8.90155 10.49 9.20149 10.1901 9.20149 9.74018V2.54161L10.9261 4.26627C11.2261 4.56621 11.676 4.56621 11.9759 4.26627C12.2759 3.96633 12.2759 3.51642 11.9759 3.21648L8.97653 0.217073C8.90155 0.142088 8.82656 0.0671031 8.75157 0.0671031C8.6016 -0.00788202 8.37665 -0.00788202 8.15169 0.0671031C8.07671 0.0671031 8.00172 0.142088 7.92674 0.217073L4.92734 3.21648C4.62739 3.51642 4.62739 3.96633 4.92734 4.26627C5.22728 4.56621 5.67719 4.56621 5.97713 4.26627Z",
      fill: "#A0A3AD"
    })
  });
}
const Uc = ({
  url: n
}) => {
  const [e, t] = ot.useState(!1), r = async (s) => {
    try {
      await navigator.clipboard.writeText(n), t(!0), setTimeout(() => {
        t(!1);
      }, 2e3);
    } catch (i) {
      console.error("Failed to copy the text to clipboard:", i);
    }
  };
  return /* @__PURE__ */ K.jsx("div", {
    children: e ? /* @__PURE__ */ K.jsx("svg", {
      style: {
        cursor: "pointer",
        fill: "green"
      },
      width: "16",
      height: "15",
      viewBox: "0 0 16 15",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ K.jsx("path", {
        d: "M5.99967 12.8136L1.71967 8.53364L0.559673 9.69364L5.99967 15.1336L16.4397 4.69364L15.2797 3.53364L5.99967 12.8136Z"
      })
    }) : /* @__PURE__ */ K.jsx(QA, {
      onClick: r
    })
  });
}, eI = () => /* @__PURE__ */ K.jsxs("svg", {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */ K.jsx("path", {
    d: "M5.85855 0.555664H8.31281M8.31281 0.555664V2.73754M8.31281 0.555664L4.31445 4.11122",
    stroke: "#FFFFFF",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), /* @__PURE__ */ K.jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M3.31445 1H1.31445C0.762168 1 0.314453 1.44772 0.314453 2V8C0.314453 8.55228 0.762168 9 1.31445 9H7.31445C7.86674 9 8.31445 8.55228 8.31445 8V6H7.31445V8H1.31445V2H3.31445V1Z",
    fill: "#FFFFFF"
  })]
}), tI = () => /* @__PURE__ */ K.jsx("svg", {
  width: "10",
  height: "14",
  viewBox: "0 0 10 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /* @__PURE__ */ K.jsx("path", {
    d: "M5.01451 12.5187L4.96833 12.5174L4.93914 12.522C4.93113 12.516 4.92402 12.5087 4.91808 12.5005L4.51231 12.7926L4.91808 12.5005C4.9049 12.4822 4.89824 12.46 4.89913 12.4375L4.89953 12.4275V12.4176V8.81194V8.31194H4.39953H1.8876H1.88753C1.76188 8.31196 1.63853 8.27825 1.53036 8.21433C1.42218 8.1504 1.33315 8.05862 1.27256 7.94854C1.21196 7.83847 1.18203 7.71415 1.18588 7.58856C1.18973 7.46301 1.2272 7.34079 1.29438 7.23466C1.2944 7.23463 1.29442 7.23459 1.29444 7.23456L4.90001 1.54377L4.90567 1.53483L4.91095 1.52567C4.92227 1.50601 4.93988 1.49074 4.96094 1.48232C4.982 1.47389 5.00528 1.47281 5.02703 1.47924L5.02912 1.47985C5.05077 1.48614 5.06969 1.4995 5.08286 1.5178C5.09603 1.53609 5.1027 1.55827 5.1018 1.58079L5.10141 1.59073V1.60067V5.20631V5.70631H5.60141H8.11333H8.1134C8.23905 5.70629 8.3624 5.74 8.47058 5.80392C8.57875 5.86784 8.66778 5.95963 8.72838 6.06971C8.78897 6.17978 8.81891 6.3041 8.81506 6.42969C8.81121 6.55528 8.77371 6.67753 8.70649 6.78369L5.10232 12.4723C5.10219 12.4725 5.10205 12.4727 5.10191 12.4729C5.09255 12.4873 5.07969 12.499 5.06452 12.507C5.04914 12.5152 5.03191 12.5192 5.01451 12.5187Z",
    stroke: "#FFFFFF"
  })
}), rI = /* @__PURE__ */ oe("button")({
  classes: ["f1hmcrrf"]
}), nI = /* @__PURE__ */ oe("div")({
  classes: ["f1ki4il6"]
}), sI = /* @__PURE__ */ oe("div")({
  classes: ["bgnz0ud"]
}), iI = /* @__PURE__ */ oe("img")({
  classes: ["f1gbget9"]
}), oI = /* @__PURE__ */ oe("div")({
  classes: ["f4rwe4i"]
}), aI = /* @__PURE__ */ oe("div")({
  classes: ["f1qellgw"]
}), lI = /* @__PURE__ */ oe("input")({
  classes: ["i1hgxwhi"]
}), cI = /* @__PURE__ */ oe("div")({
  classes: ["s1ahcfax"]
}), uI = () => {
  const n = lr(null);
  return Et(() => {
    if (n.current) {
      let e = 0;
      const t = () => {
        e += 6, n.current && (n.current.style.transform = `rotate(${e}deg)`), requestAnimationFrame(t);
      };
      requestAnimationFrame(t);
    }
  }, []), /* @__PURE__ */ K.jsx("svg", {
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: "1.5",
    stroke: "currentColor",
    className: "size-6 text-white",
    style: {
      width: "24px",
      height: "24px"
    },
    children: /* @__PURE__ */ K.jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
    })
  });
};
function dI({
  number: n,
  text: e,
  actionType: t,
  target: r,
  frameUrl: s,
  handleOnClick: i
}) {
  return /* @__PURE__ */ K.jsxs(rI, {
    onClick: () => i(n),
    children: [e, (t === "link" || t === "post_redirect" || t === "mint") && /* @__PURE__ */ K.jsx(eI, {}), t === "tx" && /* @__PURE__ */ K.jsx(tI, {})]
  });
}
function hI({
  frame: n,
  onFrameBtnPress: e
}) {
  var h;
  const [t, r] = We(n), [s, i] = We(""), [o, a] = We(!1), l = () => {
    const f = t.buttons.map((p) => /* @__PURE__ */ K.jsx(dI, {
      number: p.index,
      text: p.title,
      actionType: p.action_type,
      target: p.target,
      frameUrl: n.frames_url,
      handleOnClick: (y) => {
        a(!0), e(y, t, r, s).finally(() => a(!1));
      }
    }, p.index));
    return /* @__PURE__ */ K.jsx(sI, {
      children: f
    });
  }, c = (f) => {
    i(f);
  }, u = (f) => {
    try {
      return new URL(f).hostname.replace("www.", "");
    } catch {
      return "";
    }
  }, d = () => {
    switch (t.image_aspect_ratio) {
      case "1:1":
        return {
          aspectRatio: "1 / 1"
        };
      case "1.91:1":
        return {
          aspectRatio: "1.91 / 1"
        };
      default:
        return {
          aspectRatio: "1.91 / 1"
        };
    }
  };
  return /* @__PURE__ */ K.jsxs(K.Fragment, {
    children: [/* @__PURE__ */ K.jsxs(nI, {
      children: [o && /* @__PURE__ */ K.jsx(cI, {
        children: /* @__PURE__ */ K.jsx(uI, {})
      }), t.frames_url && /* @__PURE__ */ K.jsxs(K.Fragment, {
        children: [/* @__PURE__ */ K.jsx("a", {
          href: t.frames_url,
          target: "_blank",
          rel: "noopener noreferrer",
          style: {
            width: "100%"
          },
          children: /* @__PURE__ */ K.jsx(iI, {
            src: t.image,
            alt: `Frame image for ${t.frames_url}`,
            style: d()
          })
        }), ((h = t.input) == null ? void 0 : h.text) && /* @__PURE__ */ K.jsx(lI, {
          type: "text",
          placeholder: t.input.text,
          value: s,
          onChange: (f) => c(f.target.value)
        }), l()]
      })]
    }), t.frames_url && /* @__PURE__ */ K.jsx(oI, {
      children: u(t.frames_url)
    })]
  });
}
const fI = ({
  frame: n,
  onFrameBtnPress: e
}) => /* @__PURE__ */ K.jsx(aI, {
  children: n ? /* @__PURE__ */ K.jsx(hI, {
    frame: n,
    onFrameBtnPress: e
  }) : /* @__PURE__ */ K.jsx(K.Fragment, {})
}), gI = ({
  url: n,
  onFrameBtnPress: e,
  initialFrame: t
}) => {
  const {
    client_id: r,
    showToast: s
  } = gn(), [i] = Du(ai.NEYNAR_AUTHENTICATED_USER, null), [o, a] = We(null), [l, c] = We(t || null), [u, d] = We(null);
  Et(() => {
    i ? a(i.signer_uuid) : console.warn("No NEYNAR_AUTHENTICATED_USER found in local storage.");
  }, [i]), Et(() => {
    t || (async () => {
      try {
        const y = await pI(`${Es}/v2/farcaster/frame/crawl?url=${n}&client_id=${r}`, {
          method: "GET"
        });
        if (y.ok) {
          const b = (await y.json()).frame;
          if (Object.keys(b).length === 0)
            throw new Error("No frame data available");
          c(b), d(null);
        } else
          throw new Error(`HTTP error! status: ${y.status}`);
      } catch (y) {
        console.error(`An error occurred: ${y}`), d(`Failed to fetch: ${y.message}`);
      }
    })();
  }, [n, s, t]);
  const h = (p) => {
    if (typeof p != "object" || p === null) return !1;
    const y = ["version", "image", "buttons", "frames_url"];
    for (const m of y)
      if (!(m in p)) return !1;
    return !(!Array.isArray(p.buttons) || p.buttons.some((m) => typeof m.index != "number"));
  }, f = async (p, y, m, b) => {
    try {
      const C = await e(p, y, m, b);
      if (!h(C))
        throw new Error("Invalid frame data received");
      m(C);
    } catch (C) {
      s(Ng.Error, `An error occurred while processing the button press: ${C}`);
    }
  };
  return u ? /* @__PURE__ */ K.jsx("div", {
    style: {
      color: "red",
      padding: "10px",
      border: "1px solid red",
      borderRadius: "5px"
    },
    children: u
  }) : /* @__PURE__ */ K.jsx(fI, {
    frame: l,
    onFrameBtnPress: f
  });
};
function pI(n, e, t = 8e3) {
  return Promise.race([Ss(n, e), new Promise((r, s) => setTimeout(() => s(new Error("Request timed out")), t))]);
}
function yf(n) {
  const e = Math.min(n, 1e9);
  return e >= 1e9 ? Math.floor(e / 1e8) / 10 + "B" : e >= 1e6 ? Math.floor(e / 1e5) / 10 + "M" : e >= 1e3 ? Math.floor(e / 100) / 10 + "K" : e.toString();
}
function mI(n) {
  if (!n)
    return console.error("Error: Timestamp is undefined or empty."), "Invalid timestamp";
  const e = new Date(n);
  if (isNaN(e.getTime()))
    return console.error("Error: Invalid timestamp provided:", n), "Invalid timestamp";
  const t = /* @__PURE__ */ new Date(), s = new Intl.DateTimeFormat(void 0, {
    hour: "numeric",
    minute: "2-digit",
    hour12: !0
  }).format(e).replace(" ", ""), i = t.toDateString() === e.toDateString(), o = new Date(t.setDate(t.getDate() - 1)).toDateString() === e.toDateString();
  if (i)
    return `${s}, today`;
  if (o)
    return `${s}, yesterday`;
  const a = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], l = e.getDate(), c = a[e.getMonth()], u = e.getFullYear(), h = `${c} ${((f) => {
    if (f > 3 && f < 21) return `${f}th`;
    const p = ["st", "nd", "rd"], y = f % 10;
    return `${f}${p[y - 1] || "th"}`;
  })(l)} ${u}`;
  return `${s}, ${h}`;
}
const yI = /* @__PURE__ */ oe("div")({
  classes: ["sxqvxvq"]
}), vI = /* @__PURE__ */ oe("a")({
  classes: ["s3kamov"]
}), xI = /* @__PURE__ */ oe("div")({
  classes: ["m1wrvvhk"]
}), EI = /* @__PURE__ */ oe("div")({
  classes: ["t1lcaq27"]
}), SI = /* @__PURE__ */ oe("div")({
  classes: ["ugtp1wh"]
}), bI = /* @__PURE__ */ oe("div")({
  classes: ["l1dqpn4e"]
}), TI = /* @__PURE__ */ oe("div")({
  classes: ["l1bjnv2t"]
}), vf = /* @__PURE__ */ oe("div")({
  classes: ["e15yf123"]
}), wI = /* @__PURE__ */ oe("div")({
  classes: ["rxra94g"]
}), xf = /* @__PURE__ */ oe("div")({
  classes: ["s1whgqrs"]
}), AI = /* @__PURE__ */ oe("p")({
  classes: ["dz8marf"]
}), wa = ot.memo(({
  username: n,
  displayName: e,
  avatarImgUrl: t,
  text: r = "",
  hash: s,
  reactions: i,
  replies: o,
  embeds: a = [],
  frames: l = [],
  channel: c,
  viewerFid: u,
  hasPowerBadge: d,
  isEmbed: h = !0,
  allowReactions: f,
  renderEmbeds: p,
  renderFrames: y,
  onLikeBtnPress: m,
  onRecastBtnPress: b,
  onCommentBtnPress: C,
  onFrameBtnPress: A,
  direct_replies: P,
  containerStyles: I,
  textStyles: U,
  timestamp: j,
  appAvatarImgUrl: G
}) => {
  const [F, B] = We(i.likes_count), [V, H] = We(i.likes.some((N) => N.fid === u)), L = /* @__PURE__ */ K.jsx(TI, {
    children: GS(r, a)
  }), g = (a == null ? void 0 : a.length) === 1, x = Ln(() => l.map((N) => N.frames_url), [l]), w = Ln(() => a.filter((N) => !x.includes(N.url)), [a, x]), _ = ft((N) => {
    N.currentTarget.src = Vi;
  }, []);
  Et(() => {
    H(i.likes.some((N) => N.fid === u));
  }, [i.likes, u]);
  const D = ft(() => m && m() ? (B((R) => R + 1), H(!V), !0) : !1, [m]), O = jA(w, f, u);
  return /* @__PURE__ */ K.jsx(yI, {
    style: {
      ...I,
      borderWidth: h ? "1px" : "0"
    },
    children: /* @__PURE__ */ K.jsxs(jr, {
      children: [/* @__PURE__ */ K.jsx(Fr, {
        spacingRight: "10px",
        children: /* @__PURE__ */ K.jsx(ha, {
          src: t && t.length > 0 ? t : Vi,
          width: "20px",
          height: "20px",
          onError: _,
          loading: "lazy",
          alt: `${e ?? "Skeleton"} Avatar`
        })
      }), /* @__PURE__ */ K.jsxs(xI, {
        children: [/* @__PURE__ */ K.jsxs(jr, {
          flexGrow: 1,
          alignItems: "center",
          children: [/* @__PURE__ */ K.jsxs(jr, {
            children: [/* @__PURE__ */ K.jsx(AI, {
              children: e
            }), " ", G && /* @__PURE__ */ K.jsx(Fr, {
              spacingLeft: "5px",
              children: /* @__PURE__ */ K.jsx("img", {
                style: {
                  padding: "2px",
                  borderWidth: "0.5px"
                },
                className: "border-white rounded-full",
                src: G,
                width: "18",
                height: "18",
                onError: (N) => {
                  N.currentTarget.style.display = "none";
                }
              })
            })]
          }), /* @__PURE__ */ K.jsxs(jr, {
            alignItems: "center",
            children: [/* @__PURE__ */ K.jsxs(SI, {
              children: ["@", n, " ·"]
            }), " ", /* @__PURE__ */ K.jsx(EI, {
              style: {
                color: "#999999",
                fontSize: "14px",
                fontFamily: "Work Sans"
              },
              children: mI(j)
            })]
          })]
        }), /* @__PURE__ */ K.jsx(Fr, {
          style: {
            marginTop: "10px"
          },
          children: /* @__PURE__ */ K.jsx(bI, {
            style: U,
            children: L
          })
        }), p && w && w.length > 0 ? /* @__PURE__ */ K.jsx(vf, {
          style: {
            margin: g ? "4px 0" : "0"
          },
          children: O.map((N, R) => /* @__PURE__ */ K.jsx("div", {
            style: {
              width: "100%"
            },
            children: N
          }, R))
        }) : /* @__PURE__ */ K.jsx(K.Fragment, {}), y && l && l.length > 0 ? /* @__PURE__ */ K.jsx(vf, {
          children: l.map((N) => /* @__PURE__ */ K.jsx(gI, {
            url: N.frames_url,
            initialFrame: N,
            onFrameBtnPress: A
          }, N.frames_url))
        }) : null, /* @__PURE__ */ K.jsxs(wI, {
          style: {
            justifyContent: f ? "space-between" : "flex-end"
          },
          children: [f && /* @__PURE__ */ K.jsx(JA, {
            hash: s,
            reactions: i,
            onComment: C,
            onRecast: b,
            onLike: D,
            isLiked: V
          }), f && n && s && /* @__PURE__ */ K.jsx(Uc, {
            url: `https://farcaster.xyz/${n}/${s.slice(0, 10)}`
          })]
        }), /* @__PURE__ */ K.jsxs(xf, {
          style: {
            justifyContent: f ? "" : "space-between",
            marginTop: "10px"
          },
          children: [/* @__PURE__ */ K.jsxs(xf, {
            style: {
              justifyContent: f ? "" : "space-between",
              gap: 6
            },
            children: [/* @__PURE__ */ K.jsxs("div", {
              style: {
                display: "flex",
                alignItems: "center",
                gap: "4px",
                color: "#999999"
              },
              children: [/* @__PURE__ */ K.jsx(fm, {}), o]
            }), /* @__PURE__ */ K.jsx("div", {
              style: {
                padding: "0px 10px"
              }
            }), /* @__PURE__ */ K.jsxs("div", {
              style: {
                display: "flex",
                alignItems: "center",
                gap: "4px",
                color: "#999999"
              },
              children: [/* @__PURE__ */ K.jsx(gm, {}), " ", F]
            }), c && /* @__PURE__ */ K.jsxs(K.Fragment, {
              children: [/* @__PURE__ */ K.jsx("div", {}), /* @__PURE__ */ K.jsxs(vI, {
                href: `https://farcaster.xyz/~/channel/${c.id}`,
                target: "_blank",
                children: ["/", c.id]
              })]
            })]
          }), !f && n && s && /* @__PURE__ */ K.jsx(Uc, {
            url: `https://farcaster.xyz/${n}/${s.slice(0, 10)}`
          })]
        })]
      })]
    })
  });
}), II = /* @__PURE__ */ oe("div")({
  classes: ["s1m6ob1a"]
}), Ef = /* @__PURE__ */ oe("div")({
  classes: ["r1esevc7"]
}), Sf = /* @__PURE__ */ oe("div")({
  classes: ["vxb1f00"]
}), _I = /* @__PURE__ */ oe("div")({
  classes: ["htv0qz7"]
}), bf = /* @__PURE__ */ oe("div")({
  classes: ["rzksy2"]
});
function LI(n) {
  return /* @__PURE__ */ K.jsx(II, {
    children: n.casts.map((e, t) => /* @__PURE__ */ K.jsxs(Ef, {
      children: [t !== 0 && /* @__PURE__ */ K.jsx(Sf, {
        style: {
          left: "42px"
        }
      }), /* @__PURE__ */ K.jsxs(bf, {
        children: [/* @__PURE__ */ K.jsx(wa, {
          isEmbed: !1,
          ...e
        }), t === 0 && /* @__PURE__ */ K.jsx(_I, {}), e.direct_replies && e.direct_replies.length > 0 && e.direct_replies.map((r, s) => /* @__PURE__ */ K.jsxs(Ef, {
          children: [/* @__PURE__ */ K.jsx(Sf, {
            style: {
              left: "42px"
            }
          }), /* @__PURE__ */ K.jsx(bf, {
            children: /* @__PURE__ */ K.jsx(wa, {
              isEmbed: !1,
              ...r
            })
          })]
        }, s))]
      })]
    }, t))
  });
}
async function RI({
  type: n,
  identifier: e,
  replyDepth: t = 2,
  includeChronologicalParentCasts: r = !1,
  limit: s = 20,
  viewerFid: i,
  clientId: o
}) {
  try {
    let a = `${Es}/v2/farcaster/cast/conversation?identifier=${encodeURIComponent(e)}&type=${n}&reply_depth=${t}&include_chronological_parent_casts=${r}&limit=${s}&client_id=${o}`;
    return i && (a += `&viewer_fid=${i}`), await (await Ss(a, {
      method: "GET",
      headers: {
        accept: "application/json"
      }
    })).json() || null;
  } catch (a) {
    return console.error("Error fetching conversation", a), null;
  }
}
function mm(n) {
  return {
    username: n.author.username,
    displayName: n.author.display_name,
    avatarImgUrl: n.author.pfp_url,
    text: n.text,
    hash: n.hash,
    reactions: n.reactions,
    replies: n.replies.count,
    embeds: n.embeds,
    frames: n.frames,
    renderEmbeds: n.renderEmbeds,
    channel: n.channel,
    viewerFid: 2,
    hasPowerBadge: n.author.power_badge,
    appAvatarImgUrl: n.app.pfp_url,
    isOwnProfile: !1,
    allowReactions: !0,
    renderFrames: !1,
    direct_replies: n.direct_replies ? n.direct_replies.map(mm) : [],
    timestamp: n.timestamp
  };
}
function CI(n) {
  const e = [];
  return n.cast && e.push(mm(n.cast)), e;
}
const SL = ({
  type: n,
  identifier: e,
  replyDepth: t = 2,
  includeChronologicalParentCasts: r = !1,
  limit: s = 20,
  viewerFid: i
}) => {
  const {
    client_id: o
  } = gn(), [a, l] = ot.useState(null), [c, u] = ot.useState(!0), [d, h] = ot.useState(null);
  return ot.useEffect(() => {
    u(!0), h(null), RI({
      type: n,
      identifier: e,
      replyDepth: t,
      includeChronologicalParentCasts: r,
      limit: s,
      viewerFid: i,
      clientId: o
    }).then((f) => {
      l(f);
    }).catch((f) => {
      h(f);
    }).finally(() => {
      u(!1);
    });
  }, [n, e, t, r, s, i, o]), c ? /* @__PURE__ */ K.jsx(K.Fragment, {
    children: " "
  }) : d ? /* @__PURE__ */ K.jsx(K.Fragment, {
    children: " "
  }) : /* @__PURE__ */ K.jsx(LI, {
    casts: CI(a.conversation)
  });
};
var ym = { exports: {} }, Yl = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tf;
function kI() {
  if (Tf) return Yl;
  Tf = 1;
  var n = ot;
  function e(d, h) {
    return d === h && (d !== 0 || 1 / d === 1 / h) || d !== d && h !== h;
  }
  var t = typeof Object.is == "function" ? Object.is : e, r = n.useState, s = n.useEffect, i = n.useLayoutEffect, o = n.useDebugValue;
  function a(d, h) {
    var f = h(), p = r({ inst: { value: f, getSnapshot: h } }), y = p[0].inst, m = p[1];
    return i(
      function() {
        y.value = f, y.getSnapshot = h, l(y) && m({ inst: y });
      },
      [d, f, h]
    ), s(
      function() {
        return l(y) && m({ inst: y }), d(function() {
          l(y) && m({ inst: y });
        });
      },
      [d]
    ), o(f), f;
  }
  function l(d) {
    var h = d.getSnapshot;
    d = d.value;
    try {
      var f = h();
      return !t(d, f);
    } catch {
      return !0;
    }
  }
  function c(d, h) {
    return h();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : a;
  return Yl.useSyncExternalStore = n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : u, Yl;
}
ym.exports = kI();
var vm = ym.exports;
const xm = 0, Em = 1, Sm = 2, wf = 3;
var Af = Object.prototype.hasOwnProperty;
function $c(n, e) {
  var t, r;
  if (n === e) return !0;
  if (n && e && (t = n.constructor) === e.constructor) {
    if (t === Date) return n.getTime() === e.getTime();
    if (t === RegExp) return n.toString() === e.toString();
    if (t === Array) {
      if ((r = n.length) === e.length)
        for (; r-- && $c(n[r], e[r]); ) ;
      return r === -1;
    }
    if (!t || typeof n == "object") {
      r = 0;
      for (t in n)
        if (Af.call(n, t) && ++r && !Af.call(e, t) || !(t in e) || !$c(n[t], e[t])) return !1;
      return Object.keys(e).length === r;
    }
  }
  return n !== n && e !== e;
}
const nn = /* @__PURE__ */ new WeakMap(), Wn = () => {
}, Zt = (
  /*#__NOINLINE__*/
  Wn()
), Gc = Object, Ue = (n) => n === Zt, Vr = (n) => typeof n == "function", Jn = (n, e) => ({
  ...n,
  ...e
}), bm = (n) => Vr(n.then), Zl = {}, wo = {}, ed = "undefined", Ji = typeof window != ed, jc = typeof document != ed, DI = Ji && "Deno" in window, PI = () => Ji && typeof window.requestAnimationFrame != ed, jn = (n, e) => {
  const t = nn.get(n);
  return [
    // Getter
    () => !Ue(e) && n.get(e) || Zl,
    // Setter
    (r) => {
      if (!Ue(e)) {
        const s = n.get(e);
        e in wo || (wo[e] = s), t[5](e, Jn(s, r), s || Zl);
      }
    },
    // Subscriber
    t[6],
    // Get server cache snapshot
    () => !Ue(e) && e in wo ? wo[e] : !Ue(e) && n.get(e) || Zl
  ];
};
let Vc = !0;
const MI = () => Vc, [Kc, Hc] = Ji && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  Wn,
  Wn
], OI = () => {
  const n = jc && document.visibilityState;
  return Ue(n) || n !== "hidden";
}, BI = (n) => (jc && document.addEventListener("visibilitychange", n), Kc("focus", n), () => {
  jc && document.removeEventListener("visibilitychange", n), Hc("focus", n);
}), FI = (n) => {
  const e = () => {
    Vc = !0, n();
  }, t = () => {
    Vc = !1;
  };
  return Kc("online", e), Kc("offline", t), () => {
    Hc("online", e), Hc("offline", t);
  };
}, NI = {
  isOnline: MI,
  isVisible: OI
}, UI = {
  initFocus: BI,
  initReconnect: FI
}, If = !ot.useId, Ki = !Ji || DI, $I = (n) => PI() ? window.requestAnimationFrame(n) : setTimeout(n, 1), Fo = Ki ? Et : Dm, Xl = typeof navigator < "u" && navigator.connection, _f = !Ki && Xl && ([
  "slow-2g",
  "2g"
].includes(Xl.effectiveType) || Xl.saveData), Ao = /* @__PURE__ */ new WeakMap(), Jl = (n, e) => Gc.prototype.toString.call(n) === `[object ${e}]`;
let GI = 0;
const Wc = (n) => {
  const e = typeof n, t = Jl(n, "Date"), r = Jl(n, "RegExp"), s = Jl(n, "Object");
  let i, o;
  if (Gc(n) === n && !t && !r) {
    if (i = Ao.get(n), i) return i;
    if (i = ++GI + "~", Ao.set(n, i), Array.isArray(n)) {
      for (i = "@", o = 0; o < n.length; o++)
        i += Wc(n[o]) + ",";
      Ao.set(n, i);
    }
    if (s) {
      i = "#";
      const a = Gc.keys(n).sort();
      for (; !Ue(o = a.pop()); )
        Ue(n[o]) || (i += o + ":" + Wc(n[o]) + ",");
      Ao.set(n, i);
    }
  } else
    i = t ? n.toJSON() : e == "symbol" ? n.toString() : e == "string" ? JSON.stringify(n) : "" + n;
  return i;
}, Hi = (n) => {
  if (Vr(n))
    try {
      n = n();
    } catch {
      n = "";
    }
  const e = n;
  return n = typeof n == "string" ? n : (Array.isArray(n) ? n.length : n) ? Wc(n) : "", [
    n,
    e
  ];
};
let jI = 0;
const qc = () => ++jI;
async function Tm(...n) {
  const [e, t, r, s] = n, i = Jn({
    populateCache: !0,
    throwOnError: !0
  }, typeof s == "boolean" ? {
    revalidate: s
  } : s || {});
  let o = i.populateCache;
  const a = i.rollbackOnError;
  let l = i.optimisticData;
  const c = (h) => typeof a == "function" ? a(h) : a !== !1, u = i.throwOnError;
  if (Vr(t)) {
    const h = t, f = [], p = e.keys();
    for (const y of p)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(y) && h(e.get(y)._k) && f.push(y);
    return Promise.all(f.map(d));
  }
  return d(t);
  async function d(h) {
    const [f] = Hi(h);
    if (!f) return;
    const [p, y] = jn(e, f), [m, b, C, A] = nn.get(e), P = () => {
      const L = m[f];
      return (Vr(i.revalidate) ? i.revalidate(p().data, h) : i.revalidate !== !1) && (delete C[f], delete A[f], L && L[0]) ? L[0](Sm).then(() => p().data) : p().data;
    };
    if (n.length < 3)
      return P();
    let I = r, U;
    const j = qc();
    b[f] = [
      j,
      0
    ];
    const G = !Ue(l), F = p(), B = F.data, V = F._c, H = Ue(V) ? B : V;
    if (G && (l = Vr(l) ? l(H, B) : l, y({
      data: l,
      _c: H
    })), Vr(I))
      try {
        I = I(H);
      } catch (L) {
        U = L;
      }
    if (I && bm(I))
      if (I = await I.catch((L) => {
        U = L;
      }), j !== b[f][0]) {
        if (U) throw U;
        return I;
      } else U && G && c(U) && (o = !0, y({
        data: H,
        _c: Zt
      }));
    if (o && !U)
      if (Vr(o)) {
        const L = o(I, H);
        y({
          data: L,
          error: Zt,
          _c: Zt
        });
      } else
        y({
          data: I,
          error: Zt,
          _c: Zt
        });
    if (b[f][1] = qc(), Promise.resolve(P()).then(() => {
      y({
        _c: Zt
      });
    }), U) {
      if (u) throw U;
      return;
    }
    return I;
  }
}
const Lf = (n, e) => {
  for (const t in n)
    n[t][0] && n[t][0](e);
}, VI = (n, e) => {
  if (!nn.has(n)) {
    const t = Jn(UI, e), r = /* @__PURE__ */ Object.create(null), s = Tm.bind(Zt, n);
    let i = Wn;
    const o = /* @__PURE__ */ Object.create(null), a = (u, d) => {
      const h = o[u] || [];
      return o[u] = h, h.push(d), () => h.splice(h.indexOf(d), 1);
    }, l = (u, d, h) => {
      n.set(u, d);
      const f = o[u];
      if (f)
        for (const p of f)
          p(d, h);
    }, c = () => {
      if (!nn.has(n) && (nn.set(n, [
        r,
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        /* @__PURE__ */ Object.create(null),
        s,
        l,
        a
      ]), !Ki)) {
        const u = t.initFocus(setTimeout.bind(Zt, Lf.bind(Zt, r, xm))), d = t.initReconnect(setTimeout.bind(Zt, Lf.bind(Zt, r, Em)));
        i = () => {
          u && u(), d && d(), nn.delete(n);
        };
      }
    };
    return c(), [
      n,
      s,
      c,
      i
    ];
  }
  return [
    n,
    nn.get(n)[4]
  ];
}, KI = (n, e, t, r, s) => {
  const i = t.errorRetryCount, o = s.retryCount, a = ~~((Math.random() + 0.5) * (1 << (o < 8 ? o : 8))) * t.errorRetryInterval;
  !Ue(i) && o > i || setTimeout(r, a, s);
}, HI = $c, [td, WI] = VI(/* @__PURE__ */ new Map()), qI = Jn(
  {
    // events
    onLoadingSlow: Wn,
    onSuccess: Wn,
    onError: Wn,
    onErrorRetry: KI,
    onDiscarded: Wn,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: _f ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: _f ? 5e3 : 3e3,
    // providers
    compare: HI,
    isPaused: () => !1,
    cache: td,
    mutate: WI,
    fallback: {}
  },
  // use web preset by default
  NI
), zI = (n, e) => {
  const t = Jn(n, e);
  if (e) {
    const { use: r, fallback: s } = n, { use: i, fallback: o } = e;
    r && i && (t.use = r.concat(i)), s && o && (t.fallback = Jn(s, o));
  }
  return t;
}, YI = Aa({}), wm = "$inf$", Am = Ji && window.__SWR_DEVTOOLS_USE__, ZI = Am ? window.__SWR_DEVTOOLS_USE__ : [], XI = () => {
  Am && (window.__SWR_DEVTOOLS_REACT__ = ot);
}, Im = (n) => Vr(n[1]) ? [
  n[0],
  n[1],
  n[2] || {}
] : [
  n[0],
  null,
  (n[1] === null ? n[2] : n[1]) || {}
], JI = () => Jn(qI, Wi(YI)), QI = (n) => (e, t, r) => n(e, t && ((...i) => {
  const [o] = Hi(e), [, , , a] = nn.get(td);
  if (o.startsWith(wm))
    return t(...i);
  const l = a[o];
  return Ue(l) ? t(...i) : (delete a[o], l);
}), r), e_ = ZI.concat(QI), t_ = (n) => function(...t) {
  const r = JI(), [s, i, o] = Im(t), a = zI(r, o);
  let l = n;
  const { use: c } = a, u = (c || []).concat(e_);
  for (let d = u.length; d--; )
    l = u[d](l);
  return l(s, i || a.fetcher || null, a);
}, r_ = (n, e, t) => {
  const r = e[n] || (e[n] = []);
  return r.push(t), () => {
    const s = r.indexOf(t);
    s >= 0 && (r[s] = r[r.length - 1], r.pop());
  };
}, n_ = (n, e) => (...t) => {
  const [r, s, i] = Im(t), o = (i.use || []).concat(e);
  return n(r, s, {
    ...i,
    use: o
  });
};
XI();
const Ql = ot.use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((n) => {
  switch (n.status) {
    case "pending":
      throw n;
    case "fulfilled":
      return n.value;
    case "rejected":
      throw n.reason;
    default:
      throw n.status = "pending", n.then((e) => {
        n.status = "fulfilled", n.value = e;
      }, (e) => {
        n.status = "rejected", n.reason = e;
      }), n;
  }
}), ec = {
  dedupe: !0
}, s_ = (n, e, t) => {
  const { cache: r, compare: s, suspense: i, fallbackData: o, revalidateOnMount: a, revalidateIfStale: l, refreshInterval: c, refreshWhenHidden: u, refreshWhenOffline: d, keepPreviousData: h } = t, [f, p, y, m] = nn.get(r), [b, C] = Hi(n), A = lr(!1), P = lr(!1), I = lr(b), U = lr(e), j = lr(t), G = () => j.current, F = () => G().isVisible() && G().isOnline(), [B, V, H, L] = jn(r, b), g = lr({}).current, x = Ue(o) ? Ue(t.fallback) ? Zt : t.fallback[b] : o, w = (Ge, ye) => {
    for (const Be in g) {
      const me = Be;
      if (me === "data") {
        if (!s(Ge[me], ye[me]) && (!Ue(Ge[me]) || !s(ee, ye[me])))
          return !1;
      } else if (ye[me] !== Ge[me])
        return !1;
    }
    return !0;
  }, _ = Ln(() => {
    const Ge = !b || !e ? !1 : Ue(a) ? G().isPaused() || i ? !1 : l !== !1 : a, ye = (be) => {
      const Me = Jn(be);
      return delete Me._k, Ge ? {
        isValidating: !0,
        isLoading: !0,
        ...Me
      } : Me;
    }, Be = B(), me = L(), xe = ye(Be), Pe = Be === me ? xe : ye(me);
    let Qe = xe;
    return [
      () => {
        const be = ye(B());
        return w(be, Qe) ? (Qe.data = be.data, Qe.isLoading = be.isLoading, Qe.isValidating = be.isValidating, Qe.error = be.error, Qe) : (Qe = be, be);
      },
      () => Pe
    ];
  }, [
    r,
    b
  ]), D = vm.useSyncExternalStore(ft(
    (Ge) => H(b, (ye, Be) => {
      w(Be, ye) || Ge();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      b
    ]
  ), _[0], _[1]), O = !A.current, N = f[b] && f[b].length > 0, R = D.data, v = Ue(R) ? x && bm(x) ? Ql(x) : x : R, M = D.error, te = lr(v), ee = h ? Ue(R) ? Ue(te.current) ? v : te.current : R : v, ne = N && !Ue(M) ? !1 : O && !Ue(a) ? a : G().isPaused() ? !1 : i ? Ue(v) ? !1 : l : Ue(v) || l, Ce = !!(b && e && O && ne), ve = Ue(D.isValidating) ? Ce : D.isValidating, Ae = Ue(D.isLoading) ? Ce : D.isLoading, qt = ft(
    async (Ge) => {
      const ye = U.current;
      if (!b || !ye || P.current || G().isPaused())
        return !1;
      let Be, me, xe = !0;
      const Pe = Ge || {}, Qe = !y[b] || !Pe.dedupe, be = () => If ? !P.current && b === I.current && A.current : b === I.current, Me = {
        isValidating: !1,
        isLoading: !1
      }, pt = () => {
        V(Me);
      }, et = () => {
        const at = y[b];
        at && at[1] === me && delete y[b];
      }, tt = {
        isValidating: !0
      };
      Ue(B().data) && (tt.isLoading = !0);
      try {
        if (Qe && (V(tt), t.loadingTimeout && Ue(B().data) && setTimeout(() => {
          xe && be() && G().onLoadingSlow(b, t);
        }, t.loadingTimeout), y[b] = [
          ye(C),
          qc()
        ]), [Be, me] = y[b], Be = await Be, Qe && setTimeout(et, t.dedupingInterval), !y[b] || y[b][1] !== me)
          return Qe && be() && G().onDiscarded(b), !1;
        Me.error = Zt;
        const at = p[b];
        if (!Ue(at) && // case 1
        (me <= at[0] || // case 2
        me <= at[1] || // case 3
        at[1] === 0))
          return pt(), Qe && be() && G().onDiscarded(b), !1;
        const Ve = B().data;
        Me.data = s(Ve, Be) ? Ve : Be, Qe && be() && G().onSuccess(Be, b, t);
      } catch (at) {
        et();
        const Ve = G(), { shouldRetryOnError: k } = Ve;
        Ve.isPaused() || (Me.error = at, Qe && be() && (Ve.onError(at, b, Ve), (k === !0 || Vr(k) && k(at)) && (!G().revalidateOnFocus || !G().revalidateOnReconnect || F()) && Ve.onErrorRetry(at, b, Ve, (E) => {
          const S = f[b];
          S && S[0] && S[0](wf, E);
        }, {
          retryCount: (Pe.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return xe = !1, pt(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      b,
      r
    ]
  ), qe = ft(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...Ge) => Tm(r, I.current, ...Ge),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (Fo(() => {
    U.current = e, j.current = t, Ue(R) || (te.current = R);
  }), Fo(() => {
    if (!b) return;
    const Ge = qt.bind(Zt, ec);
    let ye = 0;
    G().revalidateOnFocus && (ye = Date.now() + G().focusThrottleInterval);
    const me = r_(b, f, (xe, Pe = {}) => {
      if (xe == xm) {
        const Qe = Date.now();
        G().revalidateOnFocus && Qe > ye && F() && (ye = Qe + G().focusThrottleInterval, Ge());
      } else if (xe == Em)
        G().revalidateOnReconnect && F() && Ge();
      else {
        if (xe == Sm)
          return qt();
        if (xe == wf)
          return qt(Pe);
      }
    });
    return P.current = !1, I.current = b, A.current = !0, V({
      _k: C
    }), ne && (Ue(v) || Ki ? Ge() : $I(Ge)), () => {
      P.current = !0, me();
    };
  }, [
    b
  ]), Fo(() => {
    let Ge;
    function ye() {
      const me = Vr(c) ? c(B().data) : c;
      me && Ge !== -1 && (Ge = setTimeout(Be, me));
    }
    function Be() {
      !B().error && (u || G().isVisible()) && (d || G().isOnline()) ? qt(ec).then(ye) : ye();
    }
    return ye(), () => {
      Ge && (clearTimeout(Ge), Ge = -1);
    };
  }, [
    c,
    u,
    d,
    b
  ]), Pm(ee), i && Ue(v) && b) {
    if (!If && Ki)
      throw new Error("Fallback data is required when using Suspense in SSR.");
    U.current = e, j.current = t, P.current = !1;
    const Ge = m[b];
    if (!Ue(Ge)) {
      const ye = qe(Ge);
      Ql(ye);
    }
    if (Ue(M)) {
      const ye = qt(ec);
      Ue(ee) || (ye.status = "fulfilled", ye.value = !0), Ql(ye);
    } else
      throw M;
  }
  return {
    mutate: qe,
    get data() {
      return g.data = !0, ee;
    },
    get error() {
      return g.error = !0, M;
    },
    get isValidating() {
      return g.isValidating = !0, ve;
    },
    get isLoading() {
      return g.isLoading = !0, Ae;
    }
  };
}, i_ = t_(s_), o_ = () => {
}, a_ = (
  /*#__NOINLINE__*/
  o_()
), zc = Object, Rf = (n) => n === a_, l_ = (n) => typeof n == "function", Io = /* @__PURE__ */ new WeakMap(), tc = (n, e) => zc.prototype.toString.call(n) === `[object ${e}]`;
let c_ = 0;
const Yc = (n) => {
  const e = typeof n, t = tc(n, "Date"), r = tc(n, "RegExp"), s = tc(n, "Object");
  let i, o;
  if (zc(n) === n && !t && !r) {
    if (i = Io.get(n), i) return i;
    if (i = ++c_ + "~", Io.set(n, i), Array.isArray(n)) {
      for (i = "@", o = 0; o < n.length; o++)
        i += Yc(n[o]) + ",";
      Io.set(n, i);
    }
    if (s) {
      i = "#";
      const a = zc.keys(n).sort();
      for (; !Rf(o = a.pop()); )
        Rf(n[o]) || (i += o + ":" + Yc(n[o]) + ",");
      Io.set(n, i);
    }
  } else
    i = t ? n.toJSON() : e == "symbol" ? n.toString() : e == "string" ? JSON.stringify(n) : "" + n;
  return i;
}, u_ = (n) => {
  if (l_(n))
    try {
      n = n();
    } catch {
      n = "";
    }
  const e = n;
  return n = typeof n == "string" ? n : (Array.isArray(n) ? n.length : n) ? Yc(n) : "", [
    n,
    e
  ];
}, d_ = (n) => u_(n ? n(0, null) : null)[0], rc = Promise.resolve(), h_ = (n) => (e, t, r) => {
  const s = lr(!1), { cache: i, initialSize: o = 1, revalidateAll: a = !1, persistSize: l = !1, revalidateFirstPage: c = !0, revalidateOnMount: u = !1, parallel: d = !1 } = r, [, , , h] = nn.get(td);
  let f;
  try {
    f = d_(e), f && (f = wm + f);
  } catch {
  }
  const [p, y, m] = jn(i, f), b = ft(() => Ue(p()._l) ? o : p()._l, [
    i,
    f,
    o
  ]);
  vm.useSyncExternalStore(ft(
    (G) => f ? m(f, () => {
      G();
    }) : () => {
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      i,
      f
    ]
  ), b, b);
  const C = ft(() => {
    const G = p()._l;
    return Ue(G) ? o : G;
  }, [
    f,
    o
  ]), A = lr(C());
  Fo(() => {
    if (!s.current) {
      s.current = !0;
      return;
    }
    f && y({
      _l: l ? A.current : C()
    });
  }, [
    f,
    i
  ]);
  const P = u && !s.current, I = n(f, async (G) => {
    const F = p()._i, B = p()._r;
    y({
      _r: Zt
    });
    const V = [], H = C(), [L] = jn(i, G), g = L().data, x = [];
    let w = null;
    for (let _ = 0; _ < H; ++_) {
      const [D, O] = Hi(e(_, d ? null : w));
      if (!D)
        break;
      const [N, R] = jn(i, D);
      let v = N().data;
      const M = a || F || Ue(v) || c && !_ && !Ue(g) || P || g && !Ue(g[_]) && !r.compare(g[_], v);
      if (t && (typeof B == "function" ? B(v, O) : M)) {
        const te = async () => {
          if (!(D in h))
            v = await t(O);
          else {
            const ne = h[D];
            delete h[D], v = await ne;
          }
          R({
            data: v,
            _k: O
          }), V[_] = v;
        };
        d ? x.push(te) : await te();
      } else
        V[_] = v;
      d || (w = v);
    }
    return d && await Promise.all(x.map((_) => _())), y({
      _i: Zt
    }), V;
  }, r), U = ft(
    // eslint-disable-next-line func-names
    function(G, F) {
      const B = typeof F == "boolean" ? {
        revalidate: F
      } : F || {}, V = B.revalidate !== !1;
      return f ? (V && (Ue(G) ? y({
        _i: !0,
        _r: B.revalidate
      }) : y({
        _i: !1,
        _r: B.revalidate
      })), arguments.length ? I.mutate(G, {
        ...B,
        revalidate: V
      }) : I.mutate()) : rc;
    },
    // swr.mutate is always the same reference
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      f,
      i
    ]
  ), j = ft(
    (G) => {
      if (!f) return rc;
      const [, F] = jn(i, f);
      let B;
      if (Vr(G) ? B = G(C()) : typeof G == "number" && (B = G), typeof B != "number") return rc;
      F({
        _l: B
      }), A.current = B;
      const V = [], [H] = jn(i, f);
      let L = null;
      for (let g = 0; g < B; ++g) {
        const [x] = Hi(e(g, L)), [w] = jn(i, x), _ = x ? w().data : Zt;
        if (Ue(_))
          return U(H().data);
        V.push(_), L = _;
      }
      return U(V);
    },
    // exclude getKey from the dependencies, which isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      f,
      i,
      U,
      C
    ]
  );
  return {
    size: C(),
    setSize: j,
    mutate: U,
    get data() {
      return I.data;
    },
    get error() {
      return I.error;
    },
    get isValidating() {
      return I.isValidating;
    },
    get isLoading() {
      return I.isLoading;
    }
  };
}, f_ = n_(i_, h_), g_ = /* @__PURE__ */ oe("div")({
  classes: ["sfmkqcr"]
}), p_ = /* @__PURE__ */ oe("div")({
  classes: ["hrldtio"]
}), m_ = Pf(({
  casts: n,
  cursor: e
}) => /* @__PURE__ */ K.jsx(g_, {
  children: n.map((t, r) => /* @__PURE__ */ K.jsxs(ot.Fragment, {
    children: [/* @__PURE__ */ K.jsx(wa, {
      isEmbed: !1,
      ...t
    }), r < n.length - 1 && /* @__PURE__ */ K.jsx(p_, {})]
  }, t.hash))
}));
function y_(n) {
  return n ? n.map((e) => {
    var r, s, i, o, a;
    const t = e != null && e.replies && typeof e.replies == "object" ? Number(e.replies.count) || 0 : Number(e == null ? void 0 : e.replies) || 0;
    return {
      username: ((r = e == null ? void 0 : e.author) == null ? void 0 : r.username) ?? "",
      displayName: ((s = e == null ? void 0 : e.author) == null ? void 0 : s.display_name) ?? "",
      avatarImgUrl: ((i = e == null ? void 0 : e.author) == null ? void 0 : i.pfp_url) ?? "",
      text: (e == null ? void 0 : e.text) ?? "",
      hash: (e == null ? void 0 : e.hash) ?? "",
      reactions: (e == null ? void 0 : e.reactions) ?? [],
      replies: t,
      embeds: (e == null ? void 0 : e.embeds) ?? [],
      frames: (e == null ? void 0 : e.frames) ?? [],
      renderEmbeds: (e == null ? void 0 : e.renderEmbeds) ?? !0,
      channel: (e == null ? void 0 : e.channel) ?? "",
      viewerFid: 2,
      hasPowerBadge: ((o = e == null ? void 0 : e.author) == null ? void 0 : o.power_badge) ?? !1,
      appAvatarImgUrl: ((a = e == null ? void 0 : e.app) == null ? void 0 : a.pfp_url) ?? "",
      isOwnProfile: !1,
      allowReactions: !0,
      renderFrames: !1,
      timestamp: e.timestamp ?? ""
    };
  }) : [];
}
const v_ = (n) => Ss(n).then(async (e) => await e.json()), x_ = (n, e, t, r, s) => {
  if (e && (!e.casts || !e.casts.length)) return null;
  let i = `${Es}/v2/farcaster/feed${t ? "" : "?"}`;
  const o = new URLSearchParams();
  t && (i += `${t}?`), s && (i += `client_id=${s}`), e && (i += `&cursor=${e.next.cursor}`);
  const a = (l, c) => {
    c != null && !i.includes(`${l}=`) && o.append(l, String(c));
  };
  if (r) {
    Object.entries(r).forEach(([c, u]) => {
      const d = c.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
      a(d, u);
    });
    const l = o.toString();
    l && (i += i.includes("?") ? `&${l}` : `?${l}`);
  }
  if (Object.keys(r).length > 1)
    return i;
}, bL = ({
  path: n,
  ...e
}) => {
  var f;
  const {
    client_id: t
  } = gn(), r = lr(null), [s, i] = We(!1), o = lr(null), {
    data: a,
    error: l,
    size: c,
    setSize: u,
    isValidating: d
  } = f_((p, y) => x_(p, y, n, e, t), v_), h = Ln(() => {
    if (!a) return [];
    const p = a.flatMap((m) => (m == null ? void 0 : m.casts) ?? []), y = Array.from(new Set(p.map((m) => m.hash))).map((m) => p.find((b) => b.hash === m));
    return y_(y);
  }, [a]);
  return Et(() => (o.current && o.current.disconnect(), o.current = new IntersectionObserver((p) => {
    var m, b;
    const [y] = p;
    y.isIntersecting && !s && !d && a && ((b = (m = a[a.length - 1]) == null ? void 0 : m.next) != null && b.cursor) && (i(!0), u(c + 1).then(() => i(!1)));
  }, {
    rootMargin: "100px"
  }), r.current && o.current.observe(r.current), () => {
    o.current && o.current.disconnect();
  }), [r.current, s, d, a, c]), l ? /* @__PURE__ */ K.jsx("div", {
    children: "Error fetching feed data"
  }) : /* @__PURE__ */ K.jsxs("div", {
    children: [h.length !== 0 ? /* @__PURE__ */ K.jsx(m_, {
      casts: h,
      cursor: ""
    }) : /* @__PURE__ */ K.jsx("div", {
      children: (f = a == null ? void 0 : a[0]) == null ? void 0 : f.message
    }), d && /* @__PURE__ */ K.jsxs("div", {
      style: {
        display: "flex",
        justifyContent: "center",
        padding: "10px"
      },
      children: [/* @__PURE__ */ K.jsxs("span", {
        style: {
          animation: "blink 1.5s infinite"
        },
        children: ["Loading", /* @__PURE__ */ K.jsx("span", {
          className: "dots",
          children: "..."
        })]
      }), /* @__PURE__ */ K.jsx("style", {
        children: `
                        @keyframes blink {
                            0% { opacity: 1; }
                            50% { opacity: 0; }
                            100% { opacity: 1; }
                        }
                    `
      })]
    }), /* @__PURE__ */ K.jsx("div", {
      ref: r
    })]
  });
}, E_ = /* @__PURE__ */ oe("button")({
  classes: ["b1bqug8r"]
}), S_ = /* @__PURE__ */ oe("button")({
  classes: ["b1mra45w"]
}), Cf = "https://farcaster.xyz", _m = /(^|\s)\/\w+/g, Lm = /@\w+/g, Rm = /((https?:\/\/)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\/[^\s]*)?)/g, kf = new RegExp(`(${_m.source})|(${Lm.source})|(${Rm.source})`, "g"), b_ = (n) => _m.test(n) ? `${Cf}/~/channel${n.trim()}` : Lm.test(n) ? `${Cf}/${n.substring(1)}` : Rm.test(n) ? n.startsWith("http") ? n : `http://${n}` : "", T_ = /* @__PURE__ */ oe("a")({
  classes: ["sby9wa2"]
}), w_ = (n) => {
  if (!n) return [];
  const e = [];
  let t = 0, r;
  for (; (r = kf.exec(n)) !== null; ) {
    const s = r.index;
    t < s && e.push(n.slice(t, s));
    const i = b_(r[0]), o = r[0].trim().startsWith("/");
    e.push(/* @__PURE__ */ K.jsx("span", {
      children: /* @__PURE__ */ K.jsx(T_, {
        href: i,
        target: "_blank",
        style: o ? {
          marginLeft: 3.5
        } : {},
        children: r[0]
      }, s)
    })), t = kf.lastIndex;
  }
  return t < n.length && e.push(n.slice(t)), e;
}, A_ = /* @__PURE__ */ oe("div")({
  classes: ["sdahm58"]
}), I_ = /* @__PURE__ */ oe("div")({
  classes: ["mziqyxp"]
}), __ = /* @__PURE__ */ oe("div")({
  classes: ["uz7tpmf"]
}), L_ = /* @__PURE__ */ oe("div")({
  classes: ["d1rxlwac"]
}), R_ = /* @__PURE__ */ oe("div")({
  classes: ["ugc6yqp"]
}), Df = /* @__PURE__ */ oe("div")({
  classes: ["porjf9a"]
}), C_ = /* @__PURE__ */ oe("div")({
  classes: ["ttt7x9x"]
}), k_ = /* @__PURE__ */ oe("div")({
  classes: ["b1wbe9o6"]
}), D_ = Pf(({
  fid: n,
  username: e,
  displayName: t,
  avatarImgUrl: r,
  bio: s,
  followers: i,
  following: o,
  hasPowerBadge: a,
  isFollowing: l,
  isOwnProfile: c,
  onCast: u,
  containerStyles: d
}) => {
  const h = w_(s), f = Ln(() => yf(o), [o]), p = Ln(() => yf(i), [i]), y = () => {
    window.open("https://farcaster.xyz/~/settings", "_blank");
  }, m = {
    color: d == null ? void 0 : d.color
  };
  return /* @__PURE__ */ K.jsxs(A_, {
    style: d,
    children: [c && u && /* @__PURE__ */ K.jsxs(jr, {
      alignItems: "center",
      justifyContent: "space-between",
      spacingBottom: "20px",
      children: [/* @__PURE__ */ K.jsxs(R_, {
        children: ["@", e]
      }), /* @__PURE__ */ K.jsx(E_, {
        onClick: u,
        children: "Cast"
      })]
    }), /* @__PURE__ */ K.jsx(jr, {
      children: /* @__PURE__ */ K.jsxs(I_, {
        children: [/* @__PURE__ */ K.jsxs(jr, {
          alignItems: "center",
          flexGrow: 1,
          style: {
            gap: "10px"
          },
          children: [/* @__PURE__ */ K.jsx(Fr, {
            children: /* @__PURE__ */ K.jsx(ha, {
              width: "20px",
              height: "20px",
              src: r ?? Vi,
              loading: "lazy",
              alt: `${t ?? "Skeleton"} Avatar`
            })
          }), /* @__PURE__ */ K.jsx(jr, {
            children: /* @__PURE__ */ K.jsx(L_, {
              children: t || `!${n}`
            })
          }), /* @__PURE__ */ K.jsxs(jr, {
            alignItems: "center",
            children: [/* @__PURE__ */ K.jsxs(__, {
              children: ["@", e]
            }), l && /* @__PURE__ */ K.jsx(C_, {
              children: "Follows you"
            })]
          }), /* @__PURE__ */ K.jsx(jr, {
            children: c && /* @__PURE__ */ K.jsx(S_, {
              onClick: y,
              children: "Edit Profile"
            })
          })]
        }), /* @__PURE__ */ K.jsx(k_, {
          children: h
        }), /* @__PURE__ */ K.jsxs(jr, {
          style: {
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center"
          },
          children: [/* @__PURE__ */ K.jsxs(Df, {
            children: [/* @__PURE__ */ K.jsx("strong", {
              style: m,
              children: f
            }), " ", "Following"]
          }), /* @__PURE__ */ K.jsxs(Df, {
            children: [/* @__PURE__ */ K.jsx("strong", {
              style: m,
              children: p
            }), " ", "Followers"]
          }), e && /* @__PURE__ */ K.jsx(Fr, {
            style: {
              marginLeft: "auto"
            },
            children: /* @__PURE__ */ K.jsx(Uc, {
              url: `https://farcaster.xyz/${e}`
            })
          })]
        })]
      })
    })]
  });
});
async function P_({
  fid: n,
  viewerFid: e,
  clientId: t
}) {
  var r;
  try {
    let s = `${Es}/v2/farcaster/user/bulk?client_id=${t}&fids=${n}`;
    e && (s += `&viewer_fid=${e}`);
    const o = await (await Ss(s)).json();
    return ((r = o == null ? void 0 : o.users) == null ? void 0 : r[0]) ?? null;
  } catch (s) {
    return console.error("Error fetching user by fid", s), null;
  }
}
const TL = ({
  fid: n,
  viewerFid: e,
  containerStyles: t
}) => {
  var h;
  const {
    client_id: r
  } = gn(), [s, i] = We(null), [o, a] = We(!0), [l, c] = We(null), u = (s == null ? void 0 : s.fid) === e;
  Et(() => {
    n && (a(!0), c(null), P_({
      fid: n,
      viewerFid: e,
      clientId: r
    }).then((f) => {
      i(f);
    }).catch((f) => {
      c(f);
    }).finally(() => {
      a(!1);
    }));
  }, [n, e]);
  const d = ft(() => {
  }, []);
  return o ? /* @__PURE__ */ K.jsx("div", {
    style: {
      padding: "20px"
    },
    children: "Loading..."
  }) : !s || l ? /* @__PURE__ */ K.jsx("div", {
    children: "Error fetching user data"
  }) : /* @__PURE__ */ K.jsx(D_, {
    fid: n,
    username: s.username,
    displayName: s.display_name,
    avatarImgUrl: s.pfp_url,
    bio: s.profile.bio.text,
    followers: s.follower_count,
    following: s.following_count,
    hasPowerBadge: s.power_badge,
    isOwnProfile: u,
    isFollowing: (h = s.viewer_context) == null ? void 0 : h.followed_by,
    onCast: d,
    containerStyles: t
  });
}, M_ = /* @__PURE__ */ oe("ul")({
  classes: ["d12rx4om"]
}), O_ = /* @__PURE__ */ oe("li")({
  classes: ["lrpm6lp"]
}), B_ = /* @__PURE__ */ oe("img")({
  classes: ["a1e9hg3b"]
}), F_ = /* @__PURE__ */ oe("div")({
  classes: ["u1aqay1i"]
}), N_ = /* @__PURE__ */ oe("div")({
  classes: ["d1m0njq"]
}), U_ = /* @__PURE__ */ oe("div")({
  classes: ["u1lvlbuo"]
}), $_ = ({
  users: n,
  onSelect: e,
  customStyles: t = {}
}) => /* @__PURE__ */ K.jsx(M_, {
  style: {
    ...t == null ? void 0 : t.dropdown
  },
  children: n.map((r) => /* @__PURE__ */ K.jsxs(O_, {
    style: {
      ...t == null ? void 0 : t.listItem
    },
    onClick: () => e(r),
    children: [/* @__PURE__ */ K.jsx(B_, {
      style: {
        ...t == null ? void 0 : t.avatar
      },
      src: r.pfp_url,
      alt: r.username
    }), /* @__PURE__ */ K.jsxs(F_, {
      style: {
        ...t.userInfo
      },
      children: [/* @__PURE__ */ K.jsx(N_, {
        children: r.display_name
      }), /* @__PURE__ */ K.jsxs(U_, {
        children: ["@", r.username]
      })]
    })]
  }, r.fid))
}), G_ = /* @__PURE__ */ oe("div")({
  classes: ["c9hm20t"]
}), j_ = /* @__PURE__ */ oe("input")({
  classes: ["i80sd8h"]
});
async function V_({
  q: n,
  viewerFid: e,
  client_id: t
}) {
  var r;
  try {
    let s = `${Es}/v2/farcaster/user/search?q=${n}&limit=5${e ? `&viewer_fid=${e}` : ""}&client_id=${t}`;
    const o = await (await Ss(s)).json();
    return ((r = o == null ? void 0 : o.result) == null ? void 0 : r.users) || [];
  } catch {
    return null;
  }
}
const wL = ({
  value: n,
  onChange: e,
  style: t = {},
  placeholder: r = "Enter username",
  disabled: s = !1,
  viewerFid: i,
  customStyles: o = {},
  limit: a = null
}) => {
  const {
    client_id: l
  } = gn(), [c, u] = We(""), [d, h] = We(!1), [f, p] = We([]), y = lr(null);
  Et(() => {
    const I = (n == null ? void 0 : n.split(",")) || [];
    if (!I[I.length - 1]) {
      u("");
      return;
    }
    u(I[I.length - 1].trim());
  }, [n]), Et(() => {
    c !== "" && !/^\d+$/.test(c) ? m(c) : h(!1);
  }, [c]);
  const m = async (I) => {
    const U = await V_({
      q: I,
      viewerFid: i,
      client_id: l
    });
    U && (p(U), h(!0));
  }, b = (I) => {
    const U = I.target.value;
    e(U);
  }, C = (I) => {
    let U = n.split(",");
    a !== null && U.length >= a ? U[U.length - 1] = I.fid.toString() : U.push(I.fid.toString());
    const j = U.join(",");
    e(j), u(""), h(!1);
  }, A = () => {
    c && isNaN(Number(c)) && h(!0);
  }, P = () => {
    setTimeout(() => h(!1), 200);
  };
  return /* @__PURE__ */ K.jsxs(G_, {
    style: t,
    children: [/* @__PURE__ */ K.jsx(j_, {
      ref: y,
      type: "text",
      value: n,
      onChange: b,
      onFocus: A,
      onBlur: P,
      placeholder: r,
      disabled: s
    }), d && /* @__PURE__ */ K.jsx($_, {
      users: f,
      onSelect: C,
      customStyles: o
    })]
  });
}, K_ = ({
  color: n = "#855DCD"
}) => /* @__PURE__ */ K.jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: n,
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  className: "lucide lucide-search",
  children: [/* @__PURE__ */ K.jsx("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  }), /* @__PURE__ */ K.jsx("path", {
    d: "m21 21-4.3-4.3"
  })]
}), H_ = ({
  color: n = "#855DCD"
}) => /* @__PURE__ */ K.jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: n,
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  className: "lucide lucide-loader-circle",
  children: /* @__PURE__ */ K.jsx("path", {
    d: "M21 12a9 9 0 1 1-6.219-8.56"
  })
}), W_ = /* @__PURE__ */ oe("div")({
  classes: ["ig7kcuc"]
}), q_ = /* @__PURE__ */ oe("input")({
  classes: ["sh7z7k6"]
}), z_ = /* @__PURE__ */ oe("div")({
  classes: ["s14ai203"]
}), Y_ = /* @__PURE__ */ oe("div")({
  classes: ["if18nd6"]
}), Z_ = /* @__PURE__ */ oe("div")({
  classes: ["sd833lb"]
}), X_ = /* @__PURE__ */ oe("div")({
  classes: ["ugo586m"]
}), J_ = /* @__PURE__ */ oe("div")({
  classes: ["ukwty1d"]
}), Q_ = /* @__PURE__ */ oe("div")({
  classes: ["u77olmy"]
}), eL = /* @__PURE__ */ oe("div")({
  classes: ["s1xvkxww"]
}), tL = /* @__PURE__ */ oe("div")({
  classes: ["s1f6b1ja"]
}), rL = /* @__PURE__ */ oe("div")({
  classes: ["udiufd8"]
}), nL = /* @__PURE__ */ oe("div")({
  classes: ["f1b8a2h0"]
}), sL = /* @__PURE__ */ oe("div")({
  classes: ["l1yq26j0"]
}), iL = /* @__PURE__ */ oe("li")({
  classes: ["s18mk47k"]
}), AL = ({
  width: n,
  height: e,
  selectedUsers: t,
  onSelectUsers: r,
  ...s
}) => {
  const {
    client_id: i
  } = gn(), {
    user: o,
    isAuthenticated: a
  } = Fg(), [l, c] = We(""), [u, d] = We([]), [h, f] = We(!1), p = lr(null);
  Et(() => {
    function I(U) {
      p.current && !p.current.contains(U.target) && (d([]), c(""));
    }
    return document.addEventListener("mousedown", I), () => {
      document.removeEventListener("mousedown", I);
    };
  }, []);
  const b = ft(((I, U) => {
    let j;
    return (...G) => {
      clearTimeout(j), j = setTimeout(() => I(...G), U);
    };
  })(async (I, U) => {
    var j;
    if (!I) {
      d([]);
      return;
    }
    f(!0);
    try {
      const F = await (await Ss(U)).json();
      d(((j = F == null ? void 0 : F.result) == null ? void 0 : j.users) || []);
    } catch (G) {
      console.error("Error fetching data:", G);
    } finally {
      f(!1);
    }
  }, 500), []), C = (I) => {
    const U = `${Es}/v2/farcaster/user/search?q=${I.target.value}&client_id=${i}${a ? `&viewer_fid=${o == null ? void 0 : o.fid}` : ""})`;
    c(I.target.value), b(I.target.value, U);
  }, A = (I) => {
    t.some((U) => U.username === I.username) || (r([...t, I]), c(""), d([]));
  }, P = (I) => {
    r(t.filter((U) => U.username !== I));
  };
  return /* @__PURE__ */ K.jsxs(W_, {
    ref: p,
    style: {
      width: n
    },
    children: [/* @__PURE__ */ K.jsxs(Y_, {
      children: [t.map((I) => /* @__PURE__ */ K.jsxs(Z_, {
        children: [/* @__PURE__ */ K.jsx(ha, {
          src: I.pfp_url ?? Vi,
          alt: `${I.username} Avatar`,
          style: {
            width: "24px",
            height: "24px",
            borderRadius: "50%"
          }
        }), /* @__PURE__ */ K.jsx("span", {
          style: {
            marginLeft: "8px"
          },
          children: I.display_name
        }), /* @__PURE__ */ K.jsx(pm, {
          size: 20,
          onClick: () => P(I.username)
        })]
      }, I.username)), /* @__PURE__ */ K.jsxs(eL, {
        children: [/* @__PURE__ */ K.jsx(tL, {
          children: /* @__PURE__ */ K.jsx(K_, {
            color: "#855DCD"
          })
        }), /* @__PURE__ */ K.jsx(q_, {
          ...s,
          value: l,
          onChange: C,
          placeholder: "Type to search users",
          style: {
            width: n || "100%",
            height: e || "40px"
          }
        })]
      })]
    }), h ? /* @__PURE__ */ K.jsx(sL, {
      children: /* @__PURE__ */ K.jsx(H_, {
        color: "#855DCD"
      })
    }) : u.length !== 0 && /* @__PURE__ */ K.jsx(z_, {
      children: u.map((I) => /* @__PURE__ */ K.jsxs(iL, {
        onClick: () => A(I),
        children: [/* @__PURE__ */ K.jsx(ha, {
          src: I.pfp_url ?? Vi,
          alt: `${I.username} Avatar`,
          style: {
            width: "40px",
            height: "40px",
            borderRadius: "50%"
          }
        }), /* @__PURE__ */ K.jsxs(X_, {
          children: [/* @__PURE__ */ K.jsx(J_, {
            children: I.display_name
          }), /* @__PURE__ */ K.jsxs(rL, {
            children: [/* @__PURE__ */ K.jsxs(Q_, {
              children: ["@", I.username]
            }), I.viewer_context && (I.viewer_context.following || I.viewer_context.followed_by) && /* @__PURE__ */ K.jsx(nL, {
              children: I.viewer_context.following && I.viewer_context.followed_by ? "Following each other" : I.viewer_context.following ? "Following" : I.viewer_context.followed_by ? "Follows you" : null
            })]
          })]
        })]
      }, I.username))
    })]
  });
};
export {
  wa as CastCard,
  mL as MiniAppProvider,
  FS as NeynarAuthButton,
  AL as NeynarAutoCompleteUser,
  OA as NeynarCastCard,
  vL as NeynarContextProvider,
  SL as NeynarConversationList,
  bL as NeynarFeedList,
  gI as NeynarFrameCard,
  TL as NeynarProfileCard,
  wL as NeynarUserDropdown,
  _n as SIWN_variant,
  Og as Theme,
  Du as useLocalStorage,
  yL as useMiniApp,
  gn as useNeynarContext
};
